import axios$1 from 'axios';
import React, { useContext, useState, useCallback, useRef, useEffect, useMemo, useReducer, createContext, useLayoutEffect, forwardRef, createElement, memo } from 'react';
import habo from 'habo';
import ReactDOM, { createPortal } from 'react-dom';
import OSS from 'ali-oss';

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics$2 = function extendStatics(d, b) {
  _extendStatics$2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics$2(d, b);
};

function __extends$2(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics$2(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign$4 = function __assign() {
  _assign$4 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$4.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter$2(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
var js_cookie = createCommonjsModule(function (module, exports) {

  (function (factory) {
    var registeredInModuleLoader;

    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }

    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    function init(converter) {
      function api() {}

      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        } // We're using "expires" because "max-age" is not supported by IE


        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          var result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + value + stringifiedAttributes;
      }

      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }

        var jar = {}; // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');

          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }

          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);

            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            jar[name] = cookie;

            if (key === name) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      api.set = set;

      api.get = function (key) {
        return get(key, false
        /* read as raw */
        );
      };

      api.getJSON = function (key) {
        return get(key, true
        /* read as json */
        );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.defaults = {};
      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
});

var EHaboEventId;

(function (EHaboEventId) {
  // 角印上报事件ID
  EHaboEventId["FOOTPRINT_REPORT"] = "6182011583293440"; // 统一作答拍照按钮

  EHaboEventId["CLICK_IMG_UPLOAD"] = "10061599964620800"; // 答题页面关闭统一作答提示记录

  EHaboEventId["CLOSE_UNIFY_TIP"] = "10061560553105408"; // 课后练习最后一题统一拍照按钮点击行为

  EHaboEventId["CLICK_LAST_IMG_UPLOAD"] = "10061571600050176";
})(EHaboEventId || (EHaboEventId = {}));

var EHaboEventId$1 = EHaboEventId;

var FOOT_PRINT_SECOND_ACTION = {
  // 组件接收业务传来数据
  RECEIVED_DATA: 'exercise_ui_received_question_data',
  // 组件发送用户作答数据给业务
  SEND_USER_DATA: 'exercise_ui_send_user_result'
};
var FOOT_PRINT_fIRST_ACTION = {
  jsError: 'js_error'
};

var instance = axios$1.create();
instance.defaults.timeout = 8000;

var get = function get(url, params) {
  return instance.request({
    method: 'get',
    url: url,
    // 附着在url上
    params: params,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (_a) {
    var data = _a.data;
    return data;
  });
};

var post = function post(url, data, extraHeaders) {
  return instance.request({
    method: 'post',
    url: url,
    data: data,
    headers: _assign$4({
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json; charset=UTF-8'
    }, extraHeaders)
  }).then(function (_a) {
    var data = _a.data;
    return data;
  });
};

var upload = function upload(url, formData) {
  formData.append('secret', 'ZXmVc6TrePQEHan2d9vBnEYhbAgoxmgt');
  return instance.request({
    method: 'post',
    url: url,
    data: formData,
    timeout: 60000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(function (_a) {
    var data = _a.data;
    return data;
  });
};

var axios = {
  get: get,
  post: post,
  upload: upload
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics$1 = function extendStatics(d, b) {
  _extendStatics$1 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics$1(d, b);
};

function __extends$1(d, b) {
  _extendStatics$1(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign$3 = function __assign() {
  _assign$3 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$3.apply(this, arguments);
};
function __values$2(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$3(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread$2() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$3(arguments[i]));
  }

  return ar;
}

/**
 * Session Status
 */
var SessionStatus;

(function (SessionStatus) {
  /** JSDoc */
  SessionStatus["Ok"] = "ok";
  /** JSDoc */

  SessionStatus["Exited"] = "exited";
  /** JSDoc */

  SessionStatus["Crashed"] = "crashed";
  /** JSDoc */

  SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus || (SessionStatus = {}));

/** JSDoc */
// eslint-disable-next-line import/export
var Severity;

(function (Severity) {
  /** JSDoc */
  Severity["Fatal"] = "fatal";
  /** JSDoc */

  Severity["Error"] = "error";
  /** JSDoc */

  Severity["Warning"] = "warning";
  /** JSDoc */

  Severity["Log"] = "log";
  /** JSDoc */

  Severity["Info"] = "info";
  /** JSDoc */

  Severity["Debug"] = "debug";
  /** JSDoc */

  Severity["Critical"] = "critical";
})(Severity || (Severity = {})); // eslint-disable-next-line @typescript-eslint/no-namespace, import/export


(function (Severity) {
  /**
   * Converts a string-based level into a {@link Severity}.
   *
   * @param level string representation of Severity
   * @returns Severity
   */
  function fromString(level) {
    switch (level) {
      case 'debug':
        return Severity.Debug;

      case 'info':
        return Severity.Info;

      case 'warn':
      case 'warning':
        return Severity.Warning;

      case 'error':
        return Severity.Error;

      case 'fatal':
        return Severity.Fatal;

      case 'critical':
        return Severity.Critical;

      case 'log':
      default:
        return Severity.Log;
    }
  }

  Severity.fromString = fromString;
})(Severity || (Severity = {}));

/** The status of an event. */
// eslint-disable-next-line import/export
var Status;

(function (Status) {
  /** The status could not be determined. */
  Status["Unknown"] = "unknown";
  /** The event was skipped due to configuration or callbacks. */

  Status["Skipped"] = "skipped";
  /** The event was sent to Sentry successfully. */

  Status["Success"] = "success";
  /** The client is currently rate limited and will try again later. */

  Status["RateLimit"] = "rate_limit";
  /** The event could not be processed. */

  Status["Invalid"] = "invalid";
  /** A server-side error ocurred during submission. */

  Status["Failed"] = "failed";
})(Status || (Status = {})); // eslint-disable-next-line @typescript-eslint/no-namespace, import/export


(function (Status) {
  /**
   * Converts a HTTP status code into a {@link Status}.
   *
   * @param code The HTTP response status code.
   * @returns The send status or {@link Status.Unknown}.
   */
  function fromHttpCode(code) {
    if (code >= 200 && code < 300) {
      return Status.Success;
    }

    if (code === 429) {
      return Status.RateLimit;
    }

    if (code >= 400 && code < 500) {
      return Status.Invalid;
    }

    if (code >= 500) {
      return Status.Failed;
    }

    return Status.Unknown;
  }

  Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));

var _assign$2 = function __assign() {
  _assign$2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$2.apply(this, arguments);
};
function __read$2(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread$1() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read$2(arguments[i]));
  }

  return ar;
}

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (Object.prototype.toString.call(wat)) {
    case '[object Error]':
      return true;

    case '[object Exception]':
      return true;

    case '[object DOMException]':
      return true;

    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isErrorEvent(wat) {
  return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isDOMError(wat) {
  return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isDOMException(wat) {
  return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isString(wat) {
  return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isPrimitive(wat) {
  return wat === null || _typeof$1(wat) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isPlainObject(wat) {
  return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isElement$1(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */

function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */

function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */

function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */

function htmlTreeAsString(elem) {
  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    var height = 0;
    var len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    var nextStr = void 0; // eslint-disable-next-line no-plusplus

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem); // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)

      if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) {
        break;
      }

      out.push(nextStr);
      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */

function _htmlElementAsString(el) {
  var elem = el;
  var out = [];
  var className;
  var classes;
  var key;
  var attr;
  var i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  if (elem.id) {
    out.push("#" + elem.id);
  } // eslint-disable-next-line prefer-const


  className = elem.className;

  if (className && isString(className)) {
    classes = className.split(/\s+/);

    for (i = 0; i < classes.length; i++) {
      out.push("." + classes[i]);
    }
  }

  var allowedAttrs = ['type', 'name', 'title', 'alt'];

  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);

    if (attr) {
      out.push("[" + key + "=\"" + attr + "\"]");
    }
  }

  return out.join('');
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign$1 = function __assign() {
  _assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$1.apply(this, arguments);
};
function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

var setPrototypeOf = Object.setPrototypeOf || ({
  __proto__: []
} instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types

function setProtoOf(obj, proto) {
  // @ts-ignore __proto__ does not exist on obj
  obj.__proto__ = proto;
  return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types


function mixinProperties(obj, proto) {
  for (var prop in proto) {
    // eslint-disable-next-line no-prototype-builtins
    if (!obj.hasOwnProperty(prop)) {
      // @ts-ignore typescript complains about indexing so we remove
      obj[prop] = proto[prop];
    }
  }

  return obj;
}

/** An error emitted by Sentry SDKs and related utilities. */

var SentryError =
/** @class */
function (_super) {
  __extends(SentryError, _super);

  function SentryError(message) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message) || this;

    _this.message = message;
    _this.name = _newTarget.prototype.constructor.name;
    setPrototypeOf(_this, _newTarget.prototype);
    return _this;
  }

  return SentryError;
}(Error);

/** Regular expression used to parse a Dsn. */

var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */

var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */

var Dsn =
/** @class */
function () {
  /** Creates a new Dsn component */
  function Dsn(from) {
    if (typeof from === 'string') {
      this._fromString(from);
    } else {
      this._fromComponents(from);
    }

    this._validate();
  }
  /**
   * Renders the string representation of this Dsn.
   *
   * By default, this will render the public representation without the password
   * component. To get the deprecated private representation, set `withPassword`
   * to true.
   *
   * @param withPassword When set to true, the password will be included.
   */


  Dsn.prototype.toString = function (withPassword) {
    if (withPassword === void 0) {
      withPassword = false;
    }

    var _a = this,
        host = _a.host,
        path = _a.path,
        pass = _a.pass,
        port = _a.port,
        projectId = _a.projectId,
        protocol = _a.protocol,
        user = _a.user;

    return protocol + "://" + user + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
  };
  /** Parses a string into this Dsn. */


  Dsn.prototype._fromString = function (str) {
    var match = DSN_REGEX.exec(str);

    if (!match) {
      throw new SentryError(ERROR_MESSAGE);
    }

    var _a = __read$1(match.slice(1), 6),
        protocol = _a[0],
        user = _a[1],
        _b = _a[2],
        pass = _b === void 0 ? '' : _b,
        host = _a[3],
        _c = _a[4],
        port = _c === void 0 ? '' : _c,
        lastPath = _a[5];

    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');

    if (split.length > 1) {
      path = split.slice(0, -1).join('/');
      projectId = split.pop();
    }

    if (projectId) {
      var projectMatch = projectId.match(/^\d+/);

      if (projectMatch) {
        projectId = projectMatch[0];
      }
    }

    this._fromComponents({
      host: host,
      pass: pass,
      path: path,
      projectId: projectId,
      port: port,
      protocol: protocol,
      user: user
    });
  };
  /** Maps Dsn components into this instance. */


  Dsn.prototype._fromComponents = function (components) {
    this.protocol = components.protocol;
    this.user = components.user;
    this.pass = components.pass || '';
    this.host = components.host;
    this.port = components.port || '';
    this.path = components.path || '';
    this.projectId = components.projectId;
  };
  /** Validates this Dsn and throws on error. */


  Dsn.prototype._validate = function () {
    var _this = this;

    ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
      if (!_this[component]) {
        throw new SentryError(ERROR_MESSAGE + ": " + component + " missing");
      }
    });

    if (!this.projectId.match(/^\d+$/)) {
      throw new SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
    }

    if (this.protocol !== 'http' && this.protocol !== 'https') {
      throw new SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
    }

    if (this.port && isNaN(parseInt(this.port, 10))) {
      throw new SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
    }
  };

  return Dsn;
}();

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo$1 =
/** @class */
function () {
  function Memo() {
    this._hasWeakSet = typeof WeakSet === 'function';
    this._inner = this._hasWeakSet ? new WeakSet() : [];
  }
  /**
   * Sets obj to remember.
   * @param obj Object to remember
   */


  Memo.prototype.memoize = function (obj) {
    if (this._hasWeakSet) {
      if (this._inner.has(obj)) {
        return true;
      }

      this._inner.add(obj);

      return false;
    } // eslint-disable-next-line @typescript-eslint/prefer-for-of


    for (var i = 0; i < this._inner.length; i++) {
      var value = this._inner[i];

      if (value === obj) {
        return true;
      }
    }

    this._inner.push(obj);

    return false;
  };
  /**
   * Removes object from internal storage.
   * @param obj Object to forget
   */


  Memo.prototype.unmemoize = function (obj) {
    if (this._hasWeakSet) {
      this._inner.delete(obj);
    } else {
      for (var i = 0; i < this._inner.length; i++) {
        if (this._inner[i] === obj) {
          this._inner.splice(i, 1);

          break;
        }
      }
    }
  };

  return Memo;
}();

var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */

function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }

    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */

function truncate(str, max) {
  if (max === void 0) {
    max = 0;
  }

  if (typeof str !== 'string' || max === 0) {
    return str;
  }

  return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  var output = []; // eslint-disable-next-line @typescript-eslint/prefer-for-of

  for (var i = 0; i < input.length; i++) {
    var value = input[i];

    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
 * will be substituted in for `source[name]`.
 * @returns void
 */

function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  var original = source[name];
  var wrapped = replacementFactory(original); // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"

  if (typeof wrapped === 'function') {
    try {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __sentry_original__: {
          enumerable: false,
          value: original
        }
      });
    } catch (_Oo) {// This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */

function urlEncode(object) {
  return Object.keys(object).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
  }).join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */

function getWalkSource(value) {
  if (isError(value)) {
    var error = value;
    var err = {
      message: error.message,
      name: error.name,
      stack: error.stack
    };

    for (var i in error) {
      if (Object.prototype.hasOwnProperty.call(error, i)) {
        err[i] = error[i];
      }
    }

    return err;
  }

  if (isEvent(value)) {
    var event_1 = value;
    var source = {};
    source.type = event_1.type; // Accessing event.target can throw (see getsentry/raven-js#838, #768)

    try {
      source.target = isElement$1(event_1.target) ? htmlTreeAsString(event_1.target) : Object.prototype.toString.call(event_1.target);
    } catch (_oO) {
      source.target = '<unknown>';
    }

    try {
      source.currentTarget = isElement$1(event_1.currentTarget) ? htmlTreeAsString(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
    } catch (_oO) {
      source.currentTarget = '<unknown>';
    }

    if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
      source.detail = event_1.detail;
    }

    for (var i in event_1) {
      if (Object.prototype.hasOwnProperty.call(event_1, i)) {
        source[i] = event_1;
      }
    }

    return source;
  }

  return value;
}
/** Calculates bytes size of input string */


function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */


function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
/** JSDoc */


function normalizeToSize(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
  if (depth === void 0) {
    depth = 3;
  }

  if (maxSize === void 0) {
    maxSize = 100 * 1024;
  }

  var serialized = normalize(object, depth);

  if (jsonSize(serialized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */

function serializeValue(value) {
  var type = Object.prototype.toString.call(value); // Node.js REPL notation

  if (typeof value === 'string') {
    return value;
  }

  if (type === '[object Object]') {
    return '[Object]';
  }

  if (type === '[object Array]') {
    return '[Array]';
  }

  var normalized = normalizeValue(value);
  return isPrimitive(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */


function normalizeValue(value, key) {
  if (key === 'domain' && value && _typeof$1(value) === 'object' && value._events) {
    return '[Domain]';
  }

  if (key === 'domainEmitter') {
    return '[DomainEmitter]';
  }

  if (typeof global !== 'undefined' && value === global) {
    return '[Global]';
  }

  if (typeof window !== 'undefined' && value === window) {
    return '[Window]';
  }

  if (typeof document !== 'undefined' && value === document) {
    return '[Document]';
  } // React's SyntheticEvent thingy


  if (isSyntheticEvent(value)) {
    return '[SyntheticEvent]';
  }

  if (typeof value === 'number' && value !== value) {
    return '[NaN]';
  }

  if (value === void 0) {
    return '[undefined]';
  }

  if (typeof value === 'function') {
    return "[Function: " + getFunctionName(value) + "]";
  } // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable


  if (_typeof$1(value) === 'symbol') {
    return "[" + String(value) + "]";
  }

  if (typeof value === 'bigint') {
    return "[BigInt: " + String(value) + "]";
  }

  return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


function walk(key, value, depth, memo) {
  if (depth === void 0) {
    depth = +Infinity;
  }

  if (memo === void 0) {
    memo = new Memo$1();
  } // If we reach the maximum depth, serialize whatever has left


  if (depth === 0) {
    return serializeValue(value);
  }
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // If value implements `toJSON` method, call it and return early


  if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
    return value.toJSON();
  }
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further


  var normalized = normalizeValue(value, key);

  if (isPrimitive(normalized)) {
    return normalized;
  } // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself


  var source = getWalkSource(value); // Create an accumulator that will act as a parent for all future itterations of that branch

  var acc = Array.isArray(value) ? [] : {}; // If we already walked that branch, bail out, as it's circular reference

  if (memo.memoize(value)) {
    return '[Circular ~]';
  } // Walk all keys of the source


  for (var innerKey in source) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
      continue;
    } // Recursively walk through all the child nodes


    acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
  } // Once walked through all the branches, remove the parent from memo storage


  memo.unmemoize(value); // Return accumulated values

  return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

function normalize(input, depth) {
  try {
    return JSON.parse(JSON.stringify(input, function (key, value) {
      return walk(key, value, depth);
    }));
  } catch (_oO) {
    return '**non-serializable**';
  }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

function extractExceptionKeysForMessage(exception, maxLength) {
  if (maxLength === void 0) {
    maxLength = 40;
  }

  var keys = Object.keys(getWalkSource(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }

  for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    var serialized = keys.slice(0, includedKeys).join(', ');

    if (serialized.length > maxLength) {
      continue;
    }

    if (includedKeys === keys.length) {
      return serialized;
    }

    return truncate(serialized, maxLength);
  }

  return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */

function dropUndefinedKeys(val) {
  var e_1, _a;

  if (isPlainObject(val)) {
    var obj = val;
    var rv = {};

    try {
      for (var _b = __values$1(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;

        if (typeof obj[key] !== 'undefined') {
          rv[key] = dropUndefinedKeys(obj[key]);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return rv;
  }

  if (Array.isArray(val)) {
    return val.map(dropUndefinedKeys);
  }

  return val;
}

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */

function isNodeEnv() {
  return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */

function getGlobalObject() {
  return isNodeEnv() ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : fallbackGlobalObject;
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */

function uuid4() {
  var global = getGlobalObject();
  var crypto = global.crypto || global.msCrypto;

  if (!(crypto === void 0) && crypto.getRandomValues) {
    // Use window.crypto API if available
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr); // set 4 in byte 7
    // eslint-disable-next-line no-bitwise

    arr[3] = arr[3] & 0xfff | 0x4000; // set 2 most significant bits of byte 9 to '10'
    // eslint-disable-next-line no-bitwise

    arr[4] = arr[4] & 0x3fff | 0x8000;

    var pad = function pad(num) {
      var v = num.toString(16);

      while (v.length < 4) {
        v = "0" + v;
      }

      return v;
    };

    return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
  } // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523


  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0; // eslint-disable-next-line no-bitwise

    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */

function parseUrl(url) {
  if (!url) {
    return {};
  }

  var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  } // coerce to undefined values to empty string so we don't get 'undefined'


  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment
  };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */

function getEventDescription(event) {
  if (event.message) {
    return event.message;
  }

  if (event.exception && event.exception.values && event.exception.values[0]) {
    var exception = event.exception.values[0];

    if (exception.type && exception.value) {
      return exception.type + ": " + exception.value;
    }

    return exception.type || exception.value || event.event_id || '<unknown>';
  }

  return event.event_id || '<unknown>';
}
/** JSDoc */

function consoleSandbox(callback) {
  var global = getGlobalObject();
  var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];

  if (!('console' in global)) {
    return callback();
  } // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access


  var originalConsole = global.console;
  var wrappedLevels = {}; // Restore all wrapped console methods

  levels.forEach(function (level) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (level in global.console && originalConsole[level].__sentry_original__) {
      wrappedLevels[level] = originalConsole[level];
      originalConsole[level] = originalConsole[level].__sentry_original__;
    }
  }); // Perform callback manipulations

  var result = callback(); // Revert restoration to wrapped state

  Object.keys(wrappedLevels).forEach(function (level) {
    originalConsole[level] = wrappedLevels[level];
  });
  return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */

function addExceptionTypeValue(event, value, type) {
  event.exception = event.exception || {};
  event.exception.values = event.exception.values || [];
  event.exception.values[0] = event.exception.values[0] || {};
  event.exception.values[0].value = event.exception.values[0].value || value || '';
  event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */

function addExceptionMechanism(event, mechanism) {
  if (mechanism === void 0) {
    mechanism = {};
  } // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?


  try {
    // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
    Object.keys(mechanism).forEach(function (key) {
      // @ts-ignore Mechanism has no index signature
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      event.exception.values[0].mechanism[key] = mechanism[key];
    });
  } catch (_oO) {// no-empty
  }
}
var defaultRetryAfter = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */

function parseRetryAfterHeader(now, header) {
  if (!header) {
    return defaultRetryAfter;
  }

  var headerDelay = parseInt("" + header, 10);

  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  var headerDate = Date.parse("" + header);

  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return defaultRetryAfter;
}

/* eslint-disable @typescript-eslint/no-explicit-any */

var global$3 = getGlobalObject();
/** Prefix for logging strings */

var PREFIX = 'Sentry Logger ';
/** JSDoc */

var Logger =
/** @class */
function () {
  /** JSDoc */
  function Logger() {
    this._enabled = false;
  }
  /** JSDoc */


  Logger.prototype.disable = function () {
    this._enabled = false;
  };
  /** JSDoc */


  Logger.prototype.enable = function () {
    this._enabled = true;
  };
  /** JSDoc */


  Logger.prototype.log = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!this._enabled) {
      return;
    }

    consoleSandbox(function () {
      global$3.console.log(PREFIX + "[Log]: " + args.join(' '));
    });
  };
  /** JSDoc */


  Logger.prototype.warn = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!this._enabled) {
      return;
    }

    consoleSandbox(function () {
      global$3.console.warn(PREFIX + "[Warn]: " + args.join(' '));
    });
  };
  /** JSDoc */


  Logger.prototype.error = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!this._enabled) {
      return;
    }

    consoleSandbox(function () {
      global$3.console.error(PREFIX + "[Error]: " + args.join(' '));
    });
  };

  return Logger;
}(); // Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used


global$3.__SENTRY__ = global$3.__SENTRY__ || {};
var logger = global$3.__SENTRY__.logger || (global$3.__SENTRY__.logger = new Logger());

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */

function supportsFetch() {
  if (!('fetch' in getGlobalObject())) {
    return false;
  }

  try {
    new Headers();
    new Request('');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types

function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */


function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  var global = getGlobalObject(); // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method

  if (isNativeFetch(global.fetch)) {
    return true;
  } // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch


  var result = false;
  var doc = global.document; // eslint-disable-next-line deprecation/deprecation

  if (doc && typeof doc.createElement === "function") {
    try {
      var sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);

      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }

      doc.head.removeChild(sandbox);
    } catch (err) {
      logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */

function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
  // https://caniuse.com/#feat=referrer-policy
  // It doesn't. And it throw exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233
  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */

function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  var global = getGlobalObject();
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var chrome = global.chrome;
  var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */

  var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
  return !isChromePackagedApp && hasHistoryApi;
}

var global$2 = getGlobalObject();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

var handlers = {};
var instrumented = {};
/** Instruments given API */

function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;

    case 'dom':
      instrumentDOM();
      break;

    case 'xhr':
      instrumentXHR();
      break;

    case 'fetch':
      instrumentFetch();
      break;

    case 'history':
      instrumentHistory();
      break;

    case 'error':
      instrumentError();
      break;

    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;

    default:
      logger.warn('unknown instrumentation type:', type);
  }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */


function addInstrumentationHandler(handler) {
  if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
    return;
  }

  handlers[handler.type] = handlers[handler.type] || [];
  handlers[handler.type].push(handler.callback);
  instrument(handler.type);
}
/** JSDoc */

function triggerHandlers(type, data) {
  var e_1, _a;

  if (!type || !handlers[type]) {
    return;
  }

  try {
    for (var _b = __values$1(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
      var handler = _c.value;

      try {
        handler(data);
      } catch (e) {
        logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + getFunctionName(handler) + "\nError: " + e);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}
/** JSDoc */


function instrumentConsole() {
  if (!('console' in global$2)) {
    return;
  }

  ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
    if (!(level in global$2.console)) {
      return;
    }

    fill(global$2.console, level, function (originalConsoleLevel) {
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        triggerHandlers('console', {
          args: args,
          level: level
        }); // this fails for some browsers. :(

        if (originalConsoleLevel) {
          Function.prototype.apply.call(originalConsoleLevel, global$2.console, args);
        }
      };
    });
  });
}
/** JSDoc */


function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  fill(global$2, 'fetch', function (originalFetch) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var handlerData = {
        args: args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args)
        },
        startTimestamp: Date.now()
      };
      triggerHandlers('fetch', _assign$1({}, handlerData)); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

      return originalFetch.apply(global$2, args).then(function (response) {
        triggerHandlers('fetch', _assign$1(_assign$1({}, handlerData), {
          endTimestamp: Date.now(),
          response: response
        }));
        return response;
      }, function (error) {
        triggerHandlers('fetch', _assign$1(_assign$1({}, handlerData), {
          endTimestamp: Date.now(),
          error: error
        })); // NOTE: If you are a Sentry user, and you are seeing this stack frame,
        //       it means the sentry.javascript SDK caught an error invoking your application code.
        //       This is expected behavior and NOT indicative of a bug with sentry.javascript.

        throw error;
      });
    };
  });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Extract `method` from fetch call arguments */


function getFetchMethod(fetchArgs) {
  if (fetchArgs === void 0) {
    fetchArgs = [];
  }

  if ('Request' in global$2 && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }

  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }

  return 'GET';
}
/** Extract `url` from fetch call arguments */


function getFetchUrl(fetchArgs) {
  if (fetchArgs === void 0) {
    fetchArgs = [];
  }

  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }

  if ('Request' in global$2 && isInstanceOf(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }

  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */


function instrumentXHR() {
  if (!('XMLHttpRequest' in global$2)) {
    return;
  } // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.


  var requestKeys = [];
  var requestValues = [];
  var xhrproto = XMLHttpRequest.prototype;
  fill(xhrproto, 'open', function (originalOpen) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      } // eslint-disable-next-line @typescript-eslint/no-this-alias


      var xhr = this;
      var url = args[1];
      xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: isString(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1]
      }; // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

      if (isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      var onreadystatechangeHandler = function onreadystatechangeHandler() {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            if (xhr.__sentry_xhr__) {
              xhr.__sentry_xhr__.status_code = xhr.status;
            }
          } catch (e) {
            /* do nothing */
          }

          try {
            var requestPos = requestKeys.indexOf(xhr);

            if (requestPos !== -1) {
              // Make sure to pop both key and value to keep it in sync.
              requestKeys.splice(requestPos);
              var args_1 = requestValues.splice(requestPos)[0];

              if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
                xhr.__sentry_xhr__.body = args_1[0];
              }
            }
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args: args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: xhr
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        fill(xhr, 'onreadystatechange', function (original) {
          return function () {
            var readyStateArgs = [];

            for (var _i = 0; _i < arguments.length; _i++) {
              readyStateArgs[_i] = arguments[_i];
            }

            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });
  fill(xhrproto, 'send', function (originalSend) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      requestKeys.push(this);
      requestValues.push(args);
      triggerHandlers('xhr', {
        args: args,
        startTimestamp: Date.now(),
        xhr: this
      });
      return originalSend.apply(this, args);
    };
  });
}

var lastHref;
/** JSDoc */

function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  var oldOnPopState = global$2.onpopstate;

  global$2.onpopstate = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var to = global$2.location.href; // keep track of the current URL state, as we always receive only the updated state

    var from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from: from,
      to: to
    });

    if (oldOnPopState) {
      return oldOnPopState.apply(this, args);
    }
  };
  /** @hidden */


  function historyReplacementFunction(originalHistoryFunction) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var url = args.length > 2 ? args[2] : undefined;

      if (url) {
        // coerce to string (this is what pushState does)
        var from = lastHref;
        var to = String(url); // keep track of the current URL state, as we always receive only the updated state

        lastHref = to;
        triggerHandlers('history', {
          from: from,
          to: to
        });
      }

      return originalHistoryFunction.apply(this, args);
    };
  }

  fill(global$2.history, 'pushState', historyReplacementFunction);
  fill(global$2.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */


function instrumentDOM() {
  if (!('document' in global$2)) {
    return;
  } // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
  // to the document. Do this before we instrument addEventListener.


  global$2.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
  global$2.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false); // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.

  ['EventTarget', 'Node'].forEach(function (target) {
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    var proto = global$2[target] && global$2[target].prototype; // eslint-disable-next-line no-prototype-builtins

    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */


    fill(proto, 'addEventListener', function (original) {
      return function (eventName, fn, options) {
        if (fn && fn.handleEvent) {
          if (eventName === 'click') {
            fill(fn, 'handleEvent', function (innerOriginal) {
              return function (event) {
                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                return innerOriginal.call(this, event);
              };
            });
          }

          if (eventName === 'keypress') {
            fill(fn, 'handleEvent', function (innerOriginal) {
              return function (event) {
                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                return innerOriginal.call(this, event);
              };
            });
          }
        } else {
          if (eventName === 'click') {
            domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
          }

          if (eventName === 'keypress') {
            keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
          }
        }

        return original.call(this, eventName, fn, options);
      };
    });
    fill(proto, 'removeEventListener', function (original) {
      return function (eventName, fn, options) {
        try {
          original.call(this, eventName, fn.__sentry_wrapped__, options);
        } catch (e) {// ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }

        return original.call(this, eventName, fn, options);
      };
    });
  });
}

var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */

function domEventHandler(name, handler, debounce) {
  if (debounce === void 0) {
    debounce = false;
  }

  return function (event) {
    // reset keypress timeout; e.g. triggering a 'click' after
    // a 'keypress' will reset the keypress debounce so that a new
    // set of keypresses can be recorded
    keypressTimeout = undefined; // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors). Ignore if we've
    // already captured the event.

    if (!event || lastCapturedEvent === event) {
      return;
    }

    lastCapturedEvent = event;

    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    if (debounce) {
      debounceTimer = setTimeout(function () {
        handler({
          event: event,
          name: name
        });
      });
    } else {
      handler({
        event: event,
        name: name
      });
    }
  };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */


function keypressEventHandler(handler) {
  // TODO: if somehow user switches keypress target before
  //       debounce timeout is triggered, we will only capture
  //       a single breadcrumb from the FIRST target (acceptable?)
  return function (event) {
    var target;

    try {
      target = event.target;
    } catch (e) {
      // just accessing event properties can throw an exception in some rare circumstances
      // see: https://github.com/getsentry/raven-js/issues/838
      return;
    }

    var tagName = target && target.tagName; // only consider keypress events on actual input elements
    // this will disregard keypresses targeting body (e.g. tabbing
    // through elements, hotkeys, etc)

    if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable) {
      return;
    } // record first keypress in a series, but ignore subsequent
    // keypresses until debounce clears


    if (!keypressTimeout) {
      domEventHandler('input', handler)(event);
    }

    clearTimeout(keypressTimeout);
    keypressTimeout = setTimeout(function () {
      keypressTimeout = undefined;
    }, debounceDuration);
  };
}

var _oldOnErrorHandler = null;
/** JSDoc */

function instrumentError() {
  _oldOnErrorHandler = global$2.onerror;

  global$2.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column: column,
      error: error,
      line: line,
      msg: msg,
      url: url
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */

function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = global$2.onunhandledrejection;

  global$2.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/** SyncPromise internal states */

var States;

(function (States) {
  /** Pending */
  States["PENDING"] = "PENDING";
  /** Resolved / OK */

  States["RESOLVED"] = "RESOLVED";
  /** Rejected / Error */

  States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */


var SyncPromise =
/** @class */
function () {
  function SyncPromise(executor) {
    var _this = this;

    this._state = States.PENDING;
    this._handlers = [];
    /** JSDoc */

    this._resolve = function (value) {
      _this._setResult(States.RESOLVED, value);
    };
    /** JSDoc */


    this._reject = function (reason) {
      _this._setResult(States.REJECTED, reason);
    };
    /** JSDoc */


    this._setResult = function (state, value) {
      if (_this._state !== States.PENDING) {
        return;
      }

      if (isThenable(value)) {
        value.then(_this._resolve, _this._reject);
        return;
      }

      _this._state = state;
      _this._value = value;

      _this._executeHandlers();
    }; // TODO: FIXME

    /** JSDoc */


    this._attachHandler = function (handler) {
      _this._handlers = _this._handlers.concat(handler);

      _this._executeHandlers();
    };
    /** JSDoc */


    this._executeHandlers = function () {
      if (_this._state === States.PENDING) {
        return;
      }

      var cachedHandlers = _this._handlers.slice();

      _this._handlers = [];
      cachedHandlers.forEach(function (handler) {
        if (handler.done) {
          return;
        }

        if (_this._state === States.RESOLVED) {
          if (handler.onfulfilled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            handler.onfulfilled(_this._value);
          }
        }

        if (_this._state === States.REJECTED) {
          if (handler.onrejected) {
            handler.onrejected(_this._value);
          }
        }

        handler.done = true;
      });
    };

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }
  /** JSDoc */


  SyncPromise.resolve = function (value) {
    return new SyncPromise(function (resolve) {
      resolve(value);
    });
  };
  /** JSDoc */


  SyncPromise.reject = function (reason) {
    return new SyncPromise(function (_, reject) {
      reject(reason);
    });
  };
  /** JSDoc */


  SyncPromise.all = function (collection) {
    return new SyncPromise(function (resolve, reject) {
      if (!Array.isArray(collection)) {
        reject(new TypeError("Promise.all requires an array as input."));
        return;
      }

      if (collection.length === 0) {
        resolve([]);
        return;
      }

      var counter = collection.length;
      var resolvedCollection = [];
      collection.forEach(function (item, index) {
        SyncPromise.resolve(item).then(function (value) {
          resolvedCollection[index] = value;
          counter -= 1;

          if (counter !== 0) {
            return;
          }

          resolve(resolvedCollection);
        }).then(null, reject);
      });
    });
  };
  /** JSDoc */


  SyncPromise.prototype.then = function (_onfulfilled, _onrejected) {
    var _this = this;

    return new SyncPromise(function (resolve, reject) {
      _this._attachHandler({
        done: false,
        onfulfilled: function onfulfilled(result) {
          if (!_onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result);
            return;
          }

          try {
            resolve(_onfulfilled(result));
            return;
          } catch (e) {
            reject(e);
            return;
          }
        },
        onrejected: function onrejected(reason) {
          if (!_onrejected) {
            reject(reason);
            return;
          }

          try {
            resolve(_onrejected(reason));
            return;
          } catch (e) {
            reject(e);
            return;
          }
        }
      });
    });
  };
  /** JSDoc */


  SyncPromise.prototype.catch = function (onrejected) {
    return this.then(function (val) {
      return val;
    }, onrejected);
  };
  /** JSDoc */


  SyncPromise.prototype.finally = function (onfinally) {
    var _this = this;

    return new SyncPromise(function (resolve, reject) {
      var val;
      var isRejected;
      return _this.then(function (value) {
        isRejected = false;
        val = value;

        if (onfinally) {
          onfinally();
        }
      }, function (reason) {
        isRejected = true;
        val = reason;

        if (onfinally) {
          onfinally();
        }
      }).then(function () {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val);
      });
    });
  };
  /** JSDoc */


  SyncPromise.prototype.toString = function () {
    return '[object SyncPromise]';
  };

  return SyncPromise;
}();

/** A simple queue that holds promises. */

var PromiseBuffer =
/** @class */
function () {
  function PromiseBuffer(_limit) {
    this._limit = _limit;
    /** Internal set of queued Promises */

    this._buffer = [];
  }
  /**
   * Says if the buffer is ready to take more requests
   */


  PromiseBuffer.prototype.isReady = function () {
    return this._limit === undefined || this.length() < this._limit;
  };
  /**
   * Add a promise to the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns The original promise.
   */


  PromiseBuffer.prototype.add = function (task) {
    var _this = this;

    if (!this.isReady()) {
      return SyncPromise.reject(new SentryError('Not adding Promise due to buffer limit reached.'));
    }

    if (this._buffer.indexOf(task) === -1) {
      this._buffer.push(task);
    }

    task.then(function () {
      return _this.remove(task);
    }).then(null, function () {
      return _this.remove(task).then(null, function () {// We have to add this catch here otherwise we have an unhandledPromiseRejection
        // because it's a new Promise chain.
      });
    });
    return task;
  };
  /**
   * Remove a promise to the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */


  PromiseBuffer.prototype.remove = function (task) {
    var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];

    return removedTask;
  };
  /**
   * This function returns the number of unresolved promises in the queue.
   */


  PromiseBuffer.prototype.length = function () {
    return this._buffer.length;
  };
  /**
   * This will drain the whole queue, returns true if queue is empty or drained.
   * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
   *
   * @param timeout Number in ms to wait until it resolves with false.
   */


  PromiseBuffer.prototype.drain = function (timeout) {
    var _this = this;

    return new SyncPromise(function (resolve) {
      var capturedSetTimeout = setTimeout(function () {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);
      SyncPromise.all(_this._buffer).then(function () {
        clearTimeout(capturedSetTimeout);
        resolve(true);
      }).then(null, function () {
        resolve(true);
      });
    });
  };

  return PromiseBuffer;
}();

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */

var dateTimestampSource = {
  nowSeconds: function nowSeconds() {
    return Date.now() / 1000;
  }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */

function getBrowserPerformance() {
  var performance = getGlobalObject().performance;

  if (!performance || !performance.now) {
    return undefined;
  } // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.


  var timeOrigin = Date.now() - performance.now();
  return {
    now: function now() {
      return performance.now();
    },
    timeOrigin: timeOrigin
  };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */


function getNodePerformance() {
  try {
    var perfHooks = dynamicRequire(module, 'perf_hooks');
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}
/**
 * The Performance API implementation for the current platform, if available.
 */


var platformPerformance = isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
  nowSeconds: function nowSeconds() {
    return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
  }
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */

var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */

timestampSource.nowSeconds.bind(timestampSource); // Re-exported with an old name for backwards-compatibility.
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */

(function () {
  var performance = getGlobalObject().performance;

  if (!performance) {
    return undefined;
  }

  if (performance.timeOrigin) {
    return performance.timeOrigin;
  } // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation


  return performance.timing && performance.timing.navigationStart || Date.now();
})();

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */

var Scope =
/** @class */
function () {
  function Scope() {
    /** Flag if notifiying is happening. */
    this._notifyingListeners = false;
    /** Callback for client to receive scope changes. */

    this._scopeListeners = [];
    /** Callback list that will be called after {@link applyToEvent}. */

    this._eventProcessors = [];
    /** Array of breadcrumbs. */

    this._breadcrumbs = [];
    /** User */

    this._user = {};
    /** Tags */

    this._tags = {};
    /** Extra */

    this._extra = {};
    /** Contexts */

    this._contexts = {};
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */


  Scope.clone = function (scope) {
    var newScope = new Scope();

    if (scope) {
      newScope._breadcrumbs = __spread$1(scope._breadcrumbs);
      newScope._tags = _assign$2({}, scope._tags);
      newScope._extra = _assign$2({}, scope._extra);
      newScope._contexts = _assign$2({}, scope._contexts);
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = __spread$1(scope._eventProcessors);
    }

    return newScope;
  };
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */


  Scope.prototype.addScopeListener = function (callback) {
    this._scopeListeners.push(callback);
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.addEventProcessor = function (callback) {
    this._eventProcessors.push(callback);

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setUser = function (user) {
    this._user = user || {};

    if (this._session) {
      this._session.update({
        user: user
      });
    }

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.getUser = function () {
    return this._user;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setTags = function (tags) {
    this._tags = _assign$2(_assign$2({}, this._tags), tags);

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setTag = function (key, value) {
    var _a;

    this._tags = _assign$2(_assign$2({}, this._tags), (_a = {}, _a[key] = value, _a));

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setExtras = function (extras) {
    this._extra = _assign$2(_assign$2({}, this._extra), extras);

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setExtra = function (key, extra) {
    var _a;

    this._extra = _assign$2(_assign$2({}, this._extra), (_a = {}, _a[key] = extra, _a));

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setFingerprint = function (fingerprint) {
    this._fingerprint = fingerprint;

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setLevel = function (level) {
    this._level = level;

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setTransactionName = function (name) {
    this._transactionName = name;

    this._notifyScopeListeners();

    return this;
  };
  /**
   * Can be removed in major version.
   * @deprecated in favor of {@link this.setTransactionName}
   */


  Scope.prototype.setTransaction = function (name) {
    return this.setTransactionName(name);
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setContext = function (key, context) {
    var _a;

    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts = _assign$2(_assign$2({}, this._contexts), (_a = {}, _a[key] = context, _a));
    }

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setSpan = function (span) {
    this._span = span;

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.getSpan = function () {
    return this._span;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.getTransaction = function () {
    var _a, _b, _c, _d; // often, this span will be a transaction, but it's not guaranteed to be


    var span = this.getSpan(); // try it the new way first

    if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
      return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
    } // fallback to the old way (known bug: this only finds transactions with sampled = true)


    if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
      return span.spanRecorder.spans[0];
    } // neither way found a transaction


    return undefined;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.setSession = function (session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.getSession = function () {
    return this._session;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.update = function (captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      var updatedScope = captureContext(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = _assign$2(_assign$2({}, this._tags), captureContext._tags);
      this._extra = _assign$2(_assign$2({}, this._extra), captureContext._extra);
      this._contexts = _assign$2(_assign$2({}, this._contexts), captureContext._contexts);

      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }

      if (captureContext._level) {
        this._level = captureContext._level;
      }

      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
    } else if (isPlainObject(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext;
      this._tags = _assign$2(_assign$2({}, this._tags), captureContext.tags);
      this._extra = _assign$2(_assign$2({}, this._extra), captureContext.extra);
      this._contexts = _assign$2(_assign$2({}, this._contexts), captureContext.contexts);

      if (captureContext.user) {
        this._user = captureContext.user;
      }

      if (captureContext.level) {
        this._level = captureContext.level;
      }

      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
    }

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.clear = function () {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._span = undefined;
    this._session = undefined;

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
    var mergedBreadcrumb = _assign$2({
      timestamp: dateTimestampInSeconds()
    }, breadcrumb);

    this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? __spread$1(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs) : __spread$1(this._breadcrumbs, [mergedBreadcrumb]);

    this._notifyScopeListeners();

    return this;
  };
  /**
   * @inheritDoc
   */


  Scope.prototype.clearBreadcrumbs = function () {
    this._breadcrumbs = [];

    this._notifyScopeListeners();

    return this;
  };
  /**
   * Applies the current context and fingerprint to the event.
   * Note that breadcrumbs will be added by the client.
   * Also if the event has already breadcrumbs on it, we do not merge them.
   * @param event Event
   * @param hint May contain additional informartion about the original exception.
   * @hidden
   */


  Scope.prototype.applyToEvent = function (event, hint) {
    var _a;

    if (this._extra && Object.keys(this._extra).length) {
      event.extra = _assign$2(_assign$2({}, this._extra), event.extra);
    }

    if (this._tags && Object.keys(this._tags).length) {
      event.tags = _assign$2(_assign$2({}, this._tags), event.tags);
    }

    if (this._user && Object.keys(this._user).length) {
      event.user = _assign$2(_assign$2({}, this._user), event.user);
    }

    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = _assign$2(_assign$2({}, this._contexts), event.contexts);
    }

    if (this._level) {
      event.level = this._level;
    }

    if (this._transactionName) {
      event.transaction = this._transactionName;
    } // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relys on that.


    if (this._span) {
      event.contexts = _assign$2({
        trace: this._span.getTraceContext()
      }, event.contexts);
      var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;

      if (transactionName) {
        event.tags = _assign$2({
          transaction: transactionName
        }, event.tags);
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = __spread$1(event.breadcrumbs || [], this._breadcrumbs);
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
    return this._notifyEventProcessors(__spread$1(getGlobalEventProcessors(), this._eventProcessors), event, hint);
  };
  /**
   * This will be called after {@link applyToEvent} is finished.
   */


  Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
    var _this = this;

    if (index === void 0) {
      index = 0;
    }

    return new SyncPromise(function (resolve, reject) {
      var processor = processors[index];

      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        var result = processor(_assign$2({}, event), hint);

        if (isThenable(result)) {
          result.then(function (final) {
            return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
          }).then(null, reject);
        } else {
          _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
      }
    });
  };
  /**
   * This will be called on every set call.
   */


  Scope.prototype._notifyScopeListeners = function () {
    var _this = this; // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.


    if (!this._notifyingListeners) {
      this._notifyingListeners = true;

      this._scopeListeners.forEach(function (callback) {
        callback(_this);
      });

      this._notifyingListeners = false;
    }
  };
  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */


  Scope.prototype._applyFingerprint = function (event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : []; // If we have something on the scope, then merge it with event

    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    } // If we have no data at all, remove empty array default


    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  };

  return Scope;
}();
/**
 * Retruns the global event processors.
 */

function getGlobalEventProcessors() {
  /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
  var global = getGlobalObject();
  global.__SENTRY__ = global.__SENTRY__ || {};
  global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
  return global.__SENTRY__.globalEventProcessors;
  /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */


function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

/**
 * @inheritdoc
 */

var Session =
/** @class */
function () {
  function Session(context) {
    this.errors = 0;
    this.sid = uuid4();
    this.timestamp = Date.now();
    this.started = Date.now();
    this.duration = 0;
    this.status = SessionStatus.Ok;

    if (context) {
      this.update(context);
    }
  }
  /** JSDoc */
  // eslint-disable-next-line complexity


  Session.prototype.update = function (context) {
    if (context === void 0) {
      context = {};
    }

    if (context.user) {
      if (context.user.ip_address) {
        this.ipAddress = context.user.ip_address;
      }

      if (!context.did) {
        this.did = context.user.id || context.user.email || context.user.username;
      }
    }

    this.timestamp = context.timestamp || Date.now();

    if (context.sid) {
      // Good enough uuid validation. — Kamil
      this.sid = context.sid.length === 32 ? context.sid : uuid4();
    }

    if (context.did) {
      this.did = "" + context.did;
    }

    if (typeof context.started === 'number') {
      this.started = context.started;
    }

    if (typeof context.duration === 'number') {
      this.duration = context.duration;
    } else {
      this.duration = this.timestamp - this.started;
    }

    if (context.release) {
      this.release = context.release;
    }

    if (context.environment) {
      this.environment = context.environment;
    }

    if (context.ipAddress) {
      this.ipAddress = context.ipAddress;
    }

    if (context.userAgent) {
      this.userAgent = context.userAgent;
    }

    if (typeof context.errors === 'number') {
      this.errors = context.errors;
    }

    if (context.status) {
      this.status = context.status;
    }
  };
  /** JSDoc */


  Session.prototype.close = function (status) {
    if (status) {
      this.update({
        status: status
      });
    } else if (this.status === SessionStatus.Ok) {
      this.update({
        status: SessionStatus.Exited
      });
    } else {
      this.update();
    }
  };
  /** JSDoc */


  Session.prototype.toJSON = function () {
    return dropUndefinedKeys({
      sid: "" + this.sid,
      init: true,
      started: new Date(this.started).toISOString(),
      timestamp: new Date(this.timestamp).toISOString(),
      status: this.status,
      errors: this.errors,
      did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
      duration: this.duration,
      attrs: dropUndefinedKeys({
        release: this.release,
        environment: this.environment,
        ip_address: this.ipAddress,
        user_agent: this.userAgent
      })
    });
  };

  return Session;
}();

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */

var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */

var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */

var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */

var Hub =
/** @class */
function () {
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  function Hub(client, scope, _version) {
    if (scope === void 0) {
      scope = new Scope();
    }

    if (_version === void 0) {
      _version = API_VERSION;
    }

    this._version = _version;
    /** Is a {@link Layer}[] containing the client and scope */

    this._stack = [{}];
    this.getStackTop().scope = scope;
    this.bindClient(client);
  }
  /**
   * @inheritDoc
   */


  Hub.prototype.isOlderThan = function (version) {
    return this._version < version;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.bindClient = function (client) {
    var top = this.getStackTop();
    top.client = client;

    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.pushScope = function () {
    // We want to clone the content of prev scope
    var scope = Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope: scope
    });
    return scope;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.popScope = function () {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.withScope = function (callback) {
    var scope = this.pushScope();

    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.getClient = function () {
    return this.getStackTop().client;
  };
  /** Returns the scope of the top stack. */


  Hub.prototype.getScope = function () {
    return this.getStackTop().scope;
  };
  /** Returns the scope stack for domains or the process. */


  Hub.prototype.getStack = function () {
    return this._stack;
  };
  /** Returns the topmost scope layer in the order domain > local > process. */


  Hub.prototype.getStackTop = function () {
    return this._stack[this._stack.length - 1];
  };
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types


  Hub.prototype.captureException = function (exception, hint) {
    var eventId = this._lastEventId = uuid4();
    var finalHint = hint; // If there's no explicit hint provided, mimick the same thing that would happen
    // in the minimal itself to create a consistent behavior.
    // We don't do this in the client, as it's the lowest level API, and doing this,
    // would prevent user from having full control over direct calls.

    if (!hint) {
      var syntheticException = void 0;

      try {
        throw new Error('Sentry syntheticException');
      } catch (exception) {
        syntheticException = exception;
      }

      finalHint = {
        originalException: exception,
        syntheticException: syntheticException
      };
    }

    this._invokeClient('captureException', exception, _assign$2(_assign$2({}, finalHint), {
      event_id: eventId
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.captureMessage = function (message, level, hint) {
    var eventId = this._lastEventId = uuid4();
    var finalHint = hint; // If there's no explicit hint provided, mimick the same thing that would happen
    // in the minimal itself to create a consistent behavior.
    // We don't do this in the client, as it's the lowest level API, and doing this,
    // would prevent user from having full control over direct calls.

    if (!hint) {
      var syntheticException = void 0;

      try {
        throw new Error(message);
      } catch (exception) {
        syntheticException = exception;
      }

      finalHint = {
        originalException: message,
        syntheticException: syntheticException
      };
    }

    this._invokeClient('captureMessage', message, level, _assign$2(_assign$2({}, finalHint), {
      event_id: eventId
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.captureEvent = function (event, hint) {
    var eventId = this._lastEventId = uuid4();

    this._invokeClient('captureEvent', event, _assign$2(_assign$2({}, hint), {
      event_id: eventId
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.lastEventId = function () {
    return this._lastEventId;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
    var _a = this.getStackTop(),
        scope = _a.scope,
        client = _a.client;

    if (!scope || !client) return; // eslint-disable-next-line @typescript-eslint/unbound-method

    var _b = client.getOptions && client.getOptions() || {},
        _c = _b.beforeBreadcrumb,
        beforeBreadcrumb = _c === void 0 ? null : _c,
        _d = _b.maxBreadcrumbs,
        maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;

    if (maxBreadcrumbs <= 0) return;
    var timestamp = dateTimestampInSeconds();

    var mergedBreadcrumb = _assign$2({
      timestamp: timestamp
    }, breadcrumb);

    var finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(function () {
      return beforeBreadcrumb(mergedBreadcrumb, hint);
    }) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.setUser = function (user) {
    var scope = this.getScope();
    if (scope) scope.setUser(user);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.setTags = function (tags) {
    var scope = this.getScope();
    if (scope) scope.setTags(tags);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.setExtras = function (extras) {
    var scope = this.getScope();
    if (scope) scope.setExtras(extras);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.setTag = function (key, value) {
    var scope = this.getScope();
    if (scope) scope.setTag(key, value);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.setExtra = function (key, extra) {
    var scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  };
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Hub.prototype.setContext = function (name, context) {
    var scope = this.getScope();
    if (scope) scope.setContext(name, context);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.configureScope = function (callback) {
    var _a = this.getStackTop(),
        scope = _a.scope,
        client = _a.client;

    if (scope && client) {
      callback(scope);
    }
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.run = function (callback) {
    var oldHub = makeMain(this);

    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.getIntegration = function (integration) {
    var client = this.getClient();
    if (!client) return null;

    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
      return null;
    }
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.startSpan = function (context) {
    return this._callExtensionMethod('startSpan', context);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.startTransaction = function (context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.traceHeaders = function () {
    return this._callExtensionMethod('traceHeaders');
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.startSession = function (context) {
    // End existing session if there's one
    this.endSession();

    var _a = this.getStackTop(),
        scope = _a.scope,
        client = _a.client;

    var _b = client && client.getOptions() || {},
        release = _b.release,
        environment = _b.environment;

    var session = new Session(_assign$2(_assign$2({
      release: release,
      environment: environment
    }, scope && {
      user: scope.getUser()
    }), context));

    if (scope) {
      scope.setSession(session);
    }

    return session;
  };
  /**
   * @inheritDoc
   */


  Hub.prototype.endSession = function () {
    var _a = this.getStackTop(),
        scope = _a.scope,
        client = _a.client;

    if (!scope) return;
    var session = scope.getSession && scope.getSession();

    if (session) {
      session.close();

      if (client && client.captureSession) {
        client.captureSession(session);
      }

      scope.setSession();
    }
  };
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Hub.prototype._invokeClient = function (method) {
    var _a;

    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var _b = this.getStackTop(),
        scope = _b.scope,
        client = _b.client;

    if (client && client[method]) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      (_a = client)[method].apply(_a, __spread$1(args, [scope]));
    }
  };
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Hub.prototype._callExtensionMethod = function (method) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var carrier = getMainCarrier();
    var sentry = carrier.__SENTRY__;

    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }

    logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
  };

  return Hub;
}();
/** Returns the global shim registry. */

function getMainCarrier() {
  var carrier = getGlobalObject();
  carrier.__SENTRY__ = carrier.__SENTRY__ || {
    extensions: {},
    hub: undefined
  };
  return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */

function makeMain(hub) {
  var registry = getMainCarrier();
  var oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */

function getCurrentHub() {
  // Get main carrier (global for every environment)
  var registry = getMainCarrier(); // If there's no hub, or its an old API, assign a new one

  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  } // Prefer domains over global if they are there (applicable only to Node environment)


  if (isNodeEnv()) {
    return getHubFromActiveDomain(registry);
  } // Return hub that lives on a global object


  return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 *
 * @returns The domain, or undefined if there is no active domain
 */

function getActiveDomain() {
  var sentry = getMainCarrier().__SENTRY__;

  return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */

function getHubFromActiveDomain(registry) {
  try {
    var activeDomain = getActiveDomain(); // If there's no active domain, just return global hub

    if (!activeDomain) {
      return getHubFromCarrier(registry);
    } // If there's no hub on current domain, or it's an old API, assign a new one


    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
    } // Return hub that lives on a domain


    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */


function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */


function getHubFromCarrier(carrier) {
  if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return carrier.__SENTRY__.hub;
  carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  carrier.__SENTRY__.hub = new Hub();
  return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */

function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  carrier.__SENTRY__.hub = hub;
  return true;
}

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */

var API =
/** @class */
function () {
  /** Create a new instance of API */
  function API(dsn) {
    this.dsn = dsn;
    this._dsnObject = new Dsn(dsn);
  }
  /** Returns the Dsn object. */


  API.prototype.getDsn = function () {
    return this._dsnObject;
  };
  /** Returns the prefix to construct Sentry ingestion API endpoints. */


  API.prototype.getBaseApiEndpoint = function () {
    var dsn = this._dsnObject;
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
  };
  /** Returns the store endpoint URL. */


  API.prototype.getStoreEndpoint = function () {
    return this._getIngestEndpoint('store');
  };
  /**
   * Returns the store endpoint URL with auth in the query string.
   *
   * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
   */


  API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
    return this.getStoreEndpoint() + "?" + this._encodedAuth();
  };
  /**
   * Returns the envelope endpoint URL with auth in the query string.
   *
   * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
   */


  API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
    return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
  };
  /** Returns only the path component for the store endpoint. */


  API.prototype.getStoreEndpointPath = function () {
    var dsn = this._dsnObject;
    return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
  };
  /**
   * Returns an object that can be used in request headers.
   * This is needed for node and the old /store endpoint in sentry
   */


  API.prototype.getRequestHeaders = function (clientName, clientVersion) {
    var dsn = this._dsnObject;
    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.user);

    if (dsn.pass) {
      header.push("sentry_secret=" + dsn.pass);
    }

    return {
      'Content-Type': 'application/json',
      'X-Sentry-Auth': header.join(', ')
    };
  };
  /** Returns the url to the report dialog endpoint. */


  API.prototype.getReportDialogEndpoint = function (dialogOptions) {
    if (dialogOptions === void 0) {
      dialogOptions = {};
    }

    var dsn = this._dsnObject;
    var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
    var encodedOptions = [];
    encodedOptions.push("dsn=" + dsn.toString());

    for (var key in dialogOptions) {
      if (key === 'dsn') {
        continue;
      }

      if (key === 'user') {
        if (!dialogOptions.user) {
          continue;
        }

        if (dialogOptions.user.name) {
          encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
        }

        if (dialogOptions.user.email) {
          encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
        }
      } else {
        encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
      }
    }

    if (encodedOptions.length) {
      return endpoint + "?" + encodedOptions.join('&');
    }

    return endpoint;
  };
  /** Returns the envelope endpoint URL. */


  API.prototype._getEnvelopeEndpoint = function () {
    return this._getIngestEndpoint('envelope');
  };
  /** Returns the ingest API endpoint for target. */


  API.prototype._getIngestEndpoint = function (target) {
    var base = this.getBaseApiEndpoint();
    var dsn = this._dsnObject;
    return "" + base + dsn.projectId + "/" + target + "/";
  };
  /** Returns a URL-encoded string with auth config suitable for a query string. */


  API.prototype._encodedAuth = function () {
    var dsn = this._dsnObject;
    var auth = {
      // We send only the minimum set of required information. See
      // https://github.com/getsentry/sentry-javascript/issues/2572.
      sentry_key: dsn.user,
      sentry_version: SENTRY_API_VERSION
    };
    return urlEncode(auth);
  };

  return API;
}();

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var installedIntegrations = [];
/** Gets integration to install */

function getIntegrationsToSetup(options) {
  var defaultIntegrations = options.defaultIntegrations && __spread(options.defaultIntegrations) || [];
  var userIntegrations = options.integrations;
  var integrations = [];

  if (Array.isArray(userIntegrations)) {
    var userIntegrationsNames_1 = userIntegrations.map(function (i) {
      return i.name;
    });
    var pickedIntegrationsNames_1 = []; // Leave only unique default integrations, that were not overridden with provided user integrations

    defaultIntegrations.forEach(function (defaultIntegration) {
      if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 && pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
        integrations.push(defaultIntegration);
        pickedIntegrationsNames_1.push(defaultIntegration.name);
      }
    }); // Don't add same user integration twice

    userIntegrations.forEach(function (userIntegration) {
      if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
        integrations.push(userIntegration);
        pickedIntegrationsNames_1.push(userIntegration.name);
      }
    });
  } else if (typeof userIntegrations === 'function') {
    integrations = userIntegrations(defaultIntegrations);
    integrations = Array.isArray(integrations) ? integrations : [integrations];
  } else {
    integrations = __spread(defaultIntegrations);
  } // Make sure that if present, `Debug` integration will always run last


  var integrationsNames = integrations.map(function (i) {
    return i.name;
  });
  var alwaysLastToRun = 'Debug';

  if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
    integrations.push.apply(integrations, __spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
  }

  return integrations;
}
/** Setup given integration */

function setupIntegration(integration) {
  if (installedIntegrations.indexOf(integration.name) !== -1) {
    return;
  }

  integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
  installedIntegrations.push(integration.name);
  logger.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */

function setupIntegrations(options) {
  var integrations = {};
  getIntegrationsToSetup(options).forEach(function (integration) {
    integrations[integration.name] = integration;
    setupIntegration(integration);
  });
  return integrations;
}

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */

var BaseClient =
/** @class */
function () {
  /**
   * Initializes this client instance.
   *
   * @param backendClass A constructor function to create the backend.
   * @param options Options for the client.
   */
  function BaseClient(backendClass, options) {
    /** Array of used integrations. */
    this._integrations = {};
    /** Number of call being processed */

    this._processing = 0;
    this._backend = new backendClass(options);
    this._options = options;

    if (options.dsn) {
      this._dsn = new Dsn(options.dsn);
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types


  BaseClient.prototype.captureException = function (exception, hint, scope) {
    var _this = this;

    var eventId = hint && hint.event_id;

    this._process(this._getBackend().eventFromException(exception, hint).then(function (event) {
      return _this._captureEvent(event, hint, scope);
    }).then(function (result) {
      eventId = result;
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
    var _this = this;

    var eventId = hint && hint.event_id;
    var promisedEvent = isPrimitive(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);

    this._process(promisedEvent.then(function (event) {
      return _this._captureEvent(event, hint, scope);
    }).then(function (result) {
      eventId = result;
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.captureEvent = function (event, hint, scope) {
    var eventId = hint && hint.event_id;

    this._process(this._captureEvent(event, hint, scope).then(function (result) {
      eventId = result;
    }));

    return eventId;
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.captureSession = function (session) {
    if (!session.release) {
      logger.warn('Discarded session because of missing release');
    } else {
      this._sendSession(session);
    }
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.getDsn = function () {
    return this._dsn;
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.getOptions = function () {
    return this._options;
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.flush = function (timeout) {
    var _this = this;

    return this._isClientProcessing(timeout).then(function (ready) {
      return _this._getBackend().getTransport().close(timeout).then(function (transportFlushed) {
        return ready && transportFlushed;
      });
    });
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.close = function (timeout) {
    var _this = this;

    return this.flush(timeout).then(function (result) {
      _this.getOptions().enabled = false;
      return result;
    });
  };
  /**
   * Sets up the integrations
   */


  BaseClient.prototype.setupIntegrations = function () {
    if (this._isEnabled()) {
      this._integrations = setupIntegrations(this._options);
    }
  };
  /**
   * @inheritDoc
   */


  BaseClient.prototype.getIntegration = function (integration) {
    try {
      return this._integrations[integration.id] || null;
    } catch (_oO) {
      logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
      return null;
    }
  };
  /** Updates existing session based on the provided event */


  BaseClient.prototype._updateSessionFromEvent = function (session, event) {
    var e_1, _a;

    var crashed = false;
    var errored = false;
    var userAgent;
    var exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      try {
        for (var exceptions_1 = __values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
          var ex = exceptions_1_1.value;
          var mechanism = ex.mechanism;

          if (mechanism && mechanism.handled === false) {
            crashed = true;
            break;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    var user = event.user;

    if (!session.userAgent) {
      var headers = event.request ? event.request.headers : {};

      for (var key in headers) {
        if (key.toLowerCase() === 'user-agent') {
          userAgent = headers[key];
          break;
        }
      }
    }

    session.update(_assign(_assign({}, crashed && {
      status: SessionStatus.Crashed
    }), {
      user: user,
      userAgent: userAgent,
      errors: session.errors + Number(errored || crashed)
    }));
  };
  /** Deliver captured session to Sentry */


  BaseClient.prototype._sendSession = function (session) {
    this._getBackend().sendSession(session);
  };
  /** Waits for the client to be done with processing. */


  BaseClient.prototype._isClientProcessing = function (timeout) {
    var _this = this;

    return new SyncPromise(function (resolve) {
      var ticked = 0;
      var tick = 1;
      var interval = setInterval(function () {
        if (_this._processing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;

          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  };
  /** Returns the current backend. */


  BaseClient.prototype._getBackend = function () {
    return this._backend;
  };
  /** Determines whether this SDK is enabled and a valid Dsn is present. */


  BaseClient.prototype._isEnabled = function () {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  };
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */


  BaseClient.prototype._prepareEvent = function (event, scope, hint) {
    var _this = this;

    var _a = this.getOptions().normalizeDepth,
        normalizeDepth = _a === void 0 ? 3 : _a;

    var prepared = _assign(_assign({}, event), {
      event_id: event.event_id || (hint && hint.event_id ? hint.event_id : uuid4()),
      timestamp: event.timestamp || dateTimestampInSeconds()
    });

    this._applyClientOptions(prepared);

    this._applyIntegrationsMetadata(prepared); // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.


    var finalScope = scope;

    if (hint && hint.captureContext) {
      finalScope = Scope.clone(finalScope).update(hint.captureContext);
    } // We prepare the result here with a resolved Event.


    var result = SyncPromise.resolve(prepared); // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.

    if (finalScope) {
      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(function (evt) {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return _this._normalizeEvent(evt, normalizeDepth);
      }

      return evt;
    });
  };
  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */


  BaseClient.prototype._normalizeEvent = function (event, depth) {
    if (!event) {
      return null;
    }

    var normalized = _assign(_assign(_assign(_assign(_assign({}, event), event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(function (b) {
        return _assign(_assign({}, b), b.data && {
          data: normalize(b.data, depth)
        });
      })
    }), event.user && {
      user: normalize(event.user, depth)
    }), event.contexts && {
      contexts: normalize(event.contexts, depth)
    }), event.extra && {
      extra: normalize(event.extra, depth)
    }); // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.


    if (event.contexts && event.contexts.trace) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      normalized.contexts.trace = event.contexts.trace;
    }

    return normalized;
  };
  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */


  BaseClient.prototype._applyClientOptions = function (event) {
    var options = this.getOptions();
    var environment = options.environment,
        release = options.release,
        dist = options.dist,
        _a = options.maxValueLength,
        maxValueLength = _a === void 0 ? 250 : _a;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = truncate(event.message, maxValueLength);
    }

    var exception = event.exception && event.exception.values && event.exception.values[0];

    if (exception && exception.value) {
      exception.value = truncate(exception.value, maxValueLength);
    }

    var request = event.request;

    if (request && request.url) {
      request.url = truncate(request.url, maxValueLength);
    }
  };
  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
   */


  BaseClient.prototype._applyIntegrationsMetadata = function (event) {
    var sdkInfo = event.sdk;
    var integrationsArray = Object.keys(this._integrations);

    if (sdkInfo && integrationsArray.length > 0) {
      sdkInfo.integrations = integrationsArray;
    }
  };
  /**
   * Tells the backend to send this event
   * @param event The Sentry event to send
   */


  BaseClient.prototype._sendEvent = function (event) {
    this._getBackend().sendEvent(event);
  };
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */


  BaseClient.prototype._captureEvent = function (event, hint, scope) {
    return this._processEvent(event, hint, scope).then(function (finalEvent) {
      return finalEvent.event_id;
    }, function (reason) {
      logger.error(reason);
      return undefined;
    });
  };
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */


  BaseClient.prototype._processEvent = function (event, hint, scope) {
    var _this = this; // eslint-disable-next-line @typescript-eslint/unbound-method


    var _a = this.getOptions(),
        beforeSend = _a.beforeSend,
        sampleRate = _a.sampleRate;

    if (!this._isEnabled()) {
      return SyncPromise.reject(new SentryError('SDK not enabled, will not send event.'));
    }

    var isTransaction = event.type === 'transaction'; // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else

    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      return SyncPromise.reject(new SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
    }

    return this._prepareEvent(event, scope, hint).then(function (prepared) {
      if (prepared === null) {
        throw new SentryError('An event processor returned null, will not send event.');
      }

      var isInternalException = hint && hint.data && hint.data.__sentry__ === true;

      if (isInternalException || isTransaction || !beforeSend) {
        return prepared;
      }

      var beforeSendResult = beforeSend(prepared, hint);

      if (typeof beforeSendResult === 'undefined') {
        throw new SentryError('`beforeSend` method has to return `null` or a valid event.');
      } else if (isThenable(beforeSendResult)) {
        return beforeSendResult.then(function (event) {
          return event;
        }, function (e) {
          throw new SentryError("beforeSend rejected with " + e);
        });
      }

      return beforeSendResult;
    }).then(function (processedEvent) {
      if (processedEvent === null) {
        throw new SentryError('`beforeSend` returned `null`, will not send event.');
      }

      var session = scope && scope.getSession && scope.getSession();

      if (!isTransaction && session) {
        _this._updateSessionFromEvent(session, processedEvent);
      }

      _this._sendEvent(processedEvent);

      return processedEvent;
    }).then(null, function (reason) {
      if (reason instanceof SentryError) {
        throw reason;
      }

      _this.captureException(reason, {
        data: {
          __sentry__: true
        },
        originalException: reason
      });

      throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
    });
  };
  /**
   * Occupies the client with processing and event
   */


  BaseClient.prototype._process = function (promise) {
    var _this = this;

    this._processing += 1;
    promise.then(function (value) {
      _this._processing -= 1;
      return value;
    }, function (reason) {
      _this._processing -= 1;
      return reason;
    });
  };

  return BaseClient;
}();

/** Noop transport */

var NoopTransport =
/** @class */
function () {
  function NoopTransport() {}
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.sendEvent = function (_) {
    return SyncPromise.resolve({
      reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
      status: Status.Skipped
    });
  };
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.close = function (_) {
    return SyncPromise.resolve(true);
  };

  return NoopTransport;
}();

/**
 * This is the base implemention of a Backend.
 * @hidden
 */

var BaseBackend =
/** @class */
function () {
  /** Creates a new backend instance. */
  function BaseBackend(options) {
    this._options = options;

    if (!this._options.dsn) {
      logger.warn('No DSN provided, backend will not do anything.');
    }

    this._transport = this._setupTransport();
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types


  BaseBackend.prototype.eventFromException = function (_exception, _hint) {
    throw new SentryError('Backend has to implement `eventFromException` method');
  };
  /**
   * @inheritDoc
   */


  BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
    throw new SentryError('Backend has to implement `eventFromMessage` method');
  };
  /**
   * @inheritDoc
   */


  BaseBackend.prototype.sendEvent = function (event) {
    this._transport.sendEvent(event).then(null, function (reason) {
      logger.error("Error while sending event: " + reason);
    });
  };
  /**
   * @inheritDoc
   */


  BaseBackend.prototype.sendSession = function (session) {
    if (!this._transport.sendSession) {
      logger.warn("Dropping session because custom transport doesn't implement sendSession");
      return;
    }

    this._transport.sendSession(session).then(null, function (reason) {
      logger.error("Error while sending session: " + reason);
    });
  };
  /**
   * @inheritDoc
   */


  BaseBackend.prototype.getTransport = function () {
    return this._transport;
  };
  /**
   * Sets up the transport so it can be used later to send requests.
   */


  BaseBackend.prototype._setupTransport = function () {
    return new NoopTransport();
  };

  return BaseBackend;
}();

/** Creates a SentryRequest from an event. */

function sessionToSentryRequest(session, api) {
  var envelopeHeaders = JSON.stringify({
    sent_at: new Date().toISOString()
  });
  var itemHeaders = JSON.stringify({
    type: 'session'
  });
  return {
    body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
    type: 'session',
    url: api.getEnvelopeEndpointWithUrlEncodedAuth()
  };
}
/** Creates a SentryRequest from an event. */

function eventToSentryRequest(event, api) {
  // since JS has no Object.prototype.pop()
  var _a = event.tags || {},
      samplingMethod = _a.__sentry_samplingMethod,
      sampleRate = _a.__sentry_sampleRate,
      otherTags = __rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);

  event.tags = otherTags;
  var useEnvelope = event.type === 'transaction';
  var req = {
    body: JSON.stringify(event),
    type: event.type || 'event',
    url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth()
  }; // https://develop.sentry.dev/sdk/envelopes/
  // Since we don't need to manipulate envelopes nor store them, there is no
  // exported concept of an Envelope with operations including serialization and
  // deserialization. Instead, we only implement a minimal subset of the spec to
  // serialize events inline here.

  if (useEnvelope) {
    var envelopeHeaders = JSON.stringify({
      event_id: event.event_id,
      sent_at: new Date().toISOString()
    });
    var itemHeaders = JSON.stringify({
      type: event.type,
      // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
      // explicitly-set sampling decisions). Are we good with that?
      sample_rates: [{
        id: samplingMethod,
        rate: sampleRate
      }]
    }); // The trailing newline is optional. We intentionally don't send it to avoid
    // sending unnecessary bytes.
    //
    // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;

    var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
    req.body = envelope;
  }

  return req;
}

/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */

var UNKNOWN_FUNCTION = '?'; // Chromium based browsers: Chrome, Brave, new Opera, new Edge

var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i; // gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.

var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/; // Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108

var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

function computeStackTrace(ex) {
  var stack = null;
  var popSize = 0;

  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      popSize = ex.framesToPop;
    } else if (reactMinifiedRegexp.test(ex.message)) {
      popSize = 1;
    }
  }

  try {
    // This must be tried first because Opera 10 *destroys*
    // its stacktrace property if you try to access the stack
    // property first!!
    stack = computeStackTraceFromStacktraceProp(ex);

    if (stack) {
      return popFrames(stack, popSize);
    }
  } catch (e) {// no-empty
  }

  try {
    stack = computeStackTraceFromStackProp(ex);

    if (stack) {
      return popFrames(stack, popSize);
    }
  } catch (e) {// no-empty
  }

  return {
    message: extractMessage(ex),
    name: ex && ex.name,
    stack: [],
    failed: true
  };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity

function computeStackTraceFromStackProp(ex) {
  if (!ex || !ex.stack) {
    return null;
  }

  var stack = [];
  var lines = ex.stack.split('\n');
  var isEval;
  var submatch;
  var parts;
  var element;

  for (var i = 0; i < lines.length; ++i) {
    if (parts = chrome.exec(lines[i])) {
      var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line

      isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

      if (isEval && (submatch = chromeEval.exec(parts[2]))) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url

        parts[3] = submatch[2]; // line

        parts[4] = submatch[3]; // column
      }

      element = {
        // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
        // prefix here seems like the quickest solution for now.
        url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
        func: parts[1] || UNKNOWN_FUNCTION,
        args: isNative ? [parts[2]] : [],
        line: parts[3] ? +parts[3] : null,
        column: parts[4] ? +parts[4] : null
      };
    } else if (parts = winjs.exec(lines[i])) {
      element = {
        url: parts[2],
        func: parts[1] || UNKNOWN_FUNCTION,
        args: [],
        line: +parts[3],
        column: parts[4] ? +parts[4] : null
      };
    } else if (parts = gecko.exec(lines[i])) {
      isEval = parts[3] && parts[3].indexOf(' > eval') > -1;

      if (isEval && (submatch = geckoEval.exec(parts[3]))) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || "eval";
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = ''; // no column when eval
      } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
        // FireFox uses this awesome columnNumber property for its top frame
        // Also note, Firefox's column number is 0-based and everything else expects 1-based,
        // so adding 1
        // NOTE: this hack doesn't work if top-most frame is eval
        stack[0].column = ex.columnNumber + 1;
      }

      element = {
        url: parts[3],
        func: parts[1] || UNKNOWN_FUNCTION,
        args: parts[2] ? parts[2].split(',') : [],
        line: parts[4] ? +parts[4] : null,
        column: parts[5] ? +parts[5] : null
      };
    } else {
      continue;
    }

    if (!element.func && element.line) {
      element.func = UNKNOWN_FUNCTION;
    }

    stack.push(element);
  }

  if (!stack.length) {
    return null;
  }

  return {
    message: extractMessage(ex),
    name: ex.name,
    stack: stack
  };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


function computeStackTraceFromStacktraceProp(ex) {
  if (!ex || !ex.stacktrace) {
    return null;
  } // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.


  var stacktrace = ex.stacktrace;
  var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
  var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
  var lines = stacktrace.split('\n');
  var stack = [];
  var parts;

  for (var line = 0; line < lines.length; line += 2) {
    var element = null;

    if (parts = opera10Regex.exec(lines[line])) {
      element = {
        url: parts[2],
        func: parts[3],
        args: [],
        line: +parts[1],
        column: null
      };
    } else if (parts = opera11Regex.exec(lines[line])) {
      element = {
        url: parts[6],
        func: parts[3] || parts[4],
        args: parts[5] ? parts[5].split(',') : [],
        line: +parts[1],
        column: +parts[2]
      };
    }

    if (element) {
      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }
  }

  if (!stack.length) {
    return null;
  }

  return {
    message: extractMessage(ex),
    name: ex.name,
    stack: stack
  };
}
/** Remove N number of frames from the stack */


function popFrames(stacktrace, popSize) {
  try {
    return _assign$3(_assign$3({}, stacktrace), {
      stack: stacktrace.stack.slice(popSize)
    });
  } catch (e) {
    return stacktrace;
  }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


function extractMessage(ex) {
  var message = ex && ex.message;

  if (!message) {
    return 'No error message';
  }

  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }

  return message;
}

var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */

function exceptionFromStacktrace(stacktrace) {
  var frames = prepareFramesForEvent(stacktrace.stack);
  var exception = {
    type: stacktrace.name,
    value: stacktrace.message
  };

  if (frames && frames.length) {
    exception.stacktrace = {
      frames: frames
    };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}
/**
 * @hidden
 */

function eventFromPlainObject(exception, syntheticException, rejection) {
  var event = {
    exception: {
      values: [{
        type: isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
        value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + extractExceptionKeysForMessage(exception)
      }]
    },
    extra: {
      __serialized__: normalizeToSize(exception)
    }
  };

  if (syntheticException) {
    var stacktrace = computeStackTrace(syntheticException);
    var frames_1 = prepareFramesForEvent(stacktrace.stack);
    event.stacktrace = {
      frames: frames_1
    };
  }

  return event;
}
/**
 * @hidden
 */

function eventFromStacktrace(stacktrace) {
  var exception = exceptionFromStacktrace(stacktrace);
  return {
    exception: {
      values: [exception]
    }
  };
}
/**
 * @hidden
 */

function prepareFramesForEvent(stack) {
  if (!stack || !stack.length) {
    return [];
  }

  var localStack = stack;
  var firstFrameFunction = localStack[0].func || '';
  var lastFrameFunction = localStack[localStack.length - 1].func || ''; // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)

  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  } // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)


  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  } // The frame where the crash happened, should be the last entry in the array


  return localStack.slice(0, STACKTRACE_LIMIT).map(function (frame) {
    return {
      colno: frame.column === null ? undefined : frame.column,
      filename: frame.url || localStack[0].url,
      function: frame.func || '?',
      in_app: true,
      lineno: frame.line === null ? undefined : frame.line
    };
  }).reverse();
}

/**
 * Builds and Event from a Exception
 * @hidden
 */

function eventFromException(options, exception, hint) {
  var syntheticException = hint && hint.syntheticException || undefined;
  var event = eventFromUnknownInput(exception, syntheticException, {
    attachStacktrace: options.attachStacktrace
  });
  addExceptionMechanism(event, {
    handled: true,
    type: 'generic'
  });
  event.level = Severity.Error;

  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }

  return SyncPromise.resolve(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */

function eventFromMessage(options, message, level, hint) {
  if (level === void 0) {
    level = Severity.Info;
  }

  var syntheticException = hint && hint.syntheticException || undefined;
  var event = eventFromString(message, syntheticException, {
    attachStacktrace: options.attachStacktrace
  });
  event.level = level;

  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }

  return SyncPromise.resolve(event);
}
/**
 * @hidden
 */

function eventFromUnknownInput(exception, syntheticException, options) {
  if (options === void 0) {
    options = {};
  }

  var event;

  if (isErrorEvent(exception) && exception.error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    var errorEvent = exception; // eslint-disable-next-line no-param-reassign

    exception = errorEvent.error;
    event = eventFromStacktrace(computeStackTrace(exception));
    return event;
  }

  if (isDOMError(exception) || isDOMException(exception)) {
    // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
    // then we just extract the name, code, and message, as they don't provide anything else
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    var domException = exception;
    var name_1 = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
    var message = domException.message ? name_1 + ": " + domException.message : name_1;
    event = eventFromString(message, syntheticException, options);
    addExceptionTypeValue(event, message);

    if ('code' in domException) {
      event.tags = _assign$3(_assign$3({}, event.tags), {
        'DOMException.code': "" + domException.code
      });
    }

    return event;
  }

  if (isError(exception)) {
    // we have a real Error object, do nothing
    event = eventFromStacktrace(computeStackTrace(exception));
    return event;
  }

  if (isPlainObject(exception) || isEvent(exception)) {
    // If it is plain Object or Event, serialize it manually and extract options
    // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    var objectException = exception;
    event = eventFromPlainObject(objectException, syntheticException, options.rejection);
    addExceptionMechanism(event, {
      synthetic: true
    });
    return event;
  } // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:


  event = eventFromString(exception, syntheticException, options);
  addExceptionTypeValue(event, "" + exception, undefined);
  addExceptionMechanism(event, {
    synthetic: true
  });
  return event;
}
/**
 * @hidden
 */

function eventFromString(input, syntheticException, options) {
  if (options === void 0) {
    options = {};
  }

  var event = {
    message: input
  };

  if (options.attachStacktrace && syntheticException) {
    var stacktrace = computeStackTrace(syntheticException);
    var frames_1 = prepareFramesForEvent(stacktrace.stack);
    event.stacktrace = {
      frames: frames_1
    };
  }

  return event;
}

/** Base Transport class implementation */

var BaseTransport =
/** @class */
function () {
  function BaseTransport(options) {
    this.options = options;
    /** A simple buffer holding all requests. */

    this._buffer = new PromiseBuffer(30);
    /** Locks transport after receiving rate limits in a response */

    this._rateLimits = {};
    this._api = new API(this.options.dsn); // eslint-disable-next-line deprecation/deprecation

    this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
  }
  /**
   * @inheritDoc
   */


  BaseTransport.prototype.sendEvent = function (_) {
    throw new SentryError('Transport Class has to implement `sendEvent` method');
  };
  /**
   * @inheritDoc
   */


  BaseTransport.prototype.close = function (timeout) {
    return this._buffer.drain(timeout);
  };
  /**
   * Handle Sentry repsonse for promise-based transports.
   */


  BaseTransport.prototype._handleResponse = function (_a) {
    var requestType = _a.requestType,
        response = _a.response,
        headers = _a.headers,
        resolve = _a.resolve,
        reject = _a.reject;
    var status = Status.fromHttpCode(response.status);
    /**
     * "The name is case-insensitive."
     * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
     */

    var limited = this._handleRateLimit(headers);

    if (limited) logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));

    if (status === Status.Success) {
      resolve({
        status: status
      });
      return;
    }

    reject(response);
  };
  /**
   * Gets the time that given category is disabled until for rate limiting
   */


  BaseTransport.prototype._disabledUntil = function (category) {
    return this._rateLimits[category] || this._rateLimits.all;
  };
  /**
   * Checks if a category is rate limited
   */


  BaseTransport.prototype._isRateLimited = function (category) {
    return this._disabledUntil(category) > new Date(Date.now());
  };
  /**
   * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
   */


  BaseTransport.prototype._handleRateLimit = function (headers) {
    var e_1, _a, e_2, _b;

    var now = Date.now();
    var rlHeader = headers['x-sentry-rate-limits'];
    var raHeader = headers['retry-after'];

    if (rlHeader) {
      try {
        // rate limit headers are of the form
        //     <header>,<header>,..
        // where each <header> is of the form
        //     <retry_after>: <categories>: <scope>: <reason_code>
        // where
        //     <retry_after> is a delay in ms
        //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
        //         <category>;<category>;...
        //     <scope> is what's being limited (org, project, or key) - ignored by SDK
        //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
        for (var _c = __values$2(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
          var limit = _d.value;
          var parameters = limit.split(':', 2);
          var headerDelay = parseInt(parameters[0], 10);
          var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default

          try {
            for (var _e = (e_2 = void 0, __values$2(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var category = _f.value;
              this._rateLimits[category || 'all'] = new Date(now + delay);
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      return true;
    } else if (raHeader) {
      this._rateLimits.all = new Date(now + parseRetryAfterHeader(now, raHeader));
      return true;
    }

    return false;
  };

  return BaseTransport;
}();

var global$1 = getGlobalObject();
/** `fetch` based transport */

var FetchTransport =
/** @class */
function (_super) {
  __extends$1(FetchTransport, _super);

  function FetchTransport() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @inheritDoc
   */


  FetchTransport.prototype.sendEvent = function (event) {
    return this._sendRequest(eventToSentryRequest(event, this._api), event);
  };
  /**
   * @inheritDoc
   */


  FetchTransport.prototype.sendSession = function (session) {
    return this._sendRequest(sessionToSentryRequest(session, this._api), session);
  };
  /**
   * @param sentryRequest Prepared SentryRequest to be delivered
   * @param originalPayload Original payload used to create SentryRequest
   */


  FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
    var _this = this;

    if (this._isRateLimited(sentryRequest.type)) {
      return Promise.reject({
        event: originalPayload,
        type: sentryRequest.type,
        reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
        status: 429
      });
    }

    var options = {
      body: sentryRequest.body,
      method: 'POST',
      // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
      // https://caniuse.com/#feat=referrer-policy
      // It doesn't. And it throw exception instead of ignoring this parameter...
      // REF: https://github.com/getsentry/raven-js/issues/1233
      referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
    };

    if (this.options.fetchParameters !== undefined) {
      Object.assign(options, this.options.fetchParameters);
    }

    if (this.options.headers !== undefined) {
      options.headers = this.options.headers;
    }

    return this._buffer.add(new SyncPromise(function (resolve, reject) {
      global$1.fetch(sentryRequest.url, options).then(function (response) {
        var headers = {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After')
        };

        _this._handleResponse({
          requestType: sentryRequest.type,
          response: response,
          headers: headers,
          resolve: resolve,
          reject: reject
        });
      }).catch(reject);
    }));
  };

  return FetchTransport;
}(BaseTransport);

/** `XHR` based transport */

var XHRTransport =
/** @class */
function (_super) {
  __extends$1(XHRTransport, _super);

  function XHRTransport() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @inheritDoc
   */


  XHRTransport.prototype.sendEvent = function (event) {
    return this._sendRequest(eventToSentryRequest(event, this._api), event);
  };
  /**
   * @inheritDoc
   */


  XHRTransport.prototype.sendSession = function (session) {
    return this._sendRequest(sessionToSentryRequest(session, this._api), session);
  };
  /**
   * @param sentryRequest Prepared SentryRequest to be delivered
   * @param originalPayload Original payload used to create SentryRequest
   */


  XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
    var _this = this;

    if (this._isRateLimited(sentryRequest.type)) {
      return Promise.reject({
        event: originalPayload,
        type: sentryRequest.type,
        reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
        status: 429
      });
    }

    return this._buffer.add(new SyncPromise(function (resolve, reject) {
      var request = new XMLHttpRequest();

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          var headers = {
            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
            'retry-after': request.getResponseHeader('Retry-After')
          };

          _this._handleResponse({
            requestType: sentryRequest.type,
            response: request,
            headers: headers,
            resolve: resolve,
            reject: reject
          });
        }
      };

      request.open('POST', sentryRequest.url);

      for (var header in _this.options.headers) {
        if (_this.options.headers.hasOwnProperty(header)) {
          request.setRequestHeader(header, _this.options.headers[header]);
        }
      }

      request.send(sentryRequest.body);
    }));
  };

  return XHRTransport;
}(BaseTransport);

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */

var BrowserBackend =
/** @class */
function (_super) {
  __extends$1(BrowserBackend, _super);

  function BrowserBackend() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype.eventFromException = function (exception, hint) {
    return eventFromException(this._options, exception, hint);
  };
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
    if (level === void 0) {
      level = Severity.Info;
    }

    return eventFromMessage(this._options, message, level, hint);
  };
  /**
   * @inheritDoc
   */


  BrowserBackend.prototype._setupTransport = function () {
    if (!this._options.dsn) {
      // We return the noop transport here in case there is no Dsn.
      return _super.prototype._setupTransport.call(this);
    }

    var transportOptions = _assign$3(_assign$3({}, this._options.transportOptions), {
      dsn: this._options.dsn
    });

    if (this._options.transport) {
      return new this._options.transport(transportOptions);
    }

    if (supportsFetch()) {
      return new FetchTransport(transportOptions);
    }

    return new XHRTransport(transportOptions);
  };

  return BrowserBackend;
}(BaseBackend);

/**
 * Injects the Report Dialog script
 * @hidden
 */

function injectReportDialog(options) {
  if (options === void 0) {
    options = {};
  }

  if (!options.eventId) {
    logger.error("Missing eventId option in showReportDialog call");
    return;
  }

  if (!options.dsn) {
    logger.error("Missing dsn option in showReportDialog call");
    return;
  }

  var script = document.createElement('script');
  script.async = true;
  script.src = new API(options.dsn).getReportDialogEndpoint(options);

  if (options.onLoad) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
  }

  (document.head || document.body).appendChild(script);
}

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */

var Breadcrumbs =
/** @class */
function () {
  /**
   * @inheritDoc
   */
  function Breadcrumbs(options) {
    /**
     * @inheritDoc
     */
    this.name = Breadcrumbs.id;
    this._options = _assign$3({
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true
    }, options);
  }
  /**
   * Create a breadcrumb of `sentry` from the events themselves
   */


  Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
    if (!this._options.sentry) {
      return;
    }

    getCurrentHub().addBreadcrumb({
      category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
      event_id: event.event_id,
      level: event.level,
      message: getEventDescription(event)
    }, {
      event: event
    });
  };
  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */


  Breadcrumbs.prototype.setupOnce = function () {
    var _this = this;

    if (this._options.console) {
      addInstrumentationHandler({
        callback: function callback() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          _this._consoleBreadcrumb.apply(_this, __spread$2(args));
        },
        type: 'console'
      });
    }

    if (this._options.dom) {
      addInstrumentationHandler({
        callback: function callback() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          _this._domBreadcrumb.apply(_this, __spread$2(args));
        },
        type: 'dom'
      });
    }

    if (this._options.xhr) {
      addInstrumentationHandler({
        callback: function callback() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          _this._xhrBreadcrumb.apply(_this, __spread$2(args));
        },
        type: 'xhr'
      });
    }

    if (this._options.fetch) {
      addInstrumentationHandler({
        callback: function callback() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          _this._fetchBreadcrumb.apply(_this, __spread$2(args));
        },
        type: 'fetch'
      });
    }

    if (this._options.history) {
      addInstrumentationHandler({
        callback: function callback() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          _this._historyBreadcrumb.apply(_this, __spread$2(args));
        },
        type: 'history'
      });
    }
  };
  /**
   * Creates breadcrumbs from console API calls
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
    var breadcrumb = {
      category: 'console',
      data: {
        arguments: handlerData.args,
        logger: 'console'
      },
      level: Severity.fromString(handlerData.level),
      message: safeJoin(handlerData.args, ' ')
    };

    if (handlerData.level === 'assert') {
      if (handlerData.args[0] === false) {
        breadcrumb.message = "Assertion failed: " + (safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        // Don't capture a breadcrumb for passed assertions
        return;
      }
    }

    getCurrentHub().addBreadcrumb(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level
    });
  };
  /**
   * Creates breadcrumbs from DOM API calls
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
    var target; // Accessing event.target can throw (see getsentry/raven-js#838, #768)

    try {
      target = handlerData.event.target ? htmlTreeAsString(handlerData.event.target) : htmlTreeAsString(handlerData.event);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    getCurrentHub().addBreadcrumb({
      category: "ui." + handlerData.name,
      message: target
    }, {
      event: handlerData.event,
      name: handlerData.name
    });
  };
  /**
   * Creates breadcrumbs from XHR API calls
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
    if (handlerData.endTimestamp) {
      // We only capture complete, non-sentry requests
      if (handlerData.xhr.__sentry_own_request__) {
        return;
      }

      var _a = handlerData.xhr.__sentry_xhr__ || {},
          method = _a.method,
          url = _a.url,
          status_code = _a.status_code,
          body = _a.body;

      getCurrentHub().addBreadcrumb({
        category: 'xhr',
        data: {
          method: method,
          url: url,
          status_code: status_code
        },
        type: 'http'
      }, {
        xhr: handlerData.xhr,
        input: body
      });
      return;
    }
  };
  /**
   * Creates breadcrumbs from fetch API calls
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
      return;
    }

    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
      // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
      return;
    }

    if (handlerData.error) {
      getCurrentHub().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: Severity.Error,
        type: 'http'
      }, {
        data: handlerData.error,
        input: handlerData.args
      });
    } else {
      getCurrentHub().addBreadcrumb({
        category: 'fetch',
        data: _assign$3(_assign$3({}, handlerData.fetchData), {
          status_code: handlerData.response.status
        }),
        type: 'http'
      }, {
        input: handlerData.args,
        response: handlerData.response
      });
    }
  };
  /**
   * Creates breadcrumbs from history API calls
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
    var global = getGlobalObject();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = parseUrl(global.location.href);
    var parsedFrom = parseUrl(from);
    var parsedTo = parseUrl(to); // Initial pushState doesn't provide `from` information

    if (!parsedFrom.path) {
      parsedFrom = parsedLoc;
    } // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)


    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }

    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }

    getCurrentHub().addBreadcrumb({
      category: 'navigation',
      data: {
        from: from,
        to: to
      }
    });
  };
  /**
   * @inheritDoc
   */


  Breadcrumbs.id = 'Breadcrumbs';
  return Breadcrumbs;
}();

var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.30.0';

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */

var BrowserClient =
/** @class */
function (_super) {
  __extends$1(BrowserClient, _super);
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */


  function BrowserClient(options) {
    if (options === void 0) {
      options = {};
    }

    return _super.call(this, BrowserBackend, options) || this;
  }
  /**
   * Show a report dialog to the user to send feedback to a specific event.
   *
   * @param options Set individual options for the dialog
   */


  BrowserClient.prototype.showReportDialog = function (options) {
    if (options === void 0) {
      options = {};
    } // doesn't work without a document (React Native)


    var document = getGlobalObject().document;

    if (!document) {
      return;
    }

    if (!this._isEnabled()) {
      logger.error('Trying to call showReportDialog with Sentry Client disabled');
      return;
    }

    injectReportDialog(_assign$3(_assign$3({}, options), {
      dsn: options.dsn || this.getDsn()
    }));
  };
  /**
   * @inheritDoc
   */


  BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
    event.platform = event.platform || 'javascript';
    event.sdk = _assign$3(_assign$3({}, event.sdk), {
      name: SDK_NAME,
      packages: __spread$2(event.sdk && event.sdk.packages || [], [{
        name: 'npm:@sentry/browser',
        version: SDK_VERSION
      }]),
      version: SDK_VERSION
    });
    return _super.prototype._prepareEvent.call(this, event, scope, hint);
  };
  /**
   * @inheritDoc
   */


  BrowserClient.prototype._sendEvent = function (event) {
    var integration = this.getIntegration(Breadcrumbs);

    if (integration) {
      integration.addSentryBreadcrumb(event);
    }

    _super.prototype._sendEvent.call(this, event);
  };

  return BrowserClient;
}(BaseClient);

// import * as Sentry from '@sentry/browser';

var hub = null; // sentry初始化方法，一定要在最开始时调用，因为如果cube.min.js加载完之后再init就会报错

function initSentry$1() {
  try {
    // sentry初始化方法，一定要在最开始时调用，因为如果cube.min.js加载完之后再init就会报错
    var client = new BrowserClient({
      enabled: true,
      dsn: 'https://af48702c4315441eb3ac59a9548d0961@internal-sentry.baijia.com/838',
      environment: getEnv()
    });
    hub = new Hub(client);

    var _a = parseQuery(),
        _b = _a.exerciseNumber,
        exerciseNumber = _b === void 0 ? '' : _b,
        _c = _a.exerciseType,
        exerciseType = _c === void 0 ? '' : _c; // // 对错误做出补充信息的写到extras中


    var extras_1 = {
      reportTime: new Date().toString(),
      url: location.href
    }; // 注意，能作为筛选项的要写到tags中

    var tags_1 = {
      exerciseNumber: exerciseNumber,
      exerciseType: exerciseType,
      userId: js_cookie.get('userId') || js_cookie.get('uid') || ''
    };
    hub.configureScope(function (scope) {
      scope.setTags(tags_1);
      scope.setExtras(extras_1);
    });
  } catch (e) {
    throw new Error(JSON.stringify(e));
  }
} // sentry上报方法

function sentryReport(msg, params) {
  if (params === void 0) {
    params = {};
  }

  try {
    hub === null || hub === void 0 ? void 0 : hub.withScope(function (scope) {
      params.extras && scope.setExtras(params.extras);
      hub === null || hub === void 0 ? void 0 : hub.captureMessage(msg);
    });
  } catch (e) {
    new Error(JSON.stringify(e));
  }
}

var EUploadResState;

(function (EUploadResState) {
  EUploadResState["SUCCESS"] = "SUCCESS";
  EUploadResState["FAIL"] = "FAIL";
})(EUploadResState || (EUploadResState = {})); // eslint-disable-next-line


var uploadObject = function uploadObject(object) {
  return __awaiter$2(void 0, void 0, void 0, function () {
    var formData, res, error_1;

    var _a, _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          formData = new FormData();
          formData === null || formData === void 0 ? void 0 : formData.append('file', new Blob([JSON.stringify(object)]));
          _c.label = 1;

        case 1:
          _c.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , axios.upload('https://storage.genshuixue.com/webupload.php', formData)];

        case 2:
          res = _c.sent();
          return [2
          /*return*/
          , [{
            url: (_b = (_a = res.files) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url,
            prefix: 'https://p.gsxcdn.com/',
            state: EUploadResState.SUCCESS
          }, null]];

        case 3:
          error_1 = _c.sent();
          sentryReport('JSON上传失败', {
            extras: {
              errorMsg: error_1
            }
          });
          return [2
          /*return*/
          , [{
            url: '',
            prefix: 'https://p.gsxcdn.com/',
            state: EUploadResState.FAIL
          }, new Error(JSON.stringify(error_1))]];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};
 // export default uploadObject;

var getInfo = function getInfo() {
  return {
    trackId: js_cookie.get('_gaotu_track_id_') || '',
    loggerId: js_cookie.get('logger_id') || '',
    userId: getUserId(),
    name: 'gt-c-exercise-ui'
  };
}; // 性能统计添加path路径


habo.perf.setConfig({
  path: function path() {
    // 取hash路由
    return window.location.hash.split('?')[0].substring(1);
  }
}); // 业务中使用方法：clickReport(EVENT_ID_HUB.TEA_REPORT_VERSION, extraPar);

var clickReport = function clickReport(eventId, otherParams) {
  habo.click(_assign$4(_assign$4({
    eventId: eventId
  }, otherParams), getInfo()));
};

var style$17 = {"error":"tangram_C_error_a19909bbb2","otherLogo":"tangram_C_otherLogo_a19909bbb2"};

var ErrorBoundary =
/** @class */
function (_super) {
  __extends$2(ErrorBoundary, _super); // @ts-ignore


  function ErrorBoundary(props) {
    var _this = _super.call(this, props) || this;

    _this.otherLogo = location.origin.indexOf('xhvip100') > -1;
    _this.state = {
      hasError: false
    };
    return _this;
  } // @ts-ignore


  ErrorBoundary.getDerivedStateFromError = function (error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }; // @ts-ignore


  ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
    footPrintJSErrorReport({
      actionValue: "\u7EC4\u4EF6errorBoundary\u6355\u83B7\u5230\u7684\u9519\u8BEF".concat(error).concat(errorInfo)
    });
    console.log('组件errorBoundary捕获到的错误', error, errorInfo); // throw new Error(error);
    // You can also log the error to an error reporting service
    // @ts-ignore
    // logErrorToMyService(error, errorInfo);
  };

  ErrorBoundary.prototype.render = function () {
    // @ts-ignore
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(style$17.error, " ").concat(this.otherLogo ? style$17.otherLogo : '')
      });
    } // eslint-disable-next-line


    return this.props.children;
  };

  return ErrorBoundary;
}(React.Component);

function withErrorBoundary(FunctionalComp) {
  return function HocComp(props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(FunctionalComp, _assign$4({}, props)));
  };
}

/**
 * 将字符串解释为对象
 * @param string 要解释的字符串
 * @return 解释后的对象
 */

var parseJSON = function parseJSON(src) {
  if (typeof src === 'string' && src.length !== 0) {
    try {
      return JSON.parse(src);
    } catch (e) {
      console.log('组件JSON解析失败时的数据及类型：', src, _typeof$1(src));
      sentryReport('组件中JSON解析失败', {
        extras: {
          json: src
        }
      });
      footPrintDetailReport({
        detailAction: '组件JSON解析失败'
      });
    }
  }

  return null;
};
/**
 * 秒数转为分秒 eg: 120 -> 02:00
 * @param s 时间数
*/

function timeFormat(s) {
  if (s === void 0) {
    s = 0;
  }

  s = Math.max(s, 0);
  var min = Math.floor(s / 60);
  var sec = s % 60;
  return [min, sec].map(function (item) {
    return item < 10 ? "0".concat(item) : "".concat(item || '00');
  }).join(':');
}
/**
 * @description: 解析地址栏的url
 * @return {Object} 以&分割，左边作为key，右边作为value组成的对象
 */

function parseQuery(query) {
  if (query === void 0) {
    query = window.location.href;
  }

  try {
    var params_1 = {};
    var search = query.split('?')[1];

    if (!search) {
      return params_1;
    }

    search.split('&').forEach(function (param) {
      // 执行操作钱做判空，否则不规则URL可能解析失败
      if (param) {
        var pair = param.split('=');
        var key = pair[0];
        var value = decodeURIComponent(pair[1]);
        params_1[key] = value;
      }
    });
    return params_1;
  } catch (e) {
    throw new Error("\u89E3\u6790url\u5931\u8D25\uFF0C\u9519\u8BEF\u4FE1\u606F\uFF1A".concat(e));
  }
}
/**
 * @description: 与Object.entries()功能相同的entries函数，用于解决低版本浏览器不支持Object.entries()的问题
 * @param object 任意对象
 * @return {[][]} 返回一个二维数组，二维数组中的每一个数组包含原对象中的键和值
 * @author gy
 */

function entries(object) {
  var ownProps = Object.keys(object);
  var i = ownProps.length;
  var resArray = new Array(i);

  while (i--) {
    resArray[i] = [ownProps[i], object[ownProps[i]]];
  }

  return resArray;
}
/**
 * 判断是否字段存在，通常用于必传参数没传时抛错
 * @author chenbaijin
 */

var exit = function exit(val) {
  return typeof val !== 'undefined';
};
var exist = function exist(val) {
  return typeof val !== 'undefined' && val !== null;
};

var noop$1 = function noop() {};
var getEnv = function getEnv() {
  var _a; // 'https://test-m.gaotu100.com/exercise/exam.html#/cosplay/noexam'.match();


  var envTag = (_a = /https:\/\/(.*)\.gaotu100/.exec(window.location.href)) === null || _a === void 0 ? void 0 : _a[1];
  return envTag === 'test-m' ? 'test' : envTag === 'm' ? 'production' : 'dev';
};
var getUserId = function getUserId() {
  var _a;

  return ((_a = parseQuery()) === null || _a === void 0 ? void 0 : _a.userId) || js_cookie.get('userId') || js_cookie.get('uid') || '';
};
var getSid = function getSid() {
  var _a;

  return ((_a = parseQuery()) === null || _a === void 0 ? void 0 : _a.sid) || js_cookie.get('sid') || '';
};
var envPrefix = function envPrefix() {
  var hostname = window.location.hostname;
  return /(0.0.0.0)|(localhost)|(127.0.0.1)|(test-)/.test(hostname) ? 'test-' : /(beta-)/.test(hostname) ? 'beta-' : /(perf-)/.test(hostname) ? 'perf-' : '';
};
/**
 * 比较版本号大小 。是否比目标版本低。
 * 1.2.2,
 * 1.2.3
 */

var compareVersion$1 = function compareVersion(current, target) {
  var currentArr = current.split('.');
  var targetArr = target.split('.');
  var maxLength = Math.max(currentArr.length, targetArr.length);

  for (var i = 0; i < maxLength; i++) {
    var currentVersion = currentArr[i] || 0;
    var targetVersion = targetArr[i] || 0;

    if (currentVersion < targetVersion) {
      return true;
    }

    if (currentVersion > targetVersion) {
      return false;
    }
  }

  return false;
};

var loadAndCacheSource = function loadAndCacheSource(loadFunc) {
  var cache = Object.create(null);
  return function (url) {
    if (url in cache) {
      return cache[url];
    }

    var sourcePromise = loadFunc(url);
    sourcePromise.catch(function () {
      return delete cache[url];
    });
    return cache[url] = sourcePromise;
  };
};

var loadScript = loadAndCacheSource(function (url) {
  return new Promise(function (resolve, reject) {
    var dom = document.createElement('script');
    dom.type = 'text/javascript';
    dom.src = url;
    dom.onload = resolve;
    dom.onerror = reject;
    document.body.appendChild(dom);
  });
});
var loadStyle = loadAndCacheSource(function (url) {
  return new Promise(function (resolve, reject) {
    var dom = document.createElement('link');
    dom.href = url;
    dom.rel = 'stylesheet';
    dom.onload = resolve;
    dom.onerror = reject;
    document.head.appendChild(dom);
  });
});
var reTryPromise = function reTryPromise(promiseHandler, retryTimes) {
  if (retryTimes === void 0) {
    retryTimes = 3;
  }

  var times = 0;

  function runPromise() {
    return __awaiter$2(this, void 0, void 0, function () {

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            times++;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , promiseHandler()];

          case 2:
            _b.sent();

            return [3
            /*break*/
            , 4];

          case 3:
            _b.sent();

            if (times <= retryTimes) {
              return [2
              /*return*/
              , runPromise()];
            }

            return [2
            /*return*/
            , Promise.reject('重试失败')];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  return runPromise();
};

var footprintDefaultParams = {
  actionSource: 'JS',
  targetId: '',
  primaryAction: '-',
  secondaryAction: '-',
  actionValue: '-',
  detailAction: '-'
};

var getFootprintDefaultParams = function getFootprintDefaultParams() {
  var _a;

  return _assign$4(_assign$4({}, footprintDefaultParams), {
    // targetId: Cookies.get('questionId') || '',
    primaryAction: js_cookie.get('primaryAction') || '',
    targetId: "".concat(getUserId(), "-").concat((_a = parseQuery()) === null || _a === void 0 ? void 0 : _a.questionNumber)
  });
};
/**
 * @author chenbaijin
 * @param actionValue 事件携带的具体信息
 * @param secondaryAction 二级事件名，这个事件值需要体现在脚印的文档上：https://doc.baijia.com/sheets/Ec9n0pv9w08REn78/yZEer，并且和@袁平同步。这样才能再脚印系统里看到有标题的二级事件。
 */


function footPrintSecondaryReport(params) {
  if (params === void 0) {
    params = {};
  }

  var reportParams = _assign$4(_assign$4(_assign$4({}, getFootprintDefaultParams()), {
    secondaryAction: 'fraudSecondaryAction'
  }), params);

  clickReport(EHaboEventId$1.FOOTPRINT_REPORT, reportParams);
}
/**
 * @author chenbaijin
 * @param actionValue 三级事件只需要把上报信息附带上即可
 */

function footPrintDetailReport(params) {
  if (params === void 0) {
    params = {};
  }

  var reportParams = _assign$4(_assign$4({}, getFootprintDefaultParams()), params);

  clickReport(EHaboEventId$1.FOOTPRINT_REPORT, reportParams);
}
/**
 * @author chenbaijin
 * @param actionValue 错误事件只需要把上报信息附带上即可
 */

function footPrintJSErrorReport(params) {
  if (params === void 0) {
    params = {};
  }

  var reportParams = _assign$4(_assign$4(_assign$4({}, getFootprintDefaultParams()), params), {
    primaryAction: FOOT_PRINT_fIRST_ACTION.jsError
  });

  clickReport(EHaboEventId$1.FOOTPRINT_REPORT, reportParams);
}

// import {FOOT_PRINT_fIRST_ACTION} from '@/config/foot-print-action';
/**
 * @author chenbaijin
 * @desp 全局监听所有的报错，通过target类型筛选出时静态资源的错并上报
 */

function assetsErrorReport() {
  window.addEventListener('error', function (event) {
    var target = event.target;
    var elementTarget = target instanceof HTMLImageElement || target instanceof HTMLAudioElement || target instanceof HTMLVideoElement ? target : null;

    if (!elementTarget) {
      return false;
    }

    var url = elementTarget === null || elementTarget === void 0 ? void 0 : elementTarget.src;
    var isUiAssets = (elementTarget === null || elementTarget === void 0 ? void 0 : elementTarget.getAttribute('data-source')) === 'exercise-ui';

    if (isUiAssets) {
      sentryReport('静态资源加载失败', {
        extras: {
          url: url
        }
      });
      footPrintJSErrorReport({
        actionValue: "\u9759\u6001\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25-url:".concat(url),
        errorCause: '题目组件库静态资源加载失败'
      });
    } // 关于这里为什么不可以用 e.preventDefault() 来阻止默认打印，是因为这个错误，我们是捕获阶段获取到的，而不是冒泡；

  }, true);
}

function propsException(key, value) {
  sentryReport('业务传参异常', {
    extras: {
      key: key,
      value: value
    }
  });
}

assetsErrorReport();

var bind = createCommonjsModule(function (module) {
  /* global define */
  (function () {

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof$1(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(this && this[arg] || arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(this, arg));
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(this && this[key] || key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof$1(global)) == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */

var _Symbol = root$1.Symbol;
var _Symbol$1 = _Symbol;

/** Used for built-in method references. */

var objectProto$c = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$c.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$c.toString;
/** Built-in value references. */

var symToStringTag$1 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$b.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof$1(value) == 'object';
}

/** `Object#toString` result references. */

var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return _typeof$1(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$2;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$3(value) {
  var type = _typeof$1(value);

  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject$3(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */

var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$a = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */

var WeakMap = getNative(root$1, 'WeakMap');
var WeakMap$1 = WeakMap;

/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject$3(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var baseCreate$1 = baseCreate;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var defineProperty$1 = defineProperty;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = _typeof$1(value);

  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$8.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */

var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$7.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */

var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/** Built-in value references. */

var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */

var freeExports$1 = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$1 = freeExports$1 && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports$1 && freeGlobal$1.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$6.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$5.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$5.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/* Built-in method references that are verified to be native. */

var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }

  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */

var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$2.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */

var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof$1(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

/** Built-in value references. */

var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */

var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }

  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */

var DataView$1 = getNative(root$1, 'DataView');
var DataView$2 = DataView$1;

/* Built-in method references that are verified to be native. */

var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */

var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/** `Object#toString` result references. */

var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView$2),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$1);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$3;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$3;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

/** Built-in value references. */

var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol$1 ? _Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}

/** `Object#toString` result references. */

var mapTag$1 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

/* Node.js helper references. */

var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */

var setTag$1 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

/* Node.js helper references. */

var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$3(value)) {
    return value;
  }

  var isArr = isArray$1(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now$1 = function now() {
  return root$1.Date.now();
};

var now$2 = now$1;

/** Error message constants. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  wait = toNumber(wait) || 0;

  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now$2();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */

function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  if (isObject$3(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

// import {IAudioSDKJudgeResult} from './native-ability';

/**
 * @author chenbaijin
 */
var EPlayTime;

(function (EPlayTime) {
  EPlayTime[EPlayTime["FIRST"] = 1] = "FIRST";
  EPlayTime[EPlayTime["SECONO"] = 2] = "SECONO";
})(EPlayTime || (EPlayTime = {}));

var EConversationState;

(function (EConversationState) {
  EConversationState["UNPLAYED"] = "UNPLAYED";
  EConversationState["PLAYING"] = "PLAYING";
  EConversationState["PLAYED"] = "PLAYED";
  EConversationState["PAUSED"] = "PAUSED";
})(EConversationState || (EConversationState = {}));

var EPageState;

(function (EPageState) {
  EPageState["PAUSED"] = "PAUSED";
  EPageState["PLAYING"] = "PLAYING";
})(EPageState || (EPageState = {}));

var EAudioSDKFeedBackStatus$1;

(function (EAudioSDKFeedBackStatus) {
  EAudioSDKFeedBackStatus["\u97F3\u9891\u683C\u5F0F\u9519\u8BEF"] = "INVALID_AUDIO_FORMAT";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u97F3\u9891"] = "INVALID_AUDIO";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u7684\u9898\u76EE\u4FE1\u606F"] = "INVALID_CONTENT";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u7684Option\u4FE1\u606F"] = "INVALID_OPTIONS";
  EAudioSDKFeedBackStatus["\u8C03\u7528\u6253\u5206\u5E93\u9519\u8BEF"] = "INVALID_EVOKE_ORDER";
  EAudioSDKFeedBackStatus["\u7A7A\u97F3\u9891"] = "EMPTY_AUDIO";
  EAudioSDKFeedBackStatus["\u81EA\u52A8\u68C0\u6D4B\u5230\u6717\u8BFB\u7ED3\u675F\u5E76\u8FD4\u56DE"] = "READING_COMPLETED";
  EAudioSDKFeedBackStatus["\u68C0\u6D4B\u5230\u9759\u97F3\u7ED3\u675F"] = "NOISE_TO_THE_END";
  EAudioSDKFeedBackStatus["\u672A\u77E5\u9519\u8BEF"] = "UNKOWN_ERROR";
  EAudioSDKFeedBackStatus["\u6B63\u5E38\u7ED3\u675F"] = "NORMAL_FINISHED";
  EAudioSDKFeedBackStatus["\u5B9E\u65F6\u8FD4\u56DE\u7ED3\u679C"] = "NORMAL_PARTIAL_FEEDBACK";
  EAudioSDKFeedBackStatus["\u957F\u65F6\u95F4\u505C\u987F"] = "LONG_PAUSE_DETECTED";
})(EAudioSDKFeedBackStatus$1 || (EAudioSDKFeedBackStatus$1 = {}));

var EResultCorrectness$1;

(function (EResultCorrectness) {
  // 待批改/自评
  EResultCorrectness["WAIT"] = "WAIT";
  EResultCorrectness["RIGHT"] = "RIGHT";
  EResultCorrectness["PARTIAL_RIGHT"] = "PARTIAL_RIGHT";
  EResultCorrectness["WRONG"] = "WRONG";
})(EResultCorrectness$1 || (EResultCorrectness$1 = {}));

var EAutoGradingTypes;

(function (EAutoGradingTypes) {
  EAutoGradingTypes[EAutoGradingTypes["CAN_NOT_AUTO"] = 0] = "CAN_NOT_AUTO";
  EAutoGradingTypes[EAutoGradingTypes["CAN_AUTO"] = 1] = "CAN_AUTO";
  EAutoGradingTypes[EAutoGradingTypes["CAN_NOT_AUTO_MULTIPLE"] = 2] = "CAN_NOT_AUTO_MULTIPLE";
  EAutoGradingTypes[EAutoGradingTypes["CAN_AUTO_MULTIPLE"] = 3] = "CAN_AUTO_MULTIPLE";
})(EAutoGradingTypes || (EAutoGradingTypes = {}));

var ECorrectType;

(function (ECorrectType) {
  // 自动批改
  ECorrectType[ECorrectType["AUTO_CORRECT"] = 0] = "AUTO_CORRECT"; // 自评对错

  ECorrectType[ECorrectType["SELF_CORRECT"] = 1] = "SELF_CORRECT"; // 自评得分

  ECorrectType[ECorrectType["SELF_CORRECT_LEVEL"] = 2] = "SELF_CORRECT_LEVEL"; // 老师批改

  ECorrectType[ECorrectType["TEACHER_CORRECT"] = 3] = "TEACHER_CORRECT"; // ai批改

  ECorrectType[ECorrectType["AI_CORRECT"] = 4] = "AI_CORRECT";
})(ECorrectType || (ECorrectType = {}));

var EJudgeTypes;

(function (EJudgeTypes) {
  /** 严谨 */
  EJudgeTypes[EJudgeTypes["RIGOROUS"] = 1] = "RIGOROUS";
  /** 不严谨-不可错 */

  EJudgeTypes[EJudgeTypes["NOT_RIGOROUS_AND_CAN_NOT_ERROR"] = 2] = "NOT_RIGOROUS_AND_CAN_NOT_ERROR";
  /** 不严谨-可错 */

  EJudgeTypes[EJudgeTypes["NOT_RIGOROUS_AND_CAN_ERROR"] = 3] = "NOT_RIGOROUS_AND_CAN_ERROR";
})(EJudgeTypes || (EJudgeTypes = {}));
/**
 * 题目的难度枚举
 * @author chenbaijin
 * @desp number类型，从1到5表示难度
 */


var EDifficultyTypes;

(function (EDifficultyTypes) {
  EDifficultyTypes[EDifficultyTypes["EASIEST"] = 1] = "EASIEST";
  EDifficultyTypes[EDifficultyTypes["EASIER"] = 2] = "EASIER";
  EDifficultyTypes[EDifficultyTypes["MEDIUM"] = 3] = "MEDIUM";
  EDifficultyTypes[EDifficultyTypes["HARDER"] = 4] = "HARDER";
  EDifficultyTypes[EDifficultyTypes["HARDEST"] = 5] = "HARDEST";
})(EDifficultyTypes || (EDifficultyTypes = {}));

var ENativeApi;

(function (ENativeApi) {
  ENativeApi["PREVIEW_IMAGE"] = "previewImage";
  ENativeApi["GOTOPLAY_VIDEO"] = "goToPlayVideo";
  ENativeApi["SHOW_UPLOAD_IMAGE"] = "showUpLoadImage";
  ENativeApi["SPEAK_START_EVALUATE"] = "speakStartEvaluate";
  ENativeApi["CHECK_INDICATE_PRIVILEGE"] = "checkIndicatePrivilege";
  ENativeApi["STOP_SPEAK_SDK"] = "speakStopEvaluate";
  ENativeApi["AUTO_PLAY_AUDIO"] = "audioPlayStart";
  ENativeApi["OPERATE_AUDIO"] = "audioPlayOperate";
  ENativeApi["OPEN_CAMERA"] = "openCameraFromNative";
  ENativeApi["GET_ALBUM"] = "choosePictureOrVideoFromAlbum";
  ENativeApi["RECORD_AUDIO"] = "recordingAudioFromNative";
  ENativeApi["SPEAK_EVALUTE"] = "speakEvaluate";
  ENativeApi["OPERATE_NATIVE_AUDIO"] = "audioPlay";
})(ENativeApi || (ENativeApi = {}));

var ENativeCBNames;

(function (ENativeCBNames) {
  ENativeCBNames["UPLOAD_IMG_CB"] = "logisticsUpLoadImageCallBack";
  ENativeCBNames["GET_AUTHORITY_CB"] = "getNativeAuthorityCallback";
  ENativeCBNames["SPEAK_CB"] = "speakStartEvaluateCallback";
  ENativeCBNames["STOP_SPEAK_CB"] = "speakStopEvaluateCallback";
  ENativeCBNames["AUTO_PLAY_AUDIO_CB"] = "audioPlayStartCallback";
  ENativeCBNames["OPERATE_AUDIO_CB"] = "audioPlayOperateCallback";
  ENativeCBNames["NATIVE_UPLOAD_CB"] = "nativeUploadCallback";
  ENativeCBNames["SPEAK_EVALUTE_CB"] = "speakEvaluateCallback";
  ENativeCBNames["OPERATE_NATIVE_AUDIO_CB"] = "audioPlayCallback";
})(ENativeCBNames || (ENativeCBNames = {}));

var EAuthorityTypes;

(function (EAuthorityTypes) {
  EAuthorityTypes["ALBUM"] = "album";
  EAuthorityTypes["CAMERA"] = "camera";
  EAuthorityTypes["MICROPHONE"] = "microphone";
  EAuthorityTypes["AUDIO"] = "audio";
  EAuthorityTypes["NATIVE_UPLOAD_CB"] = "nativeUploadCallback";
})(EAuthorityTypes || (EAuthorityTypes = {}));

var EServiceNames;

(function (EServiceNames) {
  EServiceNames["GT_CAMERA"] = "gtcamera";
})(EServiceNames || (EServiceNames = {}));
/**
 * 试题类型属性
 */


var ELogicTypeId;

(function (ELogicTypeId) {
  // 互动题
  ELogicTypeId["INTERACTIVE"] = "0"; // 选择

  ELogicTypeId["CHOICE"] = "1"; // 多选

  ELogicTypeId["MULTIPLE_CHOICE"] = "2"; // 不定项选择

  ELogicTypeId["INDEFINITE_CHOICE"] = "3"; // 填空

  ELogicTypeId["FILL_BLANK"] = "4"; // 解答

  ELogicTypeId["EXPLANATION"] = "5"; // 语音

  ELogicTypeId["VOICE"] = "6"; // 写作

  ELogicTypeId["WRITING"] = "7"; // 判断

  ELogicTypeId["JUDGE"] = "8"; // 完形填空

  ELogicTypeId["CLOZE"] = "9"; // 复合题

  ELogicTypeId["COMPOUND"] = "10"; // 多选多

  ELogicTypeId["MULTI_CHOICE_MULTI"] = "11"; // 视频题

  ELogicTypeId["VIDEO"] = "12"; // 字词句朗诵

  ELogicTypeId["WORD_RECITATION"] = "13"; // 古诗文朗诵

  ELogicTypeId["POETRY_RECITATION"] = "14"; // 角色扮演

  ELogicTypeId["ROLE_PLAY"] = "15"; // TODO: 空上作答

  ELogicTypeId["FILL_ON_BLANK"] = "16";
})(ELogicTypeId || (ELogicTypeId = {}));
/**
 * 渲染解析结构化数据组件richtext的位置
 */


var ERichTextLocation;

(function (ERichTextLocation) {
  ERichTextLocation["STEM"] = "stem";
  ERichTextLocation["ANALYSIS"] = "analysis";
  ERichTextLocation["OPTION"] = "option";
  ERichTextLocation["ANSWER"] = "answer";
  ERichTextLocation["USER_ANSWER"] = "user_answer";
})(ERichTextLocation || (ERichTextLocation = {}));

var EStickerLocModule;

(function (EStickerLocModule) {
  // 在作答信息上面
  EStickerLocModule["ANSWERINFO"] = "answerInfo"; // 用户作答信息下面

  EStickerLocModule["ANSWERINFOEND"] = "answerInfoEnd"; // 解析下面带有卡片样式

  EStickerLocModule["ANALYSIS_END_IN_CARD"] = "analysisEndInCard"; // 背题模式 - 查看答案按钮自定义

  EStickerLocModule["RECITE_NODE"] = "reciteNode";
})(EStickerLocModule || (EStickerLocModule = {}));

var EComponent;

(function (EComponent) {
  EComponent["choice"] = "choice";
  EComponent["multipleChoice"] = "multipleChoice";
  EComponent["speech"] = "speech";
  EComponent["judge"] = "judge";
  EComponent["fill"] = "fill";
  EComponent["explain"] = "explain";
  EComponent["default"] = "";
})(EComponent || (EComponent = {})); // 提交资源类型和允许作答方式对应的交集


var ESubmitType;

(function (ESubmitType) {
  ESubmitType["AUDIO"] = "AUDIO";
  ESubmitType["VIDEO"] = "VIDEO";
  ESubmitType["IMAGE"] = "IMAGE";
  ESubmitType["TEXT"] = "TEXT"; // AUDIOEVALUATE = 'AUDIOEVALUATE'
})(ESubmitType || (ESubmitType = {}));
/**
 * 与C端前端约定的作答格式type（用户提交的资源类型）
 */


var ESubmitItemTypes;

(function (ESubmitItemTypes) {
  ESubmitItemTypes[ESubmitItemTypes["IMAGE"] = 1] = "IMAGE";
  ESubmitItemTypes[ESubmitItemTypes["AUDIO"] = 2] = "AUDIO";
  ESubmitItemTypes[ESubmitItemTypes["TEXT"] = 3] = "TEXT";
  ESubmitItemTypes[ESubmitItemTypes["VIDEO"] = 4] = "VIDEO";
  ESubmitItemTypes[ESubmitItemTypes["OPTION"] = 6] = "OPTION"; // 自动判题的文本作答

  ESubmitItemTypes[ESubmitItemTypes["TEXT_AUTO"] = 7] = "TEXT_AUTO";
  ESubmitItemTypes[ESubmitItemTypes["AUDIOEVALUATE"] = 9] = "AUDIOEVALUATE";
  ESubmitItemTypes[ESubmitItemTypes["INTERACTIVE"] = 10] = "INTERACTIVE";
})(ESubmitItemTypes || (ESubmitItemTypes = {}));

var EAnswerMode;

(function (EAnswerMode) {
  // 默认 单题作答
  EAnswerMode[EAnswerMode["SIGLE"] = 0] = "SIGLE";
  EAnswerMode[EAnswerMode["UNIFIED"] = 1] = "UNIFIED";
})(EAnswerMode || (EAnswerMode = {}));

var EMediaTypes;

(function (EMediaTypes) {
  EMediaTypes[EMediaTypes["IMG"] = 1] = "IMG";
  EMediaTypes[EMediaTypes["VIDEO"] = 2] = "VIDEO";
})(EMediaTypes || (EMediaTypes = {}));

var EAudioAnswerType;

(function (EAudioAnswerType) {
  EAudioAnswerType[EAudioAnswerType["ENGLISH_ENGLISH"] = 5] = "ENGLISH_ENGLISH";
  EAudioAnswerType[EAudioAnswerType["CHINESE_ENGLISH"] = 6] = "CHINESE_ENGLISH";
})(EAudioAnswerType || (EAudioAnswerType = {}));

var ESpeechWebSDKErrorCode;

(function (ESpeechWebSDKErrorCode) {
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8BF7\u5728\u5B89\u5168\u8FDE\u63A5\u6216\u672C\u5730\u7684\u7F51\u9875\u4E2D\u4F7F\u7528"] = 40001] = "\u8BF7\u5728\u5B89\u5168\u8FDE\u63A5\u6216\u672C\u5730\u7684\u7F51\u9875\u4E2D\u4F7F\u7528";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u7F51\u7EDC\u5F02\u5E38"] = 40002] = "\u7F51\u7EDC\u5F02\u5E38";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8BE5\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u5F55\u97F3"] = 40003] = "\u8BE5\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u5F55\u97F3";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u5F55\u97F3\u51FA\u9519\u4E86\u54E6,\u518D\u8BD5\u8BD5\u5427"] = 40004] = "\u5F55\u97F3\u51FA\u9519\u4E86\u54E6,\u518D\u8BD5\u8BD5\u5427";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8FDE\u63A5\u8BC4\u6D4B\u670D\u52A1\u65F6\u51FA\u9519"] = 70001] = "\u8FDE\u63A5\u8BC4\u6D4B\u670D\u52A1\u65F6\u51FA\u9519";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8BC4\u6D4B\u5F00\u59CB\u65F6\u72B6\u6001\u5F02\u5E38"] = 70002] = "\u8BC4\u6D4B\u5F00\u59CB\u65F6\u72B6\u6001\u5F02\u5E38";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u91CD\u590D\u8C03\u7528\u8BC4\u6D4B\u670D\u52A1"] = 70003] = "\u91CD\u590D\u8C03\u7528\u8BC4\u6D4B\u670D\u52A1";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u7B49\u5F85\u7ED3\u679C\u4E2D"] = 70004] = "\u7B49\u5F85\u7ED3\u679C\u4E2D";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u53C2\u6570\u4E3A\u7A7A"] = 70005] = "\u53C2\u6570\u4E3A\u7A7A";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u53C2\u6570\u7C7B\u578B\u9519\u8BEF"] = 70006] = "\u53C2\u6570\u7C7B\u578B\u9519\u8BEF";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u7A7A\u5B57\u7B26\u4E32"] = 70007] = "\u7A7A\u5B57\u7B26\u4E32";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u671F\u671B\u9650\u5B9A\u503C"] = 70008] = "\u671F\u671B\u9650\u5B9A\u503C";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u4E0D\u652F\u6301\u7684\u8BC4\u6D4B\u5185\u5BB9"] = 70009] = "\u4E0D\u652F\u6301\u7684\u8BC4\u6D4B\u5185\u5BB9";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u670D\u52A1\u7AEF\u8D85\u8FC7\u6700\u5927\u5E76\u53D1"] = 51001] = "\u670D\u52A1\u7AEF\u8D85\u8FC7\u6700\u5927\u5E76\u53D1";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u670D\u52A1\u7AEF\u54CD\u5E94\u8D85\u65F6"] = 51002] = "\u670D\u52A1\u7AEF\u54CD\u5E94\u8D85\u65F6";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8BC4\u6D4B\u7ED3\u675F\u65F6\u72B6\u6001\u5F02\u5E38"] = 71001] = "\u8BC4\u6D4B\u7ED3\u675F\u65F6\u72B6\u6001\u5F02\u5E38";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8BC4\u6D4B\u65F6\u8FDE\u63A5\u51FA\u9519"] = 71002] = "\u8BC4\u6D4B\u65F6\u8FDE\u63A5\u51FA\u9519";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u8FDE\u63A5\u610F\u5916\u65AD\u5F00"] = 71003] = "\u8FDE\u63A5\u610F\u5916\u65AD\u5F00";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u672A\u8C03\u7528\u8BC4\u6D4B\u670D\u52A1"] = 71004] = "\u672A\u8C03\u7528\u8BC4\u6D4B\u670D\u52A1";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u6B63\u5728\u521D\u59CB\u5316"] = 71005] = "\u6B63\u5728\u521D\u59CB\u5316";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["websocket\u8FDE\u63A5\u4E2D"] = 71006] = "websocket\u8FDE\u63A5\u4E2D";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u5F55\u97F3\u673A\u542F\u52A8\u4E2D"] = 71007] = "\u5F55\u97F3\u673A\u542F\u52A8\u4E2D";
  ESpeechWebSDKErrorCode[ESpeechWebSDKErrorCode["\u91CD\u590D\u8C03\u7528\u7ED3\u675F\u8BC4\u6D4B"] = 71008] = "\u91CD\u590D\u8C03\u7528\u7ED3\u675F\u8BC4\u6D4B";
})(ESpeechWebSDKErrorCode || (ESpeechWebSDKErrorCode = {}));
/**
 * 后端给的允许作答type对应关系 作答方式（该题目作答的方式）对应AnswerWay
 */


var EAnswerTypes;

(function (EAnswerTypes) {
  EAnswerTypes[EAnswerTypes["IMAGE"] = 1] = "IMAGE";
  EAnswerTypes[EAnswerTypes["TEXT"] = 2] = "TEXT";
  EAnswerTypes[EAnswerTypes["AUDIO"] = 3] = "AUDIO";
  EAnswerTypes[EAnswerTypes["VIDEO"] = 4] = "VIDEO";
  EAnswerTypes[EAnswerTypes["LOOK_ENG_READ_ENG"] = 5] = "LOOK_ENG_READ_ENG";
  EAnswerTypes[EAnswerTypes["LOOK_CN_READ_ENG"] = 6] = "LOOK_CN_READ_ENG";
  EAnswerTypes[EAnswerTypes["RICH_TEXT"] = 7] = "RICH_TEXT";
})(EAnswerTypes || (EAnswerTypes = {}));
/**
 * 处理过后对应业务场景的type映射（并且也是与app约定的映射
 */


var EDealedATypes;

(function (EDealedATypes) {
  EDealedATypes[EDealedATypes["IMAGE"] = 0] = "IMAGE";
  EDealedATypes[EDealedATypes["VIDEO"] = 1] = "VIDEO";
  EDealedATypes[EDealedATypes["IMAGE_AND_VIDEO"] = 2] = "IMAGE_AND_VIDEO";
  EDealedATypes[EDealedATypes["AUDIO"] = 3] = "AUDIO";
  EDealedATypes[EDealedATypes["TEXT"] = 4] = "TEXT";
})(EDealedATypes || (EDealedATypes = {}));
/**
 * 拍摄端能力
 * 0：仅拍单张图
 * 1: 可拍多张图、相册选择
 */


var EOpenType;

(function (EOpenType) {
  EOpenType[EOpenType["TOKE_A_SIGLE_PHONE"] = 0] = "TOKE_A_SIGLE_PHONE";
  EOpenType[EOpenType["TOKE_PHOTOS"] = 1] = "TOKE_PHOTOS";
})(EOpenType || (EOpenType = {}));
/**
 * 不同作答方式对应的作答数量限制
 */


var EAnswerTypeMaxCount = {
  AUDIO: 1,
  VIDEO: 1,
  IMAGE: 6,
  TEXT: 3000
};
/**
 * 我的回答 输入框placeholder
 */

var MyAnswerPlaceholder = '请输入文字...';
/**
 * 不同作答方式对应的作答文件大小限制(单位：M)
 */

var EAnswerTypeMaxSize = {
  // AUDIO: 120,
  // VIDEO: 120,
  IMAGE: 5
};
/**
 * 不同作答方式对应的作答时长限制（单位：S秒）
 */

var EAnswerTypeMaxDuration = {
  AUDIO: 300,
  VIDEO: 300
}; // export const IMAGE_ACCEPT = 'image/png, image/jpg, image/jpeg';

var IMAGE_ACCEPT = 'image/*';
var IMAGE_ACCEPT_LIST = ['.png', '.jpg', '.jpeg']; // export const VIDEO_ACCEPT = 'video/mp4, video/avi, video/flv, video/mov';

var VIDEO_ACCEPT = 'video/*';
var VIDEO_ACCEPT_LIST = ['.mp4', '.mov'];
var VIDEO_MAX_SIZE = 524288000;
var EPromptMsg;

(function (EPromptMsg) {
  EPromptMsg["OVER_VIDEO_MAX_COUNT"] = "\u6700\u591A\u53EA\u80FD\u4E0A\u4F201\u4E2A\u89C6\u9891\uFF0C\u5DF2\u4E3A\u60A8\u9009\u53D6\u524D1\u4E2A\u89C6\u9891";
  EPromptMsg["OVER_IMG_MAX_COUNT"] = "\u6700\u591A\u53EA\u80FD\u4E0A\u4F206\u5F20\u56FE\u7247\uFF0C\u5DF2\u4E3A\u60A8\u9009\u53D6\u524D6\u5F20\u56FE\u7247";
  EPromptMsg["OVER_VIDEO_MAX_SIZE"] = "\u4EC5\u652F\u6301\u6700\u5927500M\u7684\u89C6\u9891";
  EPromptMsg["OVER_IMG_MAX_SIZE"] = "\u56FE\u7247\u6700\u5927\u652F\u63015M\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20";
  EPromptMsg["OVER_VIDEO_MAX_DURATION"] = "\u89C6\u9891\u6700\u957F\u652F\u63013\u5206\u949F\uFF0C\u8BF7\u91CD\u65B0\u4E0A\u4F20";
  EPromptMsg["ERROR_VIDEO_TYPE"] = "\u4EC5\u652F\u6301\u4E0A\u4F20.mp4\uFF0C.mov\u7C7B\u578B\u7684\u89C6\u9891";
  EPromptMsg["ERROR_IMG_TYPE"] = "\u4EC5\u652F\u6301\u4E0A\u4F20.png/.jpg/.jpeg\u7C7B\u578B\u56FE\u7247"; // 微信小程序web-view内相关提示

  EPromptMsg["CHOOSE_IMG_FAILED"] = "\u9009\u62E9\u56FE\u7247\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5";
  EPromptMsg["SOME_IMG_UPLOAD_FAILED"] = "\u90E8\u5206\u56FE\u7247\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5";
  EPromptMsg["UPLOAD_FAILED"] = "\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5";
  EPromptMsg["ERROR_NETWORK"] = "\u4E0A\u4F20\u5931\u8D25\uFF01\u8BF7\u91CD\u8BD5...";
})(EPromptMsg || (EPromptMsg = {}));

var EImgTopTipMsg;

(function (EImgTopTipMsg) {
  EImgTopTipMsg["MY_ANSWER"] = "\u5C55\u793A\u7684\u662F\u672C\u6B21\u7EC3\u4E60\u63D0\u4EA4\u7684\u5168\u90E8\u56FE\u7247\u54E6\uFF5E";
  EImgTopTipMsg["CORRECTION_RESULT"] = "\u5C55\u793A\u7684\u662F\u672C\u6B21\u7EC3\u4E60\u63D0\u4EA4\u7684\u5168\u90E8\u6279\u6539\u56FE\u7247\u54E6\uFF5E";
})(EImgTopTipMsg || (EImgTopTipMsg = {})); // 作答视频上传的状态


var EVideoUploadState;

(function (EVideoUploadState) {
  EVideoUploadState["NO_UPLOAD"] = "NO_UPLOAD";
  EVideoUploadState["UPLOADING"] = "UPLOADING";
  EVideoUploadState["UPLOAD_FAILED"] = "UPLOAD_FAILED";
  EVideoUploadState["UPLOAD_SUCCESS"] = "UPLOAD_SUCCESS";
})(EVideoUploadState || (EVideoUploadState = {})); // 题目状态


var EQuestionStatus;

(function (EQuestionStatus) {
  // 作答
  EQuestionStatus[EQuestionStatus["ANSWER"] = 1] = "ANSWER"; // 解析

  EQuestionStatus[EQuestionStatus["ANALYSIS"] = 2] = "ANALYSIS";
})(EQuestionStatus || (EQuestionStatus = {}));

var EBlankVacancy;

(function (EBlankVacancy) {
  EBlankVacancy["EBlankOrdered"] = "ordered";
  EBlankVacancy["EBlankDisordered"] = "disordered";
})(EBlankVacancy || (EBlankVacancy = {})); // 音频loading时长限制


var WAITING_TIME = 30000;
var EAnswerStatus;

(function (EAnswerStatus) {
  // 有点沾边 (自评相关)
  EAnswerStatus[EAnswerStatus["LITTLE"] = 5] = "LITTLE"; // 半对

  EAnswerStatus[EAnswerStatus["HALF_RIGHT"] = 10] = "HALF_RIGHT"; // 未作答

  EAnswerStatus[EAnswerStatus["UN_ANSWER"] = 20] = "UN_ANSWER"; // 已作答

  EAnswerStatus[EAnswerStatus["ANSEWRED"] = 25] = "ANSEWRED"; // 错误

  EAnswerStatus[EAnswerStatus["WRONG"] = 30] = "WRONG"; // 基本正确

  EAnswerStatus[EAnswerStatus["BASIC_Right"] = 35] = "BASIC_Right"; // 正确

  EAnswerStatus[EAnswerStatus["RIGHT"] = 40] = "RIGHT"; // 未自评

  EAnswerStatus[EAnswerStatus["NO_EVALUATION"] = 50] = "NO_EVALUATION"; // 背题已确认 背题模式下，点击确认按钮后题目应该流转到的状态

  EAnswerStatus[EAnswerStatus["RECITED"] = 15] = "RECITED";
})(EAnswerStatus || (EAnswerStatus = {})); // 老师批改


var ECorrectCommnetResourceType;

(function (ECorrectCommnetResourceType) {
  ECorrectCommnetResourceType[ECorrectCommnetResourceType["IMAGE"] = 1] = "IMAGE";
  ECorrectCommnetResourceType[ECorrectCommnetResourceType["AUDIO"] = 2] = "AUDIO";
  ECorrectCommnetResourceType[ECorrectCommnetResourceType["TEXT"] = 3] = "TEXT";
  ECorrectCommnetResourceType[ECorrectCommnetResourceType["VIDEO"] = 4] = "VIDEO";
})(ECorrectCommnetResourceType || (ECorrectCommnetResourceType = {})); // 手动滑动速度


var SWIPER_SPEED = 240; // 点击题号切换速度

var JUMP_SWIPER_SPEED = 10;

var ua = window.navigator.userAgent;
var isAndroid$1 = /android/i.test(ua);
var isIOS$1 = /iphone|ipad|ipod/i.test(ua);
/iphone/i.test(ua);
/ipad/i.test(ua);
/ipod/i.test(ua);
/micromessenger\/([\d.]+)/i.test(ua); // 爱马仕项目添加 老版本没有
// gaotuapp-android/3.16.0
// gaotuapp-ios/3.16.0

var isGaotuApp = /gaotuapp/i.test(ua);
var isGaotuAndroid = /gaotuapp-android/i.test(ua);
/gaotuapp-ios/i.test(ua); // 是否是诺亚框架，用于区分新老版本端能力

var isNoah$1 = /noah/i.test(ua);

var sdkLoader = function sdkLoader(_ref) {
  var id = _ref.id,
      url = _ref.url;
  var sdk = document.getElementById(id);

  if (!sdk) {
    var script = document.createElement('script');
    script.src = url;
    script.id = id;
    document.body.appendChild(script);
    return new Promise(function (resolve, reject) {
      script.onload = function () {
        resolve(1);
      };

      script.onerror = function (error) {
        reject(error);
      };
    });
  }

  return Promise.resolve();
};
window.Hybrid = {};
/**
 * 在 window/window.Hybrid 上绑定 native 回调事件
 * @param functionObject 回调事件的 key-value 对象
 * @example
 * addFunc({
 *     'rightButtonClickCallback',
 *     () => console.log('right button clicked')
 * });
 */

var addFunc = function addFunc(functionObject) {
  Object.assign(window.Hybrid, functionObject);
  Object.assign(window, functionObject);
};

var runtime_1 = createCommonjsModule(function (module) {
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof$1(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : _typeof$1(globalThis)) === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
});

var regenerator = runtime_1;

var ACTION_SERVICE = {
  // 自定义测试
  customTestJsBridge: '自定义测试',

  /** *********** GTCommonHeader *************/
  // 展示导航栏
  showNavigationBar: 'GTCommonHeader',
  // 隐藏导航栏
  hideNavigationBar: 'GTCommonHeader',
  // 展示标题栏右侧功能区
  showRightButton: 'GTCommonHeader',
  // 隐藏标题栏右侧功能区
  hideRightButton: 'GTCommonHeader',
  // 设置标题
  setTitle: 'GTCommonHeader',
  // 展示左上角按钮 {"Buttons":[{"type":"text->文本 image->图片","content":"按钮显示的内容"}]}
  showLeftButton: 'GTCommonHeader',
  // 设置状态栏
  handleNavigationStatusBar: 'GTCommonHeader',

  /** *********** GTError *************/
  // 网络错误
  onWebError: 'GTError',
  // 展示网络错误页面
  showNetworkErrorView: 'GTError',

  /** *********** GTAccount *************/
  // 用户登录
  userLogin: 'GTAccount',
  // web页面错误回调，用户账号在别处登陆 {"errorCode": "29"}
  userLogout: 'GTAccount',
  // 用户登陆状态错误
  userLoginError: 'GTAccount',
  // 存储信息到本地
  saveDataToLocal: 'GTAccount',
  // 取出本地的信息
  unsaveDataToLocal: 'GTAccount',
  // 获取用户基本信息
  getUserCommonInfo: 'GTAccount',
  // 不校验登录态，直接弹出登录
  renewalLogin: 'GTAccount',

  /** *********** GTCustomService *************/
  // 调起客服电话
  servicePhone: 'GTCustomService',

  /** *********** GTRouter *************/
  // 跳转主页
  showNativeTabbar: 'GTRouter',
  // 跳转用户资料页
  showNativeUserInfo: 'GTRouter',
  // 录取通知书
  showNativeAdmissionLetterDetail: 'GTRouter',
  // 新页面打开H5
  openWindow: 'GTRouter',
  // 跳首页
  showHomePage: 'GTRouter',
  navigation: 'GTRouter',
  showWapUrlToNative: 'GTRouter',

  /** *********** GTDownload *************/
  // 保存到本地
  saveToLocal: 'GTDownload',

  /** *********** GTApp *************/
  // 引导好评
  showCommentFavourable: 'GTApp',
  // 提示更新App
  showUpgradeApp: 'GTApp',
  // H5从App中获取网络状态
  getNativeNetStatus: 'GTApp',
  // 获取定位省市信息
  getAreaInfo: 'GTApp',
  // 上报统计或者打印日志
  reportLog: 'GTApp',

  /** *********** GTWechat *************/
  // 打开微信
  openWeChat: 'GTWechat',
  // 根据微信ID获取微信登录后的code
  getNativeWeChatCode: 'GTWechat',
  // 弹出老师微信
  showNativeTeacherQRCode: 'GTWechat',

  /** *********** GTStudy *************/
  // 分享阶段报告
  shareStageReport: 'GTStudy',
  // 跳转练习
  goToClassroomQuiz: 'GTStudy',
  // 去考试
  goFinalExamLookParse: 'GTStudy',
  // 播视频
  goToPlayVideo: 'GTStudy',
  // 去摸底测或结课测
  goToDiagnosticOrFinalExam: 'GTStudy',
  // 开始语音评测
  speakEvaluate: 'GTStudy',
  // 语音播放 - 开始播放
  audioPlay: 'GTStudy',
  // 作业模块趣味打卡-录音
  recordingAudioFromNative: 'GTStudy',
  // 作业模块趣味打卡-相册选择
  choosePictureOrVideoFromAlbum: 'GTStudy',
  // 查看课后练习解析页面
  goHomeworkAnalysis: 'GTStudy',
  // 缓存音频列表
  cacheAudioList: 'GTStudy',
  // 趣味互动调用原生——设置显示新手引导标志
  setBeginnerGuideMarkFromNative: 'GTStudy',
  // 趣味互动调用原生——获取显示新手引导标志
  getBeginnerGuideMarkFromNative: 'GTStudy',

  /** *********** GTCamera *************/
  // 调起相册
  showUpLoadImage: 'GTCamera',
  // iOS 获取 相册、拍照录音权限
  checkIndicatePrivilege: 'GTCamera',
  // 作业模块趣味打卡-拍摄相机调起
  openCameraFromNative: 'GTCamera',
  // 查看大图
  previewImage: 'GTCamera',

  /** *********** GTPage *************/
  // 页面返回上一级
  closeWindow: 'GTPage',
  showToast: 'GTPage',
  // h5获取剩余内存(通过getAppMemory将数据告知H5)
  // getRamMemoryAvailable: 'GTPage',
  // 转客户端日志回捞{"content":"日志内容"}
  // logStash: 'GTPage',
  // 展示网络错误toast
  showNetworkErrorToast: 'GTPage',
  // 初始化七陌SDK
  customerService: 'GTPage',
  // h5发送到客户端的通知： type：行为类型“reachUpload”、“interactiveQuiz”； data：数据内容
  // send: 'GTPage',
  // 关闭web页面，返回APP
  closeWebView: 'GTPage',
  // 展示toast
  shareStageReportshowToast: 'GTPage',
  // 请求音频权限：成功返回：recordPermissionGranted(true)；失败返回: recordPermissionGranted(false)
  // requestRecordPermission: 'GTPage',
  // tocken过期
  // tokenExpired: 'GTPage',
  // 关闭当前页面
  // closeWin: 'GTPage',
  // 展示loading
  startLoading: 'GTPage',
  // 隐藏loading
  stopLoading: 'GTPage',

  /** *********** GTOrder *************/
  // web支付信息 {"orderId":"订单编号","pay_success_url":"支付成功地址"}
  payActivity: 'GTOrder',
  showNativeCouponsCourseList: 'GTOrder',
  // 去报名 {"courseType":"课程对应的类型","courseGrade":"课程对应的年级","activityType":"课程对应活动的类型","activityNumber":"课程对应活动的number","activityExtInfo":"课程的活动扩展信息"}
  showNativeEnroll: 'GTOrder',
  // 兑换码跳转支付成功页面：{"orderId": "订单ID"}
  showPaySuccess: 'GTOrder',
  // 电子发票提交成功，通知订单刷新
  invoiceCommitSuccess: 'GTOrder',
  // 电子发票保存相册，通知订单刷新 imageUrls 电子发票URL
  invoiceSaveToAlbum: 'GTOrder',
  // 跳转支付成功页
  jumpToPaySuccessPage: 'GTOrder',

  /** *********** GTShare *************/
  // 分享一张图片（微信好友，微信朋友圈，保存到本地）： {"URL": "下载图片的url", "type": "分享图片的方式"} type： 1 是微信好友 3是保存到本地 其他是朋友圈
  shareImageToNative: 'GTShare',
  showCommonShareView: 'GTShare',
  sharePoster: 'GTShare',
  // H5通用分享 {"title": "分享的标题", "img": "分享的图片", "content": "分享的副标题", "url": "分享的URL"}
  sharePromotion: 'GTShare',

  /** * h5打开微信小程序 {"jumpWechatId":"分享的标题微信id","jumpWechatPath":"打开小程序的路径","jumpWechatContentId":"携带的参数"} source参数为客户会话必带参数  banner：1  popup：2  弹窗 avtivity_link:3 软文配置 */
  shareNativeMiniProgram: 'GTShare',
  // 分享课程 clazzNumber ：班级number courseType ：课程类型
  // activityType ：分享课对应活动的类型，通过/course/detail中获取 activityNumber 分享课程对应活动的number，通过/course/detail中获取 activityExtInfo 分享课程的活动扩展信息，json格式保存，由活动模块解析，通过/course/detail中获取 teacherNumber为老师编号（如果teacherNumber为nil就是分享课程，不然就是分享老师主页）
  // 弹起分享
  showNativeSharePop: 'GTShare',
  // 每日一练分享 {"clazzNumber": "课程ID", "url": "分享的URL"}
  shareExerciseEverdayResult: 'GTShare',
  // 学习报告分享 {"clazzLessonId": "clazzLessonId"}
  shareReport: 'GTShare',
  // 听口角分享海报
  sharePosterFromCorner: 'GTShare',
  // 分享海报
  sharePosterFromNative: 'GTShare',
  // 分享小程序
  shareMiniProgram: 'GTShare',

  /** *********** GTCourse *************/
  // 跳转已购买课程详情页 {"course_type": "课程的courseType（联保课程或者普通课程）", "course_id": "courseId"}
  showNativeBoughtCourseDetail: 'GTCourse',
  goComment: 'GTCourse',
  jumpClass: 'GTCourse',
  // 跳转未购买课程详情页 {"course_type": "课程的courseType（联保课程或者普通课程）", "course_id": "courseId"}
  showNativeCourseDetail: 'GTCourse',
  // 去直播或者去回放 {"liveId": "直播ID", "type": "类型"} type: 1 直播 2 回放
  showNativeLiving: 'GTCourse',
  // 申请退款，已经登录状态下，跳转到订单列表页面
  applyForRefund: 'GTCourse',
  // 调班/调课，已经登录状态下，跳转到订单列表页面
  adjustClazz: 'GTCourse',
  // 讲义问题，已经登录状态下，跳转到订单列表页面
  bookProblem: 'GTCourse',
  // 跳转教务客服
  educationService: 'GTCourse',
  // 进入作业页面 {"clazzLessonId": "clazzLessonId"}
  submitHomework: 'GTCourse',
  // 去鼓励弹窗
  showAppFavourable: 'GTCourse',
  // 去错题本 {"course_id": "课程ID", "course_title": "课程名称"}
  showErrorBookExercise: 'GTCourse',
  // 看回放 {"course_id": "课程的ID"}
  showNativeCourseSection: 'GTCourse',
  // 推荐课程回调
  // recommendCourse: 'GTCourse',

  /** *********** GTQuestionnaire *************/
  // 告诉入学通知书刷新页面
  questionnaireCommitSuccess: 'GTQuestionnaire',

  /** *********** GTRenewalClazz *************/
  // 展示课程大纲 {"activityNumber": "续班活动的number"}
  renewalClazzShowOutline: 'GTRenewalClazz',
  // 预报名成功 {"activityNumber": "续班活动的number"}
  renewalClazzBookSuccess: 'GTRenewalClazz',
  // 点击预付款、支付 {"clazzNumber": "班级number"}
  renewalClazzPayOrder: 'GTRenewalClazz',
  // 续班限流，展示出错页面
  renewalClazzShowNetLimit: 'GTRenewalClazz',
  // 查看课程，跳转到课节详情页 {"courseId": "课程ID"}
  renewalClazzShowLesson: 'GTRenewalClazz'
  /** *********** GTInteractiveProblem *************/
  // // 互动课件获取时间戳
  // interWebViewInitTime: 'GTInteractiveProblem',
  // // 互动课件获取本地图片地址
  // interactiveQuizResource: 'GTInteractiveProblem',
  // // 开始录音
  // recordingAudio: 'GTInteractiveProblem',
  // // 停止录音
  // stopRecordingAudio: 'GTInteractiveProblem',
  // // 准备新版语音评测 voiceItemId 语音条目id
  // prepareInteractiveVoiceQuiz: 'GTInteractiveProblem',
  // // 开始新版语音评测 失败触发onInteractiveVoiceEvaluationResult(code: -1, msg: "")
  // startInteractiveVoiceQuiz: 'GTInteractiveProblem',
  // // 结束新版语音评测
  // stopInteractiveVoiceQuiz: 'GTInteractiveProblem',
  // // 连击相关回调
  // operationNotice: 'GTInteractiveProblem',

  /** *********** GTPerformanceTest *************/
  // 下一题
  // loadNextQuestion: 'GTPerformanceTest',

};
var getServiceByAction = function getServiceByAction(name) {
  var service = ACTION_SERVICE[name];

  if (!service) {
    // eslint-disable-next-line
    console.error("\u6CA1\u6709\u627E\u5230 ".concat(name, " \u5BF9\u5E94\u7684 service\uFF0C\u8BF7\u624B\u52A8\u6307\u5B9A\u3002eg: gtJsBridge.exec(action_name, PARAMS, service)"));
    return '';
  }

  return service;
};

var __awaiter$1 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/** 标记 Noah 环境已完成初始化 */

var deviceReadied = false;

function voidFunction() {}
/**
 * 根据当前运行平台 Android 或 iOS，加载对应的 Noah 库
 */


function loadNoah() {
  var platfrom = isGaotuAndroid ? 'android' : 'ios';
  var url = isGaotuAndroid ? "https://cdn.gaotu100.com/m-all/noah-android1.1.js"
  /* android */
  : "https://cdn.gaotu100.com/m-all/noah-ios1.1.js"
  /* ios */
  ;
  var id = "gt-bridge-".concat(platfrom);
  return sdkLoader({
    id: id,
    url: url
  });
}
/**
 * 通过监听 deviceready 事件，等待 Noah 环境完成初始化
 */


function waitNoahReady() {
  return new Promise(function (resolve) {
    document.addEventListener('deviceready', function ready() {
      document.removeEventListener('deviceready', ready);
      deviceReadied = true;
      resolve(deviceReadied);
    }, false);
  });
}
/**
 * 初始化 js-bridge，在 exec 之前调用
 * 运行此方法时可能有三种状态：
 * 1. deviceReadied：noah 运行环境已完成初始化，此时可以直接调用 noah.exec
 * 2. noah 已加载 && 运行环境没有初始化完成：此时有 window.noah，需要通过监听 deviceready 等待 Noah 运行环境初始化
 * 3. noah 未加载：此时需要加载 Noah，然后等待 Noah 运行环境初始化
 */


function setupWebViewJavascriptBridge$1() {
  return __awaiter$1(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!deviceReadied) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", window.noah);

          case 2:
            if (!window.noah) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return waitNoahReady();

          case 5:
            return _context.abrupt("return", window.noah);

          case 6:
            _context.next = 8;
            return loadNoah();

          case 8:
            _context.next = 10;
            return waitNoahReady();

          case 10:
            return _context.abrupt("return", window.noah);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
/**
 * 调用端能力 + 绑定 Native 回调事件
 * @param action 端能力 API 名称
 * @param data 端能力参数
 * @param service 绑定的回调事件名称
 * @param callback Native -> js 回调函数
 * @param fail 回调失败事件
 */


function exec$1(action, data, service) {
  var success = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : voidFunction;
  var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : voidFunction;
  return __awaiter$1(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee2() {
    var noah, noahParams;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return setupWebViewJavascriptBridge$1();

          case 2:
            noah = _context2.sent;
            service = service || getServiceByAction(action);
            noahParams = data ? [data] : [];
            noah.exec(success, fail, service.toLowerCase(), action, noahParams);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
/**
 * noah 版本调用端能力（兼容老版本）
 * @param action 端能力 API 名称
 * @param data 端能力参数
 * @param service 绑定的回调事件名称
 */


function doCall$1(action, data) {
  var service = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  exec$1(action, data, service);
}

var bridge$1 = {
  exec: exec$1,
  doCall: doCall$1
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * 初始化 jsBridge，获取 jsBridge 实例
 * @param callback 初始化 jsBridge 后的回调事件，回调参数为 jsBridge 实例
 */

function setupWebViewJavascriptBridge() {
  return new Promise(function (resolve) {
    if (window.gaotuJSBridge) {
      return resolve(window.gaotuJSBridge);
    }

    if (window.WebViewJavascriptBridge) {
      return resolve(window.WebViewJavascriptBridge);
    }

    function callback() {
      return resolve(window.WebViewJavascriptBridge);
    }

    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }

    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      return document.documentElement.removeChild(WVJBIframe);
    });
  });
}
/**
 * 调用端能力 API (js -> Native)
 * @param name 端能力 API 名称
 * @param data 端能力参数
 * @param callback 回调事件（注：仅 iOS 有效）
 */


function callhandler(name, data, callback) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
    var bridge;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return setupWebViewJavascriptBridge();

          case 2:
            bridge = _context.sent;
            isAndroid$1 && bridge[name](JSON.stringify(data));
            isIOS$1 && bridge.callHandler(name, data, callback);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
/**
 * 绑定 Native 回调事件（Native -> js）
 * @param name 绑定的回调事件名称
 * @param callback 回调函数
 */


function registerhandler(name, callback) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee2() {
    var bridge;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return setupWebViewJavascriptBridge();

          case 2:
            bridge = _context2.sent;
            addFunc(_defineProperty$1({}, name, callback));
            isIOS$1 && bridge.registerHandler(name, function registerCallback(data, responseCallback) {
              callback(data, responseCallback);
            });

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
/**
 * 调用端能力 + 绑定 Native 回调事件
 * @param action 端能力 API 名称
 * @param data 端能力参数
 * @param service 绑定的回调事件名称
 * @param callback Native -> js 回调函数
 * @param fail 回调失败事件
 */


function exec(action, data, service, callback) {
  if (service && callback) {
    registerhandler(service, callback);
  }

  callhandler(action, data);
}
/**
 * 调用端能力
 * @param action 端能力 API 名称
 * @param data 端能力参数
 */


function doCall(action) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  callhandler(action, params);
}

var bridgeOld = {
  doCall: doCall,
  exec: exec,
  callhandler: callhandler,
  registerhandler: registerhandler
};

var jsBridge = isNoah$1 ? bridge$1 : bridgeOld;
var bridge = {
  /**
   * 在 window/window.Hybrid 上绑定 native 回调事件
   * @param functionObject 回调事件的 key-value 对象
   * @example addFunc({'rightButtonClickCallback', () => console.log('right button clicked')})
   */
  addFunc: addFunc,

  /**
   * jsBridge 实例
   */
  jsBridge: jsBridge,

  /**
   * 调用端能力 + 绑定 Native 回调事件
   * @param action 端能力 API 名称
   * @param data 端能力参数
   * @param service 绑定的回调事件名称
   * @param callback Native -> js 回调函数
   * @param fail 回调失败事件
   */
  exec: jsBridge.exec,

  /**
   * 调用端能力
   * @param action 端能力 API 名称
   * @param data 端能力参数
   * @param service ation 对应的 service（仅新版本需要）
   */
  doCall: function doCall(action, data, service) {
    if (isGaotuApp) {
      jsBridge.doCall(action, data, service);
    }
  },

  /**
   * 调用端能力 API (js -> Native)
   * @param name 端能力 API 名称
   * @param data 端能力参数
   * @param callback 回调事件（注：仅 iOS 有效）
   */
  callhandler: function callhandler(name, data) {
    if (isGaotuApp && !isNoah$1) {
      bridgeOld.callhandler(name, data);
    }
  },

  /**
   * 绑定 Native 回调事件（Native -> js）
   * @param name 绑定的回调事件名称
   * @param callback 回调函数
   */
  registerhandler: function registerhandler(name, callback) {
    if (isGaotuApp && !isNoah$1) {
      bridgeOld.registerhandler(name, callback);
    }
  }
};

var u$1 = navigator.userAgent;
var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']; // Android终端

var isAndroid = u$1.indexOf('Android') > -1 || u$1.indexOf('Adr') > -1; // IOS终端

var isIOS = !!u$1.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 微信客户端

var isWX = u$1.indexOf('MicroMessenger') > -1; // 高途/途途移动客户端

var isMobileClient = u$1.indexOf('gaotuapp') > -1;
var isTutuClient = isMobileClient && u$1.indexOf('/tutu') > -1;
var isGaotuClient = isMobileClient && u$1.indexOf('/gaotu', u$1.indexOf('gaotuapp')) > -1; // 是否是移动终端(h5浏览器及APP)

var isMobile = Agents.some(function (platform) {
  return u$1.indexOf(platform) > 0;
}); // pc端

var isPC = Agents.every(function (platform) {
  return u$1.indexOf(platform) < 0;
}); // 是否是 cordova

var isNoah = /noah/i.test(u$1);

var getAppVersion = function getAppVersion() {
  var index = u$1.indexOf('gaotuapp');

  if (index > -1) {
    var appVersionStr = u$1.slice(index);
    return appVersionStr.split('/')[1];
  }

  return '0';
};

var appVersion = getAppVersion();
var appVersionsplit = appVersion.split('.'); // 比较app版本，当前版本高于传入version，返回true，否则返回false
// 如果本地版本号只有两位，例如：0.8，这种情况只比较的前两位参数最后一个参数不论是多少都会返回true

function compareVersion(head, mid, back) {
  var headNum = +appVersionsplit[0];
  var midNum = +appVersionsplit[1];
  var backNum = parseInt(appVersionsplit[2], 10);

  if (headNum > head) {
    return true;
  }

  if (headNum === head && midNum > mid) {
    return true;
  }

  if (headNum === head && midNum === mid && backNum >= back) {
    return true;
  }

  return false;
} // 高途：4.52.0及以上，途途：4.40.0及以上 的iOS 可以从相册上传视频

var SHOW_IOS_ALBUM = isIOS && !(isTutuClient && !compareVersion(4, 40, 0) || isGaotuClient && !compareVersion(4, 52, 0)); // 高途、途途 > 4.24.19，精品或其他APP为true；低版本途途/高途APP，或PC端返回false

var judgeNewVersion = function judgeNewVersion() {
  return isMobileClient && (isGaotuClient || isTutuClient ? compareVersion(4, 24, 20) : true);
}; // 直接调起相机多张上传图片功能（以下三个可以支持，目前业务只有途途使用）
// 高途v4.59.0
// 高中v4.57.0
// 途途v4.47.0
// 安卓版本号升一个版本（修复问题）


var judgeTokePhotos = function judgeTokePhotos() {
  return isTutuClient && (isAndroid ? compareVersion(4, 48, 0) : compareVersion(4, 47, 0));
};

var CAN_TOKE_PHOTOS = judgeTokePhotos();
var isNewVersion = judgeNewVersion();

function registerHanler(callbackName, handler) {
  if (isWX) {
    console.warn('已拦截在微信环境中注册端能力回调函数方法(registerHanler)的调用');
    return;
  }

  if (isAndroid) {
    // @ts-ignore
    window[callbackName] = function (data) {
      handler(data);
    };
  } // 老版本 IOS 要调用 bridge 上的registerhandler方法注册回调
  // IOS Cordova 版本只需要回调中进行相关操作即可，无需注册
  else if (isIOS) {
    if (isNoah) {
      bridge.addFunc({
        callbackName: function callbackName(data, responseCallback) {
          handler(data, responseCallback);
        }
      });
    } else {
      // @ts-ignore
      bridge.jsBridge.registerhandler(callbackName, function (data, responseCallback) {
        handler(data, responseCallback);
      });
    }
  }
}

var EScreenOrientation;

(function (EScreenOrientation) {
  EScreenOrientation[EScreenOrientation["LANDSCAPE"] = 1] = "LANDSCAPE";
  EScreenOrientation[EScreenOrientation["PORTRAIT"] = 2] = "PORTRAIT";
})(EScreenOrientation || (EScreenOrientation = {})); // 函数重载，这里相当于端能力的接口文档
// export function callNative(payload: {
//     apiName: ENativeApi.GOTOPLAY_VIDEO;
//     params: {
//         screenOrientation?: EScreenOrientation;
//         videoUrl: string;
//         playProgress: number;
//     };
// } | {
//     apiName: ENativeApi.PREVIEW_IMAGE;
//     params: {
//         imageURL: string;
//     };
//     serviceName: EServiceNames.GT_CAMERA;
// } |
// {
//     apiName: ENativeApi.OPEN_CAMERA;
//     callbackName: ENativeCBNames.NATIVE_UPLOAD_CB;
//     callback: (fileItem: INativeFile) => void;
// } |
// {
//     apiName: ENativeApi.RECORD_AUDIO;
//     callbackName: ENativeCBNames.NATIVE_UPLOAD_CB;
//     callback: (fileItem: INativeFile) => void;
// } |
// {
//     apiName: ENativeApi.GET_ALBUM;
//     callbackName: ENativeCBNames.NATIVE_UPLOAD_CB;
//     callback: (fileItem: INativeFile) => void;
// } | {
//     apiName: ENativeApi.SHOW_UPLOAD_IMAGE;
//     callbackName: ENativeCBNames.UPLOAD_IMG_CB;
//     callback: LoadedCallback;
// }): void;


function callNative(payload) {
  if (isWX) {
    console.warn('已拦截在微信环境中端能力调用函数(callNative)的调用');
    return;
  }

  var apiName = payload.apiName,
      params = payload.params,
      callbackName = payload.callbackName,
      callback = payload.callback,
      serviceName = payload.serviceName;
  callbackName && callback && registerHanler(callbackName, callback); // 只有是 IOS 并且 是Cordova 才支持 Promise 风格的调用

  if (isNoah) {
    bridge.exec(apiName, params, serviceName, callback);
  } else {
    bridge.doCall(apiName, params, serviceName);
  }

  footPrintDetailReport({
    detailAction: "".concat(apiName, "\u7AEF\u80FD\u529B\u5DF2\u8C03\u7528")
  });
}
function paramCallbackCallNative(payload) {
  if (isWX) {
    console.warn('已拦截在微信环境中端能力调用函数(paramCallbackCallNative)的调用');
    return;
  }

  var apiName = payload.apiName,
      params = payload.params,
      callbackName = payload.callbackName,
      callback = payload.callback,
      serviceName = payload.serviceName;
  callbackName && callback && registerHanler(callbackName, callback); // 只有是 IOS 并且 是Cordova 才支持 Promise 风格的调用

  if (isNoah) {
    bridge.exec(apiName, params, serviceName, callback);
  } else if (isAndroid) {
    bridge.doCall(apiName, params, serviceName);
  } else {
    // @ts-ignore
    bridge.jsBridge.callhandler(apiName, params, callback);
  }

  footPrintDetailReport({
    detailAction: "".concat(apiName, "\u7AEF\u80FD\u529B\u5DF2\u8C03\u7528")
  });
}
/**
 * @author chenbaijin
 * @desp 为了避免callback hell封装了promise风格的调用方式
 * @desp 但是不能完全取代callNative，因为promise风格的回调只能调用一次，而有的端能力的回调是要多次调用的
 */

var promisifiedCallNative = function promisifiedCallNative(payload) {
  return new Promise(function (resolve, reject) {
    var apiName = payload.apiName,
        params = payload.params,
        callbackName = payload.callbackName,
        maxWaitTime = payload.maxWaitTime;

    if (isWX) {
      console.warn('已拦截在微信环境中端能力调用函数(promisifiedCallNative)的调用');
      reject(new Error('微信环境中不可调用端能力'));
    }

    if (exit(maxWaitTime)) {
      setTimeout(reject, maxWaitTime);
    }

    if (isAndroid) {
      // @ts-ignore
      window[callbackName] = function (data) {
        resolve(data);
      }; // @ts-ignore


      bridge.doCall(apiName, params);
    } else {
      if (isNoah) {
        bridge.addFunc({
          callbackName: function callbackName(data) {
            resolve(data);
          }
        }); // @ts-ignore

        bridge.exec(apiName, params, '', function (data) {
          resolve(data);
        });
      } else {
        // @ts-ignore
        bridge.jsBridge.registerhandler(callbackName, function (data) {
          resolve(data);
        }); // @ts-ignore

        bridge.jsBridge.callhandler(apiName, params, function (payload) {
          resolve(payload);
        });
      }
    }

    footPrintDetailReport({
      detailAction: "".concat(apiName, "\u7AEF\u80FD\u529B\u5DF2\u8C03\u7528")
    });
  });
};

var ECallNativeAudioTypes;

(function (ECallNativeAudioTypes) {
  ECallNativeAudioTypes[ECallNativeAudioTypes["START"] = 1] = "START";
  ECallNativeAudioTypes[ECallNativeAudioTypes["RECOVER"] = 2] = "RECOVER";
  ECallNativeAudioTypes[ECallNativeAudioTypes["PAUSE"] = 3] = "PAUSE";
  ECallNativeAudioTypes[ECallNativeAudioTypes["STOP"] = 4] = "STOP";
})(ECallNativeAudioTypes || (ECallNativeAudioTypes = {}));

var ENativeAudioStatus$1;

(function (ENativeAudioStatus) {
  ENativeAudioStatus[ENativeAudioStatus["STARTED"] = 1] = "STARTED";
  ENativeAudioStatus[ENativeAudioStatus["FINISHED"] = 2] = "FINISHED";
  ENativeAudioStatus[ENativeAudioStatus["FIALED"] = 3] = "FIALED";
  ENativeAudioStatus[ENativeAudioStatus["INVALID"] = 4] = "INVALID";
})(ENativeAudioStatus$1 || (ENativeAudioStatus$1 = {})); // eslint-disable-next-line


function stopNativeAudio(nativeAudioPlayStateRef, nativeAudioProgressRef) {
  return promisifiedCallNative({
    apiName: ENativeApi.OPERATE_NATIVE_AUDIO,
    params: {
      type: ECallNativeAudioTypes.STOP
    },
    callbackName: ENativeCBNames.OPERATE_NATIVE_AUDIO_CB
  }).then(function () {
    footPrintDetailReport({
      detailAction: '成功收到结束播放的回调'
    });

    if (nativeAudioPlayStateRef) {
      nativeAudioPlayStateRef.current = false;
    }

    if (nativeAudioProgressRef) {
      // console.log(nativeAudioProgressRef, '清除函数里是否清零？nativeAudioProgressRef===');
      nativeAudioProgressRef.current = 0;
    }
  }).catch(function () {
    footPrintDetailReport({
      detailAction: '结束播放回调异常'
    });
  });
}
function clearNativeAudio() {
  try {
    footPrintDetailReport({
      detailAction: '供业务使用的停止播放音频端能力被调用'
    });
    paramCallbackCallNative({
      apiName: ENativeApi.OPERATE_NATIVE_AUDIO,
      params: {
        type: ECallNativeAudioTypes.STOP
      },
      callbackName: ENativeCBNames.OPERATE_NATIVE_AUDIO_CB
    });
  } catch (e) {
    // eslint-disable-next-line
    console.log("\u4F9B\u4E1A\u52A1\u4F7F\u7528\u7684\u505C\u6B62\u64AD\u653E\u97F3\u9891\u7AEF\u80FD\u529B\u5931\u8D25\uFF0C\u62A5\u9519\u4FE1\u606F\uFF1A".concat(e));
    footPrintDetailReport({
      detailAction: '停止播放音频端能力失败',
      actionValue: "".concat(e)
    });
  }
}
function autoPlayAudio(params) {
  var url = params.url,
      callback = params.callback;
  paramCallbackCallNative({
    apiName: ENativeApi.OPERATE_NATIVE_AUDIO,
    callbackName: ENativeCBNames.OPERATE_NATIVE_AUDIO_CB,
    params: {
      type: ECallNativeAudioTypes.START,
      url: url // url: 'https://speech-ws-test.gsxcdn.com/39449a4e-e9f3-4824-b8dc-37115db92e45.mp3'
      // url: 'https://jyimgs.gsxcdn.com/be/base/test/20210315/37950634531667968.mp3'

    },
    callback: callback
  });
}
function betterAutoPlayAudio(params) {
  var url = params.url,
      onStarted = params.onStarted,
      onFinshed = params.onFinshed,
      onFailed = params.onFailed;

  function handleCallback(payload) {
    var status = payload.status,
        duration = payload.duration;

    if (status === ENativeAudioStatus$1.STARTED) {
      onStarted === null || onStarted === void 0 ? void 0 : onStarted({
        duration: duration
      });
      return;
    }

    if (status === ENativeAudioStatus$1.FINISHED) {
      onFinshed === null || onFinshed === void 0 ? void 0 : onFinshed();
      return;
    }

    if (status === ENativeAudioStatus$1.INVALID) {
      onFailed === null || onFailed === void 0 ? void 0 : onFailed('URL不合法');
      return;
    }

    if (status === ENativeAudioStatus$1.FIALED) {
      onFailed === null || onFailed === void 0 ? void 0 : onFailed('未知错误');
    }
  }

  paramCallbackCallNative({
    apiName: ENativeApi.OPERATE_NATIVE_AUDIO,
    callbackName: ENativeCBNames.OPERATE_NATIVE_AUDIO_CB,
    params: {
      type: ECallNativeAudioTypes.START,
      url: url // url: 'https://speech-ws-test.gsxcdn.com/39449a4e-e9f3-4824-b8dc-37115db92e45.mp3'
      // url: 'https://jyimgs.gsxcdn.com/be/base/test/20210315/37950634531667968.mp3'

    },
    callback: handleCallback
  });
}

var ESpeakGenerateFileTypes;

(function (ESpeakGenerateFileTypes) {
  ESpeakGenerateFileTypes[ESpeakGenerateFileTypes["WAV"] = 1] = "WAV"; // eslint-disable-next-line

  ESpeakGenerateFileTypes[ESpeakGenerateFileTypes["MP3"] = 5] = "MP3";
})(ESpeakGenerateFileTypes || (ESpeakGenerateFileTypes = {})); // 端能力语音评测的默认配置


var speakSDKConfig = {
  limitTime: 60,
  tolerable_silence_in_second: 60,
  detect_reading_completed: false
};
var EVoiceStatus;

(function (EVoiceStatus) {
  EVoiceStatus[EVoiceStatus["TAPE_START"] = 1] = "TAPE_START";
  EVoiceStatus[EVoiceStatus["TAPE_FINISH"] = 2] = "TAPE_FINISH";
})(EVoiceStatus || (EVoiceStatus = {}));

var ESpeakResulCode;

(function (ESpeakResulCode) {
  ESpeakResulCode[ESpeakResulCode["SUCCESS_FINISH"] = 1] = "SUCCESS_FINISH";
  ESpeakResulCode[ESpeakResulCode["ERROR"] = 2] = "ERROR";
  ESpeakResulCode[ESpeakResulCode["UN_AUTHORIZATION"] = 3] = "UN_AUTHORIZATION";
})(ESpeakResulCode || (ESpeakResulCode = {}));

var ESpeakEvaluteTypes;

(function (ESpeakEvaluteTypes) {
  ESpeakEvaluteTypes[ESpeakEvaluteTypes["START"] = 1] = "START";
  ESpeakEvaluteTypes[ESpeakEvaluteTypes["STOP"] = 2] = "STOP";
})(ESpeakEvaluteTypes || (ESpeakEvaluteTypes = {}));

var ELangTypes;

(function (ELangTypes) {
  ELangTypes[ELangTypes["ENGLISH"] = 0] = "ENGLISH";
  ELangTypes[ELangTypes["CHINESE"] = 1] = "CHINESE";
})(ELangTypes || (ELangTypes = {}));

var ESpeechQuestionTypes;

(function (ESpeechQuestionTypes) {
  ESpeechQuestionTypes[ESpeechQuestionTypes["BASIC"] = 0] = "BASIC";
  ESpeechQuestionTypes[ESpeechQuestionTypes["FOLLOW"] = 1] = "FOLLOW";
  ESpeechQuestionTypes[ESpeechQuestionTypes["POETRY"] = 2] = "POETRY";
})(ESpeechQuestionTypes || (ESpeechQuestionTypes = {}));

var EAudioSDKFeedBackStatus;

(function (EAudioSDKFeedBackStatus) {
  EAudioSDKFeedBackStatus["\u97F3\u9891\u683C\u5F0F\u9519\u8BEF"] = "INVALID_AUDIO_FORMAT";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u97F3\u9891"] = "INVALID_AUDIO";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u7684\u9898\u76EE\u4FE1\u606F"] = "INVALID_CONTENT";
  EAudioSDKFeedBackStatus["\u65E0\u6548\u7684Option\u4FE1\u606F"] = "INVALID_OPTIONS";
  EAudioSDKFeedBackStatus["\u8C03\u7528\u6253\u5206\u5E93\u9519\u8BEF"] = "INVALID_EVOKE_ORDER";
  EAudioSDKFeedBackStatus["\u7A7A\u97F3\u9891"] = "EMPTY_AUDIO";
  EAudioSDKFeedBackStatus["\u81EA\u52A8\u68C0\u6D4B\u5230\u6717\u8BFB\u7ED3\u675F\u5E76\u8FD4\u56DE"] = "READING_COMPLETED";
  EAudioSDKFeedBackStatus["\u68C0\u6D4B\u5230\u9759\u97F3\u7ED3\u675F"] = "NOISE_TO_THE_END";
  EAudioSDKFeedBackStatus["\u672A\u77E5\u9519\u8BEF"] = "UNKOWN_ERROR";
  EAudioSDKFeedBackStatus["\u6B63\u5E38\u7ED3\u675F"] = "NORMAL_FINISHED";
  EAudioSDKFeedBackStatus["\u5B9E\u65F6\u8FD4\u56DE\u7ED3\u679C"] = "NORMAL_PARTIAL_FEEDBACK";
  EAudioSDKFeedBackStatus["\u957F\u65F6\u95F4\u505C\u987F"] = "LONG_PAUSE_DETECTED";
})(EAudioSDKFeedBackStatus || (EAudioSDKFeedBackStatus = {}));

var EAudioWebFeedBackStatus;

(function (EAudioWebFeedBackStatus) {
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID"] = 0] = "INVALID";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID_AUDIO_FORMAT"] = 1] = "INVALID_AUDIO_FORMAT";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID_AUDIO"] = 2] = "INVALID_AUDIO";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID_CONTENT"] = 3] = "INVALID_CONTENT";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID_OPTIONS"] = 4] = "INVALID_OPTIONS";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["INVALID_EVOKE_ORDER"] = 5] = "INVALID_EVOKE_ORDER";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["EMPTY_AUDIO"] = 6] = "EMPTY_AUDIO";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["READING_COMPLETED"] = 7] = "READING_COMPLETED";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["NOISE_TO_THE_END"] = 8] = "NOISE_TO_THE_END";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["UNKOWN_ERROR"] = 9] = "UNKOWN_ERROR";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["NORMAL_FINISHED"] = 10] = "NORMAL_FINISHED";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["NORMAL_PARTIAL_FEEDBACK"] = 11] = "NORMAL_PARTIAL_FEEDBACK";
  EAudioWebFeedBackStatus[EAudioWebFeedBackStatus["LONG_PAUSE_DETECTED"] = 12] = "LONG_PAUSE_DETECTED";
})(EAudioWebFeedBackStatus || (EAudioWebFeedBackStatus = {}));
/**
 * 单词维度的判题结果
 * @author chenbaijin
 * @property 调用App封装的AI判题的接口，app的文档：https://wiki.baijia.com/pages/viewpage.action?pageId=105358694
 */


function callNativeSpeakEvalute(props) {
  var speakType = props.speakType,
      _a = props.type,
      type = _a === void 0 ? ESpeakGenerateFileTypes.MP3 : _a,
      lang = props.lang,
      question_type = props.question_type,
      callback = props.callback,
      questionId = props.questionId,
      content = props.content,
      _b = props.detect_reading_completed,
      detect_reading_completed = _b === void 0 ? false : _b,
      targetUser = props.targetUser;
  paramCallbackCallNative({
    apiName: ENativeApi.SPEAK_EVALUTE,
    params: _assign$4(_assign$4({}, speakSDKConfig), {
      speakType: speakType,
      type: type,
      lang: lang,
      question_type: question_type,
      questionId: questionId,
      content: content,
      detect_reading_completed: detect_reading_completed,
      target_user: targetUser
    }),
    callbackName: ENativeCBNames.SPEAK_EVALUTE_CB,
    callback: callback
  });
}
function startSpeakEvalute(props) {
  var _a = props.speakType,
      speakType = _a === void 0 ? ESpeakEvaluteTypes.START : _a,
      _b = props.type,
      type = _b === void 0 ? ESpeakGenerateFileTypes.MP3 : _b,
      _c = props.lang,
      lang = _c === void 0 ? 0 : _c,
      _d = props.question_type,
      question_type = _d === void 0 ? 0 : _d,
      content = props.content,
      onStarted = props.onStarted,
      onFinished = props.onFinished,
      onResult = props.onResult,
      onFailed = props.onFailed,
      _e = props.detect_reading_completed,
      detect_reading_completed = _e === void 0 ? false : _e;

  function handleJudgeCallback(payload) {
    // eslint-disable-next-line
    if (!payload) {
      // onFailed('没有参数');
      return;
    }

    var voiceStatus = payload.voiceStatus,
        resultCode = payload.resultCode,
        dataResult = payload.dataResult,
        appSdkCode = payload.appSdkCode; // eslint-disable-next-line

    console.log(voiceStatus, resultCode, dataResult, appSdkCode, '录音端能力的回调');

    if (+voiceStatus === 1) {
      onStarted();
    }

    if (+resultCode === 1) {
      onResult({
        dataResult: dataResult
      });
    }

    if (+resultCode === 2) {
      onFailed({
        appSdkCode: appSdkCode
      });
    }

    if (+voiceStatus === 2) {
      onFinished();
    }
  }

  paramCallbackCallNative({
    apiName: ENativeApi.SPEAK_EVALUTE,
    params: _assign$4(_assign$4({}, speakSDKConfig), {
      speakType: speakType,
      type: type,
      lang: lang,
      question_type: question_type,
      content: content,
      detect_reading_completed: detect_reading_completed
    }),
    callbackName: ENativeCBNames.SPEAK_EVALUTE_CB,
    callback: handleJudgeCallback
  });
}
function finishSpeakEvalute(props) {
  var onStarted = props.onStarted,
      onFinished = props.onFinished,
      onResult = props.onResult,
      onFailed = props.onFailed;

  function handleJudgeCallback(payload) {
    // eslint-disable-next-line
    if (!payload) {
      // onFailed('没有参数');
      return;
    }

    var voiceStatus = payload.voiceStatus,
        resultCode = payload.resultCode,
        dataResult = payload.dataResult,
        appSdkCode = payload.appSdkCode; // eslint-disable-next-line

    console.log(voiceStatus, resultCode, dataResult, appSdkCode, '录音端能力的回调');

    if (+voiceStatus === 1) {
      onStarted();
    }

    if (+resultCode === 1) {
      onResult({
        dataResult: dataResult
      });
    }

    if (+resultCode === 2) {
      onFailed({
        appSdkCode: appSdkCode
      });
    }

    if (+voiceStatus === 2) {
      onFinished();
    }
  }

  paramCallbackCallNative({
    apiName: ENativeApi.SPEAK_EVALUTE,
    params: {
      speakType: ESpeakEvaluteTypes.STOP
    },
    callbackName: ENativeCBNames.SPEAK_EVALUTE_CB,
    callback: handleJudgeCallback
  });
}

var audioAvaluteExceptionReport$3 = function audioAvaluteExceptionReport(errorMsg) {
  sentryReport('语音评测端能力异常', {
    extras: {
      errorMsg: errorMsg
    }
  });
}; // [IPrivilegeRes, null] | [null | string]


function getTapePrivilege() {
  return __awaiter$2(this, void 0, void 0, function () {
    var privilegeRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , promisifiedCallNative({
            apiName: ENativeApi.CHECK_INDICATE_PRIVILEGE,
            params: {
              type: EAuthorityTypes.AUDIO
            },
            callbackName: ENativeCBNames.GET_AUTHORITY_CB,
            maxWaitTime: 10000
          })];

        case 1:
          privilegeRes = _a.sent();

          if ((privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']) === false) {
            audioAvaluteExceptionReport$3('端能力结果表示用户拒绝权限');
          }

          return [2
          /*return*/
          , privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']];

        case 2:
          _a.sent();
          audioAvaluteExceptionReport$3('请求权限超时，导致无法录音');
          return [2
          /*return*/
          , null];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

var handlePhoneticSymbols = function handlePhoneticSymbols(phoneticSymbols) {
  if (phoneticSymbols === null || phoneticSymbols === void 0 ? void 0 : phoneticSymbols.startsWith('/')) {
    return "/ ".concat(phoneticSymbols.slice(1, -1), " /");
  }

  return phoneticSymbols;
};
var audioAvaluteExceptionReport$2 = function audioAvaluteExceptionReport(errorMsg) {
  sentryReport('语音评测能力异常', {
    extras: {
      errorMsg: errorMsg
    }
  });
  footPrintJSErrorReport({
    // detailAction: '',
    actionValue: "\u8BED\u97F3\u8BC4\u6D4B\u80FD\u529B\u5F02\u5E38:".concat(errorMsg)
  });
};
var stringToInnerHTML = function stringToInnerHTML(rawString, target, nodeStr) {
  if (rawString && target && nodeStr && target instanceof RegExp && target.test(rawString)) {
    // 过滤潜在的xss攻击风险
    var scriptReg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    var purified = rawString === null || rawString === void 0 ? void 0 : rawString.replace(scriptReg, '');
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-danger
      React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: purified === null || purified === void 0 ? void 0 : purified.replace(target, nodeStr)
        }
      })
    );
  }

  return rawString;
};

var style$16 = {"text-stem":"tangram_C_text-stem_626c124547"};

/**
 * 题目组件语境下一般用于展示注释/翻译/引导语，用灰色展示
 */

var Annotation = function Annotation(props) {
  var text = props.text,
      fontSize = props.fontSize,
      color = props.color,
      _a = props.columnPadding,
      columnPadding = _a === void 0 ? 0 : _a,
      _b = props.rowPadding,
      rowPadding = _b === void 0 ? 0 : _b,
      otherStyles = props.otherStyles;
  return /*#__PURE__*/React.createElement("div", {
    className: style$16['text-stem'],
    style: _assign$4({
      fontSize: fontSize,
      color: color,
      padding: "".concat(columnPadding, "px ").concat(rowPadding, "px")
    }, otherStyles)
  }, stringToInnerHTML(text, /\n/g, '<br />'));
};

var style$15 = {"container":"tangram_C_container_351ea04a27","recite-content":"tangram_C_recite-content_351ea04a27","blank":"tangram_C_blank_351ea04a27","syllable":"tangram_C_syllable_351ea04a27","word":"tangram_C_word_351ea04a27","good":"tangram_C_good_351ea04a27","bad":"tangram_C_bad_351ea04a27"};

var styledClassNames$8 = bind.bind(style$15);
var PRONUNCIATION_GOOD_LINE$1 = 75;
var PRONUNCIATION_PASS_LINE$1 = 50;
var wordId$1 = 0;

var AtomJudge$1 = function AtomJudge(props) {
  var base_info = props.atomJudge.base_info;
  return /*#__PURE__*/React.createElement("span", {
    className: styledClassNames$8('word', {
      good: (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) && (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) > PRONUNCIATION_GOOD_LINE$1,
      bad: (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) && (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) < PRONUNCIATION_PASS_LINE$1
    })
  }, base_info === null || base_info === void 0 ? void 0 : base_info.text_content);
};

var Words$1 = function Words(props) {
  var wordInfo = props.wordInfo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AtomJudge$1, {
    atomJudge: wordInfo
  }), /*#__PURE__*/React.createElement("span", {
    className: style$15.blank
  }, "\xA0"));
};

var HandledReadContent = function HandledReadContent(props) {
  var item = props.item;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: style$15.word
  }, item), /*#__PURE__*/React.createElement("span", {
    className: style$15.blank
  }, "\xA0"));
};

var ReadContent = function ReadContent() {
  var _a, _b;

  var _c = useContext(FollowReadContext),
      currentSentenceInfo = _c.currentSentenceInfo,
      currentResult = _c.currentResult;

  var judgeResultJson = currentResult === null || currentResult === void 0 ? void 0 : currentResult.judgeResultJson;
  var judgeResult = judgeResultJson ? parseJSON(judgeResultJson) : null;
  var readContent = currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.original;
  var noBlankContent = readContent === null || readContent === void 0 ? void 0 : readContent.split(' ');
  return /*#__PURE__*/React.createElement("div", {
    className: style$15.container
  }, /*#__PURE__*/React.createElement("div", {
    className: style$15['recite-content']
  }, ((_a = judgeResult === null || judgeResult === void 0 ? void 0 : judgeResult.word_infos) === null || _a === void 0 ? void 0 : _a.length) && ((_b = judgeResult === null || judgeResult === void 0 ? void 0 : judgeResult.word_infos) === null || _b === void 0 ? void 0 : _b.length) > 0 ? judgeResult.word_infos.map(function (wordInfo) {
    return /*#__PURE__*/React.createElement(Words$1, {
      key: wordId$1++,
      wordInfo: wordInfo
    });
  }) : noBlankContent === null || noBlankContent === void 0 ? void 0 : noBlankContent.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(HandledReadContent, {
        key: item + index,
        item: item
      })
    );
  })));
};

var style$14 = {"progress-container":"tangram_C_progress-container_29006279db","progress-circle-trail":"tangram_C_progress-circle-trail_29006279db","progress-circle-path":"tangram_C_progress-circle-path_29006279db"};

var DEFAULT_RING_WIDTH = 3;
var DEFAULT_CIRCLE_WIDTH = 40;
var SVG_HALF = 50;
var SVG_WHOLE = 100;

var Progress = function Progress(props) {
  var duration = props.duration,
      _a = props.playing,
      playing = _a === void 0 ? 0 : _a,
      _b = props.ringWidth,
      ringWidth = _b === void 0 ? DEFAULT_RING_WIDTH : _b,
      _c = props.circleWidth,
      circleWidth = _c === void 0 ? DEFAULT_CIRCLE_WIDTH : _c,
      backgroundImage = props.backgroundImage,
      ringColor = props.ringColor,
      ringOpacity = props.ringOpacity,
      containerStyle = props.containerStyle; // console.log(playing, duration, 'duration===');
  // 1.strokeWidth指定路径的宽度时，默认是从中间延伸到两边的
  // 2.由于SVG的可缩放性，所以strokeWidth不能指定px而只能是百分比，所以要根据px换算成百分比

  var strokeWidth = SVG_WHOLE * ringWidth / (circleWidth + 2 * ringWidth);
  var offsetY = SVG_HALF - strokeWidth / 2;
  var perimeter = Math.PI * offsetY * 2;
  var opcity = playing === 1 ? ringOpacity ? ringOpacity >= 0 && ringOpacity <= 1 ? "".concat(ringOpacity) : '1' : '1' : '0';
  return /*#__PURE__*/React.createElement("div", {
    className: style$14['progress-container'],
    style: _assign$4({
      width: '100%',
      height: '100%',
      backgroundImage: "url(\"".concat(backgroundImage, "\")")
    }, containerStyle)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("path", {
    className: style$14['progress-circle-path'],
    // d属性用来绘制圆环
    // M 50 50表示原点移动到（50，50）坐标
    // m 0,-${offsetY}表示相对于（50，50）坐标向上偏移offsetY
    // a表示画弧线，前两个参数表示所画弧线所在的椭圆的x轴半径和y轴半径
    // 第三个参数表示椭圆在x轴的偏移量，为0表示垂直摆放
    // 第四个参数表示大角还是小角，为1表示要大弧线
    // 第五个参数表示顺时针还是逆时针画，为1表示顺时针
    // 最后两个参数表示终点坐标
    // 这里是先用a命令画了一个半弧，再用了一个a命令画了剩下的半弧
    d: "\n                        M 50,50\n                        m 0,-".concat(offsetY, "\n                        a ").concat(offsetY, " ").concat(offsetY, " 0 1 1 0 ").concat(offsetY * 2, "\n                        a ").concat(offsetY, " ").concat(offsetY, " 0 1 1 0 -").concat(offsetY * 2, "\n                    "),
    strokeLinecap: "round",
    // 弧线的宽度，svg就是画是线，设宽度后画的线就有了宽度
    // strokeWidth={playing === 1 ? strokeWidth : '0'}
    strokeWidth: strokeWidth,
    opacity: opcity,
    fillOpacity: "0",
    style: {
      // 第二个属性是间距的长度，设为周长，则不会有间距，只会展示周长*进度后的弧线
      strokeDasharray: "".concat(perimeter * playing, ", ").concat(perimeter),
      // 通过css实现音频播放进度
      transition: "stroke-dasharray ".concat(duration, "s linear 0s"),
      stroke: ringColor
    }
  })));
};

var img$j = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='%e5%9b%be%e5%b1%82_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 41 40' style='enable-background:new 0 0 41 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:%23FF3741%3b%7d .st1%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:white%3b%7d .st2%7bfill:none%3bstroke:white%3bstroke-width:2%3bstroke-linecap:round%3b%7d%3c/style%3e%3ctitle%3e%e5%8e%9f%e9%9f%b3%3c/title%3e%3cg id='%e9%a1%b5%e9%9d%a2-1'%3e %3cg id='%e8%b7%9f%e8%af%bb-%e5%bd%95%e9%9f%b3%e5%ae%8c%e6%88%90' transform='translate(-77.000000%2c -521.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3%e7%bb%84%e5%bb%ba' transform='translate(0.000000%2c 479.000000)'%3e %3cg id='%e7%bc%96%e7%bb%84-4' transform='translate(73.500000%2c 28.000000)'%3e %3cg id='%e5%8e%9f%e9%9f%b3' transform='translate(4.000000%2c 14.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2%e5%a4%87%e4%bb%bd-2' class='st0' cx='20' cy='20' r='20'/%3e %3cpath id='%e5%bd%a2%e7%8a%b6%e7%bb%93%e5%90%88' class='st1' d='M19.8%2c12.3c0.3%2c0.4%2c0.5%2c0.9%2c0.5%2c1.4v12.9c0%2c1.1-0.9%2c2-2%2c2c-0.5%2c0-1-0.2-1.4-0.5 l-3.2-2.9l-3.5%2c0c-1.1%2c0-2-0.9-2-2v-6c0-1.1%2c0.9-2%2c2-2l3.5%2c0l3.2-2.9C17.7%2c11.5%2c19%2c11.5%2c19.8%2c12.3z'/%3e %3cpath id='%e8%b7%af%e5%be%84' class='st2' d='M28.4%2c25.8c3.1-3.1%2c3.1-8.2%2c0-11.3'/%3e %3cpath id='%e8%b7%af%e5%be%84%e5%a4%87%e4%bb%bd' class='st2' d='M24.2%2c23c1.6-1.6%2c1.6-4.1%2c0-5.7'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$i = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAABblBMVEUAAAD/paX/vcH/q7H/wMP/ur7/tLb/w8b/sbH/r7L/vMD/wcT/rK7/u77/xMf/vsD/qbD/ra3/tbj/rrX/srX/q7H/wMT/////ubn/ur7/uLv/vcH/rLH/srf/r7P/s7X/rrH/t7v/pq7/p7D/qLL/t7r/rrP/srb/rrH/h43/i5H/iI7/////kpf/qKz/o6f/i5D/u77/jZL/j5T/qa7/mp//k5j/ycz/oaX/qK3/vcD/wsX/rLD/rrL/w8b/r7P/s7f/wMP/mZ7/8/P/q6//1df/t7v/tbn/x8r/wcT/qa3/l53/jpT/8PH/5+j/293/l5z//Pz/+vr/6On/kpj/9/f/naL/8fL/lJn/9/j//f3/9vb/+/v/0NL/oqf/vsH/pKj/+Pn/kZb/7/D/jpP/xsn/6er/ipD/3+H/oab/4eP/9fb/srb/5eb/n6T/tLj/jJH/6+z/p6v/pqr/k5n/tLf/vL//j5X/ysz/5+kOMkKBAAAAKXRSTlMAEfqC/ffZ/g2l+v5u9v78dyLnJtCJ/QEL+PH7NM2v0qrsSDo47LHRq7KWhzcAAANbSURBVHherZlldyIxFIYHLy20UKgX624lI7hL3V3X3d31329ugJZtSSaZ5v2Qc7/wnIRcyx3FRKFAfHbaZXd6PE67a3o2Hggp1mVzRPz985fU7484bFZoIz533zxFfW7fiCCux9s7z1Svt0fkrNGBc8B6PVUwcqqmqTmjkKqvnyMHotwnd9hbsGq+oKJLUgv5agtpd3Dhbgw2aVuNHdRd2k5jq4kcvGnOGxomuKVkFjGUTS4R4vCQCW40THC1iopMpFZqBBkeZfGC44S3YSAOGRuEOB6k8ybHyPbKiFNlssmxSRpvagJ4mSLiVjEDxIkpyv4IbzGNBJReJMSuewyS8y5oSEjaAjl1sMv9kvtYRcJaJTdz9a7DZH/Igsgew1f8GXiLmhWgRv7HoUvxBvGRSSNLSmcgZv6PQojfWhFZVLEGcd3Jc8Cmy8iyyvD7jtxjs0O8oWsIotB+kR9n4MDGdYAGHDp6nu8hP1fQtVSBHN6uCl7If9R8tVvaf1V6YQZUIT96W/UN6lGSxru1omM9f2ZGTELlatZCH+R7Wn5+clcnemgGzEJV8BGgG1sNWqA+0Ju6jczUwBg38Rmo55R69Pme3pYpcAc6AFvLqavdeY+BxAtE1ZZzRzBwuytvUxcC5jEogoF+DFzuwNxZW2lDxIAFDPIrSgj6K7WDdx8AVoAq9GYhJQD9C7rQms4Clp6+O6USoe8JKHN4rXcAV1jAR9j4+JoGrGNUXInhNdUB1M2A+ksaMIVRMSWB1wIvEB1g6/iUcSsJxYVXgxtYPMPmLwrQwCiXArk1xw0kvv6GAsxBllWc4DX8wLcQ1wy/cSoevGr8wCw2jyhADaM8osACNt+zgKJH/oDNfdaRBS9FO8HmJutSBN2mBuYnltuIOfbhEbYOWOlmWiz0trFxdsgKvVklLpIcvnzVj78hZnIQTF/q9x+Inb6kJ1j5JYAUqby0IiW/jLIL/U/hQs/diuzxtSLSmyXudm7vN187x9Nw5v6c/C3tijSc8ltiJSqpaZf+rJD98JH9NJP+eJT9vJX/AJc/IpA/xJA/ZpE/CJI/qpI/TJM/7pM/kBQfmSLWyJQ91N1evjrUXRYc6oJsMzxj5xmb9MG4/NG9/I8L4goF5mKJ9uePRGzO9PPHP7UZfKMCsNxAAAAAAElFTkSuQmCC";

/**
 * 获取强制更新能力，通常配合useRef使用
 * @author chenbaijin
 */

function useForceUpdate() {
  var _a = useState(Object.create(null)),
      dispatch = _a[1];

  var memoizedDispatch = useCallback(function () {
    dispatch(Object.create(null));
  }, [dispatch]);
  return memoizedDispatch;
}

var useAudioLoaded = function useAudioLoaded(audioRef, questionId) {
  var loaded = useRef(false);
  var forceUpdate = useForceUpdate();
  useEffect(function () {
    var audioDom = audioRef.current;

    function onLoaded() {
      footPrintDetailReport({
        detailAction: "\u8BED\u97F3\u9898\u97F3\u9891\u52A0\u8F7D\u5B8C\u6210, url:".concat(audioDom === null || audioDom === void 0 ? void 0 : audioDom.src)
      });
      loaded.current = true;
      forceUpdate();
    }

    audioDom === null || audioDom === void 0 ? void 0 : audioDom.addEventListener('loadedmetadata', onLoaded);
    return function () {
      audioDom === null || audioDom === void 0 ? void 0 : audioDom.removeEventListener('loadedmetadata', onLoaded);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
  return loaded;
};

var playingMediaDomRef = null;
/**
 * 互斥播放，当播放下一个音频时暂停上一个音频
 * @author chenbaijin
 * @param mediaDomRef 音频的ref
 * @param needEmpty 播放其他音频时是否需要清空上一个音频的播放进度
 */

var useExclusivePlay = function useExclusivePlay(mediaDomRef, needEmpty) {
  if (needEmpty === void 0) {
    needEmpty = false;
  }

  function stop() {
    var _a; // mediaDomRef !== playingMediaDomRef && playingMediaDomRef?.current?.pause();


    if (needEmpty && ((_a = playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) === null || _a === void 0 ? void 0 : _a.currentTime)) {
      playingMediaDomRef.current.currentTime = 0;
    }
  }

  useEffect(function () {
    var mediaDom = mediaDomRef === null || mediaDomRef === void 0 ? void 0 : mediaDomRef.current;

    function handlePlay() {
      var _a, _b, _c;

      if ((playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) && mediaDomRef !== playingMediaDomRef) {
        (_a = playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        footPrintDetailReport({
          detailAction: "\u5176\u4ED6\u5A92\u4F53\u64AD\u653E\u5BFC\u81F4\u7684\u6682\u505C, url:".concat((_b = playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) === null || _b === void 0 ? void 0 : _b.src)
        });
      }

      if (needEmpty && ((_c = playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) === null || _c === void 0 ? void 0 : _c.currentTime)) {
        playingMediaDomRef.current.currentTime = 0;
      }

      if (mediaDomRef) {
        playingMediaDomRef = mediaDomRef;
      }
    }

    mediaDom === null || mediaDom === void 0 ? void 0 : mediaDom.addEventListener('play', handlePlay);
    return function () {
      mediaDom === null || mediaDom === void 0 ? void 0 : mediaDom.removeEventListener('play', handlePlay);
    };
  });
  return {
    stop: stop,
    playingMediaDomRef: playingMediaDomRef
  };
};

var Sticker = function Sticker(_a) {
  var sticker = _a.sticker;
  var stickerForDisplay = useMemo(function () {
    var getCustomNode = sticker.getCustomNode,
        data = sticker.data;

    if (!getCustomNode || typeof getCustomNode !== 'function') {
      return null;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, getCustomNode(data));
  }, [sticker]);
  return stickerForDisplay;
};

var style$13 = {"exercise-wrapper":"tangram_C_exercise-wrapper_337813ad15","question-detail":"tangram_C_question-detail_337813ad15","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_337813ad15","card-title":"tangram_C_card-title_337813ad15","structure":"tangram_C_structure_337813ad15","full-blank":"tangram_C_full-blank_337813ad15","text-emphasis":"tangram_C_text-emphasis_337813ad15","table-wrapper":"tangram_C_table-wrapper_337813ad15","answer-wrapper":"tangram_C_answer-wrapper_337813ad15","sticker":"tangram_C_sticker_337813ad15","top-right":"tangram_C_top-right_337813ad15","bottom-right":"tangram_C_bottom-right_337813ad15","bottom-left":"tangram_C_bottom-left_337813ad15","top-left":"tangram_C_top-left_337813ad15","imgs-wrapper":"tangram_C_imgs-wrapper_337813ad15","img-wrapper":"tangram_C_img-wrapper_337813ad15","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_337813ad15","answer-box":"tangram_C_answer-box_337813ad15","imgs-container":"tangram_C_imgs-container_337813ad15","all-tip":"tangram_C_all-tip_337813ad15"};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1 = "function" === typeof Symbol && Symbol.for,
    c$1 = b$1 ? Symbol.for("react.element") : 60103,
    d$1 = b$1 ? Symbol.for("react.portal") : 60106,
    e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
    f$1 = b$1 ? Symbol.for("react.strict_mode") : 60108,
    g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
    h$1 = b$1 ? Symbol.for("react.provider") : 60109,
    k$1 = b$1 ? Symbol.for("react.context") : 60110,
    l$1 = b$1 ? Symbol.for("react.async_mode") : 60111,
    m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
    n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112,
    p$1 = b$1 ? Symbol.for("react.suspense") : 60113,
    q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120,
    r$1 = b$1 ? Symbol.for("react.memo") : 60115,
    t$1 = b$1 ? Symbol.for("react.lazy") : 60116,
    v$1 = b$1 ? Symbol.for("react.block") : 60121,
    w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
    x$1 = b$1 ? Symbol.for("react.responder") : 60118,
    y$1 = b$1 ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === _typeof$1(a) && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$1:
          case p$1:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A$4(a) {
  return z(a) === m$1;
}

var AsyncMode = l$1;
var ConcurrentMode = m$1;
var ContextConsumer = k$1;
var ContextProvider = h$1;
var Element$1 = c$1;
var ForwardRef = n$1;
var Fragment = e$1;
var Lazy = t$1;
var Memo = r$1;
var Portal = d$1;
var Profiler = g$1;
var StrictMode = f$1;
var Suspense = p$1;

var isAsyncMode = function isAsyncMode(a) {
  return A$4(a) || z(a) === l$1;
};

var isConcurrentMode = A$4;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k$1;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h$1;
};

var isElement = function isElement(a) {
  return "object" === _typeof$1(a) && null !== a && a.$$typeof === c$1;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n$1;
};

var isFragment = function isFragment(a) {
  return z(a) === e$1;
};

var isLazy = function isLazy(a) {
  return z(a) === t$1;
};

var isMemo = function isMemo(a) {
  return z(a) === r$1;
};

var isPortal = function isPortal(a) {
  return z(a) === d$1;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g$1;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f$1;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p$1;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === _typeof$1(a) && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof$1(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (_typeof$1(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return _typeof$1(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof$1(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof$1(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && _typeof$1(data) === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (_typeof$1(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = _typeof$1(propValue);

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = require$$2();
  }
});
var PropTypes = propTypes;

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass$1(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass$1(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass$1(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$2(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = /*#__PURE__*/React.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass$1(node, c);
  });
};

var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$2(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React.createElement(Transition$1, _extends$2({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$2({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var withHashStyle = {"stem-image":"tangram_C_stem-image_fbd07da41c","stem-answer-image":"tangram_C_stem-answer-image_fbd07da41c","shadow-img":"tangram_C_shadow-img_fbd07da41c","preview-mobile-image":"tangram_C_preview-mobile-image_fbd07da41c","preview-pc-image":"tangram_C_preview-pc-image_fbd07da41c","previews-enter":"tangram_C_previews-enter_fbd07da41c","previews-enter-active":"tangram_C_previews-enter-active_fbd07da41c","previews-enter-done":"tangram_C_previews-enter-done_fbd07da41c","previews-exit":"tangram_C_previews-exit_fbd07da41c","previews-exit-active":"tangram_C_previews-exit-active_fbd07da41c","previews-exit-done":"tangram_C_previews-exit-done_fbd07da41c"};

var Image$1 = function Image(props) {
  var style = props.style,
      source = props.source,
      imgLocation = props.imgLocation;
  var node = useRef();
  useEffect(function () {
    if (isMobileClient) {
      return;
    }

    node.current = document.createElement('div');
    document.body.appendChild(node.current);
    return function () {
      if (node.current) {
        node.current.remove();
      }
    };
  }, []);

  var imgStyle = _assign$4(_assign$4({}, style), {
    width: (style === null || style === void 0 ? void 0 : style.width) && (style === null || style === void 0 ? void 0 : style.width) !== 'auto' ? "".concat(style.width, "px") : '100%',
    borderRadius: (style === null || style === void 0 ? void 0 : style.borderRadius) ? "".concat(style.borderRadius, "px") : '0',
    margin: "".concat(imgLocation === ERichTextLocation.USER_ANSWER ? '0' : '0 2px')
  });

  if (imgLocation !== ERichTextLocation.USER_ANSWER) {
    imgStyle.height = (style === null || style === void 0 ? void 0 : style.height) && (style === null || style === void 0 ? void 0 : style.height) !== 'auto' ? "".concat(style.height, "px") : 'auto';
  }

  var ref = useRef(null);

  var _a = useState(false),
      isClickPreView = _a[0],
      setClickPreView = _a[1];

  if (!source) {
    return null;
  } // @ts-ignore


  function previewImg(event) {
    event.stopPropagation();

    if (isMobileClient) {
      try {
        callNative({
          apiName: ENativeApi.PREVIEW_IMAGE,
          params: {
            imageURL: source
          },
          serviceName: EServiceNames.GT_CAMERA
        });
      } catch (e) {
        throw new Error(JSON.stringify(e));
      }

      return;
    }

    if (isWX && wx) {
      source && window.wx.previewImage({
        current: source,
        urls: [source]
      });
      return;
    }

    setClickPreView(true);
  } // @ts-ignore


  function hideImage(event) {
    event.stopPropagation();
    setClickPreView(false);
  }

  var ImageShadow = function ImageShadow() {
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: withHashStyle['shadow-img'],
      onClick: hideImage
    }, /*#__PURE__*/React.createElement("img", {
      className: isMobile ? withHashStyle['preview-mobile-image'] : withHashStyle['preview-pc-image'],
      src: source,
      alt: "\u56FE\u7247\u52A0\u8F7D\u9519\u8BEF",
      "data-source": "exercise-ui"
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    ref: ref,
    role: "button",
    tabIndex: 0,
    onClick: previewImg,
    style: {
      width: (style === null || style === void 0 ? void 0 : style.width) ? "".concat(style.width, "px") : 'auto',
      outline: 'none'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u56FE\u7247\u52A0\u8F7D\u9519\u8BEF",
    src: source,
    className: "".concat(withHashStyle['stem-image'], "\n                        ").concat(imgLocation === ERichTextLocation.USER_ANSWER && withHashStyle['stem-answer-image']),
    style: _assign$4(_assign$4({}, style), imgStyle),
    "data-source": "exercise-ui"
  })), node.current && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(CSSTransition$1, {
    in: isClickPreView,
    timeout: {
      enter: 500,
      exit: 100
    },
    unmountOnExit: true,
    classNames: {
      enter: withHashStyle['previews-enter'],
      enterActive: withHashStyle['previews-enter-active'],
      enterDone: withHashStyle['previews-enter-done'],
      exit: withHashStyle['previews-exit'],
      exitActive: withHashStyle['previews-exit-active'],
      exitDone: withHashStyle['previews-exit-done']
    }
  }, /*#__PURE__*/React.createElement(ImageShadow, null)), node.current));
};

var style$12 = {"exercise-wrapper":"tangram_C_exercise-wrapper_8edf4372d3","question-detail":"tangram_C_question-detail_8edf4372d3","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_8edf4372d3","card-title":"tangram_C_card-title_8edf4372d3","structure":"tangram_C_structure_8edf4372d3","full-blank":"tangram_C_full-blank_8edf4372d3","text-emphasis":"tangram_C_text-emphasis_8edf4372d3","table-wrapper":"tangram_C_table-wrapper_8edf4372d3","answer-wrapper":"tangram_C_answer-wrapper_8edf4372d3","sticker":"tangram_C_sticker_8edf4372d3","top-right":"tangram_C_top-right_8edf4372d3","bottom-right":"tangram_C_bottom-right_8edf4372d3","bottom-left":"tangram_C_bottom-left_8edf4372d3","top-left":"tangram_C_top-left_8edf4372d3","imgs-wrapper":"tangram_C_imgs-wrapper_8edf4372d3","img-wrapper":"tangram_C_img-wrapper_8edf4372d3","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_8edf4372d3","answer-box":"tangram_C_answer-box_8edf4372d3","delete-icon":"tangram_C_delete-icon_8edf4372d3"};

var ImageEditor = function ImageEditor(props) {
  var editable = props.editable,
      customStyle = props.customStyle,
      content = props.content,
      _a = props.answerMode,
      answerMode = _a === void 0 ? EAnswerMode.SIGLE : _a,
      deleteCallback = props.deleteCallback; // pc隐藏统一作答图片 统一作答 + 编辑状态 + isPC + 当前作答

  if (answerMode === EAnswerMode.UNIFIED && isPC && editable) {
    return null;
  }

  function previewImage(event) {
    var source = event.currentTarget.getAttribute('img-source');
    callNative({
      apiName: ENativeApi.PREVIEW_IMAGE,
      params: {
        imageURL: source
      },
      serviceName: EServiceNames.GT_CAMERA
    });
  }

  function handleDelete(e) {
    e.stopPropagation();
    deleteCallback === null || deleteCallback === void 0 ? void 0 : deleteCallback();
  }

  return /*#__PURE__*/React.createElement("div", {
    key: content,
    "img-source": content,
    style: customStyle,
    className: "".concat(style$12['img-wrapper'], " ").concat(editable ? '' : 'img-wrapper-analyze'),
    onClick: previewImage,
    role: "button",
    tabIndex: 0
  }, isNewVersion ? /*#__PURE__*/React.createElement("img", {
    src: content,
    alt: "\u4F5C\u7B54\u56FE\u7247\u52A0\u8F7D\u9519\u8BEF",
    className: style$12['img-item'],
    "data-source": "exercise-ui"
  }) : /*#__PURE__*/React.createElement(Image$1, {
    source: content,
    imgLocation: ERichTextLocation.USER_ANSWER
  }), editable && answerMode === EAnswerMode.SIGLE && /*#__PURE__*/React.createElement("span", {
    className: style$12['delete-icon'],
    onClick: handleDelete,
    role: "button",
    tabIndex: 0
  }));
};

var ImageAnsChecker = function ImageAnsChecker(props) {
  var _a = props.editable,
      editable = _a === void 0 ? false : _a,
      answerList = props.answerList,
      _b = props.showTip,
      showTip = _b === void 0 ? false : _b,
      tipMsg = props.tipMsg,
      dispatchAnsSort = props.dispatchAnsSort;

  function handleDelete(index) {
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.DELETE,
      answerType: ESubmitType.IMAGE,
      deleteIndex: +index
    });
  }

  var isShowAllTip = showTip && (isMobile || !editable) && (answerList === null || answerList === void 0 ? void 0 : answerList.some(function (item) {
    return item.answerMode === EAnswerMode.UNIFIED;
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: style$13['imgs-container']
  }, isShowAllTip && tipMsg && /*#__PURE__*/React.createElement("span", {
    className: style$13['all-tip']
  }, tipMsg), answerList === null || answerList === void 0 ? void 0 : answerList.map(function (item, index) {
    var _a, _b;

    return /*#__PURE__*/React.createElement(ImageEditor // eslint-disable-next-line react/no-array-index-key
    , {
      // eslint-disable-next-line react/no-array-index-key
      key: (_a = item.resource) === null || _a === void 0 ? void 0 : _a.url,
      answerMode: item.answerMode,
      editable: editable,
      content: (_b = item.resource) === null || _b === void 0 ? void 0 : _b.url,
      // eslint-disable-next-line react/jsx-no-bind
      deleteCallback: function deleteCallback() {
        return handleDelete(index);
      }
    });
  }));
};

var usePlayEvent = function usePlayEvent(audioRef, onPlay, deps) {
  if (deps === void 0) {
    deps = [];
  }

  useEffect(function () {
    var audioDOM = audioRef.current;

    function handlePlay() {
      var _a;

      footPrintDetailReport({
        detailAction: "playing: \u5728\u97F3\u9891\u56E0\u7F13\u51B2\u800C\u6682\u505C\u6216\u505C\u6B62\u540E\u5DF2\u5C31\u7EEA\u65F6\u89E6\u53D1\uFF0Curl:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
      });
      onPlay === null || onPlay === void 0 ? void 0 : onPlay();
    } // 当正常播放时，根据实际的播放时间改变UI的播放进度


    audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.addEventListener('playing', handlePlay);
    return function () {
      audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.removeEventListener('playing', handlePlay);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

var minmax = function minmax(val, min, max) {
  return val < min ? min : val > max ? max : val;
}; // 根据mouse或者touch在progressBar上的位置，获取播放进度


var getCurrentPlayProgress = function getCurrentPlayProgress(curX, inititalX, progressBarWidth) {
  if (!inititalX || !progressBarWidth) {
    return 0;
  }

  var playProgress = minmax(curX - inititalX, 0, progressBarWidth) / progressBarWidth;
  return playProgress;
};
var secondToDate = function secondToDate(second) {
  var m = Math.floor(second / 60 % 60);
  var s = Math.floor(second % 60);
  m = m < 10 ? "0".concat(m) : m;
  s = s < 10 ? "0".concat(s) : s;
  return "".concat(m || '00', ":").concat(s || '00');
};
var playErrorReport = function playErrorReport(errorMsg) {
  sentryReport('播放失败', {
    extras: {
      errorMsg: errorMsg
    }
  });
  footPrintDetailReport({
    detailAction: '音频播放失败'
  });
};

var ELoadType;

(function (ELoadType) {
  ELoadType[ELoadType["LOADED"] = 0] = "LOADED";
  ELoadType[ELoadType["LOADING"] = 1] = "LOADING";
  ELoadType[ELoadType["LOAD_FAULT"] = 2] = "LOAD_FAULT";
})(ELoadType || (ELoadType = {}));

var EActionTypes$1;

(function (EActionTypes) {
  EActionTypes["TOGGLE_PLAY_STATE"] = "TOGGLE_PLAY_STATE";
  EActionTypes["PAUSE"] = "PAUSE";
  EActionTypes["UPDATE_PROGRESS"] = "UPDATE_PROGRESS";
  EActionTypes["SET_DURATION"] = "SET_DURATION";
  EActionTypes["PRESS"] = "PRESS";
  EActionTypes["PRESS_END"] = "PRESS_END";
  EActionTypes["MOVE"] = "MOVE";
  EActionTypes["SET_CURRENT_TIME"] = "SET_CURRENT_TIME";
  EActionTypes["REINIT"] = "REINIT";
  EActionTypes["INIT"] = "INIT";
  EActionTypes["LOAD"] = "LOAD";
})(EActionTypes$1 || (EActionTypes$1 = {}));

var EStateTypes;

(function (EStateTypes) {
  EStateTypes["INITIAL"] = "INITIAL";
  EStateTypes["PLAYING"] = "PLAYING";
  EStateTypes["PAUSED"] = "PAUSED";
  EStateTypes["DRAGGING"] = "DRAGGING";
})(EStateTypes || (EStateTypes = {})); // eslint-disable-next-line complexity


function reducer(state, action) {
  var _a, _b;

  switch (action.actionType) {
    case EActionTypes$1.TOGGLE_PLAY_STATE:
      return _assign$4(_assign$4({}, state), {
        stateType: state.stateType === EStateTypes.INITIAL || state.stateType === EStateTypes.PAUSED ? EStateTypes.PLAYING : EStateTypes.PAUSED
      });

    case EActionTypes$1.PAUSE:
      return _assign$4(_assign$4({}, state), {
        stateType: EStateTypes.PAUSED
      });

    case EActionTypes$1.UPDATE_PROGRESS:
      if (state.stateType === EStateTypes.PAUSED) {
        return state;
      }

      return _assign$4(_assign$4({}, state), {
        playProgress: action.playProgress,
        UICurrentTime: action.UICurrentTime
      });

    case EActionTypes$1.SET_DURATION:
      return _assign$4(_assign$4({}, state), {
        duration: action.duration,
        loading: action.loading
      });

    case EActionTypes$1.PRESS:
      return _assign$4(_assign$4({}, state), {
        stateTypeBeforeDown: state.stateType,
        stateType: EStateTypes.PAUSED,
        playProgress: action.playProgress,
        indicatorDown: true,
        UICurrentTime: action.UICurrentTime
      });

    case EActionTypes$1.MOVE:
      if (state.indicatorDown) {
        return _assign$4(_assign$4({}, state), {
          stateType: EStateTypes.PAUSED,
          playProgress: action.playProgress,
          UICurrentTime: action.UICurrentTime
        });
      }

      return state;

    case EActionTypes$1.PRESS_END:
      if (action.progressBarWidth && ((_a = action.audioRef) === null || _a === void 0 ? void 0 : _a.current)) {
        var duration = action.audioRef.current.duration * +state.playProgress.slice(0, -1) / 100;

        if (typeof duration === 'number' && !Number.isNaN(duration)) {
          action.audioRef.current.currentTime = duration;
        }
      }

      return _assign$4(_assign$4({}, state), {
        indicatorDown: false,
        // up的时候恢复down前的状态
        stateType: state.stateTypeBeforeDown || state.stateType,
        stateTypeBeforeDown: null
      });

    case EActionTypes$1.REINIT:
      if ((_b = action.audioRef) === null || _b === void 0 ? void 0 : _b.current) {
        action.audioRef.current.currentTime = 0;
      }

      return _assign$4(_assign$4({}, state), {
        playProgress: '0',
        UICurrentTime: '00:00',
        stateType: EStateTypes.PAUSED
      });

    case EActionTypes$1.INIT:
      return _assign$4(_assign$4({}, state), {
        stateType: EStateTypes.INITIAL,
        UICurrentTime: action.UICurrentTime,
        duration: action.duration,
        playProgress: action.playProgress,
        indicatorDown: action.indicatorDown,
        loading: action.loading
      });

    case EActionTypes$1.LOAD:
      return _assign$4(_assign$4({}, state), {
        loading: action.loading,
        stateType: action.stateType || state.stateType
      });

    default:
      return state;
  }
}

var useAutoPause$1 = function useAutoPause(audioRef) {
  useEffect(function () {
    function pauseAudio() {
      var _a;

      var audioDom = audioRef.current;

      if (document.hidden) {
        footPrintDetailReport({
          detailAction: "\u5207\u540E\u53F0\u5BFC\u81F4\u7684\u6682\u505C url: ".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
        });
        audioDom === null || audioDom === void 0 ? void 0 : audioDom.pause();
      }
    }

    window.addEventListener('blur', pauseAudio);
    window.addEventListener('visibilitychange', pauseAudio);
    return function () {
      window.removeEventListener('blur', pauseAudio);
      window.removeEventListener('visibilitychange', pauseAudio);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

var useLoadedEvent = function useLoadedEvent(audioRef, onLoaded) {
  function handleLoaded() {
    var _a;

    footPrintDetailReport({
      detailAction: "\u97F3\u9891\u52A0\u8F7D\u5B8C\u6210, url:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
    });
    onLoaded();
  }

  useEffect(function () {
    var audioDom = audioRef.current;
    audioDom === null || audioDom === void 0 ? void 0 : audioDom.addEventListener('loadedmetadata', handleLoaded);
    return function () {
      audioDom === null || audioDom === void 0 ? void 0 : audioDom.removeEventListener('loadedmetadata', handleLoaded);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioRef.current]);
};

var usePressEvent = function usePressEvent(audioRef, pressedDomRef, onPressed) {
  var _a = useState(false),
      loaded = _a[0],
      setLoaded = _a[1];

  useLoadedEvent(audioRef, function () {
    setLoaded(true);
  });

  function handleMouseDown(e) {
    if (isMobile) {
      return;
    }

    footPrintDetailReport({
      detailAction: '音频播放器被按下'
    });
    onPressed(e);
  }

  function handleTouchStart(e) {
    footPrintDetailReport({
      detailAction: '音频播放器被按下'
    });
    onPressed(e);
  }

  useEffect(function () {
    var pressedDom = pressedDomRef.current;

    if (loaded) {
      pressedDom === null || pressedDom === void 0 ? void 0 : pressedDom.addEventListener('mousedown', handleMouseDown);
      pressedDom === null || pressedDom === void 0 ? void 0 : pressedDom.addEventListener('touchstart', handleTouchStart);
    }

    return function () {
      pressedDom === null || pressedDom === void 0 ? void 0 : pressedDom.removeEventListener('mousedown', handleMouseDown);
      pressedDom === null || pressedDom === void 0 ? void 0 : pressedDom.removeEventListener('touchstart', handleTouchStart);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);
};

var useMouseUp$1 = function useMouseUp(audioRef, progressBarRef, onMouseUp) {
  var _a = useState(false),
      pressed = _a[0],
      setPressed = _a[1];

  usePressEvent(audioRef, progressBarRef, function () {
    setPressed(true);
  });

  function handleUp() {
    setPressed(false);
    footPrintDetailReport({
      detailAction: 'audio播放器的按键松开'
    });
    onMouseUp();
  }

  useEffect(function () {
    var dragDom = progressBarRef.current;

    if (pressed) {
      dragDom === null || dragDom === void 0 ? void 0 : dragDom.addEventListener('mouseup', handleUp);
      dragDom === null || dragDom === void 0 ? void 0 : dragDom.addEventListener('touchend', handleUp);
    }

    return function () {
      dragDom === null || dragDom === void 0 ? void 0 : dragDom.removeEventListener('mouseup', handleUp);
      dragDom === null || dragDom === void 0 ? void 0 : dragDom.removeEventListener('touchend', handleUp);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressed]);
};

var useMouseUp = function useMouseUp(dragItemRef, onDrag) {
  var _a = useState(false),
      mouseDown = _a[0],
      setMouseDown = _a[1];

  function handleDragItemPressed(e) {
    e.stopPropagation();
    setMouseDown(!mouseDown);
  }

  useEffect(function () {
    var dragItemDom = dragItemRef.current;
    dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.addEventListener('mousedown', handleDragItemPressed);
    dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.addEventListener('touchstart', handleDragItemPressed);
    dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.addEventListener('mouseup', handleDragItemPressed);
    dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.addEventListener('touchend', handleDragItemPressed); // 只有down状态才需要监听move事件，用于更新playProgress和UI currentTime

    if (mouseDown) {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('touchmove', onDrag);
    } else {
      window.removeEventListener('mousemove', onDrag);
      window.removeEventListener('touchmove', onDrag);
    }

    return function () {
      dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.removeEventListener('mousedown', handleDragItemPressed);
      dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.removeEventListener('touchstart', handleDragItemPressed);
      dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.removeEventListener('mouseup', handleDragItemPressed);
      dragItemDom === null || dragItemDom === void 0 ? void 0 : dragItemDom.removeEventListener('touchend', handleDragItemPressed);
      window.removeEventListener('mousemove', onDrag);
      window.removeEventListener('touchmove', onDrag);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mouseDown]);
};

var usePreload$1 = function usePreload(audioRef) {
  function loadAudio() {
    var _a;

    (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.load();
  }

  useEffect(function () {
    var _a;

    loadAudio();
    footPrintDetailReport({
      detailAction: "\u9884\u52A0\u8F7D\u97F3\u9891\uFF0Csrc:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioRef.current]);
};

var usePauseEvent$1 = function usePauseEvent(audioRef, onPause) {
  useEffect(function () {
    var audioDom = audioRef.current;
    audioDom === null || audioDom === void 0 ? void 0 : audioDom.addEventListener('pause', onPause);
    return function () {
      audioDom === null || audioDom === void 0 ? void 0 : audioDom.removeEventListener('pause', onPause);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

var useWaitingEvent = function useWaitingEvent(audioRef, onWaiting) {
  function handleWaitingEvent() {
    var _a;

    footPrintDetailReport({
      detailAction: "\u97F3\u9891\u6682\u505C\u64AD\u653E\uFF0C\u7B49\u5F85\u8D44\u6E90\u52A0\u8F7D url:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
    });
    onWaiting();
  }

  useEffect(function () {
    var audioDom = audioRef.current;
    audioDom === null || audioDom === void 0 ? void 0 : audioDom.addEventListener('waiting', handleWaitingEvent);
    return function () {
      audioDom === null || audioDom === void 0 ? void 0 : audioDom.removeEventListener('waiting', handleWaitingEvent);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

var useErrorEvent = function useErrorEvent(audioRef, onError) {
  function handleErrorEvent() {
    var _a;

    footPrintDetailReport({
      detailAction: "\u97F3\u9891\u8D44\u6E90\u52A0\u8F7D\u51FA\u9519\uFF0Csrc\uFF1A".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
    });
    onError();
  }

  useEffect(function () {
    var audioEle = audioRef.current;
    audioEle === null || audioEle === void 0 ? void 0 : audioEle.addEventListener('error', handleErrorEvent);
    return function () {
      audioEle === null || audioEle === void 0 ? void 0 : audioEle.removeEventListener('error', handleErrorEvent);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

var useCanPlayEvent = function useCanPlayEvent(audioRef, onCanPlay, deps) {
  if (deps === void 0) {
    deps = [];
  }

  function handleCanPlayEvent() {
    var _a;

    footPrintDetailReport({
      detailAction: "canplay:\u97F3\u9891\u8D44\u6E90\u52A0\u8F7D\u5230\u53EF\u64AD\u653E\u72B6\u6001, src: ".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
    });
    onCanPlay === null || onCanPlay === void 0 ? void 0 : onCanPlay();
  }

  useEffect(function () {
    var audioEle = audioRef.current;
    audioEle === null || audioEle === void 0 ? void 0 : audioEle.addEventListener('canplay', handleCanPlayEvent);
    return function () {
      audioEle === null || audioEle === void 0 ? void 0 : audioEle.removeEventListener('canplay', handleCanPlayEvent);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

var styles$1 = {"stem-image":"tangram_C_stem-image_d7d0c41601","stem-input":"tangram_C_stem-input_d7d0c41601","audio-wrapper":"tangram_C_audio-wrapper_d7d0c41601","audio-box":"tangram_C_audio-box_d7d0c41601","play-btn":"tangram_C_play-btn_d7d0c41601","playing-bg":"tangram_C_playing-bg_d7d0c41601","pause-bg":"tangram_C_pause-bg_d7d0c41601","load-fault":"tangram_C_load-fault_d7d0c41601","loading-bg":"tangram_C_loading-bg_d7d0c41601","loadingPlayBtn":"tangram_C_loadingPlayBtn_d7d0c41601","start-time":"tangram_C_start-time_d7d0c41601","end-time":"tangram_C_end-time_d7d0c41601","progress-bar":"tangram_C_progress-bar_d7d0c41601","delete-width":"tangram_C_delete-width_d7d0c41601","completed-progress":"tangram_C_completed-progress_d7d0c41601","indicator":"tangram_C_indicator_d7d0c41601","delete-icon":"tangram_C_delete-icon_d7d0c41601"};

var waitingTimer$1 = null;
/**
 * @author chenbaijin
 */

var Audio$1 = function Audio(props) {
  var _a;

  var content = props.content,
      richTextLocation = props.richTextLocation,
      editable = props.editable,
      indexNum = props.indexNum,
      deleteMethed = props.deleteMethed,
      maxWidth = props.maxWidth,
      durationProp = props.duration;
  var source = content;
  var customMaxWidth = maxWidth ? {
    maxWidth: "".concat(maxWidth, "px")
  } : {
    maxWidth: '400px'
  };
  var audioRef = useRef(null);
  var indicatorRef = useRef(null);
  var progressBarRef = useRef(null);
  var progressBarWidth = useRef();
  var bgColorMap = (_a = {}, _a[ERichTextLocation.STEM] = '#f5f5f5', _a[ERichTextLocation.OPTION] = '#f5f5f5', _a[ERichTextLocation.ANALYSIS] = '#fff', _a[ERichTextLocation.ANSWER] = '#f5f5f5', _a[ERichTextLocation.USER_ANSWER] = '#f5f5f5', _a);
  var bgColor = richTextLocation ? bgColorMap[richTextLocation] : '#f5f5f5';
  var hasDuratoin = Boolean(durationProp);
  var externalDuration = durationProp !== null && durationProp !== void 0 ? durationProp : 0;

  var _b = useReducer(reducer, {
    stateType: EStateTypes.INITIAL,
    UICurrentTime: '00:00',
    duration: timeFormat(+externalDuration),
    playProgress: '0',
    indicatorDown: false,
    loading: isIOS && isWX ? ELoadType.LOADED : ELoadType.LOADING
  }),
      state = _b[0],
      dispatch = _b[1];

  useEffect(function () {
    dispatch({
      actionType: EActionTypes$1.INIT,
      UICurrentTime: '00:00',
      duration: timeFormat(+externalDuration),
      playProgress: '0',
      indicatorDown: false,
      loading: isIOS && isWX ? ELoadType.LOADED : ELoadType.LOADING
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);
  var stateType = state.stateType,
      UICurrentTime = state.UICurrentTime,
      duration = state.duration,
      playProgress = state.playProgress,
      loading = state.loading; // 初始即固定的DOM UI Date，用于计算playProgress

  useEffect(function () {
    var _a;

    progressBarWidth.current = (_a = progressBarRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
  }, []); // duration正常情况下结构化数据或者业务方会传, 万一没有传的话就加载完成后读取 DOM

  useLoadedEvent(audioRef, function () {
    var _a, _b;

    if (((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.duration) && audioRef.current.duration === Infinity) {
      return;
    }

    if (!hasDuratoin || loading !== ELoadType.LOADED) {
      audioRef.current && dispatch({
        actionType: EActionTypes$1.SET_DURATION,
        duration: secondToDate((_b = audioRef.current) === null || _b === void 0 ? void 0 : _b.duration),
        loading: ELoadType.LOADED
      });
    }
  }); // IOS和微信需要手动预加载, 否则播放前设置audio.currentTime会有问题

  usePreload$1(audioRef); // stateType状态改变需要这个useEffect来让audio实质改变,除了用户点击播放按钮

  useEffect(function () {
    var _a, _b;

    footPrintDetailReport({
      detailAction: "stateType\u72B6\u6001\u6539\u53D8\uFF0C\u5C06\u5F15\u53D1audio api\u8C03\u7528\uFF1A".concat(stateType)
    });
    stateType === EStateTypes.PLAYING ? (_a = audioRef === null || audioRef === void 0 ? void 0 : audioRef.current) === null || _a === void 0 ? void 0 : _a.play().catch(function (error) {
      playErrorReport(error);
      dispatch({
        actionType: EActionTypes$1.LOAD,
        loading: ELoadType.LOAD_FAULT
      });
    }) : (_b = audioRef === null || audioRef === void 0 ? void 0 : audioRef.current) === null || _b === void 0 ? void 0 : _b.pause(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateType]);
  useErrorEvent(audioRef, function () {
    dispatch({
      actionType: EActionTypes$1.LOAD,
      loading: ELoadType.LOAD_FAULT
    });
  }); // 等待资源加载的情况

  useWaitingEvent(audioRef, function () {
    dispatch({
      actionType: EActionTypes$1.LOAD,
      loading: ELoadType.LOADING
    });

    if (isIOS && isWX) {
      waitingTimer$1 = setTimeout(function () {
        var _a;

        (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        dispatch({
          actionType: EActionTypes$1.LOAD,
          loading: ELoadType.LOAD_FAULT
        });
      }, WAITING_TIME);
    }
  }); // 处理其他媒体播放导致的暂停, 改变UI上播放按钮的样式

  usePauseEvent$1(audioRef, function () {
    dispatch({
      actionType: EActionTypes$1.PAUSE
    });
  }); // 切到后台后自动暂停

  useAutoPause$1(audioRef); // 和其他媒体资源互斥播放，原理是每次新播放一个媒体资源时，暂停上一个媒体资源

  useExclusivePlay(audioRef); // 按下音频按键时, 仅仅改变 UI 上的进度条位置和 UI 上的当前时间

  usePressEvent(audioRef, progressBarRef, function (e) {
    var _a;

    var curX = e instanceof MouseEvent ? e.pageX : e.touches[0].pageX;
    var playProgress = getCurrentPlayProgress(curX, ((_a = progressBarRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0, progressBarWidth.current);
    playProgress && audioRef.current && dispatch({
      actionType: EActionTypes$1.PRESS,
      playProgress: "".concat(playProgress * 100, "%"),
      UICurrentTime: secondToDate(audioRef.current.duration * playProgress)
    });
  }); // 松开按键时: 1.恢复按下时的状态 2.设置 audio.currentTime 真正改变播放进度(按下/拖拽时仅仅是UI上改变进度)

  useMouseUp$1(audioRef, progressBarRef, function () {
    dispatch({
      actionType: EActionTypes$1.PRESS_END,
      progressBarWidth: progressBarWidth.current,
      audioRef: audioRef
    });
  }); // 当指示器被拖动时

  useMouseUp(progressBarRef, function (e) {
    var _a;

    var curPageX = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX;
    var playProgress = getCurrentPlayProgress(curPageX, ((_a = progressBarRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0, progressBarWidth.current);
    (playProgress || playProgress === 0) && audioRef.current && dispatch({
      actionType: EActionTypes$1.MOVE,
      playProgress: "".concat(playProgress * 100, "%"),
      UICurrentTime: secondToDate(audioRef.current.duration * playProgress)
    });
  }); // 当指示条被拖动后，可能会loading，能够继续播放后，需要重置为loaded状态

  useCanPlayEvent(audioRef, function () {
    loading !== ELoadType.LOADED && dispatch({
      actionType: EActionTypes$1.LOAD,
      loading: ELoadType.LOADED
    });
  }, [loading]);
  usePlayEvent(audioRef, function () {
    waitingTimer$1 && clearTimeout(waitingTimer$1);

    if (stateType === EStateTypes.PLAYING) {
      return;
    }

    dispatch({
      actionType: EActionTypes$1.TOGGLE_PLAY_STATE
    });
  }, [stateType]); // 播放或暂停按钮，点击播放/暂停 由于ios端必须用户直接行为才能播放音频，所以音频播放不在useEffect hooks中控制

  function handlePlayBtnClick() {
    var _a, _b, _c, _d, _e;

    if (loading === ELoadType.LOADING) {
      return;
    }

    if (loading === ELoadType.LOAD_FAULT) {
      footPrintDetailReport({
        detailAction: '点击了重新加载按钮',
        actionValue: "src:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
      });
      (_b = audioRef === null || audioRef === void 0 ? void 0 : audioRef.current) === null || _b === void 0 ? void 0 : _b.load();

      if (isIOS && isWX) {
        dispatch({
          actionType: EActionTypes$1.TOGGLE_PLAY_STATE
        });
      } else {
        dispatch({
          actionType: EActionTypes$1.LOAD,
          loading: ELoadType.LOADING,
          stateType: EStateTypes.PAUSED
        });
      }

      return;
    }

    footPrintDetailReport({
      detailAction: '点击了播放按钮',
      actionValue: "\u5F53\u524D\u64AD\u653E\u72B6\u6001\uFF1A".concat(stateType, "\uFF0Csrc:").concat((_c = audioRef.current) === null || _c === void 0 ? void 0 : _c.src)
    });

    if (isIOS && isWX && !((_d = audioRef.current) === null || _d === void 0 ? void 0 : _d.duration)) {
      (_e = audioRef.current) === null || _e === void 0 ? void 0 : _e.load();
    }

    dispatch({
      actionType: EActionTypes$1.TOGGLE_PLAY_STATE
    });
  } // 当正常播放时，根据实际的播放时间改变UI 的播放进度


  function handleTimeUpdate() {
    var currentAudioEl = audioRef.current;

    if ((currentAudioEl === null || currentAudioEl === void 0 ? void 0 : currentAudioEl.duration) && (currentAudioEl === null || currentAudioEl === void 0 ? void 0 : currentAudioEl.currentTime) && progressBarWidth.current) {
      var duration_1 = currentAudioEl.duration,
          currentTime = currentAudioEl.currentTime;
      var playProgress_1 = "".concat(Math.ceil(currentTime / duration_1 * 100), "%");
      dispatch({
        actionType: EActionTypes$1.UPDATE_PROGRESS,
        playProgress: playProgress_1,
        UICurrentTime: secondToDate(currentTime)
      });
    }
  }

  function handleEnd() {
    footPrintDetailReport({
      detailAction: '播放结束事件'
    });
    dispatch({
      actionType: EActionTypes$1.REINIT,
      audioRef: audioRef
    });
  }

  return source ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$1['audio-wrapper']
  }, /*#__PURE__*/React.createElement("audio", {
    preload: "auto",
    className: "audio-list",
    ref: audioRef,
    src: source,
    style: {
      display: 'block'
    },
    // eslint-disable-next-line react/jsx-no-bind
    onTimeUpdate: handleTimeUpdate,
    // eslint-disable-next-line react/jsx-no-bind
    onEnded: handleEnd,
    "data-source": "exercise-ui"
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1['audio-box'], " swiping-disable"),
    style: _assign$4({
      backgroundColor: bgColor
    }, customMaxWidth)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['start-time']
  }, UICurrentTime), /*#__PURE__*/React.createElement("div", {
    ref: progressBarRef,
    role: "button",
    tabIndex: 0,
    className: "".concat(styles$1['progress-bar'], " ").concat(editable ? styles$1['delete-width'] : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['completed-progress'],
    style: {
      width: playProgress
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: indicatorRef,
    role: "button",
    tabIndex: 0,
    className: styles$1.indicator,
    style: {
      left: playProgress
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1['end-time']
  }, duration), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styles$1['play-btn'],
    // eslint-disable-next-line react/jsx-no-bind
    onClick: handlePlayBtnClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(loading === ELoadType.LOADED ? stateType === EStateTypes.PLAYING ? styles$1['pause-bg'] : styles$1['playing-bg'] : loading === ELoadType.LOADING ? styles$1['loading-bg'] : styles$1['load-fault'])
  }))), editable && /*#__PURE__*/React.createElement("div", {
    className: styles$1['delete-icon'],
    onClick: deleteMethed,
    role: "button",
    tabIndex: 0,
    "audio-index": indexNum
  }))) : null;
};

var AudioAnsChecker = function AudioAnsChecker(props) {
  var editable = props.editable,
      answerList = props.answerList,
      dispatchAnsSort = props.dispatchAnsSort;

  function deleteAnswer(event) {
    var index = event.currentTarget.getAttribute('audio-index') || -1;
    event.stopPropagation();
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.DELETE,
      answerType: ESubmitType.AUDIO,
      deleteIndex: +index
    });
  }

  return /*#__PURE__*/React.createElement("div", null, answerList === null || answerList === void 0 ? void 0 : answerList.map(function (item, index) {
    var _a = item.resource || {},
        url = _a.url,
        length = _a.length;

    return /*#__PURE__*/React.createElement(Audio$1, {
      content: url,
      key: url,
      duration: length ? +length : null,
      maxWidth: 400,
      editable: editable,
      richTextLocation: editable ? ERichTextLocation.ANSWER : ERichTextLocation.ANALYSIS,
      deleteMethed: deleteAnswer,
      indexNum: index
    });
  }));
};

var unusualEvents = ['stalled'];
var retryLimits = 5;

var usePlaySafe = function usePlaySafe(videoRef, src) {
  var vr = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;

  function getRandomUrl() {
    if (retryLimits < 0) {
      unusualEvents.forEach(function (event) {
        vr === null || vr === void 0 ? void 0 : vr.removeEventListener(event, getRandomUrl);
      });
      return;
    }

    var newly = [];

    if (Array.isArray(src)) {
      (src === null || src === void 0 ? void 0 : src.length) > 1 && src.forEach(function (url) {
        url !== (vr === null || vr === void 0 ? void 0 : vr.currentSrc) && newly.push(url);
      });
    } // @ts-ignore


    vr === null || vr === void 0 ? void 0 : vr.src = newly === null || newly === void 0 ? void 0 : newly[Math.floor(Math.random()) * (newly.length - 1)];
    retryLimits -= 1;
  }

  useEffect(function () {
    if (vr && Array.isArray(src) && src.length > 1) {
      unusualEvents.forEach(function (event) {
        vr === null || vr === void 0 ? void 0 : vr.addEventListener(event, getRandomUrl);
      });
    }
  }, [vr, src]);
};

var styleSheet = {"video-wrapper":"tangram_C_video-wrapper_1a87bc5d9e","pause-container":"tangram_C_pause-container_1a87bc5d9e","stem-img":"tangram_C_stem-img_1a87bc5d9e","stem-width":"tangram_C_stem-width_1a87bc5d9e","c-base-video":"tangram_C_c-base-video_1a87bc5d9e","center-video":"tangram_C_center-video_1a87bc5d9e","left-video":"tangram_C_left-video_1a87bc5d9e"};

function removePreviousListners(shouldNotAddNew, previousEventsAndActions, newEventsAndActions, videoRef) {
  if (previousEventsAndActions) {
    var vr_1 = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
    var events = previousEventsAndActions.events,
        actions_1 = previousEventsAndActions.actions;
    var shouldNotRemovePrevious = !events || !actions_1 || !Array.isArray(events) || !Array.isArray(actions_1) || !vr_1;

    if (newEventsAndActions) {
      var newEvents = newEventsAndActions.events,
          newActions_1 = newEventsAndActions.actions;

      if (shouldNotRemovePrevious) {
        if (!shouldNotAddNew) {
          newEvents === null || newEvents === void 0 ? void 0 : newEvents.forEach(function (e, index) {
            e && newActions_1 && newActions_1[index] && (vr_1 === null || vr_1 === void 0 ? void 0 : vr_1.addEventListener(e, newActions_1[index]));
          });
        }

        return _assign$4({}, newEventsAndActions);
      }
    }

    if (!shouldNotRemovePrevious) {
      events === null || events === void 0 ? void 0 : events.forEach(function (e, index) {
        e && actions_1 && actions_1[index] && (vr_1 === null || vr_1 === void 0 ? void 0 : vr_1.removeEventListener(e, actions_1[index]));
      });
    }
  }
}

function useEventsAndActions(eventsAndActions, videoRef) {
  var _a = useState(eventsAndActions);
      _a[0];
      var setEventsAndActions = _a[1];

  useEffect(function () {
    setEventsAndActions(function (previousEventsAndActions) {
      if (eventsAndActions) {
        var vr_2 = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        var newEvents = eventsAndActions.events,
            newActions_2 = eventsAndActions.actions;
        var shouldNotAddNew = !newEvents || !newActions_2 || !Array.isArray(newEvents) || !Array.isArray(newActions_2) || !vr_2;

        if (previousEventsAndActions) {
          removePreviousListners(shouldNotAddNew, previousEventsAndActions, eventsAndActions, videoRef);
        }

        if (!shouldNotAddNew) {
          newEvents === null || newEvents === void 0 ? void 0 : newEvents.forEach(function (e, index) {
            e && newActions_2 && newActions_2[index] && (vr_2 === null || vr_2 === void 0 ? void 0 : vr_2.addEventListener(e, newActions_2[index]));
          });
        }

        return _assign$4({}, eventsAndActions);
      }

      removePreviousListners(true, previousEventsAndActions, eventsAndActions, videoRef);
      return {};
    });
  }, [eventsAndActions]);
}

var VideoPlayer = function VideoPlayer(_a) {
  var source = _a.source,
      isAnswer = _a.isAnswer,
      coverUrl = _a.coverUrl;
      _a.duration;
      var isCenter = _a.isCenter,
      eventsAndActions = _a.eventsAndActions,
      videoWrapperStyle = _a.videoWrapperStyle;
  var videoRef = useRef(null);
  var src = useMemo(function () {
    return Array.isArray(source) ? source === null || source === void 0 ? void 0 : source[0] : source;
  }, [source]);

  function handleClick() {
    if (isMobileClient) {
      callNative({
        apiName: ENativeApi.GOTOPLAY_VIDEO,
        params: {
          screenOrientation: EScreenOrientation.LANDSCAPE,
          videoUrl: src,
          playProgress: 0
        }
      });
      return false;
    }
  }

  useEventsAndActions(eventsAndActions, videoRef);
  usePlaySafe(videoRef, source);
  useEffect(function () {
    if (isWX && videoRef.current && src) {
      videoRef.current.poster = coverUrl || "".concat(src, "?x-oss-process=video/snapshot,t_0000");
    }
  }, [videoRef.current]);

  if (!source) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "\n                ".concat(styleSheet['video-wrapper'], " \n                ").concat(isAnswer ? '' : styleSheet['stem-width'], "\n                ").concat(isCenter ? styleSheet['center-video'] : styleSheet['left-video'], "\n            "),
    style: videoWrapperStyle
  }, isNewVersion ? /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    className: styleSheet['pause-container']
  }, /*#__PURE__*/React.createElement("img", {
    className: styleSheet['stem-img'],
    // src="https://test-i.gsxcdn.com/5862173_e3t4hxuf.png"
    src: coverUrl !== null && coverUrl !== void 0 ? coverUrl : "".concat(src, "?x-oss-process=video/snapshot,t_0000"),
    alt: "poster",
    "data-source": "exercise-ui"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    controls: true,
    disablePictureInPicture: true,
    controlsList: "nodownload noremoteplayback noplaybackrate",
    src: src,
    className: styleSheet['c-base-video']
  }, "Sorry, your browser doesn't support embedded videos.")));
};

var style$11 = {"videos-wrapper":"tangram_C_videos-wrapper_73a0fcacfe","video-player-container":"tangram_C_video-player-container_73a0fcacfe","delete-icon":"tangram_C_delete-icon_73a0fcacfe"};

var VidoeAnsChecker = function VidoeAnsChecker(props) {
  var editable = props.editable,
      answerList = props.answerList,
      dispatchAnsSort = props.dispatchAnsSort;

  function deleteAnswer(event) {
    var index = event.currentTarget.getAttribute('el-index') || -1;
    event.stopPropagation();
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.DELETE,
      answerType: ESubmitType.VIDEO,
      deleteIndex: +index
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style$11['videos-wrapper']
  }, answerList === null || answerList === void 0 ? void 0 : answerList.map(function (_a, index) {
    var _b;

    var resource = _a.resource;
    var url = (_b = resource) === null || _b === void 0 ? void 0 : _b.url;
    return /*#__PURE__*/React.createElement("div", {
      key: url,
      "video-source": url,
      className: style$11['video-player-container']
    }, /*#__PURE__*/React.createElement(VideoPlayer, {
      source: url,
      isAnswer: true
    }), editable && /*#__PURE__*/React.createElement("span", {
      className: style$11['delete-icon'],
      "el-index": index,
      onClick: deleteAnswer,
      role: "button",
      tabIndex: 0
    }));
  })));
};

var style$10 = {"text-area-container":"tangram_C_text-area-container_20aea36f8b","text-area-main":"tangram_C_text-area-main_20aea36f8b","text-area-btns":"tangram_C_text-area-btns_20aea36f8b"};

var TextArea = function TextArea(props) {
  var _a;

  var answerList = props.answerList,
      questionId = props.questionId,
      editable = props.editable,
      dispatchAnsSort = props.dispatchAnsSort,
      onEditorFocus = props.onEditorFocus,
      onEditorBlur = props.onEditorBlur;
  var textRef = useRef(null);

  var _b = useState(((_a = answerList === null || answerList === void 0 ? void 0 : answerList[0]) === null || _a === void 0 ? void 0 : _a.resource) || ''),
      curContent = _b[0],
      setCurContent = _b[1];

  var _c = useState(false),
      lock = _c[0],
      setLock = _c[1];

  var remainCount = EAnswerTypeMaxCount.TEXT - (curContent.length || 0); // 高度自适应的 textarea

  function autoHeight(element) {
    if (element.scrollHeight < 120) {
      element.style.height = "".concat(element.scrollHeight, "px");
    } else {
      element.style.height = '120px';
    }
  }

  useEffect(function () {
    var _a;

    setCurContent(((_a = answerList === null || answerList === void 0 ? void 0 : answerList[0]) === null || _a === void 0 ? void 0 : _a.resource) || '');
    textRef.current && autoHeight(textRef.current);
  }, [answerList, questionId]); // 失焦时滚动到视口顶部

  var focusOutScroll = function focusOutScroll() {
    window.scrollTo(0, 0);
  };

  useEffect(function () {
    var textDom = textRef.current;

    if (isIOS) {
      textDom === null || textDom === void 0 ? void 0 : textDom.addEventListener('focusout', focusOutScroll, true);
    }

    return function () {
      if (isIOS) {
        textDom === null || textDom === void 0 ? void 0 : textDom.addEventListener('focusout', focusOutScroll, true);
      }
    };
  }, [textRef]); // 提交作答结果

  function confirmSubText(curContent) {
    if (curContent === void 0) {
      curContent = '';
    }

    var curAnswerList = curContent ? [{
      resource: curContent,
      resourceType: ESubmitItemTypes.TEXT
    }] : [];
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.ADD,
      answerType: ESubmitType.TEXT,
      answerList: curAnswerList
    });
  } // 输入内容处理


  function handleInputText(event) {
    var curContent = event.currentTarget.value;

    if (curContent.length > EAnswerTypeMaxCount.TEXT) {
      return;
    }

    setCurContent(curContent);

    if (lock) {
      return;
    }

    confirmSubText(curContent);
  }

  function handleComsitionStart(e) {
    setLock(true);
  } // 拼音打字时


  function handleCompositionEnd(e) {
    confirmSubText(e.currentTarget.value);
    setLock(false);
  }

  function watchMove(event) {
    if (!textRef.current) {
      return;
    }

    document.removeEventListener('touchmove', watchMove);
    var touchDom = event.target; // 若点击区域在dom元素之外，失焦

    !textRef.current.contains(touchDom) && textRef.current.blur();
  }

  function watchTouch() {
    if (!textRef.current) {
      return;
    } // 移动时传入touchStart时的事件（判断触摸区域是否为当前题目）


    document.addEventListener('touchstart', watchMove);
  }

  function handleFocus(e) {
    onEditorFocus === null || onEditorFocus === void 0 ? void 0 : onEditorFocus(e);
    window.addEventListener('touchstart', watchTouch);
  }

  function handleBlur(e) {
    onEditorBlur === null || onEditorBlur === void 0 ? void 0 : onEditorBlur(e);
    window.removeEventListener('touchstart', watchTouch);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: style$10['text-area-container']
  }, /*#__PURE__*/React.createElement("textarea", {
    ref: textRef,
    className: style$10['text-area-main'],
    name: "answerText",
    id: "answerText",
    spellCheck: false,
    rows: 1,
    maxLength: EAnswerTypeMaxCount.TEXT,
    value: curContent,
    placeholder: MyAnswerPlaceholder,
    tabIndex: -1,
    onInput: handleInputText,
    onCompositionEnd: handleCompositionEnd,
    onCompositionStart: handleComsitionStart,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), editable && /*#__PURE__*/React.createElement("p", {
    className: style$10['text-area-btns']
  }, /*#__PURE__*/React.createElement("span", null, remainCount)));
};

var style$$ = {"toast-wrapper":"tangram_C_toast-wrapper_fc5bc87151","toast-msg":"tangram_C_toast-msg_fc5bc87151"};

var Toast = function Toast(props) {
  var icon = props.icon,
      msg = props.msg,
      customToastStyle = props.customToastStyle,
      otherNodes = props.otherNodes;
  return /*#__PURE__*/React.createElement("div", {
    className: style$$['toast-wrapper'],
    style: _assign$4({}, customToastStyle)
  }, icon, /*#__PURE__*/React.createElement("span", {
    className: style$$['toast-msg']
  }, msg), otherNodes);
};

/**
 * 输入类型；目前仅 解答题，填空题的非自动判题 的回答会用到；
 */
var EAnswerContentType;

(function (EAnswerContentType) {
  /**
   * 纯文本
   */
  EAnswerContentType[EAnswerContentType["plainText"] = 0] = "plainText";
  /**
   * 富文本
   */

  EAnswerContentType[EAnswerContentType["richText"] = 1] = "richText";
})(EAnswerContentType || (EAnswerContentType = {}));
/**
 * 富文本工具
 */


var ERichTextTool;

(function (ERichTextTool) {
  ERichTextTool[ERichTextTool["copy"] = 0] = "copy";
  ERichTextTool[ERichTextTool["cut"] = 1] = "cut";
  ERichTextTool[ERichTextTool["paste"] = 2] = "paste";
  ERichTextTool[ERichTextTool["formula"] = 3] = "formula";
})(ERichTextTool || (ERichTextTool = {}));

var EKeyCode;

(function (EKeyCode) {
  EKeyCode[EKeyCode["backspace"] = 8] = "backspace";
  EKeyCode[EKeyCode["delete"] = 46] = "delete";
})(EKeyCode || (EKeyCode = {}));

var FormulaMark = 'math-tk';
var zeroWidth = "\uFEFF";

var jqueryLocation = '//jy.gsxcdn.com/fe/3rd/mathquill/0.10.1/jquery.min.js';
var mathquillJsLocation = '//jy.gsxcdn.com/fe/3rd/mathquill/0.10.1-v1/mathquill.min.js';
var mathquillCssLocation = '//jy.gsxcdn.com/fe/3rd/mathquill/0.10.1-v1/mathquill.min.css';
function downloadDependency() {
  return __awaiter$2(this, void 0, void 0, function () {
    var jQuery, loadArr;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          jQuery = window.jQuery;
          _b.label = 1;

        case 1:
          _b.trys.push([1, 5,, 6]);

          if (!(!jQuery || compareVersion$1(jQuery().jquery, '1.5.2'))) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , reTryPromise(function () {
            return loadScript(jqueryLocation);
          })];

        case 2:
          _b.sent();

          _b.label = 3;

        case 3:
          loadArr = [];

          if (!window.MathQuill) {
            loadArr.push(reTryPromise(function () {
              return loadStyle(mathquillCssLocation);
            }), reTryPromise(function () {
              return loadScript(mathquillJsLocation);
            }));
          }

          if (!loadArr.length) {
            return [2
            /*return*/
            , window.MathQuill.getInterface(2)];
          }

          return [4
          /*yield*/
          , Promise.all(loadArr)];

        case 4:
          _b.sent();

          return [2
          /*return*/
          , window.MathQuill.getInterface(2)];

        case 5:
          _b.sent();
          return [2
          /*return*/
          , Promise.reject('下载依赖失败')];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}
function getUserSelection() {
  if (window.getSelection) {
    return window.getSelection();
  }

  if (document.selection) {
    return document.selection.createRange();
  }

  return null;
}

var style$_ = {"tk-mathquill":"tangram_C_tk-mathquill_40dd77ae3d","rich-text-container":"tangram_C_rich-text-container_40dd77ae3d","rich-text":"tangram_C_rich-text_40dd77ae3d","empty":"tangram_C_empty_40dd77ae3d","font-sum":"tangram_C_font-sum_40dd77ae3d","tool-list":"tangram_C_tool-list_40dd77ae3d","tooltip":"tangram_C_tooltip_40dd77ae3d","tooltip-arrow":"tangram_C_tooltip-arrow_40dd77ae3d","tooltip-arrow-content":"tangram_C_tooltip-arrow-content_40dd77ae3d","tooltip-inner":"tangram_C_tooltip-inner_40dd77ae3d","tool-info":"tangram_C_tool-info_40dd77ae3d","tool-btn":"tangram_C_tool-btn_40dd77ae3d","tool-select":"tangram_C_tool-select_40dd77ae3d","copy":"tangram_C_copy_40dd77ae3d","cut":"tangram_C_cut_40dd77ae3d","paste":"tangram_C_paste_40dd77ae3d","formula":"tangram_C_formula_40dd77ae3d","formula-tab":"tangram_C_formula-tab_40dd77ae3d","type-name-list":"tangram_C_type-name-list_40dd77ae3d","type-name":"tangram_C_type-name_40dd77ae3d","active":"tangram_C_active_40dd77ae3d","formula-box":"tangram_C_formula-box_40dd77ae3d","formula-symbol":"tangram_C_formula-symbol_40dd77ae3d"};

var _a$f, _b$4, _c$1;

var EFormulaType;

(function (EFormulaType) {
  EFormulaType[EFormulaType["custom"] = 0] = "custom";
  EFormulaType[EFormulaType["symbol"] = 1] = "symbol";
  EFormulaType[EFormulaType["greeceLetter"] = 2] = "greeceLetter";
})(EFormulaType || (EFormulaType = {}));

var FormulaTypeName = (_a$f = {}, _a$f[EFormulaType.custom] = '常用公式', _a$f[EFormulaType.symbol] = '符号', _a$f[EFormulaType.greeceLetter] = '希腊字母', _a$f);
var ossUrl = '//jy.gsxcdn.com/fe/project/exercise-tangram/static/symbol';
var symbolUrl = "".concat(ossUrl, "/symbol/");
var formulaUrl = "".concat(ossUrl, "/formula/");
var greeceLetterUrl = "".concat(ossUrl, "/greeceLetter/");
var FormulaInfo = {
  frac: {
    iconKey: 'frac',
    latex: '\\frac{ }{ }',
    text: '分数'
  },
  except: {
    iconKey: 'except',
    latex: '^{ }/_{ }',
    text: '除'
  },
  sup: {
    iconKey: 'sup',
    latex: 'x^{ }',
    text: '上角标'
  },
  sub: {
    iconKey: 'sub',
    latex: 'x_{ }',
    text: '下角标'
  },
  supSub: {
    iconKey: 'supSub',
    latex: 'x_{ }^{ }',
    text: '上下角标'
  },
  overline: {
    iconKey: 'overline',
    latex: '\\overline{ }',
    text: 'overline'
  },
  sum: {
    iconKey: 'sum',
    latex: '\\sum_{n=}^{ }',
    text: '求和'
  },
  log: {
    iconKey: 'log',
    latex: '\\log_{ }\\left(\\right)',
    text: 'log'
  },
  ln: {
    iconKey: 'ln',
    latex: '\\ln\\left(\\right)',
    text: 'ln'
  },
  int: {
    iconKey: 'int',
    latex: '\\int_{ }^{ }',
    text: 'int'
  },
  oint: {
    iconKey: 'oint',
    latex: '\\oint_{ }^{ }',
    text: 'oint'
  },
  sqrt: {
    iconKey: 'sqrt',
    latex: '\\sqrt{ }',
    text: '平方根'
  },
  sqrtn: {
    iconKey: 'sqrtn',
    latex: '\\sqrt[]{}',
    text: 'n次方根'
  },
  topRightArrow: {
    iconKey: 'topRightArrow',
    latex: '\\overrightarrow{}',
    text: 'topRightArrow'
  },
  topLeftArrow: {
    iconKey: 'topLeftArrow',
    latex: '\\overleftarrow{}',
    text: 'topLeftArrow'
  },
  plus: {
    iconKey: 'plus',
    latex: '+',
    text: '+'
  },
  reduce: {
    iconKey: 'reduce',
    latex: '-',
    text: '-'
  },
  pm: {
    iconKey: 'pm',
    latex: '\\pm',
    text: 'pm'
  },
  multiply: {
    iconKey: 'multiply',
    latex: '\\times',
    text: 'x'
  },
  asterisk: {
    iconKey: 'asterisk',
    latex: '\\ast',
    text: '*'
  },
  divide: {
    iconKey: 'divide',
    latex: '\\div',
    text: 'div'
  },
  oblique: {
    iconKey: 'oblique',
    latex: '/',
    text: '/'
  },
  infinity: {
    iconKey: 'infinity',
    latex: '\\infty',
    text: 'infty'
  },
  in: {
    iconKey: 'in',
    latex: '\\in',
    text: 'in'
  },
  triangle: {
    iconKey: 'triangle',
    latex: '\\triangle',
    text: 'triangle'
  },
  eq: {
    iconKey: 'eq',
    latex: '=',
    text: '='
  },
  neq: {
    iconKey: 'neq',
    latex: '\\neq ',
    text: 'neq'
  },
  approx: {
    iconKey: 'approx',
    latex: '\\approx',
    text: 'approx '
  },
  bigger: {
    iconKey: 'bigger',
    latex: '>',
    text: '>'
  },
  smaller: {
    iconKey: 'smaller',
    latex: '<',
    text: '<'
  },
  bigEq: {
    iconKey: 'bigEq',
    latex: '\\ge',
    text: 'ge '
  },
  smallEq: {
    iconKey: 'smallEq',
    latex: '\\le ',
    text: 'le'
  },
  vert: {
    iconKey: 'vert',
    latex: '\\vert\\vert',
    text: 'Vert'
  },
  int2: {
    iconKey: 'int2',
    latex: '\\int{}',
    text: 'int'
  },
  rightArrow: {
    iconKey: 'rightArrow',
    latex: '\\rightarrow ',
    text: 'rightarrow '
  },
  alpha: {
    iconKey: 'alpha',
    latex: '\\alpha',
    text: 'alpha'
  },
  beta: {
    iconKey: 'beta',
    latex: '\\beta ',
    text: 'beta'
  },
  gamma: {
    iconKey: 'gamma',
    latex: '\\gamma',
    text: ''
  },
  delta: {
    iconKey: 'delta',
    latex: '\\delta ',
    text: 'delta '
  },
  varepsilon: {
    iconKey: 'varepsilon',
    latex: '\\varepsilon',
    text: 'varepsilon'
  },
  zeta: {
    iconKey: 'zeta',
    latex: '\\zeta',
    text: 'zeta'
  },
  eta: {
    iconKey: 'eta',
    latex: '\\eta',
    text: 'eta'
  },
  theta: {
    iconKey: 'theta',
    latex: '\\theta ',
    text: 'theta '
  },
  iota: {
    iconKey: 'iota',
    latex: '\\iota',
    text: 'iota'
  },
  kappa: {
    iconKey: 'kappa',
    latex: '\\kappa',
    text: 'kappa '
  },
  lambda: {
    iconKey: 'lambda',
    latex: '\\lambda',
    text: 'lambda'
  },
  mu: {
    iconKey: 'mu',
    latex: '\\mu',
    text: 'mu'
  },
  nu: {
    iconKey: 'nu',
    latex: '\\nu',
    text: 'nu'
  },
  xi: {
    iconKey: 'xi',
    latex: '\\xi',
    text: 'xi'
  },
  omicron: {
    iconKey: 'omicron',
    latex: 'o',
    text: 'omicron'
  },
  pi: {
    iconKey: 'pi',
    latex: '\\pi',
    text: 'pi'
  },
  rho: {
    iconKey: 'rho',
    latex: '\\rho',
    text: 'rho'
  },
  sigma: {
    iconKey: 'sigma',
    latex: '\\sigma',
    text: 'sigma'
  },
  tau: {
    iconKey: 'tau',
    latex: '\\tau',
    text: 'tau'
  },
  upsilon: {
    iconKey: 'upsilon',
    latex: "\\upsilon",
    text: 'upsilon'
  },
  phi: {
    iconKey: 'phi',
    latex: '\\phi',
    text: 'phi'
  },
  chi: {
    iconKey: 'chi',
    latex: '\\chi',
    text: 'chi'
  },
  psi: {
    iconKey: 'psi',
    latex: '\\psi',
    text: 'psi'
  },
  omega: {
    iconKey: 'omega',
    latex: '\\omega',
    text: 'omega'
  }
};
var IconBaseUrl = (_b$4 = {}, _b$4[EFormulaType.custom] = formulaUrl, _b$4[EFormulaType.symbol] = symbolUrl, _b$4[EFormulaType.greeceLetter] = greeceLetterUrl, _b$4);
var EFormulaLetter = (_c$1 = {}, _c$1[EFormulaType.custom] = [FormulaInfo.frac, FormulaInfo.except, FormulaInfo.sup, FormulaInfo.sub, FormulaInfo.supSub, FormulaInfo.overline, FormulaInfo.sum, FormulaInfo.log, FormulaInfo.ln, FormulaInfo.int, FormulaInfo.oint, FormulaInfo.sqrt, FormulaInfo.sqrtn, FormulaInfo.topRightArrow, FormulaInfo.topLeftArrow], _c$1[EFormulaType.symbol] = [FormulaInfo.plus, FormulaInfo.reduce, FormulaInfo.pm, FormulaInfo.multiply, FormulaInfo.asterisk, FormulaInfo.divide, FormulaInfo.oblique, FormulaInfo.infinity, FormulaInfo.in, FormulaInfo.triangle, FormulaInfo.eq, FormulaInfo.neq, FormulaInfo.approx, FormulaInfo.bigger, FormulaInfo.smaller, FormulaInfo.bigEq, FormulaInfo.smallEq, FormulaInfo.vert, FormulaInfo.int2, FormulaInfo.rightArrow], _c$1[EFormulaType.greeceLetter] = [FormulaInfo.alpha, FormulaInfo.beta, FormulaInfo.gamma, FormulaInfo.delta, FormulaInfo.varepsilon, FormulaInfo.zeta, FormulaInfo.eta, FormulaInfo.theta, FormulaInfo.iota, FormulaInfo.kappa, FormulaInfo.lambda, FormulaInfo.mu, FormulaInfo.nu, FormulaInfo.xi, FormulaInfo.omicron, FormulaInfo.pi, FormulaInfo.rho, FormulaInfo.sigma, FormulaInfo.tau, FormulaInfo.upsilon, FormulaInfo.phi, FormulaInfo.chi, FormulaInfo.psi, FormulaInfo.omega], _c$1);

function ToolTip(_a) {
  var title = _a.title;
  return /*#__PURE__*/React.createElement("div", {
    className: style$_.tooltip
  }, /*#__PURE__*/React.createElement("div", {
    className: style$_['tooltip-arrow']
  }, /*#__PURE__*/React.createElement("span", {
    className: style$_['tooltip-arrow-content']
  })), /*#__PURE__*/React.createElement("span", {
    className: style$_['tooltip-inner']
  }, title));
}

var FormulaTabList = [EFormulaType.custom, EFormulaType.symbol, EFormulaType.greeceLetter];
function Toolbar(_a) {
  var onInputLatex = _a.onInputLatex;
      _a.onFocusEditor;
      var onCopy = _a.onCopy,
      onCut = _a.onCut,
      onPaste = _a.onPaste,
      disableTools = _a.disableTools;

  var _b = useState(EFormulaType.custom),
      currentFormula = _b[0],
      setFormula = _b[1];

  var _c = useState(false),
      isShowFormula = _c[0],
      setFormulaShow = _c[1];

  var formulaList = useMemo(function () {
    return EFormulaLetter[currentFormula];
  }, [currentFormula]);

  function handleChangeTab(tab) {
    setFormula(tab);
  }

  function handleInputLatex(latex) {
    setFormulaShow(false);
    setFormula(EFormulaType.custom);
    onInputLatex === null || onInputLatex === void 0 ? void 0 : onInputLatex(latex);
  }

  function handleShowFormula() {
    setFormulaShow(!isShowFormula);
  }

  function handleMouseDown(event) {
    // onFocusEditor?.();
    event.preventDefault();
  }

  return /*#__PURE__*/React.createElement("div", {
    className: style$_.toolbar,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React.createElement("ul", {
    className: style$_['tool-list']
  }, /*#__PURE__*/React.createElement("li", {
    className: [style$_['tool-info'], style$_.copy].join(' ')
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableTools.includes(ERichTextTool.copy),
    type: "button",
    className: style$_['tool-btn'],
    onClick: onCopy
  }), /*#__PURE__*/React.createElement(ToolTip, {
    title: "\u590D\u5236"
  })), /*#__PURE__*/React.createElement("li", {
    className: [style$_['tool-info'], style$_.cut].join(' ')
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableTools.includes(ERichTextTool.cut),
    type: "button",
    className: style$_['tool-btn'],
    onClick: onCut
  }), /*#__PURE__*/React.createElement(ToolTip, {
    title: "\u526A\u5207"
  })), /*#__PURE__*/React.createElement("li", {
    className: [style$_['tool-info'], style$_.paste].join(' ')
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableTools.includes(ERichTextTool.paste),
    type: "button",
    className: style$_['tool-btn'],
    onClick: onPaste
  }), /*#__PURE__*/React.createElement(ToolTip, {
    title: "\u7C98\u8D34"
  })), /*#__PURE__*/React.createElement("li", {
    className: [style$_['tool-info'], style$_.formula, isShowFormula ? style$_['tool-select'] : ''].join(' ')
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disableTools.includes(ERichTextTool.formula),
    type: "button",
    className: style$_['tool-btn'],
    onClick: handleShowFormula
  }), /*#__PURE__*/React.createElement(ToolTip, {
    title: "\u516C\u5F0F"
  }))), isShowFormula ? /*#__PURE__*/React.createElement("div", {
    className: style$_['formula-tab']
  }, /*#__PURE__*/React.createElement("ul", {
    className: style$_['type-name-list']
  }, FormulaTabList.map(function (tab) {
    var tabName = FormulaTypeName[tab];
    return /*#__PURE__*/React.createElement("li", {
      key: tab,
      className: [style$_['type-name'], currentFormula === tab ? style$_.active : ''].join(' '),
      onClick: function onClick() {
        return handleChangeTab(tab);
      }
    }, tabName);
  })), /*#__PURE__*/React.createElement("ul", {
    className: style$_['formula-box']
  }, formulaList.map(function (formula) {
    return /*#__PURE__*/React.createElement("li", {
      className: style$_['formula-symbol'],
      key: formula.latex,
      onClick: function onClick(_) {
        return handleInputLatex(formula.latex);
      },
      style: {
        backgroundImage: "url(".concat(IconBaseUrl[currentFormula]).concat(formula.iconKey, ".svg)")
      }
    });
  }))) : null);
}

var selection = getUserSelection();
var bgMathSpanList = [];
var emitTimer;
/* eslint-disable-next-line */

var RichEditor = function RichEditor(props) {
  var answerList = props.answerList,
      questionId = props.questionId,
      dispatchAnsSort = props.dispatchAnsSort,
      onEditorFocus = props.onEditorFocus,
      onEditorBlur = props.onEditorBlur;

  var _a = useState(0),
      remainCount = _a[0],
      setRemainCount = _a[1];

  var _b = useState(false),
      isEmpty = _b[0],
      setEmpty = _b[1];

  var _c = useState(false),
      isShowToolBar = _c[0],
      setToolbarShow = _c[1];

  var _d = useState([ERichTextTool.formula]),
      disableTools = _d[0],
      setDisableTools = _d[1];

  var _e = useState(false),
      lock = _e[0],
      setLock = _e[1];

  var _f = useState({
    timerId: 0,
    msg: '',
    isShow: false
  }),
      toast = _f[0],
      setToast = _f[1];

  var editorDomRef = useRef(null);
  var contentRef = useRef('');
  var MQRef = useRef(null);
  var lastFocusMathFieldRef = useRef(null);

  function setToastInfo(msg) {
    if (toast.timerId) {
      window.clearTimeout(toast.timerId);
    }

    var timerId = window.setTimeout(function () {
      setToast({
        isShow: false,
        msg: '',
        timerId: timerId
      });
    }, 3000);
    setToast({
      isShow: true,
      msg: msg,
      timerId: timerId
    });
  }

  function deleteRangeContent(range) {
    var _a, _b, _c, _d, _e, _f;

    if (!range) {
      return;
    }

    if ((_b = (_a = range.startContainer) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, "data-".concat(FormulaMark))) {
      (_c = range.startContainer.parentElement) === null || _c === void 0 ? void 0 : _c.removeChild(range.startContainer);
    }

    if ((_e = (_d = range.endContainer) === null || _d === void 0 ? void 0 : _d.getAttribute) === null || _e === void 0 ? void 0 : _e.call(_d, "data-".concat(FormulaMark))) {
      (_f = range.endContainer.parentElement) === null || _f === void 0 ? void 0 : _f.removeChild(range.endContainer);
    }

    range.deleteContents();
  }

  function formateOutputContent(contentBox) {
    Array.from(contentBox.querySelectorAll('script')).forEach(function (ele) {
      var _a;

      return (_a = ele.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(ele);
    });
    var mathSpanList = Array.from(contentBox.querySelectorAll("[data-".concat(FormulaMark, "]")));
    mathSpanList.forEach(function (mathSpan) {
      var latex = mathSpan.getAttribute('data-latex');
      mathSpan.removeAttribute('data-latex');
      mathSpan.removeAttribute('contenteditable');
      mathSpan.removeAttribute('class');
      mathSpan.textContent = latex;
    });
    return contentBox.innerHTML.replace(new RegExp(zeroWidth, 'g'), '');
  } // 提交作答结果


  function confirmSubText(curContent) {
    if (curContent === void 0) {
      curContent = '';
    }

    var curAnswerList = curContent ? [{
      resource: curContent,
      resourceType: ESubmitItemTypes.TEXT
    }] : [];
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.ADD,
      answerType: ESubmitType.TEXT,
      answerList: curAnswerList
    });
  }

  function getContent() {
    if (!editorDomRef.current) {
      return '';
    }

    var cloneEditor = editorDomRef.current.cloneNode(true);
    return formateOutputContent(cloneEditor);
  }

  function emitContent() {
    var content = getContent();
    contentRef.current = content;
    confirmSubText(content);
  }

  function readyEmitContent() {
    if (emitTimer) {
      clearTimeout(emitTimer);
    }

    emitTimer = setTimeout(function () {
      emitContent();
    }, 100);
  }

  function initMQDomEvent(MQDom, mathField) {
    mathField.__controller.textarea.bind('focus', function () {
      lastFocusMathFieldRef.current = mathField;
    });

    mathField.__controller.textarea.bind('blur', function (event) {
      lastFocusMathFieldRef.current = null;
    });

    MQDom.addEventListener('input', function (event) {
      readyEmitContent();
      event.stopPropagation();
    });
    MQDom.addEventListener('paste', function (event) {
      return event.stopPropagation();
    });
    MQDom.addEventListener('copy', function (event) {
      return lastFocusMathFieldRef.current && event.stopPropagation();
    });
    MQDom.addEventListener('cut', function (event) {
      return lastFocusMathFieldRef.current && event.stopPropagation();
    });
  }

  function initStaticMath(dom) {
    /* eslint-disable-next-line */
    return MQRef.current.StaticMath(dom);
  }

  function initEditableMath(dom) {
    /* eslint-disable-next-line */
    return MQRef.current.MathField(dom, {
      statelessClipboard: true,
      handlers: {
        edit: function edit(mathField) {
          dom.setAttribute('data-latex', mathField.latex());

          if (!mathField.latex()) {
            dom.remove();
          }
        }
      }
    });
  }

  function filterScriptTag(content) {
    return content.replace(/<script[\s\S]*?<\/script>/g, '');
  }

  function setContent(content) {
    if (!editorDomRef.current) {
      return false;
    }

    content = filterScriptTag(content);
    editorDomRef.current.innerHTML = content;
    var mathSpanList = Array.from(editorDomRef.current.querySelectorAll("[data-".concat(FormulaMark, "]")));
    mathSpanList.forEach(function (mathSpan) {
      var _a, _b;

      mathSpan.setAttribute('data-latex', mathSpan.textContent || '');
      mathSpan.setAttribute('contenteditable', 'false');
      var beforText = document.createTextNode(zeroWidth);
      var afterText = beforText.cloneNode(false);
      (_a = mathSpan.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(afterText, mathSpan.nextSibling);
      (_b = mathSpan.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(beforText, mathSpan);
    });
  }

  function setSelectionBg() {
    if (!selection || !selection.rangeCount || !editorDomRef.current) {
      bgMathSpanList.forEach(function (ele) {
        ele.classList.remove('select-bg');
      });
      bgMathSpanList.length = 0;
      return false;
    }

    var range = selection.getRangeAt(0);

    if (range.collapsed) {
      bgMathSpanList.forEach(function (ele) {
        ele.classList.remove('select-bg');
      });
      bgMathSpanList.length = 0;
      return false;
    }

    var mathSpanList = Array.from(editorDomRef.current.querySelectorAll("[data-".concat(FormulaMark, "]")));
    mathSpanList.forEach(function (ele) {
      if (range.intersectsNode(ele)) {
        bgMathSpanList.push(ele);
        ele.classList.add('select-bg');
      } else {
        ele.classList.remove('select-bg');
      }
    });
  }

  function watchMove(event) {
    if (!editorDomRef.current) {
      return;
    }

    document.ontouchmove = null;
    var touchDom = event.target; // 若点击区域在dom元素之外，失焦

    !editorDomRef.current.contains(touchDom) && editorDomRef.current.blur();
  }

  function watchTouch(event) {
    if (!editorDomRef.current) {
      return;
    }

    document.ontouchmove = function () {
      // 移动时传入touchStart时的事件（判断触摸区域是否为当前题目）
      watchMove(event);
    };
  }

  function getFontSum() {
    if (!editorDomRef.current) {
      return 0;
    }

    var cloneEditor = editorDomRef.current.cloneNode(true);
    var mathSpanList = Array.from(cloneEditor.querySelectorAll("[data-".concat(FormulaMark, "]")));
    var mathSum = mathSpanList.length;
    mathSpanList.forEach(function (mathspan) {
      var _a;

      return (_a = mathspan.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(mathspan);
    });
    var text = cloneEditor.textContent.replace(new RegExp(zeroWidth, 'g'), '');
    var fontSum = text.length + mathSum;
    return fontSum;
  }

  function updateFontSum() {
    if (!editorDomRef.current) {
      return 0;
    }

    var fontSum = getFontSum();
    setRemainCount(EAnswerTypeMaxCount.TEXT - fontSum);
    var isEmpty = Boolean(!fontSum && editorDomRef.current.querySelectorAll('p').length < 2);
    setEmpty(isEmpty);
  } // 兼容之前纯文本数据，其可能存在换行符。


  function formateInputContent(content) {
    var paragraphList = content.split('\n');
    return paragraphList.map(function (paragraph) {
      return /^<p[\s\S]*<\/p>$/.test(paragraph) ? paragraph : "<p>".concat(paragraph, "</p>");
    }).join('');
  }

  function handleFocus(event) {
    onEditorFocus === null || onEditorFocus === void 0 ? void 0 : onEditorFocus(event);
    isMobile || setToolbarShow(true);
    window.addEventListener('touchstart', watchTouch);
  }

  function handleBlur(event) {
    onEditorBlur === null || onEditorBlur === void 0 ? void 0 : onEditorBlur(event);
    window.removeEventListener('touchstart', watchTouch);
    isMobile || setToolbarShow(false);
  }

  function handleCompositionStart() {
    setEmpty(false);
    setLock(true);
  }

  function handleCompositionEnd() {
    var _a;

    var fontSum = getFontSum();

    if (fontSum > EAnswerTypeMaxCount.TEXT) {
      var range = selection === null || selection === void 0 ? void 0 : selection.getRangeAt(0);
      var diffSum = fontSum - EAnswerTypeMaxCount.TEXT;
      var offset = (_a = range === null || range === void 0 ? void 0 : range.endOffset) !== null && _a !== void 0 ? _a : 0;
      range === null || range === void 0 ? void 0 : range.setStart(range.endContainer, offset - diffSum);
      deleteRangeContent(range);
      setRemainCount(0);
    } else {
      setRemainCount(EAnswerTypeMaxCount.TEXT - fontSum);
      var isEmpty_1 = Boolean(!fontSum && editorDomRef.current.querySelectorAll('p').length < 2);
      setEmpty(isEmpty_1);
    }

    var content = getContent();
    contentRef.current = content;
    confirmSubText(content);
    setLock(false);
  }

  function handleKeyPress(event) {
    if (remainCount <= 0 && !lastFocusMathFieldRef.current) {
      event.preventDefault();
      return false;
    }
  }

  function getCopyCutContent(isClearRange) {
    if (!selection || !selection.rangeCount) {
      return '';
    }

    var range = selection.getRangeAt(0);

    if (range.collapsed) {
      return '';
    }

    var frag = range.cloneContents();

    if (isClearRange) {
      deleteRangeContent(range);
      updateFontSum();
    }

    range.detach();
    var contentBox = document.createElement('div');
    contentBox.appendChild(frag);
    return formateOutputContent(contentBox);
  }

  function handleCopyCutEvent(event, isClearRange) {
    var clipboardData = event.clipboardData;
    var content = getCopyCutContent(isClearRange);
    clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.setData('text/plain', content);
    event.preventDefault();
  }

  function collectTextNode(domBox, nodeList) {
    domBox.childNodes.forEach(function (child) {
      var _a, _b;

      if (child.nodeType === 3) {
        nodeList.push((_b = (_a = child.nodeValue) === null || _a === void 0 ? void 0 : _a.replace(new RegExp(zeroWidth, 'g'), '')) !== null && _b !== void 0 ? _b : '');
      } else if (child.nodeType === 1) {
        if (child.getAttribute("data-".concat(FormulaMark))) {
          nodeList.push(child);
        } else {
          collectTextNode(child, nodeList);
        }
      }
    });
  }

  function formatePasteContent(content) {
    var domBox = document.createElement('div');
    domBox.innerHTML = content;
    var nodeList = [];
    collectTextNode(domBox, nodeList);
    var fontSum = nodeList.reduce(function (pre, cur) {
      if (cur.nodeType === 1) {
        return pre + 1;
      }

      return pre + cur.length;
    }, 0);

    if (fontSum <= remainCount) {
      return content;
    }

    var diffSum = fontSum - remainCount;

    for (var i = nodeList.length - 1; i >= 0; i--) {
      var item = nodeList[i];
      var length_1 = item.nodeType === 1 ? 1 : item.length;

      if (length_1 > diffSum) {
        nodeList[i] = item.slice(0, length_1 - diffSum);
        diffSum = 0;
      } else {
        nodeList.splice(i, 1);
        diffSum = diffSum - length_1;
      }

      if (diffSum <= 0) {
        break;
      }
    }

    var string = nodeList.reduce(function (pre, cur) {
      if (cur.nodeType === 1) {
        return pre + zeroWidth + cur.outerHTML + zeroWidth;
      }

      return pre + cur;
    }, '');
    return string;
  }

  function pasteContentToEditor(content) {
    if (!selection || !selection.rangeCount) {
      return false;
    }

    var range = selection.getRangeAt(0);

    if (!range.collapsed) {
      deleteRangeContent(range);
    }

    if (content.slice(0, 1) === '$' && content.slice(-1) === '$') {
      content = content.slice(1, -1);
      content = "<span data-".concat(FormulaMark, "='1'>").concat(content, "</span>");
    }

    content = formatePasteContent(content);
    var box = document.createElement('div');
    box.innerHTML = content;
    var mathSpanList = Array.from(box.querySelectorAll("[data-".concat(FormulaMark, "]")));
    mathSpanList.forEach(function (mathSpan) {
      var _a, _b;

      mathSpan.setAttribute('data-latex', mathSpan.textContent || '');
      mathSpan.setAttribute('contenteditable', 'false');
      var beforText = document.createTextNode(zeroWidth);
      var afterText = beforText.cloneNode(false);
      (_a = mathSpan.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(afterText, mathSpan.nextSibling);
      (_b = mathSpan.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(beforText, mathSpan);

      if (isMobile) {
        initStaticMath(mathSpan);
      } else {
        var mathField = initEditableMath(mathSpan);
        initMQDomEvent(mathSpan, mathField);
      }
    });
    Array.from(box.childNodes).reverse().forEach(function (ele) {
      range.insertNode(ele);
    });
    range.collapse(false);
  }

  function handlePasteEvent(event) {
    var _a;

    event.preventDefault();

    if (remainCount <= 0) {
      return;
    }

    var clipboardData = event.clipboardData;
    var content = (_a = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text/plain')) !== null && _a !== void 0 ? _a : '';

    if (!content) {
      return;
    }

    pasteContentToEditor(content);
    updateFontSum();
    readyEmitContent();
    event.preventDefault();
  }

  function insertMQDom(latex) {
    if (!selection) {
      return;
    } //  工具栏显示时才能插入公式，所以插入公式时一定会有选区。


    var range = selection.getRangeAt(0);

    if (!range.collapsed) {
      deleteRangeContent(range);
    }

    var span = document.createElement('span');
    span.setAttribute("data-".concat(FormulaMark), '1');
    span.setAttribute('contenteditable', 'false');
    span.setAttribute('data-latex', latex);
    span.textContent = latex;
    var beforText = document.createTextNode(zeroWidth);
    var afterText = beforText.cloneNode(false);
    var frag = document.createDocumentFragment();
    frag.appendChild(beforText);
    frag.appendChild(span);
    frag.appendChild(afterText);
    range.insertNode(frag);

    if (isMobile) {
      initStaticMath(span);
      range.collapse(false);
    } else {
      var mathField = initEditableMath(span);
      initMQDomEvent(span, mathField);
      mathField.keystroke('Left');
      range.collapse(false);
      mathField.focus();
    }
  }

  function handleInputLatex(latex) {
    if (lastFocusMathFieldRef.current) {
      lastFocusMathFieldRef.current.write(latex);
      readyEmitContent();
      return;
    }

    if (remainCount <= 0) {
      return;
    }

    insertMQDom(latex);
    updateFontSum();
    readyEmitContent();
  }

  function focusEditor() {
    var _a;

    (_a = editorDomRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  }

  function handleCopy() {
    var _a;

    if ((_a = document.execCommand) === null || _a === void 0 ? void 0 : _a.call(document, 'copy')) {
      return true;
    }

    var clipboard = window.navigator.clipboard;

    if (!clipboard) {
      setToastInfo('请使用高于66版本Chrome浏览器使用该功能');
      return false;
    }

    var content = getCopyCutContent(false);
    clipboard.writeText(content).catch(function () {
      return setToastInfo('剪切板权限已禁止，请到浏览器设置里开启');
    });
  }

  function handleCut() {
    var _a;

    if ((_a = document.execCommand) === null || _a === void 0 ? void 0 : _a.call(document, 'cut')) {
      return true;
    }

    var clipboard = window.navigator.clipboard;

    if (!clipboard) {
      setToastInfo('请使用高于66版本Chrome浏览器使用该功能');
      return false;
    }

    var content = getCopyCutContent(true);
    clipboard.writeText(content).catch(function () {
      return setToastInfo('剪切板权限已禁止，请到浏览器设置里开启');
    });
  }

  function handlePaste() {
    var _a;

    return __awaiter$2(this, void 0, void 0, function () {
      var clipboard, content, textarea, _b, selectionStart, selectionEnd, value;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (remainCount <= 0) {
              return [2
              /*return*/
              ];
            }

            if ((_a = document.execCommand) === null || _a === void 0 ? void 0 : _a.call(document, 'paste')) {
              return [2
              /*return*/
              , true];
            }

            clipboard = window.navigator.clipboard;

            if (!clipboard) {
              setToastInfo('请使用高于66版本Chrome浏览器使用该功能');
              return [2
              /*return*/
              , false];
            }

            _d.label = 1;

          case 1:
            _d.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , clipboard.readText()];

          case 2:
            content = _d.sent();

            if (!content) {
              return [2
              /*return*/
              ];
            }

            if (lastFocusMathFieldRef.current) {
              textarea = lastFocusMathFieldRef.current.__controller.textarea;
              _b = textarea[0], selectionStart = _b.selectionStart, selectionEnd = _b.selectionEnd, value = _b.value;
              /* eslint-disable-next-line */

              textarea.val("".concat(value.substring(0, selectionStart)).concat(content).concat(value.substring(selectionEnd, value.length)));
              textarea.trigger('paste');
              readyEmitContent();
              return [2
              /*return*/
              ];
            }

            pasteContentToEditor(content);
            updateFontSum();
            readyEmitContent();
            return [3
            /*break*/
            , 4];

          case 3:
            _d.sent();
            setToastInfo('剪切板权限已禁止，请到浏览器设置里开启');
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  function renderContentMath() {
    var _a, _b;

    Array.from((_b = (_a = editorDomRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-".concat(FormulaMark, "]"))) !== null && _b !== void 0 ? _b : []).forEach(function (ele) {
      if (isMobile) {
        initStaticMath(ele);
        ele.setAttribute('data-disabled', '1');
      } else {
        var mathField = initEditableMath(ele);
        initMQDomEvent(ele, mathField);
      }
    });
  }

  function handleInput() {
    if (lock) {
      return;
    }

    updateFontSum();
    var content = getContent();

    if (!content) {
      content = '<p><br></p>';
      setContent(content);
    }

    contentRef.current = content;
    confirmSubText(content);
  }

  useEffect(function () {
    document.addEventListener('selectionchange', setSelectionBg);
    downloadDependency().then(function (MQ) {
      MQRef.current = MQ;
      setDisableTools([]);
      renderContentMath();
    });
    return function () {
      document.removeEventListener('selectionchange', setSelectionBg);
    };
  }, []);
  useEffect(function () {
    var _a, _b, _c, _d;
    /**
     * 解决 编辑时光标回到编辑器头部的问题。
     */


    if ((_b = contentRef.current !== ((_a = answerList === null || answerList === void 0 ? void 0 : answerList[0]) === null || _a === void 0 ? void 0 : _a.resource)) !== null && _b !== void 0 ? _b : '') {
      var content = formateInputContent((_d = (_c = answerList === null || answerList === void 0 ? void 0 : answerList[0]) === null || _c === void 0 ? void 0 : _c.resource) !== null && _d !== void 0 ? _d : '');
      setContent(content);
      updateFontSum();
      MQRef.current && renderContentMath();
    }
  }, [answerList, questionId]); // 失焦时滚动到视口顶部

  var focusOutScroll = function focusOutScroll() {
    window.scrollTo(0, 0);
  };

  useEffect(function () {
    var textDom = editorDomRef.current;

    if (isIOS) {
      textDom === null || textDom === void 0 ? void 0 : textDom.addEventListener('focusout', focusOutScroll, true);
    }

    return function () {
      if (isIOS) {
        textDom === null || textDom === void 0 ? void 0 : textDom.addEventListener('focusout', focusOutScroll, true);
      }
    };
  }, [editorDomRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: style$_['rich-text-container']
  }, /*#__PURE__*/React.createElement("div", {
    ref: editorDomRef,
    "data-placeholder": MyAnswerPlaceholder,
    className: [style$_['rich-text'], isEmpty ? style$_.empty : ''].join(' '),
    contentEditable: true,
    tabIndex: -1,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyPress: handleKeyPress,
    onCompositionStart: handleCompositionStart,
    onCompositionEnd: handleCompositionEnd,
    onCopy: function onCopy(event) {
      return handleCopyCutEvent(event, false);
    },
    onCut: function onCut(event) {
      return handleCopyCutEvent(event, true);
    },
    onPaste: handlePasteEvent,
    onInput: handleInput
  }), isShowToolBar ? /*#__PURE__*/React.createElement(Toolbar, {
    disableTools: disableTools,
    onInputLatex: handleInputLatex,
    onFocusEditor: focusEditor,
    onCopy: handleCopy,
    onPaste: handlePaste,
    onCut: handleCut
  }) : null, /*#__PURE__*/React.createElement("p", {
    className: style$_['font-sum']
  }, remainCount), toast.isShow ? /*#__PURE__*/React.createElement(Toast, {
    msg: toast.msg,
    customToastStyle: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      height: '46px',
      minWidth: '190px',
      padding: '0 16px',
      pointerEvents: 'none'
    }
  }) : null);
};

function ownKeys(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, a);
  }

  return n;
}

function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ownKeys(Object(n), !0).forEach(function (t) {
      _defineProperty(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function _typeof(e) {
  return _typeof = "function" === typeof Symbol && "symbol" === _typeof$1(Symbol.iterator) ? function (e) {
    return _typeof$1(e);
  } : function (e) {
    return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
  }, _typeof(e);
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

var e = function createCommonjsModule(e, t, n) {
  return e(n = {
    path: t,
    exports: {},
    require: function require(e, t) {
      return function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }((void 0 === t || null === t) && n.path);
    }
  }, n.exports), n.exports;
}(function (e) {
  !function (e) {
    var t = "2021-08-03 20:01:03",
        NOOP = function NOOP() {},
        Recorder = function Recorder(e) {
      return new initFn(e);
    };

    Recorder.IsOpen = function () {
      var e = Recorder.Stream;

      if (e) {
        var t = (e.getTracks && e.getTracks() || e.audioTracks || [])[0];

        if (t) {
          var n = t.readyState;
          return "live" == n || n == t.LIVE;
        }
      }

      return !1;
    }, Recorder.BufferSize = 4096, Recorder.Destroy = function () {
      for (var e in CLog("Recorder Destroy"), Disconnect(), n) {
        n[e]();
      }
    };
    var n = {};
    Recorder.BindDestroy = function (e, t) {
      n[e] = t;
    }, Recorder.Support = function () {
      var t = e.AudioContext;
      if (t || (t = e.webkitAudioContext), !t) return !1;
      var n = navigator.mediaDevices || {};
      return n.getUserMedia || (n = navigator).getUserMedia || (n.getUserMedia = n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia), !!n.getUserMedia && (Recorder.Scope = n, Recorder.Ctx && "closed" != Recorder.Ctx.state || (Recorder.Ctx = new t(), Recorder.BindDestroy("Ctx", function () {
        var e = Recorder.Ctx;
        e && e.close && (e.close(), Recorder.Ctx = 0);
      })), !0);
    };

    var Connect = function Connect(e) {
      var t = (e = e || Recorder).BufferSize || Recorder.BufferSize,
          n = Recorder.Ctx,
          a = e.Stream,
          r = a._m = n.createMediaStreamSource(a),
          s = a._p = (n.createScriptProcessor || n.createJavaScriptNode).call(n, t, 1, 1);
      r.connect(s), s.connect(n.destination);
      var o = a._call;

      s.onaudioprocess = function (e) {
        for (var t in o) {
          for (var n = e.inputBuffer.getChannelData(0), a = n.length, r = new Int16Array(a), s = 0, i = 0; i < a; i++) {
            var _ = Math.max(-1, Math.min(1, n[i]));

            _ = _ < 0 ? 32768 * _ : 32767 * _, r[i] = _, s += Math.abs(_);
          }

          for (var l in o) {
            o[l](r, s);
          }

          return;
        }
      };
    },
        Disconnect = function Disconnect(e) {
      var t = (e = e || Recorder) == Recorder,
          n = e.Stream;

      if (n && (n._m && (n._m.disconnect(), n._p.disconnect(), n._p.onaudioprocess = n._p = n._m = null), t)) {
        for (var a = n.getTracks && n.getTracks() || n.audioTracks || [], r = 0; r < a.length; r++) {
          var s = a[r];
          s.stop && s.stop();
        }

        n.stop && n.stop();
      }

      e.Stream = 0;
    };

    Recorder.SampleData = function (e, t, n, a, r) {
      a || (a = {});
      var s = a.index || 0,
          o = a.offset || 0,
          i = a.frameNext || [];
      r || (r = {});

      var _ = r.frameSize || 1;

      r.frameType && (_ = "mp3" == r.frameType ? 1152 : 1);

      for (var l = 0, c = s; c < e.length; c++) {
        l += e[c].length;
      }

      l = Math.max(0, l - Math.floor(o));
      var f = t / n;
      f > 1 ? l = Math.floor(l / f) : (f = 1, n = t), l += i.length;
      var u = new Int16Array(l),
          d = 0;

      for (c = 0; c < i.length; c++) {
        u[d] = i[c], d++;
      }

      for (var h = e.length; s < h; s++) {
        for (var p = e[s], m = (c = o, p.length); c < m;) {
          var b = Math.floor(c),
              v = Math.ceil(c),
              g = c - b,
              w = p[b],
              E = v < m ? p[v] : (e[s + 1] || [w])[0] || 0;
          u[d] = w + (E - w) * g, d++, c += f;
        }

        o = c - m;
      }

      i = null;
      var S = u.length % _;

      if (S > 0) {
        var M = 2 * (u.length - S);
        i = new Int16Array(u.buffer.slice(M)), u = new Int16Array(u.buffer.slice(0, M));
      }

      return {
        index: s,
        offset: o,
        frameNext: i,
        sampleRate: n,
        data: u
      };
    }, Recorder.PowerLevel = function (e, t) {
      var n = e / t || 0;
      return n < 1251 ? Math.round(n / 1250 * 10) : Math.round(Math.min(100, Math.max(0, 100 * (1 + Math.log(n / 1e4) / Math.log(10)))));
    };

    var CLog = function CLog(e, t) {
      var n = new Date(),
          a = ["[" + ("0" + n.getMinutes()).substr(-2) + ":" + ("0" + n.getSeconds()).substr(-2) + "." + ("00" + n.getMilliseconds()).substr(-3) + " Recorder]" + e],
          r = arguments,
          s = 2,
          o = console.log;

      for ("number" == typeof t ? o = 1 == t ? console.error : 3 == t ? console.warn : o : s = 1; s < r.length; s++) {
        a.push(r[s]);
      }

      o.apply(console, a);
    };

    Recorder.CLog = CLog;
    var a = 0;

    function initFn(e) {
      this.id = ++a, Recorder.Traffic && Recorder.Traffic();
      var t = {
        type: "mp3",
        bitRate: 16,
        sampleRate: 16e3,
        onProcess: NOOP
      };

      for (var n in e) {
        t[n] = e[n];
      }

      this.set = t, this._S = 9, this.Sync = {
        O: 9,
        C: 9
      };
    }

    Recorder.Sync = {
      O: 9,
      C: 9
    }, Recorder.prototype = initFn.prototype = {
      _streamStore: function _streamStore() {
        return this.set.sourceStream ? this : Recorder;
      },
      open: function open(t, n) {
        var a = this,
            r = a._streamStore();

        t = t || NOOP;

        var failCall = function failCall(e, t) {
          CLog("\u5F55\u97F3open\u5931\u8D25\uFF1A" + e + ",isUserNotAllow:" + (t = !!t), 1), n && n(e, t);
        },
            ok = function ok() {
          CLog("open\u6210\u529F"), t(), a._SO = 0;
        },
            s = r.Sync,
            o = ++s.O,
            i = s.C;

        a._O = a._O_ = o, a._SO = a._S;

        var lockFail = function lockFail() {
          if (i != s.C || !a._O) {
            var e = "open\u88AB\u53D6\u6D88";
            return o == s.O ? a.close() : e = "open\u88AB\u4E2D\u65AD", failCall(e), !0;
          }
        },
            _ = a.envCheck({
          envName: "H5",
          canProcess: !0
        });

        if (_) failCall("\u4E0D\u80FD\u5F55\u97F3\uFF1A" + _);else if (a.set.sourceStream) {
          if (!Recorder.Support()) return void failCall("\u4E0D\u652F\u6301\u6B64\u6D4F\u89C8\u5668\u4ECE\u6D41\u4E2D\u83B7\u53D6\u5F55\u97F3");
          Disconnect(r), a.Stream = a.set.sourceStream, a.Stream._call = {};

          try {
            Connect(r);
          } catch (c) {
            return void failCall("\u4ECE\u6D41\u4E2D\u6253\u5F00\u5F55\u97F3\u5931\u8D25\uFF1A" + c.message);
          }

          ok();
        } else {
          var codeFail = function codeFail(t, n) {
            try {
              e.top.a;
            } catch (c) {
              return void failCall("\u65E0\u6743\u5F55\u97F3(\u8DE8\u57DF\uFF0C\u8BF7\u5C1D\u8BD5\u7ED9iframe\u6DFB\u52A0\u9EA6\u514B\u98CE\u8BBF\u95EE\u7B56\u7565\uFF0C\u5982allow=\"camera;microphone\")");
            }

            /Permission|Allow/i.test(t) ? failCall("\u7528\u6237\u62D2\u7EDD\u4E86\u5F55\u97F3\u6743\u9650", !0) : !1 === e.isSecureContext ? failCall("\u65E0\u6743\u5F55\u97F3(\u9700https)") : /Found/i.test(t) ? failCall(n + "\uFF0C\u65E0\u53EF\u7528\u9EA6\u514B\u98CE") : failCall(n);
          };

          if (Recorder.IsOpen()) ok();else if (Recorder.Support()) {
            var f1 = function f1(e) {
              Recorder.Stream = e, e._call = {}, lockFail() || setTimeout(function () {
                lockFail() || (Recorder.IsOpen() ? (Connect(), ok()) : failCall("\u5F55\u97F3\u529F\u80FD\u65E0\u6548\uFF1A\u65E0\u97F3\u9891\u6D41"));
              }, 100);
            },
                f2 = function f2(e) {
              var t = e.name || e.message || e.code + ":" + e;
              CLog("\u8BF7\u6C42\u5F55\u97F3\u6743\u9650\u9519\u8BEF", 1, e), codeFail(t, "\u65E0\u6CD5\u5F55\u97F3\uFF1A" + t);
            },
                l = Recorder.Scope.getUserMedia({
              audio: a.set.audioTrackSet || !0
            }, f1, f2);

            l && l.then && l.then(f1)[t && "catch"](f2);
          } else codeFail("", "\u6B64\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u5F55\u97F3");
        }
      },
      close: function close(e) {
        e = e || NOOP;

        var t = this,
            n = t._streamStore();

        t._stop();

        var a = n.Sync;
        if (t._O = 0, t._O_ != a.O) return CLog("close\u88AB\u5FFD\u7565", 3), void e();
        a.C++, Disconnect(n), CLog("close"), e();
      },
      mock: function mock(e, t) {
        var n = this;
        return n._stop(), n.isMock = 1, n.mockEnvInfo = null, n.buffers = [e], n.recSize = e.length, n.srcSampleRate = t, n;
      },
      envCheck: function envCheck(e) {
        var t,
            n = this,
            a = n.set;
        return t || (n[a.type + "_envCheck"] ? t = n[a.type + "_envCheck"](e, a) : a.takeoffEncodeChunk && (t = a.type + "\u7C7B\u578B\u4E0D\u652F\u6301\u8BBE\u7F6EtakeoffEncodeChunk")), t || "";
      },
      envStart: function envStart(e, t) {
        var n = this,
            a = n.set;

        if (n.isMock = e ? 1 : 0, n.mockEnvInfo = e, n.buffers = [], n.recSize = 0, n.envInLast = 0, n.envInFirst = 0, n.envInFix = 0, n.envInFixTs = [], a.sampleRate = Math.min(t, a.sampleRate), n.srcSampleRate = t, n.engineCtx = 0, n[a.type + "_start"]) {
          var r = n.engineCtx = n[a.type + "_start"](a);
          r && (r.pcmDatas = [], r.pcmSize = 0);
        }
      },
      envResume: function envResume() {
        this.envInFixTs = [];
      },
      envIn: function envIn(e, t) {
        var n = this,
            a = n.set,
            r = n.engineCtx,
            s = n.srcSampleRate,
            o = e.length,
            i = Recorder.PowerLevel(t, o),
            _ = n.buffers,
            l = _.length;

        _.push(e);

        var c = _,
            f = l,
            u = Date.now(),
            d = Math.round(o / s * 1e3);
        n.envInLast = u, 1 == n.buffers.length && (n.envInFirst = u - d);
        var h = n.envInFixTs;
        h.splice(0, 0, {
          t: u,
          d: d
        });

        for (var p = u, m = 0, b = 0; b < h.length; b++) {
          var v = h[b];

          if (u - v.t > 3e3) {
            h.length = b;
            break;
          }

          p = v.t, m += v.d;
        }

        var g = h[1],
            w = u - p;

        if (w - m > w / 3 && (g && w > 1e3 || h.length >= 6)) {
          var E = u - g.t - d;

          if (E > d / 5) {
            var S = !a.disableEnvInFix;

            if (CLog("[" + u + "]" + (S ? "" : "\u672A") + "\u8865\u507F" + E + "ms", 3), n.envInFix += E, S) {
              var M = new Int16Array(E * s / 1e3);
              o += M.length, _.push(M);
            }
          }
        }

        var y = n.recSize,
            B = o,
            R = y + B;

        if (n.recSize = R, r) {
          var A = Recorder.SampleData(_, s, a.sampleRate, r.chunkInfo);
          r.chunkInfo = A, R = (y = r.pcmSize) + (B = A.data.length), r.pcmSize = R, _ = r.pcmDatas, l = _.length, _.push(A.data), s = A.sampleRate;
        }

        var T = Math.round(R / s * 1e3),
            k = _.length,
            x = c.length,
            asyncEnd = function asyncEnd() {
          for (var e = P ? 0 : -B, t = null == _[0], s = l; s < k; s++) {
            var o = _[s];
            null == o ? t = 1 : (e += o.length, r && o.length && n[a.type + "_encode"](r, o));
          }

          if (t && r) for (s = f, c[0] && (s = 0); s < x; s++) {
            c[s] = null;
          }
          t && (e = P ? B : 0, _[0] = null), r ? r.pcmSize += e : n.recSize += e;
        },
            P = a.onProcess(_, i, T, s, l, asyncEnd);

        if (!0 === P) {
          var I = 0;

          for (b = l; b < k; b++) {
            null == _[b] ? I = 1 : _[b] = new Int16Array(0);
          }

          I ? CLog("\u672A\u8FDB\u5165\u5F02\u6B65\u524D\u4E0D\u80FD\u6E05\u9664buffers", 3) : r ? r.pcmSize -= B : n.recSize -= B;
        } else asyncEnd();
      },
      start: function start() {
        var e = this,
            t = Recorder.Ctx,
            n = 1;
        if (e.set.sourceStream ? e.Stream || (n = 0) : Recorder.IsOpen() || (n = 0), n) {
          if (CLog("\u5F00\u59CB\u5F55\u97F3"), e._stop(), e.state = 0, e.envStart(null, t.sampleRate), e._SO && e._SO + 1 != e._S) CLog("start\u88AB\u4E2D\u65AD", 3);else {
            e._SO = 0;

            var end = function end() {
              e.state = 1, e.resume();
            };

            "suspended" == t.state ? t.resume().then(function () {
              CLog("ctx resume"), end();
            }) : end();
          }
        } else CLog("\u672Aopen", 1);
      },
      pause: function pause() {
        var e = this;
        e.state && (e.state = 2, CLog("pause"), delete e._streamStore().Stream._call[e.id]);
      },
      resume: function resume() {
        var e = this;
        e.state && (e.state = 1, CLog("resume"), e.envResume(), e._streamStore().Stream._call[e.id] = function (t, n) {
          1 == e.state && e.envIn(t, n);
        });
      },
      _stop: function _stop(e) {
        var t = this,
            n = t.set;
        t.isMock || t._S++, t.state && (t.pause(), t.state = 0), !e && t[n.type + "_stop"] && (t[n.type + "_stop"](t.engineCtx), t.engineCtx = 0);
      },
      stop: function stop(e, t, n) {
        var a,
            r = this,
            s = r.set;
        CLog("Stop " + (r.envInLast ? r.envInLast - r.envInFirst + "ms \u8865" + r.envInFix + "ms" : "-"));

        var end = function end() {
          r._stop(), n && r.close();
        },
            err = function err(e) {
          CLog("\u7ED3\u675F\u5F55\u97F3\u5931\u8D25\uFF1A" + e, 1), t && t(e), end();
        },
            ok = function ok(t, n) {
          if (CLog("\u7ED3\u675F\u5F55\u97F3 \u7F16\u7801" + (Date.now() - a) + "ms \u97F3\u9891" + n + "ms/" + t.size + "b"), s.takeoffEncodeChunk) CLog("\u542F\u7528takeoffEncodeChunk\u540Estop\u8FD4\u56DE\u7684blob\u957F\u5EA6\u4E3A0\u4E0D\u63D0\u4F9B\u97F3\u9891\u6570\u636E", 3);else if (t.size < Math.max(100, n / 2)) return void err("\u751F\u6210\u7684" + s.type + "\u65E0\u6548");
          e && e(t, n), end();
        };

        if (!r.isMock) {
          if (!r.state) return void err("\u672A\u5F00\u59CB\u5F55\u97F3");

          r._stop(!0);
        }

        var o = r.recSize;
        if (o) {
          if (r.buffers[0]) {
            if (r[s.type]) {
              if (r.isMock) {
                var i = r.envCheck(r.mockEnvInfo || {
                  envName: "mock",
                  canProcess: !1
                });
                if (i) return void err("\u5F55\u97F3\u9519\u8BEF\uFF1A" + i);
              }

              var _ = r.engineCtx;

              if (r[s.type + "_complete"] && _) {
                var l = Math.round(_.pcmSize / s.sampleRate * 1e3);
                return a = Date.now(), void r[s.type + "_complete"](_, function (e) {
                  ok(e, l);
                }, err);
              }

              a = Date.now();
              var c = Recorder.SampleData(r.buffers, r.srcSampleRate, s.sampleRate);
              s.sampleRate = c.sampleRate;
              var f = c.data;
              l = Math.round(f.length / s.sampleRate * 1e3), CLog("\u91C7\u6837" + o + "->" + f.length + " \u82B1:" + (Date.now() - a) + "ms"), setTimeout(function () {
                a = Date.now(), r[s.type](f, function (e) {
                  ok(e, l);
                }, function (e) {
                  err(e);
                });
              });
            } else err("\u672A\u52A0\u8F7D" + s.type + "\u7F16\u7801\u5668");
          } else err("\u97F3\u9891\u88AB\u91CA\u653E");
        } else err("\u672A\u91C7\u96C6\u5230\u5F55\u97F3");
      }
    }, e.Recorder && e.Recorder.Destroy(), e.Recorder = Recorder, Recorder.LM = t, Recorder.TrafficImgUrl = "//ia.51.la/go1?id=20469973&pvFlag=1", Recorder.Traffic = function () {
      var e = Recorder.TrafficImgUrl;

      if (e) {
        var t = Recorder.Traffic,
            n = location.href.replace(/#.*/, "");
        0 == e.indexOf("//") && (e = /^https:/i.test(n) ? "https:" + e : "http:" + e), t[n] || (t[n] = 1, new Image().src = e, CLog("Traffic Analysis Image: Recorder.TrafficImgUrl=" + Recorder.TrafficImgUrl));
      }
    };
  }(window), e.exports && (e.exports = Recorder);
});

!function () {
  var e;
  Recorder.prototype.enc_mp3 = {
    stable: !0,
    testmsg: "\u91C7\u6837\u7387\u8303\u56F448000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000"
  }, Recorder.prototype.mp3 = function (e, t, a) {
    var r = this,
        s = r.set,
        o = e.length,
        i = r.mp3_start(s);
    if (i) return r.mp3_encode(i, e), void r.mp3_complete(i, t, a, 1);

    var _ = new Recorder.lamejs.Mp3Encoder(1, s.sampleRate, s.bitRate),
        l = [],
        c = 0,
        f = 0,
        run = function run() {
      if (c < o) {
        (a = _.encodeBuffer(e.subarray(c, c + 57600))).length > 0 && (f += a.buffer.byteLength, l.push(a.buffer)), c += 57600, setTimeout(run);
      } else {
        var a;
        (a = _.flush()).length > 0 && (f += a.buffer.byteLength, l.push(a.buffer));
        var r = n.fn(l, f, o, s.sampleRate);
        mp3TrimFixSetMeta(r, s), t(new Blob(l, {
          type: "audio/mp3"
        }));
      }
    };

    run();
  }, Recorder.BindDestroy("mp3Worker", function () {
    console.log("mp3Worker Destroy"), e && e.terminate(), e = null;
  }), Recorder.prototype.mp3_envCheck = function (e, t) {
    var n = "";
    return t.takeoffEncodeChunk && (e.canProcess ? newContext() || (n = "\u5F53\u524D\u6D4F\u89C8\u5668\u7248\u672C\u592A\u4F4E\uFF0C\u65E0\u6CD5\u5B9E\u65F6\u5904\u7406") : n = e.envName + "\u73AF\u5883\u4E0D\u652F\u6301\u5B9E\u65F6\u5904\u7406"), n;
  }, Recorder.prototype.mp3_start = function (e) {
    return newContext(e);
  };

  var t = {
    id: 0
  },
      newContext = function newContext(a) {
    var r = e;

    try {
      if (!r) {
        var s = ");wk_lame();var wk_ctxs={};self.onmessage=" + function (e) {
          var t = e.data,
              n = wk_ctxs[t.id];
          if ("init" == t.action) wk_ctxs[t.id] = {
            sampleRate: t.sampleRate,
            bitRate: t.bitRate,
            takeoff: t.takeoff,
            mp3Size: 0,
            pcmSize: 0,
            encArr: [],
            encObj: new wk_lame.Mp3Encoder(1, t.sampleRate, t.bitRate)
          };else if (!n) return;

          switch (t.action) {
            case "stop":
              n.encObj = null, delete wk_ctxs[t.id];
              break;

            case "encode":
              n.pcmSize += t.pcm.length, (a = n.encObj.encodeBuffer(t.pcm)).length > 0 && (n.takeoff ? self.postMessage({
                action: "takeoff",
                id: t.id,
                chunk: a
              }) : (n.mp3Size += a.buffer.byteLength, n.encArr.push(a.buffer)));
              break;

            case "complete":
              var a;
              (a = n.encObj.flush()).length > 0 && (n.takeoff ? self.postMessage({
                action: "takeoff",
                id: t.id,
                chunk: a
              }) : (n.mp3Size += a.buffer.byteLength, n.encArr.push(a.buffer)));
              var r = wk_mp3TrimFix.fn(n.encArr, n.mp3Size, n.pcmSize, n.sampleRate);
              self.postMessage({
                action: t.action,
                id: t.id,
                blob: new Blob(n.encArr, {
                  type: "audio/mp3"
                }),
                meta: r
              });
          }
        };

        s += ";var wk_mp3TrimFix={rm:" + n.rm + ",fn:" + n.fn + "}";
        var o = Recorder.lamejs.toString(),
            i = (window.URL || webkitURL).createObjectURL(new Blob(["var wk_lame=(", o, s], {
          type: "text/javascript"
        }));
        r = new Worker(i), setTimeout(function () {
          (window.URL || webkitURL).revokeObjectURL(i);
        }, 1e4), r.onmessage = function (e) {
          var n = e.data,
              a = t[n.id];
          a && ("takeoff" == n.action ? a.set.takeoffEncodeChunk(new Uint8Array(n.chunk.buffer)) : (a.call && a.call(n), a.call = null));
        };
      }

      var _ = {
        worker: r,
        set: a,
        takeoffQueue: []
      };
      return a ? (_.id = ++t.id, t[_.id] = _, r.postMessage({
        action: "init",
        id: _.id,
        sampleRate: a.sampleRate,
        bitRate: a.bitRate,
        takeoff: !!a.takeoffEncodeChunk,
        x: new Int16Array(5)
      })) : r.postMessage({
        x: new Int16Array(5)
      }), e = r, _;
    } catch (l) {
      return r && r.terminate(), console.error(l), null;
    }
  };

  Recorder.prototype.mp3_stop = function (e) {
    if (e && e.worker) {
      e.worker.postMessage({
        action: "stop",
        id: e.id
      }), e.worker = null, delete t[e.id];
      var n = -1;

      for (var a in t) {
        n++;
      }

      n && console.warn("mp3 worker\u5269" + n + "\u4E2A\u5728\u4E32\u884C\u7B49\u5F85");
    }
  }, Recorder.prototype.mp3_encode = function (e, t) {
    e && e.worker && e.worker.postMessage({
      action: "encode",
      id: e.id,
      pcm: t
    });
  }, Recorder.prototype.mp3_complete = function (e, t, n, a) {
    var r = this;
    e && e.worker ? (e.call = function (n) {
      mp3TrimFixSetMeta(n.meta, e.set), t(n.blob), a && r.mp3_stop(e);
    }, e.worker.postMessage({
      action: "complete",
      id: e.id
    })) : n("mp3\u7F16\u7801\u5668\u672A\u6253\u5F00");
  }, Recorder.mp3ReadMeta = function (e, t) {
    var n = "object" == (typeof window === "undefined" ? "undefined" : _typeof$1(window)) ? window.parseInt : self.parseInt,
        a = new Uint8Array(e[0] || []);
    if (a.length < 4) return null;

    var byteAt = function byteAt(e, t) {
      return ("0000000" + ((t || a)[e] || 0).toString(2)).substr(-8);
    },
        r = byteAt(0) + byteAt(1),
        s = byteAt(2) + byteAt(3);

    if (!/^1{11}/.test(r)) return null;
    var o = {
      "00": 2.5,
      10: 2,
      11: 1
    }[r.substr(11, 2)],
        i = {
      "01": 3
    }[r.substr(13, 2)],
        _ = {
      1: [44100, 48e3, 32e3],
      2: [22050, 24e3, 16e3],
      2.5: [11025, 12e3, 8e3]
    }[o];
    _ && (_ = _[n(s.substr(4, 2), 2)]);
    var l = [[0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]][1 == o ? 1 : 0][n(s.substr(0, 4), 2)];
    if (!o || !i || !l || !_) return null;

    for (var c = Math.round(8 * t / l), f = 1 == i ? 384 : 2 == i || 1 == o ? 1152 : 576, u = f / _ * 1e3, d = Math.floor(f * l / 8 / _ * 1e3), h = 0, p = 0, m = 0; m < e.length; m++) {
      var b = e[m];

      if ((p += b.byteLength) >= d + 3) {
        var v = new Uint8Array(b);
        h = "1" == byteAt(b.byteLength - (p - (d + 3) + 1), v).charAt(6);
        break;
      }
    }

    return h && d++, {
      version: o,
      layer: i,
      sampleRate: _,
      bitRate: l,
      duration: c,
      size: t,
      hasPadding: h,
      frameSize: d,
      frameDurationFloat: u
    };
  };

  var n = {
    rm: Recorder.mp3ReadMeta,
    fn: function fn(e, t, n, a) {
      var r = this.rm(e, t);
      if (!r) return {
        err: "mp3\u975E\u9884\u5B9A\u683C\u5F0F"
      };
      var s = Math.round(n / a * 1e3),
          o = Math.floor((r.duration - s) / r.frameDurationFloat);

      if (o > 0) {
        var i = o * r.frameSize - (r.hasPadding ? 1 : 0);
        t -= i;

        for (var _ = 0, l = [], c = 0; c < e.length; c++) {
          var f = e[c];
          if (i <= 0) break;
          i >= f.byteLength ? (i -= f.byteLength, l.push(f), e.splice(c, 1), c--) : (e[c] = f.slice(i), _ = f, i = 0);
        }

        if (!this.rm(e, t)) {
          _ && (e[0] = _);

          for (c = 0; c < l.length; c++) {
            e.splice(c, 0, l[c]);
          }

          r.err = "fix\u540E\u6570\u636E\u9519\u8BEF\uFF0C\u5DF2\u8FD8\u539F\uFF0C\u9519\u8BEF\u539F\u56E0\u4E0D\u660E";
        }

        var u = r.trimFix = {};
        u.remove = o, u.removeDuration = Math.round(o * r.frameDurationFloat), u.duration = Math.round(8 * t / r.bitRate);
      }

      return r;
    }
  },
      mp3TrimFixSetMeta = function mp3TrimFixSetMeta(e, t) {
    var n = "MP3\u4FE1\u606F ";
    (e.sampleRate && e.sampleRate != t.sampleRate || e.bitRate && e.bitRate != t.bitRate) && (console.warn(n + "\u548C\u8BBE\u7F6E\u7684\u4E0D\u5339\u914Dset:" + t.bitRate + "kbps " + t.sampleRate + "hz\uFF0C\u5DF2\u66F4\u65B0set:" + e.bitRate + "kbps " + e.sampleRate + "hz", t), t.sampleRate = e.sampleRate, t.bitRate = e.bitRate);
    var a = e.trimFix;
    a ? (n += "Fix\u79FB\u9664" + a.remove + "\u5E27" + a.removeDuration + "ms -> " + a.duration + "ms", a.remove > 2 && (e.err = (e.err ? e.err + ", " : "") + "\u79FB\u9664\u5E27\u6570\u8FC7\u591A")) : n += (e.duration || "-") + "ms", e.err ? console.error(n, e.err, e) : console.log(n, e);
  };
}(), function () {
  function lamejs() {
    var Math_log10 = function Math_log10(e) {
      return Math.log(e) / Math.log(10);
    };

    function new_byte(e) {
      return new Int8Array(e);
    }

    function new_int(e) {
      return new Int32Array(e);
    }

    function new_float(e) {
      return new Float32Array(e);
    }

    function new_float_n(e) {
      if (1 == e.length) return new_float(e[0]);
      var t = e[0];
      e = e.slice(1);

      for (var n = [], a = 0; a < t; a++) {
        n.push(new_float_n(e));
      }

      return n;
    }

    function new_int_n(e) {
      if (1 == e.length) return new_int(e[0]);
      var t = e[0];
      e = e.slice(1);

      for (var n = [], a = 0; a < t; a++) {
        n.push(new_int_n(e));
      }

      return n;
    }

    function new_short_n(e) {
      if (1 == e.length) return function new_short(e) {
        return new Int16Array(e);
      }(e[0]);
      var t = e[0];
      e = e.slice(1);

      for (var n = [], a = 0; a < t; a++) {
        n.push(new_short_n(e));
      }

      return n;
    }

    function new_array_n(e) {
      if (1 == e.length) return new Array(e[0]);
      var t = e[0];
      e = e.slice(1);

      for (var n = [], a = 0; a < t; a++) {
        n.push(new_array_n(e));
      }

      return n;
    }

    var e = {
      fill: function fill(e, t, n, a) {
        if (2 == arguments.length) for (var r = 0; r < e.length; r++) {
          e[r] = arguments[1];
        } else for (r = t; r < n; r++) {
          e[r] = a;
        }
      }
    },
        t = {
      arraycopy: function arraycopy(e, t, n, a, r) {
        for (var s = t + r; t < s;) {
          n[a++] = e[t++];
        }
      }
    },
        n = {};

    function ShortBlock(e) {
      this.ordinal = e;
    }

    n.SQRT2 = 1.4142135623730951, n.FAST_LOG10 = function (e) {
      return Math_log10(e);
    }, n.FAST_LOG10_X = function (e, t) {
      return Math_log10(e) * t;
    }, ShortBlock.short_block_allowed = new ShortBlock(0), ShortBlock.short_block_coupled = new ShortBlock(1), ShortBlock.short_block_dispensed = new ShortBlock(2), ShortBlock.short_block_forced = new ShortBlock(3);
    var a = {};

    function VbrMode(e) {
      this.ordinal = e;
    }

    function MPEGMode(e) {
      var t = e;

      this.ordinal = function () {
        return t;
      };
    }

    function Version() {
      this.getLameVersion = function () {
        return "3.98.4";
      }, this.getLameShortVersion = function () {
        return "3.98.4";
      }, this.getLameVeryShortVersion = function () {
        return "LAME3.98r";
      }, this.getPsyVersion = function () {
        return "0.93";
      }, this.getLameUrl = function () {
        return "http://www.mp3dev.org/";
      }, this.getLameOsBitness = function () {
        return "32bits";
      };
    }

    function Takehiro() {
      var n = null;

      function Bits(e) {
        this.bits = 0 | e;
      }

      this.qupvt = null, this.setModules = function (e) {
        this.qupvt = e, n = e;
      };
      var a = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 1], [1, 1], [1, 1], [1, 2], [2, 2], [2, 3], [2, 3], [3, 4], [3, 4], [3, 4], [4, 5], [4, 5], [4, 6], [5, 6], [5, 6], [5, 7], [6, 7], [6, 7]];

      function quantize_lines_xrpow_01(e, t, n, a, r, s) {
        var o = .5946 / t;

        for (e >>= 1; 0 != e--;) {
          r[s++] = o > n[a++] ? 0 : 1, r[s++] = o > n[a++] ? 0 : 1;
        }
      }

      function quantize_lines_xrpow(e, t, a, r, s, o) {
        var i = (e >>= 1) % 2;

        for (e >>= 1; 0 != e--;) {
          var _, l, c, f, u, d, h, p;

          _ = a[r++] * t, l = a[r++] * t, u = 0 | _, c = a[r++] * t, d = 0 | l, f = a[r++] * t, h = 0 | c, _ += n.adj43[u], p = 0 | f, l += n.adj43[d], s[o++] = 0 | _, c += n.adj43[h], s[o++] = 0 | l, f += n.adj43[p], s[o++] = 0 | c, s[o++] = 0 | f;
        }

        0 != i && (u = 0 | (_ = a[r++] * t), d = 0 | (l = a[r++] * t), _ += n.adj43[u], l += n.adj43[d], s[o++] = 0 | _, s[o++] = 0 | l);
      }

      var s = [1, 2, 5, 7, 7, 10, 10, 13, 13, 13, 13, 13, 13, 13, 13];

      function choose_table(e, t, n, a) {
        var o = function ix_max(e, t, n) {
          var a = 0,
              r = 0;

          do {
            var s = e[t++],
                o = e[t++];
            a < s && (a = s), r < o && (r = o);
          } while (t < n);

          return a < r && (a = r), a;
        }(e, t, n);

        switch (o) {
          case 0:
            return o;

          case 1:
            return function count_bit_noESC(e, t, n, a) {
              var s = 0,
                  o = r.ht[1].hlen;

              do {
                var i = 2 * e[t + 0] + e[t + 1];
                t += 2, s += o[i];
              } while (t < n);

              return a.bits += s, 1;
            }(e, t, n, a);

          case 2:
          case 3:
            return function count_bit_noESC_from2(e, t, n, a, s) {
              var o,
                  i,
                  _ = 0,
                  l = r.ht[a].xlen;
              i = 2 == a ? r.table23 : r.table56;

              do {
                var c = e[t + 0] * l + e[t + 1];
                t += 2, _ += i[c];
              } while (t < n);

              return o = 65535 & _, (_ >>= 16) > o && (_ = o, a++), s.bits += _, a;
            }(e, t, n, s[o - 1], a);

          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
            return function count_bit_noESC_from3(e, t, n, a, s) {
              var o = 0,
                  i = 0,
                  _ = 0,
                  l = r.ht[a].xlen,
                  c = r.ht[a].hlen,
                  f = r.ht[a + 1].hlen,
                  u = r.ht[a + 2].hlen;

              do {
                var d = e[t + 0] * l + e[t + 1];
                t += 2, o += c[d], i += f[d], _ += u[d];
              } while (t < n);

              var h = a;
              return o > i && (o = i, h++), o > _ && (o = _, h = a + 2), s.bits += o, h;
            }(e, t, n, s[o - 1], a);

          default:
            if (o > QuantizePVT.IXMAX_VAL) return a.bits = QuantizePVT.LARGE_BITS, -1;

            var i, _;

            for (o -= 15, i = 24; i < 32 && !(r.ht[i].linmax >= o); i++) {
            }

            for (_ = i - 8; _ < 24 && !(r.ht[_].linmax >= o); _++) {
            }

            return function count_bit_ESC(e, t, n, a, s, o) {
              var i,
                  _ = 65536 * r.ht[a].xlen + r.ht[s].xlen,
                  l = 0;

              do {
                var c = e[t++],
                    f = e[t++];
                0 != c && (c > 14 && (c = 15, l += _), c *= 16), 0 != f && (f > 14 && (f = 15, l += _), c += f), l += r.largetbl[c];
              } while (t < n);

              return i = 65535 & l, (l >>= 16) > i && (l = i, a = s), o.bits += l, a;
            }(e, t, n, _, i, a);
        }
      }

      function recalc_divide_sub(e, t, n, a, r, s, o, i) {
        for (var _ = t.big_values, l = 2; l < Encoder.SBMAX_l + 1; l++) {
          var c = e.scalefac_band.l[l];
          if (c >= _) break;
          var f = r[l - 2] + t.count1bits;
          if (n.part2_3_length <= f) break;
          var u = new Bits(f),
              d = choose_table(a, c, _, u);
          f = u.bits, n.part2_3_length <= f || (n.assign(t), n.part2_3_length = f, n.region0_count = s[l - 2], n.region1_count = l - 2 - s[l - 2], n.table_select[0] = o[l - 2], n.table_select[1] = i[l - 2], n.table_select[2] = d);
        }
      }

      this.noquant_count_bits = function (e, t, n) {
        var a = t.l3_enc,
            s = Math.min(576, t.max_nonzero_coeff + 2 >> 1 << 1);

        for (null != n && (n.sfb_count1 = 0); s > 1 && 0 == (a[s - 1] | a[s - 2]); s -= 2) {
        }

        t.count1 = s;

        for (var o = 0, i = 0; s > 3; s -= 4) {
          var _;

          if ((2147483647 & (a[s - 1] | a[s - 2] | a[s - 3] | a[s - 4])) > 1) break;
          _ = 2 * (2 * (2 * a[s - 4] + a[s - 3]) + a[s - 2]) + a[s - 1], o += r.t32l[_], i += r.t33l[_];
        }

        var l = o;
        if (t.count1table_select = 0, o > i && (l = i, t.count1table_select = 1), t.count1bits = l, t.big_values = s, 0 == s) return l;
        if (t.block_type == Encoder.SHORT_TYPE) (o = 3 * e.scalefac_band.s[3]) > t.big_values && (o = t.big_values), i = t.big_values;else if (t.block_type == Encoder.NORM_TYPE) {
          if (o = t.region0_count = e.bv_scf[s - 2], i = t.region1_count = e.bv_scf[s - 1], i = e.scalefac_band.l[o + i + 2], o = e.scalefac_band.l[o + 1], i < s) {
            var c = new Bits(l);
            t.table_select[2] = choose_table(a, i, s, c), l = c.bits;
          }
        } else t.region0_count = 7, t.region1_count = Encoder.SBMAX_l - 1 - 7 - 1, (o = e.scalefac_band.l[8]) > (i = s) && (o = i);

        if (o = Math.min(o, s), i = Math.min(i, s), 0 < o) {
          c = new Bits(l);
          t.table_select[0] = choose_table(a, 0, o, c), l = c.bits;
        }

        if (o < i) {
          c = new Bits(l);
          t.table_select[1] = choose_table(a, o, i, c), l = c.bits;
        }

        if (2 == e.use_best_huffman && (t.part2_3_length = l, best_huffman_divide(e, t), l = t.part2_3_length), null != n && t.block_type == Encoder.NORM_TYPE) {
          for (var f = 0; e.scalefac_band.l[f] < t.big_values;) {
            f++;
          }

          n.sfb_count1 = f;
        }

        return l;
      }, this.count_bits = function (t, a, r, s) {
        var o = r.l3_enc,
            i = QuantizePVT.IXMAX_VAL / n.IPOW20(r.global_gain);
        if (r.xrpow_max > i) return QuantizePVT.LARGE_BITS;
        if (function quantize_xrpow(t, a, r, s, o) {
          var i,
              _,
              l,
              c = 0,
              f = 0,
              u = 0,
              d = 0,
              h = a,
              p = 0,
              m = h,
              b = 0,
              v = t,
              g = 0;

          for (l = null != o && s.global_gain == o.global_gain, _ = s.block_type == Encoder.SHORT_TYPE ? 38 : 21, i = 0; i <= _; i++) {
            var w = -1;
            if ((l || s.block_type == Encoder.NORM_TYPE) && (w = s.global_gain - (s.scalefac[i] + (0 != s.preflag ? n.pretab[i] : 0) << s.scalefac_scale + 1) - 8 * s.subblock_gain[s.window[i]]), l && o.step[i] == w) 0 != f && (quantize_lines_xrpow(f, r, v, g, m, b), f = 0), 0 != u && (quantize_lines_xrpow_01(u, r, v, g, m, b), u = 0);else {
              var E,
                  S = s.width[i];

              if (c + s.width[i] > s.max_nonzero_coeff && (E = s.max_nonzero_coeff - c + 1, e.fill(a, s.max_nonzero_coeff, 576, 0), (S = E) < 0 && (S = 0), i = _ + 1), 0 == f && 0 == u && (m = h, b = p, v = t, g = d), null != o && o.sfb_count1 > 0 && i >= o.sfb_count1 && o.step[i] > 0 && w >= o.step[i] ? (0 != f && (quantize_lines_xrpow(f, r, v, g, m, b), f = 0, m = h, b = p, v = t, g = d), u += S) : (0 != u && (quantize_lines_xrpow_01(u, r, v, g, m, b), u = 0, m = h, b = p, v = t, g = d), f += S), S <= 0) {
                0 != u && (quantize_lines_xrpow_01(u, r, v, g, m, b), u = 0), 0 != f && (quantize_lines_xrpow(f, r, v, g, m, b), f = 0);
                break;
              }
            }
            i <= _ && (p += s.width[i], d += s.width[i], c += s.width[i]);
          }

          0 != f && (quantize_lines_xrpow(f, r, v, g, m, b), f = 0), 0 != u && (quantize_lines_xrpow_01(u, r, v, g, m, b), u = 0);
        }(a, o, n.IPOW20(r.global_gain), r, s), 0 != (2 & t.substep_shaping)) for (var _ = 0, l = r.global_gain + r.scalefac_scale, c = .634521682242439 / n.IPOW20(l), f = 0; f < r.sfbmax; f++) {
          var u,
              d = r.width[f];
          if (0 == t.pseudohalf[f]) _ += d;else for (u = _, _ += d; u < _; ++u) {
            o[u] = a[u] >= c ? o[u] : 0;
          }
        }
        return this.noquant_count_bits(t, r, s);
      }, this.best_huffman_divide = function (e, t) {
        var n = new GrInfo(),
            a = t.l3_enc,
            s = new_int(23),
            o = new_int(23),
            i = new_int(23),
            _ = new_int(23);

        if (t.block_type != Encoder.SHORT_TYPE || 1 != e.mode_gr) {
          n.assign(t), t.block_type == Encoder.NORM_TYPE && (!function recalc_divide_init(e, t, n, a, r, s, o) {
            for (var i = t.big_values, _ = 0; _ <= 22; _++) {
              a[_] = QuantizePVT.LARGE_BITS;
            }

            for (_ = 0; _ < 16; _++) {
              var l = e.scalefac_band.l[_ + 1];
              if (l >= i) break;
              var c = 0,
                  f = new Bits(c),
                  u = choose_table(n, 0, l, f);
              c = f.bits;

              for (var d = 0; d < 8; d++) {
                var h = e.scalefac_band.l[_ + d + 2];
                if (h >= i) break;
                var p = c,
                    m = choose_table(n, l, h, f = new Bits(p));
                p = f.bits, a[_ + d] > p && (a[_ + d] = p, r[_ + d] = _, s[_ + d] = u, o[_ + d] = m);
              }
            }
          }(e, t, a, s, o, i, _), recalc_divide_sub(e, n, t, a, s, o, i, _));
          var l = n.big_values;

          if (!(0 == l || (a[l - 2] | a[l - 1]) > 1) && !((l = t.count1 + 2) > 576)) {
            n.assign(t), n.count1 = l;

            for (var c = 0, f = 0; l > n.big_values; l -= 4) {
              var u = 2 * (2 * (2 * a[l - 4] + a[l - 3]) + a[l - 2]) + a[l - 1];
              c += r.t32l[u], f += r.t33l[u];
            }

            if (n.big_values = l, n.count1table_select = 0, c > f && (c = f, n.count1table_select = 1), n.count1bits = c, n.block_type == Encoder.NORM_TYPE) recalc_divide_sub(e, n, t, a, s, o, i, _);else {
              if (n.part2_3_length = c, (c = e.scalefac_band.l[8]) > l && (c = l), c > 0) {
                var d = new Bits(n.part2_3_length);
                n.table_select[0] = choose_table(a, 0, c, d), n.part2_3_length = d.bits;
              }

              if (l > c) {
                d = new Bits(n.part2_3_length);
                n.table_select[1] = choose_table(a, c, l, d), n.part2_3_length = d.bits;
              }

              t.part2_3_length > n.part2_3_length && t.assign(n);
            }
          }
        }
      };
      var o = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16],
          i = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8],
          _ = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4],
          l = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
      Takehiro.slen1_tab = _, Takehiro.slen2_tab = l, this.best_scalefac_store = function (e, t, a, s) {
        var c,
            f,
            u,
            d,
            h = s.tt[t][a],
            p = 0;

        for (u = 0, c = 0; c < h.sfbmax; c++) {
          var m = h.width[c];

          for (u += m, d = -m; d < 0 && 0 == h.l3_enc[d + u]; d++) {
          }

          0 == d && (h.scalefac[c] = p = -2);
        }

        if (0 == h.scalefac_scale && 0 == h.preflag) {
          var b = 0;

          for (c = 0; c < h.sfbmax; c++) {
            h.scalefac[c] > 0 && (b |= h.scalefac[c]);
          }

          if (0 == (1 & b) && 0 != b) {
            for (c = 0; c < h.sfbmax; c++) {
              h.scalefac[c] > 0 && (h.scalefac[c] >>= 1);
            }

            h.scalefac_scale = p = 1;
          }
        }

        if (0 == h.preflag && h.block_type != Encoder.SHORT_TYPE && 2 == e.mode_gr) {
          for (c = 11; c < Encoder.SBPSY_l && !(h.scalefac[c] < n.pretab[c] && -2 != h.scalefac[c]); c++) {
          }

          if (c == Encoder.SBPSY_l) {
            for (c = 11; c < Encoder.SBPSY_l; c++) {
              h.scalefac[c] > 0 && (h.scalefac[c] -= n.pretab[c]);
            }

            h.preflag = p = 1;
          }
        }

        for (f = 0; f < 4; f++) {
          s.scfsi[a][f] = 0;
        }

        for (2 == e.mode_gr && 1 == t && s.tt[0][a].block_type != Encoder.SHORT_TYPE && s.tt[1][a].block_type != Encoder.SHORT_TYPE && (!function scfsi_calc(e, t) {
          for (var n, a = t.tt[1][e], s = t.tt[0][e], c = 0; c < r.scfsi_band.length - 1; c++) {
            for (n = r.scfsi_band[c]; n < r.scfsi_band[c + 1] && !(s.scalefac[n] != a.scalefac[n] && a.scalefac[n] >= 0); n++) {
            }

            if (n == r.scfsi_band[c + 1]) {
              for (n = r.scfsi_band[c]; n < r.scfsi_band[c + 1]; n++) {
                a.scalefac[n] = -1;
              }

              t.scfsi[e][c] = 1;
            }
          }

          var f = 0,
              u = 0;

          for (n = 0; n < 11; n++) {
            -1 != a.scalefac[n] && (u++, f < a.scalefac[n] && (f = a.scalefac[n]));
          }

          for (var d = 0, h = 0; n < Encoder.SBPSY_l; n++) {
            -1 != a.scalefac[n] && (h++, d < a.scalefac[n] && (d = a.scalefac[n]));
          }

          for (c = 0; c < 16; c++) {
            if (f < o[c] && d < i[c]) {
              var p = _[c] * u + l[c] * h;
              a.part2_length > p && (a.part2_length = p, a.scalefac_compress = c);
            }
          }
        }(a, s), p = 0), c = 0; c < h.sfbmax; c++) {
          -2 == h.scalefac[c] && (h.scalefac[c] = 0);
        }

        0 != p && (2 == e.mode_gr ? this.scale_bitcount(h) : this.scale_bitcount_lsf(e, h));
      };
      var c = [0, 18, 36, 54, 54, 36, 54, 72, 54, 72, 90, 72, 90, 108, 108, 126],
          f = [0, 18, 36, 54, 51, 35, 53, 71, 52, 70, 88, 69, 87, 105, 104, 122],
          u = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42, 52, 43, 53, 63, 64, 74];

      this.scale_bitcount = function (e) {
        var t,
            a,
            r,
            s = 0,
            _ = 0,
            l = e.scalefac;
        if (e.block_type == Encoder.SHORT_TYPE) r = c, 0 != e.mixed_block_flag && (r = f);else if (r = u, 0 == e.preflag) {
          for (a = 11; a < Encoder.SBPSY_l && !(l[a] < n.pretab[a]); a++) {
          }

          if (a == Encoder.SBPSY_l) for (e.preflag = 1, a = 11; a < Encoder.SBPSY_l; a++) {
            l[a] -= n.pretab[a];
          }
        }

        for (a = 0; a < e.sfbdivide; a++) {
          s < l[a] && (s = l[a]);
        }

        for (; a < e.sfbmax; a++) {
          _ < l[a] && (_ = l[a]);
        }

        for (e.part2_length = QuantizePVT.LARGE_BITS, t = 0; t < 16; t++) {
          s < o[t] && _ < i[t] && e.part2_length > r[t] && (e.part2_length = r[t], e.scalefac_compress = t);
        }

        return e.part2_length == QuantizePVT.LARGE_BITS;
      };

      var d = [[15, 15, 7, 7], [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0], [7, 7, 7, 0], [3, 3, 0, 0]];

      this.scale_bitcount_lsf = function (e, a) {
        var r,
            s,
            o,
            i,
            _,
            l,
            c,
            f,
            u = new_int(4),
            p = a.scalefac;

        for (r = 0 != a.preflag ? 2 : 0, c = 0; c < 4; c++) {
          u[c] = 0;
        }

        if (a.block_type == Encoder.SHORT_TYPE) {
          s = 1;
          var m = n.nr_of_sfb_block[r][s];

          for (f = 0, o = 0; o < 4; o++) {
            for (i = m[o] / 3, c = 0; c < i; c++, f++) {
              for (_ = 0; _ < 3; _++) {
                p[3 * f + _] > u[o] && (u[o] = p[3 * f + _]);
              }
            }
          }
        } else {
          s = 0;
          m = n.nr_of_sfb_block[r][s];

          for (f = 0, o = 0; o < 4; o++) {
            for (i = m[o], c = 0; c < i; c++, f++) {
              p[f] > u[o] && (u[o] = p[f]);
            }
          }
        }

        for (l = !1, o = 0; o < 4; o++) {
          u[o] > d[r][o] && (l = !0);
        }

        if (!l) {
          var b, v, g, w;

          for (a.sfb_partition_table = n.nr_of_sfb_block[r][s], o = 0; o < 4; o++) {
            a.slen[o] = h[u[o]];
          }

          switch (b = a.slen[0], v = a.slen[1], g = a.slen[2], w = a.slen[3], r) {
            case 0:
              a.scalefac_compress = (5 * b + v << 4) + (g << 2) + w;
              break;

            case 1:
              a.scalefac_compress = 400 + (5 * b + v << 2) + g;
              break;

            case 2:
              a.scalefac_compress = 500 + 3 * b + v;
              break;

            default:
              t.err.printf("intensity stereo not implemented yet\n");
          }
        }

        if (!l) for (a.part2_length = 0, o = 0; o < 4; o++) {
          a.part2_length += a.slen[o] * a.sfb_partition_table[o];
        }
        return l;
      };

      var h = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4];

      this.huffman_init = function (e) {
        for (var t = 2; t <= 576; t += 2) {
          for (var n, r = 0; e.scalefac_band.l[++r] < t;) {
          }

          for (n = a[r][0]; e.scalefac_band.l[n + 1] > t;) {
            n--;
          }

          for (n < 0 && (n = a[r][0]), e.bv_scf[t - 2] = n, n = a[r][1]; e.scalefac_band.l[n + e.bv_scf[t - 2] + 2] > t;) {
            n--;
          }

          n < 0 && (n = a[r][1]), e.bv_scf[t - 1] = n;
        }
      };
    }

    function GainAnalysis() {}

    function Presets() {
      function VBRPresets(e, t, n, a, r, s, o, i, _, l, c, f, u, d, h) {
        this.vbr_q = e, this.quant_comp = t, this.quant_comp_s = n, this.expY = a, this.st_lrm = r, this.st_s = s, this.masking_adj = o, this.masking_adj_short = i, this.ath_lower = _, this.ath_curve = l, this.ath_sensitivity = c, this.interch = f, this.safejoint = u, this.sfb21mod = d, this.msfix = h;
      }

      function ABRPresets(e, t, n, a, r, s, o, i, _, l, c, f, u, d) {
        this.quant_comp = t, this.quant_comp_s = n, this.safejoint = a, this.nsmsfix = r, this.st_lrm = s, this.st_s = o, this.nsbass = i, this.scale = _, this.masking_adj = l, this.ath_lower = c, this.ath_curve = f, this.interch = u, this.sfscale = d;
      }

      var e;

      this.setModules = function (t) {
        e = t;
      };

      var t = [new VBRPresets(0, 9, 9, 0, 5.2, 125, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, .97), new VBRPresets(1, 9, 9, 0, 5.3, 125, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35), new VBRPresets(2, 9, 9, 0, 5.6, 125, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49), new VBRPresets(3, 9, 9, 1, 5.8, 130, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64), new VBRPresets(4, 9, 9, 1, 6, 135, -.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79), new VBRPresets(5, 9, 9, 1, 6.4, 140, .5, .4, -7.5, 4, -12, 2e-4, 0, 0, 1.95), new VBRPresets(6, 9, 9, 1, 6.6, 145, .67, .65, -14.7, 6.5, -19, 4e-4, 0, 0, 2.3), new VBRPresets(7, 9, 9, 1, 6.6, 145, .8, .75, -19.7, 8, -22, 6e-4, 0, 0, 2.7), new VBRPresets(8, 9, 9, 1, 6.6, 145, 1.2, 1.15, -27.5, 10, -23, 7e-4, 0, 0, 0), new VBRPresets(9, 9, 9, 1, 6.6, 145, 1.6, 1.6, -36, 11, -25, 8e-4, 0, 0, 0), new VBRPresets(10, 9, 9, 1, 6.6, 145, 2, 2, -36, 12, -25, 8e-4, 0, 0, 0)],
          n = [new VBRPresets(0, 9, 9, 0, 4.2, 25, -7, -4, 7.5, 1, 0, 0, 2, 26, .97), new VBRPresets(1, 9, 9, 0, 4.2, 25, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35), new VBRPresets(2, 9, 9, 0, 4.2, 25, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49), new VBRPresets(3, 9, 9, 1, 4.2, 25, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64), new VBRPresets(4, 9, 9, 1, 4.2, 25, -2.2, .1, 0, 3.5, -8, 0, 2, 0, 1.79), new VBRPresets(5, 9, 9, 1, 4.2, 25, -1, 1.65, -7.7, 4, -12, 2e-4, 0, 0, 1.95), new VBRPresets(6, 9, 9, 1, 4.2, 25, -0, 2.47, -7.7, 6.5, -19, 4e-4, 0, 0, 2), new VBRPresets(7, 9, 9, 1, 4.2, 25, .5, 2, -14.5, 8, -22, 6e-4, 0, 0, 2), new VBRPresets(8, 9, 9, 1, 4.2, 25, 1, 2.4, -22, 10, -23, 7e-4, 0, 0, 2), new VBRPresets(9, 9, 9, 1, 4.2, 25, 1.5, 2.95, -30, 11, -25, 8e-4, 0, 0, 2), new VBRPresets(10, 9, 9, 1, 4.2, 25, 2, 2.95, -36, 12, -30, 8e-4, 0, 0, 2)];

      function apply_vbr_preset(e, a, r) {
        var s = e.VBR == VbrMode.vbr_rh ? t : n,
            o = e.VBR_q_frac,
            i = s[a],
            _ = s[a + 1],
            l = i;
        i.st_lrm = i.st_lrm + o * (_.st_lrm - i.st_lrm), i.st_s = i.st_s + o * (_.st_s - i.st_s), i.masking_adj = i.masking_adj + o * (_.masking_adj - i.masking_adj), i.masking_adj_short = i.masking_adj_short + o * (_.masking_adj_short - i.masking_adj_short), i.ath_lower = i.ath_lower + o * (_.ath_lower - i.ath_lower), i.ath_curve = i.ath_curve + o * (_.ath_curve - i.ath_curve), i.ath_sensitivity = i.ath_sensitivity + o * (_.ath_sensitivity - i.ath_sensitivity), i.interch = i.interch + o * (_.interch - i.interch), i.msfix = i.msfix + o * (_.msfix - i.msfix), function lame_set_VBR_q(e, t) {
          var n = 0;
          0 > t && (n = -1, t = 0);
          9 < t && (n = -1, t = 9);
          return e.VBR_q = t, e.VBR_q_frac = 0, n;
        }(e, l.vbr_q), 0 != r ? e.quant_comp = l.quant_comp : Math.abs(e.quant_comp - -1) > 0 || (e.quant_comp = l.quant_comp), 0 != r ? e.quant_comp_short = l.quant_comp_s : Math.abs(e.quant_comp_short - -1) > 0 || (e.quant_comp_short = l.quant_comp_s), 0 != l.expY && (e.experimentalY = 0 != l.expY), 0 != r ? e.internal_flags.nsPsy.attackthre = l.st_lrm : Math.abs(e.internal_flags.nsPsy.attackthre - -1) > 0 || (e.internal_flags.nsPsy.attackthre = l.st_lrm), 0 != r ? e.internal_flags.nsPsy.attackthre_s = l.st_s : Math.abs(e.internal_flags.nsPsy.attackthre_s - -1) > 0 || (e.internal_flags.nsPsy.attackthre_s = l.st_s), 0 != r ? e.maskingadjust = l.masking_adj : Math.abs(e.maskingadjust - 0) > 0 || (e.maskingadjust = l.masking_adj), 0 != r ? e.maskingadjust_short = l.masking_adj_short : Math.abs(e.maskingadjust_short - 0) > 0 || (e.maskingadjust_short = l.masking_adj_short), 0 != r ? e.ATHlower = -l.ath_lower / 10 : Math.abs(10 * -e.ATHlower - 0) > 0 || (e.ATHlower = -l.ath_lower / 10), 0 != r ? e.ATHcurve = l.ath_curve : Math.abs(e.ATHcurve - -1) > 0 || (e.ATHcurve = l.ath_curve), 0 != r ? e.athaa_sensitivity = l.ath_sensitivity : Math.abs(e.athaa_sensitivity - -1) > 0 || (e.athaa_sensitivity = l.ath_sensitivity), l.interch > 0 && (0 != r ? e.interChRatio = l.interch : Math.abs(e.interChRatio - -1) > 0 || (e.interChRatio = l.interch)), l.safejoint > 0 && (e.exp_nspsytune = e.exp_nspsytune | l.safejoint), l.sfb21mod > 0 && (e.exp_nspsytune = e.exp_nspsytune | l.sfb21mod << 20), 0 != r ? e.msfix = l.msfix : Math.abs(e.msfix - -1) > 0 || (e.msfix = l.msfix), 0 == r && (e.VBR_q = a, e.VBR_q_frac = o);
      }

      var a = [new ABRPresets(8, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -30, 11, .0012, 1), new ABRPresets(16, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -25, 11, .001, 1), new ABRPresets(24, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -20, 11, .001, 1), new ABRPresets(32, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -15, 11, .001, 1), new ABRPresets(40, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -10, 11, 9e-4, 1), new ABRPresets(48, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -10, 11, 9e-4, 1), new ABRPresets(56, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -6, 11, 8e-4, 1), new ABRPresets(64, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, -2, 11, 8e-4, 1), new ABRPresets(80, 9, 9, 0, 0, 6.6, 145, 0, .95, 0, 0, 8, 7e-4, 1), new ABRPresets(96, 9, 9, 0, 2.5, 6.6, 145, 0, .95, 0, 1, 5.5, 6e-4, 1), new ABRPresets(112, 9, 9, 0, 2.25, 6.6, 145, 0, .95, 0, 2, 4.5, 5e-4, 1), new ABRPresets(128, 9, 9, 0, 1.95, 6.4, 140, 0, .95, 0, 3, 4, 2e-4, 1), new ABRPresets(160, 9, 9, 1, 1.79, 6, 135, 0, .95, -2, 5, 3.5, 0, 1), new ABRPresets(192, 9, 9, 1, 1.49, 5.6, 125, 0, .97, -4, 7, 3, 0, 0), new ABRPresets(224, 9, 9, 1, 1.25, 5.2, 125, 0, .98, -6, 9, 2, 0, 0), new ABRPresets(256, 9, 9, 1, .97, 5.2, 125, 0, 1, -8, 10, 1, 0, 0), new ABRPresets(320, 9, 9, 1, .9, 5.2, 125, 0, 1, -10, 12, 0, 0, 0)];

      function apply_abr_preset(t, n, r) {
        var s = n,
            o = e.nearestBitrateFullIndex(n);

        if (t.VBR = VbrMode.vbr_abr, t.VBR_mean_bitrate_kbps = s, t.VBR_mean_bitrate_kbps = Math.min(t.VBR_mean_bitrate_kbps, 320), t.VBR_mean_bitrate_kbps = Math.max(t.VBR_mean_bitrate_kbps, 8), t.brate = t.VBR_mean_bitrate_kbps, t.VBR_mean_bitrate_kbps > 320 && (t.disable_reservoir = !0), a[o].safejoint > 0 && (t.exp_nspsytune = 2 | t.exp_nspsytune), a[o].sfscale > 0 && (t.internal_flags.noise_shaping = 2), Math.abs(a[o].nsbass) > 0) {
          var i = int(4 * a[o].nsbass);
          i < 0 && (i += 64), t.exp_nspsytune = t.exp_nspsytune | i << 2;
        }

        return 0 != r ? t.quant_comp = a[o].quant_comp : Math.abs(t.quant_comp - -1) > 0 || (t.quant_comp = a[o].quant_comp), 0 != r ? t.quant_comp_short = a[o].quant_comp_s : Math.abs(t.quant_comp_short - -1) > 0 || (t.quant_comp_short = a[o].quant_comp_s), 0 != r ? t.msfix = a[o].nsmsfix : Math.abs(t.msfix - -1) > 0 || (t.msfix = a[o].nsmsfix), 0 != r ? t.internal_flags.nsPsy.attackthre = a[o].st_lrm : Math.abs(t.internal_flags.nsPsy.attackthre - -1) > 0 || (t.internal_flags.nsPsy.attackthre = a[o].st_lrm), 0 != r ? t.internal_flags.nsPsy.attackthre_s = a[o].st_s : Math.abs(t.internal_flags.nsPsy.attackthre_s - -1) > 0 || (t.internal_flags.nsPsy.attackthre_s = a[o].st_s), 0 != r ? t.scale = a[o].scale : Math.abs(t.scale - -1) > 0 || (t.scale = a[o].scale), 0 != r ? t.maskingadjust = a[o].masking_adj : Math.abs(t.maskingadjust - 0) > 0 || (t.maskingadjust = a[o].masking_adj), a[o].masking_adj > 0 ? 0 != r ? t.maskingadjust_short = .9 * a[o].masking_adj : Math.abs(t.maskingadjust_short - 0) > 0 || (t.maskingadjust_short = .9 * a[o].masking_adj) : 0 != r ? t.maskingadjust_short = 1.1 * a[o].masking_adj : Math.abs(t.maskingadjust_short - 0) > 0 || (t.maskingadjust_short = 1.1 * a[o].masking_adj), 0 != r ? t.ATHlower = -a[o].ath_lower / 10 : Math.abs(10 * -t.ATHlower - 0) > 0 || (t.ATHlower = -a[o].ath_lower / 10), 0 != r ? t.ATHcurve = a[o].ath_curve : Math.abs(t.ATHcurve - -1) > 0 || (t.ATHcurve = a[o].ath_curve), 0 != r ? t.interChRatio = a[o].interch : Math.abs(t.interChRatio - -1) > 0 || (t.interChRatio = a[o].interch), n;
      }

      this.apply_preset = function (e, t, n) {
        switch (t) {
          case Lame.R3MIX:
            t = Lame.V3, e.VBR = VbrMode.vbr_mtrh;
            break;

          case Lame.MEDIUM:
            t = Lame.V4, e.VBR = VbrMode.vbr_rh;
            break;

          case Lame.MEDIUM_FAST:
            t = Lame.V4, e.VBR = VbrMode.vbr_mtrh;
            break;

          case Lame.STANDARD:
            t = Lame.V2, e.VBR = VbrMode.vbr_rh;
            break;

          case Lame.STANDARD_FAST:
            t = Lame.V2, e.VBR = VbrMode.vbr_mtrh;
            break;

          case Lame.EXTREME:
            t = Lame.V0, e.VBR = VbrMode.vbr_rh;
            break;

          case Lame.EXTREME_FAST:
            t = Lame.V0, e.VBR = VbrMode.vbr_mtrh;
            break;

          case Lame.INSANE:
            return t = 320, e.preset = t, apply_abr_preset(e, t, n), e.VBR = VbrMode.vbr_off, t;
        }

        switch (e.preset = t, t) {
          case Lame.V9:
            return apply_vbr_preset(e, 9, n), t;

          case Lame.V8:
            return apply_vbr_preset(e, 8, n), t;

          case Lame.V7:
            return apply_vbr_preset(e, 7, n), t;

          case Lame.V6:
            return apply_vbr_preset(e, 6, n), t;

          case Lame.V5:
            return apply_vbr_preset(e, 5, n), t;

          case Lame.V4:
            return apply_vbr_preset(e, 4, n), t;

          case Lame.V3:
            return apply_vbr_preset(e, 3, n), t;

          case Lame.V2:
            return apply_vbr_preset(e, 2, n), t;

          case Lame.V1:
            return apply_vbr_preset(e, 1, n), t;

          case Lame.V0:
            return apply_vbr_preset(e, 0, n), t;
        }

        return 8 <= t && t <= 320 ? apply_abr_preset(e, t, n) : (e.preset = 0, t);
      };
    }

    function Reservoir() {
      var e;
      this.setModules = function (t) {
        e = t;
      }, this.ResvFrameBegin = function (t, n) {
        var a,
            r = t.internal_flags,
            s = r.l3_side,
            o = e.getframebits(t);
        n.bits = (o - 8 * r.sideinfo_len) / r.mode_gr;
        var i = 2048 * r.mode_gr - 8;
        t.brate > 320 ? a = 8 * int(1e3 * t.brate / (t.out_samplerate / 1152) / 8 + .5) : (a = 11520, t.strict_ISO && (a = 8 * int(32e4 / (t.out_samplerate / 1152) / 8 + .5))), r.ResvMax = a - o, r.ResvMax > i && (r.ResvMax = i), (r.ResvMax < 0 || t.disable_reservoir) && (r.ResvMax = 0);

        var _ = n.bits * r.mode_gr + Math.min(r.ResvSize, r.ResvMax);

        return _ > a && (_ = a), s.resvDrain_pre = 0, null != r.pinfo && (r.pinfo.mean_bits = n.bits / 2, r.pinfo.resvsize = r.ResvSize), _;
      }, this.ResvMaxBits = function (e, t, n, a) {
        var r,
            s = e.internal_flags,
            o = s.ResvSize,
            i = s.ResvMax;
        0 != a && (o += t), 0 != (1 & s.substep_shaping) && (i *= .9), n.bits = t, 10 * o > 9 * i ? (r = o - 9 * i / 10, n.bits += r, s.substep_shaping |= 128) : (r = 0, s.substep_shaping &= 127, e.disable_reservoir || 0 != (1 & s.substep_shaping) || (n.bits -= .1 * t));

        var _ = o < 6 * s.ResvMax / 10 ? o : 6 * s.ResvMax / 10;

        return (_ -= r) < 0 && (_ = 0), _;
      }, this.ResvAdjust = function (e, t) {
        e.ResvSize -= t.part2_3_length + t.part2_length;
      }, this.ResvFrameEnd = function (e, t) {
        var n,
            a = e.l3_side;
        e.ResvSize += t * e.mode_gr;
        var r = 0;
        a.resvDrain_post = 0, a.resvDrain_pre = 0, 0 != (n = e.ResvSize % 8) && (r += n), (n = e.ResvSize - r - e.ResvMax) > 0 && (r += n);
        var s = Math.min(8 * a.main_data_begin, r) / 8;
        a.resvDrain_pre += 8 * s, r -= 8 * s, e.ResvSize -= 8 * s, a.main_data_begin -= s, a.resvDrain_post += r, e.ResvSize -= r;
      };
    }

    function VBRTag() {
      this.setModules = function (e, t, n) {};

      var e = [0, 49345, 49537, 320, 49921, 960, 640, 49729, 50689, 1728, 1920, 51009, 1280, 50625, 50305, 1088, 52225, 3264, 3456, 52545, 3840, 53185, 52865, 3648, 2560, 51905, 52097, 2880, 51457, 2496, 2176, 51265, 55297, 6336, 6528, 55617, 6912, 56257, 55937, 6720, 7680, 57025, 57217, 8e3, 56577, 7616, 7296, 56385, 5120, 54465, 54657, 5440, 55041, 6080, 5760, 54849, 53761, 4800, 4992, 54081, 4352, 53697, 53377, 4160, 61441, 12480, 12672, 61761, 13056, 62401, 62081, 12864, 13824, 63169, 63361, 14144, 62721, 13760, 13440, 62529, 15360, 64705, 64897, 15680, 65281, 16320, 16e3, 65089, 64001, 15040, 15232, 64321, 14592, 63937, 63617, 14400, 10240, 59585, 59777, 10560, 60161, 11200, 10880, 59969, 60929, 11968, 12160, 61249, 11520, 60865, 60545, 11328, 58369, 9408, 9600, 58689, 9984, 59329, 59009, 9792, 8704, 58049, 58241, 9024, 57601, 8640, 8320, 57409, 40961, 24768, 24960, 41281, 25344, 41921, 41601, 25152, 26112, 42689, 42881, 26432, 42241, 26048, 25728, 42049, 27648, 44225, 44417, 27968, 44801, 28608, 28288, 44609, 43521, 27328, 27520, 43841, 26880, 43457, 43137, 26688, 30720, 47297, 47489, 31040, 47873, 31680, 31360, 47681, 48641, 32448, 32640, 48961, 32e3, 48577, 48257, 31808, 46081, 29888, 30080, 46401, 30464, 47041, 46721, 30272, 29184, 45761, 45953, 29504, 45313, 29120, 28800, 45121, 20480, 37057, 37249, 20800, 37633, 21440, 21120, 37441, 38401, 22208, 22400, 38721, 21760, 38337, 38017, 21568, 39937, 23744, 23936, 40257, 24320, 40897, 40577, 24128, 23040, 39617, 39809, 23360, 39169, 22976, 22656, 38977, 34817, 18624, 18816, 35137, 19200, 35777, 35457, 19008, 19968, 36545, 36737, 20288, 36097, 19904, 19584, 35905, 17408, 33985, 34177, 17728, 34561, 18368, 18048, 34369, 33281, 17088, 17280, 33601, 16640, 33217, 32897, 16448];

      function crcUpdateLookup(t, n) {
        return n = n >> 8 ^ e[255 & (n ^ t)];
      }

      this.updateMusicCRC = function (e, t, n, a) {
        for (var r = 0; r < a; ++r) {
          e[0] = crcUpdateLookup(t[n + r], e[0]);
        }
      };
    }

    function BitStream() {
      var n = this,
          a = null,
          s = null,
          o = null,
          i = null;

      this.setModules = function (e, t, n, r) {
        a = e, s = t, o = n, i = r;
      };

      var _ = null,
          l = 0,
          c = 0,
          f = 0;

      function putheader_bits(e) {
        t.arraycopy(e.header[e.w_ptr].buf, 0, _, c, e.sideinfo_len), c += e.sideinfo_len, l += 8 * e.sideinfo_len, e.w_ptr = e.w_ptr + 1 & LameInternalFlags.MAX_HEADER_BUF - 1;
      }

      function putbits2(e, t, n) {
        for (; n > 0;) {
          var a;
          0 == f && (f = 8, c++, e.header[e.w_ptr].write_timing == l && putheader_bits(e), _[c] = 0), n -= a = Math.min(n, f), f -= a, _[c] |= t >> n << f, l += a;
        }
      }

      function putbits_noheaders(e, t, n) {
        for (; n > 0;) {
          var a;
          0 == f && (f = 8, c++, _[c] = 0), n -= a = Math.min(n, f), f -= a, _[c] |= t >> n << f, l += a;
        }
      }

      function drain_into_ancillary(e, t) {
        var n,
            a = e.internal_flags;

        if (t >= 8 && (putbits2(a, 76, 8), t -= 8), t >= 8 && (putbits2(a, 65, 8), t -= 8), t >= 8 && (putbits2(a, 77, 8), t -= 8), t >= 8 && (putbits2(a, 69, 8), t -= 8), t >= 32) {
          var r = o.getLameShortVersion();
          if (t >= 32) for (n = 0; n < r.length && t >= 8; ++n) {
            t -= 8, putbits2(a, r.charCodeAt(n), 8);
          }
        }

        for (; t >= 1; t -= 1) {
          putbits2(a, a.ancillary_flag, 1), a.ancillary_flag ^= e.disable_reservoir ? 0 : 1;
        }
      }

      function writeheader(e, t, n) {
        for (var a = e.header[e.h_ptr].ptr; n > 0;) {
          var r = Math.min(n, 8 - (7 & a));
          n -= r, e.header[e.h_ptr].buf[a >> 3] |= t >> n << 8 - (7 & a) - r, a += r;
        }

        e.header[e.h_ptr].ptr = a;
      }

      function CRC_update(e, t) {
        e <<= 8;

        for (var n = 0; n < 8; n++) {
          0 != (65536 & ((t <<= 1) ^ (e <<= 1))) && (t ^= 32773);
        }

        return t;
      }

      function huffman_coder_count1(e, t) {
        var n,
            a = r.ht[t.count1table_select + 32],
            s = 0,
            o = t.big_values,
            i = t.big_values;

        for (n = (t.count1 - t.big_values) / 4; n > 0; --n) {
          var _ = 0,
              l = 0;
          0 != t.l3_enc[o + 0] && (l += 8, t.xr[i + 0] < 0 && _++), 0 != t.l3_enc[o + 1] && (l += 4, _ *= 2, t.xr[i + 1] < 0 && _++), 0 != t.l3_enc[o + 2] && (l += 2, _ *= 2, t.xr[i + 2] < 0 && _++), 0 != t.l3_enc[o + 3] && (l++, _ *= 2, t.xr[i + 3] < 0 && _++), o += 4, i += 4, putbits2(e, _ + a.table[l], a.hlen[l]), s += a.hlen[l];
        }

        return s;
      }

      function Huffmancode(e, t, n, a, s) {
        var o = r.ht[t],
            i = 0;
        if (0 == t) return i;

        for (var _ = n; _ < a; _ += 2) {
          var l = 0,
              c = 0,
              f = o.xlen,
              u = o.xlen,
              d = 0,
              h = s.l3_enc[_],
              p = s.l3_enc[_ + 1];

          if (0 != h && (s.xr[_] < 0 && d++, l--), t > 15) {
            if (h > 14) d |= h - 15 << 1, c = f, h = 15;
            if (p > 14) d <<= f, d |= p - 15, c += f, p = 15;
            u = 16;
          }

          0 != p && (d <<= 1, s.xr[_ + 1] < 0 && d++, l--), h = h * u + p, c -= l, l += o.hlen[h], putbits2(e, o.table[h], l), putbits2(e, d, c), i += l + c;
        }

        return i;
      }

      function ShortHuffmancodebits(e, t) {
        var n = 3 * e.scalefac_band.s[3];
        n > t.big_values && (n = t.big_values);
        var a = Huffmancode(e, t.table_select[0], 0, n, t);
        return a += Huffmancode(e, t.table_select[1], n, t.big_values, t);
      }

      function LongHuffmancodebits(e, t) {
        var n, a, r, s;
        n = t.big_values;
        var o = t.region0_count + 1;
        return r = e.scalefac_band.l[o], o += t.region1_count + 1, r > n && (r = n), (s = e.scalefac_band.l[o]) > n && (s = n), a = Huffmancode(e, t.table_select[0], 0, r, t), a += Huffmancode(e, t.table_select[1], r, s, t), a += Huffmancode(e, t.table_select[2], s, n, t);
      }

      function TotalBytes() {
        this.total = 0;
      }

      function compute_flushbits(e, a) {
        var r,
            s,
            o,
            i,
            _,
            f = e.internal_flags;

        return _ = f.w_ptr, -1 == (i = f.h_ptr - 1) && (i = LameInternalFlags.MAX_HEADER_BUF - 1), r = f.header[i].write_timing - l, a.total = r, r >= 0 && (s = 1 + i - _, i < _ && (s = 1 + i - _ + LameInternalFlags.MAX_HEADER_BUF), r -= 8 * s * f.sideinfo_len), r += o = n.getframebits(e), a.total += o, a.total % 8 != 0 ? a.total = 1 + a.total / 8 : a.total = a.total / 8, a.total += c + 1, r < 0 && t.err.println("strange error flushing buffer ... \n"), r;
      }

      this.getframebits = function (e) {
        var t,
            n = e.internal_flags;
        return t = 0 != n.bitrate_index ? r.bitrate_table[e.version][n.bitrate_index] : e.brate, 8 * (0 | 72e3 * (e.version + 1) * t / e.out_samplerate + n.padding);
      }, this.CRC_writeheader = function (e, t) {
        var n = 65535;
        n = CRC_update(255 & t[2], n), n = CRC_update(255 & t[3], n);

        for (var a = 6; a < e.sideinfo_len; a++) {
          n = CRC_update(255 & t[a], n);
        }

        t[4] = byte(n >> 8), t[5] = byte(255 & n);
      }, this.flush_bitstream = function (e) {
        var t,
            n,
            r = e.internal_flags;

        if (r.h_ptr, t = r.l3_side, !((n = compute_flushbits(e, new TotalBytes())) < 0)) {
          if (drain_into_ancillary(e, n), r.ResvSize = 0, t.main_data_begin = 0, r.findReplayGain) {
            var s = a.GetTitleGain(r.rgdata);
            r.RadioGain = 0 | Math.floor(10 * s + .5);
          }

          r.findPeakSample && (r.noclipGainChange = 0 | Math.ceil(20 * Math_log10(r.PeakSample / 32767) * 10), r.noclipGainChange > 0 && (EQ(e.scale, 1) || EQ(e.scale, 0)) ? r.noclipScale = Math.floor(32767 / r.PeakSample * 100) / 100 : r.noclipScale = -1);
        }
      }, this.add_dummy_byte = function (e, t, n) {
        for (var a, r = e.internal_flags; n-- > 0;) {
          for (putbits_noheaders(0, t, 8), a = 0; a < LameInternalFlags.MAX_HEADER_BUF; ++a) {
            r.header[a].write_timing += 8;
          }
        }
      }, this.format_bitstream = function (n) {
        var a,
            r = n.internal_flags;
        a = r.l3_side;
        var s = this.getframebits(n);
        drain_into_ancillary(n, a.resvDrain_pre), function encodeSideInfo2(n, a) {
          var r,
              s,
              o,
              i = n.internal_flags;

          if (r = i.l3_side, i.header[i.h_ptr].ptr = 0, e.fill(i.header[i.h_ptr].buf, 0, i.sideinfo_len, 0), n.out_samplerate < 16e3 ? writeheader(i, 4094, 12) : writeheader(i, 4095, 12), writeheader(i, n.version, 1), writeheader(i, 1, 2), writeheader(i, n.error_protection ? 0 : 1, 1), writeheader(i, i.bitrate_index, 4), writeheader(i, i.samplerate_index, 2), writeheader(i, i.padding, 1), writeheader(i, n.extension, 1), writeheader(i, n.mode.ordinal(), 2), writeheader(i, i.mode_ext, 2), writeheader(i, n.copyright, 1), writeheader(i, n.original, 1), writeheader(i, n.emphasis, 2), n.error_protection && writeheader(i, 0, 16), 1 == n.version) {
            for (writeheader(i, r.main_data_begin, 9), 2 == i.channels_out ? writeheader(i, r.private_bits, 3) : writeheader(i, r.private_bits, 5), o = 0; o < i.channels_out; o++) {
              var _;

              for (_ = 0; _ < 4; _++) {
                writeheader(i, r.scfsi[o][_], 1);
              }
            }

            for (s = 0; s < 2; s++) {
              for (o = 0; o < i.channels_out; o++) {
                writeheader(i, (l = r.tt[s][o]).part2_3_length + l.part2_length, 12), writeheader(i, l.big_values / 2, 9), writeheader(i, l.global_gain, 8), writeheader(i, l.scalefac_compress, 4), l.block_type != Encoder.NORM_TYPE ? (writeheader(i, 1, 1), writeheader(i, l.block_type, 2), writeheader(i, l.mixed_block_flag, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), writeheader(i, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), writeheader(i, l.table_select[1], 5), writeheader(i, l.subblock_gain[0], 3), writeheader(i, l.subblock_gain[1], 3), writeheader(i, l.subblock_gain[2], 3)) : (writeheader(i, 0, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), writeheader(i, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), writeheader(i, l.table_select[1], 5), 14 == l.table_select[2] && (l.table_select[2] = 16), writeheader(i, l.table_select[2], 5), writeheader(i, l.region0_count, 4), writeheader(i, l.region1_count, 3)), writeheader(i, l.preflag, 1), writeheader(i, l.scalefac_scale, 1), writeheader(i, l.count1table_select, 1);
              }
            }
          } else for (writeheader(i, r.main_data_begin, 8), writeheader(i, r.private_bits, i.channels_out), s = 0, o = 0; o < i.channels_out; o++) {
            var l;
            writeheader(i, (l = r.tt[s][o]).part2_3_length + l.part2_length, 12), writeheader(i, l.big_values / 2, 9), writeheader(i, l.global_gain, 8), writeheader(i, l.scalefac_compress, 9), l.block_type != Encoder.NORM_TYPE ? (writeheader(i, 1, 1), writeheader(i, l.block_type, 2), writeheader(i, l.mixed_block_flag, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), writeheader(i, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), writeheader(i, l.table_select[1], 5), writeheader(i, l.subblock_gain[0], 3), writeheader(i, l.subblock_gain[1], 3), writeheader(i, l.subblock_gain[2], 3)) : (writeheader(i, 0, 1), 14 == l.table_select[0] && (l.table_select[0] = 16), writeheader(i, l.table_select[0], 5), 14 == l.table_select[1] && (l.table_select[1] = 16), writeheader(i, l.table_select[1], 5), 14 == l.table_select[2] && (l.table_select[2] = 16), writeheader(i, l.table_select[2], 5), writeheader(i, l.region0_count, 4), writeheader(i, l.region1_count, 3)), writeheader(i, l.scalefac_scale, 1), writeheader(i, l.count1table_select, 1);
          }

          n.error_protection && CRC_writeheader(i, i.header[i.h_ptr].buf);
          var c = i.h_ptr;
          i.h_ptr = c + 1 & LameInternalFlags.MAX_HEADER_BUF - 1, i.header[i.h_ptr].write_timing = i.header[c].write_timing + a, i.h_ptr == i.w_ptr && t.err.println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
        }(n, s);
        var o = 8 * r.sideinfo_len;

        if (o += function writeMainData(e) {
          var t,
              n,
              a,
              r,
              s = 0,
              o = e.internal_flags,
              i = o.l3_side;
          if (1 == e.version) for (t = 0; t < 2; t++) {
            for (n = 0; n < o.channels_out; n++) {
              var _ = i.tt[t][n],
                  l = Takehiro.slen1_tab[_.scalefac_compress],
                  c = Takehiro.slen2_tab[_.scalefac_compress];

              for (r = 0, a = 0; a < _.sfbdivide; a++) {
                -1 != _.scalefac[a] && (putbits2(o, _.scalefac[a], l), r += l);
              }

              for (; a < _.sfbmax; a++) {
                -1 != _.scalefac[a] && (putbits2(o, _.scalefac[a], c), r += c);
              }

              _.block_type == Encoder.SHORT_TYPE ? r += ShortHuffmancodebits(o, _) : r += LongHuffmancodebits(o, _), s += r += huffman_coder_count1(o, _);
            }
          } else for (t = 0, n = 0; n < o.channels_out; n++) {
            var f,
                u,
                d = 0;

            if (r = 0, a = 0, u = 0, (_ = i.tt[t][n]).block_type == Encoder.SHORT_TYPE) {
              for (; u < 4; u++) {
                var h = _.sfb_partition_table[u] / 3,
                    p = _.slen[u];

                for (f = 0; f < h; f++, a++) {
                  putbits2(o, Math.max(_.scalefac[3 * a + 0], 0), p), putbits2(o, Math.max(_.scalefac[3 * a + 1], 0), p), putbits2(o, Math.max(_.scalefac[3 * a + 2], 0), p), d += 3 * p;
                }
              }

              r += ShortHuffmancodebits(o, _);
            } else {
              for (; u < 4; u++) {
                for (h = _.sfb_partition_table[u], p = _.slen[u], f = 0; f < h; f++, a++) {
                  putbits2(o, Math.max(_.scalefac[a], 0), p), d += p;
                }
              }

              r += LongHuffmancodebits(o, _);
            }

            s += d + (r += huffman_coder_count1(o, _));
          }
          return s;
        }(n), drain_into_ancillary(n, a.resvDrain_post), o += a.resvDrain_post, a.main_data_begin += (s - o) / 8, compute_flushbits(n, new TotalBytes()) != r.ResvSize && t.err.println("Internal buffer inconsistency. flushbits <> ResvSize"), 8 * a.main_data_begin != r.ResvSize && (t.err.printf("bit reservoir error: \nl3_side.main_data_begin: %d \nResvoir size:             %d \nresv drain (post)         %d \nresv drain (pre)          %d \nheader and sideinfo:      %d \ndata bits:                %d \ntotal bits:               %d (remainder: %d) \nbitsperframe:             %d \n", 8 * a.main_data_begin, r.ResvSize, a.resvDrain_post, a.resvDrain_pre, 8 * r.sideinfo_len, o - a.resvDrain_post - 8 * r.sideinfo_len, o, o % 8, s), t.err.println("This is a fatal error.  It has several possible causes:"), t.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations"), t.err.println(" 9%%  Your system is overclocked"), t.err.println(" 1%%  bug in LAME encoding library"), r.ResvSize = 8 * a.main_data_begin), l > 1e9) {
          var i;

          for (i = 0; i < LameInternalFlags.MAX_HEADER_BUF; ++i) {
            r.header[i].write_timing -= l;
          }

          l = 0;
        }

        return 0;
      }, this.copy_buffer = function (e, n, r, o, l) {
        var u = c + 1;
        if (u <= 0) return 0;
        if (0 != o && u > o) return -1;

        if (t.arraycopy(_, 0, n, r, u), c = -1, f = 0, 0 != l) {
          var d = new_int(1);
          if (d[0] = e.nMusicCRC, i.updateMusicCRC(d, n, r, u), e.nMusicCRC = d[0], u > 0 && (e.VBR_seek_table.nBytesWritten += u), e.decode_on_the_fly) for (var h, p = new_float_n([2, 1152]), m = u, b = -1; 0 != b;) {
            if (b = s.hip_decode1_unclipped(e.hip, n, r, m, p[0], p[1]), m = 0, -1 == b && (b = 0), b > 0) {
              if (e.findPeakSample) {
                for (h = 0; h < b; h++) {
                  p[0][h] > e.PeakSample ? e.PeakSample = p[0][h] : -p[0][h] > e.PeakSample && (e.PeakSample = -p[0][h]);
                }

                if (e.channels_out > 1) for (h = 0; h < b; h++) {
                  p[1][h] > e.PeakSample ? e.PeakSample = p[1][h] : -p[1][h] > e.PeakSample && (e.PeakSample = -p[1][h]);
                }
              }

              if (e.findReplayGain && a.AnalyzeSamples(e.rgdata, p[0], 0, p[1], 0, b, e.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;
            }
          }
        }

        return u;
      }, this.init_bit_stream_w = function (e) {
        _ = new_byte(Lame.LAME_MAXMP3BUFFER), e.h_ptr = e.w_ptr = 0, e.header[e.h_ptr].write_timing = 0, c = -1, f = 0, l = 0;
      };
    }

    function HuffCodeTab(e, t, n, a) {
      this.xlen = e, this.linmax = t, this.table = n, this.hlen = a;
    }

    a.MAX_VALUE = 34028235e31, VbrMode.vbr_off = new VbrMode(0), VbrMode.vbr_mt = new VbrMode(1), VbrMode.vbr_rh = new VbrMode(2), VbrMode.vbr_abr = new VbrMode(3), VbrMode.vbr_mtrh = new VbrMode(4), VbrMode.vbr_default = VbrMode.vbr_mtrh, MPEGMode.STEREO = new MPEGMode(0), MPEGMode.JOINT_STEREO = new MPEGMode(1), MPEGMode.DUAL_CHANNEL = new MPEGMode(2), MPEGMode.MONO = new MPEGMode(3), MPEGMode.NOT_SET = new MPEGMode(4), GainAnalysis.STEPS_per_dB = 100, GainAnalysis.MAX_dB = 120, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES = -24601, GainAnalysis.GAIN_ANALYSIS_ERROR = 0, GainAnalysis.GAIN_ANALYSIS_OK = 1, GainAnalysis.INIT_GAIN_ANALYSIS_ERROR = 0, GainAnalysis.INIT_GAIN_ANALYSIS_OK = 1, GainAnalysis.YULE_ORDER = 10, GainAnalysis.MAX_ORDER = GainAnalysis.YULE_ORDER, GainAnalysis.MAX_SAMP_FREQ = 48e3, GainAnalysis.RMS_WINDOW_TIME_NUMERATOR = 1, GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR = 20, GainAnalysis.MAX_SAMPLES_PER_WINDOW = GainAnalysis.MAX_SAMP_FREQ * GainAnalysis.RMS_WINDOW_TIME_NUMERATOR / GainAnalysis.RMS_WINDOW_TIME_DENOMINATOR + 1, VBRTag.NUMTOCENTRIES = 100, VBRTag.MAXFRAMESIZE = 2880, BitStream.EQ = function (e, t) {
      return Math.abs(e) > Math.abs(t) ? Math.abs(e - t) <= 1e-6 * Math.abs(e) : Math.abs(e - t) <= 1e-6 * Math.abs(t);
    }, BitStream.NEQ = function (e, t) {
      return !BitStream.EQ(e, t);
    };
    var r = {};

    function MeanBits(e) {
      this.bits = e;
    }

    function CalcNoiseResult() {
      this.over_noise = 0, this.tot_noise = 0, this.max_noise = 0, this.over_count = 0, this.over_SSD = 0, this.bits = 0;
    }

    function VBRQuantize() {
      this.setModules = function (e, t) {};
    }

    function ATH() {
      this.useAdjust = 0, this.aaSensitivityP = 0, this.adjust = 0, this.adjustLimit = 0, this.decay = 0, this.floor = 0, this.l = new_float(Encoder.SBMAX_l), this.s = new_float(Encoder.SBMAX_s), this.psfb21 = new_float(Encoder.PSFB21), this.psfb12 = new_float(Encoder.PSFB12), this.cb_l = new_float(Encoder.CBANDS), this.cb_s = new_float(Encoder.CBANDS), this.eql_w = new_float(Encoder.BLKSIZE / 2);
    }

    function LameGlobalFlags() {
      this.class_id = 0, this.num_samples = 0, this.num_channels = 0, this.in_samplerate = 0, this.out_samplerate = 0, this.scale = 0, this.scale_left = 0, this.scale_right = 0, this.analysis = !1, this.bWriteVbrTag = !1, this.decode_only = !1, this.quality = 0, this.mode = MPEGMode.STEREO, this.force_ms = !1, this.free_format = !1, this.findReplayGain = !1, this.decode_on_the_fly = !1, this.write_id3tag_automatic = !1, this.brate = 0, this.compression_ratio = 0, this.copyright = 0, this.original = 0, this.extension = 0, this.emphasis = 0, this.error_protection = 0, this.strict_ISO = !1, this.disable_reservoir = !1, this.quant_comp = 0, this.quant_comp_short = 0, this.experimentalY = !1, this.experimentalZ = 0, this.exp_nspsytune = 0, this.preset = 0, this.VBR = null, this.VBR_q_frac = 0, this.VBR_q = 0, this.VBR_mean_bitrate_kbps = 0, this.VBR_min_bitrate_kbps = 0, this.VBR_max_bitrate_kbps = 0, this.VBR_hard_min = 0, this.lowpassfreq = 0, this.highpassfreq = 0, this.lowpasswidth = 0, this.highpasswidth = 0, this.maskingadjust = 0, this.maskingadjust_short = 0, this.ATHonly = !1, this.ATHshort = !1, this.noATH = !1, this.ATHtype = 0, this.ATHcurve = 0, this.ATHlower = 0, this.athaa_type = 0, this.athaa_loudapprox = 0, this.athaa_sensitivity = 0, this.short_blocks = null, this.useTemporal = !1, this.interChRatio = 0, this.msfix = 0, this.tune = !1, this.tune_value_a = 0, this.version = 0, this.encoder_delay = 0, this.encoder_padding = 0, this.framesize = 0, this.frameNum = 0, this.lame_allocated_gfp = 0, this.internal_flags = null;
    }

    function CBRNewIterationLoop(e) {
      var t = e;
      this.quantize = t, this.iteration_loop = function (e, t, n, a) {
        var r,
            o = e.internal_flags,
            i = new_float(s.SFBMAX),
            _ = new_float(576),
            l = new_int(2),
            c = 0,
            f = o.l3_side,
            u = new MeanBits(c);

        this.quantize.rv.ResvFrameBegin(e, u), c = u.bits;

        for (var d = 0; d < o.mode_gr; d++) {
          r = this.quantize.qupvt.on_pe(e, t, l, c, d, d), o.mode_ext == Encoder.MPG_MD_MS_LR && (this.quantize.ms_convert(o.l3_side, d), this.quantize.qupvt.reduce_side(l, n[d], c, r));

          for (var h = 0; h < o.channels_out; h++) {
            var p,
                m,
                b = f.tt[d][h];
            b.block_type != Encoder.SHORT_TYPE ? (p = 0, m = o.PSY.mask_adjust - p) : (p = 0, m = o.PSY.mask_adjust_short - p), o.masking_lower = Math.pow(10, .1 * m), this.quantize.init_outer_loop(o, b), this.quantize.init_xrpow(o, b, _) && (this.quantize.qupvt.calc_xmin(e, a[d][h], b, i), this.quantize.outer_loop(e, b, i, _, h, l[h])), this.quantize.iteration_finish_one(o, d, h);
          }
        }

        this.quantize.rv.ResvFrameEnd(o, c);
      };
    }

    function ReplayGain() {}

    function ScaleFac(e, n, a, r) {
      this.l = new_int(1 + Encoder.SBMAX_l), this.s = new_int(1 + Encoder.SBMAX_s), this.psfb21 = new_int(1 + Encoder.PSFB21), this.psfb12 = new_int(1 + Encoder.PSFB12);
      var s = this.l,
          o = this.s;
      4 == arguments.length && (this.arrL = arguments[0], this.arrS = arguments[1], this.arr21 = arguments[2], this.arr12 = arguments[3], t.arraycopy(this.arrL, 0, s, 0, Math.min(this.arrL.length, this.l.length)), t.arraycopy(this.arrS, 0, o, 0, Math.min(this.arrS.length, this.s.length)), t.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length)), t.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length)));
    }

    function QuantizePVT() {
      var e = null,
          t = null,
          r = null;
      this.setModules = function (n, a, s) {
        e = n, t = a, r = s;
      }, this.IPOW20 = function (e) {
        return u[e];
      };
      var o = 2220446049250313e-31,
          i = QuantizePVT.IXMAX_VAL + 2,
          _ = QuantizePVT.Q_MAX,
          l = QuantizePVT.Q_MAX2;
      this.nr_of_sfb_block = [[[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]], [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]], [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]], [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]], [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]], [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];
      var c = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 3, 3, 3, 2, 0];
      this.pretab = c, this.sfBandIndex = [new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464, 540, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418, 576], [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384, 576], [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550, 576], [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464, 522, 576], [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0]), new ScaleFac([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570, 572, 574, 576], [0, 8, 16, 24, 36, 52, 72, 96, 124, 160, 162, 164, 166, 192], [0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0])];
      var f = new_float(_ + l + 1),
          u = new_float(_),
          d = new_float(i),
          h = new_float(i);

      function ATHmdct(e, t) {
        var n = r.ATHformula(t, e);
        return n -= 100, n = Math.pow(10, n / 10 + e.ATHlower);
      }

      function StartLine(e) {
        this.s = e;
      }

      this.adj43 = h, this.iteration_init = function (t) {
        var n,
            r = t.internal_flags,
            s = r.l3_side;

        if (0 == r.iteration_init_init) {
          for (r.iteration_init_init = 1, s.main_data_begin = 0, function compute_ath(e) {
            for (var t = e.internal_flags.ATH.l, n = e.internal_flags.ATH.psfb21, r = e.internal_flags.ATH.s, s = e.internal_flags.ATH.psfb12, o = e.internal_flags, i = e.out_samplerate, _ = 0; _ < Encoder.SBMAX_l; _++) {
              var l = o.scalefac_band.l[_],
                  c = o.scalefac_band.l[_ + 1];
              t[_] = a.MAX_VALUE;

              for (var f = l; f < c; f++) {
                var u = ATHmdct(e, f * i / 1152);
                t[_] = Math.min(t[_], u);
              }
            }

            for (_ = 0; _ < Encoder.PSFB21; _++) {
              for (l = o.scalefac_band.psfb21[_], c = o.scalefac_band.psfb21[_ + 1], n[_] = a.MAX_VALUE, f = l; f < c; f++) {
                u = ATHmdct(e, f * i / 1152), n[_] = Math.min(n[_], u);
              }
            }

            for (_ = 0; _ < Encoder.SBMAX_s; _++) {
              for (l = o.scalefac_band.s[_], c = o.scalefac_band.s[_ + 1], r[_] = a.MAX_VALUE, f = l; f < c; f++) {
                u = ATHmdct(e, f * i / 384), r[_] = Math.min(r[_], u);
              }

              r[_] *= o.scalefac_band.s[_ + 1] - o.scalefac_band.s[_];
            }

            for (_ = 0; _ < Encoder.PSFB12; _++) {
              for (l = o.scalefac_band.psfb12[_], c = o.scalefac_band.psfb12[_ + 1], s[_] = a.MAX_VALUE, f = l; f < c; f++) {
                u = ATHmdct(e, f * i / 384), s[_] = Math.min(s[_], u);
              }

              s[_] *= o.scalefac_band.s[13] - o.scalefac_band.s[12];
            }

            if (e.noATH) {
              for (_ = 0; _ < Encoder.SBMAX_l; _++) {
                t[_] = 1e-20;
              }

              for (_ = 0; _ < Encoder.PSFB21; _++) {
                n[_] = 1e-20;
              }

              for (_ = 0; _ < Encoder.SBMAX_s; _++) {
                r[_] = 1e-20;
              }

              for (_ = 0; _ < Encoder.PSFB12; _++) {
                s[_] = 1e-20;
              }
            }

            o.ATH.floor = 10 * Math_log10(ATHmdct(e, -1));
          }(t), d[0] = 0, n = 1; n < i; n++) {
            d[n] = Math.pow(n, 4 / 3);
          }

          for (n = 0; n < i - 1; n++) {
            h[n] = n + 1 - Math.pow(.5 * (d[n] + d[n + 1]), .75);
          }

          for (h[n] = .5, n = 0; n < _; n++) {
            u[n] = Math.pow(2, -.1875 * (n - 210));
          }

          for (n = 0; n <= _ + l; n++) {
            f[n] = Math.pow(2, .25 * (n - 210 - l));
          }

          var o, c, p, m;

          for (e.huffman_init(r), (n = t.exp_nspsytune >> 2 & 63) >= 32 && (n -= 64), o = Math.pow(10, n / 4 / 10), (n = t.exp_nspsytune >> 8 & 63) >= 32 && (n -= 64), c = Math.pow(10, n / 4 / 10), (n = t.exp_nspsytune >> 14 & 63) >= 32 && (n -= 64), p = Math.pow(10, n / 4 / 10), (n = t.exp_nspsytune >> 20 & 63) >= 32 && (n -= 64), m = p * Math.pow(10, n / 4 / 10), n = 0; n < Encoder.SBMAX_l; n++) {
            b = n <= 6 ? o : n <= 13 ? c : n <= 20 ? p : m, r.nsPsy.longfact[n] = b;
          }

          for (n = 0; n < Encoder.SBMAX_s; n++) {
            var b;
            b = n <= 5 ? o : n <= 10 ? c : n <= 11 ? p : m, r.nsPsy.shortfact[n] = b;
          }
        }
      }, this.on_pe = function (e, n, a, r, s, o) {
        var i,
            _,
            l = e.internal_flags,
            c = 0,
            f = new_int(2),
            u = new MeanBits(c),
            d = t.ResvMaxBits(e, r, u, o),
            h = (c = u.bits) + d;

        for (h > LameInternalFlags.MAX_BITS_PER_GRANULE && (h = LameInternalFlags.MAX_BITS_PER_GRANULE), i = 0, _ = 0; _ < l.channels_out; ++_) {
          a[_] = Math.min(LameInternalFlags.MAX_BITS_PER_CHANNEL, c / l.channels_out), f[_] = 0 | a[_] * n[s][_] / 700 - a[_], f[_] > 3 * r / 4 && (f[_] = 3 * r / 4), f[_] < 0 && (f[_] = 0), f[_] + a[_] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (f[_] = Math.max(0, LameInternalFlags.MAX_BITS_PER_CHANNEL - a[_])), i += f[_];
        }

        if (i > d) for (_ = 0; _ < l.channels_out; ++_) {
          f[_] = d * f[_] / i;
        }

        for (_ = 0; _ < l.channels_out; ++_) {
          a[_] += f[_], d -= f[_];
        }

        for (i = 0, _ = 0; _ < l.channels_out; ++_) {
          i += a[_];
        }

        if (i > LameInternalFlags.MAX_BITS_PER_GRANULE) {
          for (_ = 0; _ < l.channels_out; ++_) {
            a[_] *= LameInternalFlags.MAX_BITS_PER_GRANULE, a[_] /= i, a[_];
          }
        }

        return h;
      }, this.reduce_side = function (e, t, n, a) {
        var r = .33 * (.5 - t) / .5;
        r < 0 && (r = 0), r > .5 && (r = .5);
        var s = 0 | .5 * r * (e[0] + e[1]);
        s > LameInternalFlags.MAX_BITS_PER_CHANNEL - e[0] && (s = LameInternalFlags.MAX_BITS_PER_CHANNEL - e[0]), s < 0 && (s = 0), e[1] >= 125 && (e[1] - s > 125 ? (e[0] < n && (e[0] += s), e[1] -= s) : (e[0] += e[1] - 125, e[1] = 125)), (s = e[0] + e[1]) > a && (e[0] = a * e[0] / s, e[1] = a * e[1] / s);
      }, this.athAdjust = function (e, t, a) {
        var r = 90.30873362,
            s = n.FAST_LOG10_X(t, 10),
            o = e * e,
            i = 0;
        return s -= a, o > 1e-20 && (i = 1 + n.FAST_LOG10_X(o, 10 / r)), i < 0 && (i = 0), s *= i, s += a + r - 94.82444863, Math.pow(10, .1 * s);
      }, this.calc_xmin = function (e, t, n, a) {
        var r,
            s = 0,
            i = e.internal_flags,
            _ = 0,
            l = 0,
            c = i.ATH,
            f = n.xr,
            u = e.VBR == VbrMode.vbr_mtrh ? 1 : 0,
            d = i.masking_lower;

        for (e.VBR != VbrMode.vbr_mtrh && e.VBR != VbrMode.vbr_mt || (d = 1), r = 0; r < n.psy_lmax; r++) {
          E = (w = e.VBR == VbrMode.vbr_rh || e.VBR == VbrMode.vbr_mtrh ? athAdjust(c.adjust, c.l[r], c.floor) : c.adjust * c.l[r]) / (b = n.width[r]), S = o, R = b >> 1, B = 0;

          do {
            B += A = f[_] * f[_], S += A < E ? A : E, B += T = f[++_] * f[_], S += T < E ? T : E, _++;
          } while (--R > 0);

          if (B > w && l++, r == Encoder.SBPSY_l) S < (y = w * i.nsPsy.longfact[r]) && (S = y);
          if (0 != u && (w = S), !e.ATHonly) if ((M = t.en.l[r]) > 0) y = B * t.thm.l[r] * d / M, 0 != u && (y *= i.nsPsy.longfact[r]), w < y && (w = y);
          a[s++] = 0 != u ? w : w * i.nsPsy.longfact[r];
        }

        var h = 575;
        if (n.block_type != Encoder.SHORT_TYPE) for (var p = 576; 0 != p-- && BitStream.EQ(f[p], 0);) {
          h = p;
        }
        n.max_nonzero_coeff = h;

        for (var m = n.sfb_smin; r < n.psymax; m++, r += 3) {
          var b, v, g;

          for (g = e.VBR == VbrMode.vbr_rh || e.VBR == VbrMode.vbr_mtrh ? athAdjust(c.adjust, c.s[m], c.floor) : c.adjust * c.s[m], b = n.width[r], v = 0; v < 3; v++) {
            var w,
                E,
                S,
                M,
                y,
                B = 0,
                R = b >> 1;
            E = g / b, S = o;

            do {
              var A, T;
              B += A = f[_] * f[_], S += A < E ? A : E, B += T = f[++_] * f[_], S += T < E ? T : E, _++;
            } while (--R > 0);

            if (B > g && l++, m == Encoder.SBPSY_s) S < (y = g * i.nsPsy.shortfact[m]) && (S = y);
            if (w = 0 != u ? S : g, !e.ATHonly && !e.ATHshort) if ((M = t.en.s[m][v]) > 0) y = B * t.thm.s[m][v] * d / M, 0 != u && (y *= i.nsPsy.shortfact[m]), w < y && (w = y);
            a[s++] = 0 != u ? w : w * i.nsPsy.shortfact[m];
          }

          e.useTemporal && (a[s - 3] > a[s - 3 + 1] && (a[s - 3 + 1] += (a[s - 3] - a[s - 3 + 1]) * i.decay), a[s - 3 + 1] > a[s - 3 + 2] && (a[s - 3 + 2] += (a[s - 3 + 1] - a[s - 3 + 2]) * i.decay));
        }

        return l;
      }, this.calc_noise_core = function (e, t, n, a) {
        var r = 0,
            s = t.s,
            o = e.l3_enc;
        if (s > e.count1) for (; 0 != n--;) {
          _ = e.xr[s], s++, r += _ * _, _ = e.xr[s], s++, r += _ * _;
        } else if (s > e.big_values) {
          var i = new_float(2);

          for (i[0] = 0, i[1] = a; 0 != n--;) {
            _ = Math.abs(e.xr[s]) - i[o[s]], s++, r += _ * _, _ = Math.abs(e.xr[s]) - i[o[s]], s++, r += _ * _;
          }
        } else for (; 0 != n--;) {
          var _;

          _ = Math.abs(e.xr[s]) - d[o[s]] * a, s++, r += _ * _, _ = Math.abs(e.xr[s]) - d[o[s]] * a, s++, r += _ * _;
        }
        return t.s = s, r;
      }, this.calc_noise = function (e, t, a, r, s) {
        var o,
            i,
            _ = 0,
            l = 0,
            u = 0,
            d = 0,
            h = 0,
            p = -20,
            m = 0,
            b = e.scalefac,
            v = 0;

        for (r.over_SSD = 0, o = 0; o < e.psymax; o++) {
          var g,
              w = e.global_gain - (b[v++] + (0 != e.preflag ? c[o] : 0) << e.scalefac_scale + 1) - 8 * e.subblock_gain[e.window[o]],
              E = 0;
          if (null != s && s.step[o] == w) E = s.noise[o], m += e.width[o], a[_++] = E / t[l++], E = s.noise_log[o];else {
            var S,
                M = f[w + QuantizePVT.Q_MAX2];
            if (i = e.width[o] >> 1, m + e.width[o] > e.max_nonzero_coeff) i = (S = e.max_nonzero_coeff - m + 1) > 0 ? S >> 1 : 0;
            var y = new StartLine(m);
            E = this.calc_noise_core(e, y, i, M), m = y.s, null != s && (s.step[o] = w, s.noise[o] = E), E = a[_++] = E / t[l++], E = n.FAST_LOG10(Math.max(E, 1e-20)), null != s && (s.noise_log[o] = E);
          }
          if (null != s && (s.global_gain = e.global_gain), h += E, E > 0) g = Math.max(0 | 10 * E + .5, 1), r.over_SSD += g * g, u++, d += E;
          p = Math.max(p, E);
        }

        return r.over_count = u, r.tot_noise = h, r.over_noise = d, r.max_noise = p, u;
      }, this.set_pinfo = function (e, t, n, a, r) {
        var o,
            i,
            _,
            l,
            f,
            u = e.internal_flags,
            d = 0 == t.scalefac_scale ? .5 : 1,
            h = t.scalefac,
            p = new_float(s.SFBMAX),
            m = new_float(s.SFBMAX),
            b = new CalcNoiseResult();

        calc_xmin(e, n, t, p), calc_noise(t, p, m, b, null);
        var v = 0;

        for (i = t.sfb_lmax, t.block_type != Encoder.SHORT_TYPE && 0 == t.mixed_block_flag && (i = 22), o = 0; o < i; o++) {
          var g = u.scalefac_band.l[o],
              w = (E = u.scalefac_band.l[o + 1]) - g;

          for (l = 0; v < E; v++) {
            l += t.xr[v] * t.xr[v];
          }

          l /= w, f = 1e15, u.pinfo.en[a][r][o] = f * l, u.pinfo.xfsf[a][r][o] = f * p[o] * m[o] / w, n.en.l[o] > 0 && !e.ATHonly ? l /= n.en.l[o] : l = 0, u.pinfo.thr[a][r][o] = f * Math.max(l * n.thm.l[o], u.ATH.l[o]), u.pinfo.LAMEsfb[a][r][o] = 0, 0 != t.preflag && o >= 11 && (u.pinfo.LAMEsfb[a][r][o] = -d * c[o]), o < Encoder.SBPSY_l && (u.pinfo.LAMEsfb[a][r][o] -= d * h[o]);
        }

        if (t.block_type == Encoder.SHORT_TYPE) for (i = o, o = t.sfb_smin; o < Encoder.SBMAX_s; o++) {
          g = u.scalefac_band.s[o], w = (E = u.scalefac_band.s[o + 1]) - g;

          for (var E, S = 0; S < 3; S++) {
            for (l = 0, _ = g; _ < E; _++) {
              l += t.xr[v] * t.xr[v], v++;
            }

            l = Math.max(l / w, 1e-20), f = 1e15, u.pinfo.en_s[a][r][3 * o + S] = f * l, u.pinfo.xfsf_s[a][r][3 * o + S] = f * p[i] * m[i] / w, n.en.s[o][S] > 0 ? l /= n.en.s[o][S] : l = 0, (e.ATHonly || e.ATHshort) && (l = 0), u.pinfo.thr_s[a][r][3 * o + S] = f * Math.max(l * n.thm.s[o][S], u.ATH.s[o]), u.pinfo.LAMEsfb_s[a][r][3 * o + S] = -2 * t.subblock_gain[S], o < Encoder.SBPSY_s && (u.pinfo.LAMEsfb_s[a][r][3 * o + S] -= d * h[i]), i++;
          }
        }
        u.pinfo.LAMEqss[a][r] = t.global_gain, u.pinfo.LAMEmainbits[a][r] = t.part2_3_length + t.part2_length, u.pinfo.LAMEsfbits[a][r] = t.part2_length, u.pinfo.over[a][r] = b.over_count, u.pinfo.max_noise[a][r] = 10 * b.max_noise, u.pinfo.over_noise[a][r] = 10 * b.over_noise, u.pinfo.tot_noise[a][r] = 10 * b.tot_noise, u.pinfo.over_SSD[a][r] = b.over_SSD;
      };
    }

    function CalcNoiseData() {
      this.global_gain = 0, this.sfb_count1 = 0, this.step = new_int(39), this.noise = new_float(39), this.noise_log = new_float(39);
    }

    function GrInfo() {
      this.xr = new_float(576), this.l3_enc = new_int(576), this.scalefac = new_int(s.SFBMAX), this.xrpow_max = 0, this.part2_3_length = 0, this.big_values = 0, this.count1 = 0, this.global_gain = 0, this.scalefac_compress = 0, this.block_type = 0, this.mixed_block_flag = 0, this.table_select = new_int(3), this.subblock_gain = new_int(4), this.region0_count = 0, this.region1_count = 0, this.preflag = 0, this.scalefac_scale = 0, this.count1table_select = 0, this.part2_length = 0, this.sfb_lmax = 0, this.sfb_smin = 0, this.psy_lmax = 0, this.sfbmax = 0, this.psymax = 0, this.sfbdivide = 0, this.width = new_int(s.SFBMAX), this.window = new_int(s.SFBMAX), this.count1bits = 0, this.sfb_partition_table = null, this.slen = new_int(4), this.max_nonzero_coeff = 0;
      var e = this;

      function clone_int(e) {
        return new Int32Array(e);
      }

      this.assign = function (t) {
        e.xr = function clone_float(e) {
          return new Float32Array(e);
        }(t.xr), e.l3_enc = clone_int(t.l3_enc), e.scalefac = clone_int(t.scalefac), e.xrpow_max = t.xrpow_max, e.part2_3_length = t.part2_3_length, e.big_values = t.big_values, e.count1 = t.count1, e.global_gain = t.global_gain, e.scalefac_compress = t.scalefac_compress, e.block_type = t.block_type, e.mixed_block_flag = t.mixed_block_flag, e.table_select = clone_int(t.table_select), e.subblock_gain = clone_int(t.subblock_gain), e.region0_count = t.region0_count, e.region1_count = t.region1_count, e.preflag = t.preflag, e.scalefac_scale = t.scalefac_scale, e.count1table_select = t.count1table_select, e.part2_length = t.part2_length, e.sfb_lmax = t.sfb_lmax, e.sfb_smin = t.sfb_smin, e.psy_lmax = t.psy_lmax, e.sfbmax = t.sfbmax, e.psymax = t.psymax, e.sfbdivide = t.sfbdivide, e.width = clone_int(t.width), e.window = clone_int(t.window), e.count1bits = t.count1bits, e.sfb_partition_table = t.sfb_partition_table.slice(0), e.slen = clone_int(t.slen), e.max_nonzero_coeff = t.max_nonzero_coeff;
      };
    }

    r.t1HB = [1, 1, 1, 0], r.t2HB = [1, 2, 1, 3, 1, 1, 3, 2, 0], r.t3HB = [3, 2, 1, 1, 1, 1, 3, 2, 0], r.t5HB = [1, 2, 6, 5, 3, 1, 4, 4, 7, 5, 7, 1, 6, 1, 1, 0], r.t6HB = [7, 3, 5, 1, 6, 2, 3, 2, 5, 4, 4, 1, 3, 3, 2, 0], r.t7HB = [1, 2, 10, 19, 16, 10, 3, 3, 7, 10, 5, 3, 11, 4, 13, 17, 8, 4, 12, 11, 18, 15, 11, 2, 7, 6, 9, 14, 3, 1, 6, 4, 5, 3, 2, 0], r.t8HB = [3, 4, 6, 18, 12, 5, 5, 1, 2, 16, 9, 3, 7, 3, 5, 14, 7, 3, 19, 17, 15, 13, 10, 4, 13, 5, 8, 11, 5, 1, 12, 4, 4, 1, 1, 0], r.t9HB = [7, 5, 9, 14, 15, 7, 6, 4, 5, 5, 6, 7, 7, 6, 8, 8, 8, 5, 15, 6, 9, 10, 5, 1, 11, 7, 9, 6, 4, 1, 14, 4, 6, 2, 6, 0], r.t10HB = [1, 2, 10, 23, 35, 30, 12, 17, 3, 3, 8, 12, 18, 21, 12, 7, 11, 9, 15, 21, 32, 40, 19, 6, 14, 13, 22, 34, 46, 23, 18, 7, 20, 19, 33, 47, 27, 22, 9, 3, 31, 22, 41, 26, 21, 20, 5, 3, 14, 13, 10, 11, 16, 6, 5, 1, 9, 8, 7, 8, 4, 4, 2, 0], r.t11HB = [3, 4, 10, 24, 34, 33, 21, 15, 5, 3, 4, 10, 32, 17, 11, 10, 11, 7, 13, 18, 30, 31, 20, 5, 25, 11, 19, 59, 27, 18, 12, 5, 35, 33, 31, 58, 30, 16, 7, 5, 28, 26, 32, 19, 17, 15, 8, 14, 14, 12, 9, 13, 14, 9, 4, 1, 11, 4, 6, 6, 6, 3, 2, 0], r.t12HB = [9, 6, 16, 33, 41, 39, 38, 26, 7, 5, 6, 9, 23, 16, 26, 11, 17, 7, 11, 14, 21, 30, 10, 7, 17, 10, 15, 12, 18, 28, 14, 5, 32, 13, 22, 19, 18, 16, 9, 5, 40, 17, 31, 29, 17, 13, 4, 2, 27, 12, 11, 15, 10, 7, 4, 1, 27, 12, 8, 12, 6, 3, 1, 0], r.t13HB = [1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19, 3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14, 15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16, 22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14, 35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24, 58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17, 47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15, 72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42, 43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16, 53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11, 35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22, 53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7, 34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5, 45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3, 48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2, 16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1], r.t15HB = [7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63, 13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36, 19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33, 29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29, 52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27, 77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38, 125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30, 109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25, 90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20, 71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15, 109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9, 86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11, 118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7, 91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3, 123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1, 71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0], r.t16HB = [1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17, 3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9, 15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16, 45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26, 75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9, 66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16, 111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10, 98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8, 85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7, 154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11, 139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4, 243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6, 202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4, 747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2, 377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0, 12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3], r.t24HB = [15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88, 14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42, 47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18, 81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16, 147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14, 263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12, 249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10, 435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17, 427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16, 335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11, 668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10, 652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6, 648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4, 620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2, 1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0, 43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3], r.t32HB = [1, 10, 8, 20, 12, 20, 16, 32, 14, 12, 24, 0, 28, 16, 24, 16], r.t33HB = [15, 28, 26, 48, 22, 40, 36, 64, 14, 24, 20, 32, 12, 16, 8, 0], r.t1l = [1, 4, 3, 5], r.t2l = [1, 4, 7, 4, 5, 7, 6, 7, 8], r.t3l = [2, 3, 7, 4, 4, 7, 6, 7, 8], r.t5l = [1, 4, 7, 8, 4, 5, 8, 9, 7, 8, 9, 10, 8, 8, 9, 10], r.t6l = [3, 4, 6, 8, 4, 4, 6, 7, 5, 6, 7, 8, 7, 7, 8, 9], r.t7l = [1, 4, 7, 9, 9, 10, 4, 6, 8, 9, 9, 10, 7, 7, 9, 10, 10, 11, 8, 9, 10, 11, 11, 11, 8, 9, 10, 11, 11, 12, 9, 10, 11, 12, 12, 12], r.t8l = [2, 4, 7, 9, 9, 10, 4, 4, 6, 10, 10, 10, 7, 6, 8, 10, 10, 11, 9, 10, 10, 11, 11, 12, 9, 9, 10, 11, 12, 12, 10, 10, 11, 11, 13, 13], r.t9l = [3, 4, 6, 7, 9, 10, 4, 5, 6, 7, 8, 10, 5, 6, 7, 8, 9, 10, 7, 7, 8, 9, 9, 10, 8, 8, 9, 9, 10, 11, 9, 9, 10, 10, 11, 11], r.t10l = [1, 4, 7, 9, 10, 10, 10, 11, 4, 6, 8, 9, 10, 11, 10, 10, 7, 8, 9, 10, 11, 12, 11, 11, 8, 9, 10, 11, 12, 12, 11, 12, 9, 10, 11, 12, 12, 12, 12, 12, 10, 11, 12, 12, 13, 13, 12, 13, 9, 10, 11, 12, 12, 12, 13, 13, 10, 10, 11, 12, 12, 13, 13, 13], r.t11l = [2, 4, 6, 8, 9, 10, 9, 10, 4, 5, 6, 8, 10, 10, 9, 10, 6, 7, 8, 9, 10, 11, 10, 10, 8, 8, 9, 11, 10, 12, 10, 11, 9, 10, 10, 11, 11, 12, 11, 12, 9, 10, 11, 12, 12, 13, 12, 13, 9, 9, 9, 10, 11, 12, 12, 12, 9, 9, 10, 11, 12, 12, 12, 12], r.t12l = [4, 4, 6, 8, 9, 10, 10, 10, 4, 5, 6, 7, 9, 9, 10, 10, 6, 6, 7, 8, 9, 10, 9, 10, 7, 7, 8, 8, 9, 10, 10, 10, 8, 8, 9, 9, 10, 10, 10, 11, 9, 9, 10, 10, 10, 11, 10, 11, 9, 9, 9, 10, 10, 11, 11, 12, 10, 10, 10, 11, 11, 11, 11, 12], r.t13l = [1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14, 4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14, 7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15, 8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15, 9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16, 10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16, 10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16, 11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18, 10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17, 11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17, 11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19, 12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18, 12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18, 13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18, 14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18, 13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18], r.t15l = [3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14, 5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13, 8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14, 10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15, 12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15], r.t16_5l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14, 11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12], r.t16l = [1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10, 4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10, 7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11, 9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12, 10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11, 10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12, 11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12, 12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13, 12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12, 13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13, 15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13, 14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10], r.t24l = [4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10, 5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10, 7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9, 8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9, 10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9, 10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9, 11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10, 12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10, 13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6], r.t32l = [1, 5, 5, 7, 5, 8, 7, 9, 5, 7, 7, 9, 7, 9, 9, 10], r.t33l = [4, 5, 5, 6, 5, 6, 6, 7, 5, 6, 6, 7, 6, 7, 7, 8], r.ht = [new HuffCodeTab(0, 0, null, null), new HuffCodeTab(2, 0, r.t1HB, r.t1l), new HuffCodeTab(3, 0, r.t2HB, r.t2l), new HuffCodeTab(3, 0, r.t3HB, r.t3l), new HuffCodeTab(0, 0, null, null), new HuffCodeTab(4, 0, r.t5HB, r.t5l), new HuffCodeTab(4, 0, r.t6HB, r.t6l), new HuffCodeTab(6, 0, r.t7HB, r.t7l), new HuffCodeTab(6, 0, r.t8HB, r.t8l), new HuffCodeTab(6, 0, r.t9HB, r.t9l), new HuffCodeTab(8, 0, r.t10HB, r.t10l), new HuffCodeTab(8, 0, r.t11HB, r.t11l), new HuffCodeTab(8, 0, r.t12HB, r.t12l), new HuffCodeTab(16, 0, r.t13HB, r.t13l), new HuffCodeTab(0, 0, null, r.t16_5l), new HuffCodeTab(16, 0, r.t15HB, r.t15l), new HuffCodeTab(1, 1, r.t16HB, r.t16l), new HuffCodeTab(2, 3, r.t16HB, r.t16l), new HuffCodeTab(3, 7, r.t16HB, r.t16l), new HuffCodeTab(4, 15, r.t16HB, r.t16l), new HuffCodeTab(6, 63, r.t16HB, r.t16l), new HuffCodeTab(8, 255, r.t16HB, r.t16l), new HuffCodeTab(10, 1023, r.t16HB, r.t16l), new HuffCodeTab(13, 8191, r.t16HB, r.t16l), new HuffCodeTab(4, 15, r.t24HB, r.t24l), new HuffCodeTab(5, 31, r.t24HB, r.t24l), new HuffCodeTab(6, 63, r.t24HB, r.t24l), new HuffCodeTab(7, 127, r.t24HB, r.t24l), new HuffCodeTab(8, 255, r.t24HB, r.t24l), new HuffCodeTab(9, 511, r.t24HB, r.t24l), new HuffCodeTab(11, 2047, r.t24HB, r.t24l), new HuffCodeTab(13, 8191, r.t24HB, r.t24l), new HuffCodeTab(0, 0, r.t32HB, r.t32l), new HuffCodeTab(0, 0, r.t33HB, r.t33l)], r.largetbl = [65540, 327685, 458759, 589832, 655369, 655370, 720906, 720907, 786443, 786444, 786444, 851980, 851980, 851980, 917517, 655370, 262149, 393222, 524295, 589832, 655369, 720906, 720906, 720907, 786443, 786443, 786444, 851980, 917516, 851980, 917516, 655370, 458759, 524295, 589832, 655369, 720905, 720906, 786442, 786443, 851979, 786443, 851979, 851980, 851980, 917516, 917517, 720905, 589832, 589832, 655369, 720905, 720906, 786442, 786442, 786443, 851979, 851979, 917515, 917516, 917516, 983052, 983052, 786441, 655369, 655369, 720905, 720906, 786442, 786442, 851978, 851979, 851979, 917515, 917516, 917516, 983052, 983052, 983053, 720905, 655370, 655369, 720906, 720906, 786442, 851978, 851979, 917515, 851979, 917515, 917516, 983052, 983052, 983052, 1048588, 786441, 720906, 720906, 720906, 786442, 851978, 851979, 851979, 851979, 917515, 917516, 917516, 917516, 983052, 983052, 1048589, 786441, 720907, 720906, 786442, 786442, 851979, 851979, 851979, 917515, 917516, 983052, 983052, 983052, 983052, 1114125, 1114125, 786442, 720907, 786443, 786443, 851979, 851979, 851979, 917515, 917515, 983051, 983052, 983052, 983052, 1048588, 1048589, 1048589, 786442, 786443, 786443, 786443, 851979, 851979, 917515, 917515, 983052, 983052, 983052, 983052, 1048588, 983053, 1048589, 983053, 851978, 786444, 851979, 786443, 851979, 917515, 917516, 917516, 917516, 983052, 1048588, 1048588, 1048589, 1114125, 1114125, 1048589, 786442, 851980, 851980, 851979, 851979, 917515, 917516, 983052, 1048588, 1048588, 1048588, 1048588, 1048589, 1048589, 983053, 1048589, 851978, 851980, 917516, 917516, 917516, 917516, 983052, 983052, 983052, 983052, 1114124, 1048589, 1048589, 1048589, 1048589, 1179661, 851978, 983052, 917516, 917516, 917516, 983052, 983052, 1048588, 1048588, 1048589, 1179661, 1114125, 1114125, 1114125, 1245197, 1114125, 851978, 917517, 983052, 851980, 917516, 1048588, 1048588, 983052, 1048589, 1048589, 1114125, 1179661, 1114125, 1245197, 1114125, 1048589, 851978, 655369, 655369, 655369, 720905, 720905, 786441, 786441, 786441, 851977, 851977, 851977, 851978, 851978, 851978, 851978, 655366], r.table23 = [65538, 262147, 458759, 262148, 327684, 458759, 393222, 458759, 524296], r.table56 = [65539, 262148, 458758, 524296, 262148, 327684, 524294, 589831, 458757, 524294, 589831, 655368, 524295, 524295, 589832, 655369], r.bitrate_table = [[0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1], [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1]], r.samplerate_table = [[22050, 24e3, 16e3, -1], [44100, 48e3, 32e3, -1], [11025, 12e3, 8e3, -1]], r.scfsi_band = [0, 6, 11, 16, 21], QuantizePVT.Q_MAX = 257, QuantizePVT.Q_MAX2 = 116, QuantizePVT.LARGE_BITS = 1e5, QuantizePVT.IXMAX_VAL = 8206;
    var s = {};

    function Quantize() {
      var a, r, o;
      this.rv = null, this.qupvt = null;

      var i,
          _ = new VBRQuantize();

      function BinSearchDirection(e) {
        this.ordinal = e;
      }

      function loop_break(e) {
        for (var t = 0; t < e.sfbmax; t++) {
          if (e.scalefac[t] + e.subblock_gain[e.window[t]] == 0) return !1;
        }

        return !0;
      }

      function quant_compare(e, t, a, r, s) {
        var o;

        switch (e) {
          default:
            t.over_count > 0 ? (o = a.over_SSD <= t.over_SSD, a.over_SSD == t.over_SSD && (o = a.bits < t.bits)) : o = a.max_noise < 0 && 10 * a.max_noise + a.bits <= 10 * t.max_noise + t.bits;
            break;

          case 0:
            o = a.over_count < t.over_count || a.over_count == t.over_count && a.over_noise < t.over_noise || a.over_count == t.over_count && BitStream.EQ(a.over_noise, t.over_noise) && a.tot_noise < t.tot_noise;
            break;

          case 8:
            a.max_noise = function get_klemm_noise(e, t) {
              for (var a, r = 1e-37, s = 0; s < t.psymax; s++) {
                r += (a = e[s], n.FAST_LOG10(.368 + .632 * a * a * a));
              }

              return Math.max(1e-20, r);
            }(s, r);

          case 1:
            o = a.max_noise < t.max_noise;
            break;

          case 2:
            o = a.tot_noise < t.tot_noise;
            break;

          case 3:
            o = a.tot_noise < t.tot_noise && a.max_noise < t.max_noise;
            break;

          case 4:
            o = a.max_noise <= 0 && t.max_noise > .2 || a.max_noise <= 0 && t.max_noise < 0 && t.max_noise > a.max_noise - .2 && a.tot_noise < t.tot_noise || a.max_noise <= 0 && t.max_noise > 0 && t.max_noise > a.max_noise - .2 && a.tot_noise < t.tot_noise + t.over_noise || a.max_noise > 0 && t.max_noise > -.05 && t.max_noise > a.max_noise - .1 && a.tot_noise + a.over_noise < t.tot_noise + t.over_noise || a.max_noise > 0 && t.max_noise > -.1 && t.max_noise > a.max_noise - .15 && a.tot_noise + a.over_noise + a.over_noise < t.tot_noise + t.over_noise + t.over_noise;
            break;

          case 5:
            o = a.over_noise < t.over_noise || BitStream.EQ(a.over_noise, t.over_noise) && a.tot_noise < t.tot_noise;
            break;

          case 6:
            o = a.over_noise < t.over_noise || BitStream.EQ(a.over_noise, t.over_noise) && (a.max_noise < t.max_noise || BitStream.EQ(a.max_noise, t.max_noise) && a.tot_noise <= t.tot_noise);
            break;

          case 7:
            o = a.over_count < t.over_count || a.over_noise < t.over_noise;
        }

        return 0 == t.over_count && (o = o && a.bits < t.bits), o;
      }

      function balance_noise(t, n, a, r, s) {
        var _ = t.internal_flags;
        !function amp_scalefac_bands(e, t, n, a, r) {
          var s,
              o = e.internal_flags;
          s = 0 == t.scalefac_scale ? 1.2968395546510096 : 1.6817928305074292;

          for (var i = 0, _ = 0; _ < t.sfbmax; _++) {
            i < n[_] && (i = n[_]);
          }

          var l = o.noise_shaping_amp;

          switch (3 == l && (l = r ? 2 : 1), l) {
            case 2:
              break;

            case 1:
              i > 1 ? i = Math.pow(i, .5) : i *= .95;
              break;

            default:
              i > 1 ? i = 1 : i *= .95;
          }

          var c = 0;

          for (_ = 0; _ < t.sfbmax; _++) {
            var f,
                u = t.width[_];

            if (c += u, !(n[_] < i)) {
              if (0 != (2 & o.substep_shaping) && (o.pseudohalf[_] = 0 == o.pseudohalf[_] ? 1 : 0, 0 == o.pseudohalf[_] && 2 == o.noise_shaping_amp)) return;

              for (t.scalefac[_]++, f = -u; f < 0; f++) {
                a[c + f] *= s, a[c + f] > t.xrpow_max && (t.xrpow_max = a[c + f]);
              }

              if (2 == o.noise_shaping_amp) return;
            }
          }
        }(t, n, a, r, s);
        var l = loop_break(n);
        return !l && (!(l = 2 == _.mode_gr ? i.scale_bitcount(n) : i.scale_bitcount_lsf(_, n)) || (_.noise_shaping > 1 && (e.fill(_.pseudohalf, 0), 0 == n.scalefac_scale ? (!function inc_scalefac_scale(e, t) {
          for (var n = 0, a = 0; a < e.sfbmax; a++) {
            var r = e.width[a],
                s = e.scalefac[a];

            if (0 != e.preflag && (s += o.pretab[a]), n += r, 0 != (1 & s)) {
              s++;

              for (var i = -r; i < 0; i++) {
                t[n + i] *= 1.2968395546510096, t[n + i] > e.xrpow_max && (e.xrpow_max = t[n + i]);
              }
            }

            e.scalefac[a] = s >> 1;
          }

          e.preflag = 0, e.scalefac_scale = 1;
        }(n, r), l = !1) : n.block_type == Encoder.SHORT_TYPE && _.subblock_gain > 0 && (l = function inc_subblock_gain(e, t, n) {
          var a,
              r = t.scalefac;

          for (a = 0; a < t.sfb_lmax; a++) {
            if (r[a] >= 16) return !0;
          }

          for (var s = 0; s < 3; s++) {
            var i = 0,
                _ = 0;

            for (a = t.sfb_lmax + s; a < t.sfbdivide; a += 3) {
              i < r[a] && (i = r[a]);
            }

            for (; a < t.sfbmax; a += 3) {
              _ < r[a] && (_ = r[a]);
            }

            if (!(i < 16 && _ < 8)) {
              if (t.subblock_gain[s] >= 7) return !0;
              t.subblock_gain[s]++;
              var l = e.scalefac_band.l[t.sfb_lmax];

              for (a = t.sfb_lmax + s; a < t.sfbmax; a += 3) {
                var c = t.width[a],
                    f = r[a];
                if ((f -= 4 >> t.scalefac_scale) >= 0) r[a] = f, l += 3 * c;else {
                  r[a] = 0;
                  var u = 210 + (f << t.scalefac_scale + 1);
                  h = o.IPOW20(u), l += c * (s + 1);

                  for (var d = -c; d < 0; d++) {
                    n[l + d] *= h, n[l + d] > t.xrpow_max && (t.xrpow_max = n[l + d]);
                  }

                  l += c * (3 - s - 1);
                }
              }

              var h = o.IPOW20(202);

              for (l += t.width[a] * (s + 1), d = -t.width[a]; d < 0; d++) {
                n[l + d] *= h, n[l + d] > t.xrpow_max && (t.xrpow_max = n[l + d]);
              }
            }
          }

          return !1;
        }(_, n, r) || loop_break(n))), l || (l = 2 == _.mode_gr ? i.scale_bitcount(n) : i.scale_bitcount_lsf(_, n)), !l));
      }

      this.setModules = function (e, t, n, s) {
        a = e, r = t, this.rv = t, o = n, this.qupvt = n, i = s, _.setModules(o, i);
      }, this.ms_convert = function (e, t) {
        for (var a = 0; a < 576; ++a) {
          var r = e.tt[t][0].xr[a],
              s = e.tt[t][1].xr[a];
          e.tt[t][0].xr[a] = (r + s) * (.5 * n.SQRT2), e.tt[t][1].xr[a] = (r - s) * (.5 * n.SQRT2);
        }
      }, this.init_xrpow = function (t, n, a) {
        var r = 0,
            s = 0 | n.max_nonzero_coeff;

        if (n.xrpow_max = 0, e.fill(a, s, 576, 0), r = function init_xrpow_core(e, t, n, a) {
          a = 0;

          for (var r = 0; r <= n; ++r) {
            var s = Math.abs(e.xr[r]);
            a += s, t[r] = Math.sqrt(s * Math.sqrt(s)), t[r] > e.xrpow_max && (e.xrpow_max = t[r]);
          }

          return a;
        }(n, a, s, r), r > 1e-20) {
          var o = 0;
          0 != (2 & t.substep_shaping) && (o = 1);

          for (var i = 0; i < n.psymax; i++) {
            t.pseudohalf[i] = o;
          }

          return !0;
        }

        return e.fill(n.l3_enc, 0, 576, 0), !1;
      }, this.init_outer_loop = function (n, a) {
        a.part2_3_length = 0, a.big_values = 0, a.count1 = 0, a.global_gain = 210, a.scalefac_compress = 0, a.table_select[0] = 0, a.table_select[1] = 0, a.table_select[2] = 0, a.subblock_gain[0] = 0, a.subblock_gain[1] = 0, a.subblock_gain[2] = 0, a.subblock_gain[3] = 0, a.region0_count = 0, a.region1_count = 0, a.preflag = 0, a.scalefac_scale = 0, a.count1table_select = 0, a.part2_length = 0, a.sfb_lmax = Encoder.SBPSY_l, a.sfb_smin = Encoder.SBPSY_s, a.psy_lmax = n.sfb21_extra ? Encoder.SBMAX_l : Encoder.SBPSY_l, a.psymax = a.psy_lmax, a.sfbmax = a.sfb_lmax, a.sfbdivide = 11;

        for (var r = 0; r < Encoder.SBMAX_l; r++) {
          a.width[r] = n.scalefac_band.l[r + 1] - n.scalefac_band.l[r], a.window[r] = 3;
        }

        if (a.block_type == Encoder.SHORT_TYPE) {
          var s = new_float(576);
          a.sfb_smin = 0, a.sfb_lmax = 0, 0 != a.mixed_block_flag && (a.sfb_smin = 3, a.sfb_lmax = 2 * n.mode_gr + 4), a.psymax = a.sfb_lmax + 3 * ((n.sfb21_extra ? Encoder.SBMAX_s : Encoder.SBPSY_s) - a.sfb_smin), a.sfbmax = a.sfb_lmax + 3 * (Encoder.SBPSY_s - a.sfb_smin), a.sfbdivide = a.sfbmax - 18, a.psy_lmax = a.sfb_lmax;
          var i = n.scalefac_band.l[a.sfb_lmax];
          t.arraycopy(a.xr, 0, s, 0, 576);

          for (r = a.sfb_smin; r < Encoder.SBMAX_s; r++) {
            for (var _ = n.scalefac_band.s[r], l = n.scalefac_band.s[r + 1], c = 0; c < 3; c++) {
              for (var f = _; f < l; f++) {
                a.xr[i++] = s[3 * f + c];
              }
            }
          }

          var u = a.sfb_lmax;

          for (r = a.sfb_smin; r < Encoder.SBMAX_s; r++) {
            a.width[u] = a.width[u + 1] = a.width[u + 2] = n.scalefac_band.s[r + 1] - n.scalefac_band.s[r], a.window[u] = 0, a.window[u + 1] = 1, a.window[u + 2] = 2, u += 3;
          }
        }

        a.count1bits = 0, a.sfb_partition_table = o.nr_of_sfb_block[0][0], a.slen[0] = 0, a.slen[1] = 0, a.slen[2] = 0, a.slen[3] = 0, a.max_nonzero_coeff = 575, e.fill(a.scalefac, 0), function psfb21_analogsilence(e, t) {
          var n = e.ATH,
              a = t.xr;
          if (t.block_type != Encoder.SHORT_TYPE) for (var r = !1, s = Encoder.PSFB21 - 1; s >= 0 && !r; s--) {
            var i = e.scalefac_band.psfb21[s],
                _ = e.scalefac_band.psfb21[s + 1],
                l = o.athAdjust(n.adjust, n.psfb21[s], n.floor);
            e.nsPsy.longfact[21] > 1e-12 && (l *= e.nsPsy.longfact[21]);

            for (var c = _ - 1; c >= i; c--) {
              if (!(Math.abs(a[c]) < l)) {
                r = !0;
                break;
              }

              a[c] = 0;
            }
          } else for (var f = 0; f < 3; f++) {
            for (r = !1, s = Encoder.PSFB12 - 1; s >= 0 && !r; s--) {
              _ = (i = 3 * e.scalefac_band.s[12] + (e.scalefac_band.s[13] - e.scalefac_band.s[12]) * f + (e.scalefac_band.psfb12[s] - e.scalefac_band.psfb12[0])) + (e.scalefac_band.psfb12[s + 1] - e.scalefac_band.psfb12[s]);
              var u = o.athAdjust(n.adjust, n.psfb12[s], n.floor);

              for (e.nsPsy.shortfact[12] > 1e-12 && (u *= e.nsPsy.shortfact[12]), c = _ - 1; c >= i; c--) {
                if (!(Math.abs(a[c]) < u)) {
                  r = !0;
                  break;
                }

                a[c] = 0;
              }
            }
          }
        }(n, a);
      }, BinSearchDirection.BINSEARCH_NONE = new BinSearchDirection(0), BinSearchDirection.BINSEARCH_UP = new BinSearchDirection(1), BinSearchDirection.BINSEARCH_DOWN = new BinSearchDirection(2), this.trancate_smallspectrums = function (t, n, a, r) {
        var _ = new_float(s.SFBMAX);

        if ((0 != (4 & t.substep_shaping) || n.block_type != Encoder.SHORT_TYPE) && 0 == (128 & t.substep_shaping)) {
          o.calc_noise(n, a, _, new CalcNoiseResult(), null);

          for (var l = 0; l < 576; l++) {
            var c = 0;
            0 != n.l3_enc[l] && (c = Math.abs(n.xr[l])), r[l] = c;
          }

          l = 0;
          var f = 8;
          n.block_type == Encoder.SHORT_TYPE && (f = 6);

          do {
            var u,
                d,
                h,
                p,
                m = n.width[f];

            if (l += m, !(_[f] >= 1) && (e.sort(r, l - m, m), !BitStream.EQ(r[l - 1], 0))) {
              u = (1 - _[f]) * a[f], d = 0, p = 0;

              do {
                var b;

                for (h = 1; p + h < m && !BitStream.NEQ(r[p + l - m], r[p + l + h - m]); h++) {
                }

                if (u < (b = r[p + l - m] * r[p + l - m] * h)) {
                  0 != p && (d = r[p + l - m - 1]);
                  break;
                }

                u -= b, p += h;
              } while (p < m);

              if (!BitStream.EQ(d, 0)) do {
                Math.abs(n.xr[l - m]) <= d && (n.l3_enc[l - m] = 0);
              } while (--m > 0);
            }
          } while (++f < n.psymax);

          n.part2_3_length = i.noquant_count_bits(t, n, null);
        }
      }, this.outer_loop = function (e, n, a, r, _, l) {
        var c = e.internal_flags,
            f = new GrInfo(),
            u = new_float(576),
            d = new_float(s.SFBMAX),
            h = new CalcNoiseResult(),
            p = new CalcNoiseData(),
            m = 9999999,
            b = !1,
            v = !1,
            g = 0;
        if (function bin_search_StepSize(e, t, n, a, r) {
          var s,
              o = e.CurrentStep[a],
              _ = !1,
              l = e.OldValue[a],
              c = BinSearchDirection.BINSEARCH_NONE;

          for (t.global_gain = l, n -= t.part2_length;;) {
            var f;
            if (s = i.count_bits(e, r, t, null), 1 == o || s == n) break;
            s > n ? (c == BinSearchDirection.BINSEARCH_DOWN && (_ = !0), _ && (o /= 2), c = BinSearchDirection.BINSEARCH_UP, f = o) : (c == BinSearchDirection.BINSEARCH_UP && (_ = !0), _ && (o /= 2), c = BinSearchDirection.BINSEARCH_DOWN, f = -o), t.global_gain += f, t.global_gain < 0 && (t.global_gain = 0, _ = !0), t.global_gain > 255 && (t.global_gain = 255, _ = !0);
          }

          for (; s > n && t.global_gain < 255;) {
            t.global_gain++, s = i.count_bits(e, r, t, null);
          }

          return e.CurrentStep[a] = l - t.global_gain >= 4 ? 4 : 2, e.OldValue[a] = t.global_gain, t.part2_3_length = s, s;
        }(c, n, l, _, r), 0 == c.noise_shaping) return 100;
        o.calc_noise(n, a, d, h, p), h.bits = n.part2_3_length, f.assign(n);
        var w = 0;

        for (t.arraycopy(r, 0, u, 0, 576); !b;) {
          do {
            var E,
                S = new CalcNoiseResult(),
                M = 255;

            if (E = 0 != (2 & c.substep_shaping) ? 20 : 3, c.sfb21_extra) {
              if (d[f.sfbmax] > 1) break;
              if (f.block_type == Encoder.SHORT_TYPE && (d[f.sfbmax + 1] > 1 || d[f.sfbmax + 2] > 1)) break;
            }

            if (!balance_noise(e, f, d, r, v)) break;
            0 != f.scalefac_scale && (M = 254);
            var y = l - f.part2_length;
            if (y <= 0) break;

            for (; (f.part2_3_length = i.count_bits(c, r, f, p)) > y && f.global_gain <= M;) {
              f.global_gain++;
            }

            if (f.global_gain > M) break;

            if (0 == h.over_count) {
              for (; (f.part2_3_length = i.count_bits(c, r, f, p)) > m && f.global_gain <= M;) {
                f.global_gain++;
              }

              if (f.global_gain > M) break;
            }

            if (o.calc_noise(f, a, d, S, p), S.bits = f.part2_3_length, 0 != (quant_compare(n.block_type != Encoder.SHORT_TYPE ? e.quant_comp : e.quant_comp_short, h, S, f, d) ? 1 : 0)) m = n.part2_3_length, h = S, n.assign(f), w = 0, t.arraycopy(r, 0, u, 0, 576);else if (0 == c.full_outer_loop) {
              if (++w > E && 0 == h.over_count) break;
              if (3 == c.noise_shaping_amp && v && w > 30) break;
              if (3 == c.noise_shaping_amp && v && f.global_gain - g > 15) break;
            }
          } while (f.global_gain + f.scalefac_scale < 255);

          3 == c.noise_shaping_amp ? v ? b = !0 : (f.assign(n), t.arraycopy(u, 0, r, 0, 576), w = 0, g = f.global_gain, v = !0) : b = !0;
        }

        return e.VBR == VbrMode.vbr_rh || e.VBR == VbrMode.vbr_mtrh ? t.arraycopy(u, 0, r, 0, 576) : 0 != (1 & c.substep_shaping) && trancate_smallspectrums(c, n, a, r), h.over_count;
      }, this.iteration_finish_one = function (e, t, n) {
        var a = e.l3_side,
            s = a.tt[t][n];
        i.best_scalefac_store(e, t, n, a), 1 == e.use_best_huffman && i.best_huffman_divide(e, s), r.ResvAdjust(e, s);
      }, this.VBR_encode_granule = function (n, a, r, s, o, i, _) {
        var l,
            c = n.internal_flags,
            f = new GrInfo(),
            u = new_float(576),
            d = _,
            h = _ + 1,
            p = (_ + i) / 2,
            m = 0,
            b = c.sfb21_extra;
        e.fill(f.l3_enc, 0);

        do {
          c.sfb21_extra = !(p > d - 42) && b, outer_loop(n, a, r, s, o, p) <= 0 ? (m = 1, h = a.part2_3_length, f.assign(a), t.arraycopy(s, 0, u, 0, 576), l = (_ = h - 32) - i, p = (_ + i) / 2) : (l = _ - (i = p + 32), p = (_ + i) / 2, 0 != m && (m = 2, a.assign(f), t.arraycopy(u, 0, s, 0, 576)));
        } while (l > 12);

        c.sfb21_extra = b, 2 == m && t.arraycopy(f.l3_enc, 0, a.l3_enc, 0, 576);
      }, this.get_framebits = function (e, t) {
        var n = e.internal_flags;
        n.bitrate_index = n.VBR_min_bitrate;
        var s = a.getframebits(e);
        n.bitrate_index = 1, s = a.getframebits(e);

        for (var o = 1; o <= n.VBR_max_bitrate; o++) {
          n.bitrate_index = o;
          var i = new MeanBits(s);
          t[o] = r.ResvFrameBegin(e, i), s = i.bits;
        }
      }, this.VBR_old_prepare = function (e, t, n, a, s, i, _, l, c) {
        var f,
            u = e.internal_flags,
            d = 0,
            h = 1,
            p = 0;
        u.bitrate_index = u.VBR_max_bitrate;
        var m = r.ResvFrameBegin(e, new MeanBits(0)) / u.mode_gr;
        get_framebits(e, i);

        for (var b = 0; b < u.mode_gr; b++) {
          var v = o.on_pe(e, t, l[b], m, b, 0);
          u.mode_ext == Encoder.MPG_MD_MS_LR && (ms_convert(u.l3_side, b), o.reduce_side(l[b], n[b], m, v));

          for (var g = 0; g < u.channels_out; ++g) {
            var w = u.l3_side.tt[b][g];
            w.block_type != Encoder.SHORT_TYPE ? (d = 1.28 / (1 + Math.exp(3.5 - t[b][g] / 300)) - .05, f = u.PSY.mask_adjust - d) : (d = 2.56 / (1 + Math.exp(3.5 - t[b][g] / 300)) - .14, f = u.PSY.mask_adjust_short - d), u.masking_lower = Math.pow(10, .1 * f), init_outer_loop(u, w), c[b][g] = o.calc_xmin(e, a[b][g], w, s[b][g]), 0 != c[b][g] && (h = 0), _[b][g] = 126, p += l[b][g];
          }
        }

        for (b = 0; b < u.mode_gr; b++) {
          for (g = 0; g < u.channels_out; g++) {
            p > i[u.VBR_max_bitrate] && (l[b][g] *= i[u.VBR_max_bitrate], l[b][g] /= p), _[b][g] > l[b][g] && (_[b][g] = l[b][g]);
          }
        }

        return h;
      }, this.bitpressure_strategy = function (e, t, n, a) {
        for (var r = 0; r < e.mode_gr; r++) {
          for (var s = 0; s < e.channels_out; s++) {
            for (var o = e.l3_side.tt[r][s], i = t[r][s], _ = 0, l = 0; l < o.psy_lmax; l++) {
              i[_++] *= 1 + .029 * l * l / Encoder.SBMAX_l / Encoder.SBMAX_l;
            }

            if (o.block_type == Encoder.SHORT_TYPE) for (l = o.sfb_smin; l < Encoder.SBMAX_s; l++) {
              i[_++] *= 1 + .029 * l * l / Encoder.SBMAX_s / Encoder.SBMAX_s, i[_++] *= 1 + .029 * l * l / Encoder.SBMAX_s / Encoder.SBMAX_s, i[_++] *= 1 + .029 * l * l / Encoder.SBMAX_s / Encoder.SBMAX_s;
            }
            a[r][s] = 0 | Math.max(n[r][s], .9 * a[r][s]);
          }
        }
      }, this.VBR_new_prepare = function (e, t, n, a, s, i) {
        var _,
            l = e.internal_flags,
            c = 1,
            f = 0,
            u = 0;

        if (e.free_format) {
          l.bitrate_index = 0;
          d = new MeanBits(f);
          _ = r.ResvFrameBegin(e, d), f = d.bits, s[0] = _;
        } else {
          l.bitrate_index = l.VBR_max_bitrate;
          var d = new MeanBits(f);
          r.ResvFrameBegin(e, d), f = d.bits, get_framebits(e, s), _ = s[l.VBR_max_bitrate];
        }

        for (var h = 0; h < l.mode_gr; h++) {
          o.on_pe(e, t, i[h], f, h, 0), l.mode_ext == Encoder.MPG_MD_MS_LR && ms_convert(l.l3_side, h);

          for (var p = 0; p < l.channels_out; ++p) {
            var m = l.l3_side.tt[h][p];
            l.masking_lower = Math.pow(10, .1 * l.PSY.mask_adjust), init_outer_loop(l, m), 0 != o.calc_xmin(e, n[h][p], m, a[h][p]) && (c = 0), u += i[h][p];
          }
        }

        for (h = 0; h < l.mode_gr; h++) {
          for (p = 0; p < l.channels_out; p++) {
            u > _ && (i[h][p] *= _, i[h][p] /= u);
          }
        }

        return c;
      }, this.calc_target_bits = function (e, t, n, s, i, _) {
        var l,
            c,
            f,
            u,
            d = e.internal_flags,
            h = d.l3_side,
            p = 0;
        d.bitrate_index = d.VBR_max_bitrate;
        var m = new MeanBits(p);

        for (_[0] = r.ResvFrameBegin(e, m), p = m.bits, d.bitrate_index = 1, p = a.getframebits(e) - 8 * d.sideinfo_len, i[0] = p / (d.mode_gr * d.channels_out), p = e.VBR_mean_bitrate_kbps * e.framesize * 1e3, 0 != (1 & d.substep_shaping) && (p *= 1.09), p /= e.out_samplerate, p -= 8 * d.sideinfo_len, p /= d.mode_gr * d.channels_out, (l = .93 + .07 * (11 - e.compression_ratio) / 5.5) < .9 && (l = .9), l > 1 && (l = 1), c = 0; c < d.mode_gr; c++) {
          var b = 0;

          for (f = 0; f < d.channels_out; f++) {
            if (s[c][f] = int(l * p), t[c][f] > 700) {
              var v = int((t[c][f] - 700) / 1.4),
                  g = h.tt[c][f];
              s[c][f] = int(l * p), g.block_type == Encoder.SHORT_TYPE && v < p / 2 && (v = p / 2), v > 3 * p / 2 ? v = 3 * p / 2 : v < 0 && (v = 0), s[c][f] += v;
            }

            s[c][f] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (s[c][f] = LameInternalFlags.MAX_BITS_PER_CHANNEL), b += s[c][f];
          }

          if (b > LameInternalFlags.MAX_BITS_PER_GRANULE) for (f = 0; f < d.channels_out; ++f) {
            s[c][f] *= LameInternalFlags.MAX_BITS_PER_GRANULE, s[c][f] /= b;
          }
        }

        if (d.mode_ext == Encoder.MPG_MD_MS_LR) for (c = 0; c < d.mode_gr; c++) {
          o.reduce_side(s[c], n[c], p * d.channels_out, LameInternalFlags.MAX_BITS_PER_GRANULE);
        }

        for (u = 0, c = 0; c < d.mode_gr; c++) {
          for (f = 0; f < d.channels_out; f++) {
            s[c][f] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (s[c][f] = LameInternalFlags.MAX_BITS_PER_CHANNEL), u += s[c][f];
          }
        }

        if (u > _[0]) for (c = 0; c < d.mode_gr; c++) {
          for (f = 0; f < d.channels_out; f++) {
            s[c][f] *= _[0], s[c][f] /= u;
          }
        }
      };
    }

    function NewMDCT() {
      var a = [-.1482523854003001, 32.308141959636465, 296.40344946382766, 883.1344870032432, 11113.947376231741, 1057.2713659324597, 305.7402417275812, 30.825928907280012, 3.8533188138216365, 59.42900443849514, 709.5899960123345, 5281.91112291017, -5829.66483675846, -817.6293103748613, -76.91656988279972, -4.594269939176596, .9063471690191471, .1960342806591213, -.15466694054279598, 34.324387823855965, 301.8067566458425, 817.599602898885, 11573.795901679885, 1181.2520595540152, 321.59731579894424, 31.232021761053772, 3.7107095756221318, 53.650946155329365, 684.167428119626, 5224.56624370173, -6366.391851890084, -908.9766368219582, -89.83068876699639, -5.411397422890401, .8206787908286602, .3901806440322567, -.16070888947830023, 36.147034243915876, 304.11815768187864, 732.7429163887613, 11989.60988270091, 1300.012278487897, 335.28490093152146, 31.48816102859945, 3.373875931311736, 47.232241542899175, 652.7371796173471, 5132.414255594984, -6909.087078780055, -1001.9990371107289, -103.62185754286375, -6.104916304710272, .7416505462720353, .5805693545089249, -.16636367662261495, 37.751650073343995, 303.01103387567713, 627.9747488785183, 12358.763425278165, 1412.2779918482834, 346.7496836825721, 31.598286663170416, 3.1598635433980946, 40.57878626349686, 616.1671130880391, 5007.833007176154, -7454.040671756168, -1095.7960341867115, -118.24411666465777, -6.818469345853504, .6681786379192989, .7653668647301797, -.1716176790982088, 39.11551877123304, 298.3413246578966, 503.5259106886539, 12679.589408408976, 1516.5821921214542, 355.9850766329023, 31.395241710249053, 2.9164211881972335, 33.79716964664243, 574.8943997801362, 4853.234992253242, -7997.57021486075, -1189.7624067269965, -133.6444792601766, -7.7202770609839915, .5993769336819237, .9427934736519954, -.17645823955292173, 40.21879108166477, 289.9982036694474, 359.3226160751053, 12950.259102786438, 1612.1013903507662, 362.85067106591504, 31.045922092242872, 2.822222032597987, 26.988862316190684, 529.8996541764288, 4671.371946949588, -8535.899136645805, -1282.5898586244496, -149.58553632943463, -8.643494270763135, .5345111359507916, 1.111140466039205, -.36174739330527045, 41.04429910497807, 277.5463268268618, 195.6386023135583, 13169.43812144731, 1697.6433561479398, 367.40983966190305, 30.557037410382826, 2.531473372857427, 20.070154905927314, 481.50208566532336, 4464.970341588308, -9065.36882077239, -1373.62841526722, -166.1660487028118, -9.58289321133207, .4729647758913199, 1.268786568327291, -.36970682634889585, 41.393213350082036, 261.2935935556502, 12.935476055240873, 13336.131683328815, 1772.508612059496, 369.76534388639965, 29.751323653701338, 2.4023193045459172, 13.304795348228817, 430.5615775526625, 4237.0568611071185, -9581.931701634761, -1461.6913552409758, -183.12733958476446, -10.718010163869403, .41421356237309503, 1.414213562373095, -.37677560326535325, 41.619486213528496, 241.05423794991074, -187.94665032361226, 13450.063605744153, 1836.153896465782, 369.4908799925761, 29.001847876923147, 2.0714759319987186, 6.779591200894186, 377.7767837205709, 3990.386575512536, -10081.709459700915, -1545.947424837898, -200.3762958015653, -11.864482073055006, .3578057213145241, 1.546020906725474, -.3829366947518991, 41.1516456456653, 216.47684307105183, -406.1569483347166, 13511.136535077321, 1887.8076599260432, 367.3025214564151, 28.136213436723654, 1.913880671464418, .3829366947518991, 323.85365704338597, 3728.1472257487526, -10561.233882199509, -1625.2025997821418, -217.62525175416, -13.015432208941645, .3033466836073424, 1.66293922460509, -.5822628872992417, 40.35639251440489, 188.20071124269245, -640.2706748618148, 13519.21490106562, 1927.6022433578062, 362.8197642637487, 26.968821921868447, 1.7463817695935329, -5.62650678237171, 269.3016715297017, 3453.386536448852, -11016.145278780888, -1698.6569643425091, -234.7658734267683, -14.16351421663124, .2504869601913055, 1.76384252869671, -.5887180101749253, 39.23429103868072, 155.76096234403798, -889.2492977967378, 13475.470561874661, 1955.0535223723712, 356.4450994756727, 25.894952980042156, 1.5695032905781554, -11.181939564328772, 214.80884394039484, 3169.1640829158237, -11443.321309975563, -1765.1588461316153, -251.68908574481912, -15.49755935939164, .198912367379658, 1.847759065022573, -.7912582233652842, 37.39369355329111, 119.699486012458, -1151.0956593239027, 13380.446257078214, 1970.3952110853447, 348.01959814116185, 24.731487364283044, 1.3850130831637748, -16.421408865300393, 161.05030052864092, 2878.3322807850063, -11838.991423510031, -1823.985884688674, -268.2854986386903, -16.81724543849939, .1483359875383474, 1.913880671464418, -.7960642926861912, 35.2322109610459, 80.01928065061526, -1424.0212633405113, 13235.794061869668, 1973.804052543835, 337.9908651258184, 23.289159354463873, 1.3934255946442087, -21.099669467133474, 108.48348407242611, 2583.700758091299, -12199.726194855148, -1874.2780658979746, -284.2467154529415, -18.11369784385905, .09849140335716425, 1.961570560806461, -.998795456205172, 32.56307803611191, 36.958364584370486, -1706.075448829146, 13043.287458812016, 1965.3831106103316, 326.43182772364605, 22.175018750622293, 1.198638339011324, -25.371248002043963, 57.53505923036915, 2288.41886619975, -12522.674544337233, -1914.8400385312243, -299.26241273417224, -19.37805630698734, .04912684976946725, 1.990369453344394, .035780907 * n.SQRT2 * .5 / 2384e-9, .017876148 * n.SQRT2 * .5 / 2384e-9, .003134727 * n.SQRT2 * .5 / 2384e-9, .002457142 * n.SQRT2 * .5 / 2384e-9, 971317e-9 * n.SQRT2 * .5 / 2384e-9, 218868e-9 * n.SQRT2 * .5 / 2384e-9, 101566e-9 * n.SQRT2 * .5 / 2384e-9, 13828e-9 * n.SQRT2 * .5 / 2384e-9, 12804.797818791945, 1945.5515939597317, 313.4244966442953, 20.801593959731544, 1995.1556208053692, 9.000838926174497, -29.20218120805369],
          r = [[2382191739347913e-28, 6423305872147834e-28, 9400849094049688e-28, 1122435026096556e-27, 1183840321267481e-27, 1122435026096556e-27, 940084909404969e-27, 6423305872147839e-28, 2382191739347918e-28, 5456116108943412e-27, 4878985199565852e-27, 4240448995017367e-27, 3559909094758252e-27, 2858043359288075e-27, 2156177623817898e-27, 1475637723558783e-27, 8371015190102974e-28, 2599706096327376e-28, -5456116108943412e-27, -4878985199565852e-27, -4240448995017367e-27, -3559909094758252e-27, -2858043359288076e-27, -2156177623817898e-27, -1475637723558783e-27, -8371015190102975e-28, -2599706096327376e-28, -2382191739347923e-28, -6423305872147843e-28, -9400849094049696e-28, -1122435026096556e-27, -1183840321267481e-27, -1122435026096556e-27, -9400849094049694e-28, -642330587214784e-27, -2382191739347918e-28], [2382191739347913e-28, 6423305872147834e-28, 9400849094049688e-28, 1122435026096556e-27, 1183840321267481e-27, 1122435026096556e-27, 9400849094049688e-28, 6423305872147841e-28, 2382191739347918e-28, 5456116108943413e-27, 4878985199565852e-27, 4240448995017367e-27, 3559909094758253e-27, 2858043359288075e-27, 2156177623817898e-27, 1475637723558782e-27, 8371015190102975e-28, 2599706096327376e-28, -5461314069809755e-27, -4921085770524055e-27, -4343405037091838e-27, -3732668368707687e-27, -3093523840190885e-27, -2430835727329465e-27, -1734679010007751e-27, -974825365660928e-27, -2797435120168326e-28, 0, 0, 0, 0, 0, 0, -2283748241799531e-28, -4037858874020686e-28, -2146547464825323e-28], [.1316524975873958, .414213562373095, .7673269879789602, 1.091308501069271, 1.303225372841206, 1.56968557711749, 1.920982126971166, 2.414213562373094, 3.171594802363212, 4.510708503662055, 7.595754112725146, 22.90376554843115, .984807753012208, .6427876096865394, .3420201433256688, .9396926207859084, -.1736481776669303, -.7660444431189779, .8660254037844387, .5, -.5144957554275265, -.4717319685649723, -.3133774542039019, -.1819131996109812, -.09457419252642064, -.04096558288530405, -.01419856857247115, -.003699974673760037, .8574929257125442, .8817419973177052, .9496286491027329, .9833145924917901, .9955178160675857, .9991605581781475, .999899195244447, .9999931550702802], [0, 0, 0, 0, 0, 0, 2283748241799531e-28, 4037858874020686e-28, 2146547464825323e-28, 5461314069809755e-27, 4921085770524055e-27, 4343405037091838e-27, 3732668368707687e-27, 3093523840190885e-27, 2430835727329466e-27, 1734679010007751e-27, 974825365660928e-27, 2797435120168326e-28, -5456116108943413e-27, -4878985199565852e-27, -4240448995017367e-27, -3559909094758253e-27, -2858043359288075e-27, -2156177623817898e-27, -1475637723558782e-27, -8371015190102975e-28, -2599706096327376e-28, -2382191739347913e-28, -6423305872147834e-28, -9400849094049688e-28, -1122435026096556e-27, -1183840321267481e-27, -1122435026096556e-27, -9400849094049688e-28, -6423305872147841e-28, -2382191739347918e-28]],
          s = r[Encoder.SHORT_TYPE],
          o = r[Encoder.SHORT_TYPE],
          i = r[Encoder.SHORT_TYPE],
          _ = r[Encoder.SHORT_TYPE],
          l = [0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29, 2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31];

      function window_subband(e, t, r) {
        for (var s, o, i, _ = 10, l = t + 238 - 14 - 286, c = -15; c < 0; c++) {
          var f, u, d;
          f = a[_ + -10], u = e[l + -224] * f, d = e[t + 224] * f, f = a[_ + -9], u += e[l + -160] * f, d += e[t + 160] * f, f = a[_ + -8], u += e[l + -96] * f, d += e[t + 96] * f, f = a[_ + -7], u += e[l + -32] * f, d += e[t + 32] * f, f = a[_ + -6], u += e[l + 32] * f, d += e[t + -32] * f, f = a[_ + -5], u += e[l + 96] * f, d += e[t + -96] * f, f = a[_ + -4], u += e[l + 160] * f, d += e[t + -160] * f, f = a[_ + -3], u += e[l + 224] * f, d += e[t + -224] * f, f = a[_ + -2], u += e[t + -256] * f, d -= e[l + 256] * f, f = a[_ + -1], u += e[t + -192] * f, d -= e[l + 192] * f, f = a[_ + 0], u += e[t + -128] * f, d -= e[l + 128] * f, f = a[_ + 1], u += e[t + -64] * f, d -= e[l + 64] * f, f = a[_ + 2], u += e[t + 0] * f, d -= e[l + 0] * f, f = a[_ + 3], u += e[t + 64] * f, d -= e[l + -64] * f, f = a[_ + 4], u += e[t + 128] * f, d -= e[l + -128] * f, f = a[_ + 5], u += e[t + 192] * f, f = (d -= e[l + -192] * f) - (u *= a[_ + 6]), r[30 + 2 * c] = d + u, r[31 + 2 * c] = a[_ + 7] * f, _ += 18, t--, l++;
        }

        d = e[t + -16] * a[_ + -10], u = e[t + -32] * a[_ + -2], d += (e[t + -48] - e[t + 16]) * a[_ + -9], u += e[t + -96] * a[_ + -1], d += (e[t + -80] + e[t + 48]) * a[_ + -8], u += e[t + -160] * a[_ + 0], d += (e[t + -112] - e[t + 80]) * a[_ + -7], u += e[t + -224] * a[_ + 1], d += (e[t + -144] + e[t + 112]) * a[_ + -6], u -= e[t + 32] * a[_ + 2], d += (e[t + -176] - e[t + 144]) * a[_ + -5], u -= e[t + 96] * a[_ + 3], d += (e[t + -208] + e[t + 176]) * a[_ + -4], u -= e[t + 160] * a[_ + 4], d += (e[t + -240] - e[t + 208]) * a[_ + -3], s = (u -= e[t + 224]) - d, o = u + d, d = r[14], u = r[15] - d, r[31] = o + d, r[30] = s + u, r[15] = s - u, r[14] = o - d, i = r[28] - r[0], r[0] += r[28], r[28] = i * a[_ + -36 + 7], i = r[29] - r[1], r[1] += r[29], r[29] = i * a[_ + -36 + 7], i = r[26] - r[2], r[2] += r[26], r[26] = i * a[_ + -72 + 7], i = r[27] - r[3], r[3] += r[27], r[27] = i * a[_ + -72 + 7], i = r[24] - r[4], r[4] += r[24], r[24] = i * a[_ + -108 + 7], i = r[25] - r[5], r[5] += r[25], r[25] = i * a[_ + -108 + 7], i = r[22] - r[6], r[6] += r[22], r[22] = i * n.SQRT2, i = r[23] - r[7], r[7] += r[23], r[23] = i * n.SQRT2 - r[7], r[7] -= r[6], r[22] -= r[7], r[23] -= r[22], i = r[6], r[6] = r[31] - i, r[31] = r[31] + i, i = r[7], r[7] = r[30] - i, r[30] = r[30] + i, i = r[22], r[22] = r[15] - i, r[15] = r[15] + i, i = r[23], r[23] = r[14] - i, r[14] = r[14] + i, i = r[20] - r[8], r[8] += r[20], r[20] = i * a[_ + -180 + 7], i = r[21] - r[9], r[9] += r[21], r[21] = i * a[_ + -180 + 7], i = r[18] - r[10], r[10] += r[18], r[18] = i * a[_ + -216 + 7], i = r[19] - r[11], r[11] += r[19], r[19] = i * a[_ + -216 + 7], i = r[16] - r[12], r[12] += r[16], r[16] = i * a[_ + -252 + 7], i = r[17] - r[13], r[13] += r[17], r[17] = i * a[_ + -252 + 7], i = -r[20] + r[24], r[20] += r[24], r[24] = i * a[_ + -216 + 7], i = -r[21] + r[25], r[21] += r[25], r[25] = i * a[_ + -216 + 7], i = r[4] - r[8], r[4] += r[8], r[8] = i * a[_ + -216 + 7], i = r[5] - r[9], r[5] += r[9], r[9] = i * a[_ + -216 + 7], i = r[0] - r[12], r[0] += r[12], r[12] = i * a[_ + -72 + 7], i = r[1] - r[13], r[1] += r[13], r[13] = i * a[_ + -72 + 7], i = r[16] - r[28], r[16] += r[28], r[28] = i * a[_ + -72 + 7], i = -r[17] + r[29], r[17] += r[29], r[29] = i * a[_ + -72 + 7], i = n.SQRT2 * (r[2] - r[10]), r[2] += r[10], r[10] = i, i = n.SQRT2 * (r[3] - r[11]), r[3] += r[11], r[11] = i, i = n.SQRT2 * (-r[18] + r[26]), r[18] += r[26], r[26] = i - r[18], i = n.SQRT2 * (-r[19] + r[27]), r[19] += r[27], r[27] = i - r[19], i = r[2], r[19] -= r[3], r[3] -= i, r[2] = r[31] - i, r[31] += i, i = r[3], r[11] -= r[19], r[18] -= i, r[3] = r[30] - i, r[30] += i, i = r[18], r[27] -= r[11], r[19] -= i, r[18] = r[15] - i, r[15] += i, i = r[19], r[10] -= i, r[19] = r[14] - i, r[14] += i, i = r[10], r[11] -= i, r[10] = r[23] - i, r[23] += i, i = r[11], r[26] -= i, r[11] = r[22] - i, r[22] += i, i = r[26], r[27] -= i, r[26] = r[7] - i, r[7] += i, i = r[27], r[27] = r[6] - i, r[6] += i, i = n.SQRT2 * (r[0] - r[4]), r[0] += r[4], r[4] = i, i = n.SQRT2 * (r[1] - r[5]), r[1] += r[5], r[5] = i, i = n.SQRT2 * (r[16] - r[20]), r[16] += r[20], r[20] = i, i = n.SQRT2 * (r[17] - r[21]), r[17] += r[21], r[21] = i, i = -n.SQRT2 * (r[8] - r[12]), r[8] += r[12], r[12] = i - r[8], i = -n.SQRT2 * (r[9] - r[13]), r[9] += r[13], r[13] = i - r[9], i = -n.SQRT2 * (r[25] - r[29]), r[25] += r[29], r[29] = i - r[25], i = -n.SQRT2 * (r[24] + r[28]), r[24] -= r[28], r[28] = i - r[24], i = r[24] - r[16], r[24] = i, i = r[20] - i, r[20] = i, i = r[28] - i, r[28] = i, i = r[25] - r[17], r[25] = i, i = r[21] - i, r[21] = i, i = r[29] - i, r[29] = i, i = r[17] - r[1], r[17] = i, i = r[9] - i, r[9] = i, i = r[25] - i, r[25] = i, i = r[5] - i, r[5] = i, i = r[21] - i, r[21] = i, i = r[13] - i, r[13] = i, i = r[29] - i, r[29] = i, i = r[1] - r[0], r[1] = i, i = r[16] - i, r[16] = i, i = r[17] - i, r[17] = i, i = r[8] - i, r[8] = i, i = r[9] - i, r[9] = i, i = r[24] - i, r[24] = i, i = r[25] - i, r[25] = i, i = r[4] - i, r[4] = i, i = r[5] - i, r[5] = i, i = r[20] - i, r[20] = i, i = r[21] - i, r[21] = i, i = r[12] - i, r[12] = i, i = r[13] - i, r[13] = i, i = r[28] - i, r[28] = i, i = r[29] - i, r[29] = i, i = r[0], r[0] += r[31], r[31] -= i, i = r[1], r[1] += r[30], r[30] -= i, i = r[16], r[16] += r[15], r[15] -= i, i = r[17], r[17] += r[14], r[14] -= i, i = r[8], r[8] += r[23], r[23] -= i, i = r[9], r[9] += r[22], r[22] -= i, i = r[24], r[24] += r[7], r[7] -= i, i = r[25], r[25] += r[6], r[6] -= i, i = r[4], r[4] += r[27], r[27] -= i, i = r[5], r[5] += r[26], r[26] -= i, i = r[20], r[20] += r[11], r[11] -= i, i = r[21], r[21] += r[10], r[10] -= i, i = r[12], r[12] += r[19], r[19] -= i, i = r[13], r[13] += r[18], r[18] -= i, i = r[28], r[28] += r[3], r[3] -= i, i = r[29], r[29] += r[2], r[2] -= i;
      }

      function mdct_short(e, t) {
        for (var n = 0; n < 3; n++) {
          var a, s, o, i, _, l;

          s = (i = e[t + 6] * r[Encoder.SHORT_TYPE][0] - e[t + 15]) + (a = e[t + 0] * r[Encoder.SHORT_TYPE][2] - e[t + 9]), o = i - a, _ = (i = e[t + 15] * r[Encoder.SHORT_TYPE][0] + e[t + 6]) + (a = e[t + 9] * r[Encoder.SHORT_TYPE][2] + e[t + 0]), l = -i + a, a = 2069978111953089e-26 * (e[t + 3] * r[Encoder.SHORT_TYPE][1] - e[t + 12]), i = 2069978111953089e-26 * (e[t + 12] * r[Encoder.SHORT_TYPE][1] + e[t + 3]), e[t + 0] = 190752519173728e-25 * s + a, e[t + 15] = 190752519173728e-25 * -_ + i, o = .8660254037844387 * o * 1907525191737281e-26, _ = .5 * _ * 1907525191737281e-26 + i, e[t + 3] = o - _, e[t + 6] = o + _, s = .5 * s * 1907525191737281e-26 - a, l = .8660254037844387 * l * 1907525191737281e-26, e[t + 9] = s + l, e[t + 12] = s - l, t++;
        }
      }

      function mdct_long(e, t, n) {
        var a, r, s, i, _, l, c, f, u, d, h, p, m, b, v, g, w, E;

        s = n[17] - n[9], _ = n[15] - n[11], l = n[14] - n[12], c = n[0] + n[8], f = n[1] + n[7], u = n[2] + n[6], d = n[3] + n[5], e[t + 17] = c + u - d - (f - n[4]), r = (c + u - d) * o[19] + (f - n[4]), a = (s - _ - l) * o[18], e[t + 5] = a + r, e[t + 6] = a - r, i = (n[16] - n[10]) * o[18], f = f * o[19] + n[4], a = s * o[12] + i + _ * o[13] + l * o[14], r = -c * o[16] + f - u * o[17] + d * o[15], e[t + 1] = a + r, e[t + 2] = a - r, a = s * o[13] - i - _ * o[14] + l * o[12], r = -c * o[17] + f - u * o[15] + d * o[16], e[t + 9] = a + r, e[t + 10] = a - r, a = s * o[14] - i + _ * o[12] - l * o[13], r = c * o[15] - f + u * o[16] - d * o[17], e[t + 13] = a + r, e[t + 14] = a - r, h = n[8] - n[0], m = n[6] - n[2], b = n[5] - n[3], v = n[17] + n[9], g = n[16] + n[10], w = n[15] + n[11], E = n[14] + n[12], e[t + 0] = v + w + E + (g + n[13]), a = (v + w + E) * o[19] - (g + n[13]), r = (h - m + b) * o[18], e[t + 11] = a + r, e[t + 12] = a - r, p = (n[7] - n[1]) * o[18], g = n[13] - g * o[19], a = v * o[15] - g + w * o[16] + E * o[17], r = h * o[14] + p + m * o[12] + b * o[13], e[t + 3] = a + r, e[t + 4] = a - r, a = -v * o[17] + g - w * o[15] - E * o[16], r = h * o[13] + p - m * o[14] - b * o[12], e[t + 7] = a + r, e[t + 8] = a - r, a = -v * o[16] + g - w * o[17] - E * o[15], r = h * o[12] - p + m * o[13] - b * o[14], e[t + 15] = a + r, e[t + 16] = a - r;
      }

      this.mdct_sub48 = function (n, a, o) {
        for (var c = a, f = 286, u = 0; u < n.channels_out; u++) {
          for (var d = 0; d < n.mode_gr; d++) {
            for (var h, p = n.l3_side.tt[d][u], m = p.xr, b = 0, v = n.sb_sample[u][1 - d], g = 0, w = 0; w < 9; w++) {
              for (window_subband(c, f, v[g]), window_subband(c, f + 32, v[g + 1]), g += 2, f += 64, h = 1; h < 32; h += 2) {
                v[g - 1][h] *= -1;
              }
            }

            for (h = 0; h < 32; h++, b += 18) {
              var E = p.block_type,
                  S = n.sb_sample[u][d],
                  M = n.sb_sample[u][1 - d];
              if (0 != p.mixed_block_flag && h < 2 && (E = 0), n.amp_filter[h] < 1e-12) e.fill(m, b + 0, b + 18, 0);else {
                if (n.amp_filter[h] < 1) for (w = 0; w < 18; w++) {
                  M[w][l[h]] *= n.amp_filter[h];
                }

                if (E == Encoder.SHORT_TYPE) {
                  for (w = -3; w < 0; w++) {
                    var y = r[Encoder.SHORT_TYPE][w + 3];
                    m[b + 3 * w + 9] = S[9 + w][l[h]] * y - S[8 - w][l[h]], m[b + 3 * w + 18] = S[14 - w][l[h]] * y + S[15 + w][l[h]], m[b + 3 * w + 10] = S[15 + w][l[h]] * y - S[14 - w][l[h]], m[b + 3 * w + 19] = M[2 - w][l[h]] * y + M[3 + w][l[h]], m[b + 3 * w + 11] = M[3 + w][l[h]] * y - M[2 - w][l[h]], m[b + 3 * w + 20] = M[8 - w][l[h]] * y + M[9 + w][l[h]];
                  }

                  mdct_short(m, b);
                } else {
                  var B = new_float(18);

                  for (w = -9; w < 0; w++) {
                    var R, A;
                    R = r[E][w + 27] * M[w + 9][l[h]] + r[E][w + 36] * M[8 - w][l[h]], A = r[E][w + 9] * S[w + 9][l[h]] - r[E][w + 18] * S[8 - w][l[h]], B[w + 9] = R - A * s[3 + w + 9], B[w + 18] = R * s[3 + w + 9] + A;
                  }

                  mdct_long(m, b, B);
                }
              }
              if (E != Encoder.SHORT_TYPE && 0 != h) for (w = 7; w >= 0; --w) {
                var T, k;
                T = m[b + w] * i[20 + w] + m[b + -1 - w] * _[28 + w], k = m[b + w] * _[28 + w] - m[b + -1 - w] * i[20 + w], m[b + -1 - w] = T, m[b + w] = k;
              }
            }
          }

          if (c = o, f = 286, 1 == n.mode_gr) for (var x = 0; x < 18; x++) {
            t.arraycopy(n.sb_sample[u][1][x], 0, n.sb_sample[u][0][x], 0, 32);
          }
        }
      };
    }

    function III_psy_ratio() {
      this.thm = new III_psy_xmin(), this.en = new III_psy_xmin();
    }

    function Encoder() {
      var e = Encoder.FFTOFFSET,
          n = Encoder.MPG_MD_MS_LR,
          a = null;
      this.psy = null;
      var r = null,
          s = null,
          o = null;

      this.setModules = function (e, t, n, i) {
        a = e, this.psy = t, r = t, s = i, o = n;
      };

      var i = new NewMDCT();

      this.lame_encode_mp3_frame = function (_, l, c, f, u, d) {
        var h,
            p = new_array_n([2, 2]);
        p[0][0] = new III_psy_ratio(), p[0][1] = new III_psy_ratio(), p[1][0] = new III_psy_ratio(), p[1][1] = new III_psy_ratio();
        var m,
            b = new_array_n([2, 2]);
        b[0][0] = new III_psy_ratio(), b[0][1] = new III_psy_ratio(), b[1][0] = new III_psy_ratio(), b[1][1] = new III_psy_ratio();
        var v,
            g,
            w,
            E = [null, null],
            S = _.internal_flags,
            M = new_float_n([2, 4]),
            y = [.5, .5],
            B = [[0, 0], [0, 0]],
            R = [[0, 0], [0, 0]];

        if (E[0] = l, E[1] = c, 0 == S.lame_encode_frame_init && function lame_encode_frame_init(e, t) {
          var n,
              a,
              r = e.internal_flags;

          if (0 == r.lame_encode_frame_init) {
            var s,
                o,
                _ = new_float(2014),
                l = new_float(2014);

            for (r.lame_encode_frame_init = 1, s = 0, o = 0; s < 286 + 576 * (1 + r.mode_gr); ++s) {
              s < 576 * r.mode_gr ? (_[s] = 0, 2 == r.channels_out && (l[s] = 0)) : (_[s] = t[0][o], 2 == r.channels_out && (l[s] = t[1][o]), ++o);
            }

            for (a = 0; a < r.mode_gr; a++) {
              for (n = 0; n < r.channels_out; n++) {
                r.l3_side.tt[a][n].block_type = Encoder.SHORT_TYPE;
              }
            }

            i.mdct_sub48(r, _, l);
          }
        }(_, E), S.padding = 0, (S.slot_lag -= S.frac_SpF) < 0 && (S.slot_lag += _.out_samplerate, S.padding = 1), 0 != S.psymodel) {
          var A = [null, null],
              T = 0,
              k = new_int(2);

          for (w = 0; w < S.mode_gr; w++) {
            for (g = 0; g < S.channels_out; g++) {
              A[g] = E[g], T = 576 + 576 * w - Encoder.FFTOFFSET;
            }

            if (0 != (_.VBR == VbrMode.vbr_mtrh || _.VBR == VbrMode.vbr_mt ? r.L3psycho_anal_vbr(_, A, T, w, p, b, B[w], R[w], M[w], k) : r.L3psycho_anal_ns(_, A, T, w, p, b, B[w], R[w], M[w], k))) return -4;

            for (_.mode == MPEGMode.JOINT_STEREO && (y[w] = M[w][2] + M[w][3], y[w] > 0 && (y[w] = M[w][3] / y[w])), g = 0; g < S.channels_out; g++) {
              var x = S.l3_side.tt[w][g];
              x.block_type = k[g], x.mixed_block_flag = 0;
            }
          }
        } else for (w = 0; w < S.mode_gr; w++) {
          for (g = 0; g < S.channels_out; g++) {
            S.l3_side.tt[w][g].block_type = Encoder.NORM_TYPE, S.l3_side.tt[w][g].mixed_block_flag = 0, R[w][g] = B[w][g] = 700;
          }
        }

        if (function adjust_ATH(e) {
          var t, n;
          if (0 != e.ATH.useAdjust) {
            if (n = e.loudness_sq[0][0], t = e.loudness_sq[1][0], 2 == e.channels_out ? (n += e.loudness_sq[0][1], t += e.loudness_sq[1][1]) : (n += n, t += t), 2 == e.mode_gr && (n = Math.max(n, t)), n *= .5, (n *= e.ATH.aaSensitivityP) > .03125) e.ATH.adjust >= 1 ? e.ATH.adjust = 1 : e.ATH.adjust < e.ATH.adjustLimit && (e.ATH.adjust = e.ATH.adjustLimit), e.ATH.adjustLimit = 1;else {
              var a = 31.98 * n + 625e-6;
              e.ATH.adjust >= a ? (e.ATH.adjust *= .075 * a + .925, e.ATH.adjust < a && (e.ATH.adjust = a)) : e.ATH.adjustLimit >= a ? e.ATH.adjust = a : e.ATH.adjust < e.ATH.adjustLimit && (e.ATH.adjust = e.ATH.adjustLimit), e.ATH.adjustLimit = a;
            }
          } else e.ATH.adjust = 1;
        }(S), i.mdct_sub48(S, E[0], E[1]), S.mode_ext = Encoder.MPG_MD_LR_LR, _.force_ms) S.mode_ext = Encoder.MPG_MD_MS_LR;else if (_.mode == MPEGMode.JOINT_STEREO) {
          var P = 0,
              I = 0;

          for (w = 0; w < S.mode_gr; w++) {
            for (g = 0; g < S.channels_out; g++) {
              P += R[w][g], I += B[w][g];
            }
          }

          if (P <= 1 * I) {
            var L = S.l3_side.tt[0],
                V = S.l3_side.tt[S.mode_gr - 1];
            L[0].block_type == L[1].block_type && V[0].block_type == V[1].block_type && (S.mode_ext = Encoder.MPG_MD_MS_LR);
          }
        }
        if (S.mode_ext == n ? (m = b, v = R) : (m = p, v = B), _.analysis && null != S.pinfo) for (w = 0; w < S.mode_gr; w++) {
          for (g = 0; g < S.channels_out; g++) {
            S.pinfo.ms_ratio[w] = S.ms_ratio[w], S.pinfo.ms_ener_ratio[w] = y[w], S.pinfo.blocktype[w][g] = S.l3_side.tt[w][g].block_type, S.pinfo.pe[w][g] = v[w][g], t.arraycopy(S.l3_side.tt[w][g].xr, 0, S.pinfo.xr[w][g], 0, 576), S.mode_ext == n && (S.pinfo.ers[w][g] = S.pinfo.ers[w][g + 2], t.arraycopy(S.pinfo.energy[w][g + 2], 0, S.pinfo.energy[w][g], 0, S.pinfo.energy[w][g].length));
          }
        }

        if (_.VBR == VbrMode.vbr_off || _.VBR == VbrMode.vbr_abr) {
          var H, C;

          for (H = 0; H < 18; H++) {
            S.nsPsy.pefirbuf[H] = S.nsPsy.pefirbuf[H + 1];
          }

          for (C = 0, w = 0; w < S.mode_gr; w++) {
            for (g = 0; g < S.channels_out; g++) {
              C += v[w][g];
            }
          }

          for (S.nsPsy.pefirbuf[18] = C, C = S.nsPsy.pefirbuf[9], H = 0; H < 9; H++) {
            C += (S.nsPsy.pefirbuf[H] + S.nsPsy.pefirbuf[18 - H]) * Encoder.fircoef[H];
          }

          for (C = 3350 * S.mode_gr * S.channels_out / C, w = 0; w < S.mode_gr; w++) {
            for (g = 0; g < S.channels_out; g++) {
              v[w][g] *= C;
            }
          }
        }

        if (S.iteration_loop.iteration_loop(_, v, y, m), a.format_bitstream(_), h = a.copy_buffer(S, f, u, d, 1), _.bWriteVbrTag && s.addVbrFrame(_), _.analysis && null != S.pinfo) {
          for (g = 0; g < S.channels_out; g++) {
            var N;

            for (N = 0; N < e; N++) {
              S.pinfo.pcmdata[g][N] = S.pinfo.pcmdata[g][N + _.framesize];
            }

            for (N = e; N < 1600; N++) {
              S.pinfo.pcmdata[g][N] = E[g][N - e];
            }
          }

          o.set_frame_pinfo(_, m);
        }

        return function updateStats(e) {
          var t, n;

          for (e.bitrate_stereoMode_Hist[e.bitrate_index][4]++, e.bitrate_stereoMode_Hist[15][4]++, 2 == e.channels_out && (e.bitrate_stereoMode_Hist[e.bitrate_index][e.mode_ext]++, e.bitrate_stereoMode_Hist[15][e.mode_ext]++), t = 0; t < e.mode_gr; ++t) {
            for (n = 0; n < e.channels_out; ++n) {
              var a = 0 | e.l3_side.tt[t][n].block_type;
              0 != e.l3_side.tt[t][n].mixed_block_flag && (a = 4), e.bitrate_blockType_Hist[e.bitrate_index][a]++, e.bitrate_blockType_Hist[e.bitrate_index][5]++, e.bitrate_blockType_Hist[15][a]++, e.bitrate_blockType_Hist[15][5]++;
            }
          }
        }(S), h;
      };
    }

    function VBRSeekInfo() {
      this.sum = 0, this.seen = 0, this.want = 0, this.pos = 0, this.size = 0, this.bag = null, this.nVbrNumFrames = 0, this.nBytesWritten = 0, this.TotalFrameSize = 0;
    }

    function IIISideInfo() {
      this.tt = [[null, null], [null, null]], this.main_data_begin = 0, this.private_bits = 0, this.resvDrain_pre = 0, this.resvDrain_post = 0, this.scfsi = [new_int(4), new_int(4)];

      for (var e = 0; e < 2; e++) {
        for (var t = 0; t < 2; t++) {
          this.tt[e][t] = new GrInfo();
        }
      }
    }

    function III_psy_xmin() {
      this.l = new_float(Encoder.SBMAX_l), this.s = new_float_n([Encoder.SBMAX_s, 3]);
      var e = this;

      this.assign = function (n) {
        t.arraycopy(n.l, 0, e.l, 0, Encoder.SBMAX_l);

        for (var a = 0; a < Encoder.SBMAX_s; a++) {
          for (var r = 0; r < 3; r++) {
            e.s[a][r] = n.s[a][r];
          }
        }
      };
    }

    function NsPsy() {
      this.last_en_subshort = new_float_n([4, 9]), this.lastAttacks = new_int(4), this.pefirbuf = new_float(19), this.longfact = new_float(Encoder.SBMAX_l), this.shortfact = new_float(Encoder.SBMAX_s), this.attackthre = 0, this.attackthre_s = 0;
    }

    function LameInternalFlags() {
      function Header() {
        this.write_timing = 0, this.ptr = 0, this.buf = new_byte(40);
      }

      this.Class_ID = 0, this.lame_encode_frame_init = 0, this.iteration_init_init = 0, this.fill_buffer_resample_init = 0, this.mfbuf = new_float_n([2, LameInternalFlags.MFSIZE]), this.mode_gr = 0, this.channels_in = 0, this.channels_out = 0, this.resample_ratio = 0, this.mf_samples_to_encode = 0, this.mf_size = 0, this.VBR_min_bitrate = 0, this.VBR_max_bitrate = 0, this.bitrate_index = 0, this.samplerate_index = 0, this.mode_ext = 0, this.lowpass1 = 0, this.lowpass2 = 0, this.highpass1 = 0, this.highpass2 = 0, this.noise_shaping = 0, this.noise_shaping_amp = 0, this.substep_shaping = 0, this.psymodel = 0, this.noise_shaping_stop = 0, this.subblock_gain = 0, this.use_best_huffman = 0, this.full_outer_loop = 0, this.l3_side = new IIISideInfo(), this.ms_ratio = new_float(2), this.padding = 0, this.frac_SpF = 0, this.slot_lag = 0, this.tag_spec = null, this.nMusicCRC = 0, this.OldValue = new_int(2), this.CurrentStep = new_int(2), this.masking_lower = 0, this.bv_scf = new_int(576), this.pseudohalf = new_int(s.SFBMAX), this.sfb21_extra = !1, this.inbuf_old = new Array(2), this.blackfilt = new Array(2 * LameInternalFlags.BPC + 1), this.itime = function new_double(e) {
        return new Float64Array(e);
      }(2), this.sideinfo_len = 0, this.sb_sample = new_float_n([2, 2, 18, Encoder.SBLIMIT]), this.amp_filter = new_float(32), this.header = new Array(LameInternalFlags.MAX_HEADER_BUF), this.h_ptr = 0, this.w_ptr = 0, this.ancillary_flag = 0, this.ResvSize = 0, this.ResvMax = 0, this.scalefac_band = new ScaleFac(), this.minval_l = new_float(Encoder.CBANDS), this.minval_s = new_float(Encoder.CBANDS), this.nb_1 = new_float_n([4, Encoder.CBANDS]), this.nb_2 = new_float_n([4, Encoder.CBANDS]), this.nb_s1 = new_float_n([4, Encoder.CBANDS]), this.nb_s2 = new_float_n([4, Encoder.CBANDS]), this.s3_ss = null, this.s3_ll = null, this.decay = 0, this.thm = new Array(4), this.en = new Array(4), this.tot_ener = new_float(4), this.loudness_sq = new_float_n([2, 2]), this.loudness_sq_save = new_float(2), this.mld_l = new_float(Encoder.SBMAX_l), this.mld_s = new_float(Encoder.SBMAX_s), this.bm_l = new_int(Encoder.SBMAX_l), this.bo_l = new_int(Encoder.SBMAX_l), this.bm_s = new_int(Encoder.SBMAX_s), this.bo_s = new_int(Encoder.SBMAX_s), this.npart_l = 0, this.npart_s = 0, this.s3ind = new_int_n([Encoder.CBANDS, 2]), this.s3ind_s = new_int_n([Encoder.CBANDS, 2]), this.numlines_s = new_int(Encoder.CBANDS), this.numlines_l = new_int(Encoder.CBANDS), this.rnumlines_l = new_float(Encoder.CBANDS), this.mld_cb_l = new_float(Encoder.CBANDS), this.mld_cb_s = new_float(Encoder.CBANDS), this.numlines_s_num1 = 0, this.numlines_l_num1 = 0, this.pe = new_float(4), this.ms_ratio_s_old = 0, this.ms_ratio_l_old = 0, this.ms_ener_ratio_old = 0, this.blocktype_old = new_int(2), this.nsPsy = new NsPsy(), this.VBR_seek_table = new VBRSeekInfo(), this.ATH = null, this.PSY = null, this.nogap_total = 0, this.nogap_current = 0, this.decode_on_the_fly = !0, this.findReplayGain = !0, this.findPeakSample = !0, this.PeakSample = 0, this.RadioGain = 0, this.AudiophileGain = 0, this.rgdata = null, this.noclipGainChange = 0, this.noclipScale = 0, this.bitrate_stereoMode_Hist = new_int_n([16, 5]), this.bitrate_blockType_Hist = new_int_n([16, 6]), this.pinfo = null, this.hip = null, this.in_buffer_nsamples = 0, this.in_buffer_0 = null, this.in_buffer_1 = null, this.iteration_loop = null;

      for (var e = 0; e < this.en.length; e++) {
        this.en[e] = new III_psy_xmin();
      }

      for (e = 0; e < this.thm.length; e++) {
        this.thm[e] = new III_psy_xmin();
      }

      for (e = 0; e < this.header.length; e++) {
        this.header[e] = new Header();
      }
    }

    function FFT() {
      var e = new_float(Encoder.BLKSIZE),
          t = new_float(Encoder.BLKSIZE_s / 2),
          a = [.9238795325112867, .3826834323650898, .9951847266721969, .0980171403295606, .9996988186962042, .02454122852291229, .9999811752826011, .006135884649154475];

      function fht(e, t, r) {
        var s,
            o,
            i,
            _ = 0,
            l = t + (r <<= 1);
        s = 4;

        do {
          var c, f, u, d, h, p, m;
          m = s >> 1, p = (h = s << 1) + (d = s), s = h << 1, i = (o = t) + m;

          do {
            M = e[o + 0] - e[o + d], S = e[o + 0] + e[o + d], A = e[o + h] - e[o + p], B = e[o + h] + e[o + p], e[o + h] = S - B, e[o + 0] = S + B, e[o + p] = M - A, e[o + d] = M + A, M = e[i + 0] - e[i + d], S = e[i + 0] + e[i + d], A = n.SQRT2 * e[i + p], B = n.SQRT2 * e[i + h], e[i + h] = S - B, e[i + 0] = S + B, e[i + p] = M - A, e[i + d] = M + A, i += s, o += s;
          } while (o < l);

          for (f = a[_ + 0], c = a[_ + 1], u = 1; u < m; u++) {
            var b, v;
            b = 1 - 2 * c * c, v = 2 * c * f, o = t + u, i = t + d - u;

            do {
              var g, w, E, S, M, y, B, R, A, T;
              w = v * e[o + d] - b * e[i + d], g = b * e[o + d] + v * e[i + d], M = e[o + 0] - g, S = e[o + 0] + g, y = e[i + 0] - w, E = e[i + 0] + w, w = v * e[o + p] - b * e[i + p], g = b * e[o + p] + v * e[i + p], A = e[o + h] - g, B = e[o + h] + g, T = e[i + h] - w, R = e[i + h] + w, w = c * B - f * T, g = f * B + c * T, e[o + h] = S - g, e[o + 0] = S + g, e[i + p] = y - w, e[i + d] = y + w, w = f * R - c * A, g = c * R + f * A, e[i + h] = E - g, e[i + 0] = E + g, e[o + p] = M - w, e[o + d] = M + w, i += s, o += s;
            } while (o < l);

            f = (b = f) * a[_ + 0] - c * a[_ + 1], c = b * a[_ + 1] + c * a[_ + 0];
          }

          _ += 2;
        } while (s < r);
      }

      var r = [0, 128, 64, 192, 32, 160, 96, 224, 16, 144, 80, 208, 48, 176, 112, 240, 8, 136, 72, 200, 40, 168, 104, 232, 24, 152, 88, 216, 56, 184, 120, 248, 4, 132, 68, 196, 36, 164, 100, 228, 20, 148, 84, 212, 52, 180, 116, 244, 12, 140, 76, 204, 44, 172, 108, 236, 28, 156, 92, 220, 60, 188, 124, 252, 2, 130, 66, 194, 34, 162, 98, 226, 18, 146, 82, 210, 50, 178, 114, 242, 10, 138, 74, 202, 42, 170, 106, 234, 26, 154, 90, 218, 58, 186, 122, 250, 6, 134, 70, 198, 38, 166, 102, 230, 22, 150, 86, 214, 54, 182, 118, 246, 14, 142, 78, 206, 46, 174, 110, 238, 30, 158, 94, 222, 62, 190, 126, 254];
      this.fft_short = function (e, n, a, s, o) {
        for (var i = 0; i < 3; i++) {
          var _ = Encoder.BLKSIZE_s / 2,
              l = 65535 & 192 * (i + 1),
              c = Encoder.BLKSIZE_s / 8 - 1;

          do {
            var f,
                u,
                d,
                h,
                p,
                m = 255 & r[c << 2];
            u = (f = t[m] * s[a][o + m + l]) - (p = t[127 - m] * s[a][o + m + l + 128]), f += p, h = (d = t[m + 64] * s[a][o + m + l + 64]) - (p = t[63 - m] * s[a][o + m + l + 192]), d += p, _ -= 4, n[i][_ + 0] = f + d, n[i][_ + 2] = f - d, n[i][_ + 1] = u + h, n[i][_ + 3] = u - h, u = (f = t[m + 1] * s[a][o + m + l + 1]) - (p = t[126 - m] * s[a][o + m + l + 129]), f += p, h = (d = t[m + 65] * s[a][o + m + l + 65]) - (p = t[62 - m] * s[a][o + m + l + 193]), d += p, n[i][_ + Encoder.BLKSIZE_s / 2 + 0] = f + d, n[i][_ + Encoder.BLKSIZE_s / 2 + 2] = f - d, n[i][_ + Encoder.BLKSIZE_s / 2 + 1] = u + h, n[i][_ + Encoder.BLKSIZE_s / 2 + 3] = u - h;
          } while (--c >= 0);

          fht(n[i], _, Encoder.BLKSIZE_s / 2);
        }
      }, this.fft_long = function (t, n, a, s, o) {
        var i = Encoder.BLKSIZE / 8 - 1,
            _ = Encoder.BLKSIZE / 2;

        do {
          var l,
              c,
              f,
              u,
              d,
              h = 255 & r[i];
          c = (l = e[h] * s[a][o + h]) - (d = e[h + 512] * s[a][o + h + 512]), l += d, u = (f = e[h + 256] * s[a][o + h + 256]) - (d = e[h + 768] * s[a][o + h + 768]), f += d, n[(_ -= 4) + 0] = l + f, n[_ + 2] = l - f, n[_ + 1] = c + u, n[_ + 3] = c - u, c = (l = e[h + 1] * s[a][o + h + 1]) - (d = e[h + 513] * s[a][o + h + 513]), l += d, u = (f = e[h + 257] * s[a][o + h + 257]) - (d = e[h + 769] * s[a][o + h + 769]), f += d, n[_ + Encoder.BLKSIZE / 2 + 0] = l + f, n[_ + Encoder.BLKSIZE / 2 + 2] = l - f, n[_ + Encoder.BLKSIZE / 2 + 1] = c + u, n[_ + Encoder.BLKSIZE / 2 + 3] = c - u;
        } while (--i >= 0);

        fht(n, _, Encoder.BLKSIZE / 2);
      }, this.init_fft = function (n) {
        for (var a = 0; a < Encoder.BLKSIZE; a++) {
          e[a] = .42 - .5 * Math.cos(2 * Math.PI * (a + .5) / Encoder.BLKSIZE) + .08 * Math.cos(4 * Math.PI * (a + .5) / Encoder.BLKSIZE);
        }

        for (a = 0; a < Encoder.BLKSIZE_s / 2; a++) {
          t[a] = .5 * (1 - Math.cos(2 * Math.PI * (a + .5) / Encoder.BLKSIZE_s));
        }
      };
    }

    function PsyModel() {
      var t = new FFT(),
          r = 2.302585092994046,
          s = 1 / 217621504 / (Encoder.BLKSIZE / 2),
          o = .3,
          i = 21,
          _ = .2302585093;

      function psycho_loudness_approx(e, t) {
        for (var n = 0, a = 0; a < Encoder.BLKSIZE / 2; ++a) {
          n += e[a] * t.ATH.eql_w[a];
        }

        return n *= s;
      }

      function compute_ffts(e, a, r, s, o, i, _, l, c, f, u) {
        var d = e.internal_flags;
        if (c < 2) t.fft_long(d, s[o], c, f, u), t.fft_short(d, i[_], c, f, u);else if (2 == c) {
          for (var h = Encoder.BLKSIZE - 1; h >= 0; --h) {
            var p = s[o + 0][h],
                m = s[o + 1][h];
            s[o + 0][h] = (p + m) * n.SQRT2 * .5, s[o + 1][h] = (p - m) * n.SQRT2 * .5;
          }

          for (var b = 2; b >= 0; --b) {
            for (h = Encoder.BLKSIZE_s - 1; h >= 0; --h) {
              p = i[_ + 0][b][h], m = i[_ + 1][b][h];
              i[_ + 0][b][h] = (p + m) * n.SQRT2 * .5, i[_ + 1][b][h] = (p - m) * n.SQRT2 * .5;
            }
          }
        }
        a[0] = s[o + 0][0], a[0] *= a[0];

        for (h = Encoder.BLKSIZE / 2 - 1; h >= 0; --h) {
          var v = s[o + 0][Encoder.BLKSIZE / 2 - h],
              g = s[o + 0][Encoder.BLKSIZE / 2 + h];
          a[Encoder.BLKSIZE / 2 - h] = .5 * (v * v + g * g);
        }

        for (b = 2; b >= 0; --b) {
          r[b][0] = i[_ + 0][b][0], r[b][0] *= r[b][0];

          for (h = Encoder.BLKSIZE_s / 2 - 1; h >= 0; --h) {
            v = i[_ + 0][b][Encoder.BLKSIZE_s / 2 - h], g = i[_ + 0][b][Encoder.BLKSIZE_s / 2 + h];
            r[b][Encoder.BLKSIZE_s / 2 - h] = .5 * (v * v + g * g);
          }
        }

        var w = 0;

        for (h = 11; h < Encoder.HBLKSIZE; h++) {
          w += a[h];
        }

        if (d.tot_ener[c] = w, e.analysis) {
          for (h = 0; h < Encoder.HBLKSIZE; h++) {
            d.pinfo.energy[l][c][h] = d.pinfo.energy_save[c][h], d.pinfo.energy_save[c][h] = a[h];
          }

          d.pinfo.pe[l][c] = d.pe[c];
        }

        2 == e.athaa_loudapprox && c < 2 && (d.loudness_sq[l][c] = d.loudness_sq_save[c], d.loudness_sq_save[c] = psycho_loudness_approx(a, d));
      }

      var l,
          c,
          f,
          u = [1, .79433, .63096, .63096, .63096, .63096, .63096, .25119, .11749];
      var d = [3.3246 * 3.3246, 3.23837 * 3.23837, 9.9500500969, 9.0247369744, 8.1854926609, 7.0440875649, 2.46209 * 2.46209, 2.284 * 2.284, 4.4892710641, 1.96552 * 1.96552, 1.82335 * 1.82335, 1.69146 * 1.69146, 2.4621061921, 2.1508568964, 1.37074 * 1.37074, 1.31036 * 1.31036, 1.5691069696, 1.4555939904, 1.16203 * 1.16203, 1.2715945225, 1.09428 * 1.09428, 1.0659 * 1.0659, 1.0779838276, 1.0382591025, 1],
          h = [1.7782755904, 1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497, 1.40548 * 1.40548, 1.3537 * 1.3537, 1.6999465924, 1.22321 * 1.22321, 1.3169398564, 1],
          p = [5.5396212496, 2.29259 * 2.29259, 4.9868695969, 2.12675 * 2.12675, 2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303, 1.61695 * 1.61695, 2.2499700001, 1.39148 * 1.39148, 1.29083 * 1.29083, 1.19746 * 1.19746, 1.2339655056, 1.0779838276];

      function mask_add(e, t, a, r, s, o) {
        var i;

        if (t > e) {
          if (!(t < e * c)) return e + t;
          i = t / e;
        } else {
          if (e >= t * c) return e + t;
          i = e / t;
        }

        if (e += t, r + 3 <= 6) {
          if (i >= l) return e;

          var _ = 0 | n.FAST_LOG10_X(i, 16);

          return e * h[_];
        }

        var u, m;
        _ = 0 | n.FAST_LOG10_X(i, 16);
        return t = 0 != o ? s.ATH.cb_s[a] * s.ATH.adjust : s.ATH.cb_l[a] * s.ATH.adjust, e < f * t ? e > t ? (u = 1, _ <= 13 && (u = p[_]), m = n.FAST_LOG10_X(e / t, 10 / 15), e * ((d[_] - u) * m + u)) : _ > 13 ? e : e * p[_] : e * d[_];
      }

      var m = [1.7782755904, 1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497, 1.40548 * 1.40548, 1.3537 * 1.3537, 1.6999465924, 1.22321 * 1.22321, 1.3169398564, 1];

      function vbrpsy_mask_add(e, t, a) {
        var r;
        if (e < 0 && (e = 0), t < 0 && (t = 0), e <= 0) return t;
        if (t <= 0) return e;

        if (r = t > e ? t / e : e / t, -2 <= a && a <= 2) {
          if (r >= l) return e + t;
          var s = 0 | n.FAST_LOG10_X(r, 16);
          return (e + t) * m[s];
        }

        return r < c ? e + t : (e < t && (e = t), e);
      }

      function convert_partition2scalefac_s(e, t, n, a, r) {
        var s,
            o,
            i = 0,
            _ = 0;

        for (s = o = 0; s < Encoder.SBMAX_s; ++o, ++s) {
          for (var l = e.bo_s[s], c = e.npart_s, f = l < c ? l : c; o < f;) {
            i += t[o], _ += n[o], o++;
          }

          if (e.en[a].s[s][r] = i, e.thm[a].s[s][r] = _, o >= c) {
            ++s;
            break;
          }

          var u = e.PSY.bo_s_weight[s],
              d = 1 - u;
          i = u * t[o], _ = u * n[o], e.en[a].s[s][r] += i, e.thm[a].s[s][r] += _, i = d * t[o], _ = d * n[o];
        }

        for (; s < Encoder.SBMAX_s; ++s) {
          e.en[a].s[s][r] = 0, e.thm[a].s[s][r] = 0;
        }
      }

      function convert_partition2scalefac_l(e, t, n, a) {
        var r,
            s,
            o = 0,
            i = 0;

        for (r = s = 0; r < Encoder.SBMAX_l; ++s, ++r) {
          for (var _ = e.bo_l[r], l = e.npart_l, c = _ < l ? _ : l; s < c;) {
            o += t[s], i += n[s], s++;
          }

          if (e.en[a].l[r] = o, e.thm[a].l[r] = i, s >= l) {
            ++r;
            break;
          }

          var f = e.PSY.bo_l_weight[r],
              u = 1 - f;
          o = f * t[s], i = f * n[s], e.en[a].l[r] += o, e.thm[a].l[r] += i, o = u * t[s], i = u * n[s];
        }

        for (; r < Encoder.SBMAX_l; ++r) {
          e.en[a].l[r] = 0, e.thm[a].l[r] = 0;
        }
      }

      function compute_masking_s(e, t, n, a, r, s) {
        var o,
            i,
            _ = e.internal_flags;

        for (i = o = 0; i < _.npart_s; ++i) {
          for (var l = 0, c = _.numlines_s[i], f = 0; f < c; ++f, ++o) {
            l += t[s][o];
          }

          n[i] = l;
        }

        for (o = i = 0; i < _.npart_s; i++) {
          var u = _.s3ind_s[i][0],
              d = _.s3_ss[o++] * n[u];

          for (++u; u <= _.s3ind_s[i][1];) {
            d += _.s3_ss[o] * n[u], ++o, ++u;
          }

          var h = 2 * _.nb_s1[r][i];

          if (a[i] = Math.min(d, h), _.blocktype_old[1 & r] == Encoder.SHORT_TYPE) {
            h = 16 * _.nb_s2[r][i];
            var p = a[i];
            a[i] = Math.min(h, p);
          }

          _.nb_s2[r][i] = _.nb_s1[r][i], _.nb_s1[r][i] = d;
        }

        for (; i <= Encoder.CBANDS; ++i) {
          n[i] = 0, a[i] = 0;
        }
      }

      function NS_INTERP(e, t, n) {
        return n >= 1 ? e : n <= 0 ? t : t > 0 ? Math.pow(e / t, n) * t : 0;
      }

      var b = [11.8, 13.6, 17.2, 32, 46.5, 51.3, 57.5, 67.1, 71.5, 84.6, 97.6, 130];

      function pecalc_s(e, t) {
        for (var a = 309.07, s = 0; s < Encoder.SBMAX_s - 1; s++) {
          for (var o = 0; o < 3; o++) {
            var i = e.thm.s[s][o];

            if (i > 0) {
              var _ = i * t,
                  l = e.en.s[s][o];

              l > _ && (a += l > 1e10 * _ ? b[s] * (10 * r) : b[s] * n.FAST_LOG10(l / _));
            }
          }
        }

        return a;
      }

      var v = [6.8, 5.8, 5.8, 6.4, 6.5, 9.9, 12.1, 14.4, 15, 18.9, 21.6, 26.9, 34.2, 40.2, 46.8, 56.5, 60.7, 73.9, 85.7, 93.4, 126.1];

      function pecalc_l(e, t) {
        for (var a = 281.0575, s = 0; s < Encoder.SBMAX_l - 1; s++) {
          var o = e.thm.l[s];

          if (o > 0) {
            var i = o * t,
                _ = e.en.l[s];
            _ > i && (a += _ > 1e10 * i ? v[s] * (10 * r) : v[s] * n.FAST_LOG10(_ / i));
          }
        }

        return a;
      }

      function calc_energy(e, t, n, a, r) {
        var s, o;

        for (s = o = 0; s < e.npart_l; ++s) {
          var i,
              _ = 0,
              l = 0;

          for (i = 0; i < e.numlines_l[s]; ++i, ++o) {
            var c = t[o];
            _ += c, l < c && (l = c);
          }

          n[s] = _, a[s] = l, r[s] = _ * e.rnumlines_l[s];
        }
      }

      function calc_mask_index_l(e, t, n, a) {
        var r = u.length - 1,
            s = 0,
            o = n[s] + n[s + 1];
        o > 0 ? ((i = t[s]) < t[s + 1] && (i = t[s + 1]), (_ = 0 | (o = 20 * (2 * i - o) / (o * (e.numlines_l[s] + e.numlines_l[s + 1] - 1)))) > r && (_ = r), a[s] = _) : a[s] = 0;

        for (s = 1; s < e.npart_l - 1; s++) {
          var i, _;

          if ((o = n[s - 1] + n[s] + n[s + 1]) > 0) (i = t[s - 1]) < t[s] && (i = t[s]), i < t[s + 1] && (i = t[s + 1]), (_ = 0 | (o = 20 * (3 * i - o) / (o * (e.numlines_l[s - 1] + e.numlines_l[s] + e.numlines_l[s + 1] - 1)))) > r && (_ = r), a[s] = _;else a[s] = 0;
        }

        (o = n[s - 1] + n[s]) > 0 ? ((i = t[s - 1]) < t[s] && (i = t[s]), (_ = 0 | (o = 20 * (2 * i - o) / (o * (e.numlines_l[s - 1] + e.numlines_l[s] - 1)))) > r && (_ = r), a[s] = _) : a[s] = 0;
      }

      var g = [-1730326e-23, -.01703172, -1349528e-23, .0418072, -673278e-22, -.0876324, -30835e-21, .1863476, -1104424e-22, -.627638];

      function vbrpsy_compute_fft_l(e, a, r, s, o, i, _, l) {
        var c = e.internal_flags;
        if (s < 2) t.fft_long(c, _[l], s, a, r);else if (2 == s) for (var f = Encoder.BLKSIZE - 1; f >= 0; --f) {
          var u = _[l + 0][f],
              d = _[l + 1][f];
          _[l + 0][f] = (u + d) * n.SQRT2 * .5, _[l + 1][f] = (u - d) * n.SQRT2 * .5;
        }
        i[0] = _[l + 0][0], i[0] *= i[0];

        for (f = Encoder.BLKSIZE / 2 - 1; f >= 0; --f) {
          var h = _[l + 0][Encoder.BLKSIZE / 2 - f],
              p = _[l + 0][Encoder.BLKSIZE / 2 + f];
          i[Encoder.BLKSIZE / 2 - f] = .5 * (h * h + p * p);
        }

        var m = 0;

        for (f = 11; f < Encoder.HBLKSIZE; f++) {
          m += i[f];
        }

        if (c.tot_ener[s] = m, e.analysis) {
          for (f = 0; f < Encoder.HBLKSIZE; f++) {
            c.pinfo.energy[o][s][f] = c.pinfo.energy_save[s][f], c.pinfo.energy_save[s][f] = i[f];
          }

          c.pinfo.pe[o][s] = c.pe[s];
        }
      }

      function vbrpsy_compute_fft_s(e, a, r, s, o, i, _, l) {
        var c = e.internal_flags;
        if (0 == o && s < 2 && t.fft_short(c, _[l], s, a, r), 2 == s) for (var f = Encoder.BLKSIZE_s - 1; f >= 0; --f) {
          var u = _[l + 0][o][f],
              d = _[l + 1][o][f];
          _[l + 0][o][f] = (u + d) * n.SQRT2 * .5, _[l + 1][o][f] = (u - d) * n.SQRT2 * .5;
        }
        i[o][0] = _[l + 0][o][0], i[o][0] *= i[o][0];

        for (f = Encoder.BLKSIZE_s / 2 - 1; f >= 0; --f) {
          var h = _[l + 0][o][Encoder.BLKSIZE_s / 2 - f],
              p = _[l + 0][o][Encoder.BLKSIZE_s / 2 + f];
          i[o][Encoder.BLKSIZE_s / 2 - f] = .5 * (h * h + p * p);
        }
      }

      function vbrpsy_compute_loudness_approximation_l(e, t, n, a) {
        var r = e.internal_flags;
        2 == e.athaa_loudapprox && n < 2 && (r.loudness_sq[t][n] = r.loudness_sq_save[n], r.loudness_sq_save[n] = psycho_loudness_approx(a, r));
      }

      this.L3psycho_anal_ns = function (t, n, a, r, s, _, l, c, f, d) {
        var h,
            p,
            m,
            b,
            v,
            w,
            E,
            S,
            M,
            y,
            B = t.internal_flags,
            R = new_float_n([2, Encoder.BLKSIZE]),
            A = new_float_n([2, 3, Encoder.BLKSIZE_s]),
            T = new_float(Encoder.CBANDS + 1),
            k = new_float(Encoder.CBANDS + 1),
            x = new_float(Encoder.CBANDS + 2),
            P = new_int(2),
            I = new_int(2),
            L = new_float_n([2, 576]),
            V = new_int(Encoder.CBANDS + 2),
            H = new_int(Encoder.CBANDS + 2);

        for (e.fill(H, 0), h = B.channels_out, t.mode == MPEGMode.JOINT_STEREO && (h = 4), M = t.VBR == VbrMode.vbr_off ? 0 == B.ResvMax ? 0 : B.ResvSize / B.ResvMax * .5 : t.VBR == VbrMode.vbr_rh || t.VBR == VbrMode.vbr_mtrh || t.VBR == VbrMode.vbr_mt ? .6 : 1, p = 0; p < B.channels_out; p++) {
          var C = n[p],
              N = a + 576 - 350 - i + 192;

          for (b = 0; b < 576; b++) {
            var O, q;

            for (O = C[N + b + 10], q = 0, v = 0; v < 9; v += 2) {
              O += g[v] * (C[N + b + v] + C[N + b + i - v]), q += g[v + 1] * (C[N + b + v + 1] + C[N + b + i - v - 1]);
            }

            L[p][b] = O + q;
          }

          s[r][p].en.assign(B.en[p]), s[r][p].thm.assign(B.thm[p]), h > 2 && (_[r][p].en.assign(B.en[p + 2]), _[r][p].thm.assign(B.thm[p + 2]));
        }

        for (p = 0; p < h; p++) {
          var j,
              F = new_float(12),
              D = [0, 0, 0, 0],
              Y = new_float(12),
              G = 1,
              z = new_float(Encoder.CBANDS),
              X = new_float(Encoder.CBANDS),
              U = [0, 0, 0, 0],
              Q = new_float(Encoder.HBLKSIZE),
              K = new_float_n([3, Encoder.HBLKSIZE_s]);

          for (b = 0; b < 3; b++) {
            F[b] = B.nsPsy.last_en_subshort[p][b + 6], Y[b] = F[b] / B.nsPsy.last_en_subshort[p][b + 4], D[0] += F[b];
          }

          if (2 == p) for (b = 0; b < 576; b++) {
            var Z, W;
            Z = L[0][b], W = L[1][b], L[0][b] = Z + W, L[1][b] = Z - W;
          }
          var J = L[1 & p],
              $ = 0;

          for (b = 0; b < 9; b++) {
            for (var ee = $ + 64, te = 1; $ < ee; $++) {
              te < Math.abs(J[$]) && (te = Math.abs(J[$]));
            }

            B.nsPsy.last_en_subshort[p][b] = F[b + 3] = te, D[1 + b / 3] += te, te > F[b + 3 - 2] ? te /= F[b + 3 - 2] : te = F[b + 3 - 2] > 10 * te ? F[b + 3 - 2] / (10 * te) : 0, Y[b + 3] = te;
          }

          if (t.analysis) {
            var ne = Y[0];

            for (b = 1; b < 12; b++) {
              ne < Y[b] && (ne = Y[b]);
            }

            B.pinfo.ers[r][p] = B.pinfo.ers_save[p], B.pinfo.ers_save[p] = ne;
          }

          for (j = 3 == p ? B.nsPsy.attackthre_s : B.nsPsy.attackthre, b = 0; b < 12; b++) {
            0 == U[b / 3] && Y[b] > j && (U[b / 3] = b % 3 + 1);
          }

          for (b = 1; b < 4; b++) {
            (D[b - 1] > D[b] ? D[b - 1] / D[b] : D[b] / D[b - 1]) < 1.7 && (U[b] = 0, 1 == b && (U[0] = 0));
          }

          for (0 != U[0] && 0 != B.nsPsy.lastAttacks[p] && (U[0] = 0), 3 != B.nsPsy.lastAttacks[p] && U[0] + U[1] + U[2] + U[3] == 0 || (G = 0, 0 != U[1] && 0 != U[0] && (U[1] = 0), 0 != U[2] && 0 != U[1] && (U[2] = 0), 0 != U[3] && 0 != U[2] && (U[3] = 0)), p < 2 ? I[p] = G : 0 == G && (I[0] = I[1] = 0), f[p] = B.tot_ener[p], compute_ffts(t, Q, K, R, 1 & p, A, 1 & p, r, p, n, a), calc_energy(B, Q, T, z, X), calc_mask_index_l(B, z, X, V), S = 0; S < 3; S++) {
            var ae, re;

            for (compute_masking_s(t, K, k, x, p, S), convert_partition2scalefac_s(B, k, x, p, S), E = 0; E < Encoder.SBMAX_s; E++) {
              if (re = B.thm[p].s[E][S], re *= .8, U[S] >= 2 || 1 == U[S + 1]) {
                var se = 0 != S ? S - 1 : 2;
                te = NS_INTERP(B.thm[p].s[E][se], re, .6 * M);
                re = Math.min(re, te);
              }

              if (1 == U[S]) {
                se = 0 != S ? S - 1 : 2, te = NS_INTERP(B.thm[p].s[E][se], re, o * M);
                re = Math.min(re, te);
              } else if (0 != S && 3 == U[S - 1] || 0 == S && 3 == B.nsPsy.lastAttacks[p]) {
                se = 2 != S ? S + 1 : 0, te = NS_INTERP(B.thm[p].s[E][se], re, o * M);
                re = Math.min(re, te);
              }

              ae = F[3 * S + 3] + F[3 * S + 4] + F[3 * S + 5], 6 * F[3 * S + 5] < ae && (re *= .5, 6 * F[3 * S + 4] < ae && (re *= .5)), B.thm[p].s[E][S] = re;
            }
          }

          for (B.nsPsy.lastAttacks[p] = U[2], w = 0, m = 0; m < B.npart_l; m++) {
            for (var oe = B.s3ind[m][0], ie = T[oe] * u[V[oe]], _e = B.s3_ll[w++] * ie; ++oe <= B.s3ind[m][1];) {
              ie = T[oe] * u[V[oe]], _e = mask_add(_e, B.s3_ll[w++] * ie, oe, oe - m, B, 0);
            }

            _e *= .158489319246111, B.blocktype_old[1 & p] == Encoder.SHORT_TYPE ? x[m] = _e : x[m] = NS_INTERP(Math.min(_e, Math.min(2 * B.nb_1[p][m], 16 * B.nb_2[p][m])), _e, M), B.nb_2[p][m] = B.nb_1[p][m], B.nb_1[p][m] = _e;
          }

          for (; m <= Encoder.CBANDS; ++m) {
            T[m] = 0, x[m] = 0;
          }

          convert_partition2scalefac_l(B, T, x, p);
        }

        (t.mode != MPEGMode.STEREO && t.mode != MPEGMode.JOINT_STEREO || t.interChRatio > 0 && function calc_interchannel_masking(e, t) {
          var n = e.internal_flags;

          if (n.channels_out > 1) {
            for (var a = 0; a < Encoder.SBMAX_l; a++) {
              var r = n.thm[0].l[a],
                  s = n.thm[1].l[a];
              n.thm[0].l[a] += s * t, n.thm[1].l[a] += r * t;
            }

            for (a = 0; a < Encoder.SBMAX_s; a++) {
              for (var o = 0; o < 3; o++) {
                r = n.thm[0].s[a][o], s = n.thm[1].s[a][o], n.thm[0].s[a][o] += s * t, n.thm[1].s[a][o] += r * t;
              }
            }
          }
        }(t, t.interChRatio), t.mode == MPEGMode.JOINT_STEREO) && (!function msfix1(e) {
          for (var t = 0; t < Encoder.SBMAX_l; t++) {
            if (!(e.thm[0].l[t] > 1.58 * e.thm[1].l[t] || e.thm[1].l[t] > 1.58 * e.thm[0].l[t])) {
              var n = e.mld_l[t] * e.en[3].l[t],
                  a = Math.max(e.thm[2].l[t], Math.min(e.thm[3].l[t], n));
              n = e.mld_l[t] * e.en[2].l[t];
              var r = Math.max(e.thm[3].l[t], Math.min(e.thm[2].l[t], n));
              e.thm[2].l[t] = a, e.thm[3].l[t] = r;
            }
          }

          for (t = 0; t < Encoder.SBMAX_s; t++) {
            for (var s = 0; s < 3; s++) {
              e.thm[0].s[t][s] > 1.58 * e.thm[1].s[t][s] || e.thm[1].s[t][s] > 1.58 * e.thm[0].s[t][s] || (n = e.mld_s[t] * e.en[3].s[t][s], a = Math.max(e.thm[2].s[t][s], Math.min(e.thm[3].s[t][s], n)), n = e.mld_s[t] * e.en[2].s[t][s], r = Math.max(e.thm[3].s[t][s], Math.min(e.thm[2].s[t][s], n)), e.thm[2].s[t][s] = a, e.thm[3].s[t][s] = r);
            }
          }
        }(B), y = t.msfix, Math.abs(y) > 0 && function ns_msfix(e, t, n) {
          var a = t,
              r = Math.pow(10, n);
          t *= 2, a *= 2;

          for (var s = 0; s < Encoder.SBMAX_l; s++) {
            c = e.ATH.cb_l[e.bm_l[s]] * r, (i = Math.min(Math.max(e.thm[0].l[s], c), Math.max(e.thm[1].l[s], c))) * t < (_ = Math.max(e.thm[2].l[s], c)) + (l = Math.max(e.thm[3].l[s], c)) && (_ *= f = i * a / (_ + l), l *= f), e.thm[2].l[s] = Math.min(_, e.thm[2].l[s]), e.thm[3].l[s] = Math.min(l, e.thm[3].l[s]);
          }

          for (r *= Encoder.BLKSIZE_s / Encoder.BLKSIZE, s = 0; s < Encoder.SBMAX_s; s++) {
            for (var o = 0; o < 3; o++) {
              var i, _, l, c, f;

              c = e.ATH.cb_s[e.bm_s[s]] * r, (i = Math.min(Math.max(e.thm[0].s[s][o], c), Math.max(e.thm[1].s[s][o], c))) * t < (_ = Math.max(e.thm[2].s[s][o], c)) + (l = Math.max(e.thm[3].s[s][o], c)) && (_ *= f = i * t / (_ + l), l *= f), e.thm[2].s[s][o] = Math.min(e.thm[2].s[s][o], _), e.thm[3].s[s][o] = Math.min(e.thm[3].s[s][o], l);
            }
          }
        }(B, y, t.ATHlower * B.ATH.adjust));

        for (function block_type_set(e, t, n, a) {
          var r = e.internal_flags;
          e.short_blocks != ShortBlock.short_block_coupled || 0 != t[0] && 0 != t[1] || (t[0] = t[1] = 0);

          for (var s = 0; s < r.channels_out; s++) {
            a[s] = Encoder.NORM_TYPE, e.short_blocks == ShortBlock.short_block_dispensed && (t[s] = 1), e.short_blocks == ShortBlock.short_block_forced && (t[s] = 0), 0 != t[s] ? r.blocktype_old[s] == Encoder.SHORT_TYPE && (a[s] = Encoder.STOP_TYPE) : (a[s] = Encoder.SHORT_TYPE, r.blocktype_old[s] == Encoder.NORM_TYPE && (r.blocktype_old[s] = Encoder.START_TYPE), r.blocktype_old[s] == Encoder.STOP_TYPE && (r.blocktype_old[s] = Encoder.SHORT_TYPE)), n[s] = r.blocktype_old[s], r.blocktype_old[s] = a[s];
          }
        }(t, I, d, P), p = 0; p < h; p++) {
          var le,
              ce,
              fe,
              ue = 0;
          p > 1 ? (le = c, ue = -2, ce = Encoder.NORM_TYPE, d[0] != Encoder.SHORT_TYPE && d[1] != Encoder.SHORT_TYPE || (ce = Encoder.SHORT_TYPE), fe = _[r][p - 2]) : (le = l, ue = 0, ce = d[p], fe = s[r][p]), ce == Encoder.SHORT_TYPE ? le[ue + p] = pecalc_s(fe, B.masking_lower) : le[ue + p] = pecalc_l(fe, B.masking_lower), t.analysis && (B.pinfo.pe[r][p] = le[ue + p]);
        }

        return 0;
      };

      var w = [-1730326e-23, -.01703172, -1349528e-23, .0418072, -673278e-22, -.0876324, -30835e-21, .1863476, -1104424e-22, -.627638];

      function vbrpsy_skip_masking_s(e, t, n) {
        if (0 == n) for (var a = 0; a < e.npart_s; a++) {
          e.nb_s2[t][a] = e.nb_s1[t][a], e.nb_s1[t][a] = 0;
        }
      }

      function vbrpsy_skip_masking_l(e, t) {
        for (var n = 0; n < e.npart_l; n++) {
          e.nb_2[t][n] = e.nb_1[t][n], e.nb_1[t][n] = 0;
        }
      }

      function vbrpsy_compute_masking_s(e, t, n, a, r, s) {
        var o,
            i,
            _,
            l = e.internal_flags,
            c = new float[Encoder.CBANDS](),
            f = new_float(Encoder.CBANDS),
            d = new int[Encoder.CBANDS]();

        for (_ = i = 0; _ < l.npart_s; ++_) {
          var h = 0,
              p = 0,
              m = l.numlines_s[_];

          for (o = 0; o < m; ++o, ++i) {
            var b = t[s][i];
            h += b, p < b && (p = b);
          }

          n[_] = h, c[_] = p, f[_] = h / m;
        }

        for (; _ < Encoder.CBANDS; ++_) {
          c[_] = 0, f[_] = 0;
        }

        for (function psyvbr_calc_mask_index_s(e, t, n, a) {
          var r = u.length - 1,
              s = 0,
              o = n[s] + n[s + 1];

          for (o > 0 ? ((i = t[s]) < t[s + 1] && (i = t[s + 1]), (_ = 0 | (o = 20 * (2 * i - o) / (o * (e.numlines_s[s] + e.numlines_s[s + 1] - 1)))) > r && (_ = r), a[s] = _) : a[s] = 0, s = 1; s < e.npart_s - 1; s++) {
            var i, _;

            (o = n[s - 1] + n[s] + n[s + 1]) > 0 ? ((i = t[s - 1]) < t[s] && (i = t[s]), i < t[s + 1] && (i = t[s + 1]), (_ = 0 | (o = 20 * (3 * i - o) / (o * (e.numlines_s[s - 1] + e.numlines_s[s] + e.numlines_s[s + 1] - 1)))) > r && (_ = r), a[s] = _) : a[s] = 0;
          }

          (o = n[s - 1] + n[s]) > 0 ? ((i = t[s - 1]) < t[s] && (i = t[s]), (_ = 0 | (o = 20 * (2 * i - o) / (o * (e.numlines_s[s - 1] + e.numlines_s[s] - 1)))) > r && (_ = r), a[s] = _) : a[s] = 0;
        }(l, c, f, d), i = _ = 0; _ < l.npart_s; _++) {
          var v,
              g,
              w,
              E,
              S,
              M = l.s3ind_s[_][0],
              y = l.s3ind_s[_][1];

          for (v = d[M], g = 1, E = l.s3_ss[i] * n[M] * u[d[M]], ++i, ++M; M <= y;) {
            v += d[M], g += 1, E = vbrpsy_mask_add(E, w = l.s3_ss[i] * n[M] * u[d[M]], M - _), ++i, ++M;
          }

          E *= S = .5 * u[v = (1 + 2 * v) / (2 * g)], a[_] = E, l.nb_s2[r][_] = l.nb_s1[r][_], l.nb_s1[r][_] = E, w = c[_], w *= l.minval_s[_], w *= S, a[_] > w && (a[_] = w), l.masking_lower > 1 && (a[_] *= l.masking_lower), a[_] > n[_] && (a[_] = n[_]), l.masking_lower < 1 && (a[_] *= l.masking_lower);
        }

        for (; _ < Encoder.CBANDS; ++_) {
          n[_] = 0, a[_] = 0;
        }
      }

      function vbrpsy_compute_masking_l(e, t, n, a, r) {
        var s,
            i = new_float(Encoder.CBANDS),
            _ = new_float(Encoder.CBANDS),
            l = new_int(Encoder.CBANDS + 2);

        calc_energy(e, t, n, i, _), calc_mask_index_l(e, i, _, l);
        var c = 0;

        for (s = 0; s < e.npart_l; s++) {
          var f,
              d,
              h,
              p = e.s3ind[s][0],
              m = e.s3ind[s][1],
              b = 0,
              v = 0;

          for (b = l[p], v += 1, d = e.s3_ll[c] * n[p] * u[l[p]], ++c, ++p; p <= m;) {
            b += l[p], v += 1, d = vbrpsy_mask_add(d, f = e.s3_ll[c] * n[p] * u[l[p]], p - s), ++c, ++p;
          }

          if (d *= h = .5 * u[b = (1 + 2 * b) / (2 * v)], e.blocktype_old[1 & r] == Encoder.SHORT_TYPE) {
            var g = 2 * e.nb_1[r][s];
            a[s] = g > 0 ? Math.min(d, g) : Math.min(d, n[s] * o);
          } else {
            var w = 16 * e.nb_2[r][s],
                E = 2 * e.nb_1[r][s];
            w <= 0 && (w = d), E <= 0 && (E = d), g = e.blocktype_old[1 & r] == Encoder.NORM_TYPE ? Math.min(E, w) : E, a[s] = Math.min(d, g);
          }

          e.nb_2[r][s] = e.nb_1[r][s], e.nb_1[r][s] = d, f = i[s], f *= e.minval_l[s], f *= h, a[s] > f && (a[s] = f), e.masking_lower > 1 && (a[s] *= e.masking_lower), a[s] > n[s] && (a[s] = n[s]), e.masking_lower < 1 && (a[s] *= e.masking_lower);
        }

        for (; s < Encoder.CBANDS; ++s) {
          n[s] = 0, a[s] = 0;
        }
      }

      function vbrpsy_compute_MS_thresholds(e, t, n, a, r, s, o) {
        for (var i, _, l = 2 * s, c = s > 0 ? Math.pow(10, r) : 1, f = 0; f < o; ++f) {
          var u = e[2][f],
              d = e[3][f],
              h = t[0][f],
              p = t[1][f],
              m = t[2][f],
              b = t[3][f];

          if (h <= 1.58 * p && p <= 1.58 * h) {
            var v = n[f] * d,
                g = n[f] * u;
            _ = Math.max(m, Math.min(b, v)), i = Math.max(b, Math.min(m, g));
          } else _ = m, i = b;

          if (s > 0) {
            var w,
                E,
                S = a[f] * c;

            if (w = Math.min(Math.max(h, S), Math.max(p, S)), (E = (m = Math.max(_, S)) + (b = Math.max(i, S))) > 0 && w * l < E) {
              var M = w * l / E;
              m *= M, b *= M;
            }

            _ = Math.min(m, _), i = Math.min(b, i);
          }

          _ > u && (_ = u), i > d && (i = d), t[2][f] = _, t[3][f] = i;
        }
      }

      function s3_func_x(e, t) {
        var n;
        return (n = e >= 0 ? 27 * -e : e * t) <= -72 ? 0 : Math.exp(n * _);
      }

      function norm_s3_func_x(e) {
        var t,
            n,
            a = 0;

        for (a = 0; s3_func_x(a, e) > 1e-20; a -= 1) {
        }

        for (r = a, s = 0; Math.abs(s - r) > 1e-12;) {
          s3_func_x(a = (s + r) / 2, e) > 0 ? s = a : r = a;
        }

        t = r;
        var r, s;
        a = 0;

        for (a = 0; s3_func_x(a, e) > 1e-20; a += 1) {
        }

        for (r = 0, s = a; Math.abs(s - r) > 1e-12;) {
          s3_func_x(a = (s + r) / 2, e) > 0 ? r = a : s = a;
        }

        n = s;
        var o,
            i = 0,
            _ = 1e3;

        for (o = 0; o <= _; ++o) {
          i += s3_func_x(a = t + o * (n - t) / _, e);
        }

        return (_ + 1) / (i * (n - t));
      }

      function s3_func(e) {
        var t, n, a, r;
        return t = e, n = (t *= t >= 0 ? 3 : 1.5) >= .5 && t <= 2.5 ? 8 * ((r = t - .5) * r - 2 * r) : 0, (a = 15.811389 + 7.5 * (t += .474) - 17.5 * Math.sqrt(1 + t * t)) <= -60 ? 0 : (t = Math.exp((n + a) * _), t /= .6609193);
      }

      function freq2bark(e) {
        return e < 0 && (e = 0), e *= .001, 13 * Math.atan(.76 * e) + 3.5 * Math.atan(e * e / 56.25);
      }

      function init_numline(e, t, n, a, r, s, o, i, _, l, c, f) {
        var u,
            d = new_float(Encoder.CBANDS + 1),
            h = i / (f > 15 ? 1152 : 384),
            p = new_int(Encoder.HBLKSIZE);
        i /= _;
        var m = 0,
            b = 0;

        for (u = 0; u < Encoder.CBANDS; u++) {
          var v;

          for (A = freq2bark(i * m), d[u] = i * m, v = m; freq2bark(i * v) - A < .34 && v <= _ / 2; v++) {
          }

          for (e[u] = v - m, b = u + 1; m < v;) {
            p[m++] = u;
          }

          if (m > _ / 2) {
            m = _ / 2, ++u;
            break;
          }
        }

        d[u] = i * m;

        for (var g = 0; g < f; g++) {
          var w, E, S, M, y;
          S = l[g], M = l[g + 1], (w = 0 | Math.floor(.5 + c * (S - .5))) < 0 && (w = 0), (E = 0 | Math.floor(.5 + c * (M - .5))) > _ / 2 && (E = _ / 2), n[g] = (p[w] + p[E]) / 2, t[g] = p[E];
          var B = h * M;
          o[g] = (B - d[t[g]]) / (d[t[g] + 1] - d[t[g]]), o[g] < 0 ? o[g] = 0 : o[g] > 1 && (o[g] = 1), y = freq2bark(i * l[g] * c), y = Math.min(y, 15.5) / 15.5, s[g] = Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * y)) - 2.5);
        }

        m = 0;

        for (var R = 0; R < b; R++) {
          var A,
              T,
              k = e[R];
          A = freq2bark(i * m), T = freq2bark(i * (m + k - 1)), a[R] = .5 * (A + T), A = freq2bark(i * (m - .5)), T = freq2bark(i * (m + k - .5)), r[R] = T - A, m += k;
        }

        return b;
      }

      function init_s3_values(e, t, n, a, r, s) {
        var o,
            i = new_float_n([Encoder.CBANDS, Encoder.CBANDS]),
            _ = 0;
        if (s) for (var l = 0; l < t; l++) {
          for (o = 0; o < t; o++) {
            var c = s3_func(n[l] - n[o]) * a[o];
            i[l][o] = c * r[l];
          }
        } else for (o = 0; o < t; o++) {
          var f = 15 + Math.min(21 / n[o], 12),
              u = norm_s3_func_x(f);

          for (l = 0; l < t; l++) {
            c = u * s3_func_x(n[l] - n[o], f) * a[o];
            i[l][o] = c * r[l];
          }
        }

        for (l = 0; l < t; l++) {
          for (o = 0; o < t && !(i[l][o] > 0); o++) {
          }

          for (e[l][0] = o, o = t - 1; o > 0 && !(i[l][o] > 0); o--) {
          }

          e[l][1] = o, _ += e[l][1] - e[l][0] + 1;
        }

        var d = new_float(_),
            h = 0;

        for (l = 0; l < t; l++) {
          for (o = e[l][0]; o <= e[l][1]; o++) {
            d[h++] = i[l][o];
          }
        }

        return d;
      }

      function stereo_demask(e) {
        var t = freq2bark(e);
        return t = Math.min(t, 15.5) / 15.5, Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * t)) - 2.5);
      }

      function ATHformula_GB(e, t) {
        return e < -.3 && (e = 3410), e /= 1e3, e = Math.max(.1, e), 3.64 * Math.pow(e, -.8) - 6.8 * Math.exp(-.6 * Math.pow(e - 3.4, 2)) + 6 * Math.exp(-.15 * Math.pow(e - 8.7, 2)) + .001 * (.6 + .04 * t) * Math.pow(e, 4);
      }

      this.L3psycho_anal_vbr = function (e, t, n, a, r, s, o, _, l, c) {
        var f = e.internal_flags,
            u = new_float(Encoder.HBLKSIZE),
            d = new_float_n([3, Encoder.HBLKSIZE_s]),
            h = new_float_n([2, Encoder.BLKSIZE]),
            p = new_float_n([2, 3, Encoder.BLKSIZE_s]),
            m = new_float_n([4, Encoder.CBANDS]),
            b = new_float_n([4, Encoder.CBANDS]),
            v = new_float_n([4, 3]),
            g = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]],
            E = new_int(2),
            S = e.mode == MPEGMode.JOINT_STEREO ? 4 : f.channels_out;
        !function vbrpsy_attack_detection(e, t, n, a, r, s, o, _, l, c) {
          for (var f = new_float_n([2, 576]), u = e.internal_flags, d = u.channels_out, h = e.mode == MPEGMode.JOINT_STEREO ? 4 : d, p = 0; p < d; p++) {
            firbuf = t[p];

            for (var m = n + 576 - 350 - i + 192, b = 0; b < 576; b++) {
              var v, g;
              v = firbuf[m + b + 10], g = 0;

              for (var E = 0; E < 9; E += 2) {
                v += w[E] * (firbuf[m + b + E] + firbuf[m + b + i - E]), g += w[E + 1] * (firbuf[m + b + E + 1] + firbuf[m + b + i - E - 1]);
              }

              f[p][b] = v + g;
            }

            r[a][p].en.assign(u.en[p]), r[a][p].thm.assign(u.thm[p]), h > 2 && (s[a][p].en.assign(u.en[p + 2]), s[a][p].thm.assign(u.thm[p + 2]));
          }

          for (p = 0; p < h; p++) {
            var S = new_float(12),
                M = new_float(12),
                y = [0, 0, 0, 0],
                B = f[1 & p],
                R = 0,
                A = 3 == p ? u.nsPsy.attackthre_s : u.nsPsy.attackthre,
                T = 1;
            if (2 == p) for (b = 0, E = 576; E > 0; ++b, --E) {
              var k = f[0][b],
                  x = f[1][b];
              f[0][b] = k + x, f[1][b] = k - x;
            }

            for (b = 0; b < 3; b++) {
              M[b] = u.nsPsy.last_en_subshort[p][b + 6], S[b] = M[b] / u.nsPsy.last_en_subshort[p][b + 4], y[0] += M[b];
            }

            for (b = 0; b < 9; b++) {
              for (var P = R + 64, I = 1; R < P; R++) {
                I < Math.abs(B[R]) && (I = Math.abs(B[R]));
              }

              u.nsPsy.last_en_subshort[p][b] = M[b + 3] = I, y[1 + b / 3] += I, I > M[b + 3 - 2] ? I /= M[b + 3 - 2] : I = M[b + 3 - 2] > 10 * I ? M[b + 3 - 2] / (10 * I) : 0, S[b + 3] = I;
            }

            for (b = 0; b < 3; ++b) {
              var L = M[3 * b + 3] + M[3 * b + 4] + M[3 * b + 5],
                  V = 1;
              6 * M[3 * b + 5] < L && (V *= .5, 6 * M[3 * b + 4] < L && (V *= .5)), _[p][b] = V;
            }

            if (e.analysis) {
              var H = S[0];

              for (b = 1; b < 12; b++) {
                H < S[b] && (H = S[b]);
              }

              u.pinfo.ers[a][p] = u.pinfo.ers_save[p], u.pinfo.ers_save[p] = H;
            }

            for (b = 0; b < 12; b++) {
              0 == l[p][b / 3] && S[b] > A && (l[p][b / 3] = b % 3 + 1);
            }

            for (b = 1; b < 4; b++) {
              var C = y[b - 1],
                  N = y[b];
              Math.max(C, N) < 4e4 && C < 1.7 * N && N < 1.7 * C && (1 == b && l[p][0] <= l[p][b] && (l[p][0] = 0), l[p][b] = 0);
            }

            l[p][0] <= u.nsPsy.lastAttacks[p] && (l[p][0] = 0), 3 != u.nsPsy.lastAttacks[p] && l[p][0] + l[p][1] + l[p][2] + l[p][3] == 0 || (T = 0, 0 != l[p][1] && 0 != l[p][0] && (l[p][1] = 0), 0 != l[p][2] && 0 != l[p][1] && (l[p][2] = 0), 0 != l[p][3] && 0 != l[p][2] && (l[p][3] = 0)), p < 2 ? c[p] = T : 0 == T && (c[0] = c[1] = 0), o[p] = u.tot_ener[p];
          }
        }(e, t, n, a, r, s, l, v, g, E), function vbrpsy_compute_block_type(e, t) {
          var n = e.internal_flags;
          e.short_blocks != ShortBlock.short_block_coupled || 0 != t[0] && 0 != t[1] || (t[0] = t[1] = 0);

          for (var a = 0; a < n.channels_out; a++) {
            e.short_blocks == ShortBlock.short_block_dispensed && (t[a] = 1), e.short_blocks == ShortBlock.short_block_forced && (t[a] = 0);
          }
        }(e, E);

        for (var M = 0; M < S; M++) {
          vbrpsy_compute_fft_l(e, t, n, M, a, u, h, B = 1 & M), vbrpsy_compute_loudness_approximation_l(e, a, M, u), 0 != E[B] ? vbrpsy_compute_masking_l(f, u, m[M], b[M], M) : vbrpsy_skip_masking_l(f, M);
        }

        E[0] + E[1] == 2 && e.mode == MPEGMode.JOINT_STEREO && vbrpsy_compute_MS_thresholds(m, b, f.mld_cb_l, f.ATH.cb_l, e.ATHlower * f.ATH.adjust, e.msfix, f.npart_l);

        for (M = 0; M < S; M++) {
          0 != E[B = 1 & M] && convert_partition2scalefac_l(f, m[M], b[M], M);
        }

        for (var y = 0; y < 3; y++) {
          for (M = 0; M < S; ++M) {
            0 != E[B = 1 & M] ? vbrpsy_skip_masking_s(f, M, y) : (vbrpsy_compute_fft_s(e, t, n, M, y, d, p, B), vbrpsy_compute_masking_s(e, d, m[M], b[M], M, y));
          }

          E[0] + E[1] == 0 && e.mode == MPEGMode.JOINT_STEREO && vbrpsy_compute_MS_thresholds(m, b, f.mld_cb_s, f.ATH.cb_s, e.ATHlower * f.ATH.adjust, e.msfix, f.npart_s);

          for (M = 0; M < S; ++M) {
            0 == E[B = 1 & M] && convert_partition2scalefac_s(f, m[M], b[M], M, y);
          }
        }

        for (M = 0; M < S; M++) {
          var B;
          if (0 == E[B = 1 & M]) for (var R = 0; R < Encoder.SBMAX_s; R++) {
            var A = new_float(3);

            for (y = 0; y < 3; y++) {
              var T = f.thm[M].s[R][y];

              if (T *= .8, g[M][y] >= 2 || 1 == g[M][y + 1]) {
                var k = 0 != y ? y - 1 : 2,
                    x = NS_INTERP(f.thm[M].s[R][k], T, .36);
                T = Math.min(T, x);
              } else if (1 == g[M][y]) {
                k = 0 != y ? y - 1 : 2, x = NS_INTERP(f.thm[M].s[R][k], T, .18);
                T = Math.min(T, x);
              } else if (0 != y && 3 == g[M][y - 1] || 0 == y && 3 == f.nsPsy.lastAttacks[M]) {
                k = 2 != y ? y + 1 : 0, x = NS_INTERP(f.thm[M].s[R][k], T, .18);
                T = Math.min(T, x);
              }

              T *= v[M][y], A[y] = T;
            }

            for (y = 0; y < 3; y++) {
              f.thm[M].s[R][y] = A[y];
            }
          }
        }

        for (M = 0; M < S; M++) {
          f.nsPsy.lastAttacks[M] = g[M][2];
        }

        !function vbrpsy_apply_block_type(e, t, n) {
          for (var a = e.internal_flags, r = 0; r < a.channels_out; r++) {
            var s = Encoder.NORM_TYPE;
            0 != t[r] ? a.blocktype_old[r] == Encoder.SHORT_TYPE && (s = Encoder.STOP_TYPE) : (s = Encoder.SHORT_TYPE, a.blocktype_old[r] == Encoder.NORM_TYPE && (a.blocktype_old[r] = Encoder.START_TYPE), a.blocktype_old[r] == Encoder.STOP_TYPE && (a.blocktype_old[r] = Encoder.SHORT_TYPE)), n[r] = a.blocktype_old[r], a.blocktype_old[r] = s;
          }
        }(e, E, c);

        for (M = 0; M < S; M++) {
          var P, I, L, V;
          M > 1 ? (P = _, I = -2, L = Encoder.NORM_TYPE, c[0] != Encoder.SHORT_TYPE && c[1] != Encoder.SHORT_TYPE || (L = Encoder.SHORT_TYPE), V = s[a][M - 2]) : (P = o, I = 0, L = c[M], V = r[a][M]), L == Encoder.SHORT_TYPE ? P[I + M] = pecalc_s(V, f.masking_lower) : P[I + M] = pecalc_l(V, f.masking_lower), e.analysis && (f.pinfo.pe[a][M] = P[I + M]);
        }

        return 0;
      }, this.psymodel_init = function (e) {
        var n,
            s = e.internal_flags,
            o = !0,
            i = 13,
            _ = 24,
            u = 0,
            d = 0,
            h = -8.25,
            p = -4.5,
            m = new_float(Encoder.CBANDS),
            b = new_float(Encoder.CBANDS),
            v = new_float(Encoder.CBANDS),
            g = e.out_samplerate;

        switch (e.experimentalZ) {
          default:
            o = !0;
            break;

          case 1:
            o = e.VBR != VbrMode.vbr_mtrh && e.VBR != VbrMode.vbr_mt;
            break;

          case 2:
            o = !1;
            break;

          case 3:
            i = 8, u = -1.75, d = -.0125, h = -8.25, p = -2.25;
        }

        for (s.ms_ener_ratio_old = .25, s.blocktype_old[0] = s.blocktype_old[1] = Encoder.NORM_TYPE, n = 0; n < 4; ++n) {
          for (var w = 0; w < Encoder.CBANDS; ++w) {
            s.nb_1[n][w] = 1e20, s.nb_2[n][w] = 1e20, s.nb_s1[n][w] = s.nb_s2[n][w] = 1;
          }

          for (var E = 0; E < Encoder.SBMAX_l; E++) {
            s.en[n].l[E] = 1e20, s.thm[n].l[E] = 1e20;
          }

          for (w = 0; w < 3; ++w) {
            for (E = 0; E < Encoder.SBMAX_s; E++) {
              s.en[n].s[E][w] = 1e20, s.thm[n].s[E][w] = 1e20;
            }

            s.nsPsy.lastAttacks[n] = 0;
          }

          for (w = 0; w < 9; w++) {
            s.nsPsy.last_en_subshort[n][w] = 10;
          }
        }

        for (s.loudness_sq_save[0] = s.loudness_sq_save[1] = 0, s.npart_l = init_numline(s.numlines_l, s.bo_l, s.bm_l, m, b, s.mld_l, s.PSY.bo_l_weight, g, Encoder.BLKSIZE, s.scalefac_band.l, Encoder.BLKSIZE / 1152, Encoder.SBMAX_l), n = 0; n < s.npart_l; n++) {
          var S = u;
          m[n] >= i && (S = d * (m[n] - i) / (_ - i) + u * (_ - m[n]) / (_ - i)), v[n] = Math.pow(10, S / 10), s.numlines_l[n] > 0 ? s.rnumlines_l[n] = 1 / s.numlines_l[n] : s.rnumlines_l[n] = 0;
        }

        s.s3_ll = init_s3_values(s.s3ind, s.npart_l, m, b, v, o);
        var M;
        w = 0;

        for (n = 0; n < s.npart_l; n++) {
          R = a.MAX_VALUE;

          for (var y = 0; y < s.numlines_l[n]; y++, w++) {
            var B = g * w / (1e3 * Encoder.BLKSIZE);
            A = this.ATHformula(1e3 * B, e) - 20, A = Math.pow(10, .1 * A), R > (A *= s.numlines_l[n]) && (R = A);
          }

          s.ATH.cb_l[n] = R, (R = 20 * m[n] / 10 - 20) > 6 && (R = 100), R < -15 && (R = -15), R -= 8, s.minval_l[n] = Math.pow(10, R / 10) * s.numlines_l[n];
        }

        for (s.npart_s = init_numline(s.numlines_s, s.bo_s, s.bm_s, m, b, s.mld_s, s.PSY.bo_s_weight, g, Encoder.BLKSIZE_s, s.scalefac_band.s, Encoder.BLKSIZE_s / 384, Encoder.SBMAX_s), w = 0, n = 0; n < s.npart_s; n++) {
          var R;
          S = h;
          m[n] >= i && (S = p * (m[n] - i) / (_ - i) + h * (_ - m[n]) / (_ - i)), v[n] = Math.pow(10, S / 10), R = a.MAX_VALUE;

          for (y = 0; y < s.numlines_s[n]; y++, w++) {
            var A;
            B = g * w / (1e3 * Encoder.BLKSIZE_s);
            A = this.ATHformula(1e3 * B, e) - 20, A = Math.pow(10, .1 * A), R > (A *= s.numlines_s[n]) && (R = A);
          }

          s.ATH.cb_s[n] = R, R = 7 * m[n] / 12 - 7, m[n] > 12 && (R *= 1 + 3.1 * Math.log(1 + R)), m[n] < 12 && (R *= 1 + 2.3 * Math.log(1 - R)), R < -15 && (R = -15), R -= 8, s.minval_s[n] = Math.pow(10, R / 10) * s.numlines_s[n];
        }

        s.s3_ss = init_s3_values(s.s3ind_s, s.npart_s, m, b, v, o), function init_mask_add_max_values() {
          l = Math.pow(10, 9 / 16), c = Math.pow(10, 1.5), f = Math.pow(10, 1.5);
        }(), t.init_fft(s), s.decay = Math.exp(-1 * r / (.01 * g / 192)), M = 3.5, 0 != (2 & e.exp_nspsytune) && (M = 1), Math.abs(e.msfix) > 0 && (M = e.msfix), e.msfix = M;

        for (var T = 0; T < s.npart_l; T++) {
          s.s3ind[T][1] > s.npart_l - 1 && (s.s3ind[T][1] = s.npart_l - 1);
        }

        var k = 576 * s.mode_gr / g;

        if (s.ATH.decay = Math.pow(10, -1.2 * k), s.ATH.adjust = .01, s.ATH.adjustLimit = 1, -1 != e.ATHtype) {
          var x = e.out_samplerate / Encoder.BLKSIZE,
              P = 0;

          for (B = 0, n = 0; n < Encoder.BLKSIZE / 2; ++n) {
            B += x, s.ATH.eql_w[n] = 1 / Math.pow(10, this.ATHformula(B, e) / 10), P += s.ATH.eql_w[n];
          }

          for (P = 1 / P, n = Encoder.BLKSIZE / 2; --n >= 0;) {
            s.ATH.eql_w[n] *= P;
          }
        }

        for (T = w = 0; T < s.npart_s; ++T) {
          for (n = 0; n < s.numlines_s[T]; ++n) {
            ++w;
          }
        }

        for (T = w = 0; T < s.npart_l; ++T) {
          for (n = 0; n < s.numlines_l[T]; ++n) {
            ++w;
          }
        }

        for (w = 0, n = 0; n < s.npart_l; n++) {
          B = g * (w + s.numlines_l[n] / 2) / (1 * Encoder.BLKSIZE);
          s.mld_cb_l[n] = stereo_demask(B), w += s.numlines_l[n];
        }

        for (; n < Encoder.CBANDS; ++n) {
          s.mld_cb_l[n] = 1;
        }

        for (w = 0, n = 0; n < s.npart_s; n++) {
          B = g * (w + s.numlines_s[n] / 2) / (1 * Encoder.BLKSIZE_s);
          s.mld_cb_s[n] = stereo_demask(B), w += s.numlines_s[n];
        }

        for (; n < Encoder.CBANDS; ++n) {
          s.mld_cb_s[n] = 1;
        }

        return 0;
      }, this.ATHformula = function (e, t) {
        var n;

        switch (t.ATHtype) {
          case 0:
            n = ATHformula_GB(e, 9);
            break;

          case 1:
            n = ATHformula_GB(e, -1);
            break;

          case 2:
            n = ATHformula_GB(e, 0);
            break;

          case 3:
            n = ATHformula_GB(e, 1) + 6;
            break;

          case 4:
            n = ATHformula_GB(e, t.ATHcurve);
            break;

          default:
            n = ATHformula_GB(e, 0);
        }

        return n;
      };
    }

    function Lame() {
      var e = this;
      Lame.V9 = 410, Lame.V8 = 420, Lame.V7 = 430, Lame.V6 = 440, Lame.V5 = 450, Lame.V4 = 460, Lame.V3 = 470, Lame.V2 = 480, Lame.V1 = 490, Lame.V0 = 500, Lame.R3MIX = 1e3, Lame.STANDARD = 1001, Lame.EXTREME = 1002, Lame.INSANE = 1003, Lame.STANDARD_FAST = 1004, Lame.EXTREME_FAST = 1005, Lame.MEDIUM = 1006, Lame.MEDIUM_FAST = 1007;
      var n, a, s, o, i;
      Lame.LAME_MAXMP3BUFFER = 147456;

      var _,
          l,
          c,
          f = new PsyModel();

      function PSY() {
        this.mask_adjust = 0, this.mask_adjust_short = 0, this.bo_l_weight = new_float(Encoder.SBMAX_l), this.bo_s_weight = new_float(Encoder.SBMAX_s);
      }

      function LowPassHighPass() {
        this.lowerlimit = 0;
      }

      function BandPass(e, t) {
        this.lowpass = t;
      }

      this.enc = new Encoder(), this.setModules = function (e, t, r, u, d, h, p, m, b) {
        n = e, a = t, s = r, o = u, i = d, _ = h, l = m, c = b, this.enc.setModules(a, f, o, _);
      };
      var u = 4294479419;

      function filter_coef(e) {
        return e > 1 ? 0 : e <= 0 ? 1 : Math.cos(Math.PI / 2 * e);
      }

      function SmpFrqIndex(e, t) {
        switch (e) {
          case 44100:
            return t.version = 1, 0;

          case 48e3:
            return t.version = 1, 1;

          case 32e3:
            return t.version = 1, 2;

          case 22050:
            return t.version = 0, 0;

          case 24e3:
            return t.version = 0, 1;

          case 16e3:
            return t.version = 0, 2;

          case 11025:
            return t.version = 0, 0;

          case 12e3:
            return t.version = 0, 1;

          case 8e3:
            return t.version = 0, 2;

          default:
            return t.version = 0, -1;
        }
      }

      function FindNearestBitrate(e, t, n) {
        n < 16e3 && (t = 2);

        for (var a = r.bitrate_table[t][1], s = 2; s <= 14; s++) {
          r.bitrate_table[t][s] > 0 && Math.abs(r.bitrate_table[t][s] - e) < Math.abs(a - e) && (a = r.bitrate_table[t][s]);
        }

        return a;
      }

      function BitrateIndex(e, t, n) {
        n < 16e3 && (t = 2);

        for (var a = 0; a <= 14; a++) {
          if (r.bitrate_table[t][a] > 0 && r.bitrate_table[t][a] == e) return a;
        }

        return -1;
      }

      function optimum_bandwidth(t, n) {
        var a = [new BandPass(8, 2e3), new BandPass(16, 3700), new BandPass(24, 3900), new BandPass(32, 5500), new BandPass(40, 7e3), new BandPass(48, 7500), new BandPass(56, 1e4), new BandPass(64, 11e3), new BandPass(80, 13500), new BandPass(96, 15100), new BandPass(112, 15600), new BandPass(128, 17e3), new BandPass(160, 17500), new BandPass(192, 18600), new BandPass(224, 19400), new BandPass(256, 19700), new BandPass(320, 20500)],
            r = e.nearestBitrateFullIndex(n);
        t.lowerlimit = a[r].lowpass;
      }

      function calcNeeded(e) {
        var t = Encoder.BLKSIZE + e.framesize - Encoder.FFTOFFSET;
        return t = Math.max(t, 512 + e.framesize - 32);
      }

      function lame_encode_frame(t, n, a, r, s, o) {
        var i = e.enc.lame_encode_mp3_frame(t, n, a, r, s, o);
        return t.frameNum++, i;
      }

      function InOut() {
        this.n_in = 0, this.n_out = 0;
      }

      function NumUsed() {
        this.num_used = 0;
      }

      function gcd(e, t) {
        return 0 != t ? gcd(t, e % t) : e;
      }

      function blackman(e, t, n) {
        var a = Math.PI * t;
        (e /= n) < 0 && (e = 0), e > 1 && (e = 1);
        var r = e - .5,
            s = .42 - .5 * Math.cos(2 * e * Math.PI) + .08 * Math.cos(4 * e * Math.PI);
        return Math.abs(r) < 1e-9 ? a / Math.PI : s * Math.sin(n * a * r) / (Math.PI * n * r);
      }

      function fill_buffer_resample(e, t, n, a, r, s, o, i, _) {
        var l,
            c,
            f = e.internal_flags,
            u = 0,
            d = e.out_samplerate / gcd(e.out_samplerate, e.in_samplerate);
        d > LameInternalFlags.BPC && (d = LameInternalFlags.BPC);
        var h = Math.abs(f.resample_ratio - Math.floor(.5 + f.resample_ratio)) < 1e-4 ? 1 : 0,
            p = 1 / f.resample_ratio;
        p > 1 && (p = 1);
        var m = 31;
        0 == m % 2 && --m;
        var b = (m += h) + 1;

        if (0 == f.fill_buffer_resample_init) {
          for (f.inbuf_old[0] = new_float(b), f.inbuf_old[1] = new_float(b), l = 0; l <= 2 * d; ++l) {
            f.blackfilt[l] = new_float(b);
          }

          for (f.itime[0] = 0, f.itime[1] = 0, u = 0; u <= 2 * d; u++) {
            var v = 0,
                g = (u - d) / (2 * d);

            for (l = 0; l <= m; l++) {
              v += f.blackfilt[u][l] = blackman(l - g, p, m);
            }

            for (l = 0; l <= m; l++) {
              f.blackfilt[u][l] /= v;
            }
          }

          f.fill_buffer_resample_init = 1;
        }

        var w = f.inbuf_old[_];

        for (c = 0; c < a; c++) {
          var E, S;
          if (E = c * f.resample_ratio, m + (u = 0 | Math.floor(E - f.itime[_])) - m / 2 >= o) break;
          g = E - f.itime[_] - (u + m % 2 * .5);
          S = 0 | Math.floor(2 * g * d + d + .5);
          var M = 0;

          for (l = 0; l <= m; ++l) {
            var y = l + u - m / 2;
            M += (y < 0 ? w[b + y] : r[s + y]) * f.blackfilt[S][l];
          }

          t[n + c] = M;
        }

        if (i.num_used = Math.min(o, m + u - m / 2), f.itime[_] += i.num_used - c * f.resample_ratio, i.num_used >= b) for (l = 0; l < b; l++) {
          w[l] = r[s + i.num_used + l - b];
        } else {
          var B = b - i.num_used;

          for (l = 0; l < B; ++l) {
            w[l] = w[l + i.num_used];
          }

          for (u = 0; l < b; ++l, ++u) {
            w[l] = r[s + u];
          }
        }
        return c;
      }

      function fill_buffer(e, t, n, a, r, s) {
        var o = e.internal_flags;
        if (o.resample_ratio < .9999 || o.resample_ratio > 1.0001) for (var i = 0; i < o.channels_out; i++) {
          var _ = new NumUsed();

          s.n_out = fill_buffer_resample(e, t[i], o.mf_size, e.framesize, n[i], a, r, _, i), s.n_in = _.num_used;
        } else {
          s.n_out = Math.min(e.framesize, r), s.n_in = s.n_out;

          for (var l = 0; l < s.n_out; ++l) {
            t[0][o.mf_size + l] = n[0][a + l], 2 == o.channels_out && (t[1][o.mf_size + l] = n[1][a + l]);
          }
        }
      }

      this.lame_init = function () {
        var e = new LameGlobalFlags();
        return function lame_init_old(e) {
          var t;
          return e.class_id = u, t = e.internal_flags = new LameInternalFlags(), e.mode = MPEGMode.NOT_SET, e.original = 1, e.in_samplerate = 44100, e.num_channels = 2, e.num_samples = -1, e.bWriteVbrTag = !0, e.quality = -1, e.short_blocks = null, t.subblock_gain = -1, e.lowpassfreq = 0, e.highpassfreq = 0, e.lowpasswidth = -1, e.highpasswidth = -1, e.VBR = VbrMode.vbr_off, e.VBR_q = 4, e.ATHcurve = -1, e.VBR_mean_bitrate_kbps = 128, e.VBR_min_bitrate_kbps = 0, e.VBR_max_bitrate_kbps = 0, e.VBR_hard_min = 0, t.VBR_min_bitrate = 1, t.VBR_max_bitrate = 13, e.quant_comp = -1, e.quant_comp_short = -1, e.msfix = -1, t.resample_ratio = 1, t.OldValue[0] = 180, t.OldValue[1] = 180, t.CurrentStep[0] = 4, t.CurrentStep[1] = 4, t.masking_lower = 1, t.nsPsy.attackthre = -1, t.nsPsy.attackthre_s = -1, e.scale = -1, e.athaa_type = -1, e.ATHtype = -1, e.athaa_loudapprox = -1, e.athaa_sensitivity = 0, e.useTemporal = null, e.interChRatio = -1, t.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY, e.encoder_padding = 0, t.mf_size = Encoder.ENCDELAY - Encoder.MDCTDELAY, e.findReplayGain = !1, e.decode_on_the_fly = !1, t.decode_on_the_fly = !1, t.findReplayGain = !1, t.findPeakSample = !1, t.RadioGain = 0, t.AudiophileGain = 0, t.noclipGainChange = 0, t.noclipScale = -1, e.preset = 0, e.write_id3tag_automatic = !0, 0;
        }(e), e.lame_allocated_gfp = 1, e;
      }, this.nearestBitrateFullIndex = function (e) {
        var t = [8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320],
            n = 0,
            a = 0,
            r = 0,
            s = 0;
        s = t[16], r = 16, a = t[16], n = 16;

        for (var o = 0; o < 16; o++) {
          if (Math.max(e, t[o + 1]) != e) {
            s = t[o + 1], r = o + 1, a = t[o], n = o;
            break;
          }
        }

        return s - e > e - a ? n : r;
      }, this.lame_init_params = function (e) {
        var d = e.internal_flags;

        if (d.Class_ID = 0, null == d.ATH && (d.ATH = new ATH()), null == d.PSY && (d.PSY = new PSY()), null == d.rgdata && (d.rgdata = new ReplayGain()), d.channels_in = e.num_channels, 1 == d.channels_in && (e.mode = MPEGMode.MONO), d.channels_out = e.mode == MPEGMode.MONO ? 1 : 2, d.mode_ext = Encoder.MPG_MD_MS_LR, e.mode == MPEGMode.MONO && (e.force_ms = !1), e.VBR == VbrMode.vbr_off && 128 != e.VBR_mean_bitrate_kbps && 0 == e.brate && (e.brate = e.VBR_mean_bitrate_kbps), e.VBR == VbrMode.vbr_off || e.VBR == VbrMode.vbr_mtrh || e.VBR == VbrMode.vbr_mt || (e.free_format = !1), e.VBR == VbrMode.vbr_off && 0 == e.brate && BitStream.EQ(e.compression_ratio, 0) && (e.compression_ratio = 11.025), e.VBR == VbrMode.vbr_off && e.compression_ratio > 0 && (0 == e.out_samplerate && (e.out_samplerate = map2MP3Frequency(int(.97 * e.in_samplerate))), e.brate = 0 | 16 * e.out_samplerate * d.channels_out / (1e3 * e.compression_ratio), d.samplerate_index = SmpFrqIndex(e.out_samplerate, e), e.free_format || (e.brate = FindNearestBitrate(e.brate, e.version, e.out_samplerate))), 0 != e.out_samplerate && (e.out_samplerate < 16e3 ? (e.VBR_mean_bitrate_kbps = Math.max(e.VBR_mean_bitrate_kbps, 8), e.VBR_mean_bitrate_kbps = Math.min(e.VBR_mean_bitrate_kbps, 64)) : e.out_samplerate < 32e3 ? (e.VBR_mean_bitrate_kbps = Math.max(e.VBR_mean_bitrate_kbps, 8), e.VBR_mean_bitrate_kbps = Math.min(e.VBR_mean_bitrate_kbps, 160)) : (e.VBR_mean_bitrate_kbps = Math.max(e.VBR_mean_bitrate_kbps, 32), e.VBR_mean_bitrate_kbps = Math.min(e.VBR_mean_bitrate_kbps, 320))), 0 == e.lowpassfreq) {
          var h = 16e3;

          switch (e.VBR) {
            case VbrMode.vbr_off:
              optimum_bandwidth(p = new LowPassHighPass(), e.brate), h = p.lowerlimit;
              break;

            case VbrMode.vbr_abr:
              var p;
              optimum_bandwidth(p = new LowPassHighPass(), e.VBR_mean_bitrate_kbps), h = p.lowerlimit;
              break;

            case VbrMode.vbr_rh:
              var m = [19500, 19e3, 18600, 18e3, 17500, 16e3, 15600, 14900, 12500, 1e4, 3950];

              if (0 <= e.VBR_q && e.VBR_q <= 9) {
                var b = m[e.VBR_q],
                    v = m[e.VBR_q + 1],
                    g = e.VBR_q_frac;
                h = linear_int(b, v, g);
              } else h = 19500;

              break;

            default:
              m = [19500, 19e3, 18500, 18e3, 17500, 16500, 15500, 14500, 12500, 9500, 3950];

              if (0 <= e.VBR_q && e.VBR_q <= 9) {
                b = m[e.VBR_q], v = m[e.VBR_q + 1], g = e.VBR_q_frac;
                h = linear_int(b, v, g);
              } else h = 19500;

          }

          e.mode != MPEGMode.MONO || e.VBR != VbrMode.vbr_off && e.VBR != VbrMode.vbr_abr || (h *= 1.5), e.lowpassfreq = 0 | h;
        }

        if (0 == e.out_samplerate && (2 * e.lowpassfreq > e.in_samplerate && (e.lowpassfreq = e.in_samplerate / 2), e.out_samplerate = function optimum_samplefreq(e, t) {
          var n = 44100;
          return t >= 48e3 ? n = 48e3 : t >= 44100 ? n = 44100 : t >= 32e3 ? n = 32e3 : t >= 24e3 ? n = 24e3 : t >= 22050 ? n = 22050 : t >= 16e3 ? n = 16e3 : t >= 12e3 ? n = 12e3 : t >= 11025 ? n = 11025 : t >= 8e3 && (n = 8e3), -1 == e ? n : (e <= 15960 && (n = 44100), e <= 15250 && (n = 32e3), e <= 11220 && (n = 24e3), e <= 9970 && (n = 22050), e <= 7230 && (n = 16e3), e <= 5420 && (n = 12e3), e <= 4510 && (n = 11025), e <= 3970 && (n = 8e3), t < n ? t > 44100 ? 48e3 : t > 32e3 ? 44100 : t > 24e3 ? 32e3 : t > 22050 ? 24e3 : t > 16e3 ? 22050 : t > 12e3 ? 16e3 : t > 11025 ? 12e3 : t > 8e3 ? 11025 : 8e3 : n);
        }(0 | e.lowpassfreq, e.in_samplerate)), e.lowpassfreq = Math.min(20500, e.lowpassfreq), e.lowpassfreq = Math.min(e.out_samplerate / 2, e.lowpassfreq), e.VBR == VbrMode.vbr_off && (e.compression_ratio = 16 * e.out_samplerate * d.channels_out / (1e3 * e.brate)), e.VBR == VbrMode.vbr_abr && (e.compression_ratio = 16 * e.out_samplerate * d.channels_out / (1e3 * e.VBR_mean_bitrate_kbps)), e.bWriteVbrTag || (e.findReplayGain = !1, e.decode_on_the_fly = !1, d.findPeakSample = !1), d.findReplayGain = e.findReplayGain, d.decode_on_the_fly = e.decode_on_the_fly, d.decode_on_the_fly && (d.findPeakSample = !0), d.findReplayGain && n.InitGainAnalysis(d.rgdata, e.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) return e.internal_flags = null, -6;

        switch (d.decode_on_the_fly && !e.decode_only && (null != d.hip && c.hip_decode_exit(d.hip), d.hip = c.hip_decode_init()), d.mode_gr = e.out_samplerate <= 24e3 ? 1 : 2, e.framesize = 576 * d.mode_gr, e.encoder_delay = Encoder.ENCDELAY, d.resample_ratio = e.in_samplerate / e.out_samplerate, e.VBR) {
          case VbrMode.vbr_mt:
          case VbrMode.vbr_rh:
          case VbrMode.vbr_mtrh:
            e.compression_ratio = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14, 15, 16.5][e.VBR_q];
            break;

          case VbrMode.vbr_abr:
            e.compression_ratio = 16 * e.out_samplerate * d.channels_out / (1e3 * e.VBR_mean_bitrate_kbps);
            break;

          default:
            e.compression_ratio = 16 * e.out_samplerate * d.channels_out / (1e3 * e.brate);
        }

        if (e.mode == MPEGMode.NOT_SET && (e.mode = MPEGMode.JOINT_STEREO), e.highpassfreq > 0 ? (d.highpass1 = 2 * e.highpassfreq, e.highpasswidth >= 0 ? d.highpass2 = 2 * (e.highpassfreq + e.highpasswidth) : d.highpass2 = 2 * e.highpassfreq, d.highpass1 /= e.out_samplerate, d.highpass2 /= e.out_samplerate) : (d.highpass1 = 0, d.highpass2 = 0), e.lowpassfreq > 0 ? (d.lowpass2 = 2 * e.lowpassfreq, e.lowpasswidth >= 0 ? (d.lowpass1 = 2 * (e.lowpassfreq - e.lowpasswidth), d.lowpass1 < 0 && (d.lowpass1 = 0)) : d.lowpass1 = 2 * e.lowpassfreq, d.lowpass1 /= e.out_samplerate, d.lowpass2 /= e.out_samplerate) : (d.lowpass1 = 0, d.lowpass2 = 0), function lame_init_params_ppflt(e) {
          var n = e.internal_flags,
              a = 32,
              r = -1;

          if (n.lowpass1 > 0) {
            for (var s = 999, o = 0; o <= 31; o++) {
              (c = o / 31) >= n.lowpass2 && (a = Math.min(a, o)), n.lowpass1 < c && c < n.lowpass2 && (s = Math.min(s, o));
            }

            n.lowpass1 = 999 == s ? (a - .75) / 31 : (s - .75) / 31, n.lowpass2 = a / 31;
          }

          if (n.highpass2 > 0 && n.highpass2 < .75 / 31 * .9 && (n.highpass1 = 0, n.highpass2 = 0, t.err.println("Warning: highpass filter disabled.  highpass frequency too small\n")), n.highpass2 > 0) {
            var i = -1;

            for (o = 0; o <= 31; o++) {
              (c = o / 31) <= n.highpass1 && (r = Math.max(r, o)), n.highpass1 < c && c < n.highpass2 && (i = Math.max(i, o));
            }

            n.highpass1 = r / 31, n.highpass2 = -1 == i ? (r + .75) / 31 : (i + .75) / 31;
          }

          for (o = 0; o < 32; o++) {
            var _,
                l,
                c = o / 31;

            _ = n.highpass2 > n.highpass1 ? filter_coef((n.highpass2 - c) / (n.highpass2 - n.highpass1 + 1e-20)) : 1, l = n.lowpass2 > n.lowpass1 ? filter_coef((c - n.lowpass1) / (n.lowpass2 - n.lowpass1 + 1e-20)) : 1, n.amp_filter[o] = _ * l;
          }
        }(e), d.samplerate_index = SmpFrqIndex(e.out_samplerate, e), d.samplerate_index < 0) return e.internal_flags = null, -1;

        if (e.VBR == VbrMode.vbr_off) {
          if (e.free_format) d.bitrate_index = 0;else if (e.brate = FindNearestBitrate(e.brate, e.version, e.out_samplerate), d.bitrate_index = BitrateIndex(e.brate, e.version, e.out_samplerate), d.bitrate_index <= 0) return e.internal_flags = null, -1;
        } else d.bitrate_index = 1;

        e.analysis && (e.bWriteVbrTag = !1), null != d.pinfo && (e.bWriteVbrTag = !1), a.init_bit_stream_w(d);

        for (var w, E = d.samplerate_index + 3 * e.version + 6 * (e.out_samplerate < 16e3 ? 1 : 0), S = 0; S < Encoder.SBMAX_l + 1; S++) {
          d.scalefac_band.l[S] = o.sfBandIndex[E].l[S];
        }

        for (S = 0; S < Encoder.PSFB21 + 1; S++) {
          var M = (d.scalefac_band.l[22] - d.scalefac_band.l[21]) / Encoder.PSFB21,
              y = d.scalefac_band.l[21] + S * M;
          d.scalefac_band.psfb21[S] = y;
        }

        d.scalefac_band.psfb21[Encoder.PSFB21] = 576;

        for (S = 0; S < Encoder.SBMAX_s + 1; S++) {
          d.scalefac_band.s[S] = o.sfBandIndex[E].s[S];
        }

        for (S = 0; S < Encoder.PSFB12 + 1; S++) {
          M = (d.scalefac_band.s[13] - d.scalefac_band.s[12]) / Encoder.PSFB12, y = d.scalefac_band.s[12] + S * M;
          d.scalefac_band.psfb12[S] = y;
        }

        for (d.scalefac_band.psfb12[Encoder.PSFB12] = 192, 1 == e.version ? d.sideinfo_len = 1 == d.channels_out ? 21 : 36 : d.sideinfo_len = 1 == d.channels_out ? 13 : 21, e.error_protection && (d.sideinfo_len += 2), function lame_init_bitstream(e) {
          var t = e.internal_flags;
          e.frameNum = 0, e.write_id3tag_automatic && l.id3tag_write_v2(e), t.bitrate_stereoMode_Hist = new_int_n([16, 5]), t.bitrate_blockType_Hist = new_int_n([16, 6]), t.PeakSample = 0, e.bWriteVbrTag && _.InitVbrTag(e);
        }(e), d.Class_ID = u, w = 0; w < 19; w++) {
          d.nsPsy.pefirbuf[w] = 700 * d.mode_gr * d.channels_out;
        }

        switch (-1 == e.ATHtype && (e.ATHtype = 4), e.VBR) {
          case VbrMode.vbr_mt:
            e.VBR = VbrMode.vbr_mtrh;

          case VbrMode.vbr_mtrh:
            null == e.useTemporal && (e.useTemporal = !1), s.apply_preset(e, 500 - 10 * e.VBR_q, 0), e.quality < 0 && (e.quality = LAME_DEFAULT_QUALITY), e.quality < 5 && (e.quality = 0), e.quality > 5 && (e.quality = 5), d.PSY.mask_adjust = e.maskingadjust, d.PSY.mask_adjust_short = e.maskingadjust_short, e.experimentalY ? d.sfb21_extra = !1 : d.sfb21_extra = e.out_samplerate > 44e3, d.iteration_loop = new VBRNewIterationLoop(i);
            break;

          case VbrMode.vbr_rh:
            s.apply_preset(e, 500 - 10 * e.VBR_q, 0), d.PSY.mask_adjust = e.maskingadjust, d.PSY.mask_adjust_short = e.maskingadjust_short, e.experimentalY ? d.sfb21_extra = !1 : d.sfb21_extra = e.out_samplerate > 44e3, e.quality > 6 && (e.quality = 6), e.quality < 0 && (e.quality = LAME_DEFAULT_QUALITY), d.iteration_loop = new VBROldIterationLoop(i);
            break;

          default:
            var B;
            d.sfb21_extra = !1, e.quality < 0 && (e.quality = LAME_DEFAULT_QUALITY), (B = e.VBR) == VbrMode.vbr_off && (e.VBR_mean_bitrate_kbps = e.brate), s.apply_preset(e, e.VBR_mean_bitrate_kbps, 0), e.VBR = B, d.PSY.mask_adjust = e.maskingadjust, d.PSY.mask_adjust_short = e.maskingadjust_short, B == VbrMode.vbr_off ? d.iteration_loop = new CBRNewIterationLoop(i) : d.iteration_loop = new ABRIterationLoop(i);
        }

        if (e.VBR != VbrMode.vbr_off) {
          if (d.VBR_min_bitrate = 1, d.VBR_max_bitrate = 14, e.out_samplerate < 16e3 && (d.VBR_max_bitrate = 8), 0 != e.VBR_min_bitrate_kbps && (e.VBR_min_bitrate_kbps = FindNearestBitrate(e.VBR_min_bitrate_kbps, e.version, e.out_samplerate), d.VBR_min_bitrate = BitrateIndex(e.VBR_min_bitrate_kbps, e.version, e.out_samplerate), d.VBR_min_bitrate < 0)) return -1;
          if (0 != e.VBR_max_bitrate_kbps && (e.VBR_max_bitrate_kbps = FindNearestBitrate(e.VBR_max_bitrate_kbps, e.version, e.out_samplerate), d.VBR_max_bitrate = BitrateIndex(e.VBR_max_bitrate_kbps, e.version, e.out_samplerate), d.VBR_max_bitrate < 0)) return -1;
          e.VBR_min_bitrate_kbps = r.bitrate_table[e.version][d.VBR_min_bitrate], e.VBR_max_bitrate_kbps = r.bitrate_table[e.version][d.VBR_max_bitrate], e.VBR_mean_bitrate_kbps = Math.min(r.bitrate_table[e.version][d.VBR_max_bitrate], e.VBR_mean_bitrate_kbps), e.VBR_mean_bitrate_kbps = Math.max(r.bitrate_table[e.version][d.VBR_min_bitrate], e.VBR_mean_bitrate_kbps);
        }

        return e.tune && (d.PSY.mask_adjust += e.tune_value_a, d.PSY.mask_adjust_short += e.tune_value_a), function lame_init_qval(e) {
          var t = e.internal_flags;

          switch (e.quality) {
            default:
              t.psymodel = 0, t.noise_shaping = 0, t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, t.use_best_huffman = 0, t.full_outer_loop = 0;
              break;

            case 8:
              e.quality = 7;

            case 7:
              t.psymodel = 1, t.noise_shaping = 0, t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, t.use_best_huffman = 0, t.full_outer_loop = 0;
              break;

            case 6:
            case 5:
              t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 0, t.full_outer_loop = 0;
              break;

            case 4:
              t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 0, t.noise_shaping_stop = 0, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
              break;

            case 3:
              t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), t.noise_shaping_amp = 1, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
              break;

            case 2:
              t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), 0 == t.substep_shaping && (t.substep_shaping = 2), t.noise_shaping_amp = 1, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
              break;

            case 1:
            case 0:
              t.psymodel = 1, 0 == t.noise_shaping && (t.noise_shaping = 1), 0 == t.substep_shaping && (t.substep_shaping = 2), t.noise_shaping_amp = 2, t.noise_shaping_stop = 1, -1 == t.subblock_gain && (t.subblock_gain = 1), t.use_best_huffman = 1, t.full_outer_loop = 0;
          }
        }(e), e.athaa_type < 0 ? d.ATH.useAdjust = 3 : d.ATH.useAdjust = e.athaa_type, d.ATH.aaSensitivityP = Math.pow(10, e.athaa_sensitivity / -10), null == e.short_blocks && (e.short_blocks = ShortBlock.short_block_allowed), e.short_blocks != ShortBlock.short_block_allowed || e.mode != MPEGMode.JOINT_STEREO && e.mode != MPEGMode.STEREO || (e.short_blocks = ShortBlock.short_block_coupled), e.quant_comp < 0 && (e.quant_comp = 1), e.quant_comp_short < 0 && (e.quant_comp_short = 0), e.msfix < 0 && (e.msfix = 0), e.exp_nspsytune = 1 | e.exp_nspsytune, e.internal_flags.nsPsy.attackthre < 0 && (e.internal_flags.nsPsy.attackthre = PsyModel.NSATTACKTHRE), e.internal_flags.nsPsy.attackthre_s < 0 && (e.internal_flags.nsPsy.attackthre_s = PsyModel.NSATTACKTHRE_S), e.scale < 0 && (e.scale = 1), e.ATHtype < 0 && (e.ATHtype = 4), e.ATHcurve < 0 && (e.ATHcurve = 4), e.athaa_loudapprox < 0 && (e.athaa_loudapprox = 2), e.interChRatio < 0 && (e.interChRatio = 0), null == e.useTemporal && (e.useTemporal = !0), d.slot_lag = d.frac_SpF = 0, e.VBR == VbrMode.vbr_off && (d.slot_lag = d.frac_SpF = 72e3 * (e.version + 1) * e.brate % e.out_samplerate | 0), o.iteration_init(e), f.psymodel_init(e), 0;
      }, this.lame_encode_flush = function (e, t, n, r) {
        var s,
            o,
            i,
            _,
            c = e.internal_flags,
            f = new_short_n([2, 1152]),
            u = 0,
            d = c.mf_samples_to_encode - Encoder.POSTDELAY,
            h = calcNeeded(e);

        if (c.mf_samples_to_encode < 1) return 0;

        for (s = 0, e.in_samplerate != e.out_samplerate && (d += 16 * e.out_samplerate / e.in_samplerate), (i = e.framesize - d % e.framesize) < 576 && (i += e.framesize), e.encoder_padding = i, _ = (d + i) / e.framesize; _ > 0 && u >= 0;) {
          var p = h - c.mf_size,
              m = e.frameNum;
          p *= e.in_samplerate, (p /= e.out_samplerate) > 1152 && (p = 1152), p < 1 && (p = 1), o = r - s, 0 == r && (o = 0), n += u = this.lame_encode_buffer(e, f[0], f[1], p, t, n, o), s += u, _ -= m != e.frameNum ? 1 : 0;
        }

        if (c.mf_samples_to_encode = 0, u < 0) return u;
        if (o = r - s, 0 == r && (o = 0), a.flush_bitstream(e), (u = a.copy_buffer(c, t, n, o, 1)) < 0) return u;

        if (n += u, o = r - (s += u), 0 == r && (o = 0), e.write_id3tag_automatic) {
          if (l.id3tag_write_v1(e), (u = a.copy_buffer(c, t, n, o, 0)) < 0) return u;
          s += u;
        }

        return s;
      }, this.lame_encode_buffer = function (e, t, r, s, o, i, _) {
        var l = e.internal_flags,
            c = [null, null];
        if (l.Class_ID != u) return -3;
        if (0 == s) return 0;
        !function update_inbuffer_size(e, t) {
          (null == e.in_buffer_0 || e.in_buffer_nsamples < t) && (e.in_buffer_0 = new_float(t), e.in_buffer_1 = new_float(t), e.in_buffer_nsamples = t);
        }(l, s), c[0] = l.in_buffer_0, c[1] = l.in_buffer_1;

        for (var f = 0; f < s; f++) {
          c[0][f] = t[f], l.channels_in > 1 && (c[1][f] = r[f]);
        }

        return function lame_encode_buffer_sample(e, t, r, s, o, i, _) {
          var l,
              c,
              f,
              d,
              h,
              p = e.internal_flags,
              m = 0,
              b = [null, null],
              v = [null, null];
          if (p.Class_ID != u) return -3;
          if (0 == s) return 0;
          if ((h = a.copy_buffer(p, o, i, _, 0)) < 0) return h;
          if (i += h, m += h, v[0] = t, v[1] = r, BitStream.NEQ(e.scale, 0) && BitStream.NEQ(e.scale, 1)) for (c = 0; c < s; ++c) {
            v[0][c] *= e.scale, 2 == p.channels_out && (v[1][c] *= e.scale);
          }
          if (BitStream.NEQ(e.scale_left, 0) && BitStream.NEQ(e.scale_left, 1)) for (c = 0; c < s; ++c) {
            v[0][c] *= e.scale_left;
          }
          if (BitStream.NEQ(e.scale_right, 0) && BitStream.NEQ(e.scale_right, 1)) for (c = 0; c < s; ++c) {
            v[1][c] *= e.scale_right;
          }
          if (2 == e.num_channels && 1 == p.channels_out) for (c = 0; c < s; ++c) {
            v[0][c] = .5 * (v[0][c] + v[1][c]), v[1][c] = 0;
          }
          d = calcNeeded(e), b[0] = p.mfbuf[0], b[1] = p.mfbuf[1];
          var g = 0;

          for (; s > 0;) {
            var w = [null, null],
                E = 0,
                S = 0;
            w[0] = v[0], w[1] = v[1];
            var M = new InOut();
            if (fill_buffer(e, b, w, g, s, M), E = M.n_in, S = M.n_out, p.findReplayGain && !p.decode_on_the_fly && n.AnalyzeSamples(p.rgdata, b[0], p.mf_size, b[1], p.mf_size, S, p.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;

            if (s -= E, g += E, p.channels_out, p.mf_size += S, p.mf_samples_to_encode < 1 && (p.mf_samples_to_encode = Encoder.ENCDELAY + Encoder.POSTDELAY), p.mf_samples_to_encode += S, p.mf_size >= d) {
              var y = _ - m;
              if (0 == _ && (y = 0), (l = lame_encode_frame(e, b[0], b[1], o, i, y)) < 0) return l;

              for (i += l, m += l, p.mf_size -= e.framesize, p.mf_samples_to_encode -= e.framesize, f = 0; f < p.channels_out; f++) {
                for (c = 0; c < p.mf_size; c++) {
                  b[f][c] = b[f][c + e.framesize];
                }
              }
            }
          }

          return m;
        }(e, c[0], c[1], s, o, i, _);
      };
    }

    function GetAudio() {
      this.setModules = function (e, t) {};
    }

    function Parse() {
      this.setModules = function (e, t, n) {};
    }

    function MPGLib() {}

    function ID3Tag() {
      this.setModules = function (e, t) {};
    }

    s.SFBMAX = 3 * Encoder.SBMAX_s, Encoder.ENCDELAY = 576, Encoder.POSTDELAY = 1152, Encoder.MDCTDELAY = 48, Encoder.FFTOFFSET = 224 + Encoder.MDCTDELAY, Encoder.DECDELAY = 528, Encoder.SBLIMIT = 32, Encoder.CBANDS = 64, Encoder.SBPSY_l = 21, Encoder.SBPSY_s = 12, Encoder.SBMAX_l = 22, Encoder.SBMAX_s = 13, Encoder.PSFB21 = 6, Encoder.PSFB12 = 6, Encoder.BLKSIZE = 1024, Encoder.HBLKSIZE = Encoder.BLKSIZE / 2 + 1, Encoder.BLKSIZE_s = 256, Encoder.HBLKSIZE_s = Encoder.BLKSIZE_s / 2 + 1, Encoder.NORM_TYPE = 0, Encoder.START_TYPE = 1, Encoder.SHORT_TYPE = 2, Encoder.STOP_TYPE = 3, Encoder.MPG_MD_LR_LR = 0, Encoder.MPG_MD_LR_I = 1, Encoder.MPG_MD_MS_LR = 2, Encoder.MPG_MD_MS_I = 3, Encoder.fircoef = [-.1039435, -.1892065, 5 * -.0432472, -.155915, 3898045e-23, .0467745 * 5, .50455, .756825, .187098 * 5], LameInternalFlags.MFSIZE = 3456 + Encoder.ENCDELAY - Encoder.MDCTDELAY, LameInternalFlags.MAX_HEADER_BUF = 256, LameInternalFlags.MAX_BITS_PER_CHANNEL = 4095, LameInternalFlags.MAX_BITS_PER_GRANULE = 7680, LameInternalFlags.BPC = 320, s.SFBMAX = 3 * Encoder.SBMAX_s, lamejs.Mp3Encoder = function Mp3Encoder(e, t, n) {
      3 != arguments.length && (console.error("WARN: Mp3Encoder(channels, samplerate, kbps) not specified"), e = 1, t = 44100, n = 128);

      var a = new Lame(),
          r = new GetAudio(),
          s = new GainAnalysis(),
          o = new BitStream(),
          i = new Presets(),
          _ = new QuantizePVT(),
          l = new Quantize(),
          c = new VBRTag(),
          f = new Version(),
          u = new ID3Tag(),
          d = new Reservoir(),
          h = new Takehiro(),
          p = new Parse(),
          m = new MPGLib();

      a.setModules(s, o, i, _, l, c, f, u, m), o.setModules(s, m, f, c), u.setModules(o, f), i.setModules(a), l.setModules(o, d, _, h), _.setModules(h, d, a.enc.psy), d.setModules(o), h.setModules(_), c.setModules(a, o, f), r.setModules(p, m), p.setModules(f, u, i);
      var b = a.lame_init();
      b.num_channels = e, b.in_samplerate = t, b.out_samplerate = t, b.brate = n, b.mode = MPEGMode.STEREO, b.quality = 3, b.bWriteVbrTag = !1, b.disable_reservoir = !0, b.write_id3tag_automatic = !1, a.lame_init_params(b);
      var v = 1152,
          g = 0 | 1.25 * v + 7200,
          w = new_byte(g);
      this.encodeBuffer = function (t, n) {
        1 == e && (n = t), t.length > v && (v = t.length, w = new_byte(g = 0 | 1.25 * v + 7200));
        var r = a.lame_encode_buffer(b, t, n, t.length, w, 0, g);
        return new Int8Array(w.subarray(0, r));
      }, this.flush = function () {
        var e = a.lame_encode_flush(b, w, 0, g);
        return new Int8Array(w.subarray(0, e));
      };
    };
  }

  lamejs(), Recorder.lamejs = lamejs;
}(), Recorder.prototype.enc_wav = {
  stable: !0,
  testmsg: "\u652F\u6301\u4F4D\u65708\u4F4D\u300116\u4F4D\uFF08\u586B\u5728\u6BD4\u7279\u7387\u91CC\u9762\uFF09\uFF0C\u91C7\u6837\u7387\u53D6\u503C\u65E0\u9650\u5236"
}, Recorder.prototype.wav = function (e, t, n) {
  var a = this.set,
      r = e.length,
      s = a.sampleRate,
      o = 8 == a.bitRate ? 8 : 16,
      i = r * (o / 8),
      _ = new ArrayBuffer(44 + i),
      l = new DataView(_),
      c = 0,
      writeString = function writeString(e) {
    for (var t = 0; t < e.length; t++, c++) {
      l.setUint8(c, e.charCodeAt(t));
    }
  },
      write16 = function write16(e) {
    l.setUint16(c, e, !0), c += 2;
  },
      write32 = function write32(e) {
    l.setUint32(c, e, !0), c += 4;
  };

  if (writeString("RIFF"), write32(36 + i), writeString("WAVE"), writeString("fmt "), write32(16), write16(1), write16(1), write32(s), write32(s * (o / 8)), write16(o / 8), write16(o), writeString("data"), write32(i), 8 == o) for (var f = 0; f < r; f++, c++) {
    var u = 128 + (e[f] >> 8);
    l.setInt8(c, u, !0);
  } else for (f = 0; f < r; f++, c += 2) {
    l.setInt16(c, e[f], !0);
  }
  t(new Blob([l.buffer], {
    type: "audio/wav"
  }));
};
var t = 40001,
    n = 40002,
    a = 40003,
    r = 40004,
    s = 50001,
    o = 50002,
    i = 70001,
    _ = 70002,
    l = 70003,
    c = 70004,
    f = 70005,
    u = 70006,
    d = 70007,
    h = 70008,
    p = 70009,
    m = 71001,
    b = 71002,
    v = 71003,
    g = 71004,
    w = 71005,
    E = 71006,
    S = 71007,
    M = 71008,
    y = "None",
    B = "Initializing",
    R = "Connected",
    A$3 = "Evaluating",
    T = "Resulting",
    k = "Finished",
    x = "None",
    P = "Starting",
    I = "Recording",
    L = [];
var V = null;

function getMp3Blob() {
  var e = null;
  return V && (e = new Blob([V], {
    type: "audio/mp3"
  })), e;
}

var H = [];

function clearWavCache() {
  H = [];
}

var C = null;

function getWavBlob() {
  var e = new Uint16Array(function addWavHeader(e, t, n, a) {
    var r = e.byteLength,
        s = new ArrayBuffer(44 + r),
        o = new DataView(s);

    function writeString(e, t, n) {
      for (var a = 0; a < n.length; a++) {
        e.setUint8(t + a, n.charCodeAt(a));
      }
    }

    var i = 0;

    function floatTo32BitPCM(e, t, n) {
      n = new Int32Array(n);

      for (var a = 0; a < n.length; a++, t += 4) {
        e.setInt32(t, n[a], !0);
      }
    }

    function floatTo16BitPCM(e, t, n) {
      n = new Int16Array(n);

      for (var a = 0; a < n.length; a++, t += 2) {
        e.setInt16(t, n[a], !0);
      }
    }

    function floatTo8BitPCM(e, t, n) {
      n = new Int8Array(n);

      for (var a = 0; a < n.length; a++, t++) {
        e.setInt8(t, n[a], !0);
      }
    }

    writeString(o, i, "RIFF"), i += 4, o.setUint32(i, 36 + r, !0), writeString(o, i += 4, "WAVE"), writeString(o, i += 4, "fmt "), i += 4, o.setUint32(i, 16, !0), i += 4, o.setUint16(i, 1, !0), i += 2, o.setUint16(i, a, !0), i += 2, o.setUint32(i, t, !0), i += 4, o.setUint32(i, t * a * (n / 8), !0), i += 4, o.setUint16(i, a * (n / 8), !0), i += 2, o.setUint16(i, n, !0), writeString(o, i += 2, "data"), i += 4, o.setUint32(i, r, !0), i += 4, 16 === n ? floatTo16BitPCM(o, 44, e) : 8 === n ? floatTo8BitPCM(o, 44, e) : floatTo32BitPCM(o, 44, e);
    return o.buffer;
  }(C.buffer, 16e3, 16, 1));
  return new Blob([e], {
    type: "audio/wav"
  });
}

function getAudioString(e) {
  return {
    1: "wav",
    5: "mp3"
  }[e];
}

function startSentry(e, t, n) {
  var a = function getSentryHub(e, t) {
    var n = new e.BrowserClient(_objectSpread2({}, t));
    return new e.Hub(n);
  }(e, t);

  a.run(function (e) {
    e.configureScope(function (e) {
      e.setTags({
        url: window.location.href
      }), e.setUser({
        userAgent: navigator.userAgent
      });
    }), "function" === typeof n && n(e);
  });
}

function initSentry(e, t) {
  try {
    "object" === ("undefined" === typeof Sentry ? "undefined" : _typeof(Sentry)) ? startSentry(Sentry, e, t) : function loadScript(e, t) {
      var n = document.head || document.getElementsByTagName("head")[0],
          a = document.createElement("script");
      a.type = "text/javascript", a.charset = "utf8", a.async = !0, a.src = e, "onload" in a || (a.onreadystatechange = function () {
        "complete" !== a.readyState && "loaded" !== a.readyState || (a.onreadystatechange = null, t(null));
      }), a.onload = function () {
        a.onerror = a.onload = null, t(null);
      }, a.onerror = function () {
        a.onerror = a.onload = null, t(new Error("Failed to load ".concat(a.src)));
      }, n.appendChild(a);
    }("https://i.gsxcdn.com/sentry/browser/bundle.min.js", function (n) {
      n || "object" === ("undefined" === typeof Sentry ? "undefined" : _typeof(Sentry)) && startSentry(Sentry, e, t);
    });
  } catch (n) {}
}

var N = function onStart(e) {
  var t = e.options;
  console.log("[BjAiEngine] onStart()"), t && "function" === typeof t.onStart && t.onStart();
},
    O = function onResult(e, t) {
  var n = e.options;
  n && "function" === typeof n.onResult && n.onResult(t), !e.isCompleteCalled && t.is_last_response && n && "function" === typeof n.onComplete && (e.isCompleteCalled = !0, n.onComplete());
},
    q = function onError(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      a = e.options,
      r = a.config,
      s = window.location.href,
      o = ["test", "dev", "beta"],
      i = "production";
  s.indexOf("localhost") > -1 ? i = "local" : -1 !== s.indexOf("speech/demo") ? i = "development" : o.some(function (e) {
    return s.indexOf(e) > -1 && (i = "development", !0);
  });
  var _ = {
    dsn: "https://bfe08b95aeea4fe187df8b711eb5db66@sentry.baijia.com/850",
    environment: i,
    release: "1.1.2"
  };
  initSentry(_, function (e) {
    e.configureScope(function (e) {
      e.setExtras({
        config: r
      });
    }), e.captureException(new Error(JSON.stringify(t)));
  }), a && "function" === typeof a.onError ? a.onError(Object.assign({}, t, {
    isStopErr: n
  })) : console.error("[BjAiEngine] onError()", t), !e.isCompleteCalled && n && a && "function" === typeof a.onComplete && (e.isCompleteCalled = !0, a.onComplete());
};

function legacyReset(e) {
  var t,
      n = {
    status: e.status,
    recStatus: e.recStatus
  };

  if (console.log("[BjAiEngine] reset()", n), e.websocket) {
    var a = e.websocket;
    e.websocket = null, a.close();
  }

  "undefined" !== typeof e.waitResultTimer && (clearTimeout(e.waitResultTimer), e.waitResultTimer = null), e.recStatus === I && stop(), e.socketOpen = !1, null === (t = e.clearQueue) || void 0 === t || t.call(e), e.status = y;
}

function legacyStop(e) {
  var t = e.options;

  if (!e.isFinished) {
    if (e.status !== A$3) {
      var n = {
        errId: m,
        error: "[BjAiEngine] engine status error when you call 'stop', status: ".concat(e.status, ". ")
      };
      return e.status === y && (n = {
        errId: g,
        error: "[BjAiEngine] you should call 'aiengineStart' first. "
      }), e.status === B ? n = {
        errId: w,
        error: "[BjAiEngine] Initializing engine and recorder, please wait. "
      } : e.status === R ? n = {
        errId: S,
        error: "[BjAiEngine] recorder is starting, please wait. "
      } : e.status === I ? n = {
        errId: E,
        error: "[BjAiEngine] engine is connecting to server, please wait. "
      } : e.status === T && (n = {
        errId: M,
        error: "[BjAiEngine] you shouldn't call 'aiengineStop' repeatedly. "
      }), q(e, n, !0), void legacyReset(e);
    }

    e.status = T;
    var a = 1e3;
    "undefined" !== typeof t.config.timeOut && (a = function accMul(e, t) {
      var n = 0,
          a = e.toString(),
          r = t.toString();

      try {
        n += a.split(".")[1].length;
      } catch (s) {}

      try {
        n += r.split(".")[1].length;
      } catch (s) {}

      return Number(a.replace(".", "")) * Number(r.replace(".", "")) / Math.pow(10, n);
    }(t.config.timeOut, 1e3)), "undefined" !== typeof e.waitResultTimer && clearTimeout(e.waitResultTimer), console.log("[BjAiEngine] waiting result"), e.waitResultTimer = setTimeout(function (t) {
      console.log("[BjAiEngine] onWaitResultTimeout(), at status: ".concat(e.status));
      var n = {
        errId: m,
        error: "[BjAiEngine] onWaitResultTimeout: status error, status: ".concat(e.status)
      };
      e.status === T && (n = {
        errId: o,
        error: "[BjAiEngine] server timeout"
      }), legacyReset(e), q(e, n, !0);
    }, a);
  }
}

function getServerUri(e) {
  return 0 === e || "test" === e ? "wss://test-speech-ws.baijia.com/speech-ws/ws" : "wss://speech-ws.baijia.com/speech-ws/ws";
}

function legacyPrepareWebsocket(e, t) {
  var n = e.websocket;
  e.send;
  var a = e.dequeue;
  n.onopen = function () {
    console.log("[BjAiEngine] wss open!"), t.socketOpen = !0, t.status = t.status === I ? A$3 : R, t.status === A$3 && N(t), a();
  }, n.onerror = function (e) {
    console.error("[BjAiEngine] socket error", e);
    var n = t.status === R || t.status === A$3 || t.status === T || t.status === k,
        a = {
      errId: n ? b : i,
      error: "[BjAiEngine] connect server(".concat(getServerUri(t.options.env), ") fail. ")
    };
    q(t, a, n), t.isFinished = !0, legacyReset(t);
  }, n.onmessage = function legacyOnMessage(e, t) {
    return function (n) {
      var a;
      if (console.log("[BjAiEngine] onWsMessage(), at status: ".concat(t.status)), t.websocket === e) {
        if ("object" === _typeof(n) && (a = n.data), "string" === typeof a && "" !== a) {
          if (t.status === A$3 || t.status === T) {
            try {
              a = JSON.parse(a);
            } catch (f) {
              a = {};
            }

            console.log("[BjAiEngine] result", a);
            var r = a,
                o = r.code,
                i = r.data,
                _ = r.message,
                l = i.is_last_response;
            if (t.isPartialResulted = !l, t.isFinished = l, t.isFinished && (t.status = k), 1 !== o) "undefined" === typeof i.overall && (i.overall = 0), "undefined" === typeof i.fluency && (i.fluency = 0), "undefined" === typeof i.integrity && (i.integrity = 0), i.base_info && "undefined" === typeof i.base_info.pronunciation_score && (i.base_info.pronunciation_score = 0), O(t, i);else {
              var c = {
                errId: s,
                error: "[BjAiEngine] ".concat(_, ". ")
              };
              q(t, c, !0);
            }
          } else console.error("[BjAiEngine] onWsMessage: status error, status = ".concat(t.status));
        } else console.warn("[BjAiEngine] onWsMessage: server response empty result");
      } else console.log("[BjAiEngine] onWsMessage: engine has been reset. not current socketTask's event.");
    };
  }(n, t), n.onclose = function (e) {
    (console.log("[BjAiEngine] onClose()", e), t.isPartialResulted || t.isFinished || t.status !== A$3) || q(t, {
      errId: v,
      error: "[BjAiEngine] connection closed before result was returned. "
    }, !0);
    t.isFinished = !0, legacyReset(t);
  };
}

function initRecorder(t, n, a, r) {
  var s, o, i;
  "mp3" === t ? o = function sendAndCacheMp3(e) {
    return function (t) {
      if (t) {
        e(t), L.push(t);

        for (var n = 0, a = 0; a < L.length; a++) {
          n += L[a].length;
        }

        for (var r = new Uint8Array(n), s = 0, o = 0; s < L.length; s++) {
          var i = L[s];
          r.set(i, o), o += i.length;
        }

        r.length > 0 && (V = r);
      }
    };
  }(n) : "wav" === t && (o = function sendAndCacheWav(e) {
    return function (t) {
      if (t) {
        e(t), H.push(t);

        for (var n = 0, a = 0; a < H.length; a++) {
          n += H[a].length;
        }

        for (var r = new Uint16Array(n), s = 0, o = 0; s < H.length; s++) {
          var i = H[s];
          r.set(i, o), o += i.length;
        }

        r.length > 0 && (C = r);
      }
    };
  }(n));
  var _ = {
    type: t,
    sampleRate: 16e3,
    bitRate: 16,
    onProcess: function onProcess(n, a, r, s, _, l) {
      "wav" === t && (i = e.SampleData(n, 44100, 16e3, {
        index: i ? i.index : 0,
        offset: i ? i.offset : 0
      }), o(i.data));
    },
    takeoffEncodeChunk: "mp3" === t ? function (e) {
      o(e);
    } : null
  };
  return e.TrafficImgUrl = null, (s = e(_)).open(function () {
    null === a || void 0 === a || a(s);
  }, function (e, t) {
    null === r || void 0 === r || r(e, t);
  }), s;
}

function start(s, o) {
  if (e.Support()) {
    o.isCompleteCalled = !1, o.isPartialResulted = !1, o.isFinished = !1, console.log("[BjAiEngine] aiengineStart()", s.config);

    try {
      !function legacyCheckOptions(e) {
        var a = e.options,
            r = e.status,
            s = window.location,
            o = s.protocol,
            i = s.hostname;
        if ("https:" !== o && "localhost" !== i) throw {
          errId: t,
          error: "[BjAiEngine] sdk should be used in 'HTTPS' or 'localhost'. "
        };
        if (!navigator.onLine) throw {
          errId: n,
          error: "[BjAiEngine] unexpected network error. "
        };

        if (r !== y) {
          var m = {
            errId: _,
            error: "[BjAiEngine] engine status error, status: ".concat(r, ". ")
          };
          throw r === B || r === R || r === I || r === A$3 ? m = {
            errId: l,
            error: "[BjAiEngine] you should not call 'aiengineStart' repeatedly. "
          } : r === T && (m = {
            errId: c,
            error: "[BjAiEngine] you must wait engine result. "
          }), m;
        }

        var b = {};
        if (!a || !a.config) throw b = {
          errId: f,
          error: "[BjAiEngine] 'config' is required in function 'aiengineStart'. "
        };

        if ([{
          isRequired: !0,
          name: "appId",
          type: "string"
        }, {
          isRequired: !0,
          name: "lang",
          type: "number",
          isLimited: !0,
          choices: [0, 1]
        }, {
          isRequired: !0,
          name: "questionType",
          type: "number",
          isLimited: !0,
          choices: [0, 2]
        }, {
          isRequired: !1,
          name: "audioType",
          type: "number",
          isLimited: !0,
          choices: [1, 5]
        }, {
          isRequired: !1,
          name: "env",
          type: "number",
          isLimited: !0,
          choices: [0, 1]
        }, {
          isRequired: !1,
          name: "tolerableSilenceInSecond",
          type: "number",
          isLimited: !1,
          min: 0
        }, {
          isRequired: !1,
          name: "timeOut",
          type: "number",
          isLimited: !1,
          min: 1
        }, {
          isRequired: !1,
          name: "targetUser",
          type: "number",
          isLimited: !0,
          choices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
        }, {
          isRequired: !1,
          name: "lexiconType",
          type: "number",
          isLimited: !0,
          choices: [0, 1]
        }, {
          isRequired: !1,
          name: "lexicon",
          type: "object"
        }, {
          isRequired: !1,
          name: "enableSaveAudio",
          type: "boolean"
        }, {
          isRequired: !1,
          name: "detectReadingCompleted",
          type: "boolean"
        }, {
          isRequired: !1,
          name: "requireRealTimeResult",
          type: "boolean"
        }, {
          isRequired: !1,
          name: "extra",
          type: "object"
        }].every(function (e) {
          var t = !0;
          if ((e.isRequired || !e.isRequired && e.name in a.config) && _typeof(a.config[e.name]) !== e.type ? (b = {
            errId: u,
            error: "[BjAiEngine] config.".concat(e.name, " should be ").concat(e.type, " instead of ").concat(_typeof(a.config[e.name]), ". ")
          }, t = !1) : "string" === e.type && e.name in a.config && "" === a.config[e.name].trim() ? (b = {
            errId: d,
            error: "[BjAiEngine] config.".concat(e.name, " can not be empty. ")
          }, t = !1) : "number" === e.type && e.name in a.config ? isNaN(a.config[e.name]) ? (b = {
            errId: h,
            error: "config.".concat(e.name, " can not be ").concat(a.config[e.name], ". ")
          }, t = !1) : e.isLimited && e.choices.indexOf(a.config[e.name]) < 0 ? (b = {
            errId: h,
            error: "[BjAiEngine] value of config.".concat(e.name, " should be one of [").concat(e.choices, "]. ")
          }, t = !1) : !e.isLimited && a.config[e.name] < e.min && (b = {
            errId: h,
            error: "[BjAiEngine] config.".concat(e.name, " should not be less than ").concat(e.min, ". ")
          }, t = !1) : "object" === e.type && e.name in a.config && !a.config[e.name] && (b = {
            errId: h,
            error: "config.".concat(e.name, " can not be ").concat(a.config[e.name], ". ")
          }, t = !1), !t) throw b;
          return t;
        })) {
          if (0 === a.config.lang && 2 === a.config.questionType) throw b = {
            errId: p,
            error: "[BjAiEngine] config.questionType should not be two when config.lang is zero. "
          };
          var v = 2 === a.config.questionType ? "object" : "string";
          if (_typeof(a.config.spokenText) !== v) throw b = {
            errId: u,
            error: "[BjAiEngine] config.spokenText should be ".concat(v, " instead of ").concat(_typeof(a.config.spokenText), ". ")
          };

          if ("string" === v) {
            if ("" === a.config.spokenText.trim()) throw b = {
              errId: d,
              error: "[BjAiEngine] config.spokenText can not be empty. "
            };
            var g = new RegExp("[\\u4E00-\\u9FFF]", "g");
            if (0 === a.config.lang && g.test(a.config.spokenText)) throw b = {
              errId: h,
              error: "[BjAiEngine] config.spokenText should not include Chinese when config.lang is zero. "
            };
          }

          if ("object" === v && ![{
            isRequired: !0,
            name: "content",
            type: "string"
          }, {
            isRequired: !1,
            name: "title",
            type: "string"
          }, {
            isRequired: !1,
            name: "author",
            type: "string"
          }, {
            isRequired: !1,
            name: "dynasty",
            type: "string"
          }].every(function (t) {
            var n = !0;
            return (t.isRequired || !t.isRequired && t.name in a.config.spokenText) && _typeof(a.config.spokenText[t.name]) !== t.type ? (b = {
              errId: u,
              error: "[BjAiEngine] config.spokenText.".concat(t.name, " should be ").concat(t.type, " instead of ").concat(_typeof(a.config.spokenText[t.name]), ". ")
            }, n = !1) : t.name in a.config.spokenText && "" === a.config.spokenText[t.name].trim() && (b = {
              errId: d,
              error: "[BjAiEngine] config.spokenText.".concat(t.name, " can not be empty. ")
            }, n = !1), n || q(e, b), n;
          })) return;
          if ("number" === typeof a.config.lexiconType && !a.config.lexicon || "undefined" === typeof a.config.lexiconType && a.config.lexicon) throw b = {
            errId: p,
            error: "[BjAiEngine] when config.lexiconType or config.lexicon is given, the other is required. "
          };
        }
      }(o);
    } catch (w) {
      return q(o, w), void legacyReset(o);
    }

    o.recStatus = P;

    var i = s.config,
        m = function initWebSocket(e, t) {
      t.status = B;

      var n = getServerUri(e),
          a = new WebSocket(n),
          r = [],
          s = function send(e) {
        a && t.socketOpen ? a.send(e) : r.push(e);
      };

      return {
        websocket: a,
        send: s,
        dequeue: function dequeue() {
          for (var e; e = r.shift();) {
            s(e);
          }
        },
        clearQueue: function clearQueue() {
          return r = [];
        }
      };
    }(i.env, o),
        b = m.websocket,
        v = m.send,
        g = m.clearQueue;

    o.websocket = b, o.send = v, o.clearQueue = g, legacyPrepareWebsocket(m, o), o.recorder = initRecorder(getAudioString(i.audioType), o.send, function (e) {
      o.recStatus = I, o.requestId = function uuid() {
        for (var e = [], t = "0123456789abcdef", n = 0; n < 36; n++) {
          e[n] = t.substr(Math.floor(16 * Math.random()), 1);
        }

        return e[14] = "4", e[19] = t.substr(3 & e[19] | 8, 1), e[8] = e[13] = e[18] = e[23] = "-", e.join("");
      }();

      var t = function wsConfig(e) {
        var t = e.appId,
            n = e.enableSaveAudio,
            a = e.tolerableSilenceInSecond,
            r = e.detectReadingCompleted,
            s = e.requireRealTimeResult,
            o = e.lang,
            i = e.questionType,
            _ = e.spokenText,
            l = e.lexiconType,
            c = e.lexicon,
            f = e.targetUser,
            u = e.extra,
            d = e.audioType,
            h = e.NPM_VERSION,
            p = e.sampleRate,
            m = {
          app_id: t,
          enable_save_audio: n || !1,
          meta: {
            request_id: e.requestId,
            options: {
              tolerable_silence_in_second: a || 0,
              detect_reading_completed: r || !1,
              require_real_time_result: s || !1
            },
            content: {
              lang: o,
              question_type: i,
              spoken_text: "string" === typeof _ ? _ : JSON.stringify(_)
            },
            audio_format: {
              type: d,
              sampling_rate: p,
              channel: 1,
              byte_per_sample: 2
            },
            lexicon_type: l,
            lexicon: c,
            target_user: f
          },
          extra: u,
          version: h,
          platform: "web"
        };
        return JSON.stringify(m);
      }(_objectSpread2(_objectSpread2({}, i), {}, {
        requestId: o.requestId,
        sampleRate: 16e3,
        NPM_VERSION: "1.1.2"
      }));

      o.send(t), e.start(), o.status = o.status === R ? A$3 : I, o.status === A$3 && N(o);
    }, function (e, t) {
      var n = {
        errId: r,
        error: "[BjAiEngine] recorder: ".concat((t ? "UserNotAllow\uFF0C" : "") + "\u65E0\u6CD5\u5F55\u97F3:" + e)
      };
      q(o, n), legacyReset(o);
    });
  } else q(o, {
    errId: a,
    error: "[BjAiEngine] recorder is not supported in this browser. "
  });
}

function stop(t, n) {
  if (n.recorder && e.IsOpen()) {
    var a = n.recorder,
        r = n.options,
        s = n.send,
        o = getAudioString(r.config.audioType);
    "wav" === o ? a.stop(function (e, r) {
      clearWavCache(), s("EOS"), a.close(), n.recorder = null, null === t || void 0 === t || t(e);
    }, function (e) {
      clearWavCache(), console.debug("\u5F55\u97F3\u5931\u8D25:" + e), a.close(), n.recorder = null;
    }) : "mp3" === o && (!function clearMp3Cache() {
      L = [];
    }(), s("EOS"), a.close(), n.recorder = null, null === t || void 0 === t || t(getMp3Blob())), n.recStatus = x, legacyStop(n);
  }
}

var j = function createRecorder() {
  var e = {
    recorder: null,
    websocket: null,
    send: null,
    clearQueue: null,
    options: {},
    requestId: null,
    status: y,
    recStatus: x,
    socketOpen: !1,
    isCompleteCalled: !1,
    isPartialResulted: !1,
    isFinished: !1,
    waitResultTimer: null
  };
  return {
    aiengineStart: function aiengineStart(t) {
      var n = Object.assign({
        audioType: 1
      }, t.config),
          a = Object.assign({}, t, {
        config: n
      });
      e.options = a, start(e.options, e);
    },
    aiengineStop: function aiengineStop(t) {
      stop(t, e);
    },
    getVoice: function getVoice() {
      return function getBlob(e) {
        var t = getAudioString(e);
        return "wav" === t ? getWavBlob() : "mp3" === t ? getMp3Blob() : void 0;
      }(e.options.config.audioType);
    },
    getRequestId: function getRequestId() {
      return e.requestId;
    }
  };
}();

var img$h = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eicon/%e5%bd%95%e9%9f%b3%3c/title%3e %3cdefs%3e %3clinearGradient x1='50%25' y1='100%25' x2='50%25' y2='0%25' id='linearGradient-1'%3e %3cstop stop-color='%23FF3741' offset='0%25'%3e%3c/stop%3e %3cstop stop-color='%23FF7878' offset='100%25'%3e%3c/stop%3e %3c/linearGradient%3e %3c/defs%3e %3cg id='PC' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='PC-%e5%a1%ab%e7%a9%ba%e9%a2%98-4%e7%a7%8d%e4%bd%9c%e7%ad%94-%e5%bd%95%e9%9f%b3' transform='translate(-381.000000%2c -722.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3' transform='translate(60.000000%2c 698.000000)'%3e %3cg id='icon/%e5%bd%95%e9%9f%b3' transform='translate(321.000000%2c 24.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' fill='url(%23linearGradient-1)' cx='30' cy='30' r='30'%3e%3c/circle%3e %3cg id='%e7%bc%96%e7%bb%84-5' transform='translate(18.529412%2c 13.235294)'%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='white' stroke-width='2' fill='white' x='5.41176471' y='1' width='12.1176471' height='20.9411765' rx='6.05882353'%3e%3c/rect%3e %3cpath d='M22.9411765%2c13.2352941 C22.9411765%2c13.7030092 22.9411765%2c14.4975092 22.9411765%2c15.6187939 C22.9411765%2c22.0993845 17.8056192%2c27.3529412 11.4705882%2c27.3529412 C5.13555728%2c27.3529412 0%2c22.0993845 0%2c15.6187939 C0%2c14.4975092 0%2c13.7030092 0%2c13.2352941' id='%e8%b7%af%e5%be%84' stroke='white' stroke-width='3' stroke-linecap='round'%3e%3c/path%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' x='10.5882353' y='26.4705882' width='2.64705882' height='7.05882353' rx='1.32352941'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='68px' height='68px' viewBox='0 0 68 68' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eicon/%e5%bd%95%e9%9f%b3/%e6%9a%82%e5%81%9c%3c/title%3e %3cg id='%e9%a1%b5%e9%9d%a2-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%9f%b3%e9%a2%91%e7%8a%b6%e6%80%81' transform='translate(-143.000000%2c -187.000000)'%3e %3cg id='%e6%ad%a3%e5%9c%a8%e5%bd%95%e9%9f%b3' transform='translate(71.000000%2c 187.000000)'%3e %3cg id='icon/%e5%bd%95%e9%9f%b3/%e6%9a%82%e5%81%9c' transform='translate(72.000000%2c 0.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3' fill='%23FF878D'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' cx='34' cy='34' r='34'%3e%3c/circle%3e %3c/g%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' x='24' y='24' width='20' height='20' rx='6'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='60px' height='60px' viewBox='0 0 60 60' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eicon/%e6%9a%82%e5%81%9c/%e5%81%9c%e6%ad%a2%3c/title%3e %3cdefs%3e %3clinearGradient x1='50%25' y1='100%25' x2='50%25' y2='0%25' id='linearGradient-1'%3e %3cstop stop-color='%23FF3741' offset='0%25'%3e%3c/stop%3e %3cstop stop-color='%23FF7878' offset='100%25'%3e%3c/stop%3e %3c/linearGradient%3e %3c/defs%3e %3cg id='PC' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='PC-%e5%a1%ab%e7%a9%ba%e9%a2%98-4%e7%a7%8d%e4%bd%9c%e7%ad%94-%e5%bd%95%e9%9f%b3%e7%bb%93%e6%9d%9f' transform='translate(-381.000000%2c -722.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3' transform='translate(60.000000%2c 698.000000)'%3e %3cg id='icon/%e6%9a%82%e5%81%9c/%e5%81%9c%e6%ad%a2' transform='translate(321.000000%2c 24.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' fill='url(%23linearGradient-1)' cx='30' cy='30' r='30'%3e%3c/circle%3e %3cpath d='M35.5294357%2c24.1529747 L42.9351619%2c34.5209913 C43.8981888%2c35.8692291 43.5859138%2c37.7428793 42.237676%2c38.7059063 C41.7288738%2c39.0693365 41.1192304%2c39.2647059 40.4939614%2c39.2647059 L25.6825091%2c39.2647059 C24.0256549%2c39.2647059 22.6825091%2c37.9215601 22.6825091%2c36.2647059 C22.6825091%2c35.639437 22.8778786%2c35.0297936 23.2413087%2c34.5209913 L30.6470349%2c24.1529747 C31.6100619%2c22.8047369 33.4837121%2c22.4924619 34.8319499%2c23.4554889 C35.1013364%2c23.6479078 35.3370167%2c23.8835881 35.5294357%2c24.1529747 Z' id='%e4%b8%89%e8%a7%92%e5%bd%a2' fill='white' transform='translate(33.088235%2c 30.000000) rotate(90.000000) translate(-33.088235%2c -30.000000) '%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var wxRecorderConfig = {
  wxReady: function wxReady(call) {
    // 【需实现】
    // 如果在微信环境，则可以调用
    if (window.wx && isWX) {
      call(window.wx);
      return;
    }

    call(null, '未处于微信环境，window.wx实例不存在');
  },
  downWxMedia: function downWxMedia(param, success, fail) {
    /**
     * 【需实现】
     *  调用参数
     *  param: {
     *      录音接口上传得到的微信服务器上的ID，用于下载单个素材（如果录音分了多段，需要循环调用DownWxMedia）
     *      注：素材下载的amr音质很渣，也许可以通过高清接口获得清晰点的speex音频，直接下载的amr只需用mediaId参数就可以了。
     *      mediaIds: string[];
     *  }
     *  下载成功后返回的结果
     *  success: fn(obj)
     *      obj: {
     *          这个值是从服务器端请求临时素材接口返回的Content-Type响应头，未转码必是audio/amr
     *          mime: "audio/amr",
     *          data: base64,
     *      }
     *  下载出错回调
     *  fail: fn(msg)
     */
    fail('下载素材接口DownWxMedia未实现');
  }
};
var set = {
  // 最佳输出格式，如果底层实现能够支持就应当优先返回此格式
  type: 'mp3',
  // 最佳采样率hz
  sampleRate: 16000,
  // 最佳比特率kbps
  bitRate: 16
};
var permissionCalls = []; // 微信录音权限，0: 无动作，1: 请求中，5: 已有权限

var permissionState; // 录音是否已经开始

var isStart = 0; // 是否等待开始录音

var isWaitStart = 0;
var startId = 0;

var _stopJoinEnd;

var stopWaitChunk;
var wxRecordData = {};

var stopNow = function stopNow(call, keep) {
  if (!keep) {
    isStart = 0;
    isWaitStart = 0;
  }

  wxRecordData.wx.stopRecord({
    success: function success() {
      call === null || call === void 0 ? void 0 : call();
    },
    fail: function fail(o) {
      call === null || call === void 0 ? void 0 : call("\u65E0\u6CD5\u7ED3\u675F\u5F55\u97F3\uFF1A".concat(o.errMsg));
    }
  });
}; // keep为1时表示音频接续失败时重试的情况


var killStart = function killStart(call, keep) {
  if (!keep && isStart) {
    console.warn('录音中，正在kill重试');
  }

  function delayCall() {
    window.setTimeout(call, 300);
  }

  stopNow(delayCall, keep);
};

var requestPermission = function requestPermission(success, fail) {
  // 授权过，能管很久
  if (permissionState === 5) {
    success();
    return;
  } // 授权回调


  permissionCalls.push({
    t: success,
    f: fail
  });

  if (permissionState === 1) {
    console.warn('检测到连续的requestPermission调用，wx环境已加入队列，这种操作是不建议的，如果是用户触发，应当开启遮罩层避免重复点击');
    return;
  } // 标识目前的录音权限状态为 正在请求用户授权


  permissionState = 1; // isUser 为true时代表用户未授权录音

  var end = function end(e, isUser) {
    if (isUser === void 0) {
      isUser = false;
    }

    permissionState = e ? 0 : 5;
    var calls = permissionCalls;
    permissionCalls = []; // 授权成功/失败后，调用外部给的回调

    for (var _i = 0, calls_1 = calls; _i < calls_1.length; _i++) {
      var call = calls_1[_i];

      if (e) {
        call.f(e, isUser);
      } else {
        call.t();
      }
    }
  };

  var readyCall = function readyCall(wx, e) {
    wxRecordData.wx = null;

    if (e) {
      end("\u5FAE\u4FE1JS SDK\u52A0\u8F7D\u5931\u8D25\uFF0C".concat(e));
      return;
    }

    wxRecordData.wx = wx; // 微信不能提前发起授权请求，需要开始录音时才会调起授权，并且授权一次后管很久，因此开始录音然后关闭就能检测出权限

    function mockRecordCall4Permission() {
      wx.startRecord({
        success: function success() {
          // 成功唤起授权之后，开始录音后自动停止录音，因为本次的目的只是做授权请求
          // 只许关闭成功，不许失败
          var kill = function kill(wait, final) {
            function okCallback(e) {
              if (e) {
                console.warn("\u505C\u6B62wx\u5F55\u97F3".concat(final ? '[Final]' : '', ": ").concat(e));
              } // 如果没有错误，或者是有错误但最后一次重试，则结束，调用外部给的授权回调


              if (!e || final) {
                end();
              } // 有错误，并且没有重试关闭过，则加大延迟重试一次，再不行就忽略
              else {
                kill(1000, 1);
              }
            }

            function okStop() {
              stopNow(okCallback);
            }

            window.setTimeout(okStop, wait);
          };

          kill(100);
        },
        fail: function fail(o) {
          console.log('po:', o);
          end("\u8BF7\u6C42\u5FAE\u4FE1\u5F55\u97F3\u80FD\u529B\u5931\u8D25\uFF1A".concat(o.errMsg));
        },
        cancel: function cancel(o) {
          end("\u7528\u6237\u672A\u6388\u6743\u5FAE\u4FE1\u5F55\u97F3\uFF1A".concat(o.errMsg), true);
        }
      });
    } // 可能已经在录音了，暴力直接关掉一次再说，不然没法start


    killStart(mockRecordCall4Permission);
  }; // JSSDK ready后即请求用户录音授权


  wxRecorderConfig.wxReady(readyCall);
};

var startRecording = function startRecording(set, _success, fail) {
  var wx = wxRecordData.wx;

  if (!wx) {
    fail === null || fail === void 0 ? void 0 : fail('wx实例不存在，请先调用requestPermission获取wx实例');
    return;
  } // 如果目前正处于录音状态


  function restart() {
    startRecording(set, _success, fail);
  }

  if (isStart) {
    console.warn('wx正在录音，但又开始了新录音，现在将会kill掉老的录音');
    killStart(restart);
    return;
  } // 如果现在正在微信录音初始化状态，刚调用微信录音，但 wx.startRecord 还未回调success方法


  if (isWaitStart) {
    console.warn('wx上次Start还未完成，等待重试...'); // 等待600ms后，应该会处于isStart为1的状态，kill掉该次请求重试

    window.setTimeout(restart, 600);
    return;
  } // 自增id阻止掉非本次的老的异步回调


  var id = ++startId; // connectedFailed表示是否是接续时出错

  function startFailed(o, connectedFailed) {
    if (connectedFailed === void 0) {
      connectedFailed = false;
    }

    isWaitStart = 0;
    fail === null || fail === void 0 ? void 0 : fail("".concat(connectedFailed ? '接续' : '开始', "\u5FAE\u4FE1\u5F55\u97F3\u5931\u8D25\uFF1A").concat(o.errMsg));
    stopNow();
  } // 开始微信录音


  var run = function run(final) {
    isStart = 0; // 初始化过程中，isWaitStart为1

    isWaitStart = 1;
    wx.startRecord({
      success: function success() {
        // 初始化完成后，回调success函数才是真正开始录音，isStart变为1
        isStart = 1;
        isWaitStart = 0;
        wxRecordData.startTime = Date.now();
        wxRecordData.start = set;
        console.log('wx已开始录音');
        _success === null || _success === void 0 ? void 0 : _success();
      },
      fail: function fail(o) {
        // 如果重试一次后还不成功，则重置isWaitStart为0，并回调外部fail回调，让外部感知
        if (final) {
          startFailed(o);
        } else {
          // 重试一次
          killStart(function retry() {
            run(1);
          });
        }
      },
      cancel: startFailed
    });
  };

  run(); // 监听超时自动停止后，接续录音

  wxRecordData.chunks = [];
  wxRecordData.chunkErr = '';
  _stopJoinEnd = null;
  stopWaitChunk = null;
  wx.onVoiceRecordEnd({
    complete: function complete(res) {
      var t1 = Date.now();

      if (_stopJoinEnd) {
        // 如果正在进行stop调用时发生了onVoiceRecordEnd，此时不会触发stop回调，需要手动触发
        _stopJoinEnd(res, 'chunk');
      } else if (res.localId && wxRecordData.chunks) {
        wxRecordData.chunks.push({
          res: res,
          duration: t1 - wxRecordData.startTime,
          time: t1,
          from: 'chunk'
        });
      } else {
        // 已彻底停止录音了，就不要塞数据了，丢弃
        console.warn('已忽略wx chunk数据', res);
      } // 已停止，正在等待满一分钟的一块


      if (stopWaitChunk) {
        stopWaitChunk();
        return;
      }

      console.log('wx录音超时，正在接续...');

      var rerun = function rerun(tryCount) {
        // 拦截isStart状态为0时()，或者已经停止后，旧的异步回调执行
        if (!isStart || id !== startId) {
          console.warn('已停止的wx录音，拒绝接续');
          return;
        }

        wx.startRecord({
          success: function success() {
            // 应该是相同的
            if (id === startId) {
              wxRecordData.startTime = Date.now();
              console.log("\u6210\u529F\u63A5\u7EEDwx\u5F55\u97F3\uFF0C\u671F\u95F4\u4E2D\u65AD\u65F6\u95F4\uFF1A".concat(+(Date.now() - t1), "ms"));
            }
          },
          fail: function fail(o) {
            if (!isStart || id !== startId) {
              return;
            }

            console.error("\u65E0\u6CD5\u63A5\u7EED\u5FAE\u4FE1\u5F55\u97F3\uFF1A".concat(o.errMsg, ", ").concat(o)); // 如果重试3次后仍然失败，则不再重试

            if (tryCount > 2) {
              wxRecordData.chunkErr = "\u65E0\u6CD5\u63A5\u7EED\u5FAE\u4FE1\u5F55\u97F3\uFF1A".concat(o.errMsg, ", ").concat(o); // 调用外部提供的错误回调，让外部感知接续微信录音接续出错

              startFailed(o);
            } else {
              tryCount++;
              console.log("\u63A5\u7EED\u5931\u8D25\uFF0C\u5C1D\u8BD5\u91CD\u542F\u5F55\u97F3\u80FD\u529B...\uFF0C\u7B2C".concat(tryCount, "\u6B21\u91CD\u8BD5")); // 救一下，缺个几百毫秒已不重要了

              killStart(function retry() {
                rerun(tryCount);
              }, 1);
            }
          }
        });
      };

      rerun(0);
    }
  });
};

var stopRecording = function stopRecording(successx, failx, beforeUpload) {
  var wx = wxRecordData.wx;
  isStart = 0; // 最后一块录音已收到59秒以上，无需再等了，结束做后续上传下载编解码动作即可

  var hasWaitChunk = !!stopWaitChunk;
  stopWaitChunk = null;
  console.log('开始停止录音');

  var failCall = function failCall(msg) {
    failx === null || failx === void 0 ? void 0 : failx("\u5F55\u97F3\u5931\u8D25[wx]\uFF1A".concat((msg === null || msg === void 0 ? void 0 : msg.errMsg) || msg));
  };

  var set = wxRecordData.start;

  if (!set) {
    failCall('未开始录音');
    return;
  } // 开始或接续录音后距离1分钟最大时间间隔太短就调用了结束录音时
  // 等待接续信号结束本次录音，即等待wx.onVoiceRecordEnd的complete回调结束录音


  var curDuration = Date.now() - wxRecordData.startTime;

  if (!hasWaitChunk && curDuration > 59100) {
    console.warn('wx录音即将满1分钟，等待它录满，不然stop不可控...');

    stopWaitChunk = function stopWaitChunk() {
      stopRecording(successx, failx, beforeUpload);
    };

    return;
  }

  wxRecordData.start = null;
  var dwxData = {
    list: []
  };
  set.downWxMediaData = dwxData;
  var chunkList = wxRecordData.chunks;
  var mediaIds = [];

  var stopFn = function stopFn() {
    // 仅清理资源的直接返回，避免进行上传和下载操作
    if (!successx) {
      failCall('仅清理资源');
      return;
    }

    var upIds = chunkList.map(function (chunk) {
      return chunk.res.localId;
    });
    console.log("\u7ED3\u675F\u5F55\u97F3\u65F6\u5171".concat(upIds.length, "\u6BB5\uFF0C\u5F00\u59CB\u4E0A\u4F20\u4E0B\u8F7D"), upIds, chunkList);

    if (!upIds.length) {
      failCall('未获得任何录音');
      return;
    } // 记录上传开始时间


    var upStart = 0; // 记录上传点

    var upIdx = 0;

    var up = function up(tryCount) {
      if (tryCount === void 0) {
        tryCount = 0;
      }

      if (upIdx >= upIds.length) {
        dwxData.uploadTime = Date.now() - upStart;
        console.log('上传本地录音完成，返回给外部对应的serverIds', mediaIds);
        successx === null || successx === void 0 ? void 0 : successx(mediaIds);
        return;
      }

      console.log("\u5F00\u59CBwx\u4E0A\u4F20\u672C\u5730\u5F55\u97F3[".concat(upIdx, "] wx.uploadVoice({localId:").concat(upIds[upIdx], "})"));
      wx.uploadVoice({
        localId: upIds[upIdx],
        isShowProgressTips: 0,
        fail: function fail(e) {
          // 上传失败3次后，不再重试
          if (tryCount > 2) {
            failCall("\u5FAE\u4FE1uploadVoice\u5931\u8D25[".concat(upIdx, "]\uFF1A").concat(e.errMsg));
          } else {
            tryCount++;
            console.error("uploadVoice\u5931\u8D25\uFF0C\u91CD\u8BD5... \u7B2C".concat(tryCount, "\u6B21"));
            up(tryCount);
          }
        },
        success: function success(res) {
          var serverId = res.serverId;
          console.log("\u4E0A\u4F20\u6210\u529F\uFF0CserverId\uFF1A".concat(serverId));
          mediaIds.push(serverId);
          upIdx++;
          up();
        }
      });
    };

    upStart = Date.now(); // 回调beforeUpload告知外部已经录完音了，开始上传

    beforeUpload === null || beforeUpload === void 0 ? void 0 : beforeUpload();
    up();
  }; // 兼容接续出错时，外部未传回调函数，或者未做相关处理的情况
  // 如果录音过程中，有接续错误，并且重试也没用的，就返回错误


  if (wxRecordData.chunkErr) {
    console.error(wxRecordData.chunkErr, chunkList);
    failCall("\u5F55\u5236\u5931\u8D25\uFF0C\u5DF2\u5F55\u5236".concat(chunkList.length, "\u5206\u949F\uFF0C\u4F46\u540E\u7EED\u51FA\u9519\uFF1A").concat(wxRecordData.chunkErr));
    return;
  } // 已收到59秒以上最后一块录音（即已通过wx.onVoiceRecordEnd的complete回调结束了录音，无需停止录音了
  // 此时只需上传下载编解码录音即可


  if (hasWaitChunk) {
    stopFn();
    return;
  } // 等待停止回调，或者onVoiceRecordEnd回调
  // 如果停止过程中发生了onVoiceRecordEnd的complete回调，可能不会触发下面stopRecord中的stop回调
  // 所以在stopRecord success的回调中，以及onVoiceRecordEnd的complete回调中，均调用了此函数
  // 如果一个地方已经调用了，因为这个函数内重置了stopJoinEnd为null，所以另外一处不会重复调用
  // 虽然上面已经处理了快满1分钟的情况，但时间不一定准确，但还是要补刀一下


  _stopJoinEnd = function stopJoinEnd(res, from) {
    _stopJoinEnd = null;
    var t1 = Date.now();

    if (res.localId) {
      chunkList.push({
        res: res,
        duration: t1 - wxRecordData.startTime,
        time: t1,
        from: from
      });
    } else {
      // 定时n分钟录音时，当刚刚接续录音，然后立即触发停止时(即刚刚rerun接续录音，就触发了停止)，返回数据没有localId
      console.warn("\u5DF2\u5FFD\u7565".concat(from, "\u6570\u636E"), res);
    } // 不要继续塞数据了，就算有也丢弃


    wxRecordData.chunks = null;
    stopFn();
  };

  wx.stopRecord({
    fail: function fail(e) {
      _stopJoinEnd = null; // 出错了，如果录音太短，尽力将有效的部分返回

      if (chunkList.length && curDuration < 3000) {
        console.warn("\u505C\u6B62\u5F55\u97F3\u51FA\u9519\uFF0C\u4F46\u540E\u7EED\u5F55\u97F3\u592A\u77ED\uFF0C\u5DF2\u5FFD\u7565\u6B64\u9519\u8BEF\uFF1A".concat(e.errMsg));
        stopFn();
      } else {
        failCall(e);
      }
    },
    success: function success(res) {
      _stopJoinEnd === null || _stopJoinEnd === void 0 ? void 0 : _stopJoinEnd(res, 'stop');
    }
  });
};

var wxRecorder = {
  requestPermission: requestPermission,
  startRecording: startRecording,
  stopRecording: stopRecording,
  set: set
};

var style$Z = {"time-counter":"tangram_C_time-counter_2447f94629"};

var styledClassNames$7 = bind.bind(style$Z);

var TimeCounter = function TimeCounter(props) {
  var trigger = props.trigger,
      onStop = props.onStop;
  var intervalRef = useRef(null);

  function timeReducer(state, action) {
    var sec = state.sec,
        formatTime = state.formatTime;
    var formatSec;
    var formatMin;
    var MIN = 60;

    switch (action.type) {
      case 'increment':
        formatSec = sec >= MIN ? sec % MIN >= 10 ? "".concat(sec % MIN) : "0".concat(sec % MIN) : sec >= 10 ? "".concat(sec) : "0".concat(sec);
        formatMin = sec >= MIN ? parseInt((sec / MIN).toString(), 10) >= 10 ? "".concat(parseInt((sec / MIN).toString(), 10)) : "0".concat(parseInt((sec / MIN).toString(), 10)) : '00';
        return {
          sec: sec + 1,
          formatTime: "".concat(formatMin, ":").concat(formatSec)
        };

      case 'reset':
        onStop === null || onStop === void 0 ? void 0 : onStop(formatTime);
        return {
          sec: 0,
          formatTime: '00:00'
        };

      default:
        return {
          sec: state.sec,
          formatTime: formatTime
        };
    }
  }

  var _a = useReducer(timeReducer, {
    sec: 0,
    formatTime: '00:00'
  }),
      state = _a[0],
      dispatch = _a[1];

  useEffect(function () {
    if (trigger) {
      dispatch({
        type: 'increment'
      });
      intervalRef.current = window.setInterval(function () {
        dispatch({
          type: 'increment'
        });
      }, 1000);
    } else {
      // @ts-ignore
      window.clearInterval(intervalRef.current);
      dispatch({
        type: 'reset'
      });
    }

    return function () {
      // @ts-ignore
      window.clearInterval(intervalRef.current);
      dispatch({
        type: 'reset'
      });
    };
  }, [trigger]);
  return /*#__PURE__*/React.createElement("span", {
    className: styledClassNames$7({
      'time-counter': true
    })
  }, state.formatTime);
};

var svga_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t() ;
  }(window, function () {
    return function (e) {
      function t(i) {
        if (r[i]) return r[i].exports;
        var n = r[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
      }

      var r = {};
      return t.m = e, t.c = r, t.d = function (e, r, i) {
        t.o(e, r) || Object.defineProperty(e, r, {
          enumerable: !0,
          get: i
        });
      }, t.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, t.t = function (e, r) {
        if (1 & r && (e = t(e)), 8 & r) return e;
        if (4 & r && "object" == _typeof$1(e) && e && e.__esModule) return e;
        var i = Object.create(null);
        if (t.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e
        }), 2 & r && "string" != typeof e) for (var n in e) {
          t.d(i, n, function (t) {
            return e[t];
          }.bind(null, n));
        }
        return i;
      }, t.n = function (e) {
        var r = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(r, "a", r), r;
      }, t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.p = "", t(t.s = 64);
    }([function (e, t, r) {

      var i,
          n,
          o = e.exports = r(1),
          s = r(20);
      o.codegen = r(47), o.fetch = r(48), o.path = r(49), o.fs = o.inquire("fs"), o.toArray = function (e) {
        if (e) {
          for (var t = Object.keys(e), r = new Array(t.length), i = 0; i < t.length;) {
            r[i] = e[t[i++]];
          }

          return r;
        }

        return [];
      }, o.toObject = function (e) {
        for (var t = {}, r = 0; r < e.length;) {
          var i = e[r++],
              n = e[r++];
          void 0 !== n && (t[i] = n);
        }

        return t;
      };
      var a = /\\/g,
          f = /"/g;
      o.isReserved = function (e) {
        return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(e);
      }, o.safeProp = function (e) {
        return !/^[$\w_]+$/.test(e) || o.isReserved(e) ? '["' + e.replace(a, "\\\\").replace(f, '\\"') + '"]' : "." + e;
      }, o.ucFirst = function (e) {
        return e.charAt(0).toUpperCase() + e.substring(1);
      };
      var l = /_([a-z])/g;
      o.camelCase = function (e) {
        return e.substring(0, 1) + e.substring(1).replace(l, function (e, t) {
          return t.toUpperCase();
        });
      }, o.compareFieldsById = function (e, t) {
        return e.id - t.id;
      }, o.decorateType = function (e, t) {
        if (e.$type) return t && e.$type.name !== t && (o.decorateRoot.remove(e.$type), e.$type.name = t, o.decorateRoot.add(e.$type)), e.$type;
        i || (i = r(22));
        var n = new i(t || e.name);
        return o.decorateRoot.add(n), n.ctor = e, Object.defineProperty(e, "$type", {
          value: n,
          enumerable: !1
        }), Object.defineProperty(e.prototype, "$type", {
          value: n,
          enumerable: !1
        }), n;
      };
      var u = 0;
      o.decorateEnum = function (e) {
        if (e.$type) return e.$type;
        n || (n = r(2));
        var t = new n("Enum" + u++, e);
        return o.decorateRoot.add(t), Object.defineProperty(e, "$type", {
          value: t,
          enumerable: !1
        }), t;
      }, o.setProperty = function (e, t, r) {
        if ("object" != _typeof$1(e)) throw TypeError("dst must be an object");
        if (!t) throw TypeError("path must be specified");
        return function e(t, r, i) {
          var n = r.shift();
          if (r.length > 0) t[n] = e(t[n] || {}, r, i);else {
            var o = t[n];
            o && (i = [].concat(o).concat(i)), t[n] = i;
          }
          return t;
        }(e, t = t.split("."), r);
      }, Object.defineProperty(o, "decorateRoot", {
        get: function get() {
          return s.decorated || (s.decorated = new (r(30))());
        }
      });
    }, function (e, t, r) {

      (function (e) {
        function i(e, t, r) {
          for (var i = Object.keys(t), n = 0; n < i.length; ++n) {
            void 0 !== e[i[n]] && r || (e[i[n]] = t[i[n]]);
          }

          return e;
        }

        function n(e) {
          function t(e, r) {
            if (!(this instanceof t)) return new t(e, r);
            Object.defineProperty(this, "message", {
              get: function get() {
                return e;
              }
            }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", {
              value: new Error().stack || ""
            }), r && i(this, r);
          }

          return (t.prototype = Object.create(Error.prototype)).constructor = t, Object.defineProperty(t.prototype, "name", {
            get: function get() {
              return e;
            }
          }), t.prototype.toString = function () {
            return this.name + ": " + this.message;
          }, t;
        }

        var o = t;
        o.asPromise = r(17), o.base64 = r(38), o.EventEmitter = r(39), o.float = r(40), o.inquire = r(18), o.utf8 = r(41), o.pool = r(42), o.LongBits = r(43), o.isNode = Boolean(void 0 !== e && e && e.process && e.process.versions && e.process.versions.node), o.global = o.isNode && e || "undefined" != typeof window && window || "undefined" != typeof self && self || this, o.emptyArray = Object.freeze ? Object.freeze([]) : [], o.emptyObject = Object.freeze ? Object.freeze({}) : {}, o.isInteger = Number.isInteger || function (e) {
          return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
        }, o.isString = function (e) {
          return "string" == typeof e || e instanceof String;
        }, o.isObject = function (e) {
          return e && "object" == _typeof$1(e);
        }, o.isset = o.isSet = function (e, t) {
          var r = e[t];
          return !(null == r || !e.hasOwnProperty(t)) && ("object" != _typeof$1(r) || (Array.isArray(r) ? r.length : Object.keys(r).length) > 0);
        }, o.Buffer = function () {
          try {
            var e = o.inquire("buffer").Buffer;
            return e.prototype.utf8Write ? e : null;
          } catch (e) {
            return null;
          }
        }(), o._Buffer_from = null, o._Buffer_allocUnsafe = null, o.newBuffer = function (e) {
          return "number" == typeof e ? o.Buffer ? o._Buffer_allocUnsafe(e) : new o.Array(e) : o.Buffer ? o._Buffer_from(e) : "undefined" == typeof Uint8Array ? e : new Uint8Array(e);
        }, o.Array = "undefined" != typeof Uint8Array ? Uint8Array : Array, o.Long = o.global.dcodeIO && o.global.dcodeIO.Long || o.global.Long || o.inquire("long"), o.key2Re = /^true|false|0|1$/, o.key32Re = /^-?(?:0|[1-9][0-9]*)$/, o.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, o.longToHash = function (e) {
          return e ? o.LongBits.from(e).toHash() : o.LongBits.zeroHash;
        }, o.longFromHash = function (e, t) {
          var r = o.LongBits.fromHash(e);
          return o.Long ? o.Long.fromBits(r.lo, r.hi, t) : r.toNumber(Boolean(t));
        }, o.merge = i, o.lcFirst = function (e) {
          return e.charAt(0).toLowerCase() + e.substring(1);
        }, o.newError = n, o.ProtocolError = n("ProtocolError"), o.oneOfGetter = function (e) {
          for (var t = {}, r = 0; r < e.length; ++r) {
            t[e[r]] = 1;
          }

          return function () {
            for (var e = Object.keys(this), r = e.length - 1; r > -1; --r) {
              if (1 === t[e[r]] && void 0 !== this[e[r]] && null !== this[e[r]]) return e[r];
            }
          };
        }, o.oneOfSetter = function (e) {
          return function (t) {
            for (var r = 0; r < e.length; ++r) {
              e[r] !== t && delete this[e[r]];
            }
          };
        }, o.toJSONOptions = {
          longs: String,
          enums: String,
          bytes: String,
          json: !0
        }, o._configure = function () {
          var e = o.Buffer;
          e ? (o._Buffer_from = e.from !== Uint8Array.from && e.from || function (t, r) {
            return new e(t, r);
          }, o._Buffer_allocUnsafe = e.allocUnsafe || function (t) {
            return new e(t);
          }) : o._Buffer_from = o._Buffer_allocUnsafe = null;
        };
      }).call(this, r(37));
    }, function (e, t, r) {

      function i(e, t, r, i, o) {
        if (n.call(this, e, r), t && "object" != _typeof$1(t)) throw TypeError("values must be an object");
        if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = i, this.comments = o || {}, this.reserved = void 0, t) for (var s = Object.keys(t), a = 0; a < s.length; ++a) {
          "number" == typeof t[s[a]] && (this.valuesById[this.values[s[a]] = t[s[a]]] = s[a]);
        }
      }

      e.exports = i;
      var n = r(3);
      ((i.prototype = Object.create(n.prototype)).constructor = i).className = "Enum";
      var o = r(6),
          s = r(0);
      i.fromJSON = function (e, t) {
        var r = new i(e, t.values, t.options, t.comment, t.comments);
        return r.reserved = t.reserved, r;
      }, i.prototype.toJSON = function (e) {
        var t = !!e && Boolean(e.keepComments);
        return s.toObject(["options", this.options, "values", this.values, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "comment", t ? this.comment : void 0, "comments", t ? this.comments : void 0]);
      }, i.prototype.add = function (e, t, r) {
        if (!s.isString(e)) throw TypeError("name must be a string");
        if (!s.isInteger(t)) throw TypeError("id must be an integer");
        if (void 0 !== this.values[e]) throw Error("duplicate name '" + e + "' in " + this);
        if (this.isReservedId(t)) throw Error("id " + t + " is reserved in " + this);
        if (this.isReservedName(e)) throw Error("name '" + e + "' is reserved in " + this);

        if (void 0 !== this.valuesById[t]) {
          if (!this.options || !this.options.allow_alias) throw Error("duplicate id " + t + " in " + this);
          this.values[e] = t;
        } else this.valuesById[this.values[e] = t] = e;

        return this.comments[e] = r || null, this;
      }, i.prototype.remove = function (e) {
        if (!s.isString(e)) throw TypeError("name must be a string");
        var t = this.values[e];
        if (null == t) throw Error("name '" + e + "' does not exist in " + this);
        return delete this.valuesById[t], delete this.values[e], delete this.comments[e], this;
      }, i.prototype.isReservedId = function (e) {
        return o.isReservedId(this.reserved, e);
      }, i.prototype.isReservedName = function (e) {
        return o.isReservedName(this.reserved, e);
      };
    }, function (e, t, r) {

      function i(e, t) {
        if (!o.isString(e)) throw TypeError("name must be a string");
        if (t && !o.isObject(t)) throw TypeError("options must be an object");
        this.options = t, this.parsedOptions = null, this.name = e, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
      }

      e.exports = i, i.className = "ReflectionObject";
      var n,
          o = r(0);
      Object.defineProperties(i.prototype, {
        root: {
          get: function get() {
            for (var e = this; null !== e.parent;) {
              e = e.parent;
            }

            return e;
          }
        },
        fullName: {
          get: function get() {
            for (var e = [this.name], t = this.parent; t;) {
              e.unshift(t.name), t = t.parent;
            }

            return e.join(".");
          }
        }
      }), i.prototype.toJSON = function () {
        throw Error();
      }, i.prototype.onAdd = function (e) {
        this.parent && this.parent !== e && this.parent.remove(this), this.parent = e, this.resolved = !1;
        var t = e.root;
        t instanceof n && t._handleAdd(this);
      }, i.prototype.onRemove = function (e) {
        var t = e.root;
        t instanceof n && t._handleRemove(this), this.parent = null, this.resolved = !1;
      }, i.prototype.resolve = function () {
        return this.resolved ? this : (this.root instanceof n && (this.resolved = !0), this);
      }, i.prototype.getOption = function (e) {
        if (this.options) return this.options[e];
      }, i.prototype.setOption = function (e, t, r) {
        return r && this.options && void 0 !== this.options[e] || ((this.options || (this.options = {}))[e] = t), this;
      }, i.prototype.setParsedOption = function (e, t, r) {
        this.parsedOptions || (this.parsedOptions = []);
        var i = this.parsedOptions;

        if (r) {
          var n = i.find(function (t) {
            return Object.prototype.hasOwnProperty.call(t, e);
          });

          if (n) {
            var s = n[e];
            o.setProperty(s, r, t);
          } else (n = {})[e] = o.setProperty({}, r, t), i.push(n);
        } else {
          var a = {};
          a[e] = t, i.push(a);
        }

        return this;
      }, i.prototype.setOptions = function (e, t) {
        if (e) for (var r = Object.keys(e), i = 0; i < r.length; ++i) {
          this.setOption(r[i], e[r[i]], t);
        }
        return this;
      }, i.prototype.toString = function () {
        var e = this.constructor.className,
            t = this.fullName;
        return t.length ? e + " " + t : e;
      }, i._configure = function (e) {
        n = e;
      };
    }, function (e, t, r) {

      function i(e, t, r, i, o, s, u) {
        if (f.isObject(i) ? (u = o, s = i, i = o = void 0) : f.isObject(o) && (u = s, s = o, o = void 0), n.call(this, e, s), !f.isInteger(t) || t < 0) throw TypeError("id must be a non-negative integer");
        if (!f.isString(r)) throw TypeError("type must be a string");
        if (void 0 !== i && !l.test(i = i.toString().toLowerCase())) throw TypeError("rule must be a string rule");
        if (void 0 !== o && !f.isString(o)) throw TypeError("extend must be a string");
        this.rule = i && "optional" !== i ? i : void 0, this.type = r, this.id = t, this.extend = o || void 0, this.required = "required" === i, this.optional = !this.required, this.repeated = "repeated" === i, this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = !!f.Long && void 0 !== a.long[r], this.bytes = "bytes" === r, this.resolvedType = null, this.extensionField = null, this.declaringField = null, this._packed = null, this.comment = u;
      }

      e.exports = i;
      var n = r(3);
      ((i.prototype = Object.create(n.prototype)).constructor = i).className = "Field";
      var o,
          s = r(2),
          a = r(7),
          f = r(0),
          l = /^required|optional|repeated$/;
      i.fromJSON = function (e, t) {
        return new i(e, t.id, t.type, t.rule, t.extend, t.options, t.comment);
      }, Object.defineProperty(i.prototype, "packed", {
        get: function get() {
          return null === this._packed && (this._packed = !1 !== this.getOption("packed")), this._packed;
        }
      }), i.prototype.setOption = function (e, t, r) {
        return "packed" === e && (this._packed = null), n.prototype.setOption.call(this, e, t, r);
      }, i.prototype.toJSON = function (e) {
        var t = !!e && Boolean(e.keepComments);
        return f.toObject(["rule", "optional" !== this.rule && this.rule || void 0, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", t ? this.comment : void 0]);
      }, i.prototype.resolve = function () {
        if (this.resolved) return this;
        if (void 0 === (this.typeDefault = a.defaults[this.type]) && (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof o ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]), this.options && null != this.options.default && (this.typeDefault = this.options.default, this.resolvedType instanceof s && "string" == typeof this.typeDefault && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (!0 !== this.options.packed && (void 0 === this.options.packed || !this.resolvedType || this.resolvedType instanceof s) || delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long) this.typeDefault = f.Long.fromNumber(this.typeDefault, "u" === this.type.charAt(0)), Object.freeze && Object.freeze(this.typeDefault);else if (this.bytes && "string" == typeof this.typeDefault) {
          var e;
          f.base64.test(this.typeDefault) ? f.base64.decode(this.typeDefault, e = f.newBuffer(f.base64.length(this.typeDefault)), 0) : f.utf8.write(this.typeDefault, e = f.newBuffer(f.utf8.length(this.typeDefault)), 0), this.typeDefault = e;
        }
        return this.map ? this.defaultValue = f.emptyObject : this.repeated ? this.defaultValue = f.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof o && (this.parent.ctor.prototype[this.name] = this.defaultValue), n.prototype.resolve.call(this);
      }, i.d = function (e, t, r, n) {
        return "function" == typeof t ? t = f.decorateType(t).name : t && "object" == _typeof$1(t) && (t = f.decorateEnum(t).name), function (o, s) {
          f.decorateType(o.constructor).add(new i(s, e, t, r, {
            default: n
          }));
        };
      }, i._configure = function (e) {
        o = e;
      };
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.BezierPath = function e(t, r, i) {
        ((function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }))(this, e), this._d = t, this._transform = r, this._styles = i;
      };
    }, function (e, t, r) {

      function i(e, t) {
        if (e && e.length) {
          for (var r = {}, i = 0; i < e.length; ++i) {
            r[e[i].name] = e[i].toJSON(t);
          }

          return r;
        }
      }

      function n(e, t) {
        s.call(this, e, t), this.nested = void 0, this._nestedArray = null;
      }

      function o(e) {
        return e._nestedArray = null, e;
      }

      e.exports = n;
      var s = r(3);
      ((n.prototype = Object.create(s.prototype)).constructor = n).className = "Namespace";
      var a,
          f,
          l,
          u = r(4),
          h = r(0);
      n.fromJSON = function (e, t) {
        return new n(e, t.options).addJSON(t.nested);
      }, n.arrayToJSON = i, n.isReservedId = function (e, t) {
        if (e) for (var r = 0; r < e.length; ++r) {
          if ("string" != typeof e[r] && e[r][0] <= t && e[r][1] > t) return !0;
        }
        return !1;
      }, n.isReservedName = function (e, t) {
        if (e) for (var r = 0; r < e.length; ++r) {
          if (e[r] === t) return !0;
        }
        return !1;
      }, Object.defineProperty(n.prototype, "nestedArray", {
        get: function get() {
          return this._nestedArray || (this._nestedArray = h.toArray(this.nested));
        }
      }), n.prototype.toJSON = function (e) {
        return h.toObject(["options", this.options, "nested", i(this.nestedArray, e)]);
      }, n.prototype.addJSON = function (e) {
        if (e) for (var t, r = Object.keys(e), i = 0; i < r.length; ++i) {
          t = e[r[i]], this.add((void 0 !== t.fields ? a.fromJSON : void 0 !== t.values ? l.fromJSON : void 0 !== t.methods ? f.fromJSON : void 0 !== t.id ? u.fromJSON : n.fromJSON)(r[i], t));
        }
        return this;
      }, n.prototype.get = function (e) {
        return this.nested && this.nested[e] || null;
      }, n.prototype.getEnum = function (e) {
        if (this.nested && this.nested[e] instanceof l) return this.nested[e].values;
        throw Error("no such enum: " + e);
      }, n.prototype.add = function (e) {
        if (!(e instanceof u && void 0 !== e.extend || e instanceof a || e instanceof l || e instanceof f || e instanceof n)) throw TypeError("object must be a valid nested object");

        if (this.nested) {
          var t = this.get(e.name);

          if (t) {
            if (!(t instanceof n && e instanceof n) || t instanceof a || t instanceof f) throw Error("duplicate name '" + e.name + "' in " + this);

            for (var r = t.nestedArray, i = 0; i < r.length; ++i) {
              e.add(r[i]);
            }

            this.remove(t), this.nested || (this.nested = {}), e.setOptions(t.options, !0);
          }
        } else this.nested = {};

        return this.nested[e.name] = e, e.onAdd(this), o(this);
      }, n.prototype.remove = function (e) {
        if (!(e instanceof s)) throw TypeError("object must be a ReflectionObject");
        if (e.parent !== this) throw Error(e + " is not a member of " + this);
        return delete this.nested[e.name], Object.keys(this.nested).length || (this.nested = void 0), e.onRemove(this), o(this);
      }, n.prototype.define = function (e, t) {
        if (h.isString(e)) e = e.split(".");else if (!Array.isArray(e)) throw TypeError("illegal path");
        if (e && e.length && "" === e[0]) throw Error("path must be relative");

        for (var r = this; e.length > 0;) {
          var i = e.shift();

          if (r.nested && r.nested[i]) {
            if (!((r = r.nested[i]) instanceof n)) throw Error("path conflicts with non-namespace objects");
          } else r.add(r = new n(i));
        }

        return t && r.addJSON(t), r;
      }, n.prototype.resolveAll = function () {
        for (var e = this.nestedArray, t = 0; t < e.length;) {
          e[t] instanceof n ? e[t++].resolveAll() : e[t++].resolve();
        }

        return this.resolve();
      }, n.prototype.lookup = function (e, t, r) {
        if ("boolean" == typeof t ? (r = t, t = void 0) : t && !Array.isArray(t) && (t = [t]), h.isString(e) && e.length) {
          if ("." === e) return this.root;
          e = e.split(".");
        } else if (!e.length) return this;

        if ("" === e[0]) return this.root.lookup(e.slice(1), t);
        var i = this.get(e[0]);

        if (i) {
          if (1 === e.length) {
            if (!t || t.indexOf(i.constructor) > -1) return i;
          } else if (i instanceof n && (i = i.lookup(e.slice(1), t, !0))) return i;
        } else for (var o = 0; o < this.nestedArray.length; ++o) {
          if (this._nestedArray[o] instanceof n && (i = this._nestedArray[o].lookup(e, t, !0))) return i;
        }

        return null === this.parent || r ? null : this.parent.lookup(e, t);
      }, n.prototype.lookupType = function (e) {
        var t = this.lookup(e, [a]);
        if (!t) throw Error("no such type: " + e);
        return t;
      }, n.prototype.lookupEnum = function (e) {
        var t = this.lookup(e, [l]);
        if (!t) throw Error("no such Enum '" + e + "' in " + this);
        return t;
      }, n.prototype.lookupTypeOrEnum = function (e) {
        var t = this.lookup(e, [a, l]);
        if (!t) throw Error("no such Type or Enum '" + e + "' in " + this);
        return t;
      }, n.prototype.lookupService = function (e) {
        var t = this.lookup(e, [f]);
        if (!t) throw Error("no such Service '" + e + "' in " + this);
        return t;
      }, n._configure = function (e, t, r) {
        a = e, f = t, l = r;
      };
    }, function (e, t, r) {

      function i(e, t) {
        var r = 0,
            i = {};

        for (t |= 0; r < e.length;) {
          i[s[r + t]] = e[r++];
        }

        return i;
      }

      var n = t,
          o = r(0),
          s = ["double", "float", "int32", "uint32", "sint32", "fixed32", "sfixed32", "int64", "uint64", "sint64", "fixed64", "sfixed64", "bool", "string", "bytes"];
      n.basic = i([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2, 2]), n.defaults = i([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, !1, "", o.emptyArray, null]), n.long = i([0, 0, 0, 1, 1], 7), n.mapKey = i([0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2], 2), n.packed = i([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0]);
    }, function (e, t, r) {

      function i(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
      t.assign = function (e) {
        for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
          var r = t.shift();

          if (r) {
            if ("object" != _typeof$1(r)) throw new TypeError(r + "must be non-object");

            for (var n in r) {
              i(r, n) && (e[n] = r[n]);
            }
          }
        }

        return e;
      }, t.shrinkBuf = function (e, t) {
        return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
      };
      var o = {
        arraySet: function arraySet(e, t, r, i, n) {
          if (t.subarray && e.subarray) e.set(t.subarray(r, r + i), n);else for (var o = 0; o < i; o++) {
            e[n + o] = t[r + o];
          }
        },
        flattenChunks: function flattenChunks(e) {
          var t, r, i, n, o, s;

          for (i = 0, t = 0, r = e.length; t < r; t++) {
            i += e[t].length;
          }

          for (s = new Uint8Array(i), n = 0, t = 0, r = e.length; t < r; t++) {
            o = e[t], s.set(o, n), n += o.length;
          }

          return s;
        }
      },
          s = {
        arraySet: function arraySet(e, t, r, i, n) {
          for (var o = 0; o < i; o++) {
            e[n + o] = t[r + o];
          }
        },
        flattenChunks: function flattenChunks(e) {
          return [].concat.apply([], e);
        }
      };
      t.setTyped = function (e) {
        e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, o)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, s));
      }, t.setTyped(n);
    }, function (e, t, r) {

      function i(e, t, r) {
        this.fn = e, this.len = t, this.next = void 0, this.val = r;
      }

      function n() {}

      function o(e) {
        this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
      }

      function s() {
        this.len = 0, this.head = new i(n, 0, 0), this.tail = this.head, this.states = null;
      }

      function a(e, t, r) {
        t[r] = 255 & e;
      }

      function f(e, t) {
        this.len = e, this.next = void 0, this.val = t;
      }

      function l(e, t, r) {
        for (; e.hi;) {
          t[r++] = 127 & e.lo | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
        }

        for (; e.lo > 127;) {
          t[r++] = 127 & e.lo | 128, e.lo = e.lo >>> 7;
        }

        t[r++] = e.lo;
      }

      function u(e, t, r) {
        t[r] = 255 & e, t[r + 1] = e >>> 8 & 255, t[r + 2] = e >>> 16 & 255, t[r + 3] = e >>> 24;
      }

      e.exports = s;

      var h,
          c = r(1),
          d = c.LongBits,
          p = c.base64,
          y = c.utf8,
          m = function m() {
        return c.Buffer ? function () {
          return (s.create = function () {
            return new h();
          })();
        } : function () {
          return new s();
        };
      };

      s.create = m(), s.alloc = function (e) {
        return new c.Array(e);
      }, c.Array !== Array && (s.alloc = c.pool(s.alloc, c.Array.prototype.subarray)), s.prototype._push = function (e, t, r) {
        return this.tail = this.tail.next = new i(e, t, r), this.len += t, this;
      }, f.prototype = Object.create(i.prototype), f.prototype.fn = function (e, t, r) {
        for (; e > 127;) {
          t[r++] = 127 & e | 128, e >>>= 7;
        }

        t[r] = e;
      }, s.prototype.uint32 = function (e) {
        return this.len += (this.tail = this.tail.next = new f((e >>>= 0) < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5, e)).len, this;
      }, s.prototype.int32 = function (e) {
        return e < 0 ? this._push(l, 10, d.fromNumber(e)) : this.uint32(e);
      }, s.prototype.sint32 = function (e) {
        return this.uint32((e << 1 ^ e >> 31) >>> 0);
      }, s.prototype.uint64 = function (e) {
        var t = d.from(e);
        return this._push(l, t.length(), t);
      }, s.prototype.int64 = s.prototype.uint64, s.prototype.sint64 = function (e) {
        var t = d.from(e).zzEncode();
        return this._push(l, t.length(), t);
      }, s.prototype.bool = function (e) {
        return this._push(a, 1, e ? 1 : 0);
      }, s.prototype.fixed32 = function (e) {
        return this._push(u, 4, e >>> 0);
      }, s.prototype.sfixed32 = s.prototype.fixed32, s.prototype.fixed64 = function (e) {
        var t = d.from(e);
        return this._push(u, 4, t.lo)._push(u, 4, t.hi);
      }, s.prototype.sfixed64 = s.prototype.fixed64, s.prototype.float = function (e) {
        return this._push(c.float.writeFloatLE, 4, e);
      }, s.prototype.double = function (e) {
        return this._push(c.float.writeDoubleLE, 8, e);
      };
      var v = c.Array.prototype.set ? function (e, t, r) {
        t.set(e, r);
      } : function (e, t, r) {
        for (var i = 0; i < e.length; ++i) {
          t[r + i] = e[i];
        }
      };
      s.prototype.bytes = function (e) {
        var t = e.length >>> 0;
        if (!t) return this._push(a, 1, 0);

        if (c.isString(e)) {
          var r = s.alloc(t = p.length(e));
          p.decode(e, r, 0), e = r;
        }

        return this.uint32(t)._push(v, t, e);
      }, s.prototype.string = function (e) {
        var t = y.length(e);
        return t ? this.uint32(t)._push(y.write, t, e) : this._push(a, 1, 0);
      }, s.prototype.fork = function () {
        return this.states = new o(this), this.head = this.tail = new i(n, 0, 0), this.len = 0, this;
      }, s.prototype.reset = function () {
        return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new i(n, 0, 0), this.len = 0), this;
      }, s.prototype.ldelim = function () {
        var e = this.head,
            t = this.tail,
            r = this.len;
        return this.reset().uint32(r), r && (this.tail.next = e.next, this.tail = t, this.len += r), this;
      }, s.prototype.finish = function () {
        for (var e = this.head.next, t = this.constructor.alloc(this.len), r = 0; e;) {
          e.fn(e.val, t, r), r += e.len, e = e.next;
        }

        return t;
      }, s._configure = function (e) {
        h = e, s.create = m(), h._configure();
      };
    }, function (e, t, r) {

      function i(e, t) {
        return RangeError("index out of range: " + e.pos + " + " + (t || 1) + " > " + e.len);
      }

      function n(e) {
        this.buf = e, this.pos = 0, this.len = e.length;
      }

      function o() {
        var e = new u(0, 0),
            t = 0;

        if (!(this.len - this.pos > 4)) {
          for (; t < 3; ++t) {
            if (this.pos >= this.len) throw i(this);
            if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
          }

          return e.lo = (e.lo | (127 & this.buf[this.pos++]) << 7 * t) >>> 0, e;
        }

        for (; t < 4; ++t) {
          if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
        }

        if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 28) >>> 0, e.hi = (e.hi | (127 & this.buf[this.pos]) >> 4) >>> 0, this.buf[this.pos++] < 128) return e;

        if (t = 0, this.len - this.pos > 4) {
          for (; t < 5; ++t) {
            if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
          }
        } else for (; t < 5; ++t) {
          if (this.pos >= this.len) throw i(this);
          if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
        }

        throw Error("invalid varint encoding");
      }

      function s(e, t) {
        return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
      }

      function a() {
        if (this.pos + 8 > this.len) throw i(this, 8);
        return new u(s(this.buf, this.pos += 4), s(this.buf, this.pos += 4));
      }

      e.exports = n;

      var f,
          l = r(1),
          u = l.LongBits,
          h = l.utf8,
          c = "undefined" != typeof Uint8Array ? function (e) {
        if (e instanceof Uint8Array || Array.isArray(e)) return new n(e);
        throw Error("illegal buffer");
      } : function (e) {
        if (Array.isArray(e)) return new n(e);
        throw Error("illegal buffer");
      },
          d = function d() {
        return l.Buffer ? function (e) {
          return (n.create = function (e) {
            return l.Buffer.isBuffer(e) ? new f(e) : c(e);
          })(e);
        } : c;
      };

      n.create = d(), n.prototype._slice = l.Array.prototype.subarray || l.Array.prototype.slice, n.prototype.uint32 = function () {
        var e = 4294967295;
        return function () {
          if (e = (127 & this.buf[this.pos]) >>> 0, this.buf[this.pos++] < 128) return e;
          if (e = (e | (127 & this.buf[this.pos]) << 7) >>> 0, this.buf[this.pos++] < 128) return e;
          if (e = (e | (127 & this.buf[this.pos]) << 14) >>> 0, this.buf[this.pos++] < 128) return e;
          if (e = (e | (127 & this.buf[this.pos]) << 21) >>> 0, this.buf[this.pos++] < 128) return e;
          if (e = (e | (15 & this.buf[this.pos]) << 28) >>> 0, this.buf[this.pos++] < 128) return e;
          if ((this.pos += 5) > this.len) throw this.pos = this.len, i(this, 10);
          return e;
        };
      }(), n.prototype.int32 = function () {
        return 0 | this.uint32();
      }, n.prototype.sint32 = function () {
        var e = this.uint32();
        return e >>> 1 ^ -(1 & e) | 0;
      }, n.prototype.bool = function () {
        return 0 !== this.uint32();
      }, n.prototype.fixed32 = function () {
        if (this.pos + 4 > this.len) throw i(this, 4);
        return s(this.buf, this.pos += 4);
      }, n.prototype.sfixed32 = function () {
        if (this.pos + 4 > this.len) throw i(this, 4);
        return 0 | s(this.buf, this.pos += 4);
      }, n.prototype.float = function () {
        if (this.pos + 4 > this.len) throw i(this, 4);
        var e = l.float.readFloatLE(this.buf, this.pos);
        return this.pos += 4, e;
      }, n.prototype.double = function () {
        if (this.pos + 8 > this.len) throw i(this, 4);
        var e = l.float.readDoubleLE(this.buf, this.pos);
        return this.pos += 8, e;
      }, n.prototype.bytes = function () {
        var e = this.uint32(),
            t = this.pos,
            r = this.pos + e;
        if (r > this.len) throw i(this, e);
        return this.pos += e, Array.isArray(this.buf) ? this.buf.slice(t, r) : t === r ? new this.buf.constructor(0) : this._slice.call(this.buf, t, r);
      }, n.prototype.string = function () {
        var e = this.bytes();
        return h.read(e, 0, e.length);
      }, n.prototype.skip = function (e) {
        if ("number" == typeof e) {
          if (this.pos + e > this.len) throw i(this, e);
          this.pos += e;
        } else do {
          if (this.pos >= this.len) throw i(this);
        } while (128 & this.buf[this.pos++]);

        return this;
      }, n.prototype.skipType = function (e) {
        switch (e) {
          case 0:
            this.skip();
            break;

          case 1:
            this.skip(8);
            break;

          case 2:
            this.skip(this.uint32());
            break;

          case 3:
            for (; 4 != (e = 7 & this.uint32());) {
              this.skipType(e);
            }

            break;

          case 5:
            this.skip(4);
            break;

          default:
            throw Error("invalid wire type " + e + " at offset " + this.pos);
        }

        return this;
      }, n._configure = function (e) {
        f = e, n.create = d(), f._configure();
        var t = l.Long ? "toLong" : "toNumber";
        l.merge(n.prototype, {
          int64: function int64() {
            return o.call(this)[t](!1);
          },
          uint64: function uint64() {
            return o.call(this)[t](!0);
          },
          sint64: function sint64() {
            return o.call(this).zzDecode()[t](!1);
          },
          fixed64: function fixed64() {
            return a.call(this)[t](!0);
          },
          sfixed64: function sfixed64() {
            return a.call(this)[t](!1);
          }
        });
      };
    }, function (e, t, r) {

      function i(e, t, r, i) {
        if (Array.isArray(t) || (r = t, t = void 0), o.call(this, e, r), void 0 !== t && !Array.isArray(t)) throw TypeError("fieldNames must be an Array");
        this.oneof = t || [], this.fieldsArray = [], this.comment = i;
      }

      function n(e) {
        if (e.parent) for (var t = 0; t < e.fieldsArray.length; ++t) {
          e.fieldsArray[t].parent || e.parent.add(e.fieldsArray[t]);
        }
      }

      e.exports = i;
      var o = r(3);
      ((i.prototype = Object.create(o.prototype)).constructor = i).className = "OneOf";
      var s = r(4),
          a = r(0);
      i.fromJSON = function (e, t) {
        return new i(e, t.oneof, t.options, t.comment);
      }, i.prototype.toJSON = function (e) {
        var t = !!e && Boolean(e.keepComments);
        return a.toObject(["options", this.options, "oneof", this.oneof, "comment", t ? this.comment : void 0]);
      }, i.prototype.add = function (e) {
        if (!(e instanceof s)) throw TypeError("field must be a Field");
        return e.parent && e.parent !== this.parent && e.parent.remove(e), this.oneof.push(e.name), this.fieldsArray.push(e), e.partOf = this, n(this), this;
      }, i.prototype.remove = function (e) {
        if (!(e instanceof s)) throw TypeError("field must be a Field");
        var t = this.fieldsArray.indexOf(e);
        if (t < 0) throw Error(e + " is not a member of " + this);
        return this.fieldsArray.splice(t, 1), (t = this.oneof.indexOf(e.name)) > -1 && this.oneof.splice(t, 1), e.partOf = null, this;
      }, i.prototype.onAdd = function (e) {
        o.prototype.onAdd.call(this, e);

        for (var t = 0; t < this.oneof.length; ++t) {
          var r = e.get(this.oneof[t]);
          r && !r.partOf && (r.partOf = this, this.fieldsArray.push(r));
        }

        n(this);
      }, i.prototype.onRemove = function (e) {
        for (var t, r = 0; r < this.fieldsArray.length; ++r) {
          (t = this.fieldsArray[r]).parent && t.parent.remove(t);
        }

        o.prototype.onRemove.call(this, e);
      }, i.d = function () {
        for (var e = new Array(arguments.length), t = 0; t < arguments.length;) {
          e[t] = arguments[t++];
        }

        return function (t, r) {
          a.decorateType(t.constructor).add(new i(r, e)), Object.defineProperty(t, r, {
            get: a.oneOfGetter(e),
            set: a.oneOfSetter(e)
          });
        };
      };
    }, function (e, t, r) {

      function i(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          this[t[r]] = e[t[r]];
        }
      }

      e.exports = i;
      var n = r(1);
      i.create = function (e) {
        return this.$type.create(e);
      }, i.encode = function (e, t) {
        return this.$type.encode(e, t);
      }, i.encodeDelimited = function (e, t) {
        return this.$type.encodeDelimited(e, t);
      }, i.decode = function (e) {
        return this.$type.decode(e);
      }, i.decodeDelimited = function (e) {
        return this.$type.decodeDelimited(e);
      }, i.verify = function (e) {
        return this.$type.verify(e);
      }, i.fromObject = function (e) {
        return this.$type.fromObject(e);
      }, i.toObject = function (e, t) {
        return this.$type.toObject(e, t);
      }, i.prototype.toJSON = function () {
        return this.$type.toObject(this, n.toJSONOptions);
      };
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Parser = void 0;

      var i = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var i = t[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }

        return function (t, r, i) {
          return r && e(t.prototype, r), i && e(t, i), t;
        };
      }(),
          n = r(31),
          o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r(50));

      t.Parser = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
        }

        return i(e, [{
          key: "load",
          value: function value(e, t, r) {
            this.loadViaWorker(e, t, r);
          }
        }, {
          key: "loadViaWorker",
          value: function value(e, t, r) {
            (0, o.default)(e, function (e) {
              var r = e.movie;
              r.version = e.ver;
              var i = e.images,
                  o = new n.VideoEntity(r, i);
              t(o);
            }, r);
          }
        }]), e;
      }();
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RectPath = void 0;
      var i = r(5);

      t.RectPath = function (e) {
        function t(e, r, i, n, o, s, a) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var f = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != _typeof$1(t) && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

          return f._x = e, f._y = r, f._width = i, f._height = n, f._cornerRadius = o, f._transform = s, f._styles = a, f;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof$1(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(i.BezierPath);
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.EllipsePath = void 0;
      var i = r(5);

      t.EllipsePath = function (e) {
        function t(e, r, i, n, o, s) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var a = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != _typeof$1(t) && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

          return a._x = e, a._y = r, a._radiusX = i, a._radiusY = n, a._transform = o, a._styles = s, a;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof$1(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(i.BezierPath);
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = r(34),
          n = JSON.parse('{"nested":{"com":{"nested":{"opensource":{"nested":{"svga":{"options":{"objc_class_prefix":"SVGAProto","java_package":"com.opensource.svgaplayer.proto"},"nested":{"MovieParams":{"fields":{"viewBoxWidth":{"type":"float","id":1},"viewBoxHeight":{"type":"float","id":2},"fps":{"type":"int32","id":3},"frames":{"type":"int32","id":4}}},"SpriteEntity":{"fields":{"imageKey":{"type":"string","id":1},"frames":{"rule":"repeated","type":"FrameEntity","id":2},"matteKey":{"type":"string","id":3}}},"AudioEntity":{"fields":{"audioKey":{"type":"string","id":1},"startFrame":{"type":"int32","id":2},"endFrame":{"type":"int32","id":3},"startTime":{"type":"int32","id":4},"totalTime":{"type":"int32","id":5}}},"Layout":{"fields":{"x":{"type":"float","id":1},"y":{"type":"float","id":2},"width":{"type":"float","id":3},"height":{"type":"float","id":4}}},"Transform":{"fields":{"a":{"type":"float","id":1},"b":{"type":"float","id":2},"c":{"type":"float","id":3},"d":{"type":"float","id":4},"tx":{"type":"float","id":5},"ty":{"type":"float","id":6}}},"ShapeEntity":{"oneofs":{"args":{"oneof":["shape","rect","ellipse"]}},"fields":{"type":{"type":"ShapeType","id":1},"shape":{"type":"ShapeArgs","id":2},"rect":{"type":"RectArgs","id":3},"ellipse":{"type":"EllipseArgs","id":4},"styles":{"type":"ShapeStyle","id":10},"transform":{"type":"Transform","id":11}},"nested":{"ShapeType":{"values":{"SHAPE":0,"RECT":1,"ELLIPSE":2,"KEEP":3}},"ShapeArgs":{"fields":{"d":{"type":"string","id":1}}},"RectArgs":{"fields":{"x":{"type":"float","id":1},"y":{"type":"float","id":2},"width":{"type":"float","id":3},"height":{"type":"float","id":4},"cornerRadius":{"type":"float","id":5}}},"EllipseArgs":{"fields":{"x":{"type":"float","id":1},"y":{"type":"float","id":2},"radiusX":{"type":"float","id":3},"radiusY":{"type":"float","id":4}}},"ShapeStyle":{"fields":{"fill":{"type":"RGBAColor","id":1},"stroke":{"type":"RGBAColor","id":2},"strokeWidth":{"type":"float","id":3},"lineCap":{"type":"LineCap","id":4},"lineJoin":{"type":"LineJoin","id":5},"miterLimit":{"type":"float","id":6},"lineDashI":{"type":"float","id":7},"lineDashII":{"type":"float","id":8},"lineDashIII":{"type":"float","id":9}},"nested":{"RGBAColor":{"fields":{"r":{"type":"float","id":1},"g":{"type":"float","id":2},"b":{"type":"float","id":3},"a":{"type":"float","id":4}}},"LineCap":{"values":{"LineCap_BUTT":0,"LineCap_ROUND":1,"LineCap_SQUARE":2}},"LineJoin":{"values":{"LineJoin_MITER":0,"LineJoin_ROUND":1,"LineJoin_BEVEL":2}}}}}},"FrameEntity":{"fields":{"alpha":{"type":"float","id":1},"layout":{"type":"Layout","id":2},"transform":{"type":"Transform","id":3},"clipPath":{"type":"string","id":4},"shapes":{"rule":"repeated","type":"ShapeEntity","id":5}}},"MovieEntity":{"fields":{"version":{"type":"string","id":1},"params":{"type":"MovieParams","id":2},"images":{"keyType":"string","type":"bytes","id":3},"sprites":{"rule":"repeated","type":"SpriteEntity","id":4},"audios":{"rule":"repeated","type":"AudioEntity","id":5}}}}}}}}}}}'),
          o = t.proto = i.Root.fromJSON(n);
      t.ProtoMovieEntity = o.lookupType("com.opensource.svga.MovieEntity");
    }, function (e, t, r) {

      e.exports = function (e, t) {
        for (var r = new Array(arguments.length - 1), i = 0, n = 2, o = !0; n < arguments.length;) {
          r[i++] = arguments[n++];
        }

        return new Promise(function (n, s) {
          r[i] = function (e) {
            if (o) if (o = !1, e) s(e);else {
              for (var t = new Array(arguments.length - 1), r = 0; r < t.length;) {
                t[r++] = arguments[r];
              }

              n.apply(null, t);
            }
          };

          try {
            e.apply(t || null, r);
          } catch (e) {
            o && (o = !1, s(e));
          }
        });
      };
    }, function (module, exports, __webpack_require__) {

      function inquire(moduleName) {
        try {
          var mod = eval("quire".replace(/^/, "re"))(moduleName);
          if (mod && (mod.length || Object.keys(mod).length)) return mod;
        } catch (e) {}

        return null;
      }

      module.exports = inquire;
    }, function (e, t, r) {

      t.Service = r(46);
    }, function (e, t, r) {

      e.exports = {};
    }, function (e, t, r) {

      function i(e, t, r, i) {
        return t.resolvedType.group ? e("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", r, i, (t.id << 3 | 3) >>> 0, (t.id << 3 | 4) >>> 0) : e("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", r, i, (t.id << 3 | 2) >>> 0);
      }

      e.exports = function (e) {
        for (var t, r = s.codegen(["m", "w"], e.name + "$encode")("if(!w)")("w=Writer.create()"), a = e.fieldsArray.slice().sort(s.compareFieldsById), f = 0; f < a.length; ++f) {
          var l = a[f].resolve(),
              u = e._fieldsArray.indexOf(l),
              h = l.resolvedType instanceof n ? "int32" : l.type,
              c = o.basic[h];

          t = "m" + s.safeProp(l.name), l.map ? (r("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", t, l.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", t)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (l.id << 3 | 2) >>> 0, 8 | o.mapKey[l.keyType], l.keyType), void 0 === c ? r("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", u, t) : r(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | c, h, t), r("}")("}")) : l.repeated ? (r("if(%s!=null&&%s.length){", t, t), l.packed && void 0 !== o.packed[h] ? r("w.uint32(%i).fork()", (l.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", t)("w.%s(%s[i])", h, t)("w.ldelim()") : (r("for(var i=0;i<%s.length;++i)", t), void 0 === c ? i(r, l, u, t + "[i]") : r("w.uint32(%i).%s(%s[i])", (l.id << 3 | c) >>> 0, h, t)), r("}")) : (l.optional && r("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", t, l.name), void 0 === c ? i(r, l, u, t) : r("w.uint32(%i).%s(%s)", (l.id << 3 | c) >>> 0, h, t));
        }

        return r("return w");
      };

      var n = r(2),
          o = r(7),
          s = r(0);
    }, function (e, t, r) {

      function i(e, t) {
        o.call(this, e, t), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
      }

      function n(e) {
        return e._fieldsById = e._fieldsArray = e._oneofsArray = null, delete e.encode, delete e.decode, delete e.verify, e;
      }

      e.exports = i;
      var o = r(6);
      ((i.prototype = Object.create(o.prototype)).constructor = i).className = "Type";
      var s = r(2),
          a = r(11),
          f = r(4),
          l = r(23),
          u = r(24),
          h = r(12),
          c = r(10),
          d = r(9),
          p = r(0),
          y = r(21),
          m = r(26),
          v = r(27),
          g = r(28),
          b = r(29);
      Object.defineProperties(i.prototype, {
        fieldsById: {
          get: function get() {
            if (this._fieldsById) return this._fieldsById;
            this._fieldsById = {};

            for (var e = Object.keys(this.fields), t = 0; t < e.length; ++t) {
              var r = this.fields[e[t]],
                  i = r.id;
              if (this._fieldsById[i]) throw Error("duplicate id " + i + " in " + this);
              this._fieldsById[i] = r;
            }

            return this._fieldsById;
          }
        },
        fieldsArray: {
          get: function get() {
            return this._fieldsArray || (this._fieldsArray = p.toArray(this.fields));
          }
        },
        oneofsArray: {
          get: function get() {
            return this._oneofsArray || (this._oneofsArray = p.toArray(this.oneofs));
          }
        },
        ctor: {
          get: function get() {
            return this._ctor || (this.ctor = i.generateConstructor(this)());
          },
          set: function set(e) {
            var t = e.prototype;
            t instanceof h || ((e.prototype = new h()).constructor = e, p.merge(e.prototype, t)), e.$type = e.prototype.$type = this, p.merge(e, h, !0), this._ctor = e;

            for (var r = 0; r < this.fieldsArray.length; ++r) {
              this._fieldsArray[r].resolve();
            }

            var i = {};

            for (r = 0; r < this.oneofsArray.length; ++r) {
              i[this._oneofsArray[r].resolve().name] = {
                get: p.oneOfGetter(this._oneofsArray[r].oneof),
                set: p.oneOfSetter(this._oneofsArray[r].oneof)
              };
            }

            r && Object.defineProperties(e.prototype, i);
          }
        }
      }), i.generateConstructor = function (e) {
        for (var t, r = p.codegen(["p"], e.name), i = 0; i < e.fieldsArray.length; ++i) {
          (t = e._fieldsArray[i]).map ? r("this%s={}", p.safeProp(t.name)) : t.repeated && r("this%s=[]", p.safeProp(t.name));
        }

        return r("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
      }, i.fromJSON = function (e, t) {
        var r = new i(e, t.options);
        r.extensions = t.extensions, r.reserved = t.reserved;

        for (var n = Object.keys(t.fields), h = 0; h < n.length; ++h) {
          r.add((void 0 !== t.fields[n[h]].keyType ? l.fromJSON : f.fromJSON)(n[h], t.fields[n[h]]));
        }

        if (t.oneofs) for (n = Object.keys(t.oneofs), h = 0; h < n.length; ++h) {
          r.add(a.fromJSON(n[h], t.oneofs[n[h]]));
        }
        if (t.nested) for (n = Object.keys(t.nested), h = 0; h < n.length; ++h) {
          var c = t.nested[n[h]];
          r.add((void 0 !== c.id ? f.fromJSON : void 0 !== c.fields ? i.fromJSON : void 0 !== c.values ? s.fromJSON : void 0 !== c.methods ? u.fromJSON : o.fromJSON)(n[h], c));
        }
        return t.extensions && t.extensions.length && (r.extensions = t.extensions), t.reserved && t.reserved.length && (r.reserved = t.reserved), t.group && (r.group = !0), t.comment && (r.comment = t.comment), r;
      }, i.prototype.toJSON = function (e) {
        var t = o.prototype.toJSON.call(this, e),
            r = !!e && Boolean(e.keepComments);
        return p.toObject(["options", t && t.options || void 0, "oneofs", o.arrayToJSON(this.oneofsArray, e), "fields", o.arrayToJSON(this.fieldsArray.filter(function (e) {
          return !e.declaringField;
        }), e) || {}, "extensions", this.extensions && this.extensions.length ? this.extensions : void 0, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "group", this.group || void 0, "nested", t && t.nested || void 0, "comment", r ? this.comment : void 0]);
      }, i.prototype.resolveAll = function () {
        for (var e = this.fieldsArray, t = 0; t < e.length;) {
          e[t++].resolve();
        }

        var r = this.oneofsArray;

        for (t = 0; t < r.length;) {
          r[t++].resolve();
        }

        return o.prototype.resolveAll.call(this);
      }, i.prototype.get = function (e) {
        return this.fields[e] || this.oneofs && this.oneofs[e] || this.nested && this.nested[e] || null;
      }, i.prototype.add = function (e) {
        if (this.get(e.name)) throw Error("duplicate name '" + e.name + "' in " + this);

        if (e instanceof f && void 0 === e.extend) {
          if (this._fieldsById ? this._fieldsById[e.id] : this.fieldsById[e.id]) throw Error("duplicate id " + e.id + " in " + this);
          if (this.isReservedId(e.id)) throw Error("id " + e.id + " is reserved in " + this);
          if (this.isReservedName(e.name)) throw Error("name '" + e.name + "' is reserved in " + this);
          return e.parent && e.parent.remove(e), this.fields[e.name] = e, e.message = this, e.onAdd(this), n(this);
        }

        return e instanceof a ? (this.oneofs || (this.oneofs = {}), this.oneofs[e.name] = e, e.onAdd(this), n(this)) : o.prototype.add.call(this, e);
      }, i.prototype.remove = function (e) {
        if (e instanceof f && void 0 === e.extend) {
          if (!this.fields || this.fields[e.name] !== e) throw Error(e + " is not a member of " + this);
          return delete this.fields[e.name], e.parent = null, e.onRemove(this), n(this);
        }

        if (e instanceof a) {
          if (!this.oneofs || this.oneofs[e.name] !== e) throw Error(e + " is not a member of " + this);
          return delete this.oneofs[e.name], e.parent = null, e.onRemove(this), n(this);
        }

        return o.prototype.remove.call(this, e);
      }, i.prototype.isReservedId = function (e) {
        return o.isReservedId(this.reserved, e);
      }, i.prototype.isReservedName = function (e) {
        return o.isReservedName(this.reserved, e);
      }, i.prototype.create = function (e) {
        return new this.ctor(e);
      }, i.prototype.setup = function () {
        for (var e = this.fullName, t = [], r = 0; r < this.fieldsArray.length; ++r) {
          t.push(this._fieldsArray[r].resolve().resolvedType);
        }

        this.encode = y(this)({
          Writer: d,
          types: t,
          util: p
        }), this.decode = m(this)({
          Reader: c,
          types: t,
          util: p
        }), this.verify = v(this)({
          types: t,
          util: p
        }), this.fromObject = g.fromObject(this)({
          types: t,
          util: p
        }), this.toObject = g.toObject(this)({
          types: t,
          util: p
        });
        var i = b[e];

        if (i) {
          var n = Object.create(this);
          n.fromObject = this.fromObject, this.fromObject = i.fromObject.bind(n), n.toObject = this.toObject, this.toObject = i.toObject.bind(n);
        }

        return this;
      }, i.prototype.encode = function (e, t) {
        return this.setup().encode(e, t);
      }, i.prototype.encodeDelimited = function (e, t) {
        return this.encode(e, t && t.len ? t.fork() : t).ldelim();
      }, i.prototype.decode = function (e, t) {
        return this.setup().decode(e, t);
      }, i.prototype.decodeDelimited = function (e) {
        return e instanceof c || (e = c.create(e)), this.decode(e, e.uint32());
      }, i.prototype.verify = function (e) {
        return this.setup().verify(e);
      }, i.prototype.fromObject = function (e) {
        return this.setup().fromObject(e);
      }, i.prototype.toObject = function (e, t) {
        return this.setup().toObject(e, t);
      }, i.d = function (e) {
        return function (t) {
          p.decorateType(t, e);
        };
      };
    }, function (e, t, r) {

      function i(e, t, r, i, o, a) {
        if (n.call(this, e, t, i, void 0, void 0, o, a), !s.isString(r)) throw TypeError("keyType must be a string");
        this.keyType = r, this.resolvedKeyType = null, this.map = !0;
      }

      e.exports = i;
      var n = r(4);
      ((i.prototype = Object.create(n.prototype)).constructor = i).className = "MapField";
      var o = r(7),
          s = r(0);
      i.fromJSON = function (e, t) {
        return new i(e, t.id, t.keyType, t.type, t.options, t.comment);
      }, i.prototype.toJSON = function (e) {
        var t = !!e && Boolean(e.keepComments);
        return s.toObject(["keyType", this.keyType, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", t ? this.comment : void 0]);
      }, i.prototype.resolve = function () {
        if (this.resolved) return this;
        if (void 0 === o.mapKey[this.keyType]) throw Error("invalid key type: " + this.keyType);
        return n.prototype.resolve.call(this);
      }, i.d = function (e, t, r) {
        return "function" == typeof r ? r = s.decorateType(r).name : r && "object" == _typeof$1(r) && (r = s.decorateEnum(r).name), function (n, o) {
          s.decorateType(n.constructor).add(new i(o, e, t, r));
        };
      };
    }, function (e, t, r) {

      function i(e, t) {
        o.call(this, e, t), this.methods = {}, this._methodsArray = null;
      }

      function n(e) {
        return e._methodsArray = null, e;
      }

      e.exports = i;
      var o = r(6);
      ((i.prototype = Object.create(o.prototype)).constructor = i).className = "Service";
      var s = r(25),
          a = r(0),
          f = r(19);
      i.fromJSON = function (e, t) {
        var r = new i(e, t.options);
        if (t.methods) for (var n = Object.keys(t.methods), o = 0; o < n.length; ++o) {
          r.add(s.fromJSON(n[o], t.methods[n[o]]));
        }
        return t.nested && r.addJSON(t.nested), r.comment = t.comment, r;
      }, i.prototype.toJSON = function (e) {
        var t = o.prototype.toJSON.call(this, e),
            r = !!e && Boolean(e.keepComments);
        return a.toObject(["options", t && t.options || void 0, "methods", o.arrayToJSON(this.methodsArray, e) || {}, "nested", t && t.nested || void 0, "comment", r ? this.comment : void 0]);
      }, Object.defineProperty(i.prototype, "methodsArray", {
        get: function get() {
          return this._methodsArray || (this._methodsArray = a.toArray(this.methods));
        }
      }), i.prototype.get = function (e) {
        return this.methods[e] || o.prototype.get.call(this, e);
      }, i.prototype.resolveAll = function () {
        for (var e = this.methodsArray, t = 0; t < e.length; ++t) {
          e[t].resolve();
        }

        return o.prototype.resolve.call(this);
      }, i.prototype.add = function (e) {
        if (this.get(e.name)) throw Error("duplicate name '" + e.name + "' in " + this);
        return e instanceof s ? (this.methods[e.name] = e, e.parent = this, n(this)) : o.prototype.add.call(this, e);
      }, i.prototype.remove = function (e) {
        if (e instanceof s) {
          if (this.methods[e.name] !== e) throw Error(e + " is not a member of " + this);
          return delete this.methods[e.name], e.parent = null, n(this);
        }

        return o.prototype.remove.call(this, e);
      }, i.prototype.create = function (e, t, r) {
        for (var i, n = new f.Service(e, t, r), o = 0; o < this.methodsArray.length; ++o) {
          var s = a.lcFirst((i = this._methodsArray[o]).resolve().name).replace(/[^$\w_]/g, "");
          n[s] = a.codegen(["r", "c"], a.isReserved(s) ? s + "_" : s)("return this.rpcCall(m,q,s,r,c)")({
            m: i,
            q: i.resolvedRequestType.ctor,
            s: i.resolvedResponseType.ctor
          });
        }

        return n;
      };
    }, function (e, t, r) {

      function i(e, t, r, i, s, a, f, l, u) {
        if (o.isObject(s) ? (f = s, s = a = void 0) : o.isObject(a) && (f = a, a = void 0), void 0 !== t && !o.isString(t)) throw TypeError("type must be a string");
        if (!o.isString(r)) throw TypeError("requestType must be a string");
        if (!o.isString(i)) throw TypeError("responseType must be a string");
        n.call(this, e, f), this.type = t || "rpc", this.requestType = r, this.requestStream = !!s || void 0, this.responseType = i, this.responseStream = !!a || void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = l, this.parsedOptions = u;
      }

      e.exports = i;
      var n = r(3);
      ((i.prototype = Object.create(n.prototype)).constructor = i).className = "Method";
      var o = r(0);
      i.fromJSON = function (e, t) {
        return new i(e, t.type, t.requestType, t.responseType, t.requestStream, t.responseStream, t.options, t.comment, t.parsedOptions);
      }, i.prototype.toJSON = function (e) {
        var t = !!e && Boolean(e.keepComments);
        return o.toObject(["type", "rpc" !== this.type && this.type || void 0, "requestType", this.requestType, "requestStream", this.requestStream, "responseType", this.responseType, "responseStream", this.responseStream, "options", this.options, "comment", t ? this.comment : void 0, "parsedOptions", this.parsedOptions]);
      }, i.prototype.resolve = function () {
        return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), n.prototype.resolve.call(this));
      };
    }, function (e, t, r) {

      function i(e) {
        return "missing required '" + e.name + "'";
      }

      e.exports = function (e) {
        var t = s.codegen(["r", "l"], e.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (e.fieldsArray.filter(function (e) {
          return e.map;
        }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()");
        e.group && t("if((t&7)===4)")("break"), t("switch(t>>>3){");

        for (var r = 0; r < e.fieldsArray.length; ++r) {
          var a = e._fieldsArray[r].resolve(),
              f = a.resolvedType instanceof n ? "int32" : a.type,
              l = "m" + s.safeProp(a.name);

          t("case %i:", a.id), a.map ? (t("if(%s===util.emptyObject)", l)("%s={}", l)("var c2 = r.uint32()+r.pos"), void 0 !== o.defaults[a.keyType] ? t("k=%j", o.defaults[a.keyType]) : t("k=null"), void 0 !== o.defaults[f] ? t("value=%j", o.defaults[f]) : t("value=null"), t("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", a.keyType)("case 2:"), void 0 === o.basic[f] ? t("value=types[%i].decode(r,r.uint32())", r) : t("value=r.%s()", f), t("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), void 0 !== o.long[a.keyType] ? t('%s[typeof k==="object"?util.longToHash(k):k]=value', l) : t("%s[k]=value", l)) : a.repeated ? (t("if(!(%s&&%s.length))", l, l)("%s=[]", l), void 0 !== o.packed[f] && t("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", l, f)("}else"), void 0 === o.basic[f] ? t(a.resolvedType.group ? "%s.push(types[%i].decode(r))" : "%s.push(types[%i].decode(r,r.uint32()))", l, r) : t("%s.push(r.%s())", l, f)) : void 0 === o.basic[f] ? t(a.resolvedType.group ? "%s=types[%i].decode(r)" : "%s=types[%i].decode(r,r.uint32())", l, r) : t("%s=r.%s()", l, f), t("break");
        }

        for (t("default:")("r.skipType(t&7)")("break")("}")("}"), r = 0; r < e._fieldsArray.length; ++r) {
          var u = e._fieldsArray[r];
          u.required && t("if(!m.hasOwnProperty(%j))", u.name)("throw util.ProtocolError(%j,{instance:m})", i(u));
        }

        return t("return m");
      };

      var n = r(2),
          o = r(7),
          s = r(0);
    }, function (e, t, r) {

      function i(e, t) {
        return e.name + ": " + t + (e.repeated && "array" !== t ? "[]" : e.map && "object" !== t ? "{k:" + e.keyType + "}" : "") + " expected";
      }

      function n(e, t, r, n) {
        if (t.resolvedType) {
          if (t.resolvedType instanceof s) {
            e("switch(%s){", n)("default:")("return%j", i(t, "enum value"));

            for (var o = Object.keys(t.resolvedType.values), a = 0; a < o.length; ++a) {
              e("case %i:", t.resolvedType.values[o[a]]);
            }

            e("break")("}");
          } else e("{")("var e=types[%i].verify(%s);", r, n)("if(e)")("return%j+e", t.name + ".")("}");
        } else switch (t.type) {
          case "int32":
          case "uint32":
          case "sint32":
          case "fixed32":
          case "sfixed32":
            e("if(!util.isInteger(%s))", n)("return%j", i(t, "integer"));
            break;

          case "int64":
          case "uint64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            e("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", n, n, n, n)("return%j", i(t, "integer|Long"));
            break;

          case "float":
          case "double":
            e('if(typeof %s!=="number")', n)("return%j", i(t, "number"));
            break;

          case "bool":
            e('if(typeof %s!=="boolean")', n)("return%j", i(t, "boolean"));
            break;

          case "string":
            e("if(!util.isString(%s))", n)("return%j", i(t, "string"));
            break;

          case "bytes":
            e('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', n, n, n)("return%j", i(t, "buffer"));
        }
        return e;
      }

      function o(e, t, r) {
        switch (t.keyType) {
          case "int32":
          case "uint32":
          case "sint32":
          case "fixed32":
          case "sfixed32":
            e("if(!util.key32Re.test(%s))", r)("return%j", i(t, "integer key"));
            break;

          case "int64":
          case "uint64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            e("if(!util.key64Re.test(%s))", r)("return%j", i(t, "integer|Long key"));
            break;

          case "bool":
            e("if(!util.key2Re.test(%s))", r)("return%j", i(t, "boolean key"));
        }

        return e;
      }

      e.exports = function (e) {
        var t = a.codegen(["m"], e.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"),
            r = {};
        e.oneofsArray.length && t("var p={}");

        for (var s = 0; s < e.fieldsArray.length; ++s) {
          var f = e._fieldsArray[s].resolve(),
              l = "m" + a.safeProp(f.name);

          if (f.optional && t("if(%s!=null&&m.hasOwnProperty(%j)){", l, f.name), f.map) t("if(!util.isObject(%s))", l)("return%j", i(f, "object"))("var k=Object.keys(%s)", l)("for(var i=0;i<k.length;++i){"), o(t, f, "k[i]"), n(t, f, s, l + "[k[i]]")("}");else if (f.repeated) t("if(!Array.isArray(%s))", l)("return%j", i(f, "array"))("for(var i=0;i<%s.length;++i){", l), n(t, f, s, l + "[i]")("}");else {
            if (f.partOf) {
              var u = a.safeProp(f.partOf.name);
              1 === r[f.partOf.name] && t("if(p%s===1)", u)("return%j", f.partOf.name + ": multiple values"), r[f.partOf.name] = 1, t("p%s=1", u);
            }

            n(t, f, s, l);
          }
          f.optional && t("}");
        }

        return t("return null");
      };

      var s = r(2),
          a = r(0);
    }, function (e, t, r) {

      function i(e, t, r, i) {
        if (t.resolvedType) {
          if (t.resolvedType instanceof s) {
            e("switch(d%s){", i);

            for (var n = t.resolvedType.values, o = Object.keys(n), a = 0; a < o.length; ++a) {
              t.repeated && n[o[a]] === t.typeDefault && e("default:"), e("case%j:", o[a])("case %i:", n[o[a]])("m%s=%j", i, n[o[a]])("break");
            }

            e("}");
          } else e('if(typeof d%s!=="object")', i)("throw TypeError(%j)", t.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", i, r, i);
        } else {
          var f = !1;

          switch (t.type) {
            case "double":
            case "float":
              e("m%s=Number(d%s)", i, i);
              break;

            case "uint32":
            case "fixed32":
              e("m%s=d%s>>>0", i, i);
              break;

            case "int32":
            case "sint32":
            case "sfixed32":
              e("m%s=d%s|0", i, i);
              break;

            case "uint64":
              f = !0;

            case "int64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              e("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", i, i, f)('else if(typeof d%s==="string")', i)("m%s=parseInt(d%s,10)", i, i)('else if(typeof d%s==="number")', i)("m%s=d%s", i, i)('else if(typeof d%s==="object")', i)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", i, i, i, f ? "true" : "");
              break;

            case "bytes":
              e('if(typeof d%s==="string")', i)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", i, i, i)("else if(d%s.length)", i)("m%s=d%s", i, i);
              break;

            case "string":
              e("m%s=String(d%s)", i, i);
              break;

            case "bool":
              e("m%s=Boolean(d%s)", i, i);
          }
        }
        return e;
      }

      function n(e, t, r, i) {
        if (t.resolvedType) t.resolvedType instanceof s ? e("d%s=o.enums===String?types[%i].values[m%s]:m%s", i, r, i, i) : e("d%s=types[%i].toObject(m%s,o)", i, r, i);else {
          var n = !1;

          switch (t.type) {
            case "double":
            case "float":
              e("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", i, i, i, i);
              break;

            case "uint64":
              n = !0;

            case "int64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              e('if(typeof m%s==="number")', i)("d%s=o.longs===String?String(m%s):m%s", i, i, i)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", i, i, i, i, n ? "true" : "", i);
              break;

            case "bytes":
              e("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", i, i, i, i, i);
              break;

            default:
              e("d%s=m%s", i, i);
          }
        }
        return e;
      }

      var o = t,
          s = r(2),
          a = r(0);
      o.fromObject = function (e) {
        var t = e.fieldsArray,
            r = a.codegen(["d"], e.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
        if (!t.length) return r("return new this.ctor");
        r("var m=new this.ctor");

        for (var n = 0; n < t.length; ++n) {
          var o = t[n].resolve(),
              f = a.safeProp(o.name);
          o.map ? (r("if(d%s){", f)('if(typeof d%s!=="object")', f)("throw TypeError(%j)", o.fullName + ": object expected")("m%s={}", f)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", f), i(r, o, n, f + "[ks[i]]")("}")("}")) : o.repeated ? (r("if(d%s){", f)("if(!Array.isArray(d%s))", f)("throw TypeError(%j)", o.fullName + ": array expected")("m%s=[]", f)("for(var i=0;i<d%s.length;++i){", f), i(r, o, n, f + "[i]")("}")("}")) : (o.resolvedType instanceof s || r("if(d%s!=null){", f), i(r, o, n, f), o.resolvedType instanceof s || r("}"));
        }

        return r("return m");
      }, o.toObject = function (e) {
        var t = e.fieldsArray.slice().sort(a.compareFieldsById);
        if (!t.length) return a.codegen()("return {}");

        for (var r = a.codegen(["m", "o"], e.name + "$toObject")("if(!o)")("o={}")("var d={}"), i = [], o = [], f = [], l = 0; l < t.length; ++l) {
          t[l].partOf || (t[l].resolve().repeated ? i : t[l].map ? o : f).push(t[l]);
        }

        if (i.length) {
          for (r("if(o.arrays||o.defaults){"), l = 0; l < i.length; ++l) {
            r("d%s=[]", a.safeProp(i[l].name));
          }

          r("}");
        }

        if (o.length) {
          for (r("if(o.objects||o.defaults){"), l = 0; l < o.length; ++l) {
            r("d%s={}", a.safeProp(o[l].name));
          }

          r("}");
        }

        if (f.length) {
          for (r("if(o.defaults){"), l = 0; l < f.length; ++l) {
            var u = f[l],
                h = a.safeProp(u.name);
            if (u.resolvedType instanceof s) r("d%s=o.enums===String?%j:%j", h, u.resolvedType.valuesById[u.typeDefault], u.typeDefault);else if (u.long) r("if(util.Long){")("var n=new util.Long(%i,%i,%j)", u.typeDefault.low, u.typeDefault.high, u.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", h)("}else")("d%s=o.longs===String?%j:%i", h, u.typeDefault.toString(), u.typeDefault.toNumber());else if (u.bytes) {
              var c = "[" + Array.prototype.slice.call(u.typeDefault).join(",") + "]";
              r("if(o.bytes===String)d%s=%j", h, String.fromCharCode.apply(String, u.typeDefault))("else{")("d%s=%s", h, c)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", h, h)("}");
            } else r("d%s=%j", h, u.typeDefault);
          }

          r("}");
        }

        var d = !1;

        for (l = 0; l < t.length; ++l) {
          u = t[l];

          var p = e._fieldsArray.indexOf(u);

          h = a.safeProp(u.name);
          u.map ? (d || (d = !0, r("var ks2")), r("if(m%s&&(ks2=Object.keys(m%s)).length){", h, h)("d%s={}", h)("for(var j=0;j<ks2.length;++j){"), n(r, u, p, h + "[ks2[j]]")("}")) : u.repeated ? (r("if(m%s&&m%s.length){", h, h)("d%s=[]", h)("for(var j=0;j<m%s.length;++j){", h), n(r, u, p, h + "[j]")("}")) : (r("if(m%s!=null&&m.hasOwnProperty(%j)){", h, u.name), n(r, u, p, h), u.partOf && r("if(o.oneofs)")("d%s=%j", a.safeProp(u.partOf.name), u.name)), r("}");
        }

        return r("return d");
      };
    }, function (e, t, r) {

      var i = t,
          n = r(12);
      i[".google.protobuf.Any"] = {
        fromObject: function fromObject(e) {
          if (e && e["@type"]) {
            var t = e["@type"].substring(e["@type"].lastIndexOf("/") + 1),
                r = this.lookup(t);

            if (r) {
              var i = "." === e["@type"].charAt(0) ? e["@type"].substr(1) : e["@type"];
              return -1 === i.indexOf("/") && (i = "/" + i), this.create({
                type_url: i,
                value: r.encode(r.fromObject(e)).finish()
              });
            }
          }

          return this.fromObject(e);
        },
        toObject: function toObject(e, t) {
          var r = "",
              i = "";

          if (t && t.json && e.type_url && e.value) {
            i = e.type_url.substring(e.type_url.lastIndexOf("/") + 1), r = e.type_url.substring(0, e.type_url.lastIndexOf("/") + 1);
            var o = this.lookup(i);
            o && (e = o.decode(e.value));
          }

          if (!(e instanceof this.ctor) && e instanceof n) {
            var s = e.$type.toObject(e, t);
            return "" === r && (r = "type.googleapis.com/"), i = r + ("." === e.$type.fullName[0] ? e.$type.fullName.substr(1) : e.$type.fullName), s["@type"] = i, s;
          }

          return this.toObject(e, t);
        }
      };
    }, function (e, t, r) {

      function i(e) {
        s.call(this, "", e), this.deferred = [], this.files = [];
      }

      function n() {}

      function o(e, t) {
        var r = t.parent.lookup(t.extend);

        if (r) {
          var i = new u(t.fullName, t.id, t.type, t.rule, void 0, t.options);
          return i.declaringField = t, t.extensionField = i, r.add(i), !0;
        }

        return !1;
      }

      e.exports = i;
      var s = r(6);
      ((i.prototype = Object.create(s.prototype)).constructor = i).className = "Root";
      var a,
          f,
          l,
          u = r(4),
          h = r(2),
          c = r(11),
          d = r(0);
      i.fromJSON = function (e, t) {
        return t || (t = new i()), e.options && t.setOptions(e.options), t.addJSON(e.nested);
      }, i.prototype.resolvePath = d.path.resolve, i.prototype.fetch = d.fetch, i.prototype.load = function e(t, r, i) {
        function o(e, t) {
          if (i) {
            var r = i;
            if (i = null, c) throw e;
            r(e, t);
          }
        }

        function s(e) {
          var t = e.lastIndexOf("google/protobuf/");

          if (t > -1) {
            var r = e.substring(t);
            if (r in l) return r;
          }

          return null;
        }

        function a(e, t) {
          try {
            if (d.isString(t) && "{" === t.charAt(0) && (t = JSON.parse(t)), d.isString(t)) {
              f.filename = e;
              var i,
                  n = f(t, h, r),
                  a = 0;
              if (n.imports) for (; a < n.imports.length; ++a) {
                (i = s(n.imports[a]) || h.resolvePath(e, n.imports[a])) && u(i);
              }
              if (n.weakImports) for (a = 0; a < n.weakImports.length; ++a) {
                (i = s(n.weakImports[a]) || h.resolvePath(e, n.weakImports[a])) && u(i, !0);
              }
            } else h.setOptions(t.options).addJSON(t.nested);
          } catch (e) {
            o(e);
          }

          c || p || o(null, h);
        }

        function u(e, t) {
          if (!(h.files.indexOf(e) > -1)) {
            if (h.files.push(e), e in l) return void (c ? a(e, l[e]) : (++p, setTimeout(function () {
              --p, a(e, l[e]);
            })));

            if (c) {
              var r;

              try {
                r = d.fs.readFileSync(e).toString("utf8");
              } catch (e) {
                return void (t || o(e));
              }

              a(e, r);
            } else ++p, h.fetch(e, function (r, n) {
              if (--p, i) return r ? void (t ? p || o(null, h) : o(r)) : void a(e, n);
            });
          }
        }

        "function" == typeof r && (i = r, r = void 0);
        var h = this;
        if (!i) return d.asPromise(e, h, t, r);
        var c = i === n,
            p = 0;
        d.isString(t) && (t = [t]);

        for (var y, m = 0; m < t.length; ++m) {
          (y = h.resolvePath("", t[m])) && u(y);
        }

        if (c) return h;
        p || o(null, h);
      }, i.prototype.loadSync = function (e, t) {
        if (!d.isNode) throw Error("not supported");
        return this.load(e, t, n);
      }, i.prototype.resolveAll = function () {
        if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function (e) {
          return "'extend " + e.extend + "' in " + e.parent.fullName;
        }).join(", "));
        return s.prototype.resolveAll.call(this);
      };
      var p = /^[A-Z]/;
      i.prototype._handleAdd = function (e) {
        if (e instanceof u) void 0 === e.extend || e.extensionField || o(0, e) || this.deferred.push(e);else if (e instanceof h) p.test(e.name) && (e.parent[e.name] = e.values);else if (!(e instanceof c)) {
          if (e instanceof a) for (var t = 0; t < this.deferred.length;) {
            o(0, this.deferred[t]) ? this.deferred.splice(t, 1) : ++t;
          }

          for (var r = 0; r < e.nestedArray.length; ++r) {
            this._handleAdd(e._nestedArray[r]);
          }

          p.test(e.name) && (e.parent[e.name] = e);
        }
      }, i.prototype._handleRemove = function (e) {
        if (e instanceof u) {
          if (void 0 !== e.extend) if (e.extensionField) e.extensionField.parent.remove(e.extensionField), e.extensionField = null;else {
            var t = this.deferred.indexOf(e);
            t > -1 && this.deferred.splice(t, 1);
          }
        } else if (e instanceof h) p.test(e.name) && delete e.parent[e.name];else if (e instanceof s) {
          for (var r = 0; r < e.nestedArray.length; ++r) {
            this._handleRemove(e._nestedArray[r]);
          }

          p.test(e.name) && delete e.parent[e.name];
        }
      }, i._configure = function (e, t, r) {
        a = e, f = t, l = r;
      };
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.VideoEntity = void 0;

      var i = "function" == typeof Symbol && "symbol" == _typeof$1(Symbol.iterator) ? function (e) {
        return _typeof$1(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
      },
          n = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var i = t[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }

        return function (t, r, i) {
          return r && e(t.prototype, r), i && e(t, i), t;
        };
      }(),
          o = r(32),
          s = r(16).ProtoMovieEntity;

      t.VideoEntity = function () {
        function e(t, r) {
          ((function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }))(this, e), this.version = "", this.videoSize = {
            width: 0,
            height: 0
          }, this.FPS = 20, this.frames = 0, this.images = {}, this.sprites = [], this.audios = [], "object" === (void 0 === t ? "undefined" : i(t)) && t.$type == s ? ("object" === i(t.params) && (this.version = t.ver, this.videoSize.width = t.params.viewBoxWidth || 0, this.videoSize.height = t.params.viewBoxHeight || 0, this.FPS = t.params.fps || 20, this.frames = t.params.frames || 0), this.resetSprites(t), this.audios = t.audios) : t && (t.movie && (t.movie.viewBox && (this.videoSize.width = parseFloat(t.movie.viewBox.width) || 0, this.videoSize.height = parseFloat(t.movie.viewBox.height) || 0), this.version = t.ver, this.FPS = parseInt(t.movie.fps) || 20, this.frames = parseInt(t.movie.frames) || 0), this.resetSprites(t)), r && (this.images = r);
        }

        return n(e, [{
          key: "resetSprites",
          value: function value(e) {
            e.sprites instanceof Array && (this.sprites = e.sprites.map(function (e) {
              return new o.SpriteEntity(e);
            }));
          }
        }]), e;
      }();
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.SpriteEntity = void 0;
      var i = r(33);
      r(5), r(14), r(15), t.SpriteEntity = function e(t) {
        ((function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }))(this, e), this.matteKey = null, this.imageKey = null, this.frames = [], this.matteKey = t.matteKey, this.imageKey = t.imageKey, t.frames && (this.frames = t.frames.map(function (e) {
          return new i.FrameEntity(e);
        }));
      };
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.FrameEntity = void 0;
      var i = r(5);

      t.FrameEntity = function e(t) {
        ((function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }))(this, e), this.alpha = 0, this.transform = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          tx: 0,
          ty: 0
        }, this.layout = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        }, this.nx = 0, this.ny = 0, this.maskPath = null, this.shapes = [], this.alpha = parseFloat(t.alpha) || 0, t.layout && (this.layout.x = parseFloat(t.layout.x) || 0, this.layout.y = parseFloat(t.layout.y) || 0, this.layout.width = parseFloat(t.layout.width) || 0, this.layout.height = parseFloat(t.layout.height) || 0), t.transform && (this.transform.a = parseFloat(t.transform.a) || 1, this.transform.b = parseFloat(t.transform.b) || 0, this.transform.c = parseFloat(t.transform.c) || 0, this.transform.d = parseFloat(t.transform.d) || 1, this.transform.tx = parseFloat(t.transform.tx) || 0, this.transform.ty = parseFloat(t.transform.ty) || 0), t.clipPath && t.clipPath.length > 0 && (this.maskPath = new i.BezierPath(t.clipPath, void 0, {
          fill: "#000000"
        })), t.shapes && (t.shapes instanceof Array && t.shapes.forEach(function (e) {
          switch (e.pathArgs = e.args, e.type) {
            case 0:
              e.type = "shape", e.pathArgs = e.shape;
              break;

            case 1:
              e.type = "rect", e.pathArgs = e.rect;
              break;

            case 2:
              e.type = "ellipse", e.pathArgs = e.ellipse;
              break;

            case 3:
              e.type = "keep";
          }

          if (e.styles) {
            e.styles.fill && ("number" == typeof e.styles.fill.r && (e.styles.fill[0] = e.styles.fill.r), "number" == typeof e.styles.fill.g && (e.styles.fill[1] = e.styles.fill.g), "number" == typeof e.styles.fill.b && (e.styles.fill[2] = e.styles.fill.b), "number" == typeof e.styles.fill.a && (e.styles.fill[3] = e.styles.fill.a)), e.styles.stroke && ("number" == typeof e.styles.stroke.r && (e.styles.stroke[0] = e.styles.stroke.r), "number" == typeof e.styles.stroke.g && (e.styles.stroke[1] = e.styles.stroke.g), "number" == typeof e.styles.stroke.b && (e.styles.stroke[2] = e.styles.stroke.b), "number" == typeof e.styles.stroke.a && (e.styles.stroke[3] = e.styles.stroke.a));
            var t = e.styles.lineDash || [];

            switch (e.styles.lineDashI > 0 && t.push(e.styles.lineDashI), e.styles.lineDashII > 0 && (t.length < 1 && t.push(0), t.push(e.styles.lineDashII), t.push(0)), e.styles.lineDashIII > 0 && (t.length < 2 && (t.push(0), t.push(0)), t[2] = e.styles.lineDashIII), e.styles.lineDash = t, e.styles.lineJoin) {
              case 0:
                e.styles.lineJoin = "miter";
                break;

              case 1:
                e.styles.lineJoin = "round";
                break;

              case 2:
                e.styles.lineJoin = "bevel";
            }

            switch (e.styles.lineCap) {
              case 0:
                e.styles.lineCap = "butt";
                break;

              case 1:
                e.styles.lineCap = "round";
                break;

              case 2:
                e.styles.lineCap = "square";
            }
          }
        }), t.shapes[0] && "keep" === t.shapes[0].type ? this.shapes = e.lastShapes : (this.shapes = t.shapes, e.lastShapes = t.shapes));
        var r = this.transform.a * this.layout.x + this.transform.c * this.layout.y + this.transform.tx,
            n = this.transform.a * (this.layout.x + this.layout.width) + this.transform.c * this.layout.y + this.transform.tx,
            o = this.transform.a * this.layout.x + this.transform.c * (this.layout.y + this.layout.height) + this.transform.tx,
            s = this.transform.a * (this.layout.x + this.layout.width) + this.transform.c * (this.layout.y + this.layout.height) + this.transform.tx,
            a = this.transform.b * this.layout.x + this.transform.d * this.layout.y + this.transform.ty,
            f = this.transform.b * (this.layout.x + this.layout.width) + this.transform.d * this.layout.y + this.transform.ty,
            l = this.transform.b * this.layout.x + this.transform.d * (this.layout.y + this.layout.height) + this.transform.ty,
            u = this.transform.b * (this.layout.x + this.layout.width) + this.transform.d * (this.layout.y + this.layout.height) + this.transform.ty;
        this.nx = Math.min(Math.min(o, s), Math.min(r, n)), this.ny = Math.min(Math.min(l, u), Math.min(a, f));
      };
    }, function (e, t, r) {

      e.exports = r(35);
    }, function (e, t, r) {

      var i = e.exports = r(36);
      i.build = "light", i.load = function (e, t, r) {
        return "function" == typeof t ? (r = t, t = new i.Root()) : t || (t = new i.Root()), t.load(e, r);
      }, i.loadSync = function (e, t) {
        return t || (t = new i.Root()), t.loadSync(e);
      }, i.encoder = r(21), i.decoder = r(26), i.verifier = r(27), i.converter = r(28), i.ReflectionObject = r(3), i.Namespace = r(6), i.Root = r(30), i.Enum = r(2), i.Type = r(22), i.Field = r(4), i.OneOf = r(11), i.MapField = r(23), i.Service = r(24), i.Method = r(25), i.Message = r(12), i.wrappers = r(29), i.types = r(7), i.util = r(0), i.ReflectionObject._configure(i.Root), i.Namespace._configure(i.Type, i.Service, i.Enum), i.Root._configure(i.Type), i.Field._configure(i.Type);
    }, function (e, t, r) {

      function i() {
        n.util._configure(), n.Writer._configure(n.BufferWriter), n.Reader._configure(n.BufferReader);
      }

      var n = t;
      n.build = "minimal", n.Writer = r(9), n.BufferWriter = r(44), n.Reader = r(10), n.BufferReader = r(45), n.util = r(1), n.rpc = r(19), n.roots = r(20), n.configure = i, i();
    }, function (e, t) {
      var r;

      r = function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (e) {
        "object" == (typeof window === "undefined" ? "undefined" : _typeof$1(window)) && (r = window);
      }

      e.exports = r;
    }, function (e, t, r) {

      var i = t;

      i.length = function (e) {
        var t = e.length;
        if (!t) return 0;

        for (var r = 0; --t % 4 > 1 && "=" === e.charAt(t);) {
          ++r;
        }

        return Math.ceil(3 * e.length) / 4 - r;
      };

      for (var n = new Array(64), o = new Array(123), s = 0; s < 64;) {
        o[n[s] = s < 26 ? s + 65 : s < 52 ? s + 71 : s < 62 ? s - 4 : s - 59 | 43] = s++;
      }

      i.encode = function (e, t, r) {
        for (var i, o = null, s = [], a = 0, f = 0; t < r;) {
          var l = e[t++];

          switch (f) {
            case 0:
              s[a++] = n[l >> 2], i = (3 & l) << 4, f = 1;
              break;

            case 1:
              s[a++] = n[i | l >> 4], i = (15 & l) << 2, f = 2;
              break;

            case 2:
              s[a++] = n[i | l >> 6], s[a++] = n[63 & l], f = 0;
          }

          a > 8191 && ((o || (o = [])).push(String.fromCharCode.apply(String, s)), a = 0);
        }

        return f && (s[a++] = n[i], s[a++] = 61, 1 === f && (s[a++] = 61)), o ? (a && o.push(String.fromCharCode.apply(String, s.slice(0, a))), o.join("")) : String.fromCharCode.apply(String, s.slice(0, a));
      }, i.decode = function (e, t, r) {
        for (var i, n = r, s = 0, a = 0; a < e.length;) {
          var f = e.charCodeAt(a++);
          if (61 === f && s > 1) break;
          if (void 0 === (f = o[f])) throw Error("invalid encoding");

          switch (s) {
            case 0:
              i = f, s = 1;
              break;

            case 1:
              t[r++] = i << 2 | (48 & f) >> 4, i = f, s = 2;
              break;

            case 2:
              t[r++] = (15 & i) << 4 | (60 & f) >> 2, i = f, s = 3;
              break;

            case 3:
              t[r++] = (3 & i) << 6 | f, s = 0;
          }
        }

        if (1 === s) throw Error("invalid encoding");
        return r - n;
      }, i.test = function (e) {
        return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(e);
      };
    }, function (e, t, r) {

      function i() {
        this._listeners = {};
      }

      e.exports = i, i.prototype.on = function (e, t, r) {
        return (this._listeners[e] || (this._listeners[e] = [])).push({
          fn: t,
          ctx: r || this
        }), this;
      }, i.prototype.off = function (e, t) {
        if (void 0 === e) this._listeners = {};else if (void 0 === t) this._listeners[e] = [];else for (var r = this._listeners[e], i = 0; i < r.length;) {
          r[i].fn === t ? r.splice(i, 1) : ++i;
        }
        return this;
      }, i.prototype.emit = function (e) {
        var t = this._listeners[e];

        if (t) {
          for (var r = [], i = 1; i < arguments.length;) {
            r.push(arguments[i++]);
          }

          for (i = 0; i < t.length;) {
            t[i].fn.apply(t[i++].ctx, r);
          }
        }

        return this;
      };
    }, function (e, t, r) {

      function i(e) {
        return "undefined" != typeof Float32Array ? function () {
          function t(e, t, r) {
            o[0] = e, t[r] = s[0], t[r + 1] = s[1], t[r + 2] = s[2], t[r + 3] = s[3];
          }

          function r(e, t, r) {
            o[0] = e, t[r] = s[3], t[r + 1] = s[2], t[r + 2] = s[1], t[r + 3] = s[0];
          }

          function i(e, t) {
            return s[0] = e[t], s[1] = e[t + 1], s[2] = e[t + 2], s[3] = e[t + 3], o[0];
          }

          function n(e, t) {
            return s[3] = e[t], s[2] = e[t + 1], s[1] = e[t + 2], s[0] = e[t + 3], o[0];
          }

          var o = new Float32Array([-0]),
              s = new Uint8Array(o.buffer),
              a = 128 === s[3];
          e.writeFloatLE = a ? t : r, e.writeFloatBE = a ? r : t, e.readFloatLE = a ? i : n, e.readFloatBE = a ? n : i;
        }() : function () {
          function t(e, t, r, i) {
            var n = t < 0 ? 1 : 0;
            if (n && (t = -t), 0 === t) e(1 / t > 0 ? 0 : 2147483648, r, i);else if (isNaN(t)) e(2143289344, r, i);else if (t > 34028234663852886e22) e((n << 31 | 2139095040) >>> 0, r, i);else if (t < 11754943508222875e-54) e((n << 31 | Math.round(t / 1401298464324817e-60)) >>> 0, r, i);else {
              var o = Math.floor(Math.log(t) / Math.LN2);
              e((n << 31 | o + 127 << 23 | 8388607 & Math.round(t * Math.pow(2, -o) * 8388608)) >>> 0, r, i);
            }
          }

          function r(e, t, r) {
            var i = e(t, r),
                n = 2 * (i >> 31) + 1,
                o = i >>> 23 & 255,
                s = 8388607 & i;
            return 255 === o ? s ? NaN : n * (1 / 0) : 0 === o ? 1401298464324817e-60 * n * s : n * Math.pow(2, o - 150) * (s + 8388608);
          }

          e.writeFloatLE = t.bind(null, n), e.writeFloatBE = t.bind(null, o), e.readFloatLE = r.bind(null, s), e.readFloatBE = r.bind(null, a);
        }(), "undefined" != typeof Float64Array ? function () {
          function t(e, t, r) {
            o[0] = e, t[r] = s[0], t[r + 1] = s[1], t[r + 2] = s[2], t[r + 3] = s[3], t[r + 4] = s[4], t[r + 5] = s[5], t[r + 6] = s[6], t[r + 7] = s[7];
          }

          function r(e, t, r) {
            o[0] = e, t[r] = s[7], t[r + 1] = s[6], t[r + 2] = s[5], t[r + 3] = s[4], t[r + 4] = s[3], t[r + 5] = s[2], t[r + 6] = s[1], t[r + 7] = s[0];
          }

          function i(e, t) {
            return s[0] = e[t], s[1] = e[t + 1], s[2] = e[t + 2], s[3] = e[t + 3], s[4] = e[t + 4], s[5] = e[t + 5], s[6] = e[t + 6], s[7] = e[t + 7], o[0];
          }

          function n(e, t) {
            return s[7] = e[t], s[6] = e[t + 1], s[5] = e[t + 2], s[4] = e[t + 3], s[3] = e[t + 4], s[2] = e[t + 5], s[1] = e[t + 6], s[0] = e[t + 7], o[0];
          }

          var o = new Float64Array([-0]),
              s = new Uint8Array(o.buffer),
              a = 128 === s[7];
          e.writeDoubleLE = a ? t : r, e.writeDoubleBE = a ? r : t, e.readDoubleLE = a ? i : n, e.readDoubleBE = a ? n : i;
        }() : function () {
          function t(e, t, r, i, n, o) {
            var s = i < 0 ? 1 : 0;
            if (s && (i = -i), 0 === i) e(0, n, o + t), e(1 / i > 0 ? 0 : 2147483648, n, o + r);else if (isNaN(i)) e(0, n, o + t), e(2146959360, n, o + r);else if (i > 17976931348623157e292) e(0, n, o + t), e((s << 31 | 2146435072) >>> 0, n, o + r);else {
              var a;
              if (i < 22250738585072014e-324) e((a = i / 5e-324) >>> 0, n, o + t), e((s << 31 | a / 4294967296) >>> 0, n, o + r);else {
                var f = Math.floor(Math.log(i) / Math.LN2);
                1024 === f && (f = 1023), e(4503599627370496 * (a = i * Math.pow(2, -f)) >>> 0, n, o + t), e((s << 31 | f + 1023 << 20 | 1048576 * a & 1048575) >>> 0, n, o + r);
              }
            }
          }

          function r(e, t, r, i, n) {
            var o = e(i, n + t),
                s = e(i, n + r),
                a = 2 * (s >> 31) + 1,
                f = s >>> 20 & 2047,
                l = 4294967296 * (1048575 & s) + o;
            return 2047 === f ? l ? NaN : a * (1 / 0) : 0 === f ? 5e-324 * a * l : a * Math.pow(2, f - 1075) * (l + 4503599627370496);
          }

          e.writeDoubleLE = t.bind(null, n, 0, 4), e.writeDoubleBE = t.bind(null, o, 4, 0), e.readDoubleLE = r.bind(null, s, 0, 4), e.readDoubleBE = r.bind(null, a, 4, 0);
        }(), e;
      }

      function n(e, t, r) {
        t[r] = 255 & e, t[r + 1] = e >>> 8 & 255, t[r + 2] = e >>> 16 & 255, t[r + 3] = e >>> 24;
      }

      function o(e, t, r) {
        t[r] = e >>> 24, t[r + 1] = e >>> 16 & 255, t[r + 2] = e >>> 8 & 255, t[r + 3] = 255 & e;
      }

      function s(e, t) {
        return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
      }

      function a(e, t) {
        return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
      }

      e.exports = i(i);
    }, function (e, t, r) {

      var i = t;
      i.length = function (e) {
        for (var t = 0, r = 0, i = 0; i < e.length; ++i) {
          (r = e.charCodeAt(i)) < 128 ? t += 1 : r < 2048 ? t += 2 : 55296 == (64512 & r) && 56320 == (64512 & e.charCodeAt(i + 1)) ? (++i, t += 4) : t += 3;
        }

        return t;
      }, i.read = function (e, t, r) {
        if (r - t < 1) return "";

        for (var i, n = null, o = [], s = 0; t < r;) {
          (i = e[t++]) < 128 ? o[s++] = i : i > 191 && i < 224 ? o[s++] = (31 & i) << 6 | 63 & e[t++] : i > 239 && i < 365 ? (i = ((7 & i) << 18 | (63 & e[t++]) << 12 | (63 & e[t++]) << 6 | 63 & e[t++]) - 65536, o[s++] = 55296 + (i >> 10), o[s++] = 56320 + (1023 & i)) : o[s++] = (15 & i) << 12 | (63 & e[t++]) << 6 | 63 & e[t++], s > 8191 && ((n || (n = [])).push(String.fromCharCode.apply(String, o)), s = 0);
        }

        return n ? (s && n.push(String.fromCharCode.apply(String, o.slice(0, s))), n.join("")) : String.fromCharCode.apply(String, o.slice(0, s));
      }, i.write = function (e, t, r) {
        for (var i, n, o = r, s = 0; s < e.length; ++s) {
          (i = e.charCodeAt(s)) < 128 ? t[r++] = i : i < 2048 ? (t[r++] = i >> 6 | 192, t[r++] = 63 & i | 128) : 55296 == (64512 & i) && 56320 == (64512 & (n = e.charCodeAt(s + 1))) ? (i = 65536 + ((1023 & i) << 10) + (1023 & n), ++s, t[r++] = i >> 18 | 240, t[r++] = i >> 12 & 63 | 128, t[r++] = i >> 6 & 63 | 128, t[r++] = 63 & i | 128) : (t[r++] = i >> 12 | 224, t[r++] = i >> 6 & 63 | 128, t[r++] = 63 & i | 128);
        }

        return r - o;
      };
    }, function (e, t, r) {

      e.exports = function (e, t, r) {
        var i = r || 8192,
            n = i >>> 1,
            o = null,
            s = i;
        return function (r) {
          if (r < 1 || r > n) return e(r);
          s + r > i && (o = e(i), s = 0);
          var a = t.call(o, s, s += r);
          return 7 & s && (s = 1 + (7 | s)), a;
        };
      };
    }, function (e, t, r) {

      function i(e, t) {
        this.lo = e >>> 0, this.hi = t >>> 0;
      }

      e.exports = i;
      var n = r(1),
          o = i.zero = new i(0, 0);
      o.toNumber = function () {
        return 0;
      }, o.zzEncode = o.zzDecode = function () {
        return this;
      }, o.length = function () {
        return 1;
      };
      var s = i.zeroHash = "\0\0\0\0\0\0\0\0";
      i.fromNumber = function (e) {
        if (0 === e) return o;
        var t = e < 0;
        t && (e = -e);
        var r = e >>> 0,
            n = (e - r) / 4294967296 >>> 0;
        return t && (n = ~n >>> 0, r = ~r >>> 0, ++r > 4294967295 && (r = 0, ++n > 4294967295 && (n = 0))), new i(r, n);
      }, i.from = function (e) {
        if ("number" == typeof e) return i.fromNumber(e);

        if (n.isString(e)) {
          if (!n.Long) return i.fromNumber(parseInt(e, 10));
          e = n.Long.fromString(e);
        }

        return e.low || e.high ? new i(e.low >>> 0, e.high >>> 0) : o;
      }, i.prototype.toNumber = function (e) {
        if (!e && this.hi >>> 31) {
          var t = 1 + ~this.lo >>> 0,
              r = ~this.hi >>> 0;
          return t || (r = r + 1 >>> 0), -(t + 4294967296 * r);
        }

        return this.lo + 4294967296 * this.hi;
      }, i.prototype.toLong = function (e) {
        return n.Long ? new n.Long(0 | this.lo, 0 | this.hi, Boolean(e)) : {
          low: 0 | this.lo,
          high: 0 | this.hi,
          unsigned: Boolean(e)
        };
      };
      var a = String.prototype.charCodeAt;
      i.fromHash = function (e) {
        return e === s ? o : new i((a.call(e, 0) | a.call(e, 1) << 8 | a.call(e, 2) << 16 | a.call(e, 3) << 24) >>> 0, (a.call(e, 4) | a.call(e, 5) << 8 | a.call(e, 6) << 16 | a.call(e, 7) << 24) >>> 0);
      }, i.prototype.toHash = function () {
        return String.fromCharCode(255 & this.lo, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, 255 & this.hi, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
      }, i.prototype.zzEncode = function () {
        var e = this.hi >> 31;
        return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ e) >>> 0, this.lo = (this.lo << 1 ^ e) >>> 0, this;
      }, i.prototype.zzDecode = function () {
        var e = -(1 & this.lo);
        return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ e) >>> 0, this.hi = (this.hi >>> 1 ^ e) >>> 0, this;
      }, i.prototype.length = function () {
        var e = this.lo,
            t = (this.lo >>> 28 | this.hi << 4) >>> 0,
            r = this.hi >>> 24;
        return 0 === r ? 0 === t ? e < 16384 ? e < 128 ? 1 : 2 : e < 2097152 ? 3 : 4 : t < 16384 ? t < 128 ? 5 : 6 : t < 2097152 ? 7 : 8 : r < 128 ? 9 : 10;
      };
    }, function (e, t, r) {

      function i() {
        o.call(this);
      }

      function n(e, t, r) {
        e.length < 40 ? s.utf8.write(e, t, r) : t.utf8Write ? t.utf8Write(e, r) : t.write(e, r);
      }

      e.exports = i;
      var o = r(9);
      (i.prototype = Object.create(o.prototype)).constructor = i;
      var s = r(1);
      i._configure = function () {
        i.alloc = s._Buffer_allocUnsafe, i.writeBytesBuffer = s.Buffer && s.Buffer.prototype instanceof Uint8Array && "set" === s.Buffer.prototype.set.name ? function (e, t, r) {
          t.set(e, r);
        } : function (e, t, r) {
          if (e.copy) e.copy(t, r, 0, e.length);else for (var i = 0; i < e.length;) {
            t[r++] = e[i++];
          }
        };
      }, i.prototype.bytes = function (e) {
        s.isString(e) && (e = s._Buffer_from(e, "base64"));
        var t = e.length >>> 0;
        return this.uint32(t), t && this._push(i.writeBytesBuffer, t, e), this;
      }, i.prototype.string = function (e) {
        var t = s.Buffer.byteLength(e);
        return this.uint32(t), t && this._push(n, t, e), this;
      }, i._configure();
    }, function (e, t, r) {

      function i(e) {
        n.call(this, e);
      }

      e.exports = i;
      var n = r(10);
      (i.prototype = Object.create(n.prototype)).constructor = i;
      var o = r(1);
      i._configure = function () {
        o.Buffer && (i.prototype._slice = o.Buffer.prototype.slice);
      }, i.prototype.string = function () {
        var e = this.uint32();
        return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + e, this.len));
      }, i._configure();
    }, function (e, t, r) {

      function i(e, t, r) {
        if ("function" != typeof e) throw TypeError("rpcImpl must be a function");
        n.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = Boolean(t), this.responseDelimited = Boolean(r);
      }

      e.exports = i;
      var n = r(1);
      (i.prototype = Object.create(n.EventEmitter.prototype)).constructor = i, i.prototype.rpcCall = function e(t, r, i, o, s) {
        if (!o) throw TypeError("request must be specified");
        var a = this;
        if (!s) return n.asPromise(e, a, t, r, i, o);
        if (a.rpcImpl) try {
          return a.rpcImpl(t, r[a.requestDelimited ? "encodeDelimited" : "encode"](o).finish(), function (e, r) {
            if (e) return a.emit("error", e, t), s(e);

            if (null !== r) {
              if (!(r instanceof i)) try {
                r = i[a.responseDelimited ? "decodeDelimited" : "decode"](r);
              } catch (e) {
                return a.emit("error", e, t), s(e);
              }
              return a.emit("data", r, t), s(null, r);
            }

            a.end(!0);
          });
        } catch (e) {
          return a.emit("error", e, t), void setTimeout(function () {
            s(e);
          }, 0);
        } else setTimeout(function () {
          s(Error("already ended"));
        }, 0);
      }, i.prototype.end = function (e) {
        return this.rpcImpl && (e || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
      };
    }, function (e, t, r) {

      function i(e, t) {
        function r(e) {
          if ("string" != typeof e) {
            var t = n();

            if (i.verbose && console.log("codegen: " + t), t = "return " + t, e) {
              for (var s = Object.keys(e), a = new Array(s.length + 1), f = new Array(s.length), l = 0; l < s.length;) {
                a[l] = s[l], f[l] = e[s[l++]];
              }

              return a[l] = t, Function.apply(null, a).apply(null, f);
            }

            return Function(t)();
          }

          for (var u = new Array(arguments.length - 1), h = 0; h < u.length;) {
            u[h] = arguments[++h];
          }

          if (h = 0, e = e.replace(/%([%dfijs])/g, function (e, t) {
            var r = u[h++];

            switch (t) {
              case "d":
              case "f":
                return String(Number(r));

              case "i":
                return String(Math.floor(r));

              case "j":
                return JSON.stringify(r);

              case "s":
                return String(r);
            }

            return "%";
          }), h !== u.length) throw Error("parameter count mismatch");
          return o.push(e), r;
        }

        function n(r) {
          return "function " + (r || t || "") + "(" + (e && e.join(",") || "") + "){\n  " + o.join("\n  ") + "\n}";
        }

        "string" == typeof e && (t = e, e = void 0);
        var o = [];
        return r.toString = n, r;
      }

      e.exports = i, i.verbose = !1;
    }, function (e, t, r) {

      function i(e, t, r) {
        return "function" == typeof t ? (r = t, t = {}) : t || (t = {}), r ? !t.xhr && o && o.readFile ? o.readFile(e, function (n, o) {
          return n && "undefined" != typeof XMLHttpRequest ? i.xhr(e, t, r) : n ? r(n) : r(null, t.binary ? o : o.toString("utf8"));
        }) : i.xhr(e, t, r) : n(i, this, e, t);
      }

      e.exports = i;
      var n = r(17),
          o = r(18)("fs");

      i.xhr = function (e, t, r) {
        var i = new XMLHttpRequest();
        i.onreadystatechange = function () {
          if (4 === i.readyState) {
            if (0 !== i.status && 200 !== i.status) return r(Error("status " + i.status));

            if (t.binary) {
              var e = i.response;

              if (!e) {
                e = [];

                for (var n = 0; n < i.responseText.length; ++n) {
                  e.push(255 & i.responseText.charCodeAt(n));
                }
              }

              return r(null, "undefined" != typeof Uint8Array ? new Uint8Array(e) : e);
            }

            return r(null, i.responseText);
          }
        }, t.binary && ("overrideMimeType" in i && i.overrideMimeType("text/plain; charset=x-user-defined"), i.responseType = "arraybuffer"), i.open("GET", e), i.send();
      };
    }, function (e, t, r) {

      var i = t,
          n = i.isAbsolute = function (e) {
        return /^(?:\/|\w+:)/.test(e);
      },
          o = i.normalize = function (e) {
        var t = (e = e.replace(/\\/g, "/").replace(/\/{2,}/g, "/")).split("/"),
            r = n(e),
            i = "";
        r && (i = t.shift() + "/");

        for (var o = 0; o < t.length;) {
          ".." === t[o] ? o > 0 && ".." !== t[o - 1] ? t.splice(--o, 2) : r ? t.splice(o, 1) : ++o : "." === t[o] ? t.splice(o, 1) : ++o;
        }

        return i + t.join("/");
      };

      i.resolve = function (e, t, r) {
        return r || (t = o(t)), n(t) ? t : (r || (e = o(e)), (e = e.replace(/(?:\/|^)[^/]+$/, "")).length ? o(e + "/" + t) : t);
      };
    }, function (e, t, r) {

      var i = "function" == typeof Symbol && "symbol" == _typeof$1(Symbol.iterator) ? function (e) {
        return _typeof$1(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
      },
          n = r(16).ProtoMovieEntity,
          o = r(8).assign,
          s = r(51),
          a = {};
      o(a, s);

      var f = function f(e) {
        for (var t = [], r = 0; r < e.length; r += 32768) {
          t.push(String.fromCharCode.apply(null, e.subarray(r, r + 32768)));
        }

        return t.join("");
      },
          l = {
        loadAssets: function loadAssets(e, t, r) {
          if ("object" === ("undefined" == typeof JSZipUtils ? "undefined" : i(JSZipUtils)) && "function" == typeof JSZip) {
            if ("[object File]" == e.toString()) l._readBlobAsArrayBuffer(e, function (e) {
              var i = new Uint8Array(e, 0, 4);
              80 == i[0] && 75 == i[1] && 3 == i[2] && 4 == i[3] ? JSZip.loadAsync(e).then(function (e) {
                l._decodeAssets(e, t);
              }) : l.load_viaProto(e, t, r);
            });else if (e.indexOf("data:svga/1.0;base64,") >= 0) {
              var n = l._base64ToArrayBuffer(e.substring(21));

              JSZip.loadAsync(n).then(function (e) {
                l._decodeAssets(e, t);
              });
            } else if (e.indexOf("data:svga/2.0;base64,") >= 0) {
              n = l._base64ToArrayBuffer(e.substring(21));
              l.load_viaProto(n, t, r);
            } else JSZipUtils.getBinaryContent(e, function (e, i) {
              if (e) throw r && r(e), console.error(e), e;
              var n = new Uint8Array(i, 0, 4);
              80 == n[0] && 75 == n[1] && 3 == n[2] && 4 == n[3] ? JSZip.loadAsync(i).then(function (e) {
                l._decodeAssets(e, t);
              }) : l.load_viaProto(i, t, r);
            });
          } else {
            var o = new XMLHttpRequest();
            o.open("GET", e, !0), o.responseType = "arraybuffer", o.onload = function () {
              l.load_viaProto(o.response, t, r);
            }, o.onerror = function (e) {
              if (!r) throw console.error(e), e;
              r(e);
            }, o.send();
          }
        },
        load_viaProto: function load_viaProto(e, t, r) {
          try {
            var i = a.inflate(e),
                o = n.decode(i),
                s = {};

            l._loadImages(s, void 0, o, function () {
              o.ver = "2.0", t({
                movie: o,
                images: s
              });
            });
          } catch (e) {
            if (r) return void r(e);
            throw console.error(e), e;
          }
        },
        _decodeAssets: function _decodeAssets(e, t) {
          var r = "1.0";
          e.file("movie.binary") && (r = "1.5"), e.file("movie.spec").async("string").then(function (i) {
            var n = JSON.parse(i),
                o = {};
            n.ver = r, l._loadImages(o, e, n, function () {
              t({
                movie: n,
                images: o
              });
            });
          });
        },
        _loadImages: function _loadImages(e, t, r, o) {
          var s = this;

          if ("object" === (void 0 === r ? "undefined" : i(r)) && r.$type == n) {
            var a = !0;
            if (t) e: for (var u in r.images) {
              switch (function (i) {
                if (r.images.hasOwnProperty(i)) {
                  var n = r.images[i],
                      u = f(n);
                  return e.hasOwnProperty(i) ? "continue" : (a = !1, t.file(u + ".png").async("base64").then(function (n) {
                    e[i] = n, l._loadImages(e, t, r, o);
                  }.bind(s)), "break");
                }
              }(u)) {
                case "continue":
                  continue;

                case "break":
                  break e;
              }
            } else for (var h in r.images) {
              if (r.images.hasOwnProperty(h)) {
                var c = r.images[h],
                    d = void 0;

                try {
                  d = f(c);
                } catch (e) {
                  d = f(c);
                }

                e[h] = btoa(d);
              }
            }
            a && o.call(this);
          } else {
            a = !0;

            for (var p in r.images) {
              if (r.images.hasOwnProperty(p)) {
                var y = r.images[p];
                if (e.hasOwnProperty(p)) continue;
                a = !1, t.file(y + ".png").async("base64").then(function (i) {
                  e[p] = i, l._loadImages(e, t, r, o);
                }.bind(this));
                break;
              }
            }

            a && o.call(this);
          }
        },
        _base64ToArrayBuffer: function _base64ToArrayBuffer(e) {
          for (var t = window.atob(e), r = t.length, i = new Uint8Array(r), n = 0; n < r; n++) {
            i[n] = t.charCodeAt(n);
          }

          return i.buffer;
        },
        _readBlobAsArrayBuffer: function _readBlobAsArrayBuffer(e, t) {
          var r = new FileReader();
          r.onload = function (e) {
            t(e.target.result);
          }, r.readAsArrayBuffer(e);
        }
      };

      e.exports = function (e, t, r) {
        l.loadAssets(e, t, r);
      };
    }, function (e, t, r) {

      function i(e) {
        if (!(this instanceof i)) return new i(e);
        this.options = s.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ""
        }, e || {});
        var t = this.options;
        t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u(), this.strm.avail_out = 0;
        var r = o.inflateInit2(this.strm, t.windowBits);
        if (r !== f.Z_OK) throw new Error(l[r]);
        if (this.header = new h(), o.inflateGetHeader(this.strm, this.header), t.dictionary && ("string" == typeof t.dictionary ? t.dictionary = a.string2buf(t.dictionary) : "[object ArrayBuffer]" === c.call(t.dictionary) && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (r = o.inflateSetDictionary(this.strm, t.dictionary)) !== f.Z_OK)) throw new Error(l[r]);
      }

      function n(e, t) {
        var r = new i(t);
        if (r.push(e, !0), r.err) throw r.msg || l[r.err];
        return r.result;
      }

      var o = r(52),
          s = r(8),
          a = r(57),
          f = r(58),
          l = r(59),
          u = r(60),
          h = r(61),
          c = Object.prototype.toString;
      i.prototype.push = function (e, t) {
        var r,
            i,
            n,
            l,
            u,
            h = this.strm,
            d = this.options.chunkSize,
            p = this.options.dictionary,
            y = !1;
        if (this.ended) return !1;
        i = t === ~~t ? t : !0 === t ? f.Z_FINISH : f.Z_NO_FLUSH, "string" == typeof e ? h.input = a.binstring2buf(e) : "[object ArrayBuffer]" === c.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;

        do {
          if (0 === h.avail_out && (h.output = new s.Buf8(d), h.next_out = 0, h.avail_out = d), (r = o.inflate(h, f.Z_NO_FLUSH)) === f.Z_NEED_DICT && p && (r = o.inflateSetDictionary(this.strm, p)), r === f.Z_BUF_ERROR && !0 === y && (r = f.Z_OK, y = !1), r !== f.Z_STREAM_END && r !== f.Z_OK) return this.onEnd(r), this.ended = !0, !1;
          h.next_out && (0 !== h.avail_out && r !== f.Z_STREAM_END && (0 !== h.avail_in || i !== f.Z_FINISH && i !== f.Z_SYNC_FLUSH) || ("string" === this.options.to ? (n = a.utf8border(h.output, h.next_out), l = h.next_out - n, u = a.buf2string(h.output, n), h.next_out = l, h.avail_out = d - l, l && s.arraySet(h.output, h.output, n, l, 0), this.onData(u)) : this.onData(s.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (y = !0);
        } while ((h.avail_in > 0 || 0 === h.avail_out) && r !== f.Z_STREAM_END);

        return r === f.Z_STREAM_END && (i = f.Z_FINISH), i === f.Z_FINISH ? (r = o.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === f.Z_OK) : i !== f.Z_SYNC_FLUSH || (this.onEnd(f.Z_OK), h.avail_out = 0, !0);
      }, i.prototype.onData = function (e) {
        this.chunks.push(e);
      }, i.prototype.onEnd = function (e) {
        e === f.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = s.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
      }, t.Inflate = i, t.inflate = n, t.inflateRaw = function (e, t) {
        return (t = t || {}).raw = !0, n(e, t);
      }, t.ungzip = n;
    }, function (e, t, r) {

      function i(e) {
        return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
      }

      function n() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new d.Buf16(320), this.work = new d.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }

      function o(e) {
        var t;
        return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = C, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new d.Buf32(ue), t.distcode = t.distdyn = new d.Buf32(he), t.sane = 1, t.back = -1, O) : j;
      }

      function s(e) {
        var t;
        return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, o(e)) : j;
      }

      function a(e, t) {
        var r, i;
        return e && e.state ? (i = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? j : (null !== i.window && i.wbits !== t && (i.window = null), i.wrap = r, i.wbits = t, s(e))) : j;
      }

      function f(e, t) {
        var r, i;
        return e ? (i = new n(), e.state = i, i.window = null, (r = a(e, t)) !== O && (e.state = null), r) : j;
      }

      function l(e) {
        if (de) {
          var t;

          for (h = new d.Buf32(512), c = new d.Buf32(32), t = 0; t < 144;) {
            e.lens[t++] = 8;
          }

          for (; t < 256;) {
            e.lens[t++] = 9;
          }

          for (; t < 280;) {
            e.lens[t++] = 7;
          }

          for (; t < 288;) {
            e.lens[t++] = 8;
          }

          for (v(b, e.lens, 0, 288, h, 0, e.work, {
            bits: 9
          }), t = 0; t < 32;) {
            e.lens[t++] = 5;
          }

          v(_, e.lens, 0, 32, c, 0, e.work, {
            bits: 5
          }), de = !1;
        }

        e.lencode = h, e.lenbits = 9, e.distcode = c, e.distbits = 5;
      }

      function u(e, t, r, i) {
        var n,
            o = e.state;
        return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new d.Buf8(o.wsize)), i >= o.wsize ? (d.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : ((n = o.wsize - o.wnext) > i && (n = i), d.arraySet(o.window, t, r - i, n, o.wnext), (i -= n) ? (d.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += n, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += n))), 0;
      }

      var h,
          c,
          d = r(8),
          p = r(53),
          y = r(54),
          m = r(55),
          v = r(56),
          g = 0,
          b = 1,
          _ = 2,
          w = 4,
          k = 5,
          x = 6,
          O = 0,
          A = 1,
          S = 2,
          j = -2,
          T = -3,
          E = -4,
          N = -5,
          F = 8,
          C = 1,
          B = 2,
          I = 3,
          P = 4,
          R = 5,
          D = 6,
          M = 7,
          L = 8,
          z = 9,
          J = 10,
          U = 11,
          Z = 12,
          K = 13,
          q = 14,
          $ = 15,
          V = 16,
          H = 17,
          W = 18,
          G = 19,
          Y = 20,
          Q = 21,
          X = 22,
          ee = 23,
          te = 24,
          re = 25,
          ie = 26,
          ne = 27,
          oe = 28,
          se = 29,
          ae = 30,
          fe = 31,
          le = 32,
          ue = 852,
          he = 592,
          ce = 15,
          de = !0;
      t.inflateReset = s, t.inflateReset2 = a, t.inflateResetKeep = o, t.inflateInit = function (e) {
        return f(e, ce);
      }, t.inflateInit2 = f, t.inflate = function (e, t) {
        var r,
            n,
            o,
            s,
            a,
            f,
            h,
            c,
            ue,
            he,
            ce,
            de,
            pe,
            ye,
            me,
            ve,
            ge,
            be,
            _e,
            we,
            ke,
            xe,
            Oe,
            Ae,
            Se = 0,
            je = new d.Buf8(4),
            Te = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

        if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return j;
        (r = e.state).mode === Z && (r.mode = K), a = e.next_out, o = e.output, h = e.avail_out, s = e.next_in, n = e.input, f = e.avail_in, c = r.hold, ue = r.bits, he = f, ce = h, xe = O;

        e: for (;;) {
          switch (r.mode) {
            case C:
              if (0 === r.wrap) {
                r.mode = K;
                break;
              }

              for (; ue < 16;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if (2 & r.wrap && 35615 === c) {
                r.check = 0, je[0] = 255 & c, je[1] = c >>> 8 & 255, r.check = y(r.check, je, 2, 0), c = 0, ue = 0, r.mode = B;
                break;
              }

              if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & c) << 8) + (c >> 8)) % 31) {
                e.msg = "incorrect header check", r.mode = ae;
                break;
              }

              if ((15 & c) !== F) {
                e.msg = "unknown compression method", r.mode = ae;
                break;
              }

              if (ue -= 4, ke = 8 + (15 & (c >>>= 4)), 0 === r.wbits) r.wbits = ke;else if (ke > r.wbits) {
                e.msg = "invalid window size", r.mode = ae;
                break;
              }
              r.dmax = 1 << ke, e.adler = r.check = 1, r.mode = 512 & c ? J : Z, c = 0, ue = 0;
              break;

            case B:
              for (; ue < 16;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if (r.flags = c, (255 & r.flags) !== F) {
                e.msg = "unknown compression method", r.mode = ae;
                break;
              }

              if (57344 & r.flags) {
                e.msg = "unknown header flags set", r.mode = ae;
                break;
              }

              r.head && (r.head.text = c >> 8 & 1), 512 & r.flags && (je[0] = 255 & c, je[1] = c >>> 8 & 255, r.check = y(r.check, je, 2, 0)), c = 0, ue = 0, r.mode = I;

            case I:
              for (; ue < 32;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              r.head && (r.head.time = c), 512 & r.flags && (je[0] = 255 & c, je[1] = c >>> 8 & 255, je[2] = c >>> 16 & 255, je[3] = c >>> 24 & 255, r.check = y(r.check, je, 4, 0)), c = 0, ue = 0, r.mode = P;

            case P:
              for (; ue < 16;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              r.head && (r.head.xflags = 255 & c, r.head.os = c >> 8), 512 & r.flags && (je[0] = 255 & c, je[1] = c >>> 8 & 255, r.check = y(r.check, je, 2, 0)), c = 0, ue = 0, r.mode = R;

            case R:
              if (1024 & r.flags) {
                for (; ue < 16;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                r.length = c, r.head && (r.head.extra_len = c), 512 & r.flags && (je[0] = 255 & c, je[1] = c >>> 8 & 255, r.check = y(r.check, je, 2, 0)), c = 0, ue = 0;
              } else r.head && (r.head.extra = null);

              r.mode = D;

            case D:
              if (1024 & r.flags && ((de = r.length) > f && (de = f), de && (r.head && (ke = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), d.arraySet(r.head.extra, n, s, de, ke)), 512 & r.flags && (r.check = y(r.check, n, de, s)), f -= de, s += de, r.length -= de), r.length)) break e;
              r.length = 0, r.mode = M;

            case M:
              if (2048 & r.flags) {
                if (0 === f) break e;
                de = 0;

                do {
                  ke = n[s + de++], r.head && ke && r.length < 65536 && (r.head.name += String.fromCharCode(ke));
                } while (ke && de < f);

                if (512 & r.flags && (r.check = y(r.check, n, de, s)), f -= de, s += de, ke) break e;
              } else r.head && (r.head.name = null);

              r.length = 0, r.mode = L;

            case L:
              if (4096 & r.flags) {
                if (0 === f) break e;
                de = 0;

                do {
                  ke = n[s + de++], r.head && ke && r.length < 65536 && (r.head.comment += String.fromCharCode(ke));
                } while (ke && de < f);

                if (512 & r.flags && (r.check = y(r.check, n, de, s)), f -= de, s += de, ke) break e;
              } else r.head && (r.head.comment = null);

              r.mode = z;

            case z:
              if (512 & r.flags) {
                for (; ue < 16;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                if (c !== (65535 & r.check)) {
                  e.msg = "header crc mismatch", r.mode = ae;
                  break;
                }

                c = 0, ue = 0;
              }

              r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = Z;
              break;

            case J:
              for (; ue < 32;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              e.adler = r.check = i(c), c = 0, ue = 0, r.mode = U;

            case U:
              if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = f, r.hold = c, r.bits = ue, S;
              e.adler = r.check = 1, r.mode = Z;

            case Z:
              if (t === k || t === x) break e;

            case K:
              if (r.last) {
                c >>>= 7 & ue, ue -= 7 & ue, r.mode = ne;
                break;
              }

              for (; ue < 3;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              switch (r.last = 1 & c, ue -= 1, 3 & (c >>>= 1)) {
                case 0:
                  r.mode = q;
                  break;

                case 1:
                  if (l(r), r.mode = Y, t === x) {
                    c >>>= 2, ue -= 2;
                    break e;
                  }

                  break;

                case 2:
                  r.mode = H;
                  break;

                case 3:
                  e.msg = "invalid block type", r.mode = ae;
              }

              c >>>= 2, ue -= 2;
              break;

            case q:
              for (c >>>= 7 & ue, ue -= 7 & ue; ue < 32;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if ((65535 & c) != (c >>> 16 ^ 65535)) {
                e.msg = "invalid stored block lengths", r.mode = ae;
                break;
              }

              if (r.length = 65535 & c, c = 0, ue = 0, r.mode = $, t === x) break e;

            case $:
              r.mode = V;

            case V:
              if (de = r.length) {
                if (de > f && (de = f), de > h && (de = h), 0 === de) break e;
                d.arraySet(o, n, s, de, a), f -= de, s += de, h -= de, a += de, r.length -= de;
                break;
              }

              r.mode = Z;
              break;

            case H:
              for (; ue < 14;) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if (r.nlen = 257 + (31 & c), c >>>= 5, ue -= 5, r.ndist = 1 + (31 & c), c >>>= 5, ue -= 5, r.ncode = 4 + (15 & c), c >>>= 4, ue -= 4, r.nlen > 286 || r.ndist > 30) {
                e.msg = "too many length or distance symbols", r.mode = ae;
                break;
              }

              r.have = 0, r.mode = W;

            case W:
              for (; r.have < r.ncode;) {
                for (; ue < 3;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                r.lens[Te[r.have++]] = 7 & c, c >>>= 3, ue -= 3;
              }

              for (; r.have < 19;) {
                r.lens[Te[r.have++]] = 0;
              }

              if (r.lencode = r.lendyn, r.lenbits = 7, Oe = {
                bits: r.lenbits
              }, xe = v(g, r.lens, 0, 19, r.lencode, 0, r.work, Oe), r.lenbits = Oe.bits, xe) {
                e.msg = "invalid code lengths set", r.mode = ae;
                break;
              }

              r.have = 0, r.mode = G;

            case G:
              for (; r.have < r.nlen + r.ndist;) {
                for (; ve = (Se = r.lencode[c & (1 << r.lenbits) - 1]) >>> 16 & 255, ge = 65535 & Se, !((me = Se >>> 24) <= ue);) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                if (ge < 16) c >>>= me, ue -= me, r.lens[r.have++] = ge;else {
                  if (16 === ge) {
                    for (Ae = me + 2; ue < Ae;) {
                      if (0 === f) break e;
                      f--, c += n[s++] << ue, ue += 8;
                    }

                    if (c >>>= me, ue -= me, 0 === r.have) {
                      e.msg = "invalid bit length repeat", r.mode = ae;
                      break;
                    }

                    ke = r.lens[r.have - 1], de = 3 + (3 & c), c >>>= 2, ue -= 2;
                  } else if (17 === ge) {
                    for (Ae = me + 3; ue < Ae;) {
                      if (0 === f) break e;
                      f--, c += n[s++] << ue, ue += 8;
                    }

                    ue -= me, ke = 0, de = 3 + (7 & (c >>>= me)), c >>>= 3, ue -= 3;
                  } else {
                    for (Ae = me + 7; ue < Ae;) {
                      if (0 === f) break e;
                      f--, c += n[s++] << ue, ue += 8;
                    }

                    ue -= me, ke = 0, de = 11 + (127 & (c >>>= me)), c >>>= 7, ue -= 7;
                  }

                  if (r.have + de > r.nlen + r.ndist) {
                    e.msg = "invalid bit length repeat", r.mode = ae;
                    break;
                  }

                  for (; de--;) {
                    r.lens[r.have++] = ke;
                  }
                }
              }

              if (r.mode === ae) break;

              if (0 === r.lens[256]) {
                e.msg = "invalid code -- missing end-of-block", r.mode = ae;
                break;
              }

              if (r.lenbits = 9, Oe = {
                bits: r.lenbits
              }, xe = v(b, r.lens, 0, r.nlen, r.lencode, 0, r.work, Oe), r.lenbits = Oe.bits, xe) {
                e.msg = "invalid literal/lengths set", r.mode = ae;
                break;
              }

              if (r.distbits = 6, r.distcode = r.distdyn, Oe = {
                bits: r.distbits
              }, xe = v(_, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, Oe), r.distbits = Oe.bits, xe) {
                e.msg = "invalid distances set", r.mode = ae;
                break;
              }

              if (r.mode = Y, t === x) break e;

            case Y:
              r.mode = Q;

            case Q:
              if (f >= 6 && h >= 258) {
                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = f, r.hold = c, r.bits = ue, m(e, ce), a = e.next_out, o = e.output, h = e.avail_out, s = e.next_in, n = e.input, f = e.avail_in, c = r.hold, ue = r.bits, r.mode === Z && (r.back = -1);
                break;
              }

              for (r.back = 0; ve = (Se = r.lencode[c & (1 << r.lenbits) - 1]) >>> 16 & 255, ge = 65535 & Se, !((me = Se >>> 24) <= ue);) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if (ve && 0 == (240 & ve)) {
                for (be = me, _e = ve, we = ge; ve = (Se = r.lencode[we + ((c & (1 << be + _e) - 1) >> be)]) >>> 16 & 255, ge = 65535 & Se, !(be + (me = Se >>> 24) <= ue);) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                c >>>= be, ue -= be, r.back += be;
              }

              if (c >>>= me, ue -= me, r.back += me, r.length = ge, 0 === ve) {
                r.mode = ie;
                break;
              }

              if (32 & ve) {
                r.back = -1, r.mode = Z;
                break;
              }

              if (64 & ve) {
                e.msg = "invalid literal/length code", r.mode = ae;
                break;
              }

              r.extra = 15 & ve, r.mode = X;

            case X:
              if (r.extra) {
                for (Ae = r.extra; ue < Ae;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                r.length += c & (1 << r.extra) - 1, c >>>= r.extra, ue -= r.extra, r.back += r.extra;
              }

              r.was = r.length, r.mode = ee;

            case ee:
              for (; ve = (Se = r.distcode[c & (1 << r.distbits) - 1]) >>> 16 & 255, ge = 65535 & Se, !((me = Se >>> 24) <= ue);) {
                if (0 === f) break e;
                f--, c += n[s++] << ue, ue += 8;
              }

              if (0 == (240 & ve)) {
                for (be = me, _e = ve, we = ge; ve = (Se = r.distcode[we + ((c & (1 << be + _e) - 1) >> be)]) >>> 16 & 255, ge = 65535 & Se, !(be + (me = Se >>> 24) <= ue);) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                c >>>= be, ue -= be, r.back += be;
              }

              if (c >>>= me, ue -= me, r.back += me, 64 & ve) {
                e.msg = "invalid distance code", r.mode = ae;
                break;
              }

              r.offset = ge, r.extra = 15 & ve, r.mode = te;

            case te:
              if (r.extra) {
                for (Ae = r.extra; ue < Ae;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                r.offset += c & (1 << r.extra) - 1, c >>>= r.extra, ue -= r.extra, r.back += r.extra;
              }

              if (r.offset > r.dmax) {
                e.msg = "invalid distance too far back", r.mode = ae;
                break;
              }

              r.mode = re;

            case re:
              if (0 === h) break e;

              if (de = ce - h, r.offset > de) {
                if ((de = r.offset - de) > r.whave && r.sane) {
                  e.msg = "invalid distance too far back", r.mode = ae;
                  break;
                }

                de > r.wnext ? (de -= r.wnext, pe = r.wsize - de) : pe = r.wnext - de, de > r.length && (de = r.length), ye = r.window;
              } else ye = o, pe = a - r.offset, de = r.length;

              de > h && (de = h), h -= de, r.length -= de;

              do {
                o[a++] = ye[pe++];
              } while (--de);

              0 === r.length && (r.mode = Q);
              break;

            case ie:
              if (0 === h) break e;
              o[a++] = r.length, h--, r.mode = Q;
              break;

            case ne:
              if (r.wrap) {
                for (; ue < 32;) {
                  if (0 === f) break e;
                  f--, c |= n[s++] << ue, ue += 8;
                }

                if (ce -= h, e.total_out += ce, r.total += ce, ce && (e.adler = r.check = r.flags ? y(r.check, o, ce, a - ce) : p(r.check, o, ce, a - ce)), ce = h, (r.flags ? c : i(c)) !== r.check) {
                  e.msg = "incorrect data check", r.mode = ae;
                  break;
                }

                c = 0, ue = 0;
              }

              r.mode = oe;

            case oe:
              if (r.wrap && r.flags) {
                for (; ue < 32;) {
                  if (0 === f) break e;
                  f--, c += n[s++] << ue, ue += 8;
                }

                if (c !== (4294967295 & r.total)) {
                  e.msg = "incorrect length check", r.mode = ae;
                  break;
                }

                c = 0, ue = 0;
              }

              r.mode = se;

            case se:
              xe = A;
              break e;

            case ae:
              xe = T;
              break e;

            case fe:
              return E;

            case le:
            default:
              return j;
          }
        }

        return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = f, r.hold = c, r.bits = ue, (r.wsize || ce !== e.avail_out && r.mode < ae && (r.mode < ne || t !== w)) && u(e, e.output, e.next_out, ce - e.avail_out) ? (r.mode = fe, E) : (he -= e.avail_in, ce -= e.avail_out, e.total_in += he, e.total_out += ce, r.total += ce, r.wrap && ce && (e.adler = r.check = r.flags ? y(r.check, o, ce, e.next_out - ce) : p(r.check, o, ce, e.next_out - ce)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Z ? 128 : 0) + (r.mode === Y || r.mode === $ ? 256 : 0), (0 === he && 0 === ce || t === w) && xe === O && (xe = N), xe);
      }, t.inflateEnd = function (e) {
        if (!e || !e.state) return j;
        var t = e.state;
        return t.window && (t.window = null), e.state = null, O;
      }, t.inflateGetHeader = function (e, t) {
        var r;
        return e && e.state ? 0 == (2 & (r = e.state).wrap) ? j : (r.head = t, t.done = !1, O) : j;
      }, t.inflateSetDictionary = function (e, t) {
        var r,
            i = t.length;
        return e && e.state ? 0 !== (r = e.state).wrap && r.mode !== U ? j : r.mode === U && p(1, t, i, 0) !== r.check ? T : u(e, t, i, i) ? (r.mode = fe, E) : (r.havedict = 1, O) : j;
      }, t.inflateInfo = "pako inflate (from Nodeca project)";
    }, function (e, t, r) {

      e.exports = function (e, t, r, i) {
        for (var n = 65535 & e | 0, o = e >>> 16 & 65535 | 0, s = 0; 0 !== r;) {
          r -= s = r > 2e3 ? 2e3 : r;

          do {
            o = o + (n = n + t[i++] | 0) | 0;
          } while (--s);

          n %= 65521, o %= 65521;
        }

        return n | o << 16 | 0;
      };
    }, function (e, t, r) {

      var i = function () {
        for (var e, t = [], r = 0; r < 256; r++) {
          e = r;

          for (var i = 0; i < 8; i++) {
            e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
          }

          t[r] = e;
        }

        return t;
      }();

      e.exports = function (e, t, r, n) {
        var o = i,
            s = n + r;
        e ^= -1;

        for (var a = n; a < s; a++) {
          e = e >>> 8 ^ o[255 & (e ^ t[a])];
        }

        return -1 ^ e;
      };
    }, function (e, t, r) {

      e.exports = function (e, t) {
        var r, i, n, o, s, a, f, l, u, h, c, d, p, y, m, v, g, b, _, w, k, x, O, A, S;

        r = e.state, i = e.next_in, A = e.input, n = i + (e.avail_in - 5), o = e.next_out, S = e.output, s = o - (t - e.avail_out), a = o + (e.avail_out - 257), f = r.dmax, l = r.wsize, u = r.whave, h = r.wnext, c = r.window, d = r.hold, p = r.bits, y = r.lencode, m = r.distcode, v = (1 << r.lenbits) - 1, g = (1 << r.distbits) - 1;

        e: do {
          p < 15 && (d += A[i++] << p, p += 8, d += A[i++] << p, p += 8), b = y[d & v];

          t: for (;;) {
            if (d >>>= _ = b >>> 24, p -= _, 0 == (_ = b >>> 16 & 255)) S[o++] = 65535 & b;else {
              if (!(16 & _)) {
                if (0 == (64 & _)) {
                  b = y[(65535 & b) + (d & (1 << _) - 1)];
                  continue t;
                }

                if (32 & _) {
                  r.mode = 12;
                  break e;
                }

                e.msg = "invalid literal/length code", r.mode = 30;
                break e;
              }

              w = 65535 & b, (_ &= 15) && (p < _ && (d += A[i++] << p, p += 8), w += d & (1 << _) - 1, d >>>= _, p -= _), p < 15 && (d += A[i++] << p, p += 8, d += A[i++] << p, p += 8), b = m[d & g];

              r: for (;;) {
                if (d >>>= _ = b >>> 24, p -= _, !(16 & (_ = b >>> 16 & 255))) {
                  if (0 == (64 & _)) {
                    b = m[(65535 & b) + (d & (1 << _) - 1)];
                    continue r;
                  }

                  e.msg = "invalid distance code", r.mode = 30;
                  break e;
                }

                if (k = 65535 & b, p < (_ &= 15) && (d += A[i++] << p, (p += 8) < _ && (d += A[i++] << p, p += 8)), (k += d & (1 << _) - 1) > f) {
                  e.msg = "invalid distance too far back", r.mode = 30;
                  break e;
                }

                if (d >>>= _, p -= _, k > (_ = o - s)) {
                  if ((_ = k - _) > u && r.sane) {
                    e.msg = "invalid distance too far back", r.mode = 30;
                    break e;
                  }

                  if (x = 0, O = c, 0 === h) {
                    if (x += l - _, _ < w) {
                      w -= _;

                      do {
                        S[o++] = c[x++];
                      } while (--_);

                      x = o - k, O = S;
                    }
                  } else if (h < _) {
                    if (x += l + h - _, (_ -= h) < w) {
                      w -= _;

                      do {
                        S[o++] = c[x++];
                      } while (--_);

                      if (x = 0, h < w) {
                        w -= _ = h;

                        do {
                          S[o++] = c[x++];
                        } while (--_);

                        x = o - k, O = S;
                      }
                    }
                  } else if (x += h - _, _ < w) {
                    w -= _;

                    do {
                      S[o++] = c[x++];
                    } while (--_);

                    x = o - k, O = S;
                  }

                  for (; w > 2;) {
                    S[o++] = O[x++], S[o++] = O[x++], S[o++] = O[x++], w -= 3;
                  }

                  w && (S[o++] = O[x++], w > 1 && (S[o++] = O[x++]));
                } else {
                  x = o - k;

                  do {
                    S[o++] = S[x++], S[o++] = S[x++], S[o++] = S[x++], w -= 3;
                  } while (w > 2);

                  w && (S[o++] = S[x++], w > 1 && (S[o++] = S[x++]));
                }

                break;
              }
            }
            break;
          }
        } while (i < n && o < a);

        i -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = i, e.next_out = o, e.avail_in = i < n ? n - i + 5 : 5 - (i - n), e.avail_out = o < a ? a - o + 257 : 257 - (o - a), r.hold = d, r.bits = p;
      };
    }, function (e, t, r) {

      var i = r(8),
          n = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
          o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
          s = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
          a = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

      e.exports = function (e, t, r, f, l, u, h, c) {
        var d,
            p,
            y,
            m,
            v,
            g,
            b,
            _,
            w,
            k = c.bits,
            x = 0,
            O = 0,
            A = 0,
            S = 0,
            j = 0,
            T = 0,
            E = 0,
            N = 0,
            F = 0,
            C = 0,
            B = null,
            I = 0,
            P = new i.Buf16(16),
            R = new i.Buf16(16),
            D = null,
            M = 0;

        for (x = 0; x <= 15; x++) {
          P[x] = 0;
        }

        for (O = 0; O < f; O++) {
          P[t[r + O]]++;
        }

        for (j = k, S = 15; S >= 1 && 0 === P[S]; S--) {
        }

        if (j > S && (j = S), 0 === S) return l[u++] = 20971520, l[u++] = 20971520, c.bits = 1, 0;

        for (A = 1; A < S && 0 === P[A]; A++) {
        }

        for (j < A && (j = A), N = 1, x = 1; x <= 15; x++) {
          if (N <<= 1, (N -= P[x]) < 0) return -1;
        }

        if (N > 0 && (0 === e || 1 !== S)) return -1;

        for (R[1] = 0, x = 1; x < 15; x++) {
          R[x + 1] = R[x] + P[x];
        }

        for (O = 0; O < f; O++) {
          0 !== t[r + O] && (h[R[t[r + O]]++] = O);
        }

        if (0 === e ? (B = D = h, g = 19) : 1 === e ? (B = n, I -= 257, D = o, M -= 257, g = 256) : (B = s, D = a, g = -1), C = 0, O = 0, x = A, v = u, T = j, E = 0, y = -1, m = (F = 1 << j) - 1, 1 === e && F > 852 || 2 === e && F > 592) return 1;

        for (;;) {
          b = x - E, h[O] < g ? (_ = 0, w = h[O]) : h[O] > g ? (_ = D[M + h[O]], w = B[I + h[O]]) : (_ = 96, w = 0), d = 1 << x - E, A = p = 1 << T;

          do {
            l[v + (C >> E) + (p -= d)] = b << 24 | _ << 16 | w | 0;
          } while (0 !== p);

          for (d = 1 << x - 1; C & d;) {
            d >>= 1;
          }

          if (0 !== d ? (C &= d - 1, C += d) : C = 0, O++, 0 == --P[x]) {
            if (x === S) break;
            x = t[r + h[O]];
          }

          if (x > j && (C & m) !== y) {
            for (0 === E && (E = j), v += A, N = 1 << (T = x - E); T + E < S && !((N -= P[T + E]) <= 0);) {
              T++, N <<= 1;
            }

            if (F += 1 << T, 1 === e && F > 852 || 2 === e && F > 592) return 1;
            l[y = C & m] = j << 24 | T << 16 | v - u | 0;
          }
        }

        return 0 !== C && (l[v + C] = x - E << 24 | 64 << 16 | 0), c.bits = j, 0;
      };
    }, function (e, t, r) {

      function i(e, t) {
        if (t < 65534 && (e.subarray && s || !e.subarray && o)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));

        for (var r = "", i = 0; i < t; i++) {
          r += String.fromCharCode(e[i]);
        }

        return r;
      }

      var n = r(8),
          o = !0,
          s = !0;

      try {
        String.fromCharCode.apply(null, [0]);
      } catch (e) {
        o = !1;
      }

      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (e) {
        s = !1;
      }

      for (var a = new n.Buf8(256), f = 0; f < 256; f++) {
        a[f] = f >= 252 ? 6 : f >= 248 ? 5 : f >= 240 ? 4 : f >= 224 ? 3 : f >= 192 ? 2 : 1;
      }

      a[254] = a[254] = 1, t.string2buf = function (e) {
        var t,
            r,
            i,
            o,
            s,
            a = e.length,
            f = 0;

        for (o = 0; o < a; o++) {
          55296 == (64512 & (r = e.charCodeAt(o))) && o + 1 < a && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), f += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
        }

        for (t = new n.Buf8(f), s = 0, o = 0; s < f; o++) {
          55296 == (64512 & (r = e.charCodeAt(o))) && o + 1 < a && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), o++), r < 128 ? t[s++] = r : r < 2048 ? (t[s++] = 192 | r >>> 6, t[s++] = 128 | 63 & r) : r < 65536 ? (t[s++] = 224 | r >>> 12, t[s++] = 128 | r >>> 6 & 63, t[s++] = 128 | 63 & r) : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63, t[s++] = 128 | r >>> 6 & 63, t[s++] = 128 | 63 & r);
        }

        return t;
      }, t.buf2binstring = function (e) {
        return i(e, e.length);
      }, t.binstring2buf = function (e) {
        for (var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++) {
          t[r] = e.charCodeAt(r);
        }

        return t;
      }, t.buf2string = function (e, t) {
        var r,
            n,
            o,
            s,
            f = t || e.length,
            l = new Array(2 * f);

        for (n = 0, r = 0; r < f;) {
          if ((o = e[r++]) < 128) l[n++] = o;else if ((s = a[o]) > 4) l[n++] = 65533, r += s - 1;else {
            for (o &= 2 === s ? 31 : 3 === s ? 15 : 7; s > 1 && r < f;) {
              o = o << 6 | 63 & e[r++], s--;
            }

            s > 1 ? l[n++] = 65533 : o < 65536 ? l[n++] = o : (o -= 65536, l[n++] = 55296 | o >> 10 & 1023, l[n++] = 56320 | 1023 & o);
          }
        }

        return i(l, n);
      }, t.utf8border = function (e, t) {
        var r;

        for ((t = t || e.length) > e.length && (t = e.length), r = t - 1; r >= 0 && 128 == (192 & e[r]);) {
          r--;
        }

        return r < 0 ? t : 0 === r ? t : r + a[e[r]] > t ? r : t;
      };
    }, function (e, t, r) {

      e.exports = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
      };
    }, function (e, t, r) {

      e.exports = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
      };
    }, function (e, t, r) {

      e.exports = function () {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, function (e, t, r) {

      e.exports = function () {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, function (e, t, r) {
      e.exports = function (e) {
        function t(i) {
          if (r[i]) return r[i].exports;
          var n = r[i] = {
            i: i,
            l: !1,
            exports: {}
          };
          return e[i].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
        }

        var r = {};
        return t.m = e, t.c = r, t.d = function (e, r, i) {
          t.o(e, r) || Object.defineProperty(e, r, {
            configurable: !1,
            enumerable: !0,
            get: i
          });
        }, t.n = function (e) {
          var r = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(r, "a", r), r;
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 0);
      }([function (e, t, r) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = r(1);
        e.exports = i.ValueAnimator;
      }, function (e, t, r) {

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var i = function () {
          function e() {
            this.startValue = 0, this.endValue = 0, this.duration = 0, this.loops = 1, this.fillRule = 0, this.onStart = function () {}, this.onUpdate = function () {}, this.onEnd = function () {}, this.mRunning = !1, this.mStartTime = 0, this.mCurrentFrication = 0, this.mReverse = !1;
          }

          return e.prototype.start = function (e) {
            void 0 === e && (e = void 0), this.doStart(!1, e);
          }, e.prototype.reverse = function (e) {
            void 0 === e && (e = void 0), this.doStart(!0, e);
          }, e.prototype.stop = function () {
            this.doStop();
          }, Object.defineProperty(e.prototype, "animatedValue", {
            get: function get() {
              return (this.endValue - this.startValue) * this.mCurrentFrication + this.startValue;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.doStart = function (t, r) {
            void 0 === t && (t = !1), void 0 === r && (r = void 0), this.mReverse = t, this.mRunning = !0, this.mStartTime = e.currentTimeMillsecond(), r && (this.mStartTime -= t ? (1 - r / (this.endValue - this.startValue)) * this.duration : r / (this.endValue - this.startValue) * this.duration), this.mCurrentFrication = 0, this.onStart(), this.doFrame();
          }, e.prototype.doStop = function () {
            this.mRunning = !1;
          }, e.prototype.doFrame = function () {
            this.mRunning && (this.doDeltaTime(e.currentTimeMillsecond() - this.mStartTime), this.mRunning && e.requestAnimationFrame(this.doFrame.bind(this)));
          }, e.prototype.doDeltaTime = function (e) {
            e >= this.duration * this.loops ? (this.mCurrentFrication = 1 === this.fillRule ? 0 : 1, this.mRunning = !1) : (this.mCurrentFrication = e % this.duration / this.duration, this.mReverse && (this.mCurrentFrication = 1 - this.mCurrentFrication)), this.onUpdate(this.animatedValue), !1 === this.mRunning && this.onEnd();
          }, e.currentTimeMillsecond = function () {
            return "undefined" == typeof performance ? new Date().getTime() : performance.now();
          }, e.requestAnimationFrame = function (e) {
            return "undefined" == typeof requestAnimationFrame ? setTimeout(e, 16) : window.requestAnimationFrame(e);
          }, e;
        }();

        t.ValueAnimator = i;
      }]);
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Player = void 0;

      var i = "function" == typeof Symbol && "symbol" == _typeof$1(Symbol.iterator) ? function (e) {
        return _typeof$1(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
      },
          n = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var i = t[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }

        return function (t, r, i) {
          return r && e(t.prototype, r), i && e(t, i), t;
        };
      }(),
          o = r(65),
          s = r(62);

      t.Player = function () {
        function e(t) {
          ((function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }))(this, e), this.loops = 0, this.clearsAfterStop = !0, this.fillMode = "Forward", this._asChild = !1, this._container = void 0, this._renderer = void 0, this._animator = void 0, this._drawingCanvas = void 0, this._contentMode = "AspectFit", this._videoItem = void 0, this._forwardAnimating = !1, this._currentFrame = 0, this._dynamicImage = {}, this._dynamicImageTransform = {}, this._dynamicText = {}, this._onFinished = void 0, this._onFrame = void 0, this._onPercentage = void 0, this._container = "string" == typeof t ? document.querySelector(t) : t, this._asChild = void 0 === t, this._init();
        }

        return n(e, [{
          key: "setVideoItem",
          value: function value(e) {
            this._currentFrame = 0, this._videoItem = e, this._renderer.prepare(), this.clear(), this._update();
          }
        }, {
          key: "setContentMode",
          value: function value(e) {
            this._contentMode = e, this._update();
          }
        }, {
          key: "setClipsToBounds",
          value: function value(e) {
            this._container instanceof HTMLDivElement && (this._container.style.overflowX = this._container.style.overflowY = e ? "hidden" : void 0);
          }
        }, {
          key: "startAnimation",
          value: function value(e) {
            this.stopAnimation(!1), this._doStart(void 0, e, void 0);
          }
        }, {
          key: "startAnimationWithRange",
          value: function value(e, t) {
            this.stopAnimation(!1), this._doStart(e, t, void 0);
          }
        }, {
          key: "pauseAnimation",
          value: function value() {
            this.stopAnimation(!1);
          }
        }, {
          key: "stopAnimation",
          value: function value(e) {
            this._forwardAnimating = !1, void 0 !== this._animator && this._animator.stop(), void 0 === e && (e = this.clearsAfterStop), e && this.clear();
          }
        }, {
          key: "clear",
          value: function value() {
            this._renderer.clear(), this._renderer.clearAudios();
          }
        }, {
          key: "stepToFrame",
          value: function value(e, t) {
            e >= this._videoItem.frames || e < 0 || (this.pauseAnimation(), this._currentFrame = e, this._update(), t && this._doStart(void 0, !1, this._currentFrame));
          }
        }, {
          key: "stepToPercentage",
          value: function value(e, t) {
            var r = parseInt(e * this._videoItem.frames);
            r >= this._videoItem.frames && r > 0 && (r = this._videoItem.frames - 1), this.stepToFrame(r, t);
          }
        }, {
          key: "setImage",
          value: function value(e, t, r) {
            this._dynamicImage[t] = e, void 0 !== r && r instanceof Array && 6 == r.length && (this._dynamicImageTransform[t] = r);
          }
        }, {
          key: "setText",
          value: function value(e, t) {
            var r = "string" == typeof e ? e : e.text,
                n = ("object" === (void 0 === e ? "undefined" : i(e)) ? e.size : "14px") || "14px",
                o = ("object" === (void 0 === e ? "undefined" : i(e)) ? e.family : "Arial") || "Arial",
                s = ("object" === (void 0 === e ? "undefined" : i(e)) ? e.color : "#000000") || "#000000",
                a = ("object" === (void 0 === e ? "undefined" : i(e)) ? e.offset : {
              x: 0,
              y: 0
            }) || {
              x: 0,
              y: 0
            };
            this._dynamicText[t] = {
              text: r,
              style: n + " " + o,
              color: s,
              offset: a
            };
          }
        }, {
          key: "clearDynamicObjects",
          value: function value() {
            this._dynamicImage = {}, this._dynamicImageTransform = {}, this._dynamicText = {};
          }
        }, {
          key: "onFinished",
          value: function value(e) {
            this._onFinished = e;
          }
        }, {
          key: "onFrame",
          value: function value(e) {
            this._onFrame = e;
          }
        }, {
          key: "onPercentage",
          value: function value(e) {
            this._onPercentage = e;
          }
        }, {
          key: "drawOnContext",
          value: function value(e, t, r, i, n) {
            this._drawingCanvas && this._videoItem && e.drawImage(this._drawingCanvas, t, r, i || this._videoItem.videoSize.width, n || this._videoItem.videoSize.height);
          }
        }, {
          key: "_init",
          value: function value() {
            if (this._container instanceof HTMLDivElement || this._asChild) {
              if (this._container) for (var e = this._container.querySelectorAll("canvas"), t = 0; t < e.length; t++) {
                var r = e[t];
                void 0 !== r && r.__isPlayer && this._container.removeChild(r);
              }
              this._drawingCanvas = document.createElement("canvas"), this._drawingCanvas.__isPlayer = !0, this._drawingCanvas.style.backgroundColor = "transparent", this._container && (this._container.appendChild(this._drawingCanvas), this._container.style.textAlign = "left");
            }

            this._renderer = new o.Renderer(this);
          }
        }, {
          key: "_doStart",
          value: function value(e, t, r) {
            var i = this;
            this._animator = new s(), void 0 !== e ? (this._animator.startValue = Math.max(0, e.location), this._animator.endValue = Math.min(this._videoItem.frames - 1, e.location + e.length), this._animator.duration = (this._animator.endValue - this._animator.startValue + 1) * (1 / this._videoItem.FPS) * 1e3) : (this._animator.startValue = 0, this._animator.endValue = this._videoItem.frames - 1, this._animator.duration = this._videoItem.frames * (1 / this._videoItem.FPS) * 1e3), this._animator.loops = this.loops <= 0 ? 1 / 0 : this.loops, this._animator.fillRule = "Backward" === this.fillMode ? 1 : 0, this._animator.onUpdate = function (e) {
              i._currentFrame !== Math.floor(e) && (i._forwardAnimating && i._currentFrame > Math.floor(e) && i._renderer.clearAudios(), i._currentFrame = Math.floor(e), i._update(), "function" == typeof i._onFrame && i._onFrame(i._currentFrame), "function" == typeof i._onPercentage && i._onPercentage(parseFloat(i._currentFrame + 1) / parseFloat(i._videoItem.frames)));
            }, this._animator.onEnd = function () {
              i._forwardAnimating = !1, !0 === i.clearsAfterStop && i.clear(), "function" == typeof i._onFinished && i._onFinished();
            }, !0 === t ? (this._animator.reverse(r), this._forwardAnimating = !1) : (this._animator.start(r), this._forwardAnimating = !0), this._currentFrame = this._animator.startValue, this._update();
          }
        }, {
          key: "_resize",
          value: function value() {
            var e = !1;

            if (this._drawingCanvas) {
              var t;
              t = this._drawingCanvas.parentNode ? {
                width: this._drawingCanvas.parentNode.clientWidth,
                height: this._drawingCanvas.parentNode.clientHeight
              } : this._videoItem.videoSize;
              var r = this._videoItem.videoSize;
              if (t.width >= r.width && t.height >= r.height) this._drawingCanvas.width = t.width, this._drawingCanvas.height = t.height, this._drawingCanvas.style.webkitTransform = this._drawingCanvas.style.transform = "", e = !0;else {
                if (this._drawingCanvas.width = r.width, this._drawingCanvas.height = r.height, "Fill" === this._contentMode) {
                  var i = t.width / r.width,
                      n = t.height / r.height,
                      o = (r.width * i - r.width) / 2,
                      s = (r.height * n - r.height) / 2;
                  this._drawingCanvas.style.webkitTransform = this._drawingCanvas.style.transform = "matrix(" + i + ", 0.0, 0.0, " + n + ", " + o + ", " + s + ")";
                } else if ("AspectFit" === this._contentMode || "AspectFill" === this._contentMode) {
                  var a = r.width / r.height,
                      f = t.width / t.height;

                  if (a >= f && "AspectFit" === this._contentMode || a <= f && "AspectFill" === this._contentMode) {
                    var l = t.width / r.width,
                        u = (r.width * l - r.width) / 2,
                        h = (r.height * l - r.height) / 2 + (t.height - r.height * l) / 2;
                    this._drawingCanvas.style.webkitTransform = this._drawingCanvas.style.transform = "matrix(" + l + ", 0.0, 0.0, " + l + ", " + u + ", " + h + ")";
                  } else if (a < f && "AspectFit" === this._contentMode || a > f && "AspectFill" === this._contentMode) {
                    var c = t.height / r.height,
                        d = (r.width * c - r.width) / 2 + (t.width - r.width * c) / 2,
                        p = (r.height * c - r.height) / 2;
                    this._drawingCanvas.style.webkitTransform = this._drawingCanvas.style.transform = "matrix(" + c + ", 0.0, 0.0, " + c + ", " + d + ", " + p + ")";
                  }
                }

                this._globalTransform = void 0;
              }
            }

            if (void 0 === this._drawingCanvas || !0 === e) {
              var y = 1,
                  m = 1,
                  v = 0,
                  g = 0,
                  b = {
                width: void 0 !== this._container ? this._container.clientWidth : 0,
                height: void 0 !== this._container ? this._container.clientHeight : 0
              },
                  _ = this._videoItem.videoSize;
              if ("Fill" === this._contentMode) y = b.width / _.width, m = b.height / _.height;else if ("AspectFit" === this._contentMode || "AspectFill" === this._contentMode) {
                var w = _.width / _.height,
                    k = b.width / b.height;
                w >= k && "AspectFit" === this._contentMode || w <= k && "AspectFill" === this._contentMode ? (y = m = b.width / _.width, g = (b.height - _.height * m) / 2) : (w < k && "AspectFit" === this._contentMode || w > k && "AspectFill" === this._contentMode) && (y = m = b.height / _.height, v = (b.width - _.width * y) / 2);
              }
              this._globalTransform = {
                a: y,
                b: 0,
                c: 0,
                d: m,
                tx: v,
                ty: g
              };
            }
          }
        }, {
          key: "_update",
          value: function value() {
            void 0 !== this._videoItem && (this._resize(), this._renderer.drawFrame(this._currentFrame), this._renderer.playAudio(this._currentFrame));
          }
        }]), e;
      }();
    }, function (e, t, r) {

      var i = r(13),
          n = r(63),
          o = r(66);
      e.exports = {
        Parser: i.Parser,
        Player: n.Player,
        autoload: o.AutoLoader.autoload
      }, o.AutoLoader.autoload();
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Renderer = void 0;

      var i = "function" == typeof Symbol && "symbol" == _typeof$1(Symbol.iterator) ? function (e) {
        return _typeof$1(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof$1(e);
      },
          n = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var i = t[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }

        return function (t, r, i) {
          return r && e(t.prototype, r), i && e(t, i), t;
        };
      }(),
          o = r(5),
          s = r(15),
          a = r(14);

      t.Renderer = function () {
        function e(t) {
          ((function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }))(this, e), this._owner = void 0, this._prepared = !1, this._undrawFrame = void 0, this._bitmapCache = void 0, this._soundsQueue = [], this._owner = t;
        }

        return n(e, [{
          key: "dataURLtoBlob",
          value: function value(e) {
            for (var t = e.split(","), r = t[0].match(/:(.*?);/)[1], i = atob(t[1]), n = i.length, o = new Uint8Array(n); n--;) {
              o[n] = i.charCodeAt(n);
            }

            return new Blob([o], {
              type: r
            });
          }
        }, {
          key: "prepare",
          value: function value() {
            var e,
                t,
                r = this;
            if (this._prepared = !1, this._bitmapCache = void 0, void 0 === this._owner._videoItem.images || 0 == Object.keys(this._owner._videoItem.images).length) return this._bitmapCache = {}, void (this._prepared = !0);
            void 0 === this._bitmapCache && function () {
              r._bitmapCache = {};
              var i = 0,
                  n = 0;

              for (e in r._owner._videoItem.images) {
                var o = r._owner._videoItem.images[e];

                if (0 === o.indexOf("iVBO") || 0 === o.indexOf("/9j/2w")) {
                  i++;
                  var s = document.createElement("img");
                  s.onload = function () {
                    ++n == i && (this._prepared = !0, "number" == typeof this._undrawFrame && (this.drawFrame(this._undrawFrame), this._undrawFrame = void 0));
                  }.bind(r), s.src = "data:image/png;base64," + o;
                  var a = e.replace(".matte", "");
                  r._bitmapCache[a] = s;
                } else 0 === o.indexOf("SUQz") && void 0 !== window.Howl && (i++, (t = new Howl({
                  src: ["Google Inc." === navigator.vendor ? URL.createObjectURL(r.dataURLtoBlob("data:audio/x-mpeg;base64," + o)) : "data:audio/x-mpeg;base64," + o],
                  html5: "Google Inc." === navigator.vendor || void 0,
                  preload: "Google Inc." === navigator.vendor || void 0,
                  format: "Google Inc." === navigator.vendor ? ["mp3"] : void 0
                })).once("load", function () {
                  ++n == i && (this._prepared = !0, "number" == typeof this._undrawFrame && (this.drawFrame(this._undrawFrame), this._undrawFrame = void 0));
                }.bind(r)), t.on("loaderror", function (e) {
                  console.error(e);
                }), r._bitmapCache[e] = t);
              }
            }();
          }
        }, {
          key: "clear",
          value: function value() {
            var e = (this._owner._drawingCanvas || this._owner._container).getContext("2d"),
                t = {
              x: 0,
              y: 0,
              width: (this._owner._drawingCanvas || this._owner._container).width,
              height: (this._owner._drawingCanvas || this._owner._container).height
            };

            e.clearRect(t.x, t.y, t.width, t.height);
          }
        }, {
          key: "clearAudios",
          value: function value() {
            this._soundsQueue.forEach(function (e) {
              e.player.stop(e.playID);
            }), this._soundsQueue = [];
          }
        }, {
          key: "drawFrame",
          value: function value(e) {
            var t = this;

            if (this._prepared) {
              var r = (this._owner._drawingCanvas || this._owner._container).getContext("2d"),
                  i = {
                x: 0,
                y: 0,
                width: (this._owner._drawingCanvas || this._owner._container).width,
                height: (this._owner._drawingCanvas || this._owner._container).height
              };

              r.clearRect(i.x, i.y, i.width, i.height);
              var n = new Map(),
                  o = !1,
                  s = this._owner._videoItem.sprites;
              s.forEach(function (i, a) {
                if (-1 != s[0].imageKey.indexOf(".matte")) {
                  if (-1 == i.imageKey.indexOf(".matte")) {
                    var f = s[a - 1];

                    if (o && (null == i.matteKey || 0 == i.matteKey.length || i.matteKey != f.matteKey)) {
                      o = !1;
                      var l = n.get(i.matteKey);
                      r.globalCompositeOperation = "destination-in", t.drawSprite(l, r, e), r.globalCompositeOperation = "source-over", r.restore();
                    }

                    if (null == i.matteKey || null != f.matteKey && 0 != f.matteKey.length && f.matteKey == i.matteKey || (o = !0, r.save()), t.drawSprite(i, r, e), o && a == s.length - 1) {
                      l = n.get(i.matteKey);
                      r.globalCompositeOperation = "destination-in", t.drawSprite(l, r, e), r.globalCompositeOperation = "source-over", r.restore();
                    }
                  } else n.set(i.imageKey, i);
                } else t.drawSprite(i, r, e);
              });
            } else this._undrawFrame = e;
          }
        }, {
          key: "drawSprite",
          value: function value(e, t, r) {
            var n = this,
                f = e.frames[this._owner._currentFrame];

            if (!(f.alpha < .05)) {
              t.save(), this._owner._globalTransform && t.transform(this._owner._globalTransform.a, this._owner._globalTransform.b, this._owner._globalTransform.c, this._owner._globalTransform.d, this._owner._globalTransform.tx, this._owner._globalTransform.ty), t.globalAlpha = f.alpha, t.transform(f.transform.a, f.transform.b, f.transform.c, f.transform.d, f.transform.tx, f.transform.ty);
              var l = e.imageKey.replace(".matte", ""),
                  u = this._owner._dynamicImage[l] || this._bitmapCache[l] || this._owner._videoItem.images[l];

              if ("string" == typeof u) {
                var h = this._bitmapCache[e.imageKey] || document.createElement("img"),
                    c = void 0,
                    d = void 0;

                if (0 === u.indexOf("iVBO") || 0 === u.indexOf("/9j/2w") ? h.src = "data:image/png;base64," + u : (h._svgaSrc !== u && (h._svgaSrc = u, h.src = u), c = f.layout.width, d = f.layout.height), this._bitmapCache[e.imageKey] = h, void 0 !== f.maskPath && null !== f.maskPath && (this.drawBezier(t, f.maskPath), t.clip()), void 0 !== this._owner._dynamicImageTransform[e.imageKey]) {
                  t.save();
                  var p = this._owner._dynamicImageTransform[e.imageKey];
                  t.transform(p[0], p[1], p[2], p[3], p[4], p[5]);
                }

                c && d ? t.drawImage(h, 0, 0, c, d) : t.drawImage(h, 0, 0), void 0 !== this._owner._dynamicImageTransform[e.imageKey] && t.restore();
              } else if ("object" === (void 0 === u ? "undefined" : i(u))) {
                if (void 0 !== f.maskPath && null !== f.maskPath && (f.maskPath._styles = void 0, this.drawBezier(t, f.maskPath), t.clip()), void 0 !== this._owner._dynamicImageTransform[e.imageKey]) {
                  t.save();
                  var y = this._owner._dynamicImageTransform[e.imageKey];
                  t.transform(y[0], y[1], y[2], y[3], y[4], y[5]);
                }

                t.drawImage(u, 0, 0), void 0 !== this._owner._dynamicImageTransform[e.imageKey] && t.restore();
              }

              f.shapes && f.shapes.forEach(function (e) {
                "shape" === e.type && e.pathArgs && e.pathArgs.d && n.drawBezier(t, new o.BezierPath(e.pathArgs.d, e.transform, e.styles)), "ellipse" === e.type && e.pathArgs && n.drawEllipse(t, new s.EllipsePath(parseFloat(e.pathArgs.x) || 0, parseFloat(e.pathArgs.y) || 0, parseFloat(e.pathArgs.radiusX) || 0, parseFloat(e.pathArgs.radiusY) || 0, e.transform, e.styles)), "rect" === e.type && e.pathArgs && n.drawRect(t, new a.RectPath(parseFloat(e.pathArgs.x) || 0, parseFloat(e.pathArgs.y) || 0, parseFloat(e.pathArgs.width) || 0, parseFloat(e.pathArgs.height) || 0, parseFloat(e.pathArgs.cornerRadius) || 0, e.transform, e.styles));
              });
              var m = this._owner._dynamicText[e.imageKey];

              if (void 0 !== m) {
                t.textBaseline = "middle", t.font = m.style;
                var v = t.measureText(m.text).width;
                t.fillStyle = m.color;
                var g = void 0 !== m.offset && void 0 !== m.offset.x ? isNaN(parseFloat(m.offset.x)) ? 0 : parseFloat(m.offset.x) : 0,
                    b = void 0 !== m.offset && void 0 !== m.offset.y ? isNaN(parseFloat(m.offset.y)) ? 0 : parseFloat(m.offset.y) : 0;
                t.fillText(m.text, (f.layout.width - v) / 2 + g, f.layout.height / 2 + b);
              }

              t.restore();
            }
          }
        }, {
          key: "playAudio",
          value: function value(e) {
            var t = this;

            if (this._owner._forwardAnimating && this._owner._videoItem.audios instanceof Array) {
              this._owner._videoItem.audios.forEach(function (r) {
                if (r.startFrame === e && void 0 !== t._bitmapCache[r.audioKey] && "function" == typeof t._bitmapCache[r.audioKey].play) {
                  var i = {
                    playID: t._bitmapCache[r.audioKey].play(),
                    player: t._bitmapCache[r.audioKey],
                    endFrame: r.endFrame
                  };
                  i.player.seek(r.startTime / 1e3, i.playID), t._soundsQueue.push(i);
                }
              });

              var r = !1;
              this._soundsQueue.forEach(function (t) {
                e >= t.endFrame && (r = !0, t.player.stop(t.playID));
              }), r && (this._soundsQueue = this._soundsQueue.filter(function (t) {
                return e < t.endFrame;
              }));
            }
          }
        }, {
          key: "resetShapeStyles",
          value: function value(e, t) {
            var r = t._styles;
            void 0 !== r && (r && r.stroke ? e.strokeStyle = "rgba(" + parseInt(255 * r.stroke[0]) + ", " + parseInt(255 * r.stroke[1]) + ", " + parseInt(255 * r.stroke[2]) + ", " + r.stroke[3] + ")" : e.strokeStyle = "transparent", r && (e.lineWidth = r.strokeWidth || void 0, e.lineCap = r.lineCap || void 0, e.lineJoin = r.lineJoin || void 0, e.miterLimit = r.miterLimit || void 0), r && r.fill ? e.fillStyle = "rgba(" + parseInt(255 * r.fill[0]) + ", " + parseInt(255 * r.fill[1]) + ", " + parseInt(255 * r.fill[2]) + ", " + r.fill[3] + ")" : e.fillStyle = "transparent", r && r.lineDash && e.setLineDash(r.lineDash));
          }
        }, {
          key: "drawBezier",
          value: function value(e, t) {
            var r = this;
            e.save(), this.resetShapeStyles(e, t), void 0 !== t._transform && null !== t._transform && e.transform(t._transform.a, t._transform.b, t._transform.c, t._transform.d, t._transform.tx, t._transform.ty);
            var i = {
              x: 0,
              y: 0,
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 0
            };
            e.beginPath(), t._d.replace(/([a-zA-Z])/g, "|||$1 ").replace(/,/g, " ").split("|||").forEach(function (t) {
              if (0 != t.length) {
                var n = t.substr(0, 1);

                if ("MLHVCSQRZmlhvcsqrz".indexOf(n) >= 0) {
                  var o = t.substr(1).trim().split(" ");
                  r.drawBezierElement(e, i, n, o);
                }
              }
            }), t._styles && t._styles.fill && e.fill(), t._styles && t._styles.stroke && e.stroke(), e.restore();
          }
        }, {
          key: "drawBezierElement",
          value: function value(e, t, r, i) {
            switch (r) {
              case "M":
                t.x = Number(i[0]), t.y = Number(i[1]), e.moveTo(t.x, t.y);
                break;

              case "m":
                t.x += Number(i[0]), t.y += Number(i[1]), e.moveTo(t.x, t.y);
                break;

              case "L":
                t.x = Number(i[0]), t.y = Number(i[1]), e.lineTo(t.x, t.y);
                break;

              case "l":
                t.x += Number(i[0]), t.y += Number(i[1]), e.lineTo(t.x, t.y);
                break;

              case "H":
                t.x = Number(i[0]), e.lineTo(t.x, t.y);
                break;

              case "h":
                t.x += Number(i[0]), e.lineTo(t.x, t.y);
                break;

              case "V":
                t.y = Number(i[0]), e.lineTo(t.x, t.y);
                break;

              case "v":
                t.y += Number(i[0]), e.lineTo(t.x, t.y);
                break;

              case "C":
                t.x1 = Number(i[0]), t.y1 = Number(i[1]), t.x2 = Number(i[2]), t.y2 = Number(i[3]), t.x = Number(i[4]), t.y = Number(i[5]), e.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                break;

              case "c":
                t.x1 = t.x + Number(i[0]), t.y1 = t.y + Number(i[1]), t.x2 = t.x + Number(i[2]), t.y2 = t.y + Number(i[3]), t.x += Number(i[4]), t.y += Number(i[5]), e.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                break;

              case "S":
                t.x1 && t.y1 && t.x2 && t.y2 ? (t.x1 = t.x - t.x2 + t.x, t.y1 = t.y - t.y2 + t.y, t.x2 = Number(i[0]), t.y2 = Number(i[1]), t.x = Number(i[2]), t.y = Number(i[3]), e.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y)) : (t.x1 = Number(i[0]), t.y1 = Number(i[1]), t.x = Number(i[2]), t.y = Number(i[3]), e.quadraticCurveTo(t.x1, t.y1, t.x, t.y));
                break;

              case "s":
                t.x1 && t.y1 && t.x2 && t.y2 ? (t.x1 = t.x - t.x2 + t.x, t.y1 = t.y - t.y2 + t.y, t.x2 = t.x + Number(i[0]), t.y2 = t.y + Number(i[1]), t.x += Number(i[2]), t.y += Number(i[3]), e.bezierCurveTo(t.x1, t.y1, t.x2, t.y2, t.x, t.y)) : (t.x1 = t.x + Number(i[0]), t.y1 = t.y + Number(i[1]), t.x += Number(i[2]), t.y += Number(i[3]), e.quadraticCurveTo(t.x1, t.y1, t.x, t.y));
                break;

              case "Q":
                t.x1 = Number(i[0]), t.y1 = Number(i[1]), t.x = Number(i[2]), t.y = Number(i[3]), e.quadraticCurveTo(t.x1, t.y1, t.x, t.y);
                break;

              case "q":
                t.x1 = t.x + Number(i[0]), t.y1 = t.y + Number(i[1]), t.x += Number(i[2]), t.y += Number(i[3]), e.quadraticCurveTo(t.x1, t.y1, t.x, t.y);
                break;

              case "A":
              case "a":
                break;

              case "Z":
              case "z":
                e.closePath();
            }
          }
        }, {
          key: "drawEllipse",
          value: function value(e, t) {
            e.save(), this.resetShapeStyles(e, t), void 0 !== t._transform && null !== t._transform && e.transform(t._transform.a, t._transform.b, t._transform.c, t._transform.d, t._transform.tx, t._transform.ty);
            var r = t._x - t._radiusX,
                i = t._y - t._radiusY,
                n = 2 * t._radiusX,
                o = 2 * t._radiusY,
                s = n / 2 * .5522848,
                a = o / 2 * .5522848,
                f = r + n,
                l = i + o,
                u = r + n / 2,
                h = i + o / 2;
            e.beginPath(), e.moveTo(r, h), e.bezierCurveTo(r, h - a, u - s, i, u, i), e.bezierCurveTo(u + s, i, f, h - a, f, h), e.bezierCurveTo(f, h + a, u + s, l, u, l), e.bezierCurveTo(u - s, l, r, h + a, r, h), t._styles && t._styles.fill && e.fill(), t._styles && t._styles.stroke && e.stroke(), e.restore();
          }
        }, {
          key: "drawRect",
          value: function value(e, t) {
            e.save(), this.resetShapeStyles(e, t), void 0 !== t._transform && null !== t._transform && e.transform(t._transform.a, t._transform.b, t._transform.c, t._transform.d, t._transform.tx, t._transform.ty);
            var r = t._x,
                i = t._y,
                n = t._width,
                o = t._height,
                s = t._cornerRadius;
            n < 2 * s && (s = n / 2), o < 2 * s && (s = o / 2), e.beginPath(), e.moveTo(r + s, i), e.arcTo(r + n, i, r + n, i + o, s), e.arcTo(r + n, i + o, r, i + o, s), e.arcTo(r, i + o, r, i, s), e.arcTo(r, i, r + n, i, s), e.closePath(), t._styles && t._styles.fill && e.fill(), t._styles && t._styles.stroke && e.stroke(), e.restore();
          }
        }]), e;
      }();
    }, function (e, t, r) {

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.AutoLoader = void 0;

      var i = r(13),
          n = r(63),
          o = t.AutoLoader = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      };

      o.sharedParser = new i.Parser(), o.autoload = function (e, t) {
        if ("undefined" != typeof window && "undefined" != typeof document) {
          var r = t || o.sharedParser;

          if (e) {
            if (("CANVAS" === e.tagName || "DIV" === e.tagName) && e.attributes.src && e.attributes.src.value.indexOf(".svga") === e.attributes.src.value.length - 5) {
              var i = e.attributes.src.value,
                  s = new n.Player(e);
              r.load(i, function (t) {
                if (e.attributes.loops) {
                  var r = parseFloat(e.attributes.loops.value) || 0;
                  s.loops = r;
                }

                if (e.attributes.clearsAfterStop) {
                  var i = !("false" === e.attributes.clearsAfterStop.value);
                  s.clearsAfterStop = i;
                }

                s.setVideoItem(t), s.startAnimation();
              }), e.player = s;
            }
          } else for (var a = document.querySelectorAll('[src$=".svga"]'), f = 0; f < a.length; f++) {
            e = a[f];
            o.autoload(e);
          }
        }
      };
    }]);
  });
});
var SVGA = /*@__PURE__*/getDefaultExportFromCjs(svga_min);

var svga = {
  waving: 'https://cdn.gaotu100.com/images/waving.svga'
}; // 缓存解析过的svga

var svgaMap = new Map();
var svgaParser = new SVGA.Parser();
var loadSVGA = function loadSVGA(name) {
  if (!svgaMap.get(name)) {
    new Promise(function (resolve, reject) {
      svgaParser.load(svga[name], function (parsedItem) {
        svgaMap.set(name, parsedItem);
        resolve(parsedItem);
      }, function (err) {
        reject(err);
      });
    });
  }

  return svgaMap.get(name);
};
var getSVGA = function getSVGA(name, className, frame, callBack, play, loops, clearsAfterStop) {
  if (frame === void 0) {
    frame = 0;
  }

  if (play === void 0) {
    play = true;
  }

  return __awaiter$2(void 0, void 0, void 0, function () {
    var playItem, svgaPlayer;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , loadSVGA(name)];

        case 1:
          playItem = _a.sent();
          svgaPlayer = new SVGA.Player(className);

          if (loops) {
            svgaPlayer.loops = loops;
          }

          svgaPlayer.clearsAfterStop = clearsAfterStop || false;
          svgaPlayer.setVideoItem(playItem);
          svgaPlayer.stepToFrame(frame, play);
          svgaPlayer.onFinished(function () {
            if (callBack && typeof callBack === 'function') {
              callBack();
            }
          });
          return [2
          /*return*/
          , svgaPlayer];
      }
    });
  });
};

var style$Y = {"side-btn":"tangram_C_side-btn_c28580cb57","recorder-container":"tangram_C_recorder-container_c28580cb57","recorder-sider-right":"tangram_C_recorder-sider-right_c28580cb57","recorder-sider-left":"tangram_C_recorder-sider-left_c28580cb57","msg":"tangram_C_msg_c28580cb57","uploading":"tangram_C_uploading_c28580cb57","loading":"tangram_C_loading_c28580cb57","fixed-time":"tangram_C_fixed-time_c28580cb57","tape":"tangram_C_tape_c28580cb57"};

var _a$e;
var styledClassNames$6 = bind.bind(style$Y);
var DEFAULT_RECORDER_TIME_LIMIT = 300;
var client$2 = (_a$e = parseQuery()) === null || _a$e === void 0 ? void 0 : _a$e.client;
var ELANG$1;

(function (ELANG) {
  ELANG[ELANG["ENG"] = 0] = "ENG";
  ELANG[ELANG["CHN"] = 1] = "CHN";
})(ELANG$1 || (ELANG$1 = {}));

var EQTYPE$1;

(function (EQTYPE) {
  EQTYPE[EQTYPE["BASE"] = 0] = "BASE";
  EQTYPE[EQTYPE["POEM"] = 2] = "POEM";
})(EQTYPE$1 || (EQTYPE$1 = {}));

var Recorder$1 = function Recorder(props) {
  var _a = useState(false),
      isTaping = _a[0],
      setTaping = _a[1];

  var _b = useState(''),
      currentAudioUrl = _b[0],
      setCurrentAudioUrl = _b[1];

  var _c = useState(false),
      isPlaying = _c[0],
      setPlaying = _c[1];

  var _d = useState('00:00'),
      time = _d[0],
      setTime = _d[1];

  var recordDuration = useRef();
  var hiddenAudioRef = useRef(null);
  var stop = useExclusivePlay().stop;
  var questionIdRef = useRef('');
  var isTapingRef = useRef(false);
  var isPlayingRef = useRef(false);
  isTapingRef.current = isTaping;
  isPlayingRef.current = isPlaying;
  var wxFinishRecording = useRef(false);
  var wxTimer = useRef();
  var wxCountStart = useRef();
  var wxRecordTime = useRef();

  var _e = useState(false),
      wxAudioUploading = _e[0],
      setWxAudioUploading = _e[1];

  var wxAudioUploadingRef = useRef(false);
  wxAudioUploadingRef.current = wxAudioUploading; // 通过微信音频serverId上传音频的接口地址;

  var wxAudioUploadAddr = "https://".concat(envPrefix(), "api.gaotu100.com/exercise/media/transfer");
  var questionInfo = props.questionInfo,
      handleStart = props.handleStart,
      handleSubmit = props.handleSubmit,
      handleError = props.handleError;
  questionIdRef.current = (questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionId) || '';
  var myAudioTimer;

  function autoEndRecordPlaying() {
    var _a;

    if (isPlayingRef.current) {
      (_a = hiddenAudioRef === null || hiddenAudioRef === void 0 ? void 0 : hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
      setPlaying(false);
    }
  }

  var requestPermission = wxRecorder.requestPermission,
      startRecording = wxRecorder.startRecording,
      stopRecording = wxRecorder.stopRecording,
      set = wxRecorder.set; // 在14.3版本以下的iOS系统，微信小程序中使用小程序提供的录音能力
  // 停止录音相关

  function onStopSuccess(mediaIds) {
    console.log('最终上传的音频ids:', mediaIds); // 调用音频转换接口，最终接收到的mp3格式的音频链接

    var uploadAudioParams = {
      client: client$2,
      mediaIds: mediaIds
    };
    axios.post(wxAudioUploadAddr, uploadAudioParams).then(function (res) {
      var code = res.code,
          data = res.data,
          msg = res.msg;

      if (code === 0 && data) {
        setCurrentAudioUrl(data);
        setWxAudioUploading(false);
        setTime(timeFormat(wxRecordTime.current ? Math.ceil(wxRecordTime.current / 1000) : 0));
        return;
      } // eslint-disable-next-line max-len


      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u97F3\u9891serverIds\uFF0C\u8BF7\u6C42\u5C06\u97F3\u9891\u4E0A\u4F20\u5230cdn\u65F6\uFF0C\u54CD\u5E94\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(uploadAudioParams, "\uFF0C\u54CD\u5E94code\u53CAmsg: ").concat(code, ", ").concat(msg, ", \u54CD\u5E94\u6570\u636E: ").concat(data);
      handleError === null || handleError === void 0 ? void 0 : handleError('上传录音的时候出错啦，请再重新录音试试吧～');
      console.error(errMsg);
      setWxAudioUploading(false);
      footPrintJSErrorReport({
        detailAction: errMsg
      });
    }).catch(function (reason) {
      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u97F3\u9891serverIds\uFF0C\u8BF7\u6C42\u5C06\u56FE\u7247\u4E0A\u4F20\u5230cdn\u65F6\uFF0C\u8BF7\u6C42\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(uploadAudioParams, "\uFF0C\u9519\u8BEF\u4FE1\u606F: ").concat(reason);
      handleError === null || handleError === void 0 ? void 0 : handleError('上传录音时出错啦，请再重新录音试试吧～');
      console.error(errMsg);
      setWxAudioUploading(false);
      footPrintJSErrorReport({
        detailAction: errMsg
      });
    });
  } // 微信录音大致分为两个阶段：
  // 1. 录音阶段 2. 上传/上传后请求对应音频URL阶段
  // beforeUpload 钩子用于感知录音完成后，上传录音前的这段状态


  function beforeUpload() {
    // 标识已经完成录音，接下来要上传了
    wxFinishRecording.current = true; // 记录录音整体时长

    wxCountStart.current && (wxRecordTime.current = Date.now() - wxCountStart.current); // 录音完成后，改变录音状态为false
    // 清除定时器

    setTaping(false); // 录音完成后，微信音频需要上传转码，需要改变wxAudioUploading状态为true

    setWxAudioUploading(true);
    window.clearTimeout(wxTimer.current);
  }

  function onStopFailed(e) {
    if (wxFinishRecording.current) {
      var errMsg_1 = "[wx\u5F55\u97F3\u4F5C\u7B54\u65B9\u5F0F]: \u97F3\u9891\u4E0A\u4F20\u81F3\u5FAE\u4FE1\u670D\u52A1\u5668\u65F6\u51FA\u9519\uFF0C \u9519\u8BEF\u4FE1\u606F: ".concat(e);
      console.error(errMsg_1);
      handleError === null || handleError === void 0 ? void 0 : handleError('音频上传时出错啦，请再重新录音试试吧～');
      wxFinishRecording.current = false;
      setWxAudioUploading(false);
      footPrintJSErrorReport({
        actionValue: errMsg_1
      });
      return;
    }

    var errMsg = "[wx\u5F55\u97F3\u4F5C\u7B54\u65B9\u5F0F]: \u7ED3\u675F\u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F:".concat(e);
    setTaping(false);
    setWxAudioUploading(false);
    window.clearTimeout(wxTimer.current);
    wxFinishRecording.current = false;
    console.error(errMsg);
    handleError === null || handleError === void 0 ? void 0 : handleError('录音出错啦，请再重新录音试试吧～');
    footPrintJSErrorReport({
      actionValue: errMsg
    });
  }

  function wxRecording() {
    var _this = this;

    var _a, _b;

    if (wxAudioUploadingRef.current) {
      return;
    } // 如果是在录音过程中，则停止录音


    if (isTapingRef.current) {
      stopRecording(onStopSuccess, onStopFailed, beforeUpload);
      return;
    }

    function getPermission() {
      return new Promise(function (resolve, reject) {
        function permissionGranted() {
          console.info('[wx录音作答方式]: 小程序录音权限请求成功');
          footPrintSecondaryReport({
            actionValue: '[wx录音作答方式]: 小程序录音权限请求成功'
          });
          resolve(true);
        }

        function permissionDenied(e, userDenied) {
          if (userDenied === void 0) {
            userDenied = false;
          }

          var deniedMsg = "[wx\u5F55\u97F3\u4F5C\u7B54\u65B9\u5F0F]: \u5C0F\u7A0B\u5E8F\u5F55\u97F3\u6388\u6743\u672A\u901A\u8FC7\uFF0C".concat(userDenied ? '用户拒绝了录音权限请求，' : '', "\u9519\u8BEF\u4FE1\u606F:").concat(e);
          console.error(deniedMsg);
          handleError === null || handleError === void 0 ? void 0 : handleError("\u5F55\u97F3\u51FA\u9519\u4E86\u54E6\uFF0C".concat("\u8BF7".concat(userDenied ? '授权录音后' : '', "\u518D\u8BD5\u8BD5\u5427\uFF5E"))); // 请求录音权限出错时脚印上报

          footPrintJSErrorReport({
            actionValue: deniedMsg
          });
          reject(deniedMsg);
        }

        requestPermission(permissionGranted, permissionDenied);
      });
    } // 开始录音相关


    function onWxStartSuccess() {
      // 调用外部录音传入的开始录音回调
      handleStart === null || handleStart === void 0 ? void 0 : handleStart(); // 微信录音真正开始时，才设置录音状态为true，报错或停止时，将录音状态设置为false

      setTaping(true); // 录音开始时，记录开始时间

      wxCountStart.current = Date.now(); // 录音超时检查，开始录音后挂载一个定时器，当达到timelimit限制时
      // 如果此时仍在录音，则自动调用停止
      // 出错或定时器触发前停止时，则清除此定时器

      function wxRecordingAutoStop() {
        return __awaiter$2(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!isTapingRef.current) return [3
                /*break*/
                , 3];
                console.log('[wx录音作答方式]: timelimit时间到，自动停止录音');
                stopRecording(onStopSuccess, onStopFailed, beforeUpload);
                return [4
                /*yield*/
                , getSVGA('waving', '.waving', 0, null, true, 0, true)];

              case 1:
                // 自动停止录音时也需要停止svga动画
                _a.sent().stopAnimation();

                return [4
                /*yield*/
                , getSVGA('waving', '.waving-copy', 0, null, true, 0, true)];

              case 2:
                _a.sent().stopAnimation();

                _a.label = 3;

              case 3:
                return [2
                /*return*/
                ];
            }
          });
        });
      }

      wxTimer.current = window.setTimeout(wxRecordingAutoStop, (DEFAULT_RECORDER_TIME_LIMIT + 1.2) * 1000);
    }

    function onWxStartFailed(e) {
      console.error("[wx\u5F55\u97F3\u4F5C\u7B54\u65B9\u5F0F]: \u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F\uFF1A".concat(e)); // 此函数被调用时，有两种情况：
      // 1. 开始录音时即报错
      // 2. 开始录音后，微信录音超过一分钟后，接续录音时报错
      // 第2种情况发生时，需要清除计时器，并设置录音状态为false.

      window.clearTimeout(wxTimer.current);
      setTaping(false);
      handleError === null || handleError === void 0 ? void 0 : handleError('开始录音的时候出错了哦，请重新试试吧～'); // 录音出错时脚印上报

      footPrintJSErrorReport({
        actionValue: "\u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F:".concat(e)
      });
    } // 如果没有录音，则开始请求权限录音


    if (!currentAudioUrl) {
      // 请求权限，并授权成功后开始录音
      getPermission().then(function (val) {
        return __awaiter$2(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                console.info('[wx录音作答方式]: 录音开始'); // 停止所有音频播放

                stop(); // 播放svga

                return [4
                /*yield*/
                , getSVGA('waving', '.waving', 0, null, true, 0, true)];

              case 1:
                // 播放svga
                _a.sent();

                return [4
                /*yield*/
                , getSVGA('waving', '.waving-copy', 0, null, true, 0, true)];

              case 2:
                _a.sent();

                startRecording(set, onWxStartSuccess, onWxStartFailed);
                return [2
                /*return*/
                ];
            }
          });
        });
      });
      return;
    } // 已经录了音频
    // 如果此时没有播放则播放,否则暂停
    // 此处仍然需要挂载一个定时器用于定时暂停播放用户录音


    if (!isPlaying) {
      if (recordDuration.current) {
        // 停止所有其他页面上音频的播放
        stop();
        (_a = hiddenAudioRef === null || hiddenAudioRef === void 0 ? void 0 : hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.play();
        setPlaying(true);
        myAudioTimer = window.setTimeout(function () {
          return autoEndRecordPlaying();
        }, recordDuration.current * 1000);
      }
    } else {
      (_b = hiddenAudioRef === null || hiddenAudioRef === void 0 ? void 0 : hiddenAudioRef.current) === null || _b === void 0 ? void 0 : _b.pause();
      window.clearTimeout(myAudioTimer);
      setPlaying(false);
    }
  } // web录音定时器


  var timer;

  function onStart() {
    console.log('start：[web端]开始录音');
    handleStart === null || handleStart === void 0 ? void 0 : handleStart(); // 录音开始时，设置录音状态为true，报错或停止时，将录音状态设置为false

    setTaping(true); // 录音超时检查，开始录音后挂载一个定时器，当达到timelimit限制时
    // 如果此时仍在录音，则自动调用停止
    // 出错或定时器触发前停止时，则清除此定时器

    function webRecordingAutoStop() {
      return __awaiter$2(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!isTapingRef.current) return [3
              /*break*/
              , 3];
              console.log('[web端]timelimit时间到，自动停止录音');
              j.aiengineStop();
              return [4
              /*yield*/
              , getSVGA('waving', '.waving', 0, null, true, 0, true)];

            case 1:
              // 自动停止录音时也需要停止svga动画
              _a.sent().stopAnimation();

              return [4
              /*yield*/
              , getSVGA('waving', '.waving-copy', 0, null, true, 0, true)];

            case 2:
              _a.sent().stopAnimation();

              _a.label = 3;

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    timer = window.setTimeout(webRecordingAutoStop, DEFAULT_RECORDER_TIME_LIMIT * 1000);
  }

  function onError(err) {
    // 录音报错时，设置录音状态为false，抛出错误
    console.log('error：[web端]录音出错', err);
    window.clearTimeout(timer);

    if (err.errId === 40003) {
      handleError === null || handleError === void 0 ? void 0 : handleError('该浏览器不支持录音');
    } else {
      handleError === null || handleError === void 0 ? void 0 : handleError('录音出错了哦，再试试吧');
    }

    setTaping(false);
  }

  function onResult(res) {
    if (res.is_last_response) {
      console.log('[web端]录音收到最后一个响应', res);

      if (questionIdRef.current !== (questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionId)) {
        // 切题导致的不再响应上一题的回调
        return;
      }

      console.log('[web端]这是存的录音：', res.url);
      setCurrentAudioUrl(res.url);
    }
  }

  function onComplete() {
    console.log('complete：[web端]录音完成');
    window.clearTimeout(timer);
    setTaping(false);
  }

  function handleClick() {
    var _a, _b;

    return __awaiter$2(this, void 0, void 0, function () {
      var options;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!isTaping) return [3
            /*break*/
            , 3]; // 调用web能力结束录音

            j.aiengineStop();
            return [4
            /*yield*/
            , getSVGA('waving', '.waving', 0, null, true, 0, true)];

          case 1:
            // 停止svga动画
            _c.sent().stopAnimation();

            return [4
            /*yield*/
            , getSVGA('waving', '.waving-copy', 0, null, true, 0, true)];

          case 2:
            _c.sent().stopAnimation();

            return [3
            /*break*/
            , 7];

          case 3:
            if (!!currentAudioUrl) return [3
            /*break*/
            , 6]; // 停止所有音频的播放

            stop(); // 播放svga

            return [4
            /*yield*/
            , getSVGA('waving', '.waving', 0, null, true, 0, true)];

          case 4:
            // 播放svga
            _c.sent();

            return [4
            /*yield*/
            , getSVGA('waving', '.waving-copy', 0, null, true, 0, true)];

          case 5:
            _c.sent(); // web端调用语音评测sdk开始录音


            console.log('[web端]调用webSDK开始录音');
            options = {
              config: {
                lang: ELANG$1.ENG,
                questionType: EQTYPE$1.BASE,
                questionId: questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionId,
                spokenText: 'example',
                appId: '66666',
                enableSaveAudio: true
              },
              onStart: onStart,
              onResult: onResult,
              onError: onError,
              onComplete: onComplete
            };

            try {
              j.aiengineStart(options);
            } catch (error) {
              console.log('web端启用语音评测引擎失败', error);
              handleError === null || handleError === void 0 ? void 0 : handleError('web端录音出错');
            }

            return [2
            /*return*/
            ];

          case 6:
            // 已经录了音频
            // 如果此时没有播放则播放,否则暂停
            // 此处仍然需要挂载一个定时器用于定时暂停播放用户录音
            if (!isPlaying) {
              if (recordDuration.current) {
                // 停止所有其他页面上音频的播放
                stop();
                (_a = hiddenAudioRef === null || hiddenAudioRef === void 0 ? void 0 : hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.play();
                setPlaying(true);
                myAudioTimer = window.setTimeout(function () {
                  return autoEndRecordPlaying();
                }, recordDuration.current * 1000);
              }
            } else {
              (_b = hiddenAudioRef === null || hiddenAudioRef === void 0 ? void 0 : hiddenAudioRef.current) === null || _b === void 0 ? void 0 : _b.pause();
              window.clearTimeout(myAudioTimer);
              setPlaying(false);
            }

            _c.label = 7;

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  useEffect(function () {
    console.log('isPlaying变化了哟：', isPlaying);
  }, [isPlaying]); // 重录

  function handleRerecord() {
    setCurrentAudioUrl('');
  } // 完成


  function handleFinish() {
    handleSubmit === null || handleSubmit === void 0 ? void 0 : handleSubmit(currentAudioUrl, Math.ceil(recordDuration.current || 0).toString());
    setCurrentAudioUrl('');
  } // 录音计时完成


  function handleTimeCounterFinish(formatTime) {
    console.log('计时完成完成回调触发啦');
    setTime(formatTime);
  } // 组件mount, 预加载svga资源


  useEffect(function () {
    return loadSVGA('waving');
  }, []);
  useEffect(function () {
    var _a;

    if (currentAudioUrl !== '') {
      (_a = hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.load();
    }
  }, [currentAudioUrl]);
  useLoadedEvent(hiddenAudioRef, function () {
    var _a;

    recordDuration.current = (_a = hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.duration;
  });
  useEffect(function () {
    var _a;

    if (isTaping) {
      // eslint-disable-next-line
      console.log('发生录音中切题事件');
      footPrintSecondaryReport({
        actionValue: '录音中发生切题事件'
      });
      j.aiengineStop(); // TODO: 加上iOS系统的版本判断

      if (window.wx && isWX) {
        stopRecording(function () {});
        window.clearTimeout(wxTimer.current);
      }
    }

    if (isPlaying) {
      console.log('发生听录音中切题事件');
      (_a = hiddenAudioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
      window.clearTimeout(myAudioTimer);
    }

    return function () {
      j.aiengineStop();
      window.clearTimeout(timer);
      window.wx && isWX && stopRecording(function () {});
      window.clearTimeout(wxTimer.current);
      window.clearTimeout(myAudioTimer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionId]);
  var handleClickRecord = window.wx && isWX ? wxRecording : handleClick;
  return /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$6({
      'recorder-container': true
    })
  }, currentAudioUrl && /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$6({
      'recorder-sider-left': true
    }),
    role: "button",
    onClick: handleRerecord,
    tabIndex: -1
  }, "\u91CD\u5F55"), /*#__PURE__*/React.createElement("div", {
    className: "waving",
    style: {
      opacity: isTaping ? 1 : 0,
      height: '20px',
      width: '60px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(46px, 12px)'
    }
  }), isTaping && /*#__PURE__*/React.createElement(TimeCounter, {
    trigger: isTaping,
    onStop: handleTimeCounterFinish
  }), !isTaping && !isPlaying && currentAudioUrl && /*#__PURE__*/React.createElement("span", {
    className: styledClassNames$6({
      'fixed-time': true
    })
  }, time), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styledClassNames$6({
      tape: true
    }),
    onClick: handleClickRecord
  }, /*#__PURE__*/React.createElement("audio", {
    src: currentAudioUrl || '',
    ref: hiddenAudioRef
  }), !isTaping && !isPlaying && !currentAudioUrl && /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$6({
      msg: true
    })
  }, wxAudioUploading ? '上传中' : '可录音5分钟'), wxAudioUploading ? /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$6({
      uploading: true
    })
  }) : /*#__PURE__*/React.createElement(Progress, {
    circleWidth: 60,
    playing: isTaping ? 1 : isPlaying ? 1 : 0,
    duration: isTaping ? DEFAULT_RECORDER_TIME_LIMIT : isPlaying ? recordDuration.current : 0,
    backgroundImage: isTaping ? img$g : isPlaying ? img$g : currentAudioUrl ? img$f : img$h,
    ringColor: "#ffffff",
    ringOpacity: 0.5,
    ringWidth: 4
  })), /*#__PURE__*/React.createElement("div", {
    className: "waving-copy",
    style: {
      opacity: isTaping ? 1 : 0,
      height: '20px',
      width: '60px',
      position: 'absolute',
      right: '50%',
      top: '50%',
      transform: 'translate(-46px, 12px)'
    }
  }), currentAudioUrl && /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$6({
      'recorder-sider-right': true
    }),
    role: "button",
    onClick: handleFinish,
    tabIndex: -1
  }, "\u5B8C\u6210"));
};

var Recorder$2 = withErrorBoundary(Recorder$1);

var style$X = {"loading":"tangram_C_loading_829ccf0a44","load":"tangram_C_load_829ccf0a44"};

var Loading = function Loading(_a) {
  var customStyle = _a.customStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: style$X.loading,
    style: _assign$4({}, customStyle)
  });
};

var userId = getUserId(); // 阿里云上传视频获取token和基本信息

var ALI_UPLOAD_VIDEO = "https://".concat(envPrefix(), "api.gaotu100.com/homework/student/v5/getAliStorageToken"); // 最大重试次数为10次

var retryCountMax = 10;
var retryCount = 0;
var currentCheckPoint;
var uploadFileClient; // 接口重试机制

var retryGetTokenCount = 0;
var retryGetTokenCountMax = 3; // 每次上传的所有文件

var allFiles;
var curUploadAborted = false;
function updateModuleUploadAbortedVar(uploadAborted) {
  curUploadAborted = uploadAborted;
} // 重置OSS上传的client和部分opts

function resetOSSClientAndOpts() {
  uploadFileClient = null;
  currentCheckPoint = null;
  retryCount = 0;
}

var getAliVideoToken = function getAliVideoToken(params) {
  return __awaiter$2(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          // eslint-disable-next-line quote-props
          return [4
          /*yield*/
          , axios.post(ALI_UPLOAD_VIDEO, params, {
            'sid': getSid()
          })];

        case 1:
          // eslint-disable-next-line quote-props
          return [2
          /*return*/
          , _a.sent()];
      }
    });
  });
};

var getAliToken = function getAliToken() {
  return new Promise(function (resolve, reject) {
    getAliVideoToken({
      userId: userId
    }).then(function (res) {
      if (res.code === 0 && res.data) {
        resolve(res.data);
      }
    }).catch(function (error) {
      if (retryGetTokenCount < retryGetTokenCountMax) {
        console.log('获取token重试', retryGetTokenCount);
        retryGetTokenCount++;
        getAliToken();
      } else {
        console.error('获取token失败', error);
        reject(error);
      }
    });
  });
};
/**
 *
 * @param client 阿里云token实例
 * @param file 单个上传文件
 * @param getProgress 获取单个文件上传进度
 * @param judgeIsReload 重传状态显示方法
 * @returns 成功返回服务器返回的数值，其他返回false
 */

var uploadFile = function uploadFile(client, file, getProgress, getFileData, judgeIsReload, curFileIdx, onError, onFinished, getCurrentClientAndCheckPoint) {
  return __awaiter$2(void 0, void 0, void 0, function () {
    var options, result, fileUrl, url;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          console.log(client, uploadFileClient, '开始上传吗？');

          if (curUploadAborted) {
            resetOSSClientAndOpts();
            curUploadAborted = false;
            return [2
            /*return*/
            , false];
          }

          if (client && !uploadFileClient || uploadFileClient && Object.keys(uploadFileClient).length === 0) {
            uploadFileClient = client;
          }

          console.log('开始上传');
          options = {
            // 获取分片上传进度、断点和返回值。
            progress: function progress(p, cpt) {
              getProgress === null || getProgress === void 0 ? void 0 : getProgress(p);
              currentCheckPoint = cpt;
              getCurrentClientAndCheckPoint === null || getCurrentClientAndCheckPoint === void 0 ? void 0 : getCurrentClientAndCheckPoint(cpt, uploadFileClient);
            },
            // 设置并发上传的分片数量。
            parallel: 2,
            // 设置分片大小。最小值为100 KB，当前为4M
            partSize: 4 * 1024 * 1024,
            mime: 'text/plain',
            // 超时时间
            timeout: 10000
          };

          if (currentCheckPoint) {
            // @ts-ignore
            options.checkpoint = currentCheckPoint;
          }

          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , uploadFileClient === null || uploadFileClient === void 0 ? void 0 : uploadFileClient.multipartUpload(file.name, file, options)];

        case 2:
          result = _a.sent();

          if (result && result.res.status === 200) {
            currentCheckPoint = null;
            uploadFileClient = null;
            fileUrl = result === null || result === void 0 ? void 0 : result.res.requestUrls[0];

            if (fileUrl.indexOf('?') !== -1) {
              url = fileUrl.slice(0, fileUrl.indexOf('?'));
              getFileData === null || getFileData === void 0 ? void 0 : getFileData(url);
            }

            if (allFiles.length - 1 === 0) {
              onFinished === null || onFinished === void 0 ? void 0 : onFinished(true);
              uploadFileClient = null;
            } // 将成功值返回


            return [2
            /*return*/
            , result.res];
          }

          onError === null || onError === void 0 ? void 0 : onError(true);
          return [2
          /*return*/
          , false];

        case 3:
          _a.sent();
          console.error('出错了');

          if (retryCount < retryCountMax) {
            // 重试
            retryCount++;
            console.log('开始重试', retryCount);
            uploadFile(null, file, getProgress, getFileData, judgeIsReload, curFileIdx, onError, onFinished, getCurrentClientAndCheckPoint);
          } else {
            console.error("\u7B2C".concat(retryCountMax, "\u6B21\u91CD\u8BD5\u51FA\u9519"));
            resetOSSClientAndOpts();
            judgeIsReload === null || judgeIsReload === void 0 ? void 0 : judgeIsReload(true);
            onError === null || onError === void 0 ? void 0 : onError(true);
            return [2
            /*return*/
            , false];
          }

          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};
/**
 *
 * @param file 上传文件集
 * @param getProgress 获取进度函数
 * @param getFileData 获取视频url函数
 * @param judgeIsReload 控制重新加载状态函数
 * @param isShowReload 重新加载状态
 */


var handleVideoUpload = function handleVideoUpload(file, getProgress, getFileData, onError, onFinished, getCurrentClientAndCheckPoint, judgeIsReload, isShowReload) {
  // 重新加载取剩下的file，否则取初始file
  if (!isShowReload) {
    allFiles = __spreadArray([], Array.from(file), true);
  }

  if (isShowReload) {
    retryCount = 0;
    judgeIsReload === null || judgeIsReload === void 0 ? void 0 : judgeIsReload(false);
  }

  getAliToken().then(function (res) {
    return __awaiter$2(void 0, void 0, void 0, function () {
      var accessKeyId, accessKeySecret, bucketName, securityToken, client, i, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            accessKeyId = res.accessKeyId, accessKeySecret = res.accessKeySecret, bucketName = res.bucketName, securityToken = res.securityToken;
            client = new OSS({
              region: 'oss-cn-beijing',
              accessKeyId: accessKeyId,
              accessKeySecret: accessKeySecret,
              // 从STS服务获取的安全令牌（SecurityToken）。
              stsToken: securityToken,
              // 填写Bucket名称，例如examplebucket。
              bucket: bucketName
            });
            if (!allFiles.length) return [3
            /*break*/
            , 4];
            i = 0;
            _a.label = 1;

          case 1:
            if (!(i < allFiles.length)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , uploadFile(client, allFiles[i], getProgress, getFileData, judgeIsReload, i, onError, onFinished, getCurrentClientAndCheckPoint)];

          case 2:
            result = _a.sent();
            console.log('走到这里了');

            if (result) {
              // 去除上传成功的file
              allFiles.splice(i, 1);
              i--;
              return [3
              /*break*/
              , 3];
            } else {
              return [3
              /*break*/
              , 4];
            }

          case 3:
            i++;
            return [3
            /*break*/
            , 1];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }).catch(function (error) {
    console.error(error);
    onError === null || onError === void 0 ? void 0 : onError(true, '鉴权失败。');
  });
};

var style$W = {"answer-menu":"tangram_C_answer-menu_4c2f79c049","menu-item":"tangram_C_menu-item_4c2f79c049","menu-enter":"tangram_C_menu-enter_4c2f79c049","menu-enter-active":"tangram_C_menu-enter-active_4c2f79c049","menu-enter-done":"tangram_C_menu-enter-done_4c2f79c049","answer-menu-shadow":"tangram_C_answer-menu-shadow_4c2f79c049"};

var _a$d;
var AnswerType2DealedAType = (_a$d = {}, _a$d[EAnswerTypes.IMAGE] = EDealedATypes.IMAGE, _a$d[EAnswerTypes.VIDEO] = EDealedATypes.VIDEO, _a$d[EAnswerTypes.AUDIO] = EDealedATypes.AUDIO, _a$d[EAnswerTypes.TEXT] = EDealedATypes.TEXT, _a$d[EAnswerTypes.RICH_TEXT] = EDealedATypes.TEXT, _a$d[EAnswerTypes.LOOK_ENG_READ_ENG] = null, _a$d[EAnswerTypes.LOOK_CN_READ_ENG] = null, _a$d);

var AnswerMenu = function AnswerMenu(props) {
  var showMenu = props.showMenu,
      _a = props.curAnswerType,
      curAnswerType = _a === void 0 ? EAnswerTypes.IMAGE : _a,
      _b = props.curCount,
      curCount = _b === void 0 ? 0 : _b,
      haboReportData = props.haboReportData,
      changeShowMenu = props.changeShowMenu,
      nativeUploadCB = props.nativeUploadCB;
  var dealedAType = curAnswerType && AnswerType2DealedAType[curAnswerType] || EDealedATypes.IMAGE;
  var node = useRef();
  useEffect(function () {
    node.current = document.createElement('div');
    document.body.appendChild(node.current);
    return function () {
      if (node.current) {
        node.current.remove();
      }
    };
  }, []);

  var handleCamera = function handleCamera() {
    changeShowMenu(); // 调用端能力

    if (!dealedAType && dealedAType !== 0) {
      console.error('上传答案方式类型转化错误');
      return;
    }

    if ((haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.eventId) && (haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo)) {
      clickReport(haboReportData.eventId, haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo);
    }

    callNative({
      apiName: ENativeApi.OPEN_CAMERA,
      params: {
        resourceType: dealedAType,
        openType: EOpenType.TOKE_A_SIGLE_PHONE,
        // 作答时长 单位 秒
        maxRecordDuration: EAnswerTypeMaxDuration.VIDEO
      },
      callbackName: ENativeCBNames.NATIVE_UPLOAD_CB,
      callback: function callback(param) {
        return nativeUploadCB === null || nativeUploadCB === void 0 ? void 0 : nativeUploadCB(param, ESubmitType[EAnswerTypes[curAnswerType]]);
      }
    });
  };

  var handleAlbum = function handleAlbum() {
    changeShowMenu(); // 调用端能力

    if (!dealedAType && dealedAType !== 0) {
      console.error('上传答案方式类型转化错误');
      return;
    } // const curCount = ansSortListObj?.[EAnswerTypes[curAnswerType] as ESubmitType]?.length || 0;


    var curTypeLimit = EAnswerTypeMaxCount[EAnswerTypes[curAnswerType]];
    console.log('===curCount', curCount, curTypeLimit);
    callNative({
      apiName: ENativeApi.GET_ALBUM,
      params: {
        resourceType: dealedAType,
        maxRecordDuration: EAnswerTypeMaxDuration.VIDEO,
        maxCount: curTypeLimit - curCount,
        // 可取 0，1两个字符串，'0':不限制为仅mp4，'1':限制为mp4
        onlyMp4: '1'
      },
      callbackName: ENativeCBNames.NATIVE_UPLOAD_CB,
      callback: function callback(param) {
        return nativeUploadCB === null || nativeUploadCB === void 0 ? void 0 : nativeUploadCB(param, ESubmitType[EAnswerTypes[curAnswerType]]);
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, node.current && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CSSTransition$1, {
    in: showMenu,
    timeout: {
      enter: 300,
      exit: 0
    },
    unmountOnExit: true,
    classNames: {
      enter: style$W['menu-enter'],
      enterActive: style$W['menu-enter-active'],
      enterDone: style$W['menu-enter-done']
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style$W['answer-menu']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$W['menu-item'],
    role: "button",
    tabIndex: 0,
    onClick: handleCamera
  }, curAnswerType === EAnswerTypes.IMAGE ? '拍照' : '拍视频'), (curAnswerType === EAnswerTypes.IMAGE || curAnswerType === EAnswerTypes.VIDEO && (!isIOS || SHOW_IOS_ALBUM)) && /*#__PURE__*/React.createElement("div", {
    className: style$W['menu-item'],
    role: "button",
    tabIndex: 0,
    onClick: handleAlbum
  }, "\u4ECE\u76F8\u518C\u9009\u53D6"), /*#__PURE__*/React.createElement("div", {
    className: style$W['menu-item'],
    role: "button",
    tabIndex: 0,
    onClick: changeShowMenu
  }, "\u53D6\u6D88"))), showMenu && /*#__PURE__*/React.createElement("div", {
    className: style$W['answer-menu-shadow']
  })), node.current));
};

var style$V = {"IMAGE-btn":"tangram_C_IMAGE-btn_0343f50ea3","IMAGE-disabled-btn":"tangram_C_IMAGE-disabled-btn_0343f50ea3","VIDEO-btn":"tangram_C_VIDEO-btn_0343f50ea3","VIDEO-disabled-btn":"tangram_C_VIDEO-disabled-btn_0343f50ea3","AUDIO-btn":"tangram_C_AUDIO-btn_0343f50ea3","AUDIO-disabled-btn":"tangram_C_AUDIO-disabled-btn_0343f50ea3","answer-menu-btns":"tangram_C_answer-menu-btns_0343f50ea3","record-audio-container":"tangram_C_record-audio-container_0343f50ea3","close-icon":"tangram_C_close-icon_0343f50ea3","answer-menu-shadow":"tangram_C_answer-menu-shadow_0343f50ea3","wx-image-upload-shadow":"tangram_C_wx-image-upload-shadow_0343f50ea3","wx-image-upload-toast":"tangram_C_wx-image-upload-toast_0343f50ea3","spinning":"tangram_C_spinning_0343f50ea3","uploading":"tangram_C_uploading_0343f50ea3","msg":"tangram_C_msg_0343f50ea3","video-upload-cancel-btn":"tangram_C_video-upload-cancel-btn_0343f50ea3","upload-prompt-msg":"tangram_C_upload-prompt-msg_0343f50ea3"};

var CameraBtnPc = function CameraBtnPc(props) {
  var uploadCallback = props.uploadCallback,
      curCount = props.curCount,
      disabled = props.disabled,
      customStyle = props.customStyle,
      _a = props.customNode,
      customNode = _a === void 0 ? '上传图片' : _a,
      haboReportData = props.haboReportData,
      handleWXImageUpload = props.handleWXImageUpload,
      exceptionCallback = props.exceptionCallback;
  var imgRef = useRef(null);
  useUpload(imgRef, ESubmitType.IMAGE, function (imgs, isOverMaxCount) {
    uploadCallback === null || uploadCallback === void 0 ? void 0 : uploadCallback(imgs, ESubmitType.IMAGE, isOverMaxCount);
  }, IMAGE_ACCEPT, null, null, null, true, curCount, haboReportData, handleWXImageUpload, exceptionCallback);
  var isCustomBtn = Object.prototype.toString.call(customNode) === '[object String]';
  return /*#__PURE__*/React.createElement("div", {
    ref: disabled ? null : imgRef,
    style: customStyle,
    className: isCustomBtn ? style$V["".concat(EAnswerTypes[EAnswerTypes.IMAGE]).concat(disabled ? '-disabled' : '', "-btn")] : ''
  }, /*#__PURE__*/React.createElement("span", null, customNode));
};

var abortVideoUploadBtn = function abortVideoUploadBtn(curVideoUploadClient, curCheckPoint, handleUploadState) {
  var _a;

  function abortOSSUploading() {
    var _a, _b;

    if ((curVideoUploadClient === null || curVideoUploadClient === void 0 ? void 0 : curVideoUploadClient.current) && ((_a = curCheckPoint === null || curCheckPoint === void 0 ? void 0 : curCheckPoint.current) === null || _a === void 0 ? void 0 : _a.name) && ((_b = curCheckPoint === null || curCheckPoint === void 0 ? void 0 : curCheckPoint.current) === null || _b === void 0 ? void 0 : _b.uploadId)) {
      var _c = curCheckPoint.current,
          name_1 = _c.name,
          uploadId = _c.uploadId;
      handleUploadState === null || handleUploadState === void 0 ? void 0 : handleUploadState(EVideoUploadState.NO_UPLOAD);
      curVideoUploadClient.current.abortMultipartUpload(name_1, uploadId);
      updateModuleUploadAbortedVar(true);
    }
  }

  return /*#__PURE__*/React.createElement("span", {
    onClick: abortOSSUploading,
    role: "button",
    tabIndex: -1,
    className: style$V['video-upload-cancel-btn'],
    key: ((_a = curCheckPoint === null || curCheckPoint === void 0 ? void 0 : curCheckPoint.current) === null || _a === void 0 ? void 0 : _a.uploadId) || 'abort-OSS-uploading-button'
  }, "\u53D6\u6D88");
};

var videoUploadToast = function videoUploadToast(currentState, uploadProcess, curVideoUploadClient, curCheckPoint, handleUploadState) {
  var _a;

  var roundedProcess = Number(uploadProcess === null || uploadProcess === void 0 ? void 0 : uploadProcess.toFixed(2));
  var percentageProcess = uploadProcess || uploadProcess === 0 ? "".concat(Math.round(roundedProcess * 100), "%") : '';
  var commonToastStyle = {
    height: '46px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: 999,
    transform: 'translate(-50%)'
  };
  var iconStyle = {
    width: '17px',
    height: '17px',
    marginRight: '8px'
  };
  var MToastState = (_a = {}, _a[EVideoUploadState.UPLOADING] = {
    msg: "\u89C6\u9891\u4E0A\u4F20 ".concat(percentageProcess),
    icon: /*#__PURE__*/React.createElement(Loading, {
      customStyle: {
        width: '10px',
        height: '10px',
        marginRight: '8px',
        marginLeft: '16px'
      }
    }),
    customToastStyle: {
      width: '190px'
    },
    otherNodes: [abortVideoUploadBtn(curVideoUploadClient, curCheckPoint, handleUploadState)]
  }, _a[EVideoUploadState.UPLOAD_SUCCESS] = {
    msg: '视频上传成功',
    icon: /*#__PURE__*/React.createElement("img", {
      src: "https://jy.gsxcdn.com/fe/project/exercise-tangram/static/img/upload-success.svg",
      alt: "success-icon",
      style: iconStyle
    }),
    customToastStyle: {
      width: '128px'
    },
    otherNodes: [null]
  }, _a[EVideoUploadState.UPLOAD_FAILED] = {
    msg: '视频上传失败，请重试',
    icon: /*#__PURE__*/React.createElement("img", {
      src: "https://jy.gsxcdn.com/fe/project/exercise-tangram/static/img/upload-fail.svg",
      alt: "failed-icon",
      style: iconStyle
    }),
    customToastStyle: {
      width: '176px'
    },
    otherNodes: [null]
  }, _a);

  switch (currentState) {
    case EVideoUploadState.NO_UPLOAD:
      return null;

    case EVideoUploadState.UPLOADING:
    case EVideoUploadState.UPLOAD_FAILED:
    case EVideoUploadState.UPLOAD_SUCCESS:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toast, {
        icon: MToastState[currentState].icon,
        msg: MToastState[currentState].msg,
        customToastStyle: _assign$4(_assign$4({}, commonToastStyle), MToastState[currentState].customToastStyle),
        otherNodes: MToastState[currentState].otherNodes
      }), currentState === EVideoUploadState.UPLOADING && /*#__PURE__*/React.createElement("div", {
        className: style$V['answer-menu-shadow']
      }));
  }
}; // 一次选择菜单 视频上传pc


var VideoBtnPc = function VideoBtnPc(props) {
  var _a;

  var uploadCallback = props.uploadCallback,
      disabled = props.disabled,
      rootNode = props.rootNode;
  var videoRef = useRef(null);

  var _b = useState(EVideoUploadState.NO_UPLOAD),
      videoUploadState = _b[0],
      setVideoUploadState = _b[1];

  var _c = useState(0),
      uploadProcess = _c[0],
      setVideoUploadProcess = _c[1];

  var curVideoUploadClient = useRef(null);
  var curCheckPoint = useRef(null);
  var uploadStateRef = useRef(EVideoUploadState.NO_UPLOAD);

  function handleUploadState(uploadState, msg) {
    if (uploadStateRef.current === EVideoUploadState.NO_UPLOAD && (uploadState === EVideoUploadState.UPLOAD_FAILED || uploadState === EVideoUploadState.UPLOAD_SUCCESS)) {
      return;
    }

    setVideoUploadState(uploadState);
  }

  function getUploadProcess(process) {
    setVideoUploadProcess(process);
  }

  function getCurrentClientAndCheckPoint(cpt, c) {
    if (c) {
      curVideoUploadClient.current = c;
    }

    if ((cpt === null || cpt === void 0 ? void 0 : cpt.name) && (cpt === null || cpt === void 0 ? void 0 : cpt.uploadId)) {
      // @ts-ignore
      curCheckPoint.current = cpt;
    }
  }

  useUpload(videoRef, ESubmitType.VIDEO, function (urls) {
    uploadCallback === null || uploadCallback === void 0 ? void 0 : uploadCallback(urls, ESubmitType.VIDEO);
  }, "".concat(VIDEO_ACCEPT), handleUploadState, getUploadProcess, getCurrentClientAndCheckPoint, !disabled && videoUploadState !== EVideoUploadState.UPLOADING);
  useEffect(function () {
    uploadStateRef.current = videoUploadState;

    if (videoUploadState === EVideoUploadState.UPLOAD_SUCCESS || videoUploadState === EVideoUploadState.UPLOAD_FAILED) {
      window.setTimeout(function () {
        return setVideoUploadState(EVideoUploadState.NO_UPLOAD);
      }, 2000);
    }
  }, [videoUploadState]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, rootNode && /*#__PURE__*/createPortal((_a = videoUploadToast(videoUploadState, uploadProcess, curVideoUploadClient, curCheckPoint, handleUploadState)) !== null && _a !== void 0 ? _a : null, rootNode), /*#__PURE__*/React.createElement("div", {
    ref: disabled ? null : videoRef,
    className: style$V["".concat(EAnswerTypes[EAnswerTypes.VIDEO]).concat(disabled ? '-disabled' : '', "-btn")]
  }, /*#__PURE__*/React.createElement("span", null, "\u4E0A\u4F20\u89C6\u9891")));
}; // 一次选择菜单 录音上传pc


var AudioBtnPc = function AudioBtnPc(props) {
  var disabled = props.disabled,
      triggleRecordDialog = props.triggleRecordDialog;

  function openRecord() {
    if (disabled) {
      return;
    }

    triggleRecordDialog();
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: openRecord,
    className: style$V["".concat(EAnswerTypes[EAnswerTypes.AUDIO]).concat(disabled ? '-disabled' : '', "-btn")]
  }, /*#__PURE__*/React.createElement("span", null, "\u5F55\u97F3")));
}; // 一次选择菜单app 拍摄/图片/录音/视频


var MultiAnsBtnApp = function MultiAnsBtnApp(props) {
  var msg = props.msg,
      answerType = props.answerType,
      disabled = props.disabled,
      _a = props.curCount,
      curCount = _a === void 0 ? 0 : _a,
      customStyle = props.customStyle,
      subjectId = props.subjectId,
      haboReportData = props.haboReportData,
      nativeUploadCB = props.nativeUploadCB,
      h5UploadCB = props.h5UploadCB,
      updateCurAnswerType = props.updateCurAnswerType,
      changeShowMenu = props.changeShowMenu,
      handleWXImageUpload = props.handleWXImageUpload,
      exceptionCallback = props.exceptionCallback;

  if (!isMobileClient && answerType === EAnswerTypes.IMAGE) {
    return /*#__PURE__*/React.createElement(CameraBtnPc, {
      curCount: curCount,
      customStyle: customStyle,
      disabled: disabled,
      customNode: msg,
      haboReportData: haboReportData,
      uploadCallback: h5UploadCB,
      handleWXImageUpload: handleWXImageUpload,
      exceptionCallback: exceptionCallback
    });
  }

  function recordAudio() {
    // 调用端能力
    callNative({
      apiName: ENativeApi.RECORD_AUDIO,
      params: {
        // 作答时长 单位 秒
        maxRecordDuration: EAnswerTypeMaxDuration.AUDIO
      },
      callbackName: ENativeCBNames.NATIVE_UPLOAD_CB,
      callback: function callback(param) {
        return nativeUploadCB === null || nativeUploadCB === void 0 ? void 0 : nativeUploadCB(param, ESubmitType.AUDIO);
      }
    });
  }

  function takePhotos() {
    var dealedAType = answerType && AnswerType2DealedAType[answerType] || EDealedATypes.IMAGE;
    var totalMaxCount = EAnswerTypeMaxCount[EAnswerTypes[answerType]];
    var maxCount = totalMaxCount - curCount;
    callNative({
      apiName: ENativeApi.OPEN_CAMERA,
      params: {
        resourceType: dealedAType,
        openType: EOpenType.TOKE_PHOTOS,
        maxCount: maxCount,
        totalMaxCount: totalMaxCount,
        subjectId: subjectId
      },
      callbackName: ENativeCBNames.NATIVE_UPLOAD_CB,
      callback: function callback(param) {
        return nativeUploadCB === null || nativeUploadCB === void 0 ? void 0 : nativeUploadCB(param, ESubmitType[EAnswerTypes[answerType]]);
      }
    });
  }

  function handleClick() {
    if (disabled) {
      return;
    }

    if (answerType === EAnswerTypes.AUDIO) {
      recordAudio();
      return;
    }

    if (CAN_TOKE_PHOTOS && answerType === EAnswerTypes.IMAGE) {
      if ((haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.eventId) && (haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo)) {
        clickReport(haboReportData.eventId, haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo);
      }

      takePhotos();
      return;
    }

    updateCurAnswerType === null || updateCurAnswerType === void 0 ? void 0 : updateCurAnswerType(answerType);
    changeShowMenu();
  }

  var isCustomBtn = Object.prototype.toString.call(msg) === '[object String]';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    style: customStyle,
    className: isCustomBtn ? style$V["".concat(EAnswerTypes[answerType]).concat(disabled ? '-disabled' : '', "-btn")] : '',
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", null, msg)));
};

var WXUploadingToast = function WXUploadingToast(_a) {
  var current = _a.current,
      total = _a.total;
  return /*#__PURE__*/React.createElement("div", {
    className: style$V['wx-image-upload-shadow']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$V['wx-image-upload-toast']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$V.spinning
  }), /*#__PURE__*/React.createElement("div", {
    className: style$V.msg
  }, "\u4E0A\u4F20\u4E2D ".concat(current, "/").concat(total))));
}; // 一次选择菜单面板


var MultiAnswerBtn = function MultiAnswerBtn(props) {
  var _a;

  var dispatchAnsSort = props.dispatchAnsSort,
      ansBtnsDisabled = props.ansBtnsDisabled,
      questionId = props.questionId,
      subjectId = props.subjectId,
      answerWay = props.answerWay,
      showSigleQImgUpload = props.showSigleQImgUpload;

  var _b = useContext(MultiAnswerContext),
      uploadPromptMsg = _b.uploadPromptMsg,
      updateUploadPromptMsg = _b.updateUploadPromptMsg,
      ansSortListObj = _b.ansSortListObj; // 隐藏和展示二次选择菜单


  var _c = useState(false),
      showMenu = _c[0],
      setShowMenu = _c[1]; // 当前选择的作答方式


  var _d = useState(),
      curAnswerType = _d[0],
      setCurAnswerType = _d[1]; // 录音面板


  var _e = useState(false),
      isShowRecord = _e[0],
      setIsShowRecord = _e[1]; // 微信上传图片时状态


  var _f = useState(null),
      wxImgUploading = _f[0],
      setWxImgUploading = _f[1]; // 按钮是否显示


  var showBtns = {};
  answerWay === null || answerWay === void 0 ? void 0 : answerWay.forEach(function (type) {
    showBtns[EAnswerTypes[type]] = true;
  }); // 更新当前选择的作答方式

  var updateCurAnswerType = useCallback(function (type) {
    setCurAnswerType(type);
  }, []);

  var handleWXImageUpload = function handleWXImageUpload(uploadInfo) {
    setWxImgUploading(uploadInfo);
  };

  var node = useRef();
  useEffect(function () {
    node.current = document.createElement('div');
    document.body.appendChild(node.current);
    return function () {
      if (node.current) {
        node.current.remove();
      }
    };
  }, []); // 端能力更新作答数据回调

  var nativeUploadCB = useCallback(function (fileItem, answerType) {
    var _a, _b;

    if (!answerType) {
      console.error('上传类型为：' + answerType);
      return;
    }

    if ((fileItem === null || fileItem === void 0 ? void 0 : fileItem.url) || (fileItem === null || fileItem === void 0 ? void 0 : fileItem.urlList)) {
      footPrintDetailReport({
        detailAction: '上传文件端能力正常',
        actionValue: fileItem.url
      });
    } else {
      footPrintDetailReport({
        detailAction: '上传文件端能力错误'
      });
      return;
    }

    var answerList = [];

    var _c = fileItem || {},
        url = _c.url,
        length = _c.length;

    if ((_a = fileItem.urlList) === null || _a === void 0 ? void 0 : _a.length) {
      var temp = (_b = fileItem.urlList) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        return {
          resource: {
            url: item.url
          },
          resourceType: ESubmitItemTypes[answerType] || ESubmitItemTypes.IMAGE
        };
      });
      answerList.push.apply(answerList, temp);
    } else {
      answerList.push({
        resource: fileItem.resourceType === EDealedATypes.AUDIO ? {
          url: url,
          length: length
        } : {
          url: url
        },
        resourceType: ESubmitItemTypes[answerType] || ESubmitItemTypes.IMAGE
      });
    }

    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.ADD,
      answerType: answerType,
      answerList: answerList
    });
  }, [dispatchAnsSort]);
  var h5UploadCB = useCallback(function (urlList, submitType) {
    var answerList = urlList.map(function (url) {
      return {
        resource: {
          url: url
        },
        resourceType: ESubmitItemTypes[submitType]
      };
    });
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      actionType: EActionTypes.ADD,
      answerType: submitType,
      answerList: answerList
    });
  }, [dispatchAnsSort]); // 录音组件参数

  var questionInfo = {
    questionId: questionId === null || questionId === void 0 ? void 0 : questionId.toString()
  }; // 开启/关闭录音弹框

  function triggleRecordDialog() {
    setIsShowRecord(!isShowRecord);
  } // 开始录音回调


  function handleStart() {
    console.log('开始录音');
    updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg('');
  } // 提交录音回调


  function handleSubmit(audioUrl, length) {
    var answerList = [{
      resourceType: ESubmitItemTypes.AUDIO,
      resource: {
        url: audioUrl,
        length: length
      }
    }];
    triggleRecordDialog();
    dispatchAnsSort === null || dispatchAnsSort === void 0 ? void 0 : dispatchAnsSort({
      answerType: ESubmitType.AUDIO,
      actionType: EActionTypes.ADD,
      answerList: answerList
    });
  } // 录音错误回调


  function handleError(e) {
    updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(e);
    triggleRecordDialog();
  }

  function changeShowMenu() {
    setShowMenu(!showMenu);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowRecord && node.current && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: style$V['record-audio-container']
  }, /*#__PURE__*/React.createElement(Recorder$2, {
    questionInfo: questionInfo,
    handleStart: handleStart,
    handleSubmit: handleSubmit,
    handleError: handleError
  }), /*#__PURE__*/React.createElement("span", {
    className: style$V['close-icon'],
    onClick: triggleRecordDialog,
    role: "button",
    tabIndex: 0
  })), node.current), uploadPromptMsg && /*#__PURE__*/React.createElement("p", {
    className: style$V['upload-prompt-msg']
  }, uploadPromptMsg), /*#__PURE__*/React.createElement("ul", {
    className: style$V['answer-menu-btns']
  }, showSigleQImgUpload && (showBtns[EAnswerTypes[EAnswerTypes.IMAGE]] || !(answerWay === null || answerWay === void 0 ? void 0 : answerWay.length)) && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MultiAnsBtnApp, {
    changeShowMenu: changeShowMenu,
    msg: "\u4E0A\u4F20\u56FE\u7247",
    subjectId: subjectId,
    curCount: ansSortListObj[ESubmitType.IMAGE].length,
    answerType: EAnswerTypes.IMAGE,
    updateCurAnswerType: updateCurAnswerType,
    nativeUploadCB: nativeUploadCB,
    h5UploadCB: h5UploadCB,
    disabled: ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.IMAGE],
    handleWXImageUpload: handleWXImageUpload
  })), showBtns[EAnswerTypes[EAnswerTypes.AUDIO]] && /*#__PURE__*/React.createElement("li", null, isNewVersion ? /*#__PURE__*/React.createElement(MultiAnsBtnApp, {
    disabled: ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.AUDIO],
    msg: "\u5F55\u97F3",
    answerType: EAnswerTypes.AUDIO,
    updateCurAnswerType: updateCurAnswerType,
    changeShowMenu: changeShowMenu,
    nativeUploadCB: nativeUploadCB
  }) : /*#__PURE__*/React.createElement(AudioBtnPc, {
    triggleRecordDialog: triggleRecordDialog,
    disabled: ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.AUDIO]
  })), showBtns[EAnswerTypes[EAnswerTypes.VIDEO]] && /*#__PURE__*/React.createElement("li", null, isNewVersion ? /*#__PURE__*/React.createElement(MultiAnsBtnApp, {
    changeShowMenu: changeShowMenu,
    msg: "\u4E0A\u4F20\u89C6\u9891",
    nativeUploadCB: nativeUploadCB,
    answerType: EAnswerTypes.VIDEO,
    updateCurAnswerType: updateCurAnswerType,
    disabled: ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.VIDEO]
  }) : /*#__PURE__*/React.createElement(VideoBtnPc, {
    uploadCallback: h5UploadCB,
    rootNode: node.current,
    disabled: ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.VIDEO]
  }))), isShowRecord && isMobile && node.current && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: style$V['answer-menu-shadow']
  }), node.current), (wxImgUploading === null || wxImgUploading === void 0 ? void 0 : wxImgUploading.current) && (wxImgUploading === null || wxImgUploading === void 0 ? void 0 : wxImgUploading.total) && node.current && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(WXUploadingToast, {
    current: wxImgUploading.current,
    total: wxImgUploading.total
  }), node.current), /*#__PURE__*/React.createElement(AnswerMenu, _assign$4({}, props, {
    curCount: curAnswerType && ((_a = ansSortListObj === null || ansSortListObj === void 0 ? void 0 : ansSortListObj[EAnswerTypes[curAnswerType]]) === null || _a === void 0 ? void 0 : _a.length) || 0,
    curAnswerType: curAnswerType,
    nativeUploadCB: nativeUploadCB,
    showMenu: showMenu,
    changeShowMenu: changeShowMenu
  })));
};

var MultiAnswerBtn$1 = withErrorBoundary(MultiAnswerBtn);

var style$U = {"exercise-wrapper":"tangram_C_exercise-wrapper_814a9c14d8","question-detail":"tangram_C_question-detail_814a9c14d8","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_814a9c14d8","card-title":"tangram_C_card-title_814a9c14d8","structure":"tangram_C_structure_814a9c14d8","full-blank":"tangram_C_full-blank_814a9c14d8","text-emphasis":"tangram_C_text-emphasis_814a9c14d8","table-wrapper":"tangram_C_table-wrapper_814a9c14d8","answer-wrapper":"tangram_C_answer-wrapper_814a9c14d8","sticker":"tangram_C_sticker_814a9c14d8","top-right":"tangram_C_top-right_814a9c14d8","bottom-right":"tangram_C_bottom-right_814a9c14d8","bottom-left":"tangram_C_bottom-left_814a9c14d8","top-left":"tangram_C_top-left_814a9c14d8","imgs-wrapper":"tangram_C_imgs-wrapper_814a9c14d8","img-wrapper":"tangram_C_img-wrapper_814a9c14d8","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_814a9c14d8","answer-box":"tangram_C_answer-box_814a9c14d8","answer-empty":"tangram_C_answer-empty_814a9c14d8","prompt-msg":"tangram_C_prompt-msg_814a9c14d8","answer-title-text":"tangram_C_answer-title-text_814a9c14d8"};

var answerStyle = {"exercise-wrapper":"tangram_C_exercise-wrapper_230708875f","question-detail":"tangram_C_question-detail_230708875f","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_230708875f","card-title":"tangram_C_card-title_230708875f","structure":"tangram_C_structure_230708875f","full-blank":"tangram_C_full-blank_230708875f","text-emphasis":"tangram_C_text-emphasis_230708875f","table-wrapper":"tangram_C_table-wrapper_230708875f","answer-wrapper":"tangram_C_answer-wrapper_230708875f","sticker":"tangram_C_sticker_230708875f","top-right":"tangram_C_top-right_230708875f","bottom-right":"tangram_C_bottom-right_230708875f","bottom-left":"tangram_C_bottom-left_230708875f","top-left":"tangram_C_top-left_230708875f","imgs-wrapper":"tangram_C_imgs-wrapper_230708875f","img-wrapper":"tangram_C_img-wrapper_230708875f","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_230708875f","answer-box":"tangram_C_answer-box_230708875f"};

var style$T = {"tk-mathquill":"tangram_C_tk-mathquill_b7bc334031","answer-content-text":"tangram_C_answer-content-text_b7bc334031"};

var MyAnswer = function MyAnswer(props) {
  var content = props.content,
      answerWay = props.answerWay;
  var renderDomRef = useRef(null);
  useEffect(function () {
    if (answerWay === null || answerWay === void 0 ? void 0 : answerWay.includes(EAnswerTypes.RICH_TEXT)) {
      downloadDependency().then(function (MQ) {
        var _a, _b; // eslint-disable-next-line


        Array.from((_b = (_a = renderDomRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-".concat(FormulaMark, "]"))) !== null && _b !== void 0 ? _b : []).forEach(MQ.StaticMath);
      });
    }
  }, [answerWay, content]);
  return /*#__PURE__*/React.createElement("div", {
    ref: renderDomRef,
    className: style$T['answer-content-text'],
    dangerouslySetInnerHTML: {
      __html: content.replace(/\n/g, '<br />')
    }
  });
};

var _a$c;

var answerCheckerMap$1 = (_a$c = {}, _a$c[ESubmitType.IMAGE] = ImageAnsChecker, _a$c[ESubmitType.AUDIO] = AudioAnsChecker, _a$c[ESubmitType.VIDEO] = VidoeAnsChecker, _a$c[ESubmitType.TEXT] = null, _a$c);

var SubmitItemsDisplay = function SubmitItemsDisplay(props) {
  var _a, _b, _c, _d, _e;

  var editable = props.editable,
      shouldShowAnswerInfo = props.shouldShowAnswerInfo,
      ansSortListObj = props.ansSortListObj,
      answerWay = props.answerWay,
      promptMsg = props.promptMsg,
      updateAnsSortListObj = props.updateAnsSortListObj;
  return /*#__PURE__*/React.createElement("div", {
    className: !editable && shouldShowAnswerInfo ? answerStyle['answer-wrapper'] : ''
  }, !editable && shouldShowAnswerInfo && /*#__PURE__*/React.createElement(React.Fragment, null, ((_b = (_a = ansSortListObj[ESubmitType.TEXT]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.resource) ? /*#__PURE__*/React.createElement(MyAnswer, {
    answerWay: answerWay,
    content: (_e = (_d = (_c = ansSortListObj[ESubmitType.TEXT]) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.resource) !== null && _e !== void 0 ? _e : ''
  }) : ''), /*#__PURE__*/React.createElement(React.Fragment, null, Object.entries(ansSortListObj).map(function (curEntry) {
    var key = curEntry[0],
        value = curEntry[1];
    var key2Submitype = key;

    if (key2Submitype === ESubmitType.TEXT) {
      return null;
    }

    var AnswerChecker = answerCheckerMap$1[key2Submitype];

    if (!(value === null || value === void 0 ? void 0 : value.length)) {
      return null;
    }

    return AnswerChecker && /*#__PURE__*/React.createElement("div", {
      key: key2Submitype
    }, /*#__PURE__*/React.createElement(AnswerChecker, {
      editable: editable !== null && editable !== void 0 ? editable : false,
      answerList: value,
      showTip: true,
      tipMsg: EImgTopTipMsg.MY_ANSWER,
      dispatchAnsSort: updateAnsSortListObj
    }), // 图片的提示
    key2Submitype === ESubmitType.IMAGE && promptMsg.isOverImgMaxCount && /*#__PURE__*/React.createElement("p", {
      className: style$U['prompt-msg']
    }, EPromptMsg.OVER_IMG_MAX_COUNT) // 视频的提示
    || key2Submitype === ESubmitType.VIDEO && promptMsg.isOverVideoMaxCount && /*#__PURE__*/React.createElement("p", {
      className: style$U['prompt-msg']
    }, EPromptMsg.OVER_VIDEO_MAX_COUNT));
  })));
};

var _a$b, _b$3;

(_a$b = {}, _a$b[EAnswerTypes.AUDIO] = ESubmitItemTypes.AUDIO, _a$b[EAnswerTypes.IMAGE] = ESubmitItemTypes.IMAGE, _a$b[EAnswerTypes.TEXT] = ESubmitItemTypes.TEXT, _a$b[EAnswerTypes.VIDEO] = ESubmitItemTypes.VIDEO, _a$b);
var EActionTypes;

(function (EActionTypes) {
  EActionTypes["ADD"] = "ADD";
  EActionTypes["DELETE"] = "DELETE";
  EActionTypes["INIT"] = "INIT";
})(EActionTypes || (EActionTypes = {})); // 手机app使用端能力的组件


var answerCheckerMap = (_b$3 = {}, _b$3[ESubmitType.IMAGE] = ImageAnsChecker, _b$3[ESubmitType.AUDIO] = AudioAnsChecker, _b$3[ESubmitType.VIDEO] = VidoeAnsChecker, _b$3[ESubmitType.TEXT] = null, _b$3);
var MultiAnswerContext = /*#__PURE__*/createContext({}); // eslint-disable-next-line complexity

var MultiAnswer = function MultiAnswer(props) {
  if (typeof Object.entries !== 'function') {
    Object.entries = entries;
  }

  var answerWay = props.answerTypeList,
      editable = props.editable,
      userSubmitItems = props.userSubmitItems,
      questionId = props.questionId,
      onAnswerChange = props.onAnswerChange,
      onEditorFocus = props.onEditorFocus,
      onEditorBlur = props.onEditorBlur,
      sticker = props.sticker,
      subjectId = props.subjectId,
      showSigleQImgUpload = props.showSigleQImgUpload; // 这里本应从业务端拿到的 answerWay:number[]，所以需要转化一下

  var answerTypeList = (answerWay === null || answerWay === void 0 ? void 0 : answerWay.map(function (item) {
    var type = EAnswerTypes[item];
    return {
      answerType: item,
      maxCount: EAnswerTypeMaxCount[type]
    };
  })) || []; // 没有answerWay默认图片

  if (!(answerTypeList === null || answerTypeList === void 0 ? void 0 : answerTypeList.length)) {
    answerTypeList.push({
      answerType: EAnswerTypes.IMAGE,
      maxCount: EAnswerTypeMaxCount.IMAGE
    });
  }

  function initAnsSortListObj() {
    var _a; // 整理四种作答方式的作答列表到一个对象中


    var initAnsSortListObj = (_a = {}, _a[ESubmitType.TEXT] = [], _a[ESubmitType.IMAGE] = [], _a[ESubmitType.AUDIO] = [], _a[ESubmitType.VIDEO] = [], _a);
    userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.forEach(function (item) {
      var _a;

      var submitType = ESubmitItemTypes[item.resourceType];
      (_a = initAnsSortListObj[submitType]) === null || _a === void 0 ? void 0 : _a.push(item);
    });
    footPrintDetailReport({
      detailAction: '所有答案资源初始化完成'
    });
    return initAnsSortListObj;
  } // 已作答分类列表对象


  var _a = useState(initAnsSortListObj),
      ansSortListObj = _a[0],
      setAnsSortListObj = _a[1];

  function initAnsBtnsDisabled() {
    var _a;

    var initAnsBtnDisabled = (_a = {}, _a[EAnswerTypes.IMAGE] = true, _a[EAnswerTypes.AUDIO] = true, _a[EAnswerTypes.TEXT] = true, _a[EAnswerTypes.VIDEO] = true, _a[EAnswerTypes.LOOK_ENG_READ_ENG] = true, _a[EAnswerTypes.LOOK_CN_READ_ENG] = true, _a[EAnswerTypes.RICH_TEXT] = true, _a);
    answerTypeList === null || answerTypeList === void 0 ? void 0 : answerTypeList.forEach(function (item) {
      // 富文本作答和普通文本作答 作答类型相同
      // @ts-ignore
      var answerType = item.answerType === EAnswerTypes.RICH_TEXT ? EAnswerTypes[EAnswerTypes.TEXT] : EAnswerTypes[item.answerType]; // 将业务端传的作答方式渲染整理出来 (单个方式上传数量大于等于该方式的最大上传数量时禁用)

      initAnsBtnDisabled[item.answerType] = (item === null || item === void 0 ? void 0 : item.maxCount) ? item.maxCount <= ansSortListObj[answerType].length : EAnswerTypeMaxCount[answerType] <= ansSortListObj[answerType].length;
    });
    return initAnsBtnDisabled;
  } // 作答入口置灰控制


  var _b = useState(initAnsBtnsDisabled),
      ansBtnsDisabled = _b[0],
      setBtnDisabled = _b[1];

  function initPromptMsg() {
    return {
      isOverImgMaxCount: false,
      isOverImgMaxSize: false,
      isOverVideoMaxCount: false,
      isOverVideoMaxSize: false
    };
  } // 作答列表下的提示信息


  var _c = useState(initPromptMsg),
      promptMsg = _c[0],
      setPromptMsg = _c[1]; // 上传入口上的提示信息


  var _d = useState(''),
      uploadPromptMsg = _d[0],
      setUploadPromptMsg = _d[1]; // 更新作答列表


  var updateAnsSortListObj = useCallback(function (action) {
    setAnsSortListObj(function (pre) {
      var _a;

      var curList = pre === null || pre === void 0 ? void 0 : pre[action.answerType];

      switch (action.actionType) {
        case EActionTypes.ADD:
          footPrintDetailReport({
            detailAction: '答案资源添加完成'
          });

          if (action.answerType) {
            if (action.answerType === ESubmitType.AUDIO || action.answerType === ESubmitType.TEXT) {
              curList = action.answerList;
            } else {
              curList.push.apply(curList, action.answerList);
            }
          }

          break;

        case EActionTypes.DELETE:
          if (action.answerType && action.deleteIndex >= 0) {
            curList === null || curList === void 0 ? void 0 : curList.splice(action.deleteIndex, 1);
          }

          footPrintDetailReport({
            detailAction: '答案资源删除完成'
          });
          break;

        case EActionTypes.INIT:
          footPrintDetailReport({
            detailAction: '当前类型答案资源初始化完成'
          });

          if (action.answerType) {
            curList = action.answerList;
          }

          break;
      }

      return _assign$4(_assign$4({}, pre), (_a = {}, _a[action.answerType] = curList, _a));
    });
  }, []); // 将分类的作答列表整理到数组，返回给业务方

  var ansSortListObj2AnswerList = function ansSortListObj2AnswerList() {
    return [].concat.apply([], Object.values(ansSortListObj));
  };

  useEffect(function () {
    var updatedAnsList = ansSortListObj2AnswerList(); // 返回给业务端更新后的用户作答数据

    onAnswerChange === null || onAnswerChange === void 0 ? void 0 : onAnswerChange(questionId, updatedAnsList);
    footPrintSecondaryReport({
      secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
      actionValue: JSON.stringify(updatedAnsList)
    });
    setBtnDisabled(initAnsBtnsDisabled);
  }, [ansSortListObj]);
  var shouldShowAnswerInfo = !!(userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length); // 切换题目更新作答列表, 上传入口禁用状态，提示信息置空

  useEffect(function () {
    setAnsSortListObj(initAnsSortListObj());
    setBtnDisabled(initAnsBtnsDisabled());
    setPromptMsg(initPromptMsg());
    setUploadPromptMsg('');
  }, [questionId]);

  function updatePromptMsg(prompt) {
    setPromptMsg(function (pre) {
      return _assign$4(_assign$4({}, pre), prompt);
    });
  }

  function updateUploadPromptMsg(prompt) {
    setUploadPromptMsg(prompt);
  } // 含有非统一作答图片的作答


  var includeNonUniformImg = ansSortListObj[ESubmitType.IMAGE].some(function (item) {
    return !item.answerMode;
  }); // 隐藏我的作答模块
  // 1、pc端 统一作答 + 只有图片作答 + 全部是统一作答图片 或 没有作答数据 + 编辑状态
  // 2、app端 统一作答 + 只有图片作答 + 没有作答数据

  if (showSigleQImgUpload === false && (answerWay === null || answerWay === void 0 ? void 0 : answerWay.length) === 1 && answerWay.includes(EAnswerTypes.IMAGE) && (isPC && editable && (!(userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) || !includeNonUniformImg) || isMobileClient && !(userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length))) {
    return null;
  }

  return /*#__PURE__*/React.createElement(MultiAnswerContext.Provider, {
    value: {
      ansSortListObj: ansSortListObj,
      updatePromptMsg: updatePromptMsg,
      uploadPromptMsg: uploadPromptMsg,
      updateUploadPromptMsg: updateUploadPromptMsg
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style$U['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$U['card-title']
  }, "\u6211\u7684\u56DE\u7B54"), /*#__PURE__*/React.createElement("div", {
    className: style$U['answer-box']
  }, !!editable && /*#__PURE__*/React.createElement(React.Fragment, null, !(ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.TEXT]) && /*#__PURE__*/React.createElement(TextArea, {
    onEditorFocus: onEditorFocus,
    onEditorBlur: onEditorBlur,
    dispatchAnsSort: updateAnsSortListObj,
    editable: editable,
    questionId: questionId || '',
    answerList: ansSortListObj[ESubmitType.TEXT]
  })), !!editable && /*#__PURE__*/React.createElement(React.Fragment, null, // 允许的作答方式
  (ansBtnsDisabled === null || ansBtnsDisabled === void 0 ? void 0 : ansBtnsDisabled[EAnswerTypes.RICH_TEXT]) === false && /*#__PURE__*/React.createElement(RichEditor, {
    onEditorFocus: onEditorFocus,
    onEditorBlur: onEditorBlur,
    dispatchAnsSort: updateAnsSortListObj,
    editable: editable,
    questionId: questionId || '',
    answerList: ansSortListObj[ESubmitType.TEXT]
  })), shouldShowAnswerInfo ? /*#__PURE__*/React.createElement(SubmitItemsDisplay, {
    editable: editable,
    shouldShowAnswerInfo: shouldShowAnswerInfo,
    ansSortListObj: ansSortListObj,
    answerWay: answerWay,
    promptMsg: promptMsg,
    updateAnsSortListObj: updateAnsSortListObj
  }) : !editable && /*#__PURE__*/React.createElement("span", {
    className: style$U['answer-empty']
  }, "\u672A\u4F5C\u7B54"), editable && /*#__PURE__*/React.createElement(MultiAnswerBtn$1, {
    ansBtnsDisabled: ansBtnsDisabled,
    dispatchAnsSort: updateAnsSortListObj,
    questionId: questionId || '',
    answerTypeList: answerTypeList,
    ansSortListObj: ansSortListObj,
    showSigleQImgUpload: showSigleQImgUpload,
    answerWay: answerWay,
    subjectId: subjectId
  }), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (_a, index) {
    var location = _a.location,
        getCustomNode = _a.getCustomNode,
        data = _a.data;
    return location === EStickerLocModule.ANSWERINFOEND // eslint-disable-next-line react/no-array-index-key
    && /*#__PURE__*/React.createElement(Sticker, {
      sticker: {
        location: location,
        getCustomNode: getCustomNode,
        data: data
      },
      key: "".concat(questionId).concat(index)
    });
  }))));
};

var _a$a;
var THROTTLE_TIME$2 = 500;
var client$1 = (_a$a = parseQuery()) === null || _a$a === void 0 ? void 0 : _a$a.client;

var useUpload = function useUpload(uploadBtnRef, submitType, loadedCallback, acceptType, handleUploadState, getVideoUploadProcess, getCurrentClientAndCheckPoint, clearCurInputValue, currentCount, haboReportData, handleWXImageUpload, exceptionCallback) {
  if (acceptType === void 0) {
    acceptType = "".concat(IMAGE_ACCEPT);
  }

  var inputRef = useRef(document.createElement('input'));

  var _a = useContext(MultiAnswerContext),
      ansSortListObj = _a.ansSortListObj,
      updatePromptMsg = _a.updatePromptMsg,
      updateUploadPromptMsg = _a.updateUploadPromptMsg;

  var batchUploadAddr = "https://".concat(envPrefix(), "api.gaotu100.com/storage/batchUpload"); // 通过微信图片serverIds上传图片接口地址

  var wxUploadAddr = "https://".concat(envPrefix(), "api.gaotu100.com/exercise/image/transfer");

  var _b = useState([]),
      files = _b[0],
      setFiles = _b[1];

  var _c = useState(0),
      counter = _c[0],
      setCounter = _c[1];

  var _d = useState([]),
      deleteIndexList = _d[0],
      setDeleteIndexList = _d[1];

  var wxTotalUpload = useRef(0);
  var currentWxUpload = useRef(0);
  var someFailed = useRef(false);
  var wxUploadFileArray = useRef([]);

  function getVideoFileUrl(url) {
    loadedCallback([url]);
  }

  function onVideoUploadError(errorOccurred, errorMsg) {
    errorOccurred && (handleUploadState === null || handleUploadState === void 0 ? void 0 : handleUploadState(EVideoUploadState.UPLOAD_FAILED, errorMsg));
  }

  function onVideoUploadFinished(finished) {
    finished && (handleUploadState === null || handleUploadState === void 0 ? void 0 : handleUploadState(EVideoUploadState.UPLOAD_SUCCESS));
  } // 上传文件至服务端


  function uploadFiles(files, type, isOverMaxCount) {
    // 视频文件统一使用阿里云OSS服务，以支持大文件上传
    if (type === ESubmitType.VIDEO) {
      handleUploadState === null || handleUploadState === void 0 ? void 0 : handleUploadState(EVideoUploadState.UPLOADING);
      handleVideoUpload(files, getVideoUploadProcess, getVideoFileUrl, onVideoUploadError, onVideoUploadFinished, getCurrentClientAndCheckPoint);
      inputRef.current.value = '';
    } else {
      var formData_1 = new FormData();
      files.forEach(function (file) {
        formData_1 === null || formData_1 === void 0 ? void 0 : formData_1.append('file', file);
      });
      console.log('要上传的files和formData:', files);
      formData_1 && axios.upload(batchUploadAddr, formData_1).then(function (res) {
        var _a;

        (res === null || res === void 0 ? void 0 : res.result) && loadedCallback((_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a.map(function (file) {
          return file.url;
        }), isOverMaxCount);
        inputRef.current.value = '';
      }).catch(function (e) {
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.ERROR_NETWORK);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.ERROR_NETWORK
        });
        console.error('上传文件失败！', e);
        inputRef.current.value = '';
      });
    }
  } // 上传视频前的准备工作，满足条件则上传至服务端。 这里使用了counter计数判断已校验的数量，监听couter数量与选择的文件数量一致则执行过滤操作


  function uploadVideo(files) {
    var filterList = Array.from(files).filter(function (file) {
      // 文件类型限制
      var fileType = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      if (!VIDEO_ACCEPT_LIST.includes(fileType)) {
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.ERROR_VIDEO_TYPE);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.ERROR_VIDEO_TYPE
        });
        return false;
      }

      return true;
    });
    var sizeFilteredList = filterList.filter(function (file) {
      // 文件大小限制
      if (file.size > VIDEO_MAX_SIZE) {
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.OVER_VIDEO_MAX_SIZE);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.OVER_VIDEO_MAX_SIZE
        });
        return false;
      }

      return true;
    });
    setFiles(sizeFilteredList);
    sizeFilteredList.forEach(function (file, index) {
      // 视频时长限制
      window.URL = window.URL || window.webkitURL;
      var url = window.URL.createObjectURL(file);
      var audioElement = new Audio(url);

      if (isIOS) {
        audioElement.muted = true;
        audioElement.play().then(function () {
          audioElement.pause();
          audioElement.muted = false;
        });
      }

      audioElement.addEventListener('loadedmetadata', function () {
        var duration = audioElement.duration;

        if (duration && duration > EAnswerTypeMaxDuration.VIDEO) {
          updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.OVER_VIDEO_MAX_DURATION);
          exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
            msg: EPromptMsg.OVER_VIDEO_MAX_DURATION
          });
          setDeleteIndexList(function (pre) {
            return __spreadArray(__spreadArray([], pre, true), [index], false);
          });
        }

        setCounter(function (counter) {
          return counter + 1;
        });
      });
    });
  } // 上传图片前的准备工作，满足条件上传至服务端


  function uploadImg(files) {
    // 过滤图片大小和图片格式
    var filterFiles = Array.from(files).filter(function (item) {
      if (item.size > EAnswerTypeMaxSize.IMAGE * 1024 * 1024) {
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.OVER_IMG_MAX_SIZE);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.OVER_IMG_MAX_SIZE
        });
        return false;
      }

      var fileType = item.name.substring(item.name.lastIndexOf('.')).toLowerCase();

      if (!IMAGE_ACCEPT_LIST.includes(fileType)) {
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.ERROR_IMG_TYPE);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.ERROR_IMG_TYPE
        });
        return false;
      }

      return true;
    });
    var curCount = currentCount !== null && currentCount !== void 0 ? currentCount : ansSortListObj[submitType].length;
    var isOverMaxCount = filterFiles.length + curCount > EAnswerTypeMaxCount.IMAGE;

    if (isOverMaxCount) {
      // 保留delIndex下标之前的文件，delIndex也删除
      var delIndex = EAnswerTypeMaxCount.IMAGE - curCount;
      filterFiles.splice(delIndex);
      updatePromptMsg === null || updatePromptMsg === void 0 ? void 0 : updatePromptMsg({
        isOverImgMaxCount: true
      });
    }

    filterFiles.length && uploadFiles(filterFiles, ESubmitType.IMAGE, isOverMaxCount);
  }

  function uploadWxFiles(files) {
    var uploadImageParams = {
      client: client$1,
      mediaIds: files
    };
    axios.post(wxUploadAddr, uploadImageParams).then(function (res) {
      var code = res.code,
          data = res.data,
          msg = res.msg;

      if (code === 0 && data) {
        var urls = [];

        for (var _i = 0, _a = wxUploadFileArray.current; _i < _a.length; _i++) {
          var id = _a[_i];
          data[id] && urls.push(data[id]);
        }

        urls.length > 0 && loadedCallback(urls);

        if (someFailed.current) {
          updateUploadPromptMsg(EPromptMsg.SOME_IMG_UPLOAD_FAILED);
          exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
            msg: EPromptMsg.SOME_IMG_UPLOAD_FAILED
          });
          someFailed.current = false;
        }

        wxUploadFileArray.current = [];
        handleWXImageUpload === null || handleWXImageUpload === void 0 ? void 0 : handleWXImageUpload(null);
        return;
      } // eslint-disable-next-line max-len


      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u56FE\u7247serverIds\uFF0C\u8BF7\u6C42\u5C06\u56FE\u7247\u4E0A\u4F20\u5230cdn\u65F6\uFF0C\u54CD\u5E94\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(uploadImageParams, "\uFF0C\u54CD\u5E94code\u53CAmsg: ").concat(code, ", ").concat(msg, " , \u54CD\u5E94\u6570\u636E: ").concat(data);
      updateUploadPromptMsg(EPromptMsg.UPLOAD_FAILED);
      exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
        msg: EPromptMsg.UPLOAD_FAILED
      });
      footPrintJSErrorReport({
        detailAction: errMsg
      });
      wxUploadFileArray.current = [];
      handleWXImageUpload === null || handleWXImageUpload === void 0 ? void 0 : handleWXImageUpload(null);
      console.error(errMsg);
    }).catch(function (reason) {
      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u56FE\u7247serverIds\uFF0C\u8BF7\u6C42\u5C06\u56FE\u7247\u4E0A\u4F20\u5230cdn\u65F6\uFF0C\u8BF7\u6C42\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(uploadImageParams, "\uFF0C\u9519\u8BEF\u4FE1\u606F: ").concat(reason);
      updateUploadPromptMsg(EPromptMsg.UPLOAD_FAILED);
      exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
        msg: EPromptMsg.UPLOAD_FAILED
      });
      footPrintJSErrorReport({
        detailAction: errMsg
      });
      wxUploadFileArray.current = [];
      handleWXImageUpload === null || handleWXImageUpload === void 0 ? void 0 : handleWXImageUpload(null);
      console.error(errMsg);
    });
  }

  function wxImgUpload(localIds) {
    console.log('开始上传微信图片, localIds:', localIds); // 给用户展示的提示需要是 currentWxUpload.current +1 的

    var tipCurrent = currentWxUpload.current === wxTotalUpload.current ? currentWxUpload.current : currentWxUpload.current + 1;
    handleWXImageUpload === null || handleWXImageUpload === void 0 ? void 0 : handleWXImageUpload({
      current: tipCurrent,
      total: wxTotalUpload.current
    });

    if (wxTotalUpload.current && wxTotalUpload.current === currentWxUpload.current) {
      console.log('上传完所有微信图片到微信服务器，开始上传到自己的服务器并获取图片链接');
      uploadWxFiles(wxUploadFileArray.current);
      currentWxUpload.current = 0;
      wxTotalUpload.current = 0;
    } else {
      // 延迟100ms是为了解决 Android 低于6.2版本中 uploadImage 在 chooseImage 的回调中有时候会不执行的问题，Android6.2已解决此问题，此处兜底支持低版本
      window.setTimeout(function () {
        return window.wx.uploadImage({
          localId: localIds[currentWxUpload.current],
          isShowProgressTips: 0,
          success: function success(res) {
            console.log('上传微信图片成功的回调:', res);
            var serverId = res.serverId;
            wxUploadFileArray.current.push(serverId);
            currentWxUpload.current += 1;
            wxImgUpload(localIds);
          },
          fail: function fail(e) {
            var errMsg = "\u90E8\u5206\u56FE\u7247\u4E0A\u4F20\u5FAE\u4FE1\u670D\u52A1\u5668\u5931\u8D25\uFF0C\u9519\u8BEF\u4FE1\u606F: ".concat(e.errMsg);
            currentWxUpload.current += 1;
            someFailed.current = true;
            footPrintJSErrorReport({
              detailAction: errMsg
            });
          }
        });
      }, 100);
    }
  }

  function handleInputChange() {
    var _a;

    updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg('');
    exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
      msg: ''
    });

    if (!((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files)) {
      return;
    }

    if (submitType === ESubmitType.IMAGE) {
      uploadImg(inputRef.current.files);
    } else {
      uploadVideo(inputRef.current.files);
    }
  }

  useEffect(function () {
    var input = inputRef.current;
    input.type = 'file'; // 这里使用image/*, 否则导致可能无法调用相机

    input.accept = acceptType; // 一次上传多张图片

    inputRef.current.multiple = !isAndroid;
    input.addEventListener('change', handleInputChange);
    return function () {
      input.removeEventListener('change', handleInputChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  });
  useEffect(function () {
    var _a;

    if (clearCurInputValue) {
      // @ts-ignore
      (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value = '';
    }
  }, [clearCurInputValue]); // 用于判断视频时长并删除

  useEffect(function () {
    if (counter && counter === files.length) {
      // 视频大小/时长判断完毕，开始过滤
      var filterFiles = files.filter(function (file, index) {
        return !deleteIndexList.includes(index);
      });
      var curCount = currentCount !== null && currentCount !== void 0 ? currentCount : ansSortListObj[submitType].length; // 判断视频数量是否超过限制

      if (filterFiles.length + curCount > EAnswerTypeMaxCount.VIDEO) {
        // 保留delIndex下标之前的文件，delIndex也删除
        var delIndex = EAnswerTypeMaxCount.VIDEO - curCount;
        filterFiles.splice(delIndex);
        updateUploadPromptMsg === null || updateUploadPromptMsg === void 0 ? void 0 : updateUploadPromptMsg(EPromptMsg.OVER_VIDEO_MAX_COUNT);
        exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
          msg: EPromptMsg.OVER_VIDEO_MAX_COUNT
        });
      }

      filterFiles.length && uploadFiles(filterFiles, ESubmitType.VIDEO);
      setCounter(0);
      setDeleteIndexList([]);
    }
  }, [counter]);

  function uploadCallback(file) {
    loadedCallback([file.url]);
  }

  var handleChoose = throttle(function () {
    var _a;

    if ((haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.eventId) && (haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo)) {
      clickReport(haboReportData.eventId, haboReportData === null || haboReportData === void 0 ? void 0 : haboReportData.otherInfo);
    }

    if (isMobileClient) {
      callNative({
        apiName: ENativeApi.SHOW_UPLOAD_IMAGE,
        callbackName: ENativeCBNames.UPLOAD_IMG_CB,
        callback: uploadCallback
      });
    } else if (isWX && window.wx && submitType === ESubmitType.IMAGE) {
      updateUploadPromptMsg('');
      exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
        msg: ''
      });
      var curImageCount = ((_a = ansSortListObj[submitType]) === null || _a === void 0 ? void 0 : _a.length) || 0;
      window.wx.chooseImage({
        count: EAnswerTypeMaxCount.IMAGE - curImageCount,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          console.log('选择图片的success回调：', res);
          var localIds = res.localIds;
          wxTotalUpload.current = (localIds === null || localIds === void 0 ? void 0 : localIds.length) || 0;
          !!(localIds === null || localIds === void 0 ? void 0 : localIds.length) && wxImgUpload(localIds);
        },
        fail: function fail(e) {
          var errMsg = "\u8C03\u7528\u5FAE\u4FE1\u9009\u62E9\u56FE\u7247(chooseImage)\u7684\u80FD\u529B\u5931\u8D25\uFF0C\u9519\u8BEF\u4FE1\u606F: ".concat(e.errMsg);
          console.error(errMsg);
          updateUploadPromptMsg(EPromptMsg.CHOOSE_IMG_FAILED);
          exceptionCallback === null || exceptionCallback === void 0 ? void 0 : exceptionCallback({
            msg: EPromptMsg.CHOOSE_IMG_FAILED
          });
          footPrintJSErrorReport({
            detailAction: errMsg
          });
        }
      });
    } else {
      inputRef.current.click();
    }
  }, THROTTLE_TIME$2);
  useEffect(function () {
    var uploadBtn = uploadBtnRef === null || uploadBtnRef === void 0 ? void 0 : uploadBtnRef.current;
    uploadBtn === null || uploadBtn === void 0 ? void 0 : uploadBtn.addEventListener('click', handleChoose);
    return function () {
      uploadBtn === null || uploadBtn === void 0 ? void 0 : uploadBtn.removeEventListener('click', handleChoose);
    };
  });
};

var usePreload = function usePreload(audioRef, questionId) {
  function loadAudio() {
    var _a, _b;

    (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.load();
    footPrintDetailReport({
      detailAction: "\u9884\u52A0\u8F7D\u97F3\u9891 src: ".concat((_b = audioRef.current) === null || _b === void 0 ? void 0 : _b.src)
    });
  }

  useEffect(function () {
    loadAudio(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
};

var useClickEvent = function useClickEvent(audioRef, onClick, questionId, state) {
  useEffect(function () {
    var audioDOM = audioRef.current;
    audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.addEventListener('click', onClick);
    return function () {
      audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.removeEventListener('click', onClick);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId, state]);
};

var useEndEvent = function useEndEvent(audioRef, onEnd, questionId) {
  useEffect(function () {
    var audioDOM = audioRef.current;

    function handleEnd() {
      var _a;

      footPrintDetailReport({
        detailAction: "\u97F3\u9891\u5F00\u59CB\u64AD\u653E\uFF0Curl:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
      });
      onEnd === null || onEnd === void 0 ? void 0 : onEnd();
    } // 当正常播放时，根据实际的播放时间改变UI的播放进度


    audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.addEventListener('ended', handleEnd);
    return function () {
      audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.removeEventListener('ended', handleEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
};

var usePauseEvent = function usePauseEvent(audioRef, onPause, questionId) {
  useEffect(function () {
    var audioDOM = audioRef.current;

    function handlePause() {
      var _a;

      footPrintDetailReport({
        detailAction: "\u97F3\u9891\u64AD\u653E\u6682\u505C\uFF0Curl:".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
      });
      onPause === null || onPause === void 0 ? void 0 : onPause();
    } // 当正常播放时，根据实际的播放时间改变UI的播放进度


    audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.addEventListener('pause', handlePause);
    return function () {
      audioDOM === null || audioDOM === void 0 ? void 0 : audioDOM.removeEventListener('pause', handlePause);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
};

var useRefState = function useRefState(initialState) {
  var _a = useState(initialState),
      state = _a[0],
      setState = _a[1];

  var stateRef = useRef(initialState);
  stateRef.current = state;
  return [stateRef, setState];
};

var useAutoPause = function useAutoPause(audioRef, questionId) {
  useEffect(function () {
    function pauseAudio() {
      var audioDom = audioRef.current;

      if (document.hidden) {
        audioDom === null || audioDom === void 0 ? void 0 : audioDom.pause();

        if (audioDom) {
          audioDom.currentTime = 0;
        }
      }
    }

    window.addEventListener('blur', pauseAudio);
    window.addEventListener('visibilitychange', pauseAudio);
    return function () {
      window.removeEventListener('blur', pauseAudio);
      window.removeEventListener('visibilitychange', pauseAudio);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
};

/* eslint-disable react-hooks/exhaustive-deps */
/**
 * 首次渲染什么也不做，后续渲染中如果deps列表有变化则执行effect
 * @author chenbaijin
 * @param effect
 * @param deps
 */

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var isFirstRender = useRef(true);
  useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      // 1.执行effect
      // 2.如果effect中有return清理副作用的方法, 此处的return就可以将其交由React择机执行清理。
      return effect();
    }
  }, deps);
};

var useBlurEvent = function useBlurEvent(onBlur) {
  useEffect(function () {
    function blurEventInterceptor() {
      footPrintDetailReport({
        detailAction: 'H5监听到切后台等操作导致的失焦事件'
      });
      onBlur();
    }

    function hanldeChange() {
      if (document.hidden) {
        blurEventInterceptor();
      }
    }

    function hanldeBlur() {
      blurEventInterceptor();
    }

    window.addEventListener('blur', hanldeBlur);
    window.addEventListener('visibilitychange', hanldeChange);
    return function () {
      window.removeEventListener('blur', hanldeBlur);
      window.removeEventListener('visibilitychange', hanldeChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

var ERoleTypes$1;

(function (ERoleTypes) {
  ERoleTypes["MY_AUDIO"] = "MY_AUDIO";
  ERoleTypes["ORIGINAL"] = "ORIGINAL";
})(ERoleTypes$1 || (ERoleTypes$1 = {}));

var ENativeAudioStatus;

(function (ENativeAudioStatus) {
  ENativeAudioStatus[ENativeAudioStatus["STARTED"] = 1] = "STARTED";
  ENativeAudioStatus[ENativeAudioStatus["FINISHED"] = 2] = "FINISHED";
  ENativeAudioStatus[ENativeAudioStatus["FIALED"] = 3] = "FIALED";
  ENativeAudioStatus[ENativeAudioStatus["INVALID"] = 4] = "INVALID";
})(ENativeAudioStatus || (ENativeAudioStatus = {}));

var autoPlayAudioFailReport = function autoPlayAudioFailReport(errorMsg, url) {
  sentryReport('自动播放端能力异常', {
    extras: {
      errorMsg: errorMsg,
      url: url
    }
  });
};

var usePlayHandler$1 = function usePlayHandler(props) {
  var playBtnRef = props.playBtnRef,
      _a = props.nativeAudioState,
      isOriginPlaying = _a.isOriginPlaying,
      isMyAudioPlaying = _a.isMyAudioPlaying,
      setNativeAudioState = props.setNativeAudioState,
      role = props.role,
      audioUrl = props.audioUrl,
      conversationId = props.conversationId,
      isTapingRef = props.isTapingRef,
      setSpeakError = props.setSpeakError;
  var isOriginPlayingRef = useRef(false);
  isOriginPlayingRef.current = isOriginPlaying;
  var isMyAudioPlayingRef = useRef(false);
  isMyAudioPlayingRef.current = isMyAudioPlaying;
  var audioUrlRef = useRef('');
  audioUrlRef.current = audioUrl || '';

  var autoStatusMachine = function autoStatusMachine(status, duration) {
    var _a;

    var _b, _c;

    return (_c = (_b = (_a = {}, _a[ENativeAudioStatus.STARTED] = function () {
      setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
        duration: duration || 0,
        isOriginPlaying: role === ERoleTypes$1.ORIGINAL,
        isMyAudioPlaying: role === ERoleTypes$1.MY_AUDIO
      });
      footPrintDetailReport({
        detailAction: '调用 audioPlay端能力 开始'
      });
    }, _a[ENativeAudioStatus.FINISHED] = function () {
      setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
        isOriginPlaying: false,
        isMyAudioPlaying: false
      });
      footPrintDetailReport({
        detailAction: '调用 audioPlay端能力 结束'
      });
    }, _a[ENativeAudioStatus.INVALID] = function () {
      autoPlayAudioFailReport('调用audioPlay端能力失败，URL不合法', audioUrlRef.current);
      footPrintDetailReport({
        detailAction: '调用audioPlay端能力失败，URL不合法'
      });
    }, _a[ENativeAudioStatus.FIALED] = function () {
      autoPlayAudioFailReport('调用audioPlay端能力失败，app给的报错信息是：原因未知', audioUrlRef.current);
      footPrintDetailReport({
        detailAction: '调用audioPlay端能力失败，app给的报错信息是：原因未知'
      });
    }, _a))[status]) === null || _c === void 0 ? void 0 : _c.call(_b);
  };

  function playAudioCallback(payload) {
    var status = payload.status,
        duration = payload.duration;

    if (!status) {
      autoPlayAudioFailReport('audioPlay端能力的回调中不含状态码', audioUrlRef.current);
      footPrintDetailReport({
        detailAction: 'audioPlay端能力的回调中不含状态码'
      });
    }

    autoStatusMachine(+status, duration);
  }

  useEffect(function () {
    // 切换句子时自动播放原音
    if (role === ERoleTypes$1.ORIGINAL) {
      if (!audioUrlRef.current) {
        throw new Error('音频文件缺失');
      } // 先停止原有播放音频


      if (isOriginPlayingRef.current || isMyAudioPlayingRef.current) {
        footPrintDetailReport({
          detailAction: "\u5207\u6362\u53E5\u5B50\u505C\u6B62\u539F\u6709\u64AD\u653E\u97F3\u9891, url: ".concat(audioUrlRef.current)
        });
        stopNativeAudio().then(function () {
          setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
            isOriginPlaying: false,
            isMyAudioPlaying: false
          }); // 播放新音频

          autoPlayAudio({
            url: audioUrlRef.current,
            callback: playAudioCallback
          });
        });
      } else {
        autoPlayAudio({
          url: audioUrlRef.current,
          callback: playAudioCallback
        });
      }
    }
    /* eslint-disable-next-line */

  }, [conversationId]);

  function btnOnClick() {
    footPrintDetailReport({
      detailAction: "\u70B9\u51FB\u64AD\u653E\u6309\u94AE\uFF0C\n                \u5F53\u524D\u5F55\u97F3\u72B6\u6001\uFF1A".concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\uFF0C\n                \u5F53\u524D\u64AD\u653E\u72B6\u6001\uFF1AisOriginPlaying: ").concat(isOriginPlayingRef.current, "\n                            --- isMyAudioPlaying: ").concat(isMyAudioPlayingRef.current, "\n                \u88AB\u70B9\u51FB\u7684\u6309\u94AE\u89D2\u8272\u662F\uFF1A").concat(role, "\n                \u97F3\u9891\uFF1A").concat(audioUrlRef.current, "\n            ")
    });

    if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('录音中，请先结束录音');
      return;
    }

    if (role === ERoleTypes$1.MY_AUDIO && !audioUrlRef.current) {
      return;
    }

    if (role === ERoleTypes$1.ORIGINAL && !audioUrlRef.current) {
      throw new Error('音频文件缺失');
    } // 若有音频正在播放，停止播放


    if (isOriginPlayingRef.current || isMyAudioPlayingRef.current) {
      footPrintDetailReport({
        detailAction: "aduio pause\u88AB\u8C03\u7528, url: ".concat(audioUrlRef.current)
      });
      stopNativeAudio().then(function () {
        // 正在播放的音频再次被点击 设置停止播放状态
        if (isOriginPlayingRef.current && role === ERoleTypes$1.ORIGINAL || isMyAudioPlayingRef.current && role === ERoleTypes$1.MY_AUDIO) {
          setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
            isOriginPlaying: false,
            isMyAudioPlaying: false
          });
        } // 其他音频被点击，开始播放被点击音频
        else {
          autoPlayAudio({
            url: audioUrlRef.current,
            callback: playAudioCallback
          });
        }
      });
    } // 若没有有音频正在播放，则播放被点击音频
    else {
      autoPlayAudio({
        url: audioUrlRef.current,
        callback: playAudioCallback
      });
    }
  }

  useClickEvent(playBtnRef, btnOnClick);
};

var style$S = {"icon":"tangram_C_icon_02083de7f8"};

var OriginalAudio$2 = function OriginalAudio() {
  var currentSentenceInfo = useContext(FollowReadContext).currentSentenceInfo;

  var _a = useContext(PlayStateContext),
      setNativeAudioState = _a.setNativeAudioState,
      nativeAudioState = _a.nativeAudioState,
      isTapingRef = _a.isTapingRef,
      setSpeakError = _a.setSpeakError;

  var originalAudioRef = useRef(null);
  usePlayHandler$1({
    playBtnRef: originalAudioRef,
    role: ERoleTypes$1.ORIGINAL,
    nativeAudioState: nativeAudioState,
    conversationId: currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId,
    setNativeAudioState: setNativeAudioState,
    audioUrl: currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.reciteFile,
    isTapingRef: isTapingRef,
    setSpeakError: setSpeakError
  });
  var isOriginPlaying = nativeAudioState.isOriginPlaying,
      duration = nativeAudioState.duration;
  return /*#__PURE__*/React.createElement("div", {
    className: style$S.icon,
    ref: originalAudioRef
  }, /*#__PURE__*/React.createElement(Progress, {
    playing: +isOriginPlaying,
    duration: isOriginPlaying ? duration : 0,
    ringColor: "#ff3741",
    backgroundImage: isOriginPlaying ? img$i : img$j
  }));
};

var img$e = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='68px' height='68px' viewBox='0 0 68 68' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e%e5%bd%95%e9%9f%b3%3c/title%3e %3cg id='%e9%a1%b5%e9%9d%a2-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%9f%b3%e9%a2%91%e7%8a%b6%e6%80%81' transform='translate(-143.000000%2c -99.000000)'%3e %3cg id='%e9%9f%b3%e9%a2%91%e7%bb%84%e4%bb%b6-%e6%9c%aa%e5%bd%95%e9%9f%b3' transform='translate(67.000000%2c 99.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3' transform='translate(76.000000%2c 0.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' fill='%23FF3741' cx='34' cy='34' r='34'%3e%3c/circle%3e %3cg id='%e7%bc%96%e7%bb%84-5' transform='translate(21.000000%2c 15.000000)'%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='white' stroke-width='2' fill='white' x='6' y='1' width='14' height='24' rx='7'%3e%3c/rect%3e %3cpath d='M26%2c15 C26%2c15.5300771 26%2c16.4305104 26%2c17.7012997 C26%2c25.0459691 20.1797017%2c31 13%2c31 C5.82029825%2c31 0%2c25.0459691 0%2c17.7012997 C0%2c16.4305104 0%2c15.5300771 0%2c15' id='%e8%b7%af%e5%be%84' stroke='white' stroke-width='3' stroke-linecap='round'%3e%3c/path%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' x='12' y='30' width='3' height='8' rx='1.5'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$d = "data:image/png;base64,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";

var style$R = {"tape":"tangram_C_tape_b36dc9a326","error":"tangram_C_error_b36dc9a326"};

var styledClassNames$5 = bind.bind(style$R); // eslint-disable-next-line

var netErrCodes$2 = [50, 51, 52, '3002']; // 秒为单位的默认答题时限

var DEFAULT_TIME_LIMIT$2 = 45;

var audioAvaluteExceptionReport$1 = function audioAvaluteExceptionReport(errorMsg) {
  sentryReport('语音评测端能力异常', {
    extras: {
      errorMsg: errorMsg
    }
  });
};

var Tape$1 = function Tape() {
  var _a = useContext(PlayStateContext),
      isTapingRef = _a.isTapingRef,
      setIsTaping = _a.setIsTaping,
      speakError = _a.speakError,
      setSpeakError = _a.setSpeakError,
      setNativeAudioState = _a.setNativeAudioState,
      _b = _a.nativeAudioState,
      isOriginPlaying = _b.isOriginPlaying,
      isMyAudioPlaying = _b.isMyAudioPlaying;

  var _c = useContext(FollowReadContext),
      currentSentenceInfo = _c.currentSentenceInfo,
      currentSentenceIndex = _c.currentSentenceIndex,
      setResultList = _c.setResultList,
      currentResult = _c.currentResult;

  var authoritiedRef = useRef(false);
  var conversationId = useRef('');
  conversationId.current = (currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId) || '';
  var hasMyAudio = currentResult === null || currentResult === void 0 ? void 0 : currentResult.userRecordingUrl;

  function handleJudgeCallback(payload) {
    console.log('handleJudgeCallback', payload, isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, currentSentenceInfo);

    if (conversationId.current !== (currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId)) {
      audioAvaluteExceptionReport$1('切题导致的不再响应上一题的回调');
      console.log('切题导致的不再响应上一题的回调', conversationId.current, currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId);
      return;
    }

    if (!payload) {
      console.log('回调没有参数');
      footPrintSecondaryReport({
        actionValue: '！！！录音端能力回调无参数'
      });
      audioAvaluteExceptionReport$1('回调没有参数');
      return;
    }

    var voiceStatus = payload.voiceStatus,
        resultCode = payload.resultCode,
        dataResult = payload.dataResult,
        appSdkCode = payload.appSdkCode;
    console.log(voiceStatus, resultCode, dataResult, appSdkCode, '录音端能力的回调');

    if (+voiceStatus === 1) {
      // footPrintDetailReport({detailAction: '开始录音'});
      footPrintSecondaryReport({
        actionValue: "\u8DDF\u8BFB-\u5F00\u59CB\u5F55\u97F3-index: ".concat(currentSentenceIndex)
      });
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(true);
    }

    if (+resultCode === 1) {
      // eslint-disable-next-line no-console
      console.log(dataResult.overall, 'AI的打分======');

      if (dataResult.overall === 0) {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('没有听清您的声音，请再试一次吧！');
        audioAvaluteExceptionReport$1("AI\u6253\u5206\u4E3A0\uFF0C\u53EF\u80FD\u662F\u6CA1\u6709\u97F3\u9891\u5BFC\u81F4, \u97F3\u9891url:".concat(dataResult.url));
        return;
      }

      setResultList === null || setResultList === void 0 ? void 0 : setResultList(function (state) {
        var ResultListCopy = state;
        ResultListCopy.splice(currentSentenceIndex, 1, {
          judgeResultJson: JSON.stringify(dataResult),
          userRecordingUrl: dataResult.url,
          overall: dataResult.overall
        });
        return __spreadArray([], ResultListCopy, true);
      }); // footPrintDetailReport({detailAction: `录音成功 -- 分数${dataResult.overall}`, actionValue: dataResult.url});

      footPrintSecondaryReport({
        actionValue: "\u8DDF\u8BFB-\u5F55\u97F3\u6210\u529F-\u5206\u6570: ".concat(dataResult.overall, "-\u97F3\u9891: ").concat(dataResult.url)
      });
    }

    if (+resultCode === 2) {
      if (netErrCodes$2.includes(appSdkCode)) {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('网络异常，请检查网络');
        footPrintSecondaryReport({
          actionValue: "\uFF01\uFF01\uFF01\u7F51\u7EDC\u5F02\u5E38\u5BFC\u81F4\u7684\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode)
        });
        audioAvaluteExceptionReport$1("\u7F51\u7EDC\u5F02\u5E38\u5BFC\u81F4\u7684\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
      } else {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError("\u5F55\u97F3\u80FD\u529B\u8C03\u7528\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5\uFF1A".concat(appSdkCode));
        footPrintSecondaryReport({
          actionValue: "\uFF01\uFF01\uFF01\u5F55\u97F3\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode)
        });
        audioAvaluteExceptionReport$1("\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
      }
    }

    if (+voiceStatus === 2) {
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false); // footPrintDetailReport({detailAction: '录音结束'});

      footPrintSecondaryReport({
        actionValue: "\u8DDF\u8BFB-\u5F55\u97F3\u7ED3\u675F-index: ".concat(currentSentenceIndex)
      });
    }
  }

  function handleClick() {
    return __awaiter$2(this, void 0, void 0, function () {
      var privilegeRes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // footPrintDetailReport({
            //     detailAction: `录音按钮被点击，
            //     当前录音状态：${isTapingRef?.current}
            //     当前音频播放状态：isOriginPlaying: ${isOriginPlaying} -- isMyAudioPlaying: ${isMyAudioPlaying}`
            // });
            footPrintSecondaryReport({
              actionValue: "\u5F55\u97F3\u6309\u94AE\u88AB\u70B9\u51FB\uFF0C\n            \u5F53\u524D\u5F55\u97F3\u72B6\u6001\uFF1A".concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\n            \u5F53\u524D\u97F3\u9891\u64AD\u653E\u72B6\u6001\uFF1AisOriginPlaying: ").concat(isOriginPlaying, " -- isMyAudioPlaying: ").concat(isMyAudioPlaying)
            });
            console.log("\u5F53\u524D\u97F3\u9891\u64AD\u653E\u72B6\u6001\uFF1AisOriginPlaying: ".concat(isOriginPlaying, " -- isMyAudioPlaying: ").concat(isMyAudioPlaying));
            setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('');
            if (!(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current)) return [3
            /*break*/
            , 1];
            callNativeSpeakEvalute({
              speakType: ESpeakEvaluteTypes.STOP,
              callback: handleJudgeCallback
            });
            setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
            return [3
            /*break*/
            , 6];

          case 1:
            // 如果native在播放，则停止后开始录音
            if (isOriginPlaying || isMyAudioPlaying) {
              stopNativeAudio().then(function () {
                setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
                  isOriginPlaying: false,
                  isMyAudioPlaying: false
                });
              });
            } // eslint-disable-next-line


            console.log('调用权限的端能力');
            privilegeRes = {
              'privilege:': false
            };
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , promisifiedCallNative({
              apiName: ENativeApi.CHECK_INDICATE_PRIVILEGE,
              params: {
                type: EAuthorityTypes.AUDIO
              },
              callbackName: ENativeCBNames.GET_AUTHORITY_CB,
              maxWaitTime: 10000
            })];

          case 3:
            privilegeRes = _a.sent();

            if ((privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']) === false) {
              audioAvaluteExceptionReport$1('端能力结果表示用户拒绝权限');
            }

            return [3
            /*break*/
            , 5];

          case 4:
            _a.sent();
            audioAvaluteExceptionReport$1('请求权限超时，导致无法录音');
            return [2
            /*return*/
            ];

          case 5:
            if ((privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']) === true) {
              // eslint-disable-next-line
              console.log('调用评测端能力，开始录音');
              authoritiedRef.current = true;
              callNativeSpeakEvalute({
                speakType: ESpeakEvaluteTypes.START,
                lang: 0,
                question_type: 0,
                content: currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.original,
                callback: handleJudgeCallback
              });
              return [2
              /*return*/
              ];
            }

            throw new Error('用户未授权或其他异常');

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  }
  /* eslint-disable-next-line arrow-body-style */


  useEffect(function () {
    return function () {
      /* eslint-disable-next-line react-hooks/exhaustive-deps */
      if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
        console.log('发生录音中切题事件');
        footPrintDetailReport({
          detailAction: '录音中发生切题事件'
        });
        callNativeSpeakEvalute({
          speakType: ESpeakEvaluteTypes.STOP,
          callback: noop$1
        });
        setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId]);
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styledClassNames$5({
      tape: true
    }),
    "data-content": (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? '点击完成' : hasMyAudio ? '点击重录' : '开始录音',
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: style$R.error,
    style: {
      opacity: speakError ? 1 : 0
    }
  }, speakError), /*#__PURE__*/React.createElement(Progress, {
    circleWidth: 60,
    playing: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? 1 : 0,
    duration: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? DEFAULT_TIME_LIMIT$2 : 0,
    backgroundImage: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? img$d : img$e,
    ringColor: "#ff3741",
    ringWidth: 2
  }));
};

var img$c = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACsklEQVR4AWLACkbBKBgFowBAbVkDQdFEQfj/cU1wT8lwS3DyEHcIccgTIhI8xFLc3TVHcuzcBbehOxhq6t1azUrtBV/11M2b97rnbNvt9sJWq3UKnGw0Gku6yjwMLwNKU6/XVbPZXN0V5pVSA2G2BNMyQIl73XD7e2jYCe6l/fb7w2gBqFqt5hSgwJrUBoDJnaZ5KhGBdqb19vvBZA4oH3KsTePtb3UzXa1W/ylhbdpuvy+MZYAKAsJkeCYt5v/n57pSqbga5p5Wo24nzyZm9PPnz6NhdB4Gb8YN7oNegL6GfpUGBWYIGegrlD0uYM2emzmDsyIxjabr0PQFtA1UUpTLZWob+gxq9w/O2xANqeY6asNUR+jF5vbfiEYygI8Be2R/erEJ8F43LJVKWs01NRHoxSbAQWk4QCC5b4FjvyNWT5U4+ByoiLAN/Nz6KRaHB4HHQBWLxcAGWatVYu7JermPUI9hflDYP6oBaHbP3ZC9QajENH+PsyN7UEPjm2ycBJzFmZE/7xQKhSuAQ5RWc0112peIesmV2J6T0Lg3Bp8XA30C+aNrcfPnOSPuh7deGPYKqHw+TzhcqxU8ixCv2DuRBzsMfAeUGzKQ8ZoX7xIxXy6XB8PMHw6NEvZk79gDYNCcXC6nTGhAq8Tck/VyH71nJxFgEwcGwNewrGPv2ANg0IFsNsuBimquqcRj348DsQeAkbvaWBQBRP3dJN6BPAfGAXvHaj6TyQwFSsLhUGmmDfYSroOGaLVaQ+O8/WkBAnzD+iC+kCP0Oa75GuCe8gJ/aJPj/A8YjSF/gPr48aMM8QscR8gJbue5xxrWulzEr1KpNCrWjxGMHzUDYCgDnYFODNqDtTzDs2Yv9v47egxkMQMtTgRauByULIBsQwqT5FSoZxJJHegaBaNgFIyCUTAKALUmCw85ow2mAAAAAElFTkSuQmCC";

var img$b = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAD8klEQVR4AWLACkbBKBgFowBAjTnASHtFYbjuj/XYrm07dlJbcd3GTqMN6oZVVFtr27aNuPbpe3Pn5M5/c7/1N5lN8uR8uzt4zptzkaXhxK3Ul/iA+uLvU2/8jsMl35+4B+JEvTFFf+zBwyE/cNFxyG8Si/dEmU3xt0PQQOIl6hPyUcDyEaJuQeyl3JZfuvYo5NdZHNKKrjCIrIvX5PDsx5/nsYG0qCwu6QyhRp/PTfm5W45AeJXl9fSFvCS8SnPRIznXAJJ/mnpk6iwNlDzTERQ8nVvyU8kzqTeyzOJcpTxg8fZguoaWxXtyQ57oZKT+vJ66lriiLSDpCDwv3ps90dFzfTSYugm7zJPY50sh/SVGZoi6o79LeWAcGU49IGkT+CWtgd+p1TeE5y+pxV9Kzf4nqcV3Ez7Pd1B7+iPUl2iF8M/qUFLwuCjpzORBO6fO8kJaAVlJs1fR5GF+piZ3MzW6H9yjfPJJeSApWJylrUdGVimt0OUhrCqLN3J1EzUIXOJ3T+66AaQ+LMX5RNW2RbVIDeOSmbpETxzVIO8Wsiwua70LuIf3si0uACHO8owhdTUyEsvUTeJaA4DFG0CdE8/Ohd030BN/LXNkwA4WaVBbpOZZN0tzFYkLpLzE8ebebpW9kRbzvg701IEU5/TN8oyUN6SukPK1jhYa8OztFksj5+dBuiEjeaM4C6uR8UmsR4bF9dQBpy7knQ1U58rb31baffkxJF4Naf1g0ncYLXWvhTgjxRmIZ6YuajV1+48d0EUtegTyZdShpw70Wbfe2/VZV+Jq1lm+jOqiRw7+vtMR+lZfqHoDLL3jkeHUOfkax7e23ZMwTqejgS/kuAR2njpjNS6KL8R32Hx5u+U0yA/q4mreWd561s1j4xikultOy87FrtU3v/XezqfpluMiqSlJUzyfHfnxs/PRwH/bzrreAKfNDbC4agCf6cy3v4H2wDV68voFDOj7unXy1cWKWsfVWRgf/xM7l9dHZgv5KlFLnrC/gWbfq+ZxcRlOVIdF6ulaVSTFRa0sFPVV+xto8lWxvOEew7dHFrdOHtIKbqCwyv4GGj1rSt7y9rj1uOjiFWnKC9bsle8IOEyp896uyf+M55chL/iZ5dXISHmtAbwm4LAxff9lWy1SWZ1/UI3jNWrxuPl94hlNvAbxP1gcwrJCWpKfrkUX29hAxEeNrv9OPFEdnPo/4F1q9oet3o/0w2jiXTTxT0bqirK8f6jO5bV1jCD/VqY4nv9D8p8i+bN3/Bl4LeQ/pYqC/6Q40v8xTzTxVhb+kXXXqRidx8BHaOA1NHTpnj+rvPAyKit4G3yKEfp/iaQOdI2CUTAKRsEoGAUAr2pi+VWaFvEAAAAASUVORK5CYII=";

var style$Q = {"star":"tangram_C_star_3a3f2c4a0d","star-0":"tangram_C_star-0_3a3f2c4a0d","star-1":"tangram_C_star-1_3a3f2c4a0d","star-2":"tangram_C_star-2_3a3f2c4a0d","star-3":"tangram_C_star-3_3a3f2c4a0d","star-4":"tangram_C_star-4_3a3f2c4a0d","record":"tangram_C_record_3a3f2c4a0d","record-disable":"tangram_C_record-disable_3a3f2c4a0d","record-playing":"tangram_C_record-playing_3a3f2c4a0d"};

var styledClassNames$4 = bind.bind(style$Q);
var RESULT_SEG_SIZE$1 = 20;
var initialStarsInfo$1 = [{
  className: style$Q['star-0'],
  transform: 'translate(-36px, 4px)',
  left: '',
  top: '',
  isHighlight: false
}, {
  className: style$Q['star-1'],
  transform: 'translate(-18px, 2px)',
  left: '',
  top: '',
  isHighlight: false
}, {
  className: style$Q['star-2'],
  left: '50%',
  top: '-30px',
  transform: 'translateX(-50%)',
  isHighlight: false
}, {
  className: style$Q['star-3'],
  isHighlight: false,
  transform: 'translate(18px, 2px)',
  left: '',
  top: ''
}, {
  className: style$Q['star-4'],
  isHighlight: false,
  transform: 'translate(36px, 4px)',
  left: '',
  top: ''
}];

var MyAudio$1 = function MyAudio() {
  var _a;

  var _b = useContext(FollowReadContext),
      currentSentenceInfo = _b.currentSentenceInfo,
      currentResult = _b.currentResult;

  var _c = useContext(PlayStateContext),
      setNativeAudioState = _c.setNativeAudioState,
      nativeAudioState = _c.nativeAudioState,
      isTapingRef = _c.isTapingRef,
      setSpeakError = _c.setSpeakError;

  var myTapeSrc = currentResult === null || currentResult === void 0 ? void 0 : currentResult.userRecordingUrl;
  var judgeResult = parseJSON(currentResult === null || currentResult === void 0 ? void 0 : currentResult.judgeResultJson);
  var starsInfo = initialStarsInfo$1.map(function (item, index) {
    return _assign$4(_assign$4({}, item), {
      isHighlight: (judgeResult === null || judgeResult === void 0 ? void 0 : judgeResult.overall) ? index < Math.ceil(judgeResult.overall / RESULT_SEG_SIZE$1) : false
    });
  });
  var myAudioRef = useRef(null);
  usePlayHandler$1({
    playBtnRef: myAudioRef,
    role: ERoleTypes$1.MY_AUDIO,
    nativeAudioState: nativeAudioState,
    // nativeAudioState: nativeAudioStateRef,
    conversationId: currentSentenceInfo === null || currentSentenceInfo === void 0 ? void 0 : currentSentenceInfo.conversationId,
    setNativeAudioState: setNativeAudioState,
    audioUrl: myTapeSrc,
    isTapingRef: isTapingRef,
    setSpeakError: setSpeakError
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: myAudioRef,
    className: styledClassNames$4({
      'record': true,
      'record-disable': !myTapeSrc,
      'record-playing': nativeAudioState.isMyAudioPlaying
    })
  }, /*#__PURE__*/React.createElement("div", {
    key: "star-2",
    className: styledClassNames$4((_a = {
      star: true
    }, _a[starsInfo[2].className] = true, _a)),
    style: {
      display: myTapeSrc ? 'block' : 'none',
      backgroundImage: "url(\"".concat(starsInfo[2].isHighlight ? img$b : img$c, "\")")
    }
  }, starsInfo.map(function (starInfo) {
    var _a;

    return /*#__PURE__*/React.createElement("div", {
      key: starInfo.className,
      className: styledClassNames$4((_a = {
        star: true
      }, _a[starInfo.className] = true, _a)),
      style: {
        display: starInfo.className === style$Q['star-2'] ? 'none' : 'block',
        backgroundImage: "url(\"".concat(starInfo.isHighlight ? img$b : img$c, "\")")
      }
    });
  })));
};

var style$P = {"play-content":"tangram_C_play-content_1f18db95aa"};

var PlayStateContext = /*#__PURE__*/createContext({
  nativeAudioState: {
    isOriginPlaying: false,
    isMyAudioPlaying: false
  }
});

var PlayContent$1 = function PlayContent() {
  var stopFuncRef = useContext(FollowReadContext).stopFuncRef; // const {getTapeState, switchBtnRef} = useContext(FollowReadContext);

  var _a = useState({
    isOriginPlaying: false,
    isMyAudioPlaying: false
  }),
      nativeAudioState = _a[0],
      setNativeAudioState = _a[1];

  var _b = useState(''),
      speakError = _b[0],
      setSpeakError = _b[1];

  var _c = useState(false),
      isTaping = _c[0],
      setIsTaping = _c[1];

  var _d = useState(null),
      timer = _d[0],
      setTimer = _d[1];

  var isTapingRef = useRef(false);
  isTapingRef.current = isTaping;
  var stopAll = useCallback(function () {
    footPrintSecondaryReport({
      actionValue: 'stopAll --- 弹出返回弹框暂停 或者 用户切后台'
    });

    if (nativeAudioState.isOriginPlaying || nativeAudioState.isMyAudioPlaying) {
      stopNativeAudio().then(function () {
        setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
          isOriginPlaying: false,
          isMyAudioPlaying: false
        });
      });
    }

    if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
      callNativeSpeakEvalute({
        speakType: ESpeakEvaluteTypes.STOP,
        callback: noop$1
      });
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
    }
  }, [nativeAudioState.isOriginPlaying, nativeAudioState.isMyAudioPlaying]);
  useEffect(function () {
    // app切后台暂停播放和录音
    window.addEventListener('blur', stopAll);
    window.addEventListener('visibilitychange', stopAll);
    return function () {
      window.removeEventListener('blur', stopAll);
      window.removeEventListener('visibilitychange', stopAll);
    };
  }, [stopAll]);

  if (stopFuncRef) {
    stopFuncRef.current = stopAll;
  }

  useEffect(function () {
    if (speakError) {
      if (timer) {
        clearTimeout(timer);
      }

      var timeout = setTimeout(function () {
        setSpeakError('');
        setTimer(null);
      }, 2000);
      setTimer(timeout);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [speakError]);
  return /*#__PURE__*/React.createElement("div", {
    className: style$P['play-content']
  }, /*#__PURE__*/React.createElement(PlayStateContext.Provider, {
    value: {
      nativeAudioState: nativeAudioState,
      setNativeAudioState: setNativeAudioState,
      isTapingRef: isTapingRef,
      setIsTaping: setIsTaping,
      speakError: speakError,
      setSpeakError: setSpeakError
    }
  }, /*#__PURE__*/React.createElement(OriginalAudio$2, null), /*#__PURE__*/React.createElement(Tape$1, null), /*#__PURE__*/React.createElement(MyAudio$1, null)));
};

var style$O = {"single-read":"tangram_C_single-read_c7fcd0af86","read-container":"tangram_C_read-container_c7fcd0af86","role-pic":"tangram_C_role-pic_c7fcd0af86","translation":"tangram_C_translation_c7fcd0af86"};

var SingleRead = function SingleRead() {
  var currentSentenceInfo = useContext(FollowReadContext).currentSentenceInfo;

  if (currentSentenceInfo) {
    footPrintDetailReport({
      detailAction: "\u83B7\u53D6\u5230\u5355\u53E5\u8DDF\u8BFB\u5185\u5BB9 ---- ".concat(JSON.stringify(currentSentenceInfo))
    });
  } else {
    propsException('currentSentenceInfo', currentSentenceInfo);
    footPrintSecondaryReport({
      actionValue: '！！！角色扮演-跟读: 单句跟读内容缺失'
    });
    throw new Error('角色扮演-跟读: 单句跟读内容缺失！');
  }

  var translation = currentSentenceInfo.translation,
      rolePic = currentSentenceInfo.file,
      roleName = currentSentenceInfo.name;
  return /*#__PURE__*/React.createElement("div", {
    className: style$O['single-read']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$O['read-container']
  }, /*#__PURE__*/React.createElement("img", {
    src: rolePic,
    alt: "\u89D2\u8272\u5934\u50CF",
    className: style$O['role-pic']
  }), roleName && /*#__PURE__*/React.createElement(Annotation, {
    text: roleName,
    fontSize: 14
  }), /*#__PURE__*/React.createElement(ReadContent, null), translation && /*#__PURE__*/React.createElement("div", {
    className: style$O.translation
  }, translation)), /*#__PURE__*/React.createElement(PlayContent$1, null));
};

var SingleRead$1 = withErrorBoundary(SingleRead);

var style$N = {"orderNumber":"tangram_C_orderNumber_515037687d","sentence-switcher":"tangram_C_sentence-switcher_515037687d","sentence-switcher-btn":"tangram_C_sentence-switcher-btn_515037687d","first-sentence":"tangram_C_first-sentence_515037687d","is-actvie":"tangram_C_is-actvie_515037687d"};

var DEBOUNCE_DELAY = 300;
var styledClassNames$3 = bind.bind(style$N);
var FollowReadContext = /*#__PURE__*/createContext({
  currentSentenceIndex: 0
});

var FollowRead = function FollowRead(props) {
  var _a, _b;

  var _c;

  var conversations = props.conversations,
      onFinish = props.onFinish,
      stopFuncRef = props.stopFuncRef,
      questionId = props.questionId;
  var switchBtnRef = useRef(null); // if (!conversations || !conversations.length) {
  //     propsException('conversations', conversations);
  //     footPrintSecondaryReport({actionValue: '！！！角色扮演: conversations未传参或传参为空数组'});
  //     throw new Error('角色扮演: conversations未传参或传参为空数组！');
  // }
  // else {
  //     footPrintSecondaryReport({
  //         secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
  //         actionValue: '题目信息获取成功'
  //     });
  // }

  var _d = useState(0),
      currentSentenceIndex = _d[0],
      setCurrentSentenceIndex = _d[1];

  var _e = useState([]),
      resultList = _e[0],
      setResultList = _e[1];

  function switchCurrentSentence(event) {
    var _a;

    var directionStr = event.currentTarget.getAttribute('switch-direction');

    if (!directionStr || currentSentenceIndex === 0 && +directionStr === -1) {
      return;
    }

    if (+directionStr === 1 && !((_a = resultList[currentSentenceIndex]) === null || _a === void 0 ? void 0 : _a.judgeResultJson)) {
      return;
    }

    if (currentSentenceIndex + 1 === conversations.length && +directionStr === 1) {
      stopNativeAudio();
      var resultListFinish = conversations.map(function (item, index) {
        return _assign$4(_assign$4({}, item), {
          overall: resultList[index].overall,
          userRecordingUrl: resultList[index].userRecordingUrl
        });
      });
      onFinish === null || onFinish === void 0 ? void 0 : onFinish(resultListFinish);
      footPrintSecondaryReport({
        // 一级事件都从cookie中去查
        secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
        actionValue: JSON.stringify(resultListFinish)
      });
      return;
    } // footPrintDetailReport({detailAction: `切换跟读按钮点击 ---- directionStr: ${directionStr}`});


    footPrintSecondaryReport({
      // 一级事件都从cookie中去查
      actionValue: "\u5207\u6362\u8DDF\u8BFB\u6309\u94AE\u70B9\u51FB ---- directionStr: ".concat(directionStr)
    });
    setCurrentSentenceIndex(currentSentenceIndex + +directionStr);
  }

  useEffect(function () {
    if (!conversations || !conversations.length) {
      propsException('conversations', conversations);
      footPrintSecondaryReport({
        actionValue: '！！！角色扮演: conversations未传参或传参为空数组'
      });
      throw new Error('角色扮演: conversations未传参或传参为空数组！');
    } else {
      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style$N.orderNumber
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: '#1c1d20'
    }
  }, currentSentenceIndex + 1), /*#__PURE__*/React.createElement("span", null, "/".concat(conversations.length))), /*#__PURE__*/React.createElement(FollowReadContext.Provider, {
    value: _assign$4(_assign$4({}, props), {
      currentSentenceIndex: currentSentenceIndex,
      currentSentenceInfo: conversations[currentSentenceIndex],
      currentResult: resultList[currentSentenceIndex],
      setResultList: setResultList,
      switchBtnRef: switchBtnRef,
      stopFuncRef: stopFuncRef
    })
  }, /*#__PURE__*/React.createElement(SingleRead$1, null)), /*#__PURE__*/React.createElement("div", {
    className: style$N['sentence-switcher']
  }, /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$3('sentence-switcher-btn', (_a = {}, _a[style$N['first-sentence']] = currentSentenceIndex === 0, _a)),
    onClick: debounce(switchCurrentSentence, DEBOUNCE_DELAY, {
      leading: true,
      trailing: false
    }),
    role: "button",
    "switch-direction": -1,
    tabIndex: 0,
    ref: switchBtnRef
  }, "\u4E0A\u4E00\u53E5"), /*#__PURE__*/React.createElement("div", {
    className: styledClassNames$3('sentence-switcher-btn', (_b = {}, _b[style$N['is-actvie']] = (_c = resultList[currentSentenceIndex]) === null || _c === void 0 ? void 0 : _c.judgeResultJson, _b)),
    onClick: debounce(switchCurrentSentence, DEBOUNCE_DELAY, {
      leading: true,
      trailing: false
    }),
    role: "button",
    "switch-direction": 1,
    tabIndex: 0,
    ref: switchBtnRef
  }, currentSentenceIndex < conversations.length - 1 ? '下一句' : '去扮演')));
};

var index$2 = withErrorBoundary(FollowRead);

var img$a = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cg id='%e9%a1%b5%e9%9d%a2-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e8%a7%92%e8%89%b2%e6%89%ae%e6%bc%94' transform='translate(-158.000000%2c -431.000000)'%3e %3cg id='%e7%bc%96%e7%bb%84-2' transform='translate(144.000000%2c 423.000000)'%3e %3cg id='%e6%9a%82%e5%81%9c' transform='translate(14.000000%2c 8.000000)'%3e %3crect id='%e7%9f%a9%e5%bd%a2' x='0' y='0' width='24' height='24'%3e%3c/rect%3e %3cpath d='M7.5%2c4 C8.32842712%2c4 9%2c4.67157288 9%2c5.5 L9%2c18.5 C9%2c19.3284271 8.32842712%2c20 7.5%2c20 C6.67157288%2c20 6%2c19.3284271 6%2c18.5 L6%2c5.5 C6%2c4.67157288 6.67157288%2c4 7.5%2c4 Z M17.5%2c4 C18.3284271%2c4 19%2c4.67157288 19%2c5.5 L19%2c18.5 C19%2c19.3284271 18.3284271%2c20 17.5%2c20 C16.6715729%2c20 16%2c19.3284271 16%2c18.5 L16%2c5.5 C16%2c4.67157288 16.6715729%2c4 17.5%2c4 Z' id='%e5%bd%a2%e7%8a%b6%e7%bb%93%e5%90%88' fill='%23696E80'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e%e7%bb%a7%e7%bb%ad%e6%92%ad%e6%94%be%3c/title%3e %3cg id='%e9%a1%b5%e9%9d%a2-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e6%8c%89%e9%92%ae%e7%8a%b6%e6%80%81' transform='translate(-37.000000%2c -86.000000)'%3e %3cg id='%e7%bc%96%e7%bb%84-2%e5%a4%87%e4%bb%bd' transform='translate(23.000000%2c 78.000000)'%3e %3cg id='%e7%bb%a7%e7%bb%ad%e6%92%ad%e6%94%be' transform='translate(14.000000%2c 8.000000)'%3e %3crect id='%e7%9f%a9%e5%bd%a2' x='0' y='0' width='24' height='24'%3e%3c/rect%3e %3cpath d='M16.5801257%2c7.6201886 L21.908833%2c15.6132495 C22.6747142%2c16.7620712 22.3642795%2c18.3142446 21.2154578%2c19.0801257 C20.804789%2c19.3539049 20.3222697%2c19.5 19.8287073%2c19.5 L9.17129273%2c19.5 C7.79058085%2c19.5 6.67129273%2c18.3807119 6.67129273%2c17 C6.67129273%2c16.5064375 6.8173878%2c16.0239183 7.09116699%2c15.6132495 L12.4198743%2c7.6201886 C13.1857554%2c6.47136688 14.7379288%2c6.16093221 15.8867505%2c6.92681336 C16.1613812%2c7.1099005 16.3970386%2c7.34555789 16.5801257%2c7.6201886 Z' id='%e4%b8%89%e8%a7%92%e5%bd%a2' fill='%23696E80' transform='translate(14.500000%2c 12.000000) rotate(90.000000) translate(-14.500000%2c -12.000000) '%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var NOTIFY_DELAY_TIME = 200;
var ATUO_NEXT_AUDIO_INTERVAL = 900;

var useSchedule = function useSchedule(params) {
  var _a, _b;

  var conversations = params.conversations,
      onFinish = params.onFinish,
      playTime = params.playTime,
      pageStateRef = params.pageStateRef;

  var _c = useRefState(0),
      scheduleIdxRef = _c[0],
      setSchedudleIdx = _c[1];

  var _d = useRefState(0),
      progressIdx = _d[0],
      setProgressIdx = _d[1];

  var _e = useRefState(conversations === null || conversations === void 0 ? void 0 : conversations.map(function (conversation) {
    return _assign$4(_assign$4({}, conversation), {
      state: EConversationState.UNPLAYED
    });
  })),
      conversationsRef = _e[0],
      setConversations = _e[1];

  var isMyRoleRef = useRef(false);

  var _f = useRefState(false),
      isFinished = _f[0],
      setIsFinished = _f[1]; // console.log(conversations, 'conversations===');


  var myLinesRef = useRef(((_b = (_a = conversations === null || conversations === void 0 ? void 0 : conversations.filter(function (conversation) {
    return conversation.isMyRole;
  })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.original) || '');
  var forceUpdate = useForceUpdate();
  var hasMyRoleLeftRef = useRef(true);
  useEffect(function () {
    var _a;

    var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[scheduleIdxRef.current];
    var reciteFile = currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.reciteFile;
    var isMyRole = currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.isMyRole;

    function handleEnd() {
      // console.log('音频结束事件');
      // 页面暂停则不响应音频结束事件
      footPrintSecondaryReport({
        actionValue: "\u5F53\u524D\u9875\u9762\u72B6\u6001\u4E3A".concat(pageStateRef === null || pageStateRef === void 0 ? void 0 : pageStateRef.current),
        secondaryAction: '音频结束事件'
      });

      if ((pageStateRef === null || pageStateRef === void 0 ? void 0 : pageStateRef.current) === EPageState.PAUSED) {
        return;
      }

      setConversations(function (conversations) {
        var _a;

        if ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state) {
          conversations[scheduleIdxRef.current].state = EConversationState.PLAYED;
        }

        return conversations ? __spreadArray([], conversations, true) : conversations;
      });

      if (conversations === null || conversations === void 0 ? void 0 : conversations.length) {
        setTimeout(function () {
          footPrintSecondaryReport({
            actionValue: '扮演进度前进'
          });
          setSchedudleIdx(function (scheduleIdx) {
            return Math.min(scheduleIdx + 1, conversations.length);
          });
        }, ATUO_NEXT_AUDIO_INTERVAL);
      }
    }

    footPrintSecondaryReport({
      actionValue: "\u8FDB\u5EA6\u524D\u8FDB\u4E8B\u4EF6-\n                \u5F53\u524D\u662F\u6211\u7684\u89D2\u8272\u5417\uFF1F".concat(isMyRole, "\n                \u8981\u64AD\u653E\u7684\u97F3\u9891url\uFF1A").concat(reciteFile, "\n            ")
    }); // setTimeout(() => {
    //     setConversations(conversations => {
    //         if (conversations?.[scheduleIdxRef.current]?.state) {
    //             conversations[scheduleIdxRef.current].state = EConversationState.PLAYED;
    //         }
    //         return conversations ? [...conversations] : conversations;
    //     });
    //     conversations?.length
    //         && setSchedudleIdx(scheduleIdx => Math.min(scheduleIdx + 1, conversations.length - 1));
    // }, 2000);

    if (!isMyRole && reciteFile) {
      reciteFile && betterAutoPlayAudio({
        url: reciteFile,
        onFailed: handleEnd,
        onFinshed: handleEnd
      });
      setConversations(function (conversations) {
        var _a;

        if ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state) {
          conversations[scheduleIdxRef.current].state = EConversationState.PLAYING;
        }

        return conversations ? __spreadArray([], conversations, true) : conversations;
      });
      (conversations === null || conversations === void 0 ? void 0 : conversations.length) && setProgressIdx(function (scheduleIdx) {
        return Math.min(scheduleIdx + 1, conversations.length);
      });
    } // eslint-disable-next-line

  }, [scheduleIdxRef.current]); // 当进度推荐到轮到我的角色时，要把录音按钮置为可点击

  useEffect(function () {
    var _a, _b, _c, _d, _e;

    var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[scheduleIdxRef.current];
    var currentIdx = scheduleIdxRef.current;
    var leftConversation = (_b = conversationsRef.current) === null || _b === void 0 ? void 0 : _b.filter(function (conversation, index) {
      return (index > currentIdx || index === currentIdx) && conversation.isMyRole;
    });
    var len = leftConversation === null || leftConversation === void 0 ? void 0 : leftConversation.length;
    hasMyRoleLeftRef.current = exit(len) ? len > 0 : true;
    var isMyRole = currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.isMyRole;
    isMyRoleRef.current = isMyRole || false;
    var myConversations = (_c = conversationsRef.current) === null || _c === void 0 ? void 0 : _c.filter(function (conversation, index) {
      return (index > scheduleIdxRef.current || index === scheduleIdxRef.current) && conversation.isMyRole;
    });

    if (myLinesRef) {
      myLinesRef.current = ((_d = myConversations === null || myConversations === void 0 ? void 0 : myConversations[0]) === null || _d === void 0 ? void 0 : _d.original) || '';
    }

    footPrintSecondaryReport({
      actionValue: "\u8FDB\u5EA6\u53D8\u66F4-\u72B6\u6001\u66F4\u65B0\u4E8B\u4EF6-\n                \u66F4\u65B0\u662F\u5426\u8FD8\u6709\u89D2\u8272\u672A\u626E\u6F14\u72B6\u6001".concat(exit(len) ? len > 0 : true, "\n                \u66F4\u65B0\u662F\u5426\u662F\u6211\u7684\u89D2\u8272\u72B6\u6001").concat(isMyRole || false, "\n                \u66F4\u65B0\u662F\u5426\u662F\u63D0\u8BCD\u5668\u5185\u5BB9").concat(((_e = myConversations === null || myConversations === void 0 ? void 0 : myConversations[0]) === null || _e === void 0 ? void 0 : _e.original) || '', "\n            ")
    }); // updateMyLines();

    forceUpdate(); // eslint-disable-next-line
  }, [scheduleIdxRef.current]); // 每次播放状态由更新，都要检查是否已经全部播放、扮演完，如果是则回传给业务，通知演出落幕

  useEffect(function () {
    var _a, _b, _c;

    var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[scheduleIdxRef.current]; // console.log(currentConversation, 'currentConversation===');

    var isFinished = ((_b = conversationsRef.current) === null || _b === void 0 ? void 0 : _b.length) && scheduleIdxRef.current === ((_c = conversationsRef.current) === null || _c === void 0 ? void 0 : _c.length) - 1 && (currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.state) === EConversationState.PLAYED;
    footPrintSecondaryReport({
      actionValue: "\n                \u5F53\u524D\u8FDB\u5EA6".concat(scheduleIdxRef.current, "\n                \u5F53\u524D\u5BF9\u8BDD\u72B6\u6001").concat(currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.state, "\n            ")
    });

    if (isFinished) {
      setIsFinished(true);
      setTimeout(function () {
        footPrintSecondaryReport({
          actionValue: "\u901A\u77E5C\u7AEF\u89D2\u8272\u626E\u6F14\u7ED3\u675F\n                        ".concat(JSON.stringify(conversationsRef === null || conversationsRef === void 0 ? void 0 : conversationsRef.current), "\n                    ")
        });
        onFinish === null || onFinish === void 0 ? void 0 : onFinish(conversationsRef === null || conversationsRef === void 0 ? void 0 : conversationsRef.current);
      }, NOTIFY_DELAY_TIME);
    } // eslint-disable-next-line

  }, [conversationsRef.current]); // 当playTime改变，说明进入了下半场扮演，状态要重置。
  // 但是组件未必被销毁了，所以需要手动重置状态。那么要把播放状态置为未播放，播放进度也要置为0

  useUpdateEffect(function () {
    var _a, _b;

    footPrintSecondaryReport({
      actionValue: '进入下半场'
    });
    setConversations(conversations ? __spreadArray([], conversations === null || conversations === void 0 ? void 0 : conversations.map(function (conversation) {
      return _assign$4(_assign$4({}, conversation), {
        state: EConversationState.UNPLAYED
      });
    }), true) : conversations);
    setSchedudleIdx(0);
    setProgressIdx(0);
    myLinesRef.current = ((_b = (_a = conversations === null || conversations === void 0 ? void 0 : conversations.filter(function (conversation) {
      return conversation.isMyRole;
    })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.original) || ''; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playTime]);

  function stopCurrentAudio() {
    var stopedAudioIdx = scheduleIdxRef.current;
    footPrintSecondaryReport({
      secondaryAction: '调用停止当前播放中对话的方法',
      actionValue: '调用停止当前播放中对话的方法'
    });
    stopNativeAudio().then(function () {
      var _a;

      footPrintSecondaryReport({
        secondaryAction: '响应到停止当前播放中对话音频的事件',
        actionValue: '响应到停止当前播放中对话音频的事件'
      });
      var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[stopedAudioIdx];

      if ((currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.state) && !currentConversation.isMyRole) {
        currentConversation.state = EConversationState.PAUSED;
      }
    });
  }

  function recoverPauseAudio() {
    var _a;

    var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[scheduleIdxRef.current];
    var reciteFile = currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.reciteFile;
    var isMyRole = currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.isMyRole;
    footPrintSecondaryReport({
      secondaryAction: '调用恢复当前播放中对话的方法',
      actionValue: "\n                \u5F53\u524D\u662F\u6211\u7684\u89D2\u8272\u5417\uFF1F".concat(isMyRole, "\n                \u8981\u64AD\u653E\u7684\u97F3\u9891\uFF1A").concat(reciteFile, "\n            ")
    });

    function handleEnd() {
      footPrintSecondaryReport({
        secondaryAction: '恢复播放的音频播放完毕事件',
        actionValue: '恢复播放的音频播放完毕事件'
      });
      setConversations(function (conversations) {
        var _a;

        if ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state) {
          conversations[scheduleIdxRef.current].state = EConversationState.PLAYED;
        }

        return conversations ? __spreadArray([], conversations, true) : conversations;
      });
      (conversations === null || conversations === void 0 ? void 0 : conversations.length // @ts-ignore
      ) && setSchedudleIdx(function (scheduleIdx) {
        return Math.min(scheduleIdx + 1, conversations.length);
      }) && setProgressIdx(function (scheduleIdx) {
        return Math.min(scheduleIdx + 1, conversations.length);
      });
    }

    if (!isMyRole && reciteFile) {
      reciteFile && betterAutoPlayAudio({
        url: reciteFile,
        onFailed: handleEnd,
        onFinshed: handleEnd
      });
      setConversations(function (conversations) {
        var _a;

        if ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state) {
          conversations[scheduleIdxRef.current].state = EConversationState.PLAYING;
        }

        return conversations ? __spreadArray([], conversations, true) : conversations;
      });
    }
  }

  return {
    conversationsRef: conversationsRef,
    scheduleIdxRef: scheduleIdxRef,
    myLinesRef: myLinesRef,
    isMyRoleRef: isMyRoleRef,
    setSchedudleIdx: setSchedudleIdx,
    setConversations: setConversations,
    hasMyRoleLeft: hasMyRoleLeftRef === null || hasMyRoleLeftRef === void 0 ? void 0 : hasMyRoleLeftRef.current,
    stopCurrentAudio: stopCurrentAudio,
    recoverPauseAudio: recoverPauseAudio,
    progressIdx: progressIdx.current,
    setProgressIdx: setProgressIdx,
    isFinished: isFinished.current
  };
};

var netErrCodes$1 = [50, 51, 52, '3002'];

var audioAvaluteExceptionReport = function audioAvaluteExceptionReport(errorMsg) {
  sentryReport('语音评测端能力异常', {
    extras: {
      errorMsg: errorMsg
    }
  });
  footPrintJSErrorReport({
    actionValue: "\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u5F02\u5E38".concat(errorMsg)
  });
};

var useTape = function useTape(tapeBtnRef, myLinesRef, isMyRoleRef, onResult, onFinish) {
  var _a = useRefState(false),
      isTapingRef = _a[0],
      setIsTaping = _a[1];

  function handleTapeStart() {
    setIsTaping(true);
  }

  function handleTapeFailed(payload) {
    var appSdkCode = payload.appSdkCode; // console.log(appSdkCode, 'appSdkCode===');

    if (netErrCodes$1.includes(appSdkCode)) {
      audioAvaluteExceptionReport("\u7F51\u7EDC\u5F02\u5E38\u5BFC\u81F4\u7684\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
    } else {
      audioAvaluteExceptionReport("\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
    }
  }

  function handleTapeResult(payload) {
    var _a, _b, _c;

    footPrintSecondaryReport({
      secondaryAction: '录音结束事件',
      actionValue: "\u6536\u5230\u5F55\u97F3\u7ED3\u679C\n                \u5F97\u5206\uFF1A".concat((_a = payload === null || payload === void 0 ? void 0 : payload.dataResult) === null || _a === void 0 ? void 0 : _a.overall, "\n                \u97F3\u9891url: ").concat((_b = payload === null || payload === void 0 ? void 0 : payload.dataResult) === null || _b === void 0 ? void 0 : _b.url, "\n                \u72B6\u6001\u7801: ").concat((_c = payload === null || payload === void 0 ? void 0 : payload.dataResult) === null || _c === void 0 ? void 0 : _c.status, "\n            ")
    });
    onResult === null || onResult === void 0 ? void 0 : onResult(payload);
  }

  function handleTapeFinished() {
    setIsTaping(false);
    onFinish === null || onFinish === void 0 ? void 0 : onFinish();
  }

  useEffect(function () {
    var tapeBtnDom = tapeBtnRef.current;

    function handleBtnClick() {
      return __awaiter$2(this, void 0, void 0, function () {
        var content, hasTapePrivilege;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              footPrintSecondaryReport({
                secondaryAction: '录音按钮被点击事件',
                actionValue: "\u5F55\u97F3\u6309\u94AE\u88AB\u70B9\u51FB\n                    \u5F53\u524D\u662F\u6211\u7684\u89D2\u8272\u5417\uFF1F".concat(isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current, "\n                    \u5F53\u524D\u5728\u5F55\u97F3\u4E2D\u5417\uFF1F").concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\n                ")
              });
              content = myLinesRef === null || myLinesRef === void 0 ? void 0 : myLinesRef.current; // 如果没有轮到角色，则不可点击

              if (!(isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current)) {
                return [2
                /*return*/
                ];
              }

              if (!isTapingRef.current) return [3
              /*break*/
              , 1];
              finishSpeakEvalute({
                onStarted: handleTapeStart,
                onFailed: handleTapeFailed,
                onFinished: handleTapeFinished,
                onResult: handleTapeResult
              });
              return [3
              /*break*/
              , 3];

            case 1:
              // eslint-disable-next-line
              console.log('调用权限的端能力');
              return [4
              /*yield*/
              , getTapePrivilege()];

            case 2:
              hasTapePrivilege = _a.sent();
              footPrintSecondaryReport({
                secondaryAction: '获取到权限结果',
                actionValue: "\n                        \u5F55\u97F3\u6743\u9650\u7AEF\u80FD\u529B\u7684\u7ED3\u679C".concat(hasTapePrivilege, "\n                        \u8BC4\u6D4B\u6587\u672C\uFF1A").concat(content, "\n                    ")
              });

              if (hasTapePrivilege) {
                content && startSpeakEvalute({
                  content: content,
                  onStarted: handleTapeStart,
                  onFailed: handleTapeFailed,
                  onFinished: handleTapeFinished,
                  onResult: handleTapeResult
                });
              }

              _a.label = 3;

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    tapeBtnDom === null || tapeBtnDom === void 0 ? void 0 : tapeBtnDom.addEventListener('click', handleBtnClick);
    return function () {
      tapeBtnDom === null || tapeBtnDom === void 0 ? void 0 : tapeBtnDom.removeEventListener('click', handleBtnClick);
    }; // eslint-disable-next-line
  }, []);

  function autoStartTape() {
    return __awaiter$2(this, void 0, void 0, function () {
      var content, hasTapePrivilege;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            content = myLinesRef === null || myLinesRef === void 0 ? void 0 : myLinesRef.current; // eslint-disable-next-line

            console.log('调用权限的端能力');
            return [4
            /*yield*/
            , getTapePrivilege()];

          case 1:
            hasTapePrivilege = _a.sent();
            footPrintSecondaryReport({
              secondaryAction: '自动开始录音事件',
              actionValue: "\u81EA\u52A8\u5F00\u59CB\u5F55\u97F3, \u8BC4\u6D4B\u5185\u5BB9\u4E3A".concat(content)
            });

            if (hasTapePrivilege) {
              content && startSpeakEvalute({
                content: content,
                onStarted: handleTapeStart,
                onFailed: handleTapeFailed,
                onFinished: handleTapeFinished,
                onResult: handleTapeResult
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }

  function pauseTape() {
    finishSpeakEvalute({
      onStarted: handleTapeStart,
      onFailed: handleTapeFailed,
      onFinished: handleTapeFinished,
      onResult: noop$1
    });
  }

  useUpdateEffect(function () {
    footPrintSecondaryReport({
      secondaryAction: '是否到用户flag变更',
      actionValue: "\u662F\u5426\u5230\u7528\u6237\u626E\u6F14flag\u53D8\u66F4\uFF0C\u5F53\u524D\u5230\u7528\u6237\u4E86\u5417\uFF1F".concat(isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current)
    });

    if (isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current) {
      autoStartTape();
    } // eslint-disable-next-line

  }, [isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current]);
  return {
    isTaping: isTapingRef.current,
    autoStartTape: autoStartTape,
    pauseTape: pauseTape
  };
};

var REDRAW_TIME = 200;

var useAutoScroll = function useAutoScroll(containerRef, // eslint-disable-next-line
deps) {
  useEffect(function () {
    setTimeout(function () {
      var domWrapper = containerRef.current;
      var scrollHeight = domWrapper === null || domWrapper === void 0 ? void 0 : domWrapper.scrollHeight;

      if (!exit(scrollHeight) || !exit(domWrapper)) {
        return;
      }

      domWrapper.scrollTop = scrollHeight;
    }, REDRAW_TIME); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);
};

var style$M = {"dialog":"tangram_C_dialog_87e904bc21","profile":"tangram_C_profile_87e904bc21","content":"tangram_C_content_87e904bc21","name":"tangram_C_name_87e904bc21","bubble":"tangram_C_bubble_87e904bc21"};

var EDirection;

(function (EDirection) {
  EDirection["LEFT"] = "ltr";
  EDirection["RIGHT"] = "rtl";
})(EDirection || (EDirection = {}));

var Dialog = function Dialog(props) {
  var name = props.name,
      profile = props.profile,
      text = props.text,
      direction = props.direction,
      bgColor = props.bgColor;
  return /*#__PURE__*/React.createElement("div", {
    className: style$M.dialog
  }, /*#__PURE__*/React.createElement("img", {
    className: style$M.profile,
    src: profile,
    alt: "profile"
  }), /*#__PURE__*/React.createElement("div", {
    className: style$M.content,
    style: {
      marginRight: direction === EDirection.LEFT ? 0 : '12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style$M.name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: style$M.bubble,
    style: {
      borderRadius: direction === EDirection.LEFT ? '4px 25px 25px 25px' : '25px 4px 25px 25px',
      backgroundColor: bgColor ? bgColor : '#fff',
      color: bgColor ? '#fff' : '#15171a'
    }
  }, /*#__PURE__*/React.createElement("p", null, text))));
};

var img$8 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='68px' height='68px' viewBox='0 0 68 68' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e%e5%bd%95%e9%9f%b3-%e4%b8%8d%e5%8f%af%e7%82%b9%3c/title%3e %3cg id='%e9%a1%b5%e9%9d%a2-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%9f%b3%e9%a2%91%e7%8a%b6%e6%80%81' transform='translate(-143.000000%2c -451.000000)'%3e %3cg id='%e9%9f%b3%e9%a2%91%e7%bb%84%e4%bb%b6%e5%a4%87%e4%bb%bd-2' transform='translate(67.000000%2c 451.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3-%e4%b8%8d%e5%8f%af%e7%82%b9' transform='translate(76.000000%2c 0.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' fill='%23E0E6EB' cx='34' cy='34' r='34'%3e%3c/circle%3e %3cg id='%e7%bc%96%e7%bb%84-5' transform='translate(21.000000%2c 15.000000)'%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='white' stroke-width='2' fill='white' x='6' y='1' width='14' height='24' rx='7'%3e%3c/rect%3e %3cpath d='M26%2c15 C26%2c15.5300771 26%2c16.4305104 26%2c17.7012997 C26%2c25.0459691 20.1797017%2c31 13%2c31 C5.82029825%2c31 0%2c25.0459691 0%2c17.7012997 C0%2c16.4305104 0%2c15.5300771 0%2c15' id='%e8%b7%af%e5%be%84' stroke='white' stroke-width='3' stroke-linecap='round'%3e%3c/path%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' x='12' y='30' width='3' height='8' rx='1.5'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var style$L = {"tape-content":"tangram_C_tape-content_07e4f9b04d","label":"tangram_C_label_07e4f9b04d","text":"tangram_C_text_07e4f9b04d","tape-btn":"tangram_C_tape-btn_07e4f9b04d"};

var DEFAULT_TIME_LIMIT$1 = 45;

var TapeContent = function TapeContent() {
  var _a = useContext(CosplayContext),
      myLinesRef = _a.myLinesRef,
      isMyRoleRef = _a.isMyRoleRef,
      tapeBtnRef = _a.tapeBtnRef,
      isTaping = _a.isTaping;

  return /*#__PURE__*/React.createElement("div", {
    className: style$L['tape-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$L.text
  }, /*#__PURE__*/React.createElement("div", {
    className: style$L.label
  }, "\u63D0\u8BCD\u5668"), myLinesRef === null || myLinesRef === void 0 ? void 0 : myLinesRef.current), /*#__PURE__*/React.createElement("div", {
    ref: tapeBtnRef,
    className: style$L['tape-btn'],
    "data-content": isTaping ? '录音中' : '开始录音'
  }, /*#__PURE__*/React.createElement(Progress, {
    circleWidth: 60,
    playing: isTaping ? 1 : 0,
    ringColor: "#ff3741",
    duration: isTaping ? DEFAULT_TIME_LIMIT$1 : 0,
    backgroundImage: (isMyRoleRef === null || isMyRoleRef === void 0 ? void 0 : isMyRoleRef.current) ? isTaping ? img$d : img$e : img$8
  })));
};

var style$K = {"chat-content":"tangram_C_chat-content_4f02b240e0"};

var ChatContent = function ChatContent() {
  var _a;

  var conversationsRef = useContext(CosplayContext).conversationsRef;
  return /*#__PURE__*/React.createElement("div", {
    className: style$K['chat-content']
  }, (_a = conversationsRef === null || conversationsRef === void 0 ? void 0 : conversationsRef.current) === null || _a === void 0 ? void 0 : _a.map(function (conversation) {
    return conversation.state === EConversationState.PLAYING || conversation.state === EConversationState.PLAYED || conversation.state === EConversationState.PAUSED ? /*#__PURE__*/React.createElement("div", {
      key: conversation.conversationId,
      style: {
        direction: conversation.isMyRole ? EDirection.RIGHT : EDirection.LEFT
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      profile: conversation.file,
      name: conversation.name,
      text: conversation.original,
      bgColor: conversation.isMyRole ? '#0D90FF' : '',
      direction: conversation.isMyRole ? EDirection.RIGHT : EDirection.LEFT
    })) : null;
  }));
};

var style$J = {"progress-bar-outer":"tangram_C_progress-bar-outer_93f0505c61","progress-bar-inner":"tangram_C_progress-bar-inner_93f0505c61","progress-completed-part":"tangram_C_progress-completed-part_93f0505c61","progress-bar-text":"tangram_C_progress-bar-text_93f0505c61"};

function validProgress(current, total) {
  if (typeof current !== 'number' || typeof total !== 'number' || total === 0) {
    return 0;
  }

  var res = current / total;

  if (res > 1) {
    return 100;
  }

  return res * 100;
}

var ProgressBar = function ProgressBar(props) {
  var _a = props.completedBg,
      completedBg = _a === void 0 ? '#1890ff' : _a,
      _b = props.barBg,
      barBg = _b === void 0 ? '#f5f5f5' : _b,
      _c = props.current,
      current = _c === void 0 ? 0 : _c,
      _d = props.total,
      total = _d === void 0 ? 0 : _d;
  var completedStyle = {
    width: "".concat(validProgress(current, total), "%"),
    background: completedBg
  };
  var barStyle = {
    background: barBg
  };
  return /*#__PURE__*/React.createElement("div", {
    className: style$J['progress-bar-outer'],
    style: barStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: style$J['progress-bar-inner']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$J['progress-completed-part'],
    style: completedStyle
  })));
};

var addMyRole = function addMyRole(conversations, roleWeightList, playTime) {
  var _a;

  var currentRoleId = exit(playTime) && ((_a = roleWeightList === null || roleWeightList === void 0 ? void 0 : roleWeightList[playTime - 1]) === null || _a === void 0 ? void 0 : _a.roleId);
  return conversations === null || conversations === void 0 ? void 0 : conversations.map(function (conversation) {
    return _assign$4(_assign$4({}, conversation), {
      isMyRole: conversation.roleId === currentRoleId
    });
  });
};

var style$I = {"main":"tangram_C_main_4ea64a4604","progress-bar":"tangram_C_progress-bar_4ea64a4604","bottom":"tangram_C_bottom_4ea64a4604","pause-container":"tangram_C_pause-container_4ea64a4604","cheer":"tangram_C_cheer_4ea64a4604","pause-btn":"tangram_C_pause-btn_4ea64a4604","cosplay-container":"tangram_C_cosplay-container_4ea64a4604","mask":"tangram_C_mask_4ea64a4604","mask-content":"tangram_C_mask-content_4ea64a4604"};

var CosplayContext = /*#__PURE__*/createContext({});

var Bottom = function Bottom(props) {
  var hasMyRoleLeft = props.hasMyRoleLeft,
      isFinished = props.isFinished,
      handlePause = props.handlePause;

  var pauseFragment = function pauseFragment() {
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: style$I['pause-btn'],
      onClick: handlePause
    }, /*#__PURE__*/React.createElement("img", {
      src: img$a,
      alt: "\u6682\u505C"
    }), /*#__PURE__*/React.createElement("p", null, "\u6682\u505C"));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, hasMyRoleLeft ? /*#__PURE__*/React.createElement("div", {
    className: style$I.bottom
  }, /*#__PURE__*/React.createElement("div", {
    className: style$I['pause-container']
  }, pauseFragment()), /*#__PURE__*/React.createElement(TapeContent, null)) : isFinished ? null : /*#__PURE__*/React.createElement("div", {
    className: style$I.bottom
  }, /*#__PURE__*/React.createElement("div", {
    className: style$I['pause-container']
  }, pauseFragment())));
};
/**
 * @author chenbaijin
 * @desp 组件总设文档：https://wiki.baijia.com/pages/viewpage.action?pageId=110651136
 */


var Cosplay = function Cosplay(props) {
  var tapeBtnRef = useRef(null);

  var _a = useRefState(EPageState.PLAYING),
      pageStateRef = _a[0],
      setPageState = _a[1];

  var pageState = pageStateRef.current;
  var scrollContainerRef = useRef(null);
  var roleList = props.roleList,
      playTime = props.playTime,
      onFinish = props.onFinish,
      stopFuncRef = props.stopFuncRef,
      recoverFuncRef = props.recoverFuncRef; // eslint-disable-next-line react/destructuring-assignment

  var conversations = addMyRole(props.conversations, roleList, playTime); // console.log(conversations, 'conversations===');

  useEffect(function () {
    footPrintSecondaryReport({
      actionValue: "\u8FDB\u5165\u89D2\u8272\u626E\u6F14\u7EC4\u4EF6-\u89D2\u8272\u626E\u6F14\u6E90\u6570\u636E\n                conversations: ".concat(JSON.stringify(props.conversations), "\n                roleList: ").concat(JSON.stringify(roleList), "\n                playTime: ").concat(playTime, "\n            ")
    });
    footPrintDetailReport({
      actionValue: "\u89D2\u8272\u626E\u6F14\u7EC4\u4EF6\u9886\u57DF\u5185\u5BF9\u8BDD\u72B6\u6001\u6570\u636E\uFF1A".concat(conversations),
      detailAction: '组件详细数据'
    }); // eslint-disable-next-line
  }, []);

  var _b = useSchedule({
    conversations: conversations,
    onFinish: onFinish,
    playTime: playTime,
    pageStateRef: pageStateRef
  }),
      conversationsRef = _b.conversationsRef,
      scheduleIdxRef = _b.scheduleIdxRef,
      myLinesRef = _b.myLinesRef,
      isMyRoleRef = _b.isMyRoleRef,
      setSchedudleIdx = _b.setSchedudleIdx,
      setConversations = _b.setConversations,
      hasMyRoleLeft = _b.hasMyRoleLeft,
      stopCurrentAudio = _b.stopCurrentAudio,
      recoverPauseAudio = _b.recoverPauseAudio,
      progressIdx = _b.progressIdx,
      setProgressIdx = _b.setProgressIdx,
      isFinished = _b.isFinished;

  useAutoScroll(scrollContainerRef, conversationsRef === null || conversationsRef === void 0 ? void 0 : conversationsRef.current);

  function handleFinished(payload) {
    return __awaiter$2(this, void 0, void 0, function () {
      var dataResult, _a, res, error;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            // 结束的时候立即置为false，避免录制结束后、计算下个角色是否为自己前状态异常
            isMyRoleRef.current = false;
            dataResult = payload.dataResult;
            footPrintSecondaryReport({
              actionValue: '响应录制结束事件'
            });
            return [4
            /*yield*/
            , uploadObject(dataResult)];

          case 1:
            _a = _b.sent(), res = _a[0], error = _a[1];

            if (res) {
              setConversations === null || setConversations === void 0 ? void 0 : setConversations(function (conversations) {
                var _a; // console.log(conversations, scheduleIdxRef?.current, conversations?.[scheduleIdxRef?.current]?.state, '播放结束的状态没有同步');


                if (exit(scheduleIdxRef) && exit(scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current) && ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state)) {
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].state = EConversationState.PLAYED;
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].dataResultJsonUrl = "".concat(res.prefix).concat(res.url);
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].overall = dataResult.overall;
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].userRecordingUrl = dataResult.url;
                }

                return conversations ? __spreadArray([], conversations, true) : conversations;
              });
              setTimeout(function () {
                (conversations === null || conversations === void 0 ? void 0 : conversations.length) && (setSchedudleIdx === null || setSchedudleIdx === void 0 ? void 0 : setSchedudleIdx(function (scheduleIdx) {
                  return Math.min(scheduleIdx + 1, conversations.length);
                }));
              }, 1000);
              (conversations === null || conversations === void 0 ? void 0 : conversations.length) && setProgressIdx(function (idx) {
                return Math.min(idx + 1, conversations.length);
              });
            } else if (error) {
              setConversations === null || setConversations === void 0 ? void 0 : setConversations(function (conversations) {
                var _a; // console.log(conversations, scheduleIdxRef?.current, conversations?.[scheduleIdxRef?.current]?.state, '播放结束的状态没有同步');


                if (exit(scheduleIdxRef) && exit(scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current) && ((_a = conversations === null || conversations === void 0 ? void 0 : conversations[scheduleIdxRef.current]) === null || _a === void 0 ? void 0 : _a.state)) {
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].state = EConversationState.PLAYED;
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].dataResultJsonUrl = '';
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].overall = dataResult.overall;
                  conversations[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current].userRecordingUrl = dataResult.url;
                }

                return conversations ? __spreadArray([], conversations, true) : conversations;
              });
              setTimeout(function () {
                (conversations === null || conversations === void 0 ? void 0 : conversations.length) && (setSchedudleIdx === null || setSchedudleIdx === void 0 ? void 0 : setSchedudleIdx(function (scheduleIdx) {
                  return Math.min(scheduleIdx + 1, conversations.length);
                }));
              }, 1000);
              (conversations === null || conversations === void 0 ? void 0 : conversations.length) && setProgressIdx(function (idx) {
                return Math.min(idx + 1, conversations.length);
              });
              footPrintJSErrorReport({
                actionValue: "\u4E0A\u4F20\u6587\u4EF6\u63A5\u53E3\u5F02\u5E38, ".concat(error)
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }

  var _c = useTape(tapeBtnRef, myLinesRef, isMyRoleRef, handleFinished),
      isTaping = _c.isTaping,
      autoStartTape = _c.autoStartTape,
      pauseTape = _c.pauseTape; // console.log(hasMyRoleLeft, 'hasMyRoleLeft===');


  function handlePause() {
    footPrintSecondaryReport({
      actionValue: "\u63D0\u4F9B\u7ED9C\u7AEF\u7684\u6E05\u7406\u5F55\u97F3\u3001\u97F3\u9891\u64AD\u653E\u7684\u51FD\u6570\u88AB\u6267\u884C,\n                \u5F53\u524D\u9875\u9762\u72B6\u6001\u4E3A\uFF1A".concat(pageState, "\n            ")
    });

    if (pageState === EPageState.PLAYING) {
      setPageState(EPageState.PAUSED);
      pageStateRef.current = EPageState.PAUSED;
      pauseTape();
      stopCurrentAudio();
    }
  }

  function handleRecover() {
    var _a;

    var currentConversation = (_a = conversationsRef.current) === null || _a === void 0 ? void 0 : _a[scheduleIdxRef === null || scheduleIdxRef === void 0 ? void 0 : scheduleIdxRef.current];
    footPrintSecondaryReport({
      actionValue: "\u63D0\u4F9B\u7ED9C\u7AEF\u7684\u6062\u590D\u626E\u6F14\u51FD\u6570\u88AB\u6267\u884C,\n                \u5F53\u524D\u662F\u6211\u7684\u89D2\u8272\u5417\uFF1A".concat(currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.isMyRole, "\n            ")
    });

    if (!(currentConversation === null || currentConversation === void 0 ? void 0 : currentConversation.isMyRole)) {
      recoverPauseAudio();
    }

    setPageState(EPageState.PLAYING);
  }

  if (stopFuncRef === null || stopFuncRef === void 0 ? void 0 : stopFuncRef.current) {
    stopFuncRef.current = handlePause;
  }

  if (recoverFuncRef === null || recoverFuncRef === void 0 ? void 0 : recoverFuncRef.current) {
    recoverFuncRef.current = handleRecover;
  }

  useBlurEvent(function () {
    footPrintSecondaryReport({
      actionValue: '失焦事件，用户可能执行了切后台动作'
    });
    setPageState(EPageState.PAUSED);
    pauseTape();
    stopCurrentAudio();
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CosplayContext.Provider, {
    value: _assign$4(_assign$4({}, props), {
      conversations: conversations,
      conversationsRef: conversationsRef,
      scheduleIdxRef: scheduleIdxRef,
      myLinesRef: myLinesRef,
      isMyRoleRef: isMyRoleRef,
      setSchedudleIdx: setSchedudleIdx,
      setConversations: setConversations,
      isTaping: isTaping,
      autoStartTape: autoStartTape,
      pauseTape: pauseTape,
      tapeBtnRef: tapeBtnRef
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: style$I['cosplay-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$I['progress-bar']
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    current: progressIdx,
    total: conversations === null || conversations === void 0 ? void 0 : conversations.length
  })), /*#__PURE__*/React.createElement("div", {
    ref: scrollContainerRef,
    className: style$I.main
  }, /*#__PURE__*/React.createElement(ChatContent, null)), /*#__PURE__*/React.createElement(Bottom, {
    handlePause: handlePause,
    isFinished: isFinished,
    pageState: pageState,
    hasMyRoleLeft: hasMyRoleLeft
  }), pageState === EPageState.PAUSED ? /*#__PURE__*/React.createElement("div", {
    className: style$I.mask
  }, /*#__PURE__*/React.createElement("div", {
    className: style$I['mask-content']
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://i.gsxcdn.com/1396512864_4z3v27v7.png",
    alt: "cheer",
    width: 140
  }), /*#__PURE__*/React.createElement("p", null, "\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u7EE7\u7EED!"), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: style$I['pause-btn'],
    onClick: handleRecover
  }, /*#__PURE__*/React.createElement("img", {
    src: img$9,
    alt: "\u7EE7\u7EED"
  }), /*#__PURE__*/React.createElement("p", null, "\u7EE7\u7EED")))) : null)));
};

// 作答模式
var PRACTICE_MODE;

(function (PRACTICE_MODE) {
  // 作答模式
  PRACTICE_MODE["pratice"] = "pratice"; // 自评模式

  PRACTICE_MODE["evaluation"] = "evaluation"; // 解析模式

  PRACTICE_MODE["analysis"] = "analysis"; // 背题模式

  PRACTICE_MODE["recite"] = "recite"; // 核心内容展示模式（仅展示题干选项，不可作答）

  PRACTICE_MODE["coreDisplay"] = "coreDisplay"; // 订正模式-作答

  PRACTICE_MODE["revising"] = "revising";
})(PRACTICE_MODE || (PRACTICE_MODE = {}));

var ESwitchType;

(function (ESwitchType) {
  ESwitchType[ESwitchType["swiper"] = 0] = "swiper";
  ESwitchType[ESwitchType["button"] = 1] = "button";
})(ESwitchType || (ESwitchType = {}));

var EPlatForm;

(function (EPlatForm) {
  EPlatForm[EPlatForm["app"] = 1] = "app";
  EPlatForm[EPlatForm["pc"] = 2] = "pc";
})(EPlatForm || (EPlatForm = {}));

var ERecordStatus;

(function (ERecordStatus) {
  ERecordStatus[ERecordStatus["unSubmit"] = 10] = "unSubmit";
  ERecordStatus[ERecordStatus["halfSubmit"] = 15] = "halfSubmit";
  ERecordStatus[ERecordStatus["unCorrect"] = 20] = "unCorrect";
  ERecordStatus[ERecordStatus["revising"] = 30] = "revising";
  ERecordStatus[ERecordStatus["rejected"] = 35] = "rejected";
  ERecordStatus[ERecordStatus["passed"] = 40] = "passed";
  ERecordStatus[ERecordStatus["submit"] = 70] = "submit";
  ERecordStatus[ERecordStatus["unEvaluation"] = 80] = "unEvaluation";
})(ERecordStatus || (ERecordStatus = {}));

var EDisplayType;

(function (EDisplayType) {
  EDisplayType[EDisplayType["EDisplayPage"] = 0] = "EDisplayPage";
  EDisplayType[EDisplayType["EDisplayModule"] = 1] = "EDisplayModule";
})(EDisplayType || (EDisplayType = {}));

var base64 = createCommonjsModule(function (module, exports) {

  (function (root) {
    // Detect free variables `exports`.
    var freeExports = exports; // Detect free variable `module`.

    var freeModule = module && module.exports == freeExports && module; // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.

    var freeGlobal = _typeof$1(commonjsGlobal) == 'object' && commonjsGlobal;

    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }
    /*--------------------------------------------------------------------------*/


    var InvalidCharacterError = function InvalidCharacterError(message) {
      this.message = message;
    };

    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';

    var error = function error(message) {
      // Note: the error messages used throughout this file match those used by
      // the native `atob`/`btoa` implementation in Chromium.
      throw new InvalidCharacterError(message);
    };

    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // http://whatwg.org/html/common-microsyntaxes.html#space-character

    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g; // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396

    var decode = function decode(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
      var length = input.length;

      if (length % 4 == 0) {
        input = input.replace(/==?$/, '');
        length = input.length;
      }

      if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(input)) {
        error('Invalid character: the string to be decoded is not correctly encoded.');
      }

      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = '';
      var position = -1;

      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer; // Unless this is the first of a group of 4 characters…

        if (bitCounter++ % 4) {
          // …convert the first 8 bits to a single ASCII character.
          output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
      }

      return output;
    }; // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa


    var encode = function encode(input) {
      input = String(input);

      if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
      }

      var padding = input.length % 3;
      var output = '';
      var position = -1;
      var a;
      var b;
      var c;
      var buffer; // Make sure any padding is handled outside of the loop.

      var length = input.length - padding;

      while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c; // Turn the 24 bits into four chunks of 6 bits each, and append the
        // matching character for each of them to the output.

        output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
      }

      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
      }

      return output;
    };

    var base64 = {
      'encode': encode,
      'decode': decode,
      'version': '1.0.0'
    }; // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:

    if (freeExports && !freeExports.nodeType) {
      if (freeModule) {
        // in Node.js or RingoJS v0.8.0+
        freeModule.exports = base64;
      } else {
        // in Narwhal or RingoJS v0.7.0-
        for (var key in base64) {
          base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
        }
      }
    } else {
      // in Rhino or a web browser
      root.base64 = base64;
    }
  })(commonjsGlobal);
});

/* eslint-disable multiline-comment-style */
/**
 * 获取改动过答案题目的答案列表
 * @param {questionList} 题目列表
 * @param {questionId} 可选，若指定，则只返回对应题目的答案
 * @return IUserAnswerDetailDTO[]
*/

function getAnswers(questionList, questionId, all) {
  var _a, _b, _c, _d, _e;

  if (all === void 0) {
    all = false;
  }

  function refillChildrenAnswer(children, answer, evaluation) {
    var _a, _b;

    var childrenLen = children === null || children === void 0 ? void 0 : children.length;
    var answerLen = answer === null || answer === void 0 ? void 0 : answer.length;

    if (childrenLen && answerLen && childrenLen === answerLen) {
      var refilledChildItemList = __spreadArray([], answer, true);

      for (var i = 0; i < children.length; i++) {
        var _c = children[i] || {},
            questionVersion = _c.questionVersion,
            logicTypeId = _c.logicTypeId,
            subjectId = _c.subjectId;

        var _d = (evaluation === null || evaluation === void 0 ? void 0 : evaluation[i]) || {},
            correctType = _d.correctType,
            extendConfig = _d.extendConfig;

        refilledChildItemList[i] = _assign$4(_assign$4({}, answer[i]), {
          subjectId: subjectId,
          logicTypeId: logicTypeId,
          questionVersion: questionVersion,
          correctType: (_b = (_a = answer[i]) === null || _a === void 0 ? void 0 : _a.correctType) !== null && _b !== void 0 ? _b : correctType,
          extendConfig: extendConfig
        });
      }

      return refilledChildItemList;
    }

    return answer;
  }

  if (questionId) {
    var targetQuestion = questionList.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.questionInfoDTO.questionId) === questionId;
    });
    var targetChildren = (_a = targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList;
    var targetChildrenAnswer = (_b = targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.userAnswerDetailDTOList[0]) === null || _b === void 0 ? void 0 : _b.childItemList;
    var targetChildEvaluation = (_c = targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.evaluationQuestionConfigVO) === null || _c === void 0 ? void 0 : _c.childEvaluationQuestionConfigVOList;
    var refilledChildItemList = refillChildrenAnswer(targetChildren, targetChildrenAnswer, targetChildEvaluation);

    var _f = (targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.questionInfoDTO) || {},
        subjectId = _f.subjectId,
        logicTypeId = _f.logicTypeId,
        questionVersion = _f.questionVersion;

    var correctType = ((targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.evaluationQuestionConfigVO) || {}).correctType;
    return [_assign$4(_assign$4({}, targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.userAnswerDetailDTOList[0]), {
      subjectId: subjectId,
      logicTypeId: logicTypeId,
      questionVersion: questionVersion,
      childItemList: refilledChildItemList,
      correctType: (_e = (_d = targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.userAnswerDetailDTOList[0]) === null || _d === void 0 ? void 0 : _d.correctType) !== null && _e !== void 0 ? _e : correctType
    })];
  }

  return questionList.filter(function (item) {
    return all || (item === null || item === void 0 ? void 0 : item.isModified);
  }).map(function (item) {
    var _a, _b, _c, _d, _e;

    var _f = (item === null || item === void 0 ? void 0 : item.questionInfoDTO) || {},
        subjectId = _f.subjectId,
        logicTypeId = _f.logicTypeId,
        questionVersion = _f.questionVersion;

    var _g = (item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) || {},
        correctType = _g.correctType,
        extendConfig = _g.extendConfig;

    var children = (_a = item === null || item === void 0 ? void 0 : item.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList;
    var answer = (_b = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0]) === null || _b === void 0 ? void 0 : _b.childItemList;
    var evaluation = (_c = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _c === void 0 ? void 0 : _c.childEvaluationQuestionConfigVOList;
    var refilledChildItemList = refillChildrenAnswer(children, answer, evaluation); // console.log('refilled:', refilledChildItemList);

    return _assign$4(_assign$4({}, item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0]), {
      subjectId: subjectId,
      logicTypeId: logicTypeId,
      questionVersion: questionVersion,
      childItemList: refilledChildItemList,
      correctType: (_e = (_d = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0]) === null || _d === void 0 ? void 0 : _d.correctType) !== null && _e !== void 0 ? _e : correctType,
      extendConfig: extendConfig
    });
  });
}
/**
 * 获取作答总时长
 * @param {questionList} 题目列表
 * @return totalSpendTime
*/


function getTotalSpendTime(questionList) {
  var totalSpendTime = 0;
  questionList.forEach(function (item) {
    var _a, _b;

    totalSpendTime += +(((_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0]) === null || _a === void 0 ? void 0 : _a.spendTime) || 0);
    (_b = (item === null || item === void 0 ? void 0 : item.isModified) ? item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0].childItemList : item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0].childQuestionList) === null || _b === void 0 ? void 0 : _b.forEach(function (child) {
      totalSpendTime += +((child === null || child === void 0 ? void 0 : child.spendTime) || 0);
    });
  });
  return totalSpendTime;
}
/**
 * 根据题目id获取题号
 * @param {questionList} 题目列表
 * @param {questionId} 题目/母题id
 * @param {childQuestionId} 子题id
 * @return questionIndex 题目/母题序号，childQuestionIndex 子题序号
*/


function getQuestionIndex(questionList, questionId, childQuestionId) {
  var _a, _b, _c;

  var idx = questionList.findIndex(function (q) {
    var _a;

    return ((_a = q === null || q === void 0 ? void 0 : q.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.questionId) === questionId;
  });
  var childIdx = (_c = (_b = (_a = questionList[idx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO.childrenQuestionList) === null || _b === void 0 ? void 0 : _b.findIndex(function (childQ) {
    return (childQ === null || childQ === void 0 ? void 0 : childQ.questionId) === childQuestionId;
  })) !== null && _c !== void 0 ? _c : -1;
  return {
    questionIndex: idx >= 0 ? idx + 1 : null,
    childQuestionIndex: childIdx >= 0 ? childIdx + 1 : null
  };
} // 判断题目是否正确
// @param status 答题状态
// @return 是否正确


var isRightQuestion = function isRightQuestion(status) {
  return status && [EAnswerStatus.RIGHT, EAnswerStatus.BASIC_Right].includes(status);
}; // 判断评测本次作答是否包含统一作答题目
// @param questionList 题目列表
// @return 本次作答是否包含统一作答题目

function isUnifyEvaluation(questionList, mode) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  if (!questionList.length || mode && ![PRACTICE_MODE.revising, PRACTICE_MODE.pratice].includes(mode)) {
    return false;
  }

  var isRevision = mode === PRACTICE_MODE.revising;
  var list = questionList;
  var version = list === null || list === void 0 ? void 0 : list.reduce(function (pre, cur) {
    var _a;

    return Math.max(pre, ((_a = cur === null || cur === void 0 ? void 0 : cur.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) || 0);
  }, 0);

  for (var i = 0; i < list.length; i++) {
    if (((_b = (_a = list[i]) === null || _a === void 0 ? void 0 : _a.userAnswerDetailDTOList) === null || _b === void 0 ? void 0 : _b.length) === version) {
      var userAnswer = (_c = list[i]) === null || _c === void 0 ? void 0 : _c.userAnswerDetailDTOList[0];

      if ((_d = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _d === void 0 ? void 0 : _d.length) {
        for (var j = 0; j < ((_e = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _e === void 0 ? void 0 : _e.length); ++j) {
          // 复合题需要过滤掉订正模式中正确的子题
          // 复合题需要确认最新的userAnswer是否是最新提交的
          var questionAnswerVersion = (userAnswer.childItemList[j] || {}).questionAnswerVersion;

          if (((_j = (_h = (_g = (_f = list[i]) === null || _f === void 0 ? void 0 : _f.evaluationQuestionConfigVO) === null || _g === void 0 ? void 0 : _g.childEvaluationQuestionConfigVOList) === null || _h === void 0 ? void 0 : _h[j]) === null || _j === void 0 ? void 0 : _j.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && isRightQuestion((_k = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _k === void 0 ? void 0 : _k.status)) && (typeof questionAnswerVersion === 'undefined' || questionAnswerVersion >= version)) {
            return true;
          }
        }
      }

      if (((_m = (_l = list[i]) === null || _l === void 0 ? void 0 : _l.evaluationQuestionConfigVO) === null || _m === void 0 ? void 0 : _m.answerMode) === EAnswerMode.UNIFIED) {
        return true;
      }
    }
  }

  return false;
} // 获取统一作答项列表
// @param questionList 题目列表
// @return 统一作答项列表

function getUnifidItems(questionList, mode) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;

  if (!questionList.length || mode && ![PRACTICE_MODE.revising, PRACTICE_MODE.pratice].includes(mode)) {
    return [];
  }

  var isRevision = mode === PRACTICE_MODE.revising;
  var version = questionList === null || questionList === void 0 ? void 0 : questionList.reduce(function (pre, cur) {
    var _a;

    return Math.max(pre, ((_a = cur === null || cur === void 0 ? void 0 : cur.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) || 0);
  }, 0);

  for (var i = 0; i < questionList.length; i++) {
    if (((_b = (_a = questionList[i]) === null || _a === void 0 ? void 0 : _a.userAnswerDetailDTOList) === null || _b === void 0 ? void 0 : _b.length) === version) {
      var userAnswer = (_c = questionList[i]) === null || _c === void 0 ? void 0 : _c.userAnswerDetailDTOList[0];

      if ((_d = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _d === void 0 ? void 0 : _d.length) {
        for (var j = 0; j < ((_e = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _e === void 0 ? void 0 : _e.length); ++j) {
          var questionAnswerVersion = (((_f = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _f === void 0 ? void 0 : _f[j]) || {}).questionAnswerVersion;

          if (((_k = (_j = (_h = (_g = questionList[i]) === null || _g === void 0 ? void 0 : _g.evaluationQuestionConfigVO) === null || _h === void 0 ? void 0 : _h.childEvaluationQuestionConfigVOList) === null || _j === void 0 ? void 0 : _j[j]) === null || _k === void 0 ? void 0 : _k.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && isRightQuestion((_l = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _l === void 0 ? void 0 : _l.status)) && (typeof questionAnswerVersion === 'undefined' || questionAnswerVersion >= version)) {
            return ((_o = (_m = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _m === void 0 ? void 0 : _m.itemBaseList) === null || _o === void 0 ? void 0 : _o.filter(function (item) {
              return item.answerMode === EAnswerMode.UNIFIED;
            })) || [];
          }
        }
      }

      if (((_q = (_p = questionList[i]) === null || _p === void 0 ? void 0 : _p.evaluationQuestionConfigVO) === null || _q === void 0 ? void 0 : _q.answerMode) === EAnswerMode.UNIFIED) {
        return ((_r = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.itemBaseList) === null || _r === void 0 ? void 0 : _r.filter(function (item) {
          return item.answerMode === EAnswerMode.UNIFIED;
        })) || [];
      }
    }
  }

  return [];
}
/**
 * 获取需要请求的题目id列表
 * @param {id} 需要切入题目的id
 * @param {questionList} 题目列表，长度应与答题卡列表相同
 * @param {answerSheetList} 答题卡列表，长度应与题目列表相同
 * @return 形如{ids: string[], indexs: number[]} 的对象，其中ids表示本次需要请求的题目id列表，indexs：中每个数字对应ids中每个题目在整个试题列表中应插入的位置
*/

function getDemandList(id, questionList, answerSheetList) {
  if (!id || !questionList || !answerSheetList || !questionList.length || !answerSheetList.length) {
    throw new Error('获得请求题目id列表的参数不全或有误');
  }

  if (questionList.length !== answerSheetList.length) {
    throw new Error('题目与答题卡列表长度不匹配');
  } // 预加载数量


  var preLoadNum = 20; // 预加载阈值

  var threshold = 3; // 通过全量的answerSheetList来找当前题所在index。

  var index = answerSheetList.findIndex(function (item) {
    return item.questionId === id;
  }); // 大窗口范围

  var windowBegin = Math.max(index - preLoadNum / 2 + 1, 0);
  var windowEnd = Math.min(index + preLoadNum / 2, questionList.length - 1); // 最小应该有数据的窗口范围
  // 如果该范围内题目数据不存在，则此时请求以index为中心的大窗口范围内的不存在数据的题目

  var thresholdBegin = Math.max(index - threshold, 0);
  var thresholdEnd = Math.min(index + threshold, questionList.length - 1);
  var demandList = [];
  var noDataIdxList = [];
  var noDataList = [];
  var allIds = answerSheetList.map(function (answer) {
    return answer.questionId;
  });
  questionList.forEach(function (question, idx) {
    return !question && noDataIdxList.push(idx);
  });

  if (noDataIdxList.length === 0) {
    return {
      ids: [],
      indexs: []
    };
  }

  noDataIdxList.forEach(function (noDataIdx) {
    return noDataList.push({
      id: allIds[noDataIdx],
      idx: noDataIdx
    });
  });
  var shouldRequest = noDataList.some(function (no) {
    return (no === null || no === void 0 ? void 0 : no.idx) && (no === null || no === void 0 ? void 0 : no.idx) <= thresholdEnd && (no === null || no === void 0 ? void 0 : no.idx) >= thresholdBegin;
  });

  if (shouldRequest) {
    for (var i = 0; i < noDataList.length; i++) {
      if (noDataList[i]) {
        var idx = noDataList[i].idx;

        if (idx >= windowBegin && idx <= windowEnd) {
          demandList.push(noDataList[i]);
          noDataList[i] = void 0;
        }
      }
    }

    if (demandList.length < preLoadNum) {
      for (var _i = 0, noDataList_1 = noDataList; _i < noDataList_1.length; _i++) {
        var no = noDataList_1[_i];

        if (demandList.length === preLoadNum) {
          break;
        }

        if (no) {
          demandList.push(no);
        }
      }
    }

    demandList.sort(function (a, b) {
      return (a === null || a === void 0 ? void 0 : a.idx) - (b === null || b === void 0 ? void 0 : b.idx);
    });
    return {
      ids: demandList.map(function (d) {
        return d === null || d === void 0 ? void 0 : d.id;
      }),
      indexs: demandList.map(function (d) {
        return d === null || d === void 0 ? void 0 : d.idx;
      })
    };
  }

  return {
    ids: [],
    indexs: []
  };
}
/**
 * 切上一题的函数
 * @param {motifIdx} 母题的index
 * @param {questionList} 题目列表
 * @param {childIdx} 子题的index，可选，如果传了该参数，则认为是复合题内切题
 * @return 形如{motifId: string | undefined, childId: string | undefined}对象，其中motifId为大题id，childId为子题id
*/


function goPre(motifIdx, questionList, childIdx) {
  var _a, _b, _c, _d, _e;

  if (motifIdx < 0 || typeof childIdx === 'number' && childIdx < 0) {
    throw new Error('题目序号不合法');
  }

  if (!questionList || !questionList.length) {
    throw new Error('题目列表不能为空');
  }

  if (!((_a = questionList[motifIdx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO)) {
    throw new Error('题目不存在');
  }

  var currentId = (_b = questionList[motifIdx]) === null || _b === void 0 ? void 0 : _b.questionInfoDTO.questionId; // 传入childIdx则认为是在复合题中切题

  if (exist(childIdx) && exist(motifIdx)) {
    var childList = (_d = (_c = questionList[motifIdx]) === null || _c === void 0 ? void 0 : _c.questionInfoDTO) === null || _d === void 0 ? void 0 : _d.childrenQuestionList;

    if (childIdx > 0 && childList) {
      return {
        motifId: currentId,
        childId: childList[childIdx - 1].questionId
      };
    } // 如果是小题的第一题，则切大题


    return goPre(motifIdx, questionList);
  }

  var pre = questionList[motifIdx - 1];

  if (motifIdx > 0 && pre) {
    var _f = pre.questionInfoDTO,
        questionId = _f.questionId,
        childrenQuestionList = _f.childrenQuestionList;
    var childLen = (_e = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) !== null && _e !== void 0 ? _e : 0; // 如果上一题是复合题，则应返回该复合题最后一道子题id

    var childId = childLen > 0 ? childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[childLen - 1].questionId : void 0;
    return {
      motifId: questionId,
      childId: childId
    };
  }

  return {
    motifId: void 0,
    childId: void 0
  };
}
/**
 * 切下一题的函数
 * @param {motifIdx} 母题的index
 * @param {questionList} 题目列表
 * @param {childIdx} 子题的index，可选，如果传了该参数，则认为是复合题内切题
 * @return 形如{motifId: string | undefined, childId: string | undefined}对象，其中motifId为大题id，childId为子题id
*/


function goNext(motifIdx, questionList, childIdx) {
  var _a, _b, _c, _d;

  if (motifIdx < 0 || typeof childIdx === 'number' && childIdx < 0) {
    throw new Error('题目序号不合法');
  }

  if (!questionList || !questionList.length) {
    throw new Error('题目列表不能为空');
  }

  if (!((_a = questionList[motifIdx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO)) {
    throw new Error('题目不存在');
  }

  var currentId = (_b = questionList[motifIdx]) === null || _b === void 0 ? void 0 : _b.questionInfoDTO.questionId; // 传入childIdx则认为是在复合题中切题

  if (exist(childIdx) && exist(motifIdx)) {
    var childList = (_d = (_c = questionList[motifIdx]) === null || _c === void 0 ? void 0 : _c.questionInfoDTO) === null || _d === void 0 ? void 0 : _d.childrenQuestionList;

    if (childList && childIdx < (childList === null || childList === void 0 ? void 0 : childList.length) - 1) {
      return {
        motifId: currentId,
        childId: childList === null || childList === void 0 ? void 0 : childList[childIdx + 1].questionId
      };
    } // 如果是小题的最后一题，则切大题


    return goNext(motifIdx, questionList);
  }

  var next = questionList[motifIdx + 1];

  if (motifIdx < questionList.length - 1 && next) {
    var _e = next.questionInfoDTO,
        questionId = _e.questionId,
        childrenQuestionList = _e.childrenQuestionList; // 如果下一道题是复合题，则应该返回该复合题第一道子题id

    var childId = (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) ? childrenQuestionList[0].questionId : void 0;
    return {
      motifId: questionId,
      childId: childId
    };
  }

  return {
    motifId: void 0,
    childId: void 0
  };
}

function parseResourceJSON(resourceType, resource) {
  if (![ESubmitItemTypes.TEXT, ESubmitItemTypes.OPTION].includes(resourceType) && typeof resource === 'string') {
    switch (resourceType) {
      case ESubmitItemTypes.IMAGE:
        return parseJSON(resource);

      case ESubmitItemTypes.VIDEO:
        return parseJSON(resource);

      case ESubmitItemTypes.AUDIO:
        return parseJSON(resource);

      case ESubmitItemTypes.TEXT_AUTO:
        return parseJSON(resource);

      case ESubmitItemTypes.AUDIOEVALUATE:
        return parseJSON(resource);

      default:
        return resource;
    }
  }

  return resource;
}

function getParsedItemBaseList(itemBaseList) {
  if (!itemBaseList) {
    return [];
  }

  var parsedItemBaseList = [];

  for (var _i = 0, _a = itemBaseList !== null && itemBaseList !== void 0 ? itemBaseList : []; _i < _a.length; _i++) {
    var item = _a[_i];
    var resource = item.resource,
        resourceType = item.resourceType,
        answerMode = item.answerMode,
        _b = item.correctCommentVOList,
        correctCommentVOList = _b === void 0 ? [] : _b;

    if (resource && resourceType) {
      parsedItemBaseList.push({
        resource: parseResourceJSON(resourceType, resource),
        resourceType: resourceType,
        answerMode: answerMode,
        correctCommentVOList: correctCommentVOList.map(function (comment) {
          return _assign$4(_assign$4({}, comment), {
            resource: parseResourceJSON(comment.resourceType, comment.resource)
          });
        })
      });
      continue;
    }

    parsedItemBaseList.push(item);
  }

  return parsedItemBaseList;
}

function deserialization(userAnswerDetailDTOList) {
  var parsedDTOList = [];

  if (userAnswerDetailDTOList && (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.length) > 0) {
    for (var _i = 0, userAnswerDetailDTOList_1 = userAnswerDetailDTOList; _i < userAnswerDetailDTOList_1.length; _i++) {
      var userAnswerDetailDTO = userAnswerDetailDTOList_1[_i];
      var itemBaseList = userAnswerDetailDTO.itemBaseList,
          childQuestionList = userAnswerDetailDTO.childQuestionList,
          childItemList = userAnswerDetailDTO.childItemList;
      var parsedChildQuestionList = [];
      var parsedChildItemList = [];
      var parentParsedItemBaseList = itemBaseList && getParsedItemBaseList(itemBaseList) || [];

      if (childQuestionList && (childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList.length) > 0) {
        for (var _a = 0, childQuestionList_1 = childQuestionList; _a < childQuestionList_1.length; _a++) {
          var child = childQuestionList_1[_a];
          var itemBaseList_1 = child.itemBaseList;
          parsedChildQuestionList.push(_assign$4(_assign$4({}, child), {
            itemBaseList: getParsedItemBaseList(itemBaseList_1)
          }));
        }
      }

      if (childItemList && (childItemList === null || childItemList === void 0 ? void 0 : childItemList.length) > 0) {
        for (var _b = 0, childItemList_1 = childItemList; _b < childItemList_1.length; _b++) {
          var child = childItemList_1[_b];
          var itemBaseList_2 = child.itemBaseList;
          parsedChildItemList.push(_assign$4(_assign$4({}, child), {
            itemBaseList: getParsedItemBaseList(itemBaseList_2)
          }));
        }
      }

      parsedDTOList.push(_assign$4(_assign$4({}, userAnswerDetailDTO), {
        itemBaseList: parentParsedItemBaseList,
        childQuestionList: parsedChildQuestionList,
        childItemList: parsedChildItemList
      }));
    }
  }

  return parsedDTOList;
}
/**
 * 获取错题列表
 * @param questionList 题目列表
 * @param status 题目结果状态列表
 * @param flatten 复合题是否展开
 * @return errorQuestionList
*/


function getRightOrWrongQList(questionList, statusList) {
  if (statusList === void 0) {
    statusList = [EAnswerStatus.LITTLE, EAnswerStatus.WRONG];
  }

  var list = [];
  questionList.forEach(function (item) {
    var _a, _b, _c;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]; // 复合题

    if ((_b = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
      // 复合题是否包含答错的子题
      var flag = (_c = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _c === void 0 ? void 0 : _c.some(function (child) {
        return statusList.includes(child.status);
      }); // 复合题包含答错的子题， 复合题加入列表中

      flag && list.push(item);
    } // 单题错题
    else if ((lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) && statusList.includes(lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status)) {
      list.push(item);
    }
  });
  return list;
}
/**
 * 获取错题个数 - 子题平铺
 * @param questionList 题目列表
 * @param status 题目结果状态列表
 * @return errorQuestionNumber
*/


function getRightOrWrongNumber(questionList, statusList, flatten) {
  if (statusList === void 0) {
    statusList = [EAnswerStatus.LITTLE, EAnswerStatus.WRONG];
  }

  if (flatten === void 0) {
    flatten = true;
  }

  var count = 0;
  questionList.forEach(function (item) {
    var _a, _b, _c, _d;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]; // 复合题

    if ((_b = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
      if (flatten) {
        (_c = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _c === void 0 ? void 0 : _c.forEach(function (child) {
          return statusList.includes(child.status) && ++count;
        });
      } else {
        // 复合题是否包含答错的子题
        var flag = (_d = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _d === void 0 ? void 0 : _d.some(function (child) {
          return statusList.includes(child.status);
        });
        flag && ++count;
      }
    } // 单题错题
    else if ((lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) && statusList.includes(lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status)) {
      ++count;
    }
  });
  return count;
}
/**
 * 获取自评列表
 * @param questionList 题目列表
 * @param evaluationTypes 自评列表
 * @param flatten 复合题是否展开
 * @return evaluationQuestionList
*/


function getEvaluationQList(questionList, version, evaluationTypes) {
  if (evaluationTypes === void 0) {
    evaluationTypes = [ECorrectType.SELF_CORRECT, ECorrectType.SELF_CORRECT_LEVEL];
  }

  var evaluationQuestionList = [];
  questionList.forEach(function (item) {
    var _a, _b, _c, _d, _e, _f;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0];
    var correctType = (_b = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _b === void 0 ? void 0 : _b.correctType; // 复合题

    if ((_c = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _c === void 0 ? void 0 : _c.length) {
      // 是否包含自评题
      var flag = (_d = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _d === void 0 ? void 0 : _d.some(function (child) {
        var _a, _b, _c, _d;

        var childConfigList = (_a = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList;
        var childCorrectType = (_b = childConfigList === null || childConfigList === void 0 ? void 0 : childConfigList.find(function (c) {
          return child.questionId === c.questionId;
        })) === null || _b === void 0 ? void 0 : _b.correctType;
        return (evaluationTypes === null || evaluationTypes === void 0 ? void 0 : evaluationTypes.includes((_d = (_c = child === null || child === void 0 ? void 0 : child.correctType) !== null && _c !== void 0 ? _c : childCorrectType) !== null && _d !== void 0 ? _d : -1)) && (version ? version === (child === null || child === void 0 ? void 0 : child.questionAnswerVersion) : child.status === EAnswerStatus.ANSEWRED || (child === null || child === void 0 ? void 0 : child.status) === EAnswerStatus.NO_EVALUATION);
      });
      flag && evaluationQuestionList.push(item);
    } // 单题自评题
    else if (evaluationTypes.includes((_f = (_e = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.correctType) !== null && _e !== void 0 ? _e : correctType) !== null && _f !== void 0 ? _f : -1) && (version ? version === (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.questionAnswerVersion) : (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.ANSEWRED || (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.NO_EVALUATION)) {
      evaluationQuestionList.push(item);
    }
  });
  return evaluationQuestionList;
} // 需要自评的题目数量 - 默认子题展开


function getEvaluationsNum(questionList, version, evaluationTypes, flatten) {
  if (evaluationTypes === void 0) {
    evaluationTypes = [ECorrectType.SELF_CORRECT, ECorrectType.SELF_CORRECT_LEVEL];
  }

  if (flatten === void 0) {
    flatten = true;
  }

  var count = 0;
  questionList.forEach(function (item) {
    var _a, _b, _c, _d, _e, _f, _g;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0];
    var correctType = (_b = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _b === void 0 ? void 0 : _b.correctType; // 复合题

    if ((_c = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _c === void 0 ? void 0 : _c.length) {
      if (flatten) {
        (_d = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _d === void 0 ? void 0 : _d.forEach(function (child) {
          var _a, _b, _c, _d;

          var childConfigList = (_a = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList;
          var childCorrectType = (_b = childConfigList === null || childConfigList === void 0 ? void 0 : childConfigList.find(function (c) {
            return child.questionId === c.questionId;
          })) === null || _b === void 0 ? void 0 : _b.correctType;
          (evaluationTypes === null || evaluationTypes === void 0 ? void 0 : evaluationTypes.includes((_d = (_c = child === null || child === void 0 ? void 0 : child.correctType) !== null && _c !== void 0 ? _c : childCorrectType) !== null && _d !== void 0 ? _d : -1)) && (version ? version === (child === null || child === void 0 ? void 0 : child.questionAnswerVersion) : (child === null || child === void 0 ? void 0 : child.status) === EAnswerStatus.ANSEWRED || (child === null || child === void 0 ? void 0 : child.status) === EAnswerStatus.NO_EVALUATION) && ++count;
        });
      } else {
        // 是否包含自评题
        var flag = (_e = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _e === void 0 ? void 0 : _e.some(function (child) {
          var _a, _b, _c, _d;

          var childConfigList = (_a = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList;
          var childCorrectType = (_b = childConfigList === null || childConfigList === void 0 ? void 0 : childConfigList.find(function (c) {
            return child.questionId === c.questionId;
          })) === null || _b === void 0 ? void 0 : _b.correctType;
          return (evaluationTypes === null || evaluationTypes === void 0 ? void 0 : evaluationTypes.includes((_d = (_c = child === null || child === void 0 ? void 0 : child.correctType) !== null && _c !== void 0 ? _c : childCorrectType) !== null && _d !== void 0 ? _d : -1)) && (version ? version === (child === null || child === void 0 ? void 0 : child.questionAnswerVersion) : (child === null || child === void 0 ? void 0 : child.status) === EAnswerStatus.ANSEWRED || (child === null || child === void 0 ? void 0 : child.status) === EAnswerStatus.NO_EVALUATION);
        });
        flag && ++count;
      }
    } // 单题自评题
    else if (evaluationTypes.includes((_g = (_f = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.correctType) !== null && _f !== void 0 ? _f : correctType) !== null && _g !== void 0 ? _g : -1) && (version ? version === (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.questionAnswerVersion) : (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.ANSEWRED || (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.NO_EVALUATION)) {
      ++count;
    }
  });
  return count;
} // 自评题作答信息列表-不包含子题，用作提交


function getEvaluationAnswers(questionList, all, version) {
  // 全部自评题主题目
  var evaluationsAnswerList = [];
  questionList.forEach(function (item) {
    var _a, _b, _c, _d;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]; // TODO: IUserAnswerDetailDTO类型定义改为自评的类型定义
    // 复合题

    if ((_b = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
      var childAnswerList_1 = [];
      (_c = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childQuestionList) === null || _c === void 0 ? void 0 : _c.forEach(function (childItem) {
        var _a, _b, _c;

        var childConfigList = (_a = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList;
        var childIdx = (_b = childConfigList === null || childConfigList === void 0 ? void 0 : childConfigList.findIndex(function (c) {
          return childItem.questionId === c.questionId;
        })) !== null && _b !== void 0 ? _b : -1;
        var extendConfig = ((_c = childConfigList === null || childConfigList === void 0 ? void 0 : childConfigList[childIdx]) !== null && _c !== void 0 ? _c : {}).extendConfig;
        var evaluated = childItem.status !== EAnswerStatus.ANSEWRED && (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) !== EAnswerStatus.NO_EVALUATION;
        var shouldSubmitChild = (childItem === null || childItem === void 0 ? void 0 : childItem.correctType) === ECorrectType.SELF_CORRECT && (version ? version === childItem.questionAnswerVersion : evaluated);
        shouldSubmitChild && (!all && evaluated || all) && childAnswerList_1.push(_assign$4(_assign$4(_assign$4({}, childItem), {
          extendConfig: extendConfig,
          // @ts-ignore
          itemBaseList: void 0
        }), all && (childItem.status === EAnswerStatus.NO_EVALUATION || childItem.status === EAnswerStatus.ANSEWRED) ? {
          status: EAnswerStatus.WRONG
        } : {}));
      });
      (childAnswerList_1 === null || childAnswerList_1 === void 0 ? void 0 : childAnswerList_1.length) && evaluationsAnswerList.push(_assign$4(_assign$4({}, lastAnswer), {
        // @ts-ignore
        itemBaseList: void 0,
        childAnswerCommentList: childAnswerList_1
      }));
    } else {
      var extendConfig = ((_d = item === null || item === void 0 ? void 0 : item.evaluationQuestionConfigVO) !== null && _d !== void 0 ? _d : {}).extendConfig;
      var evaluted = (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.NO_EVALUATION || (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === EAnswerStatus.ANSEWRED;
      var shouldSubmit = (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.correctType) === ECorrectType.SELF_CORRECT && (version ? version === (lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.questionAnswerVersion) : evaluted);
      lastAnswer && shouldSubmit && (!all && lastAnswer.status || all) && evaluationsAnswerList.push(_assign$4(_assign$4(_assign$4({}, lastAnswer), {
        extendConfig: extendConfig
      }), all && evaluted ? {
        status: EAnswerStatus.WRONG
      } : {}));
    }
  });
  return evaluationsAnswerList;
} // 自评题未作答题目个数(包含子题)


function getUnEvaluationNumber(questionList) {
  var unEvaluationStatusList = [EAnswerStatus.ANSEWRED, EAnswerStatus.NO_EVALUATION];
  var unEvaluationsList = questionList.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList[0];
  });
  var unAnsweredNum = 0;
  unEvaluationsList.forEach(function (item) {
    var _a, _b, _c; // 复合题


    if ((_a = item === null || item === void 0 ? void 0 : item.childQuestionList) === null || _a === void 0 ? void 0 : _a.length) {
      (_b = item === null || item === void 0 ? void 0 : item.childQuestionList) === null || _b === void 0 ? void 0 : _b.forEach(function (childItem) {
        (unEvaluationStatusList === null || unEvaluationStatusList === void 0 ? void 0 : unEvaluationStatusList.includes(childItem.status)) && unAnsweredNum++;
      });
    } else {
      // @ts-ignore
      (unEvaluationStatusList === null || unEvaluationStatusList === void 0 ? void 0 : unEvaluationStatusList.includes((_c = item === null || item === void 0 ? void 0 : item.status) !== null && _c !== void 0 ? _c : -1)) && unAnsweredNum++;
    }
  });
  return unAnsweredNum;
} // 复合题子题增加 子题维度的作答Map 和 复合题补全最近一次作答记录


function addAnswerMap(questionList, revisingAnalysis) {
  questionList.forEach(function (questionInfo) {
    var _a, _b;

    var _c = questionInfo.userAnswerDetailDTOList,
        userAnswerDetailDTOList = _c === void 0 ? [] : _c;

    var _d = questionInfo.questionInfoDTO,
        _e = _d === void 0 ? {} : _d,
        logicTypeId = _e.logicTypeId,
        _f = _e.childrenQuestionList,
        childrenQuestionList = _f === void 0 ? [] : _f;

    if (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.length) {
      var childAnswerMap_1 = new Map();
      userAnswerDetailDTOList.forEach(function (userAnswerItem, userAnswerIdx) {
        var _a;

        var _b = (userAnswerItem || {}).childQuestionList,
            childQuestionList = _b === void 0 ? [] : _b; // 复合题子题增加 childAnswerMap

        if (childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList.length) {
          var hasAnswered_1 = false;
          childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList.forEach(function (childAnswerItem) {
            // 复合题第一条作答记录
            if (revisingAnalysis && userAnswerIdx === 0 && [EAnswerStatus.ANSEWRED].includes(childAnswerItem === null || childAnswerItem === void 0 ? void 0 : childAnswerItem.status)) {
              hasAnswered_1 = true;
              return;
            }

            var curChildList = childAnswerMap_1.get(childAnswerItem.questionId) || [];
            childAnswerMap_1.set(childAnswerItem.questionId, __spreadArray(__spreadArray([], curChildList, true), [childAnswerItem], false));
          });
          questionInfo && (questionInfo.childAnswerMap = childAnswerMap_1);

          if (revisingAnalysis && hasAnswered_1 && questionInfo) {
            // childQuestionList.splice(0, 1);
            userAnswerDetailDTOList.splice(0, 1);
            questionInfo.userAnswerDetailDTOList = userAnswerDetailDTOList;
          }
        } else if (revisingAnalysis) {
          if (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.length) {
            var status_1 = (_a = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0]) === null || _a === void 0 ? void 0 : _a.status; // 第一条已作答，去掉第一条

            [EAnswerStatus.ANSEWRED].includes(status_1) && userAnswerDetailDTOList.splice(0, 1);
          }

          questionInfo && (questionInfo.userAnswerDetailDTOList = userAnswerDetailDTOList);
        }
      });
    } // 补全子题第一题作答记录
    // 复合题


    if (((_a = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]) && (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length)) {
      // 最近一次作答记录的子题数据
      var childAnswerMap_2 = questionInfo.childAnswerMap;
      var lastItemList_1 = (_b = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0]) === null || _b === void 0 ? void 0 : _b.childQuestionList;
      var newChildItemList_1 = [];
      childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.forEach(function (childItem, childIndex) {
        var _a, _b, _c, _d;

        var lastItemAnswer = (lastItemList_1 === null || lastItemList_1 === void 0 ? void 0 : lastItemList_1.length) ? lastItemList_1.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.questionId) === (childItem === null || childItem === void 0 ? void 0 : childItem.questionId);
        }) : undefined; // 最近一次作答记录中不存在该子题的作答信息， 从childAnswerMap中取最新作答数据进行补全

        if (lastItemAnswer) {
          newChildItemList_1 = __spreadArray(__spreadArray([], newChildItemList_1, true), [lastItemAnswer], false);
        } else {
          var mapLastItemAnswer = (_a = childAnswerMap_2 === null || childAnswerMap_2 === void 0 ? void 0 : childAnswerMap_2.get(childItem === null || childItem === void 0 ? void 0 : childItem.questionId)) === null || _a === void 0 ? void 0 : _a[0];
          console.log('childAnswerMap-2', childAnswerMap_2);

          if (mapLastItemAnswer) {
            newChildItemList_1 = __spreadArray(__spreadArray([], newChildItemList_1, true), [mapLastItemAnswer], false);
          } else {
            // TODO: init 初始子题作答数据
            var initItem = {
              status: EAnswerStatus.UN_ANSWER,
              spendTime: '0',
              itemBaseList: [],
              questionId: childItem.questionId,
              // eslint-disable-next-line max-len
              correctType: logicTypeId === ELogicTypeId.FILL_ON_BLANK ? 0 : (_d = (_c = (_b = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.evaluationQuestionConfigVO) === null || _b === void 0 ? void 0 : _b.childEvaluationQuestionConfigVOList) === null || _c === void 0 ? void 0 : _c[childIndex]) === null || _d === void 0 ? void 0 : _d.correctType
            };
            newChildItemList_1 = __spreadArray(__spreadArray([], newChildItemList_1, true), [initItem], false);
          }
        }
      });
      (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0]) && (userAnswerDetailDTOList[0].childQuestionList = newChildItemList_1);
    }
  });
  return questionList;
}

function initList(rawQuestionList, mode, reinitedQuestionIdList, packageSubmitStatus) {
  if (reinitedQuestionIdList === void 0) {
    reinitedQuestionIdList = [];
  }

  if (packageSubmitStatus === void 0) {
    packageSubmitStatus = ERecordStatus.unSubmit;
  } // 订正状态的解析模式


  var revisingAnalysis = mode === PRACTICE_MODE.analysis && packageSubmitStatus === ERecordStatus.revising;
  var questionList = addAnswerMap(rawQuestionList, revisingAnalysis);

  function reinitUserAnswerDetailDTO(questionInfo, existingUserAnswerDTO, packageSubmitStatus, childrenQuestionList, mode) {
    var _a;

    if (packageSubmitStatus === void 0) {
      packageSubmitStatus = ERecordStatus.unSubmit;
    }

    if (mode === void 0) {
      mode = PRACTICE_MODE.pratice;
    }

    var logicTypeId = questionInfo.questionInfoDTO.logicTypeId;
    var isCompound = childrenQuestionList && (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) > 0;
    var childLength = (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) || 0;
    var reinited = {
      status: EAnswerStatus.UN_ANSWER,
      spendTime: '0',
      itemBaseList: []
    };

    function initChildItems(childLength, childrenQuestionList) {
      var childItems = Array(childLength).fill(void 0).map(function () {
        return {};
      });
      childItems.forEach(function (child, index) {
        var _a, _b, _c;

        child.status = EAnswerStatus.UN_ANSWER;
        child.spendTime = '0';
        child.itemBaseList = [];
        child.questionId = childrenQuestionList[index].questionId; // eslint-disable-next-line max-len

        child.correctType = logicTypeId === ELogicTypeId.FILL_ON_BLANK ? 0 : (_c = (_b = (_a = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.correctType;
      });
      return childItems;
    } // 整组题/卷子处于待自评状态时，需要初始化复合题的childItemList
    // 如果后端数据已经有了childQuestionList，则直接用childQuestionList初始化
    // 否则为每道子题都初始化一个空作答数据


    if ((packageSubmitStatus === ERecordStatus.unEvaluation || packageSubmitStatus === ERecordStatus.unCorrect && mode === PRACTICE_MODE.evaluation) && existingUserAnswerDTO && isCompound && (!existingUserAnswerDTO.childItemList || !existingUserAnswerDTO.childItemList.length)) {
      if (existingUserAnswerDTO.childQuestionList.length > 0) {
        reinited = _assign$4(_assign$4({}, existingUserAnswerDTO), {
          childItemList: existingUserAnswerDTO.childQuestionList,
          selfInited: true
        });
      } else {
        reinited = _assign$4(_assign$4({}, existingUserAnswerDTO), {
          childItemList: initChildItems(childLength, childrenQuestionList),
          selfInited: true
        });
      }

      return reinited;
    } // 整组题/卷子处于半提交状态时，需要重新拿后端返回的childQuestionList初始化childItemList
    // 这个时候，理论上来讲不会存在childQuestionList不存在或者length为0的情况，因为最开始从进入测评页该组题的答案就被初始化了
    // 即使开始做该测评时，初始化失败，或测评结束时提交失败，或页面在环境中不正常退出，再次进入时，也是全新的一套未作答的卷子


    if (existingUserAnswerDTO && isCompound && (packageSubmitStatus === ERecordStatus.halfSubmit || packageSubmitStatus === ERecordStatus.unSubmit // 驳回
    || packageSubmitStatus === ERecordStatus.rejected // 订正+半提交
    || packageSubmitStatus === ERecordStatus.revising && (existingUserAnswerDTO === null || existingUserAnswerDTO === void 0 ? void 0 : existingUserAnswerDTO.status) === EAnswerStatus.ANSEWRED)) {
      reinited = _assign$4(_assign$4({}, existingUserAnswerDTO), {
        childItemList: existingUserAnswerDTO.childQuestionList,
        selfInited: true
      });
      return reinited;
    } // 无作答数据
    // 或
    // 整组题/试卷处于未提交/待订正，并且userAnswerDetailDTOList首项不是已初始化过的
    // 并且当前模式不处于解析态
    // 需要初始化


    var shouldReinit = (!existingUserAnswerDTO || [ERecordStatus.revising // ERecordStatus.rejected,
    ].includes(packageSubmitStatus) && !existingUserAnswerDTO.selfInited) && mode !== PRACTICE_MODE.analysis;

    if (shouldReinit) {
      reinited.questionId = questionInfo.questionInfoDTO.questionId;
      reinited.status = EAnswerStatus.UN_ANSWER;
      reinited.spendTime = '0';
      reinited.itemBaseList = [];
      reinited.correctType = (_a = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.correctType;
      reinited.selfInited = true;

      if (isCompound) {
        if (!(existingUserAnswerDTO === null || existingUserAnswerDTO === void 0 ? void 0 : existingUserAnswerDTO.childQuestionList) || !(existingUserAnswerDTO === null || existingUserAnswerDTO === void 0 ? void 0 : existingUserAnswerDTO.childQuestionList.length)) {
          reinited.childQuestionList = initChildItems(childLength, childrenQuestionList);
        } else {
          reinited.childQuestionList = existingUserAnswerDTO === null || existingUserAnswerDTO === void 0 ? void 0 : existingUserAnswerDTO.childQuestionList;
        }

        reinited.childItemList = initChildItems(childLength, childrenQuestionList);
      }
    } else {
      reinited = _assign$4({}, existingUserAnswerDTO);
    }

    return reinited;
  }

  questionList.forEach(function (questionInfo) {
    var _a;

    if (questionInfo && !(questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.userAnswerDetailDTOList)) {
      questionInfo.userAnswerDetailDTOList = [];
    }

    var _b = questionInfo,
        _c = _b.userAnswerDetailDTOList,
        userAnswerDetailDTOList = _c === void 0 ? [] : _c,
        evaluationQuestionConfigVO = _b.evaluationQuestionConfigVO;

    var _d = (questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionInfoDTO) || {},
        _e = _d.childrenQuestionList,
        childrenQuestionList = _e === void 0 ? [] : _e,
        questionId = _d.questionId,
        logicTypeId = _d.logicTypeId;

    if (exist(questionInfo)) {
      if (questionId && !reinitedQuestionIdList.includes(questionId)) {
        // START--按空解析作答内容、判题类型（作答模式、订正模式等可空上作答模式下）处理成自动判题，用于解析作答内容并回填
        if (logicTypeId === ELogicTypeId.FILL_ON_BLANK && questionInfo) {
          var editStatus = [PRACTICE_MODE.revising, PRACTICE_MODE.pratice];
          var shouldChangeCType_1 = editStatus.includes(mode || PRACTICE_MODE.pratice);

          if (evaluationQuestionConfigVO && shouldChangeCType_1) {
            evaluationQuestionConfigVO.correctType = 0;
            var childEvaList = evaluationQuestionConfigVO === null || evaluationQuestionConfigVO === void 0 ? void 0 : evaluationQuestionConfigVO.childEvaluationQuestionConfigVOList;

            if (childEvaList === null || childEvaList === void 0 ? void 0 : childEvaList.length) {
              questionInfo.evaluationQuestionConfigVO.childEvaluationQuestionConfigVOList = childEvaList.map(function (item) {
                return _assign$4(_assign$4({}, item), {
                  correctType: 0
                });
              });
            }
          }

          if (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.length) {
            var newAnswerList = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.map(function (answerItem) {
              var childQuestionList = answerItem.childQuestionList;
              return _assign$4(_assign$4({}, answerItem), {
                correctType: shouldChangeCType_1 ? 0 : answerItem.correctType,
                childQuestionList: childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList.map(function (item) {
                  var itemBaseList = (item || {}).itemBaseList;
                  return _assign$4(_assign$4({}, item), {
                    correctType: shouldChangeCType_1 ? 0 : item.correctType,
                    itemBaseList: (itemBaseList === null || itemBaseList === void 0 ? void 0 : itemBaseList.map(function (baseItem) {
                      var _a = baseItem || {},
                          resourceType = _a.resourceType,
                          resource = _a.resource,
                          _b = _a.correctCommentVOList,
                          correctCommentVOList = _b === void 0 ? [] : _b;

                      var resultObj = isRightQuestion(item === null || item === void 0 ? void 0 : item.status) ? {
                        isRight: true
                      } : [EAnswerStatus.LITTLE, EAnswerStatus.WRONG].includes(item === null || item === void 0 ? void 0 : item.status) ? {
                        isRight: false
                      } : {};
                      return _assign$4(_assign$4({}, baseItem), {
                        resourceType: ESubmitItemTypes.TEXT_AUTO,
                        resource: resourceType === ESubmitItemTypes.TEXT_AUTO ? resource || JSON.stringify([{
                          userAnswer: ''
                        }]) : JSON.stringify([_assign$4({
                          userAnswer: resource || ''
                        }, resultObj)]),
                        correctCommentVOList: correctCommentVOList.map(function (comment) {
                          return _assign$4(_assign$4({}, comment), {
                            resource: parseResourceJSON(comment.resourceType, comment.resource)
                          });
                        })
                      });
                    })) || []
                  });
                })
              });
            });
            questionInfo.userAnswerDetailDTOList = newAnswerList; // 后面的处理中可能有对该引用的修改, 因此在这里赋值

            userAnswerDetailDTOList = newAnswerList;
          }
        } // END--按空解析判题类型处理成自动判题


        if (!userAnswerDetailDTOList[0]) {
          var reinited = reinitUserAnswerDetailDTO(questionInfo, userAnswerDetailDTOList[0], packageSubmitStatus, childrenQuestionList, mode);
          questionInfo.userAnswerDetailDTOList[0] = reinited;
        }

        if (userAnswerDetailDTOList[0] && !userAnswerDetailDTOList[0].selfInited && [// 需要插入第一项的状态
        ERecordStatus.unSubmit, ERecordStatus.rejected, // 需要替换第一项的两种状态
        ERecordStatus.halfSubmit, ERecordStatus.unEvaluation].includes(packageSubmitStatus) // 自评
        || [ERecordStatus.unCorrect].includes(packageSubmitStatus) && mode === PRACTICE_MODE.evaluation || // 练习为订正状态 && 订正作答模式 && 非复合题
        ERecordStatus.revising === packageSubmitStatus && mode === PRACTICE_MODE.revising && userAnswerDetailDTOList[0].status !== EAnswerStatus.ANSEWRED && !(childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length)) {
          var reinited = reinitUserAnswerDetailDTO(questionInfo, userAnswerDetailDTOList[0], packageSubmitStatus, childrenQuestionList, mode);
          questionInfo.userAnswerDetailDTOList.splice(0, [ERecordStatus.halfSubmit, ERecordStatus.rejected, ERecordStatus.unEvaluation].includes(packageSubmitStatus) || ERecordStatus.unSubmit === packageSubmitStatus && userAnswerDetailDTOList[0] // 自评
          || ERecordStatus.unCorrect === packageSubmitStatus && mode === PRACTICE_MODE.evaluation ? 1 : 0, reinited);
        } // 练习为订正状态 && 订正作答模式 && 复合题


        if (ERecordStatus.revising === packageSubmitStatus && mode === PRACTICE_MODE.revising && (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length)) {
          var reinitCompound = reinitUserAnswerDetailDTO(questionInfo, userAnswerDetailDTOList[0], packageSubmitStatus, childrenQuestionList, mode); // 是否有已作答的子题

          var hasAnswered_2 = false;
          var existingUserAnswerDTO = userAnswerDetailDTOList[0];
          reinitCompound.childItemList = (_a = existingUserAnswerDTO === null || existingUserAnswerDTO === void 0 ? void 0 : existingUserAnswerDTO.childQuestionList) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            // 已作答就取原作答数据，其他情况置空
            if (item.status === EAnswerStatus.ANSEWRED) {
              hasAnswered_2 = true;
            } // 半提交或正确的题目，回填数据 否则清空


            var res = item.status === EAnswerStatus.ANSEWRED || [EAnswerStatus.RIGHT, EAnswerStatus.BASIC_Right].includes(item.status) ? item : _assign$4(_assign$4({}, item), {
              status: EAnswerStatus.UN_ANSWER,
              spendTime: '0',
              itemBaseList: []
            });
            return res;
          });
          questionInfo.userAnswerDetailDTOList.splice(0, hasAnswered_2 ? 1 : 0, reinitCompound);
        }

        reinitedQuestionIdList.push(questionId);
      }

      if (userAnswerDetailDTOList && userAnswerDetailDTOList.length > 0) {
        questionInfo && (questionInfo.userAnswerDetailDTOList = deserialization(userAnswerDetailDTOList)); // childAnswerMap 作答信息format

        if (questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.childAnswerMap) {
          var newMap_1 = new Map();
          questionInfo.childAnswerMap.forEach(function (val, id) {
            var newList = deserialization(val);
            newMap_1.set(id, newList);
          });
          questionInfo.childAnswerMap = newMap_1;
        }
      }
    }

    if (packageSubmitStatus === ERecordStatus.halfSubmit && (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0].status) === EAnswerStatus.ANSEWRED && questionInfo) {
      questionInfo.isModified = true;
    }
  });
  return questionList;
} // 获取目标作答状态的列表


var getAnswerStatusList = function getAnswerStatusList(questionList, targetStatus, flatten) {
  if (targetStatus === void 0) {
    targetStatus = EAnswerStatus.UN_ANSWER;
  }

  if (flatten === void 0) {
    flatten = true;
  }

  var targetStatusList = [];
  questionList.forEach(function (item) {
    var _a, _b;

    var lastAnswer = (_a = item === null || item === void 0 ? void 0 : item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0];

    if ((_b = lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childItemList) === null || _b === void 0 ? void 0 : _b.length) {
      // 复合题是否包含目标作答状态的子题
      var hasTargetStatus_1 = false;
      lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.childItemList.forEach(function (childItem) {
        var status = childItem === null || childItem === void 0 ? void 0 : childItem.status;

        if (status === targetStatus) {
          hasTargetStatus_1 = true; // childItem 当前无意义，仅做计数使用

          flatten && targetStatusList.push(childItem);
        }
      });
      hasTargetStatus_1 && !flatten && targetStatusList.push(item);
    } else if ((lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.status) === targetStatus) {
      targetStatusList.push(item);
    }
  });
  return targetStatusList;
}; // 获取未作答的题目数据


var getUnAnsweredNum = function getUnAnsweredNum(questionList) {
  var unAnsweredList = getAnswerStatusList(questionList);
  return (unAnsweredList === null || unAnsweredList === void 0 ? void 0 : unAnsweredList.length) || 0;
}; // 问仔加密视频链接解密算法

function decodeUrl(url) {
  if (!url) {
    return '';
  }

  var prefix = 'bjcloudvod://';

  if ('' === url || url.indexOf(prefix) !== 0) {
    return;
  }

  url = url.slice(prefix.length, url.length).replace(/-/g, '+').replace(/_/g, '/');
  var MOD = 4;
  var DIGIT_2 = 2;
  var DIGIT_3 = 3;
  var DIGIT_8 = 8;
  var pad = url.length % MOD;

  if (pad === DIGIT_2) {
    url += '==';
  } else if (pad === DIGIT_3) {
    url += '=';
  }

  url = base64.decode(url);

  if (url) {
    var factor = url.charCodeAt(0);
    var c = factor % DIGIT_8;
    url = url.slice(1, url.length);
    var result = [];
    /* eslint-disable */

    for (var i = 0, char = void 0; char = url[i]; i++) {
      var step = i % 4 * c + i % 3 + 1;
      result.push(String.fromCharCode(char.charCodeAt(0) - step));
    }

    return result.join('');
  }

  return '';
}
var V3Utils = {
  getAnswers: getAnswers,
  getDemandList: getDemandList,
  goPre: goPre,
  goNext: goNext,
  initList: initList,
  deserialization: deserialization,
  getTotalSpendTime: getTotalSpendTime,
  getQuestionIndex: getQuestionIndex,
  getRightOrWrongQList: getRightOrWrongQList,
  getRightOrWrongNumber: getRightOrWrongNumber,
  getEvaluationQList: getEvaluationQList,
  getEvaluationsNum: getEvaluationsNum,
  getEvaluationAnswers: getEvaluationAnswers,
  getUnEvaluationNumber: getUnEvaluationNumber,
  getAnswerStatusList: getAnswerStatusList,
  getUnAnsweredNum: getUnAnsweredNum,
  isRightQuestion: isRightQuestion,
  getUnifidItems: getUnifidItems,
  isUnifyEvaluation: isUnifyEvaluation,
  parseResourceJSON: parseResourceJSON
};

var overMaxCountToast = '最多只能上传6张图 已为您选取前6张图片';
var toastTimer = 3000;

var CameraBtn = function CameraBtn(props) {
  var _a = props.node,
      node = _a === void 0 ? '上传图片' : _a,
      customStyle = props.customStyle,
      curCount = props.curCount,
      answerMode = props.answerMode,
      haboReportData = props.haboReportData,
      subjectId = props.subjectId,
      uploadCallback = props.uploadCallback,
      exceptionCallback = props.exceptionCallback;

  var _b = useState(false),
      showMenu = _b[0],
      setShowMenu = _b[1];

  var _c = useState(false),
      showToast = _c[0],
      setShowToast = _c[1];

  var changeShowMenu = useCallback(function () {
    return setShowMenu(!showMenu);
  }, [showMenu]);

  var nativeUploadCB = function nativeUploadCB(fileItem, submitType) {
    var _a, _b;

    var userSubmitItems = [];

    if ((_a = fileItem === null || fileItem === void 0 ? void 0 : fileItem.urlList) === null || _a === void 0 ? void 0 : _a.length) {
      (_b = fileItem === null || fileItem === void 0 ? void 0 : fileItem.urlList) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        return userSubmitItems.push({
          resource: {
            url: item.url
          },
          resourceType: ESubmitItemTypes[submitType],
          answerMode: answerMode
        });
      });
    } else {
      (fileItem === null || fileItem === void 0 ? void 0 : fileItem.url) && userSubmitItems.push({
        resource: {
          url: fileItem === null || fileItem === void 0 ? void 0 : fileItem.url
        },
        resourceType: ESubmitItemTypes[submitType],
        answerMode: answerMode
      });
    }

    (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && uploadCallback(userSubmitItems);
  };

  var handleOverMaxCount = useCallback(function () {
    if (!isPC) {
      return;
    }

    setShowToast(true);
    var timer = setTimeout(function () {
      setShowToast(false);
    }, toastTimer);
    return function () {
      clearTimeout(timer);
    };
  }, []);
  var h5UploadCB = useCallback(function (urlList, submitType, isOverMaxCount) {
    var userSubmitItems = urlList.map(function (url) {
      return {
        resource: {
          url: url
        },
        resourceType: ESubmitItemTypes[submitType],
        answerMode: answerMode
      };
    });

    if (isOverMaxCount) {
      handleOverMaxCount();
    }

    uploadCallback(userSubmitItems);
  }, [answerMode, handleOverMaxCount, uploadCallback]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MultiAnsBtnApp, {
    changeShowMenu: changeShowMenu,
    msg: node,
    haboReportData: haboReportData,
    customStyle: customStyle,
    curCount: curCount,
    answerType: EAnswerTypes.IMAGE,
    // eslint-disable-next-line react/jsx-no-bind
    nativeUploadCB: nativeUploadCB,
    // eslint-disable-next-line react/jsx-no-bind
    exceptionCallback: exceptionCallback,
    subjectId: subjectId,
    h5UploadCB: h5UploadCB,
    disabled: curCount >= EAnswerTypeMaxCount.IMAGE
  }), /*#__PURE__*/React.createElement(AnswerMenu, _assign$4({}, props, {
    curCount: curCount,
    haboReportData: haboReportData,
    curAnswerType: EAnswerTypes.IMAGE,
    // eslint-disable-next-line react/jsx-no-bind
    nativeUploadCB: nativeUploadCB,
    showMenu: showMenu,
    changeShowMenu: changeShowMenu
  })), showToast && /*#__PURE__*/React.createElement(Toast, {
    msg: overMaxCountToast,
    customToastStyle: {
      textAlign: 'center',
      width: '194px',
      height: '72px',
      padding: '12px 20px',
      margin: 0,
      lineHeight: '24px',
      boxSizing: 'border-box',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 20,
      fontSize: '16px'
    }
  }));
};

var style$H = {"unified-upload-wrapper":"tangram_C_unified-upload-wrapper_580cff5e31","exception-tip":"tangram_C_exception-tip_580cff5e31","imgs-wrapper":"tangram_C_imgs-wrapper_580cff5e31"};

var MAX_COUNT_TIP = '要上传图片的题目，请在此统一上传，最多上传6张哦～';
var HERE_UPLOAD_TIP = '拍照答题的题目请在此统一上传';
var haboReportData = {
  eventId: EHaboEventId$1.CLICK_IMG_UPLOAD,
  otherInfo: {
    primary_action: 'homework_server_push',
    secondary_action: 'homework_app_commit_complete',
    action_value: '点击统一作答图片上传按钮'
  }
};

var UnifiedUpload = function UnifiedUpload(props) {
  var _a;

  var questionList = props.questionList,
      subjectId = props.subjectId,
      onUserAnswerDetailChange = props.onUserAnswerDetailChange,
      mode = props.mode;

  var _b = useState(''),
      uploadPrompt = _b[0],
      setUploadPrompt = _b[1];

  var _c = props.editable,
      editable = _c === void 0 ? mode && [PRACTICE_MODE.pratice, PRACTICE_MODE.revising].includes(mode) || false : _c;
  var isRevision = mode === PRACTICE_MODE.revising; // 统一作答图片列表 useState

  var _d = useState(getUnifidItems(questionList) || []),
      unifiedAnswerList = _d[0],
      setUnifiedAnswerList = _d[1];

  useEffect(function () {
    setUnifiedAnswerList(getUnifidItems(questionList, mode) || []);
  }, [questionList]);

  if (!isUnifyEvaluation(questionList, mode)) {
    return null;
  }

  var handleChange = function handleChange(list) {
    // 将questionList的每一道题的userAnswerDetailDTOList[0]的itemBaseList替换成list
    var version = questionList === null || questionList === void 0 ? void 0 : questionList.reduce(function (pre, cur) {
      var _a;

      return Math.max(pre, ((_a = cur === null || cur === void 0 ? void 0 : cur.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, 0);
    onUserAnswerDetailChange === null || onUserAnswerDetailChange === void 0 ? void 0 : onUserAnswerDetailChange(questionList.map(function (question) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

      if (((_a = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) === version) {
        var userAnswer = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList[0];

        if ((_c = (_b = question === null || question === void 0 ? void 0 : question.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.childrenQuestionList) === null || _c === void 0 ? void 0 : _c.length) {
          for (var j = 0; j < ((_e = (_d = question === null || question === void 0 ? void 0 : question.questionInfoDTO) === null || _d === void 0 ? void 0 : _d.childrenQuestionList) === null || _e === void 0 ? void 0 : _e.length); ++j) {
            if (((_h = (_g = (_f = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _f === void 0 ? void 0 : _f.childEvaluationQuestionConfigVOList) === null || _g === void 0 ? void 0 : _g[j]) === null || _h === void 0 ? void 0 : _h.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && !isRightQuestion((_j = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _j === void 0 ? void 0 : _j.status))) {
              var finalList = (_l = (_k = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _k === void 0 ? void 0 : _k.itemBaseList) === null || _l === void 0 ? void 0 : _l.filter(function (item) {
                return item.answerMode !== EAnswerMode.UNIFIED;
              }).concat(list);
              var finalStatus = finalList.length ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER;
              question.userAnswerDetailDTOList[0].childQuestionList[j].itemBaseList = finalList;
              question.userAnswerDetailDTOList[0].childQuestionList[j].status = finalStatus;
              question.userAnswerDetailDTOList[0].childItemList[j].itemBaseList = finalList;
              question.userAnswerDetailDTOList[0].childItemList[j].status = finalStatus;
            }
          }
        }

        if (((_m = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _m === void 0 ? void 0 : _m.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && !isRightQuestion(userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.status))) {
          var finalList = userAnswer.itemBaseList.filter(function (item) {
            return item.answerMode !== EAnswerMode.UNIFIED;
          }).concat(list);
          question.userAnswerDetailDTOList[0].itemBaseList = finalList;
          question.userAnswerDetailDTOList[0].status = finalList.length ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER;
        }
      }

      return question;
    }));
  };

  var handleUpload = function handleUpload(userSubmitItems) {
    handleChange(unifiedAnswerList.concat(userSubmitItems) || userSubmitItems);
  };

  var handleDelete = function handleDelete(deleteIndex) {
    handleChange(unifiedAnswerList.filter(function (_, index) {
      return index !== deleteIndex;
    }));
  };

  var handleUploadException = function handleUploadException(_a) {
    var msg = _a.msg;
    setUploadPrompt(msg);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: style$H['unified-upload-wrapper']
  }, isMobile ? /*#__PURE__*/React.createElement("p", null, MAX_COUNT_TIP) : /*#__PURE__*/React.createElement("p", null, HERE_UPLOAD_TIP), uploadPrompt && /*#__PURE__*/React.createElement("p", {
    className: style$H['exception-tip']
  }, uploadPrompt), /*#__PURE__*/React.createElement("div", {
    className: style$H['imgs-wrapper']
  }, editable && /*#__PURE__*/React.createElement(CameraBtn, {
    curCount: unifiedAnswerList === null || unifiedAnswerList === void 0 ? void 0 : unifiedAnswerList.length,
    answerMode: EAnswerMode.UNIFIED,
    haboReportData: haboReportData,
    subjectId: subjectId,
    customStyle: {
      float: 'left',
      boxSizing: 'border-box',
      paddingTop: isPC ? '15px' : '27px',
      width: isPC ? '78px' : 'calc(33.3% - 8px)',
      height: isPC ? '78px' : '109px',
      marginRight: '8px'
    },
    // eslint-disable-next-line react/jsx-no-bind
    uploadCallback: handleUpload,
    // eslint-disable-next-line react/jsx-no-bind
    exceptionCallback: handleUploadException
  }), (_a = unifiedAnswerList === null || unifiedAnswerList === void 0 ? void 0 : unifiedAnswerList.map(function (submitItem, index) {
    var _a;

    return /*#__PURE__*/React.createElement(ImageEditor // eslint-disable-next-line react/no-array-index-key
    , {
      // eslint-disable-next-line react/no-array-index-key
      key: (_a = submitItem.resource) === null || _a === void 0 ? void 0 : _a.url,
      editable: !!editable,
      customStyle: {
        height: isPC ? '78px' : '109px',
        width: isPC ? '78px' : ''
      },
      content: submitItem.resource.url,
      // eslint-disable-next-line react/jsx-no-bind
      deleteCallback: function deleteCallback() {
        handleDelete(index);
      }
    });
  })) === null || _a === void 0 ? void 0 : _a.reverse()));
};

var style$G = {"exercise-wrapper":"tangram_C_exercise-wrapper_e4ed779135","question-detail":"tangram_C_question-detail_e4ed779135","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_e4ed779135","card-title":"tangram_C_card-title_e4ed779135","structure":"tangram_C_structure_e4ed779135","full-blank":"tangram_C_full-blank_e4ed779135","text-emphasis":"tangram_C_text-emphasis_e4ed779135","table-wrapper":"tangram_C_table-wrapper_e4ed779135","answer-wrapper":"tangram_C_answer-wrapper_e4ed779135","sticker":"tangram_C_sticker_e4ed779135","top-right":"tangram_C_top-right_e4ed779135","bottom-right":"tangram_C_bottom-right_e4ed779135","bottom-left":"tangram_C_bottom-left_e4ed779135","top-left":"tangram_C_top-left_e4ed779135","imgs-wrapper":"tangram_C_imgs-wrapper_e4ed779135","img-wrapper":"tangram_C_img-wrapper_e4ed779135","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_e4ed779135","answer-box":"tangram_C_answer-box_e4ed779135","answer-content-text":"tangram_C_answer-content-text_e4ed779135","inner-title":"tangram_C_inner-title_e4ed779135","inner-answer-box":"tangram_C_inner-answer-box_e4ed779135"};

var _a$9, _b$2, _c;
var correctnessMap$1 = (_a$9 = {}, _a$9[EResultCorrectness$1.RIGHT] = '正确', _a$9[EResultCorrectness$1.WRONG] = '错误', _a$9[EResultCorrectness$1.WAIT] = '', _a$9[EResultCorrectness$1.PARTIAL_RIGHT] = '部分正确', _a$9);
var correctnessStyleMap$1 = (_b$2 = {}, _b$2[EResultCorrectness$1.RIGHT] = 'right', _b$2[EResultCorrectness$1.WRONG] = 'wrong', _b$2[EResultCorrectness$1.WAIT] = '', _b$2[EResultCorrectness$1.PARTIAL_RIGHT] = 'partial-right', _b$2);
var answerStatusMap = (_c = {}, _c[EAnswerStatus.WRONG] = EResultCorrectness$1.WRONG, _c[EAnswerStatus.RIGHT] = EResultCorrectness$1.RIGHT, _c[EAnswerStatus.LITTLE] = EResultCorrectness$1.WRONG, _c[EAnswerStatus.HALF_RIGHT] = EResultCorrectness$1.PARTIAL_RIGHT, _c[EAnswerStatus.UN_ANSWER] = EResultCorrectness$1.WRONG, _c[EAnswerStatus.BASIC_Right] = EResultCorrectness$1.PARTIAL_RIGHT, _c[EAnswerStatus.NO_EVALUATION] = EResultCorrectness$1.WRONG, _c[EAnswerStatus.ANSEWRED] = EResultCorrectness$1.WRONG, _c[EAnswerStatus.RECITED] = '', _c);
/**
 * 老师批改
 */

var Correction = function Correction(props) {
  var _a, _b;

  var commentItems = props.commentItems,
      isStudent = props.isStudent,
      isInnerUse = props.isInnerUse,
      customStyle = props.customStyle,
      answerWay = props.answerWay;

  if (typeof Object.entries !== 'function') {
    Object.entries = entries;
  }

  function initAnsSortListObj(list) {
    var _a; // 整理四种作答方式的作答列表到一个对象中


    var initAnsSortListObj = (_a = {}, _a[ESubmitType.IMAGE] = [], _a[ESubmitType.AUDIO] = [], _a[ESubmitType.TEXT] = [], _a[ESubmitType.VIDEO] = [], _a);
    list === null || list === void 0 ? void 0 : list.forEach(function (item) {
      var _a;

      var submitType = ESubmitItemTypes[item.resourceType];
      (_a = initAnsSortListObj[submitType]) === null || _a === void 0 ? void 0 : _a.push(item);
    });
    return initAnsSortListObj;
  }

  var handledList = commentItems === null || commentItems === void 0 ? void 0 : commentItems.map(function (commentItem) {
    var resourceType = commentItem.resourceType,
        resource = commentItem.resource,
        status = commentItem.status;
    return {
      // 如果是选择题的选项作答6，需要转为3来展示作答历史
      // 语音评测题目的提交历史，需要转换为音频提交类型显示
      resourceType: [6, 7].includes(+resourceType) ? 3 : +resourceType === ESubmitItemTypes.AUDIOEVALUATE ? ESubmitItemTypes.AUDIO : resourceType,
      // 6,7,3 类型的作答，均需要以文本的方式展示，注意7类型，自动判题的填空题作答
      resource: +resourceType === 7 ? resource.map(function (each) {
        return each.userAnswer;
      }).filter(function (ans) {
        return ans;
      }).join(',') : +resourceType === ESubmitItemTypes.AUDIOEVALUATE ? {
        url: resource.answer
      } : resource,
      answerMode: commentItem.answerMode,
      resultCorrectness: status && !!answerStatusMap[status] && answerStatusMap[status]
    };
  }); // 这个方法没有兼容老师评语的text 需要修改

  var handleText = function handleText(text, status, style, key) {
    if (!text) {
      return null;
    }

    return /*#__PURE__*/React.createElement("span", {
      key: key
    }, (answerWay === null || answerWay === void 0 ? void 0 : answerWay.includes(EAnswerTypes.RICH_TEXT)) ? /*#__PURE__*/React.createElement(MyAnswer, {
      answerWay: answerWay,
      content: text
    }) : text, status && /*#__PURE__*/React.createElement("span", {
      className: style === null || style === void 0 ? void 0 : style[correctnessStyleMap$1[status]]
    }, " ".concat(correctnessMap$1[status])));
  };

  var ansSortListObj = initAnsSortListObj(handledList);
  return (commentItems === null || commentItems === void 0 ? void 0 : commentItems.length) ? /*#__PURE__*/React.createElement("div", {
    style: customStyle,
    className: style$G['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(isInnerUse ? style$G['inner-title'] : style$G['card-title'])
  }, isStudent ? '我的回答' : '批改结果'), /*#__PURE__*/React.createElement("div", {
    className: "".concat(isInnerUse ? style$G['inner-answer-box'] : style$G['answer-box'])
  }, /*#__PURE__*/React.createElement(React.Fragment, null, ((_a = ansSortListObj[ESubmitType.TEXT]) === null || _a === void 0 ? void 0 : _a.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: style$G['answer-content-text']
  }, (_b = ansSortListObj[ESubmitType.TEXT]) === null || _b === void 0 ? void 0 : _b.map(function (item, idx, array) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("span", {
        key: idx
      }, handleText(item.resource, item.resultCorrectness, style$G, "".concat(item.resource).concat(idx)), idx !== array.length - 1 && /*#__PURE__*/React.createElement("br", null))
    );
  })), /*#__PURE__*/React.createElement(React.Fragment, null, // ansSortListObj对象中有四个数组，分别对应四种作答类型
  Object.entries(ansSortListObj).map(function (curEntry) {
    var key = curEntry[0],
        value = curEntry[1];
    var key2Submitype = key;

    if (key2Submitype === ESubmitType.TEXT) {
      return null;
    }

    var AnswerChecker = answerCheckerMap[key2Submitype];

    if (!(value === null || value === void 0 ? void 0 : value.length)) {
      return null;
    }

    return AnswerChecker && /*#__PURE__*/React.createElement("div", {
      key: key2Submitype
    }, /*#__PURE__*/React.createElement(AnswerChecker, {
      editable: false,
      // 批改结果里面的
      showTip: !isStudent && !isInnerUse,
      tipMsg: EImgTopTipMsg.CORRECTION_RESULT,
      answerList: value
    }));
  }))))) : null;
};

var style$F = {"answer-wrapper":"tangram_C_answer-wrapper_96ad2c06c6","sticker":"tangram_C_sticker_96ad2c06c6","top-right":"tangram_C_top-right_96ad2c06c6","bottom-right":"tangram_C_bottom-right_96ad2c06c6","bottom-left":"tangram_C_bottom-left_96ad2c06c6","top-left":"tangram_C_top-left_96ad2c06c6","imgs-wrapper":"tangram_C_imgs-wrapper_96ad2c06c6","img-wrapper":"tangram_C_img-wrapper_96ad2c06c6","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_96ad2c06c6","answer-box":"tangram_C_answer-box_96ad2c06c6","exercise-wrapper":"tangram_C_exercise-wrapper_96ad2c06c6","question-detail":"tangram_C_question-detail_96ad2c06c6","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_96ad2c06c6","card-title":"tangram_C_card-title_96ad2c06c6","structure":"tangram_C_structure_96ad2c06c6","full-blank":"tangram_C_full-blank_96ad2c06c6","text-emphasis":"tangram_C_text-emphasis_96ad2c06c6","table-wrapper":"tangram_C_table-wrapper_96ad2c06c6","history-items":"tangram_C_history-items_96ad2c06c6","history-user-submit-items":"tangram_C_history-user-submit-items_96ad2c06c6","history-submit-info":"tangram_C_history-submit-info_96ad2c06c6","history-submit-idx":"tangram_C_history-submit-idx_96ad2c06c6","history-submit-status":"tangram_C_history-submit-status_96ad2c06c6","history-item":"tangram_C_history-item_96ad2c06c6","is-wrong":"tangram_C_is-wrong_96ad2c06c6","is-right":"tangram_C_is-right_96ad2c06c6","history-teacher-comments":"tangram_C_history-teacher-comments_96ad2c06c6","history-teacher-comments-title":"tangram_C_history-teacher-comments-title_96ad2c06c6","history-submit-content-area":"tangram_C_history-submit-content-area_96ad2c06c6","triangle-btn":"tangram_C_triangle-btn_96ad2c06c6","triangle-down":"tangram_C_triangle-down_96ad2c06c6"};

var _a$8, _b$1;
var correctnessStyleMap = (_a$8 = {}, _a$8[EAnswerStatus.WRONG] = 'is-wrong', _a$8[EAnswerStatus.RIGHT] = 'is-right', _a$8[EAnswerStatus.LITTLE] = 'is-wrong', _a$8[EAnswerStatus.HALF_RIGHT] = 'is-partial-right', _a$8[EAnswerStatus.UN_ANSWER] = 'is-wrong', _a$8[EAnswerStatus.BASIC_Right] = 'is-partial-right', _a$8[EAnswerStatus.ANSEWRED] = 'is-wrong', // 未自评的题目, 作答历史中不展示结果状态
_a$8[EAnswerStatus.NO_EVALUATION] = '', // 背题模式（单题提交场景）下，用户点击确认按钮后，选择类的题目会即刻变为解析或自评模式
// 此时，在后端未返回判题结果时，答案的状态会显示有误
// 单题可能会有状态闪动的情况，对于复合题子题由于不能单独提交，所以答案状态可能会一直显示错误，给用户反馈了错误信息
_a$8[EAnswerStatus.RECITED] = '', _a$8);
var correctnessMap = (_b$1 = {}, _b$1[EAnswerStatus.WRONG] = '回答错误', _b$1[EAnswerStatus.RIGHT] = '回答正确', _b$1[EAnswerStatus.LITTLE] = '回答错误', _b$1[EAnswerStatus.HALF_RIGHT] = '部分正确', _b$1[EAnswerStatus.UN_ANSWER] = '回答错误', _b$1[EAnswerStatus.BASIC_Right] = '部分正确', // 未自评的题目, 作答历史中不展示结果状态
_b$1[EAnswerStatus.NO_EVALUATION] = '', _b$1[EAnswerStatus.ANSEWRED] = '回答错误', _b$1[EAnswerStatus.RECITED] = '', _b$1);
/**
 * 试题来源
 */

var SubmitHistory = function SubmitHistory(props) {
  var submitHistory = props.submitHistory,
      questionId = props.questionId,
      answerWay = props.answerWay;

  var _a = useState(''),
      currentDisplayedComment = _a[0],
      setCurrentDisplayedComment = _a[1];

  function handleCommentToggle(e) {
    var dataset = e.target.dataset;

    if (currentDisplayedComment === dataset.version) {
      setCurrentDisplayedComment('');
      return;
    }

    setCurrentDisplayedComment(dataset.version || '');
  }

  return (submitHistory === null || submitHistory === void 0 ? void 0 : submitHistory.length) ? /*#__PURE__*/React.createElement("div", {
    className: style$F['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$F['card-title']
  }, "\u63D0\u4EA4\u5386\u53F2"), /*#__PURE__*/React.createElement("div", {
    className: style$F['answer-box']
  }, submitHistory.map(function (historyItem, idx) {
    var _a = historyItem.correctCommentVOList,
        questionCommentVOList = _a === void 0 ? [] : _a,
        _b = historyItem.itemBaseList,
        itemBaseList = _b === void 0 ? [] : _b,
        questionAnswerVersion = historyItem.questionAnswerVersion,
        submitTime = historyItem.submitTime,
        status = historyItem.status;
    var correctCommentVOList = questionCommentVOList;

    if (!correctCommentVOList.length) {
      itemBaseList.forEach(function (item) {
        var _a;

        ((_a = item === null || item === void 0 ? void 0 : item.correctCommentVOList) === null || _a === void 0 ? void 0 : _a.length) && correctCommentVOList.push.apply(correctCommentVOList, item.correctCommentVOList);
      });
    }

    var version = "".concat(questionId, "_").concat(questionAnswerVersion, "_").concat(idx);
    var isExpandCurrent = currentDisplayedComment === version;
    return /*#__PURE__*/React.createElement("div", {
      className: style$F['history-items'],
      key: version
    }, /*#__PURE__*/React.createElement("div", {
      className: style$F['history-user-submit-items'],
      role: "button",
      tabIndex: -1,
      "data-version": version,
      onClick: handleCommentToggle
    }, /*#__PURE__*/React.createElement("p", {
      className: style$F['history-submit-info'],
      "data-version": version
    }, !!questionAnswerVersion && /*#__PURE__*/React.createElement("span", {
      className: style$F['history-submit-idx'],
      "data-version": version
    }, "\u7B2C".concat(questionAnswerVersion, "\u6B21\u63D0\u4EA4")), submitTime && /*#__PURE__*/React.createElement("span", {
      "data-version": version
    }, new Date(+submitTime).toLocaleString().replace(/\//g, '-'))), /*#__PURE__*/React.createElement("p", {
      className: style$F['history-submit-status'],
      "data-version": version
    }, status && !!(correctnessMap === null || correctnessMap === void 0 ? void 0 : correctnessMap[status]) && /*#__PURE__*/React.createElement("span", {
      className: "".concat(style$F['history-item'], " ").concat(style$F[correctnessStyleMap[status]]),
      "data-version": version
    }, correctnessMap === null || correctnessMap === void 0 ? void 0 : correctnessMap[status]), /*#__PURE__*/React.createElement("span", {
      className: "".concat(style$F['triangle-btn'], "\n                                                    ").concat(isExpandCurrent ? style$F['triangle-down'] : ''),
      "data-version": version
    }))), /*#__PURE__*/React.createElement("div", {
      className: style$F['history-submit-content-area']
    }, isExpandCurrent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Correction, {
      commentItems: itemBaseList,
      answerWay: answerWay,
      isStudent: true,
      isInnerUse: true
    }), /*#__PURE__*/React.createElement(Correction, {
      commentItems: correctCommentVOList,
      isInnerUse: true
    }))));
  }))) : null;
};

var style$E = {"exercise-wrapper":"tangram_C_exercise-wrapper_06e43a5da9","question-detail":"tangram_C_question-detail_06e43a5da9","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_06e43a5da9","card-title":"tangram_C_card-title_06e43a5da9","structure":"tangram_C_structure_06e43a5da9","full-blank":"tangram_C_full-blank_06e43a5da9","text-emphasis":"tangram_C_text-emphasis_06e43a5da9","table-wrapper":"tangram_C_table-wrapper_06e43a5da9","answer-wrapper":"tangram_C_answer-wrapper_06e43a5da9","sticker":"tangram_C_sticker_06e43a5da9","top-right":"tangram_C_top-right_06e43a5da9","bottom-right":"tangram_C_bottom-right_06e43a5da9","bottom-left":"tangram_C_bottom-left_06e43a5da9","top-left":"tangram_C_top-left_06e43a5da9","imgs-wrapper":"tangram_C_imgs-wrapper_06e43a5da9","img-wrapper":"tangram_C_img-wrapper_06e43a5da9","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_06e43a5da9","answer-box":"tangram_C_answer-box_06e43a5da9"};

var VideoExplanation = function VideoExplanation(props) {
  var _a, _b, _c;

  var urls = props.urls,
      coverUrl = props.coverUrl,
      compoundUse = props.compoundUse,
      platForm = props.platForm,
      videoVOList = props.videoVOList;
  var videoUrl = decodeUrl((_b = (_a = videoVOList === null || videoVOList === void 0 ? void 0 : videoVOList[0]) === null || _a === void 0 ? void 0 : _a.cdnList) === null || _b === void 0 ? void 0 : _b[0]) || urls;
  var videoCoverImage = ((_c = videoVOList === null || videoVOList === void 0 ? void 0 : videoVOList[0]) === null || _c === void 0 ? void 0 : _c.coverUrl) || coverUrl;

  if (!videoUrl || Array.isArray(videoUrl) && !(videoUrl === null || videoUrl === void 0 ? void 0 : videoUrl.length) || isNewVersion && !videoCoverImage) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$E['card-title']
  }, "\u89C6\u9891\u8BB2\u89E3"), /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-box']
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    source: videoUrl,
    coverUrl: videoCoverImage,
    videoWrapperStyle: platForm === EPlatForm.pc && compoundUse ? {
      width: '100%'
    } : {}
  })));
};

var useCounterRef = function useCounterRef(startTime, timingType) {
  if (timingType === void 0) {
    timingType = 1;
  }

  var _a = useState(false),
      isPause = _a[0],
      setIsPause = _a[1];

  var _b = useState(false),
      shouldStop = _b[0],
      setShouldStop = _b[1];

  var countRef = useRef(startTime);
  var timer = useRef(0);

  var onVisibilityChange = function onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      setIsPause(false);
    }

    if (document.visibilityState === 'hidden') {
      setIsPause(true);
    }
  }; // 重置当前时间


  var reset = function reset(time) {
    if (time === void 0) {
      time = 0;
    }

    countRef.current = time;
  };

  useEffect(function () {
    window.clearInterval(timer.current);

    if (!isPause) {
      timer.current = window.setInterval(function () {
        // timingType 为 2 为倒计时， 为 1 为正计时
        timingType === 2 && (countRef.current -= 1);
        timingType === 1 && (countRef.current += 1);
      }, 1000);
    }

    return function () {
      return window.clearInterval(timer.current);
    };
  }, [isPause]); // 外部指定停止后，不再监听页面的显示和隐藏

  useEffect(function () {
    if (shouldStop) {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }
  }, [shouldStop]);
  useEffect(function () {
    // 监听页面显示隐藏
    document.addEventListener('visibilitychange', onVisibilityChange);
    return function () {
      return document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
  return {
    reset: reset,
    setIsPause: setIsPause,
    setShouldStop: setShouldStop,
    countRef: countRef
  };
};

var style$D = {"page-exercise":"tangram_C_page-exercise_b19ca0e28b","follow-parts":"tangram_C_follow-parts_b19ca0e28b","split-line":"tangram_C_split-line_b19ca0e28b","page-exercise-compound":"tangram_C_page-exercise-compound_b19ca0e28b","module-exercise":"tangram_C_module-exercise_b19ca0e28b"};

var style$C = {"exercise-wrapper":"tangram_C_exercise-wrapper_ce5f75cab0","question-detail":"tangram_C_question-detail_ce5f75cab0","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_ce5f75cab0","card-title":"tangram_C_card-title_ce5f75cab0","structure":"tangram_C_structure_ce5f75cab0","full-blank":"tangram_C_full-blank_ce5f75cab0","text-emphasis":"tangram_C_text-emphasis_ce5f75cab0","table-wrapper":"tangram_C_table-wrapper_ce5f75cab0","grade":"tangram_C_grade_ce5f75cab0","type":"tangram_C_type_ce5f75cab0","empty":"tangram_C_empty_ce5f75cab0","star":"tangram_C_star_ce5f75cab0","light-star":"tangram_C_light-star_ce5f75cab0","dark-star":"tangram_C_dark-star_ce5f75cab0"};

var MAX_DIFFICULTY = 5;
var logicTypeIds = ['', '单选题', '多选题', '不定项选择题', '填空题', '解答题', '语音题', '写作题', '判断题', '完形填空', '复合题', '多选多', '视频题', '字词句朗诵', '古诗文朗诵', '角色扮演', '填空题（按空写解析）'];
/**
 * 题目类型 + 难度等级组件
 * @param props
 */

var Grade = function Grade(props) {
  var logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      bigTypeName = props.bigTypeName,
      parentLogicTypeId = props.parentLogicTypeId; // 复合题类型为完形填空，子题不展示题目类型 + 难度等级

  if (parentLogicTypeId && parentLogicTypeId === ELogicTypeId.CHOICE) {
    return null;
  }

  var logicTypeName = logicTypeId ? typeof logicTypeId === 'string' && logicTypeIds.includes(logicTypeId) ? logicTypeId : logicTypeIds[+logicTypeId] : ''; // 题型展示优先级：学科大题型>逻辑题型

  var typeName = bigTypeName || logicTypeName;
  var starList = [];

  if (difficulty && difficulty > 0) {
    for (var i = 0; i < MAX_DIFFICULTY; i++) {
      var starClass = 'light-star';

      if (i > difficulty - 1) {
        starClass = 'dark-star';
      }

      var item = /*#__PURE__*/React.createElement("span", {
        key: "star".concat(i),
        className: "".concat(style$C.star, " ").concat(style$C[starClass])
      });
      starList.push(item);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: style$C.grade
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(style$C.type, " ").concat(typeName ? '' : style$C.empty)
  }, typeName), difficulty && difficulty > 0 ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, "\u96BE\u5EA6\uFF1A"), /*#__PURE__*/React.createElement("span", null, starList)) : null);
};

var style$B = {"fold-icon":"tangram_C_fold-icon_4d05421a8f","do-fold-icon":"tangram_C_do-fold-icon_4d05421a8f","do-unfold-icon":"tangram_C_do-unfold-icon_4d05421a8f","folded-content":"tangram_C_folded-content_4d05421a8f"};

/* eslint-disable react/jsx-no-bind */
/**
 * 答案解析
 */

var Analysis = function Analysis(_a) {
  var _b;

  var analysis = _a.analysis,
      platForm = _a.platForm;
  var questionAnalysis = parseJSON(analysis);

  var _c = useState(false),
      isFold = _c[0],
      setIsFold = _c[1];

  var divRef = useRef(null);
  var divMaxHeight = '3000px';

  var _d = useState({}),
      contentStyle = _d[0],
      setContentStyle = _d[1];

  function refreshStyle() {
    setContentStyle(platForm === EPlatForm.pc ? {} : isFold ? {
      maxHeight: '0',
      marginBottom: '0'
    } : {
      maxHeight: divMaxHeight,
      marginBottom: '20px'
    });
  }

  useEffect(function () {
    refreshStyle();
  }, [isFold]);
  useEffect(function () {
    setIsFold(false);
  }, [analysis]);
  return ((_b = questionAnalysis === null || questionAnalysis === void 0 ? void 0 : questionAnalysis.child) === null || _b === void 0 ? void 0 : _b.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['card-title'],
    role: "button",
    onClick: function onClick() {
      return setIsFold(!isFold);
    },
    tabIndex: -1
  }, "\u7B54\u6848\u89E3\u6790", platForm !== EPlatForm.pc && /*#__PURE__*/React.createElement("div", {
    className: "\n                                        ".concat(style$B['fold-icon'], " ").concat(style$B["".concat(isFold ? 'do-unfold-icon' : 'do-fold-icon')], "\n                                    ")
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(answerStyle['answer-box'], " ").concat(style$B['folded-content']),
    style: contentStyle,
    ref: divRef
  }, json2reactElement(questionAnalysis, {
    key: "".concat(analysis),
    richTextLocation: ERichTextLocation.ANALYSIS
  })))) : null;
};

/**
 * 试题来源
 */

var Source = function Source(_a) {
  var source = _a.source;

  if (!source) {
    return null;
  }

  source = Array.isArray(source) ? __spreadArray([], source, true) : source && [source];
  return (source === null || source === void 0 ? void 0 : source.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['card-title']
  }, "\u6765\u6E90"), /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-box']
  }, source === null || source === void 0 ? void 0 : source.map(function (val, index) {
    return typeof val === 'string' ? /*#__PURE__*/React.createElement("div", {
      className: answerStyle['source-item']
    }, val) : (val === null || val === void 0 ? void 0 : val.paperName) || /*#__PURE__*/React.createElement("div", {
      key: (val === null || val === void 0 ? void 0 : val.paperName) && (val === null || val === void 0 ? void 0 : val.paperName) + index,
      className: answerStyle['source-item']
    }, val === null || val === void 0 ? void 0 : val.paperName);
  })))) : null;
};

var style$A = {"exercise-wrapper":"tangram_C_exercise-wrapper_a57496651e","question-detail":"tangram_C_question-detail_a57496651e","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_a57496651e","card-title":"tangram_C_card-title_a57496651e","structure":"tangram_C_structure_a57496651e","full-blank":"tangram_C_full-blank_a57496651e","text-emphasis":"tangram_C_text-emphasis_a57496651e","table-wrapper":"tangram_C_table-wrapper_a57496651e","answer-wrapper":"tangram_C_answer-wrapper_a57496651e","sticker":"tangram_C_sticker_a57496651e","top-right":"tangram_C_top-right_a57496651e","bottom-right":"tangram_C_bottom-right_a57496651e","bottom-left":"tangram_C_bottom-left_a57496651e","top-left":"tangram_C_top-left_a57496651e","imgs-wrapper":"tangram_C_imgs-wrapper_a57496651e","img-wrapper":"tangram_C_img-wrapper_a57496651e","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_a57496651e","answer-box":"tangram_C_answer-box_a57496651e","knowledge-wrapper":"tangram_C_knowledge-wrapper_a57496651e","knowledge-point":"tangram_C_knowledge-point_a57496651e"};

/**
 * 答案解析
 */

var Point = function Point(_a) {
  var labelList = _a.labelList;

  if (!labelList || (labelList === null || labelList === void 0 ? void 0 : labelList.length) === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$A['card-title']
  }, "\u77E5\u8BC6\u70B9"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$A['answer-box'], " ").concat(style$A['knowledge-wrapper'])
  }, labelList === null || labelList === void 0 ? void 0 : labelList.map(function (_a) {
    var labelId = _a.labelId,
        name = _a.name;
    return /*#__PURE__*/React.createElement("span", {
      className: style$A['knowledge-point'],
      key: labelId
    }, name);
  }))));
};

/* eslint react/no-array-index-key: 0 */
/**
 * 正确答案、批改结果
 */

var Answer$3 = function Answer() {
  var answer = useContext(FillingContext).answer;

  if (!answer) {
    return null;
  }

  var parseAnswer = parseJSON(answer);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['card-title']
  }, "\u6B63\u786E\u7B54\u6848"), /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-box']
  }, parseAnswer === null || parseAnswer === void 0 ? void 0 : parseAnswer.map(function (possibleAnswer, groupIndex) {
    return /*#__PURE__*/React.createElement("div", {
      key: groupIndex
    }, possibleAnswer === null || possibleAnswer === void 0 ? void 0 : possibleAnswer.map(function (blankDetail, blankIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: blankIndex
      }, /*#__PURE__*/React.createElement("span", null, possibleAnswer.length !== 1 && "".concat(blankIndex + 1, "\u3001")), json2reactElement(blankDetail, {
        key: "answer-".concat(blankIndex),
        containerTag: 'span'
      }));
    }), /*#__PURE__*/React.createElement("span", null, groupIndex !== parseAnswer.length - 1 && '或'));
  }))));
};

var style$z = {"evaluation-wrap":"tangram_C_evaluation-wrap_34f02a94b8","result-title":"tangram_C_result-title_34f02a94b8","item-wrap":"tangram_C_item-wrap_34f02a94b8","evaluation-item":"tangram_C_evaluation-item_34f02a94b8","item-img":"tangram_C_item-img_34f02a94b8","item-title":"tangram_C_item-title_34f02a94b8","item-title-grey":"tangram_C_item-title-grey_34f02a94b8","error-grey":"tangram_C_error-grey_34f02a94b8","error-light":"tangram_C_error-light_34f02a94b8","little-grey":"tangram_C_little-grey_34f02a94b8","little-light":"tangram_C_little-light_34f02a94b8","right-grey":"tangram_C_right-grey_34f02a94b8","right-light":"tangram_C_right-light_34f02a94b8","nice-grey":"tangram_C_nice-grey_34f02a94b8","nice-light":"tangram_C_nice-light_34f02a94b8","h5-title":"tangram_C_h5-title_34f02a94b8","compound-wrapper":"tangram_C_compound-wrapper_34f02a94b8"};

var _a$7;
var evaluationData = [{
  title: '完全不对',
  noCheckedStyleName: 'error-grey',
  checkedStyleName: 'error-light',
  value: '30'
}, {
  title: '有点沾边',
  noCheckedStyleName: 'little-grey',
  checkedStyleName: 'little-light',
  value: '5'
}, {
  title: '基本正确',
  noCheckedStyleName: 'right-grey',
  checkedStyleName: 'right-light',
  value: '35'
}, {
  title: '十分正确',
  noCheckedStyleName: 'nice-grey',
  checkedStyleName: 'nice-light',
  value: '40'
}];
var evaluationStatusMap = (_a$7 = {}, _a$7[EAnswerStatus.WRONG] = 0, _a$7[EAnswerStatus.LITTLE] = 1, _a$7[EAnswerStatus.BASIC_Right] = 2, _a$7[EAnswerStatus.RIGHT] = 3, _a$7[EAnswerStatus.HALF_RIGHT] = -1, _a$7[EAnswerStatus.UN_ANSWER] = -1, _a$7[EAnswerStatus.NO_EVALUATION] = -1, _a$7[EAnswerStatus.ANSEWRED] = -1, _a$7[EAnswerStatus.RECITED] = -1, _a$7);

var SelfEvaluation = function SelfEvaluation(props) {
  var _a = props.evaluationEditable,
      evaluationEditable = _a === void 0 ? true : _a,
      questionId = props.questionId,
      _b = props.evaluationStatus,
      evaluationStatus = _b === void 0 ? EAnswerStatus.NO_EVALUATION : _b,
      onSelfEvaluationChange = props.onSelfEvaluationChange,
      compoundUse = props.compoundUse;
  var currentIndex = evaluationStatusMap[evaluationStatus];

  var evaluationChange = function evaluationChange(e) {
    if (!evaluationEditable) {
      return;
    } // @ts-ignore


    var value = e.target.dataset.value;
    onSelfEvaluationChange === null || onSelfEvaluationChange === void 0 ? void 0 : onSelfEvaluationChange(questionId, value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$z['evaluation-wrap'], " ").concat(compoundUse ? style$z['compound-wrapper'] : ''),
    key: questionId
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$z['h5-title'], " ").concat(evaluationEditable ? '' : style$z['result-title'])
  }, evaluationEditable ? '请根据答案自评' : '您的自评结果'), /*#__PURE__*/React.createElement("div", {
    className: style$z['item-wrap']
  }, evaluationData.map(function (item, keyIndex) {
    var title = item.title,
        noCheckedStyleName = item.noCheckedStyleName,
        checkedStyleName = item.checkedStyleName,
        value = item.value;
    return /*#__PURE__*/React.createElement("div", {
      className: style$z['evaluation-item'],
      key: "".concat(title).concat(questionId),
      // @ts-ignore
      // eslint-disable-next-line react/jsx-no-bind
      onClick: evaluationChange,
      role: "button",
      tabIndex: 0,
      "data-value": value
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(style$z['item-img'], " ").concat(currentIndex === keyIndex ? "".concat(style$z[checkedStyleName]) : "".concat(style$z[noCheckedStyleName])),
      "data-value": value
    }), /*#__PURE__*/React.createElement("span", {
      className: "".concat(!evaluationEditable && currentIndex !== keyIndex ? style$z['item-title-grey'] : style$z['item-title']),
      "data-value": value
    }, title));
  })));
};

var img$7 = "data:image/png;base64,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";

var style$y = {"score-edit-wrapper":"tangram_C_score-edit-wrapper_d6560cdcce","input-wrapper":"tangram_C_input-wrapper_d6560cdcce","input-main":"tangram_C_input-main_d6560cdcce","input-content":"tangram_C_input-content_d6560cdcce","score-edit-total-score":"tangram_C_score-edit-total-score_d6560cdcce","score-edit-title":"tangram_C_score-edit-title_d6560cdcce","score-show-wrapper":"tangram_C_score-show-wrapper_d6560cdcce","score-show-title":"tangram_C_score-show-title_d6560cdcce","score-show-content":"tangram_C_score-show-content_d6560cdcce","score-show-total-score":"tangram_C_score-show-total-score_d6560cdcce","compound-wrapper":"tangram_C_compound-wrapper_d6560cdcce"};

var MAX_SCORE_LEN = 6;

var SelfGraded = function SelfGraded(props) {
  var _a = props.scoreEditable,
      scoreEditable = _a === void 0 ? true : _a,
      questionId = props.questionId,
      onGradeChange = props.onGradeChange,
      onGradeBlur = props.onGradeBlur,
      scoreValue = props.scoreValue,
      maxScore = props.maxScore,
      compoundUse = props.compoundUse;

  var _b = useState(scoreValue),
      score = _b[0],
      setScore = _b[1];

  useEffect(function () {
    setScore(scoreValue);
  }, [scoreValue]);

  var handleChange = function handleChange(event) {
    var value = (event === null || event === void 0 ? void 0 : event.target).value; // 限制位数 maxLength属性无效

    if (value.length > MAX_SCORE_LEN) {
      value = value.slice(0, MAX_SCORE_LEN);
    } // 去掉非数字和小数点


    value = value.replace(/[^\d|.]/g, '') // 第一位不能是小数点
    .replace(/^\./g, '') // 去掉两个及以上连续小数点
    .replace(/\.{2,}/g, '') // 去掉第一位之后的小数点
    .replace('.', '$').replace(/\./g, '').replace('$', '.') // 保留两位数
    .replace(/^(\d+)\.(\d\d).*$/, '$1.$2');
    setScore(value);
    questionId && (onGradeChange === null || onGradeChange === void 0 ? void 0 : onGradeChange(questionId, value));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, scoreEditable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$y['score-edit-wrapper'], " ").concat(compoundUse ? style$y['compound-wrapper'] : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: style$y['score-edit-title']
  }, "\u672C\u9898\u81EA\u8BC4\u5206\u6570"), /*#__PURE__*/React.createElement("div", {
    className: style$y['input-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$y['input-main']
  }, /*#__PURE__*/React.createElement("img", {
    src: img$7,
    alt: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: style$y['input-content']
  }, /*#__PURE__*/React.createElement("span", null, score || "\u8BF7\u5728\u6B64\u8F93\u5165\u81EA\u8BC4\u5206".concat(maxScore ? "(\u6700\u9AD8".concat(maxScore, "\u5206\uFF09") : '')), /*#__PURE__*/React.createElement("input", {
    // type="number"能输入+- 即使正则也过滤不掉
    type: "text",
    value: score !== null && score !== void 0 ? score : '',
    placeholder: "\u8BF7\u5728\u6B64\u8F93\u5165\u81EA\u8BC4\u5206".concat(maxScore ? "(\u6700\u9AD8".concat(maxScore, "\u5206\uFF09") : ''),
    // eslint-disable-next-line react/jsx-no-bind
    onChange: handleChange,
    inputMode: "decimal",
    // eslint-disable-next-line react/jsx-no-bind
    onBlur: function onBlur() {
      return questionId && (onGradeBlur === null || onGradeBlur === void 0 ? void 0 : onGradeBlur(questionId, score));
    }
  })), (score || score === 0) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\u5206"), /*#__PURE__*/React.createElement("span", {
    className: style$y['score-edit-total-score']
  }, "\u6EE1\u5206".concat(maxScore, "\u5206"))))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style$y['score-show-wrapper']
  }, /*#__PURE__*/React.createElement("span", {
    className: style$y['score-show-title']
  }, "\u81EA\u8BC4\u5206\u6570"), /*#__PURE__*/React.createElement("span", {
    className: style$y['score-show-content']
  }, "".concat(score, "\u5206")), /*#__PURE__*/React.createElement("span", {
    className: style$y['score-show-total-score']
  }, "\uFF08\u6EE1\u5206".concat(maxScore, "\u5206\uFF09")))));
};

var StickerInCard = function StickerInCard(_a) {
  var _b;

  var sticker = _a.sticker,
      locModule = _a.locModule;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_b = sticker === null || sticker === void 0 ? void 0 : sticker.map(function (_a, index) {
    var location = _a.location,
        getCustomNode = _a.getCustomNode,
        data = _a.data;
    return location === locModule // eslint-disable-next-line react/no-array-index-key
    && /*#__PURE__*/React.createElement("div", {
      className: answerStyle['answer-wrapper']
    }, /*#__PURE__*/React.createElement(Sticker, {
      sticker: {
        location: location,
        getCustomNode: getCustomNode,
        data: data
      },
      key: "sticker-".concat(index)
    }));
  })) !== null && _b !== void 0 ? _b : null);
};

/**
 * 答案、解析、来源
 * @param props
 */

var AnswerInfo$3 = function AnswerInfo() {
  var _a = useContext(FillingContext),
      analysis = _a.analysis,
      source = _a.source,
      labelList = _a.labelList,
      answer = _a.answer,
      editable = _a.editable,
      alwaysShowAnswer = _a.alwaysShowAnswer,
      showEvaluation = _a.showEvaluation,
      questionId = _a.questionId,
      evaluationEditable = _a.evaluationEditable,
      evaluationStatus = _a.evaluationStatus,
      onSelfEvaluationChange = _a.onSelfEvaluationChange,
      showGraded = _a.showGraded,
      onGradeChange = _a.onGradeChange,
      onGradeBlur = _a.onGradeBlur,
      scoreValue = _a.scoreValue,
      maxScore = _a.maxScore,
      scoreEditable = _a.scoreEditable,
      compoundUse = _a.compoundUse,
      platForm = _a.platForm,
      sticker = _a.sticker;

  if (!alwaysShowAnswer && editable) {
    return null;
  }

  if (!analysis && !source && !labelList && !answer) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, !!answer && /*#__PURE__*/React.createElement(Answer$3, null), showEvaluation && /*#__PURE__*/React.createElement(SelfEvaluation, {
    questionId: questionId,
    evaluationEditable: evaluationEditable,
    evaluationStatus: evaluationStatus,
    onSelfEvaluationChange: onSelfEvaluationChange,
    compoundUse: compoundUse
  }), showGraded && /*#__PURE__*/React.createElement(SelfGraded, {
    questionId: questionId,
    scoreEditable: scoreEditable,
    onGradeChange: onGradeChange,
    onGradeBlur: onGradeBlur,
    scoreValue: scoreValue,
    maxScore: maxScore,
    compoundUse: compoundUse
  }), /*#__PURE__*/React.createElement(Analysis, {
    analysis: analysis,
    platForm: platForm
  }), /*#__PURE__*/React.createElement(StickerInCard, {
    sticker: sticker,
    locModule: EStickerLocModule.ANALYSIS_END_IN_CARD
  }), /*#__PURE__*/React.createElement(Point, {
    labelList: labelList
  }), /*#__PURE__*/React.createElement(Source, {
    source: source
  }));
};

var useSetCookie = function useSetCookie(questionId) {
  useEffect(function () {
    if (questionId) {
      js_cookie.set('questionId', "".concat(questionId));
    }
  }, [questionId]);
};

var style$x = {"exercise-wrapper":"tangram_C_exercise-wrapper_c1cf74b86b","filling-wrapper":"tangram_C_filling-wrapper_c1cf74b86b","question-detail":"tangram_C_question-detail_c1cf74b86b","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_c1cf74b86b","card-title":"tangram_C_card-title_c1cf74b86b","structure":"tangram_C_structure_c1cf74b86b","full-blank":"tangram_C_full-blank_c1cf74b86b","text-emphasis":"tangram_C_text-emphasis_c1cf74b86b","table-wrapper":"tangram_C_table-wrapper_c1cf74b86b"};

var FillingContext = /*#__PURE__*/createContext({});

var Filling = function Filling(props) {
  var logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      stem = props.stem,
      showGrade = props.showGrade,
      stemSource = props.stemSource,
      bigTypeName = props.bigTypeName,
      answerTypeList = props.answerTypeList,
      editable = props.editable,
      answerChangeCallback = props.onAnswerChange,
      userSubmitItems = props.userSubmitItems,
      questionId = props.questionId,
      onTextAreaFocus = props.onTextAreaFocus,
      onTextAreaBlur = props.onTextAreaBlur,
      sticker = props.sticker,
      subjectId = props.subjectId,
      correctType = props.correctType,
      parentLogicTypeId = props.parentLogicTypeId,
      compoundUse = props.compoundUse,
      _a = props.showSubmitInfo,
      showSubmitInfo = _a === void 0 ? true : _a,
      _b = props.showSigleQImgUpload,
      showSigleQImgUpload = _b === void 0 ? true : _b;

  var _c = useState([]),
      userAnswerList = _c[0],
      setUserAnswerList = _c[1];

  var _d = useState(),
      currentAnswerInfo = _d[0],
      setCurrentAnswerInfo = _d[1];

  var getCurrenAnswer = useCallback(function (answerInfo) {
    setCurrentAnswerInfo(answerInfo);
  }, []);
  var blankCount = useMemo(function () {
    // 计算填空题的空的数量
    var calcCount = function calcCount(stemJsonParse) {
      var counter = 0;
      var attr = stemJsonParse.attr,
          child = stemJsonParse.child; // 当前层级中的空

      if (attr === null || attr === void 0 ? void 0 : attr.vacancy) {
        counter++;
      }

      if (child) {
        counter += (child === null || child === void 0 ? void 0 : child.map(function (c, i) {
          return calcCount(c);
        })).reduce(function (pre, cur) {
          return pre + cur;
        }, 0);
      }

      return counter;
    };

    var stemJsonParse = parseJSON(stem);
    return stemJsonParse ? calcCount(stemJsonParse) : 0;
  }, [stem]);
  useSetCookie(questionId);
  useEffect(function () {
    var _a, _b; // 切换题目答案init 或者半提交回填


    if ((correctType === ECorrectType.AUTO_CORRECT || correctType === ECorrectType.AI_CORRECT) && editable) {
      var previousAnswerList = (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) && Array.isArray((_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) ? (_b = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0].resource) === null || _b === void 0 ? void 0 : _b.map(function (item) {
        return item.userAnswer;
      }) : [];
      setUserAnswerList(previousAnswerList);
    } // 切换试题, 上报业务传来的试题参数


    if (questionId) {
      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  useEffect(function () {
    if (currentAnswerInfo) {
      var answerListCopy = __spreadArray([], userAnswerList, true);

      var currentIndex = currentAnswerInfo.currentIndex,
          currentAnswer = currentAnswerInfo.currentAnswer; // for循环处理用户先答后面空格的情况

      for (var i = 0; i < blankCount; i++) {
        if (answerListCopy[currentIndex]) {
          answerListCopy.splice(currentIndex, 1, currentAnswer);
          break;
        }

        if (!answerListCopy[i]) {
          answerListCopy[i] = '';
        }
      }

      answerListCopy.splice(currentAnswerInfo.currentIndex, 1, currentAnswerInfo.currentAnswer);
      setUserAnswerList(answerListCopy);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentAnswerInfo]);
  useEffect(function () {
    if (userAnswerList.length) {
      var resourceType_1 = correctType === ECorrectType.AUTO_CORRECT || correctType === ECorrectType.AI_CORRECT ? ESubmitItemTypes.TEXT_AUTO : ESubmitItemTypes.IMAGE;
      var isPureTextAuto_1 = resourceType_1 === ESubmitItemTypes.TEXT_AUTO;
      var sendUserData = userAnswerList.map(function (item, idx) {
        return isPureTextAuto_1 ? {
          userAnswer: item,
          idx: idx + 1
        } : {
          resourceType: resourceType_1,
          resource: {
            url: item
          }
        };
      });
      answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, isPureTextAuto_1 ? sendUserData.every(function (answer) {
        return !answer.userAnswer;
      }) ? [] : [{
        resource: sendUserData,
        resourceType: resourceType_1
      }] : sendUserData); // 用户作答信息变化时上报

      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
        actionValue: JSON.stringify(sendUserData)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [userAnswerList]); // isAutoGrading改为 correctType

  var showSubmitOnAnswerComp = showSubmitInfo && [ECorrectType.SELF_CORRECT, ECorrectType.SELF_CORRECT_LEVEL, ECorrectType.TEACHER_CORRECT].includes(correctType !== null && correctType !== void 0 ? correctType : ECorrectType.TEACHER_CORRECT); // 当前我的回答不支持自动判题的数据格式

  var getFormatItems = function getFormatItems(userSubmitItems) {
    if (parentLogicTypeId === ELogicTypeId.FILL_ON_BLANK) {
      return userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.map(function (item) {
        var _a, _b;

        return (item === null || item === void 0 ? void 0 : item.resourceType) === ESubmitItemTypes.TEXT_AUTO ? _assign$4(_assign$4({}, item), {
          resourceType: ESubmitItemTypes.TEXT,
          // @ts-ignore
          resource: (_b = (_a = item === null || item === void 0 ? void 0 : item.resource) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.userAnswer
        }) : item;
      });
    }

    return userSubmitItems;
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: "\n                    ".concat(style$x['filling-wrapper'], "\n                    ").concat(compoundUse ? style$x['compound-sub-card-between-space'] : '', "\n                    single-question-item\n                ")
  }, /*#__PURE__*/React.createElement(FillingContext.Provider, {
    value: _assign$4(_assign$4({}, props), {
      getCurrenAnswer: getCurrenAnswer,
      showSubmitOnAnswerComp: showSubmitOnAnswerComp,
      showSubmitInfo: showSubmitInfo
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: style$x['question-detail'],
    style: {
      borderRadius: "".concat(compoundUse ? '0 0 10px 10px' : '10px')
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    parentLogicTypeId: parentLogicTypeId
  }), /*#__PURE__*/React.createElement(Stem, {
    questionId: questionId,
    stem: stem,
    subjectId: subjectId,
    source: stemSource,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    editable: editable
  }), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (_a, index) {
    var location = _a.location,
        getCustomNode = _a.getCustomNode,
        data = _a.data;
    return location === EStickerLocModule.ANSWERINFO && /*#__PURE__*/React.createElement(Sticker // eslint-disable-next-line react/no-array-index-key
    , {
      // eslint-disable-next-line react/no-array-index-key
      sticker: {
        location: location,
        getCustomNode: getCustomNode,
        data: data
      },
      key: "".concat(questionId).concat(index)
    });
  }), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (_a, index) {
    var location = _a.location,
        getCustomNode = _a.getCustomNode,
        data = _a.data; // 自动判题的填空题，answerInfoEnd位置的sticker应放在这个位置，否则会不展示

    return location === EStickerLocModule.ANSWERINFOEND && (correctType === ECorrectType.AUTO_CORRECT || correctType === ECorrectType.AI_CORRECT) && /*#__PURE__*/React.createElement(Sticker, {
      sticker: {
        location: location,
        getCustomNode: getCustomNode,
        data: data
      },
      // eslint-disable-next-line react/no-array-index-key
      key: "".concat(questionId).concat(index)
    });
  })), /*#__PURE__*/React.createElement(React.Fragment, null, showSubmitOnAnswerComp && /*#__PURE__*/React.createElement(MultiAnswer, {
    editable: editable,
    userSubmitItems: getFormatItems(userSubmitItems),
    questionId: questionId,
    answerTypeList: answerTypeList,
    showSigleQImgUpload: showSigleQImgUpload,
    onAnswerChange: answerChangeCallback,
    onEditorFocus: onTextAreaFocus,
    onEditorBlur: onTextAreaBlur,
    sticker: sticker
  }), /*#__PURE__*/React.createElement(AnswerInfo$3, null)))));
};

var style$w = {"exercise-wrapper":"tangram_C_exercise-wrapper_6b5ef5613a","compound-wrapper":"tangram_C_compound-wrapper_6b5ef5613a","compound-wrapper-pc":"tangram_C_compound-wrapper-pc_6b5ef5613a","question-detail":"tangram_C_question-detail_6b5ef5613a","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_6b5ef5613a","card-title":"tangram_C_card-title_6b5ef5613a","structure":"tangram_C_structure_6b5ef5613a","full-blank":"tangram_C_full-blank_6b5ef5613a","text-emphasis":"tangram_C_text-emphasis_6b5ef5613a","table-wrapper":"tangram_C_table-wrapper_6b5ef5613a","m-child-wrapper":"tangram_C_m-child-wrapper_6b5ef5613a","card-head":"tangram_C_card-head_6b5ef5613a","dividing-space-compound":"tangram_C_dividing-space-compound_6b5ef5613a","compound-stem":"tangram_C_compound-stem_6b5ef5613a","pc-dividing":"tangram_C_pc-dividing_6b5ef5613a","pc-child-wrapper":"tangram_C_pc-child-wrapper_6b5ef5613a","parent-nograde":"tangram_C_parent-nograde_6b5ef5613a"};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject$2(obj) {
  return obj !== null && _typeof$1(obj) === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend$2() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}

var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}

var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }
};

function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend$2(win, ssrWindow);
  return win;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable no-proto */

function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inherits(Dom7, _Array);

  var _super = _createSuper(Dom7);

  function Dom7(items) {
    var _this;

    _classCallCheck(this, Dom7);

    if (typeof items === 'number') {
      _this = _super.call(this, items);
    } else {
      _this = _super.call.apply(_super, [this].concat(_toConsumableArray(items || [])));
      makeReactive(_assertThisInitialized(_this));
    }

    return _possibleConstructorReturn(_this);
  }

  return _createClass(Dom7);
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, _toConsumableArray(arrayFlat(el)));
    } else {
      res.push(el);
    }
  });
  return res;
}

function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}

function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}


function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var _html = selector.trim();

    if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (_html.indexOf('<li') === 0) toCreate = 'ul';
      if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
      if (_html.indexOf('<tbody') === 0) toCreate = 'table';
      if (_html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = _html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype; // eslint-disable-next-line

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classNames));
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classNames));
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? "".concat(duration, "ms") : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;

    var _scrollTop = el === window ? window.scrollY : el.scrollTop;

    var _scrollLeft = el === window ? window.scrollX : el.scrollLeft;

    return {
      top: box.top + _scrollTop - clientTop,
      left: box.left + _scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index$1() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index$1,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return _typeof$1(o) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$1() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll(_ref) {
  var swiper = _ref.swiper,
      targetPosition = _ref.targetPosition,
      side = _ref.side;
  var window = getWindow();
  var startPosition = -swiper.translate;
  var startTime = null;
  var time;
  var duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  var dir = targetPosition > startPosition ? 'next' : 'prev';

  var isOutOfBound = function isOutOfBound(current, target) {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  var animate = function animate() {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo(_defineProperty$1({}, side, currentPosition));

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(function () {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo(_defineProperty$1({}, side, currentPosition));
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var deviceCached;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}

var browser;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

function Resize(_ref) {
  var swiper = _ref.swiper,
      on = _ref.on,
      emit = _ref.emit;
  var window = getWindow();
  var observer = null;
  var animationFrame = null;

  var resizeHandler = function resizeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  var createObserver = function createObserver() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(function (entries) {
      animationFrame = window.requestAnimationFrame(function () {
        var width = swiper.width,
            height = swiper.height;
        var newWidth = width;
        var newHeight = height;
        entries.forEach(function (_ref2) {
          var contentBoxSize = _ref2.contentBoxSize,
              contentRect = _ref2.contentRect,
              target = _ref2.target;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  var removeObserver = function removeObserver() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  var orientationChangeHandler = function orientationChangeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', function () {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', function () {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  var swiper = _ref.swiper,
      extendParams = _ref.extendParams,
      on = _ref.on,
      emit = _ref.emit;
  var observers = [];
  var window = getWindow();

  var attach = function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  var init = function init() {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  var destroy = function destroy() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(_toConsumableArray(data)));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  var slideSize;
  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function (key) {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = "";
      }

      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = "".concat(slideSize, "px");
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css(_defineProperty$1({}, getDirectionLabel('width'), "".concat(swiper.virtualSize + params.spaceBetween, "px")));
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    var newSlidesGrid = [];

    for (var _i = 0; _i < snapGrid.length; _i += 1) {
      var slidesGridItem = snapGrid[_i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css(_defineProperty$1({}, key, "".concat(spaceBetween, "px")));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
    var addToSnapGrid = -swiper.snapGrid[0];
    var addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(function (v) {
      return v + addToSnapGrid;
    });
    swiper.slidesGrid = swiper.slidesGrid.map(function (v) {
      return v + addToSlidesGrid;
    });
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
    var hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || $([])).each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate,
      snapGrid = swiper.snapGrid;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    var slideBefore = -(offsetCenter - slideOffset);
    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(activeIndex, "\"]"));
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]")).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(nextSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(prevSlide.attr('data-swiper-slide-index'), "\"]")).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e).closest(".".concat(params.slideClass))[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      var _wrapperEl$scrollTo;

      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty$1(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty$1(_wrapperEl$scrollTo, "behavior", 'smooth'), _wrapperEl$scrollTo));
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  var swiper = _ref.swiper,
      runCallbacks = _ref.runCallbacks,
      direction = _ref.direction,
      step = _ref.step;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit("transition".concat(step));

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit("slideResetTransition".concat(step));
      return;
    }

    swiper.emit("slideChangeTransition".concat(step));

    if (dir === 'next') {
      swiper.emit("slideNextTransition".concat(step));
    } else {
      swiper.emit("slidePrevTransition".concat(step));
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'End'
  });
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(_typeof$1(index), "] given."));
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = rtl ? translate : -translate;

    if (speed === 0) {
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(function () {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      var _wrapperEl$scrollTo;

      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper: swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty$1(_wrapperEl$scrollTo, isH ? 'left' : 'top', t), _defineProperty$1(_wrapperEl$scrollTo, "behavior", 'smooth'), _wrapperEl$scrollTo));
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var animating = swiper.animating,
      enabled = swiper.enabled,
      params = swiper.params;
  if (!enabled) return swiper;
  var perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    var prevSnapIndex;
    snapGrid.forEach(function (snap, snapIndex) {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  var prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(".".concat(params.slideClass, "[data-swiper-slide-index=\"").concat(realIndex, "\"]:not(.").concat(params.slideDuplicateClass, ")")).eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  var $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
  var slides = $selector.children(".".concat(params.slideClass));

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
        $selector.append(blankNode);
      }

      slides = $selector.children(".".concat(params.slideClass));
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    $(el).attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < swiper.loopedSlides; _i += 1) {
    var index = _i - Math.floor(_i / slides.length) * slides.length;

    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (var _i2 = 0; _i2 < appendSlides.length; _i2 += 1) {
    $selector.append($(appendSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i3 = prependSlides.length - 1; _i3 >= 0; _i3 -= 1) {
    $selector.prepend($(prependSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!$(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      slidesGrid = swiper.slidesGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    var pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos: currentPos
    });
    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  var rewindFirstIndex = null;
  var rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

var events = function events(swiper, method) {
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested;
  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  var swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture: capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  var swiper = this;
  events(swiper, 'off');
}

var events$1 = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

var isGridEnabled = function isGridEnabled(swiper, params) {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = isGridEnabled(swiper, params);
  var isMultiRow = isGridEnabled(swiper, breakpointParams);
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass("".concat(params.containerModifierClass, "grid ").concat(params.containerModifierClass, "grid-column"));
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass("".concat(params.containerModifierClass, "grid"));

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass("".concat(params.containerModifierClass, "grid-column"));
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(function (prop) {
    var wasModuleEnabled = params[prop] && params[prop].enabled;
    var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (_typeof$1(item) === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push.apply(classNames, _toConsumableArray(suffixes));
  $el.addClass(_toConsumableArray(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked,
      params = swiper.params;
  var slidesOffsetBefore = params.slidesOffsetBefore;

  if (slidesOffsetBefore) {
    var lastSlideIndex = swiper.slides.length - 1;
    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }

    var moduleParamName = Object.keys(obj)[0];
    var moduleParams = obj[moduleParamName];

    if (_typeof$1(moduleParams) !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (_typeof$1(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

var prototypes = {
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  events: events$1,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper$1 = /*#__PURE__*/function () {
  function Swiper() {
    _classCallCheck(this, Swiper);

    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = _toConsumableArray(swiper.__modules__);

    if (params.modules && Array.isArray(params.modules)) {
      var _swiper$modules;

      (_swiper$modules = swiper.modules).push.apply(_swiper$modules, _toConsumableArray(params.modules));
    }

    var allModulesParams = {};
    swiper.modules.forEach(function (mod) {
      mod({
        swiper: swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    var swiperParams = extend$1({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  _createClass(Swiper, [{
    key: "enable",
    value: function enable() {
      var swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;

      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      swiper.emit('enable');
    }
  }, {
    key: "disable",
    value: function disable() {
      var swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;

      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }

      swiper.emit('disable');
    }
  }, {
    key: "setProgress",
    value: function setProgress(progress, speed) {
      var swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      var min = swiper.minTranslate();
      var max = swiper.maxTranslate();
      var current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }, {
    key: "emitContainerClasses",
    value: function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var cls = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', cls.join(' '));
    }
  }, {
    key: "getSlideClasses",
    value: function getSlideClasses(slideEl) {
      var swiper = this;
      if (swiper.destroyed) return '';
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    }
  }, {
    key: "emitSlidesClasses",
    value: function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var updates = [];
      swiper.slides.each(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl: slideEl,
          classNames: classNames
        });
        swiper.emit('_slideClass', slideEl, classNames);
      });
      swiper.emit('_slideClasses', updates);
    }
  }, {
    key: "slidesPerViewDynamic",
    value: function slidesPerViewDynamic(view, exact) {
      if (view === void 0) {
        view = 'current';
      }

      if (exact === void 0) {
        exact = false;
      }

      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          slidesSizesGrid = swiper.slidesSizesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;
      var spv = 1;

      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;

        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }

        for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
          if (slides[_i] && !breakLoop) {
            slideSize += slides[_i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        // eslint-disable-next-line
        if (view === 'current') {
          for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
            var slideInView = exact ? slidesGrid[_i2] + slidesSizesGrid[_i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize;

            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          // previous
          for (var _i3 = activeIndex - 1; _i3 >= 0; _i3 -= 1) {
            var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i3] < swiperSize;

            if (_slideInView) {
              spv += 1;
            }
          }
        }
      }

      return spv;
    }
  }, {
    key: "update",
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      var translated;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
        setTranslate();

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }

        if (!translated) {
          setTranslate();
        }
      }

      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }

      swiper.emit('update');
    }
  }, {
    key: "changeDirection",
    value: function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }

      var swiper = this;
      var currentDirection = swiper.params.direction;

      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }

      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.each(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    }
  }, {
    key: "changeLanguageDirection",
    value: function changeLanguageDirection(direction) {
      var swiper = this;
      if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
      swiper.rtl = direction === 'rtl';
      swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

      if (swiper.rtl) {
        swiper.$el.addClass("".concat(swiper.params.containerModifierClass, "rtl"));
        swiper.el.dir = 'rtl';
      } else {
        swiper.$el.removeClass("".concat(swiper.params.containerModifierClass, "rtl"));
        swiper.el.dir = 'ltr';
      }

      swiper.update();
    }
  }, {
    key: "mount",
    value: function mount(el) {
      var swiper = this;
      if (swiper.mounted) return true; // Find el

      var $el = $(el || swiper.params.el);
      el = $el[0];

      if (!el) {
        return false;
      }

      el.swiper = swiper;

      var getWrapperSelector = function getWrapperSelector() {
        return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
      };

      var getWrapper = function getWrapper() {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

          res.children = function (options) {
            return $el.children(options);
          };

          return res;
        }

        if (!$el.children) {
          return $($el).children(getWrapperSelector());
        }

        return $el.children(getWrapperSelector());
      }; // Find Wrapper


      var $wrapperEl = getWrapper();

      if ($wrapperEl.length === 0 && swiper.params.createElements) {
        var document = getDocument();
        var wrapper = document.createElement('div');
        $wrapperEl = $(wrapper);
        wrapper.className = swiper.params.wrapperClass;
        $el.append(wrapper);
        $el.children(".".concat(swiper.params.slideClass)).each(function (slideEl) {
          $wrapperEl.append(slideEl);
        });
      }

      Object.assign(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box'
      });
      return true;
    }
  }, {
    key: "init",
    value: function init(el) {
      var swiper = this;
      if (swiper.initialized) return swiper;
      var mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit('beforeInit'); // Set breakpoint

      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      } // Add Classes


      swiper.addClasses(); // Create loop

      if (swiper.params.loop) {
        swiper.loopCreate();
      } // Update size


      swiper.updateSize(); // Update slides

      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      } // Set Grab Cursor


      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      } // Slide To Initial Slide


      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      } // Attach events


      swiper.attachEvents(); // Init Flag

      swiper.initialized = true; // Emit

      swiper.emit('init');
      swiper.emit('afterInit');
      return swiper;
    }
  }, {
    key: "destroy",
    value: function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }

      if (cleanStyles === void 0) {
        cleanStyles = true;
      }

      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy'); // Init Flag

      swiper.initialized = false; // Detach events

      swiper.detachEvents(); // Destroy loop

      if (params.loop) {
        swiper.loopDestroy();
      } // Cleanup styles


      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');

        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
      }

      swiper.emit('destroy'); // Detach emitter events

      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        deleteProps(swiper);
      }

      swiper.destroyed = true;
      return null;
    }
  }], [{
    key: "extendDefaults",
    value: function extendDefaults(newDefaults) {
      extend$1(extendedDefaults, newDefaults);
    }
  }, {
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }, {
    key: "installModule",
    value: function installModule(mod) {
      if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
      var modules = Swiper.prototype.__modules__;

      if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
  }, {
    key: "use",
    value: function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }

      Swiper.installModule(module);
      return Swiper;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);

function Virtual(_ref) {
  var swiper = _ref.swiper,
      extendParams = _ref.extendParams,
      on = _ref.on,
      emit = _ref.emit;
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  var cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    var params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"".concat(swiper.params.slideClass, "\" data-swiper-slide-index=\"").concat(index, "\">").concat(slide, "</div>"));
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        previousOffset = _swiper$virtual.offset;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    var activeIndex = swiper.activeIndex || 0;
    var offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    var slidesAfter;
    var slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, "".concat(offset, "px"));
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];

          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    var prependIndexes = [];
    var appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]")).remove();
        }
      }
    }

    for (var _i = 0; _i < slides.length; _i += 1) {
      if (_i >= from && _i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i);
        } else {
          if (_i > previousTo) appendIndexes.push(_i);
          if (_i < previousFrom) prependIndexes.push(_i);
        }
      }
    }

    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, "".concat(offset, "px"));
    onRendered();
  }

  function appendSlide(slides) {
    if (_typeof$1(slides) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        var $cachedEl = cache[cachedIndex];
        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', function () {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', function () {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(function () {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', function () {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', "".concat(swiper.virtualSize, "px"));
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
    update: update
  });
}

function isObject(o) {
  return _typeof$1(o) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

function getParams(obj, splitEvents) {
  if (obj === void 0) {
    obj = {};
  }

  if (splitEvents === void 0) {
    splitEvents = true;
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  var plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(function (key) {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
      } else {
        params.on["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
      className: "".concat(child.props.className || '', " ").concat(swiperParams.slideDuplicateClass)
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React.createElement("div", {
          className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];

  for (var _i = 0; _i < loopedSlides; _i += 1) {
    var index = _i - Math.floor(_i / modifiedSlides.length) * modifiedSlides.length;

    appendSlides.push(duplicateSlide(modifiedSlides[index], _i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], _i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, _toConsumableArray(modifiedSlides), appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    var oldChildrenKeys = oldChildren.map(getKey);
    var childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? _defineProperty$1({}, swiper.rtlTranslate ? 'right' : 'left', "".concat(virtualData.offset, "px")) : {
    top: "".concat(virtualData.offset, "px")
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

var updateOnVirtualData = function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

var SwiperSlideContext = /*#__PURE__*/createContext(null);
var SwiperContext = /*#__PURE__*/createContext(null);

var _excluded$1 = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}
var Swiper = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var eventsAssigned = false;

  var _useState = useState('swiper'),
      _useState2 = _slicedToArray(_useState, 2),
      containerClasses = _useState2[0],
      setContainerClasses = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      virtualData = _useState4[0],
      setVirtualData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      breakpointChanged = _useState6[0],
      setBreakpointChanged = _useState6[1];

  var initializedRef = useRef(false);
  var swiperElRef = useRef(null);
  var swiperRef = useRef(null);
  var oldPassedParamsRef = useRef(null);
  var oldSlides = useRef(null);
  var nextElRef = useRef(null);
  var prevElRef = useRef(null);
  var paginationElRef = useRef(null);
  var scrollbarElRef = useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  var initSwiper = function initSwiper() {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        slides: slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, function (c) {
      return c.key;
    });
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React.createElement(Tag, _extends$1({
    ref: swiperElRef,
    className: uniqueClasses("".concat(containerClasses).concat(className ? " ".concat(className) : ''))
  }, restProps), /*#__PURE__*/React.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
var SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutProperties(_ref, _excluded);

  var slideElRef = useRef(null);

  var _useState = useState('swiper-slide'),
      _useState2 = _slicedToArray(_useState, 2),
      slideClasses = _useState2[0],
      setSlideClasses = _useState2[1];

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses("".concat(slideClasses).concat(className ? " ".concat(className) : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

/**
 * 答案解析
 */

var Answer$2 = function Answer() {
  var _a;

  var _b = useContext(Context$2),
      answer = _b.answer,
      questionId = _b.questionId;

  var parseAnswer = parseJSON(answer);
  return (parseAnswer === null || parseAnswer === void 0 ? void 0 : parseAnswer.length) && ((_a = parseAnswer[0]) === null || _a === void 0 ? void 0 : _a.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['card-title']
  }, "\u6B63\u786E\u7B54\u6848"), /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-box']
  }, parseAnswer === null || parseAnswer === void 0 ? void 0 : parseAnswer.map(function (answer, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("span", {
        key: index
      }, answer === null || answer === void 0 ? void 0 : answer.map(function (structure, key) {
        return json2reactElement(structure, {
          key: "".concat(questionId, "-").concat(key),
          richTextLocation: ERichTextLocation.ANSWER
        });
      }), index < parseAnswer.length - 1 && /*#__PURE__*/React.createElement(React.Fragment, null, "\u6216nbsp;"))
    );
  })))) : null;
};

var ShowAnswerArea = function ShowAnswerArea() {
  var _a = useContext(Context$2),
      answer = _a.answer,
      analysis = _a.analysis,
      labelList = _a.labelList,
      source = _a.source,
      editable = _a.editable,
      showEvaluation = _a.showEvaluation,
      questionId = _a.questionId,
      evaluationEditable = _a.evaluationEditable,
      evaluationStatus = _a.evaluationStatus,
      onSelfEvaluationChange = _a.onSelfEvaluationChange,
      showGraded = _a.showGraded,
      onGradeChange = _a.onGradeChange,
      onGradeBlur = _a.onGradeBlur,
      scoreValue = _a.scoreValue,
      maxScore = _a.maxScore,
      scoreEditable = _a.scoreEditable,
      compoundUse = _a.compoundUse,
      platForm = _a.platForm,
      sticker = _a.sticker;

  if (editable) {
    return null;
  }

  if (!answer && !analysis && !source && !labelList) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, !!answer && /*#__PURE__*/React.createElement(Answer$2, null), showEvaluation && /*#__PURE__*/React.createElement(SelfEvaluation, {
    questionId: questionId,
    evaluationEditable: evaluationEditable,
    evaluationStatus: evaluationStatus,
    onSelfEvaluationChange: onSelfEvaluationChange,
    compoundUse: compoundUse
  }), showGraded && /*#__PURE__*/React.createElement(SelfGraded, {
    questionId: questionId,
    scoreEditable: scoreEditable,
    onGradeChange: onGradeChange,
    onGradeBlur: onGradeBlur,
    scoreValue: scoreValue,
    maxScore: maxScore,
    compoundUse: compoundUse
  }), /*#__PURE__*/React.createElement(Analysis, {
    analysis: analysis,
    platForm: platForm
  }), /*#__PURE__*/React.createElement(StickerInCard, {
    sticker: sticker,
    locModule: EStickerLocModule.ANALYSIS_END_IN_CARD
  }), /*#__PURE__*/React.createElement(Point, {
    labelList: labelList
  }), /*#__PURE__*/React.createElement(Source, {
    source: source
  }));
};

var style$v = {"exercise-wrapper":"tangram_C_exercise-wrapper_b60060ae43","explain-wrapper":"tangram_C_explain-wrapper_b60060ae43","question-detail":"tangram_C_question-detail_b60060ae43","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_b60060ae43","card-title":"tangram_C_card-title_b60060ae43","structure":"tangram_C_structure_b60060ae43","full-blank":"tangram_C_full-blank_b60060ae43","text-emphasis":"tangram_C_text-emphasis_b60060ae43","table-wrapper":"tangram_C_table-wrapper_b60060ae43"};

var Context$2 = /*#__PURE__*/createContext({});

var Explain = function Explain(props) {
  var logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      showGrade = props.showGrade,
      stem = props.stem,
      editable = props.editable,
      onAnswerChange = props.onAnswerChange,
      userSubmitItems = props.userSubmitItems,
      questionId = props.questionId,
      bigTypeName = props.bigTypeName,
      answerTypeList = props.answerTypeList,
      subjectId = props.subjectId,
      onTextAreaFocus = props.onTextAreaFocus,
      onTextAreaBlur = props.onTextAreaBlur,
      sticker = props.sticker,
      parentLogicTypeId = props.parentLogicTypeId,
      compoundUse = props.compoundUse,
      showSubmitInfo = props.showSubmitInfo,
      _a = props.showSigleQImgUpload,
      showSigleQImgUpload = _a === void 0 ? true : _a,
      stemSource = props.stemSource;
  useSetCookie(questionId);
  useEffect(function () {
    if (questionId) {
      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: "\n                    ".concat(style$v['explain-wrapper'], "\n                    single-question-item\n                    ").concat(compoundUse ? style$v['compound-sub-card-between-space'] : '', "\n                ")
  }, /*#__PURE__*/React.createElement("div", {
    className: style$v['question-detail'],
    style: {
      borderRadius: "".concat(compoundUse ? '0 0 10px 10px' : '10px')
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    parentLogicTypeId: parentLogicTypeId
  }), /*#__PURE__*/React.createElement(Stem, {
    questionId: questionId,
    stem: stem,
    subjectId: subjectId,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    editable: editable,
    source: stemSource
  }), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (_a, index) {
    var location = _a.location,
        getCustomNode = _a.getCustomNode,
        data = _a.data;
    return location === EStickerLocModule.ANSWERINFO && /*#__PURE__*/React.createElement(Sticker, {
      sticker: {
        location: location,
        getCustomNode: getCustomNode,
        data: data
      },
      // eslint-disable-next-line react/no-array-index-key
      key: "".concat(questionId).concat(index)
    });
  })), /*#__PURE__*/React.createElement(Context$2.Provider, {
    value: _assign$4({}, props)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, (editable || showSubmitInfo) && /*#__PURE__*/React.createElement(MultiAnswer, {
    editable: editable,
    answerTypeList: answerTypeList,
    userSubmitItems: userSubmitItems,
    questionId: questionId,
    subjectId: subjectId,
    showSigleQImgUpload: showSigleQImgUpload,
    onAnswerChange: onAnswerChange,
    onEditorFocus: onTextAreaFocus,
    onEditorBlur: onTextAreaBlur,
    sticker: sticker
  }), /*#__PURE__*/React.createElement(ShowAnswerArea, null)))));
};

var style$u = {"exercise-wrapper":"tangram_C_exercise-wrapper_f41ad78c49","question-detail":"tangram_C_question-detail_f41ad78c49","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_f41ad78c49","card-title":"tangram_C_card-title_f41ad78c49","structure":"tangram_C_structure_f41ad78c49","full-blank":"tangram_C_full-blank_f41ad78c49","text-emphasis":"tangram_C_text-emphasis_f41ad78c49","table-wrapper":"tangram_C_table-wrapper_f41ad78c49","answer-wrapper":"tangram_C_answer-wrapper_f41ad78c49","sticker":"tangram_C_sticker_f41ad78c49","top-right":"tangram_C_top-right_f41ad78c49","bottom-right":"tangram_C_bottom-right_f41ad78c49","bottom-left":"tangram_C_bottom-left_f41ad78c49","top-left":"tangram_C_top-left_f41ad78c49","imgs-wrapper":"tangram_C_imgs-wrapper_f41ad78c49","img-wrapper":"tangram_C_img-wrapper_f41ad78c49","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_f41ad78c49","answer-box":"tangram_C_answer-box_f41ad78c49","correct-answer":"tangram_C_correct-answer_f41ad78c49","user-answer":"tangram_C_user-answer_f41ad78c49"};

/**
 * 正确答案、用户答案
 */

var Answer$1 = function Answer() {
  var answerContextProps = useContext(JudgeContext);
  var correctAnswer = answerContextProps.correctAnswer,
      userAnswer = answerContextProps.userAnswer;

  if (!correctAnswer) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$u['card-title']
  }, "\u7B54\u9898\u7ED3\u679C"), /*#__PURE__*/React.createElement("div", {
    className: style$u['answer-box']
  }, correctAnswer && /*#__PURE__*/React.createElement("span", {
    className: style$u['correct-answer']
  }, "\u6B63\u786E\u7B54\u6848\uFF1A", /*#__PURE__*/React.createElement("strong", null, correctAnswer)), userAnswer && correctAnswer && /*#__PURE__*/React.createElement("span", {
    className: "\n                            ".concat(style$u['user-answer'], "\n                            ").concat(correctAnswer === userAnswer ? style$u['correct-answer'] : '', "\n                        ")
  }, "\u4F60\u7684\u7B54\u6848\uFF1A", /*#__PURE__*/React.createElement("strong", null, userAnswer))));
};

/**
 * 答案、解析、来源
 * @param props
 */

var AnswerInfo$2 = function AnswerInfo() {
  var _a, _b;

  var answerInfoContextProps = useContext(JudgeContext);
  var analysis = answerInfoContextProps.analysis,
      editable = answerInfoContextProps.editable,
      source = answerInfoContextProps.source,
      labelList = answerInfoContextProps.labelList,
      correctAnswer = answerInfoContextProps.correctAnswer,
      platForm = answerInfoContextProps.platForm,
      sticker = answerInfoContextProps.sticker;

  if (editable) {
    return null;
  }

  if (!((_b = (_a = parseJSON(analysis)) === null || _a === void 0 ? void 0 : _a.child) === null || _b === void 0 ? void 0 : _b.length) && !source && !labelList && !correctAnswer) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Answer$1, null), /*#__PURE__*/React.createElement(Analysis, {
    analysis: analysis,
    platForm: platForm
  }), /*#__PURE__*/React.createElement(StickerInCard, {
    sticker: sticker,
    locModule: EStickerLocModule.ANALYSIS_END_IN_CARD
  }), /*#__PURE__*/React.createElement(Point, {
    labelList: labelList
  }), /*#__PURE__*/React.createElement(Source, {
    source: source
  }));
};

var style$t = {"exercise-wrapper":"tangram_C_exercise-wrapper_be96776603","question-detail":"tangram_C_question-detail_be96776603","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_be96776603","card-title":"tangram_C_card-title_be96776603","structure":"tangram_C_structure_be96776603","full-blank":"tangram_C_full-blank_be96776603","text-emphasis":"tangram_C_text-emphasis_be96776603","table-wrapper":"tangram_C_table-wrapper_be96776603","option-wrapper":"tangram_C_option-wrapper_be96776603","option-item":"tangram_C_option-item_be96776603","option-title":"tangram_C_option-title_be96776603","option-text":"tangram_C_option-text_be96776603","option-correct":"tangram_C_option-correct_be96776603","option-wrong":"tangram_C_option-wrong_be96776603","option-unselect":"tangram_C_option-unselect_be96776603","option-selected":"tangram_C_option-selected_be96776603"};

var THROTTLE_TIME$1 = 500;
var ESingleOptionStateTypes$1;

(function (ESingleOptionStateTypes) {
  ESingleOptionStateTypes["NORMAL_OPTION"] = "NORMAL_OPTION";
  ESingleOptionStateTypes["CORRECT_OPTION"] = "CORRECT";
  ESingleOptionStateTypes["USER_WRONG_OPTION"] = "USER_WRONG_OPTION";
  ESingleOptionStateTypes["UNSELECT_OPTION"] = "UNSELECT_OPTION";
})(ESingleOptionStateTypes$1 || (ESingleOptionStateTypes$1 = {}));

var A$2 = 65;
/**
 * @param props 选项组件
 */

var JudgeOptions = function JudgeOptions() {
  var _a, _b;

  var _c = useContext(JudgeContext),
      options = _c.options,
      userSubmitItems = _c.userSubmitItems,
      editable = _c.editable,
      answer = _c.answer,
      answerChangeCallback = _c.onAnswerChange,
      questionId = _c.questionId;

  var choseList = (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.map(function (item) {
    return item.resource;
  })) || [];
  var optionsList = ((_a = parseJSON(options)) === null || _a === void 0 ? void 0 : _a.map(function (option, index) {
    var _a, _b;

    return {
      optionIndex: String.fromCharCode(A$2 + index),
      optionContent: ((_b = (_a = option === null || option === void 0 ? void 0 : option.child) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text) || index.toString(),
      body: option
    };
  })) || [];
  var mutipleCorrectAnswers = answer ? (_b = parseJSON(answer)) === null || _b === void 0 ? void 0 : _b.map(function (ans) {
    return ans === null || ans === void 0 ? void 0 : ans.map(function (structure) {
      var _a, _b;

      return ((_b = (_a = structure === null || structure === void 0 ? void 0 : structure.child) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text) || '';
    }).join('');
  }) : null;
  var correctAnswers = mutipleCorrectAnswers === null || mutipleCorrectAnswers === void 0 ? void 0 : mutipleCorrectAnswers.join('');

  var updateUserSubmit = function updateUserSubmit(choseList) {
    // 每次选择将数据吐出,返还业务
    var sendDataToUser = choseList.sort().map(function (item) {
      return {
        resource: item,
        resourceType: ESubmitItemTypes.OPTION
      };
    });
    answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, sendDataToUser);
  };

  var choseOption = function choseOption(option) {
    if (!editable) {
      return false;
    } // 点击选项三级上报


    footPrintDetailReport({
      detailAction: '判断题选项点击',
      actionValue: "".concat(option.optionContent)
    }); // 数据返回二级上报

    footPrintSecondaryReport({
      secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
      actionValue: JSON.stringify([{
        content: option.optionContent,
        type: ESubmitItemTypes.TEXT
      }])
    });
    updateUserSubmit([option.optionContent]);
  };

  var getOptionStyle = function getOptionStyle(option) {
    var _a; // 可作答


    if (editable) {
      return "\n                ".concat(style$t['option-item'], "\n                ").concat(choseList.includes(option.optionContent) && style$t['option-selected'], "\n            ");
    } // 单选题的对错有两种可能:1.是正确选项,则展示正确的样式2.是用户选择的错误选项,则展示错误的样式


    var optionState = ESingleOptionStateTypes$1.NORMAL_OPTION; // 没有传答案数据，未批改情况

    if (!correctAnswers) {
      return "\n            ".concat(style$t['option-item'], "\n            ").concat((userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && option.optionContent === userSubmitItems[0].resource && style$t['option-selected'], "\n        ");
    }

    var isUserSelected = (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && option.optionContent === userSubmitItems[0].resource;
    optionState = isUserSelected ? (correctAnswers === null || correctAnswers === void 0 ? void 0 : correctAnswers.includes(option.optionContent)) ? ESingleOptionStateTypes$1.CORRECT_OPTION : ESingleOptionStateTypes$1.USER_WRONG_OPTION : ESingleOptionStateTypes$1.UNSELECT_OPTION;
    var singleOptionMap = (_a = {}, _a[ESingleOptionStateTypes$1.NORMAL_OPTION] = '', _a[ESingleOptionStateTypes$1.CORRECT_OPTION] = style$t['option-correct'], _a[ESingleOptionStateTypes$1.USER_WRONG_OPTION] = style$t['option-wrong'], _a[ESingleOptionStateTypes$1.UNSELECT_OPTION] = style$t['option-unselect'], _a);
    return "\n            ".concat(style$t['option-item'], "\n            ").concat(singleOptionMap[optionState], "\n        ");
  };

  return (optionsList === null || optionsList === void 0 ? void 0 : optionsList.length) ? /*#__PURE__*/React.createElement("div", {
    className: style$t['option-wrapper']
  }, optionsList.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.optionIndex,
      role: "button",
      tabIndex: 0,
      onClick: throttle(function () {
        return choseOption(option);
      }, THROTTLE_TIME$1),
      className: getOptionStyle(option)
    }, /*#__PURE__*/React.createElement("div", {
      className: style$t['option-title'],
      style: {
        borderRadius: '50%'
      }
    }, /*#__PURE__*/React.createElement("span", null, option.optionIndex)), /*#__PURE__*/React.createElement("div", {
      className: style$t['option-text']
    }, json2reactElement(option.body, {
      key: "".concat(questionId, "-").concat(option.optionIndex)
    })));
  })) : null;
};

var style$s = {"exercise-wrapper":"tangram_C_exercise-wrapper_225f6fa90a","judge-wrapper":"tangram_C_judge-wrapper_225f6fa90a","question-detail":"tangram_C_question-detail_225f6fa90a","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_225f6fa90a","card-title":"tangram_C_card-title_225f6fa90a","structure":"tangram_C_structure_225f6fa90a","full-blank":"tangram_C_full-blank_225f6fa90a","text-emphasis":"tangram_C_text-emphasis_225f6fa90a","table-wrapper":"tangram_C_table-wrapper_225f6fa90a"};

var JudgeContext = /*#__PURE__*/createContext({});
var A$1 = 65;

var Judge = function Judge(props) {
  var _a;

  var optionsList = ((_a = parseJSON(props.options)) === null || _a === void 0 ? void 0 : _a.map(function (option, index) {
    var _a, _b;

    return ((_b = (_a = option === null || option === void 0 ? void 0 : option.child) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text) || index.toString();
  })) || [];

  function getOptionIndex(content) {
    // 取到答案对比选项，获得A或者B
    var index = optionsList.length && (optionsList === null || optionsList === void 0 ? void 0 : optionsList[0]) === content ? A$1 : A$1 + 1;
    return String.fromCharCode(index);
  }

  function getCorrectAnswer(answerJSON) {
    var _a, _b, _c, _d;

    var answer = parseJSON(answerJSON); // 答案结构为两层数组，判断题的答案只能是一种，这里取第0个

    return ((_d = (_c = (_b = (_a = answer === null || answer === void 0 ? void 0 : answer[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.child) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.text) || '';
  }

  var stem = props.stem,
      answer = props.answer,
      userSubmitItems = props.userSubmitItems,
      getChoseAnswer = props.onAnswerChange,
      subjectId = props.subjectId,
      logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      showGrade = props.showGrade,
      stemSource = props.stemSource,
      bigTypeName = props.bigTypeName,
      questionId = props.questionId,
      sticker = props.sticker,
      parentLogicTypeId = props.parentLogicTypeId,
      editable = props.editable,
      compoundUse = props.compoundUse;
  var userAnswer = Array.isArray(userSubmitItems) && userSubmitItems.length ? getOptionIndex(userSubmitItems[0].resource) : null;
  var correctAnswer = answer ? getOptionIndex(getCorrectAnswer(answer)) : '';
  useSetCookie(questionId);
  useEffect(function () {
    if (questionId) {
      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: "\n                    ".concat(style$s['judge-wrapper'], "\n                    single-question-item\n                    ").concat(compoundUse ? style$s['compound-sub-card-between-space'] : '', "\n                ")
  }, /*#__PURE__*/React.createElement(JudgeContext.Provider, {
    value: _assign$4(_assign$4({}, props), {
      userAnswer: userAnswer,
      correctAnswer: correctAnswer,
      getChoseAnswer: getChoseAnswer
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: style$s['question-detail'],
    style: {
      borderRadius: "".concat(compoundUse ? '0 0 10px 10px' : '10px')
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    parentLogicTypeId: parentLogicTypeId
  }), /*#__PURE__*/React.createElement(Stem, {
    questionId: questionId,
    subjectId: subjectId,
    stem: stem,
    source: stemSource,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    editable: editable
  }), /*#__PURE__*/React.createElement(JudgeOptions, null), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (item, index) {
    return (item.location === EStickerLocModule.ANSWERINFO || item.location === EStickerLocModule.ANSWERINFOEND) &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Sticker, {
      sticker: item,
      key: "".concat(questionId).concat(index)
    });
  })), /*#__PURE__*/React.createElement(AnswerInfo$2, null))));
};

var style$r = {"exercise-wrapper":"tangram_C_exercise-wrapper_9a1e3c9278","question-detail":"tangram_C_question-detail_9a1e3c9278","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_9a1e3c9278","card-title":"tangram_C_card-title_9a1e3c9278","structure":"tangram_C_structure_9a1e3c9278","full-blank":"tangram_C_full-blank_9a1e3c9278","text-emphasis":"tangram_C_text-emphasis_9a1e3c9278","table-wrapper":"tangram_C_table-wrapper_9a1e3c9278","question-follow":"tangram_C_question-follow_9a1e3c9278"};

var _a$6;
var ChildlogicTypeIdMap = (_a$6 = {}, _a$6[ELogicTypeId.INTERACTIVE] = null, _a$6[ELogicTypeId.CHOICE] = Choice$1, _a$6[ELogicTypeId.MULTIPLE_CHOICE] = Choice$1, _a$6[ELogicTypeId.INDEFINITE_CHOICE] = Choice$1, _a$6[ELogicTypeId.FILL_BLANK] = Filling, _a$6[ELogicTypeId.FILL_ON_BLANK] = null, _a$6[ELogicTypeId.JUDGE] = Judge, _a$6[ELogicTypeId.EXPLANATION] = Explain, _a$6[ELogicTypeId.WRITING] = Explain, _a$6[ELogicTypeId.VOICE] = null, _a$6[ELogicTypeId.CLOZE] = null, _a$6[ELogicTypeId.COMPOUND] = null, _a$6[ELogicTypeId.WORD_RECITATION] = null, _a$6[ELogicTypeId.MULTI_CHOICE_MULTI] = null, _a$6[ELogicTypeId.VIDEO] = null, _a$6[ELogicTypeId.POETRY_RECITATION] = null, _a$6[ELogicTypeId.ROLE_PLAY] = null, _a$6);
/**
 * 子题渲染
 */

var ChildQuestion = /*#__PURE__*/React.memo(function ChildQuestion(props) {
  var _a, _b;

  var index = props.index;

  var _c = useContext(CompoundContext),
      childrenQuestionList = _c.childrenQuestionList,
      _d = _c.currentChildIndex,
      currentChildIndex = _d === void 0 ? 0 : _d,
      onCompoundAnswerChange = _c.onCompoundAnswerChange,
      onSelfEvaluationChange = _c.onSelfEvaluationChange,
      onGradeChange = _c.onGradeChange,
      onGradeBlur = _c.onGradeBlur,
      parentLogicTypeId = _c.logicTypeId,
      platForm = _c.platForm;

  if (!(childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length)) {
    return null;
  }

  var childItem = childrenQuestionList[index !== undefined ? index : currentChildIndex];

  var questionId = childItem.questionId,
      logicTypeId = childItem.logicTypeId,
      videoExplanationUrls = childItem.videoExplanationUrls,
      videoVOList = childItem.videoVOList,
      videoExplanationCoverUrl = childItem.videoExplanationCoverUrl,
      answerMode = childItem.answerMode,
      answerTypeList = childItem.answerTypeList,
      commentItems = childItem.commentItems,
      submitHistoryItems = childItem.submitHistoryItems,
      otherChildInfo = __rest$1(childItem, ["questionId", "logicTypeId", "videoExplanationUrls", "videoVOList", "videoExplanationCoverUrl", "answerMode", "answerTypeList", "commentItems", "submitHistoryItems"]); // TODO: Choice作为子题时成为undefined


  var isChoice = [ELogicTypeId.CHOICE, ELogicTypeId.MULTIPLE_CHOICE, ELogicTypeId.INDEFINITE_CHOICE];
  var Child = logicTypeId ? ChildlogicTypeIdMap[logicTypeId] || isChoice && Choice$1 : null;

  function handleChildAnswerChange(questionId, answers) {
    questionId && (onCompoundAnswerChange === null || onCompoundAnswerChange === void 0 ? void 0 : onCompoundAnswerChange(questionId, answers));
  }

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(React.Fragment, null, childItem ? Child && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Child, _assign$4({
    key: questionId
  }, otherChildInfo, {
    questionId: questionId,
    parentLogicTypeId: parentLogicTypeId,
    logicTypeId: logicTypeId,
    answerTypeList: answerTypeList,
    platForm: platForm,
    onAnswerChange: handleChildAnswerChange,
    onSelfEvaluationChange: onSelfEvaluationChange,
    onGradeChange: onGradeChange,
    onGradeBlur: onGradeBlur,
    showSigleQImgUpload: answerMode !== EAnswerMode.UNIFIED,
    compoundUse: true
  })), /*#__PURE__*/React.createElement("div", {
    className: (videoExplanationUrls === null || videoExplanationUrls === void 0 ? void 0 : videoExplanationUrls.length) || (commentItems === null || commentItems === void 0 ? void 0 : commentItems.length) || (videoVOList === null || videoVOList === void 0 ? void 0 : videoVOList.length) || ((_a = submitHistoryItems === null || submitHistoryItems === void 0 ? void 0 : submitHistoryItems.submitHistory) === null || _a === void 0 ? void 0 : _a.length) ? style$r['question-follow'] : ''
  }, /*#__PURE__*/React.createElement(VideoExplanation, {
    videoVOList: videoVOList,
    urls: videoExplanationUrls,
    coverUrl: videoExplanationCoverUrl,
    platForm: platForm,
    compoundUse: true
  }), (commentItems === null || commentItems === void 0 ? void 0 : commentItems.length) ? /*#__PURE__*/React.createElement(Correction, {
    customStyle: {
      marginBottom: '1px'
    },
    commentItems: commentItems
  }) : null, submitHistoryItems ? /*#__PURE__*/React.createElement(SubmitHistory, _assign$4({
    answerWay: answerTypeList
  }, submitHistoryItems, {
    submitHistory: ((_b = submitHistoryItems === null || submitHistoryItems === void 0 ? void 0 : submitHistoryItems.submitHistory) === null || _b === void 0 ? void 0 : _b.filter(function (answer, index) {
      return answer.itemBaseList && answer.itemBaseList.length > 0;
    })) || []
  })) : null)) : null));
});

var style$q = {"container-outwrap":"tangram_C_container-outwrap_53d7618f82","sub-container-wrapper":"tangram_C_sub-container-wrapper_53d7618f82","sub-container":"tangram_C_sub-container_53d7618f82","weighted-black":"tangram_C_weighted-black_53d7618f82","normal-gray":"tangram_C_normal-gray_53d7618f82"};

function useSubQuestionChange(childId, idList, setIdx) {
  useEffect(function () {
    var _a;

    var idx = JSON.parse(idList).indexOf(childId);
    var parentEl = (_a = document.getElementById(childId)) === null || _a === void 0 ? void 0 : _a.parentElement;
    var childEl = document.getElementById(childId);

    if (parentEl && childEl) {
      var left = childEl.offsetLeft - (parentEl.clientWidth - childEl.clientWidth) / 2;
      parentEl.scrollLeft = left > 0 ? left : 0;
    }

    setIdx(idx);
  }, [childId, idList]);
}

var SubQuestions = function SubQuestions(props) {
  var currentChildId = props.currentChildId,
      childrenQuestionIdList = props.childrenQuestionIdList,
      onClickChild = props.onClickChild;

  if (!exist(currentChildId) || typeof currentChildId !== 'string') {
    propsException('currentChildId', currentChildId);
    throw new Error('复合题：子题列表currentChildId字段传参异常，会导致子题列表无法正常渲染！');
  }

  if (!exist(childrenQuestionIdList) || !Array.isArray(childrenQuestionIdList) || childrenQuestionIdList.length && childrenQuestionIdList.length === 0) {
    propsException('childrenQuestionIdList', childrenQuestionIdList);
    throw new Error('复合题：子题列表childrenQuestionIdList字段传参异常，会导致子题列表无法正常渲染！');
  }

  var _a = useState(childrenQuestionIdList.indexOf(currentChildId)),
      currentChildIdx = _a[0],
      setCurrentChildIdx = _a[1]; // 用户点击子题列表内小题时触发


  function onClickEachChild(subId, idx) {
    setCurrentChildIdx(idx);
    onClickChild === null || onClickChild === void 0 ? void 0 : onClickChild(idx);
  } // 用户点击下一题/完形填空中的空时，小题切换触发


  useSubQuestionChange(currentChildId, JSON.stringify(childrenQuestionIdList), setCurrentChildIdx);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$q['container-outwrap'], " swiping-disable")
  }, /*#__PURE__*/React.createElement("div", {
    className: style$q['sub-container-wrapper']
  }, childrenQuestionIdList.map(function (childId, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: childId,
      id: childId,
      className: style$q['sub-container'],
      role: "button",
      tabIndex: -1,
      // eslint-disable-next-line react/jsx-no-bind
      onClick: function onClick(e) {
        return onClickEachChild(childId, index);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: index === currentChildIdx ? style$q['weighted-black'] : style$q['normal-gray']
    }, "\u7B2C".concat(index + 1, "\u9898")));
  })));
};

var style$p = {"exercise-wrapper":"tangram_C_exercise-wrapper_385bb7e1b7","question-detail":"tangram_C_question-detail_385bb7e1b7","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_385bb7e1b7","card-title":"tangram_C_card-title_385bb7e1b7","structure":"tangram_C_structure_385bb7e1b7","full-blank":"tangram_C_full-blank_385bb7e1b7","text-emphasis":"tangram_C_text-emphasis_385bb7e1b7","table-wrapper":"tangram_C_table-wrapper_385bb7e1b7","child-wrapper":"tangram_C_child-wrapper_385bb7e1b7","child-question":"tangram_C_child-question_385bb7e1b7","child-question-no-swiper":"tangram_C_child-question-no-swiper_385bb7e1b7","swiper-slide":"tangram_C_swiper-slide_385bb7e1b7"};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "@font-face{font-family:swiper-icons;font-style:normal;font-weight:400;src:url(\"data:application/font-woff;charset=utf-8;base64, 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\")}:root{--swiper-theme-color:#007aff}.swiper{list-style:none;margin-left:auto;margin-right:auto;overflow:hidden;padding:0;position:relative;z-index:1}.swiper-vertical>.swiper-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.swiper-wrapper{-webkit-box-sizing:content-box;box-sizing:content-box;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;position:relative;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;-o-transition-property:transform;transition-property:transform;transition-property:transform,-webkit-transform;width:100%;z-index:1}.swiper-android .swiper-slide,.swiper-wrapper{-webkit-transform:translateZ(0);transform:translateZ(0)}.swiper-pointer-events{-ms-touch-action:pan-y;touch-action:pan-y}.swiper-pointer-events.swiper-vertical{-ms-touch-action:pan-x;touch-action:pan-x}.swiper-slide{-ms-flex-negative:0;flex-shrink:0;height:100%;position:relative;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;-o-transition-property:transform;transition-property:transform;transition-property:transform,-webkit-transform;width:100%}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-transition-property:height,-webkit-transform;transition-property:height,-webkit-transform;-o-transition-property:transform,height;transition-property:transform,height;transition-property:transform,height,-webkit-transform}.swiper-backface-hidden .swiper-slide{-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0)}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{-webkit-perspective:1200px;perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:-webkit-gradient(linear,right top,left top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-o-linear-gradient(right,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(270deg,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-o-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(90deg,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-o-linear-gradient(bottom,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(0deg,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-o-linear-gradient(top,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(180deg,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-css-mode>.swiper-wrapper{-ms-overflow-style:none;overflow:auto;scrollbar-width:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{-ms-scroll-snap-type:y mandatory;scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper:before{-ms-flex-negative:0;-webkit-box-ordinal-group:10000;-ms-flex-order:9999;content:\"\";flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{-webkit-margin-start:var(--swiper-centered-offset-before);margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{-webkit-margin-before:var(--swiper-centered-offset-before);margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper:before{height:var(--swiper-centered-offset-after);min-width:1px;width:100%}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center}";
styleInject(css_248z$1);

/* eslint-disable react/jsx-no-bind */

var ChildWrapper = function ChildWrapper(props) {
  var _a;

  var childHeight = props.childHeight;

  var _b = useState(),
      swiper = _b[0],
      setSwiper = _b[1];

  var playingMediaDomRef = useExclusivePlay().playingMediaDomRef;

  var _c = useContext(CompoundContext),
      childrenQuestionList = _c.childrenQuestionList,
      currentChildIndex = _c.currentChildIndex,
      onClickChildItem = _c.onClickChildItem,
      questionId = _c.questionId,
      _d = _c.allowSwiper,
      allowSwiper = _d === void 0 ? false : _d,
      jumpSwiperSpeed = _c.jumpSwiperSpeed,
      scrollTopSmooth = _c.scrollTopSmooth,
      onSwiperInit = _c.onSwiperInit;

  var memoedChildenInfo = useMemo(function () {
    return {
      idList: childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (questionItem) {
        return questionItem === null || questionItem === void 0 ? void 0 : questionItem.questionId;
      }),
      submitItems: childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (child) {
        var _a;

        return {
          answer: (_a = child === null || child === void 0 ? void 0 : child.userSubmitItems) !== null && _a !== void 0 ? _a : [],
          subQuestionId: child.questionId
        };
      }),
      editableList: childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (child) {
        return {
          editable: child === null || child === void 0 ? void 0 : child.editable,
          subQuestionId: child === null || child === void 0 ? void 0 : child.questionId
        };
      })
    };
  }, [childrenQuestionList]);

  function initSwiper(s) {
    setSwiper(s);
    s.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.39, 0.575, 0.565, 1)';
    s.slideTo(currentChildIndex, 0);
    onSwiperInit === null || onSwiperInit === void 0 ? void 0 : onSwiperInit(s);
  }

  useEffect(function () {
    var _a;

    if (allowSwiper) {
      // 手动切题
      swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(currentChildIndex, jumpSwiperSpeed !== null && jumpSwiperSpeed !== void 0 ? jumpSwiperSpeed : JUMP_SWIPER_SPEED); // 切题时暂停当前正在播放的音频

      var childWrapper = document.getElementById("tangram-compound-child-main-".concat(questionId));

      if ((playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) && (childWrapper === null || childWrapper === void 0 ? void 0 : childWrapper.contains(playingMediaDomRef.current))) {
        (_a = playingMediaDomRef.current) === null || _a === void 0 ? void 0 : _a.pause();
      }
    } else {
      scrollTopSmooth(currentChildIndex);
    }
  }, [currentChildIndex]);
  return /*#__PURE__*/React.createElement("div", {
    id: "tangram-compound-child-wrapper-".concat(questionId),
    className: style$p['child-wrapper'],
    style: {
      height: childHeight
    }
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SubQuestions, {
    currentChildId: (_a = memoedChildenInfo.idList) === null || _a === void 0 ? void 0 : _a[currentChildIndex],
    childrenQuestionIdList: memoedChildenInfo.idList,
    onClickChild: onClickChildItem
  }), allowSwiper ? /*#__PURE__*/React.createElement(Swiper, {
    className: style$p['child-question'],
    id: "tangram-compound-child-main-".concat(questionId),
    onSlideChange: function onSlideChange(e) {
      return onClickChildItem === null || onClickChildItem === void 0 ? void 0 : onClickChildItem(e.activeIndex);
    },
    onSwiper: initSwiper,
    speed: SWIPER_SPEED,
    edgeSwipeDetection: true,
    resistanceRatio: 0,
    noSwipingClass: "swiping-disable",
    enabled: allowSwiper
  }, childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (_item, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: style$p['swiper-slide'],
      id: "swiper-slide-".concat(questionId, "-").concat(index)
    }, /*#__PURE__*/React.createElement(ChildQuestion, {
      index: index
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: style$p['child-question-no-swiper'],
    id: "tangram-compound-child-main-".concat(questionId)
  }, /*#__PURE__*/React.createElement(ChildQuestion, null))));
};

var INIT_CHILD_HEIGHT = 0.47 * screen.height - 50; // 最小子题容器高度：：子题序号区域高度

var MIN_CHILD_HEIGHT = 50; // 最大子题容器高度：屏高70% - 子题序号区域高度

var MAX_CHILD_HEIGHT = 0.70 * screen.height - 50;

var useHeight = function useHeight(dragIconRef, questionId, isPC) {
  var _a = useState(INIT_CHILD_HEIGHT),
      childHeight = _a[0],
      setChildHeight = _a[1]; // 用来保存拖拽图片的坐标


  var cardStartY = 0;
  var childDomHeight = 0;

  function watchTouchMove(event) {
    var _a, _b;

    event.preventDefault();
    var curHeight = childDomHeight + (cardStartY - ((_b = (_a = event === null || event === void 0 ? void 0 : event.touches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.clientY));
    var cardHeight = curHeight > MIN_CHILD_HEIGHT ? curHeight > MAX_CHILD_HEIGHT ? MAX_CHILD_HEIGHT : curHeight : MIN_CHILD_HEIGHT;
    setChildHeight(cardHeight);
  }

  function watchTouchStart(event) {
    var _a, _b, _c;

    event.preventDefault();
    cardStartY = (_b = (_a = event === null || event === void 0 ? void 0 : event.touches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.clientY;
    childDomHeight = ((_c = document.getElementById("tangram-compound-child-wrapper-".concat(questionId))) === null || _c === void 0 ? void 0 : _c.offsetHeight) || childHeight;

    document.ontouchmove = function (e) {
      watchTouchMove(e);
    };

    document.ontouchend = function () {
      document.ontouchmove = null;
    };
  }

  useEffect(function () {
    var current_dragIconRef = dragIconRef === null || dragIconRef === void 0 ? void 0 : dragIconRef.current;

    if (!isPC) {
      current_dragIconRef === null || current_dragIconRef === void 0 ? void 0 : current_dragIconRef.addEventListener('touchstart', watchTouchStart); // 处理初次渲染复合体没有拿到节点的情况

      var timer_1 = setTimeout(function () {
        if (!current_dragIconRef) {
          current_dragIconRef = dragIconRef === null || dragIconRef === void 0 ? void 0 : dragIconRef.current;
          current_dragIconRef === null || current_dragIconRef === void 0 ? void 0 : current_dragIconRef.addEventListener('touchstart', watchTouchStart);
        }
      }, 0);
      return function () {
        current_dragIconRef === null || current_dragIconRef === void 0 ? void 0 : current_dragIconRef.removeEventListener('touchstart', watchTouchStart);
        timer_1 && clearTimeout(timer_1);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [dragIconRef === null || dragIconRef === void 0 ? void 0 : dragIconRef.current, questionId]);
  return [childHeight];
};

var CompoundContext = /*#__PURE__*/createContext({});

var Compound = function Compound(props) {
  var stem = props.stem,
      showGrade = props.showGrade,
      stemSource = props.stemSource,
      logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      bigTypeName = props.bigTypeName,
      questionId = props.questionId,
      childrenQuestionList = props.childrenQuestionList,
      currentChildIndex = props.currentChildIndex,
      onQuestionIdChange = props.onQuestionIdChange,
      wrapperStyle = props.wrapperStyle,
      mobileChildWrapperStyle = props.mobileChildWrapperStyle,
      subjectId = props.subjectId,
      editable = props.editable,
      _a = props.showSubmitInfo,
      showSubmitInfo = _a === void 0 ? true : _a,
      platForm = props.platForm,
      beaconId = props.beaconId,
      showPlainBlank = props.showPlainBlank;
  var IS_PC = platForm === EPlatForm.pc;
  var dragIconRef = useRef(null);
  var childHeight = useHeight(dragIconRef, questionId || '', IS_PC)[0];
  var childrenQuestionChecked = exist(currentChildIndex) && typeof currentChildIndex === 'number' && +currentChildIndex >= 0 && !!(childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length);

  var _b = useState(childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (questionItem) {
    return questionItem.questionId;
  })[currentChildIndex]),
      currentChildId = _b[0],
      setCurrentChildId = _b[1];

  function checkAnswered() {
    var _a;

    var isAnswer = false;

    for (var _i = 0, _b = childrenQuestionList !== null && childrenQuestionList !== void 0 ? childrenQuestionList : []; _i < _b.length; _i++) {
      var item = _b[_i];
      isAnswer = !!((_a = item.userSubmitItems) === null || _a === void 0 ? void 0 : _a.length);

      if (isAnswer) {
        break;
      }
    }

    return isAnswer;
  }

  function scrollTopSmooth(index) {
    var id = "compound-blank-id-".concat(questionId, "-").concat(index);
    var parentId = "compound-stem-".concat(questionId);
    var parentEl = document.getElementById(parentId);
    var childEl = document.getElementById(id);

    if (parentEl && childEl) {
      var top_1 = childEl.offsetTop - (parentEl.clientHeight - childEl.clientHeight) / 2;
      parentEl.scrollTop = top_1 > 0 ? top_1 : 0;
    }
  }

  useSetCookie(questionId);
  useEffect(function () {
    if (questionId) {
      footPrintSecondaryReport({
        // 一级事件都从cookie中去查
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  useEffect(function () {
    if ((childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && childrenQuestionList[currentChildIndex]) {
      if (!checkAnswered() && currentChildIndex === 0) {
        return;
      }

      scrollTopSmooth(currentChildIndex);
    }
  }, [childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length, questionId]);
  useEffect(function () {
    // 回到子题顶部
    var timer = setTimeout(function () {
      var childWrapper = document.getElementById("tangram-compound-child-main-".concat(questionId));

      if (!childWrapper) {
        return;
      } // 解决ios子题切换后白屏


      if (isIOS$1) {
        childWrapper.style.overflow = 'hidden';
      }

      childWrapper.scrollTo(0, 0);

      if (isIOS$1) {
        childWrapper.style.overflow = 'scroll';
      }
    }, 10);
    return function () {
      timer && clearTimeout(timer);
    };
  }, [currentChildId]);
  var changeCurrentChildId = useCallback(function (index) {
    if (index || index === 0) {
      var currentChildId_1 = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (questionItem) {
        return questionItem.questionId;
      })[index];
      setCurrentChildId(currentChildId_1);
      onQuestionIdChange === null || onQuestionIdChange === void 0 ? void 0 : onQuestionIdChange(questionId, currentChildId_1);
    }
  }, [childrenQuestionList, setCurrentChildId, onQuestionIdChange]);

  function onClickChildItem(index) {
    console.log('beaconId:', beaconId, questionId);

    if (beaconId === questionId && (index || index === 0)) {
      scrollTopSmooth(index);
      var currentChildId_2 = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (questionItem) {
        return questionItem.questionId;
      })[index];
      onQuestionIdChange === null || onQuestionIdChange === void 0 ? void 0 : onQuestionIdChange(questionId, currentChildId_2);
    }
  } // 避免【child-question子题题目展示组件】因拖拽导致的高度变化重复渲染
  // eslint-disable-next-line react-hooks/exhaustive-deps


  var contextValue = useMemo(function () {
    var _a;

    return _assign$4(_assign$4({}, props), {
      // 多选多的选项options取自母题的options
      childrenQuestionList: logicTypeId === ELogicTypeId.MULTI_CHOICE_MULTI ? (_a = props.childrenQuestionList) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        return _assign$4(_assign$4({}, item), {
          options: props.options || []
        });
      }) : props.childrenQuestionList,
      currentChildId: currentChildId,
      onClickChildItem: onClickChildItem,
      scrollTopSmooth: scrollTopSmooth
    });
  }, [props, currentChildId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CompoundContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n                        ".concat(style$w['compound-wrapper'], "\n                        ").concat(IS_PC ? style$w['compound-wrapper-pc'] : '', "\n                        single-question-item\n                    "),
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: style$w['dividing-space-compound'],
    id: "compound-stem-".concat(questionId)
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName
  }), /*#__PURE__*/React.createElement(Stem, {
    questionId: questionId,
    subjectId: subjectId,
    stem: stem,
    source: stemSource,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    changeCurChildId: changeCurrentChildId,
    compoundUse: true,
    platForm: platForm,
    editable: editable,
    childrenQuestionList: childrenQuestionList,
    currentChildIndex: currentChildIndex,
    showSubmitInfo: showSubmitInfo,
    showPlainBlank: showPlainBlank
  })), childrenQuestionChecked && (IS_PC ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style$w['pc-dividing']
  }), /*#__PURE__*/React.createElement("div", {
    className: "\n                                            ".concat(style$w['pc-child-wrapper'], "\n                                            ").concat(showGrade ? '' : style$w['parent-nograde'])
  }, /*#__PURE__*/React.createElement(ChildQuestion, null))) : /*#__PURE__*/React.createElement("div", {
    className: style$w['m-child-wrapper'],
    style: mobileChildWrapperStyle
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    ref: dragIconRef,
    className: "".concat(style$w['card-head'], " swiping-disable")
  }), /*#__PURE__*/React.createElement(ChildWrapper, {
    childHeight: childHeight
  }))))));
};

var Compound$1 = withErrorBoundary(Compound);

var style$o = {"exercise-wrapper":"tangram_C_exercise-wrapper_9b7b985acb","filling-onblank-wrapper":"tangram_C_filling-onblank-wrapper_9b7b985acb","question-detail":"tangram_C_question-detail_9b7b985acb","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_9b7b985acb","card-title":"tangram_C_card-title_9b7b985acb","structure":"tangram_C_structure_9b7b985acb","full-blank":"tangram_C_full-blank_9b7b985acb","text-emphasis":"tangram_C_text-emphasis_9b7b985acb","table-wrapper":"tangram_C_table-wrapper_9b7b985acb","hide-compound":"tangram_C_hide-compound_9b7b985acb","not-hide-compound":"tangram_C_not-hide-compound_9b7b985acb"};

var FillingOnBlankContext = /*#__PURE__*/createContext({
  currentChildIndex: 0,
  beaconId: ''
});

var FillingOnBlank = function FillingOnBlank(props) {
  var logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      stem = props.stem,
      showGrade = props.showGrade,
      stemSource = props.stemSource,
      bigTypeName = props.bigTypeName;
      props.answerTypeList;
      var editable = props.editable,
      answerChangeCallback = props.onAnswerChange;
      props.userSubmitItems;
      var questionId = props.questionId;
      props.onTextAreaFocus;
      props.onTextAreaBlur;
      props.sticker;
      var subjectId = props.subjectId,
      correctType = props.correctType,
      parentLogicTypeId = props.parentLogicTypeId,
      compoundUse = props.compoundUse,
      _a = props.showSubmitInfo,
      showSubmitInfo = _a === void 0 ? true : _a;
      props.showSigleQImgUpload;
      var childrenQuestionList = props.childrenQuestionList,
      currentChildIndex = props.currentChildIndex;

  var _c = useState([]),
      userAnswerList = _c[0],
      setUserAnswerList = _c[1];

  var _d = useState(),
      currentAnswerInfo = _d[0],
      setCurrentAnswerInfo = _d[1]; // 编辑模式下的题干作答数据


  var _e = useState([]),
      blankAnswerList = _e[0],
      setBlankAnswerList = _e[1];

  var getCurrenAnswer = useCallback(function (answerInfo) {
    answerInfo.currentAnswer;
        answerInfo.currentIndex;
    setCurrentAnswerInfo(answerInfo);
  }, []);
  var blankCount = useMemo(function () {
    // 计算填空题的空的数量
    var calcCount = function calcCount(stemJsonParse) {
      var counter = 0;
      var attr = stemJsonParse.attr,
          child = stemJsonParse.child; // 当前层级中的空

      if (attr === null || attr === void 0 ? void 0 : attr.vacancy) {
        counter++;
      }

      if (child) {
        counter += (child === null || child === void 0 ? void 0 : child.map(function (c, i) {
          return calcCount(c);
        })).reduce(function (pre, cur) {
          return pre + cur;
        }, 0);
      }

      return counter;
    };

    var stemJsonParse = parseJSON(stem);
    return stemJsonParse ? calcCount(stemJsonParse) : 0;
  }, [stem]);
  useSetCookie(questionId);
  useEffect(function () {
    // 切换题目答案init 或者半提交回填--1
    if ((correctType === ECorrectType.AUTO_CORRECT || correctType === ECorrectType.AI_CORRECT) && editable) {
      var blankAnswers_1 = [];
      var newList = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (item) {
        var _a;

        return (_a = item.userSubmitItems) === null || _a === void 0 ? void 0 : _a[0];
      });
      var previousAnswerList = (newList === null || newList === void 0 ? void 0 : newList.map(function (item, idx) {
        var _a, _b, _c, _d;

        var userAnswer = ((_b = (_a = item === null || item === void 0 ? void 0 : item.resource) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.userAnswer) || '';
        var isRight = (_d = (_c = item === null || item === void 0 ? void 0 : item.resource) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.isRight;
        blankAnswers_1.push({
          userAnswer: userAnswer,
          idx: idx,
          isRight: isRight
        });
        return userAnswer;
      })) || [];
      setBlankAnswerList([{
        resource: blankAnswers_1,
        resourceType: ESubmitItemTypes.TEXT_AUTO
      }]);
      setUserAnswerList(previousAnswerList);
    } // 切换试题, 上报业务传来的试题参数


    if (questionId) {
      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  useEffect(function () {
    var _a;

    if (currentAnswerInfo) {
      var answerListCopy = __spreadArray([], userAnswerList, true);

      var currentIndex = currentAnswerInfo.currentIndex,
          currentAnswer = currentAnswerInfo.currentAnswer;
      var curAnswer = currentAnswer ? [{
        resource: [{
          userAnswer: currentAnswer,
          idx: currentIndex
        }],
        resourceType: ESubmitItemTypes.TEXT_AUTO
      }] : []; // 当前子题作答信息提交到复合题中

      answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(((_a = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[currentIndex]) === null || _a === void 0 ? void 0 : _a.questionId) || '', curAnswer); // TODO: 用户作答信息变化时上报

      footPrintSecondaryReport({
        secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
        actionValue: JSON.stringify(curAnswer)
      }); // for循环处理用户先答后面空格的情况

      for (var i = 0; i < blankCount; i++) {
        if (answerListCopy[currentIndex]) {
          answerListCopy.splice(currentIndex, 1, currentAnswer);
          break;
        }

        if (!answerListCopy[i]) {
          answerListCopy[i] = '';
        }
      }

      answerListCopy.splice(currentAnswerInfo.currentIndex, 1, currentAnswerInfo.currentAnswer);
      setUserAnswerList(answerListCopy);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentAnswerInfo]);

  var formatToCompound = function formatToCompound() {
    var resList = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.map(function (item, index) {
      return _assign$4(_assign$4({}, item), {
        userSubmitItems: [{
          resource: (userAnswerList === null || userAnswerList === void 0 ? void 0 : userAnswerList[index]) ? [{
            idx: index,
            userAnswer: userAnswerList === null || userAnswerList === void 0 ? void 0 : userAnswerList[index]
          }] : [],
          resourceType: 7
        }]
      });
    });
    return resList;
  }; // 更改子题索引


  var changeIndex = function changeIndex(index) {
    var _a, _b;

    var childId = (_a = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[index]) === null || _a === void 0 ? void 0 : _a.questionId;
    (_b = props.onQuestionIdChange) === null || _b === void 0 ? void 0 : _b.call(props, questionId, childId);
  };

  function scrollTopSmooth(index) {
    var id = "blank-id-".concat(questionId, "-").concat(index);
    var parentId = "filling-on-blank-stem-".concat(questionId);
    var parentEl = document.getElementById(parentId);
    var childEl = document.getElementById(id);

    if (parentEl && childEl) {
      var top_1 = childEl.offsetTop - (parentEl.clientHeight - childEl.clientHeight) / 2;
      parentEl.scrollTop = top_1 > 0 ? top_1 : 0;
    }
  }

  useEffect(function () {
    if ((childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && childrenQuestionList[currentChildIndex] && editable) {
      if (currentChildIndex === 0) {
        return;
      }

      scrollTopSmooth(currentChildIndex);
    }
  }, [childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length, questionId, currentChildIndex]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    id: "filling-onblank-wrapper-".concat(questionId),
    className: "\n                    ".concat(style$o['filling-onblank-wrapper'], "\n                    ").concat(compoundUse ? style$o['compound-sub-card-between-space'] : '', "\n                    single-question-item\n                ")
  }, /*#__PURE__*/React.createElement(FillingOnBlankContext.Provider, {
    value: _assign$4(_assign$4({}, props), {
      getCurrenAnswer: getCurrenAnswer,
      showSubmitInfo: showSubmitInfo,
      userSubmitItems: (blankAnswerList === null || blankAnswerList === void 0 ? void 0 : blankAnswerList.length) ? blankAnswerList : []
    })
  }, editable && /*#__PURE__*/React.createElement("div", {
    id: "filling-on-blank-stem-".concat(questionId),
    className: style$o['question-detail'],
    style: {
      borderRadius: "".concat(compoundUse ? '0 0 10px 10px' : '10px')
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    parentLogicTypeId: parentLogicTypeId
  }), /*#__PURE__*/React.createElement(Stem, {
    key: blankAnswerList === null || blankAnswerList === void 0 ? void 0 : blankAnswerList.length,
    questionId: questionId,
    stem: stem,
    subjectId: subjectId,
    source: stemSource,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    editable: editable,
    currentChildIndex: currentChildIndex,
    changeCurChildId: changeIndex
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(editable ? style$o['hide-compound'] : style$o['not-hide-compound'])
  }, /*#__PURE__*/React.createElement(Compound$1, _assign$4({}, props, {
    stem: stem,
    showGrade: showGrade,
    stemSource: stemSource,
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    questionId: questionId,
    currentChildIndex: currentChildIndex,
    subjectId: subjectId,
    editable: false,
    showSubmitInfo: showSubmitInfo,
    childrenQuestionList: editable ? formatToCompound() : props.childrenQuestionList
  }))))));
};

var style$n = {"filling-blank":"tangram_C_filling-blank_c98c9c007a","stem-input":"tangram_C_stem-input_c98c9c007a","stem-input--no-result":"tangram_C_stem-input--no-result_c98c9c007a","stem-input--wrong":"tangram_C_stem-input--wrong_c98c9c007a","stem-input--right":"tangram_C_stem-input--right_c98c9c007a","stem-input--un-select":"tangram_C_stem-input--un-select_c98c9c007a","input-not-auto-grading":"tangram_C_input-not-auto-grading_c98c9c007a","blank-id":"tangram_C_blank-id_c98c9c007a","blank-id--edit":"tangram_C_blank-id--edit_c98c9c007a","blank-id--wrong":"tangram_C_blank-id--wrong_c98c9c007a","blank-id--right":"tangram_C_blank-id--right_c98c9c007a","filling-blank-long":"tangram_C_filling-blank-long_c98c9c007a","stem-input-long":"tangram_C_stem-input-long_c98c9c007a"};

var LONG_BLANK = 56;

function judgeLongBlank(inputDom, blankDom, line) {
  var inputWidth = inputDom.offsetWidth;
  return inputWidth > LONG_BLANK;
}

var Blank = function Blank(props) {
  var stemInput = useRef(null);
  var blankRef = useRef(null);

  var _a = useState(''),
      optionStyle = _a[0],
      setOptionStyle = _a[1];

  var _b = useState(''),
      inputStyle = _b[0],
      setInputStyle = _b[1];

  var _c = useState(false),
      isBlankLong = _c[0],
      setIsBlankLong = _c[1];

  var blankId = props.blankId,
      vacancy = props.vacancy,
      onBlank = props.onBlank,
      changeCurrentChildId = props.changeCurrentChildId,
      currentChildIndex = props.currentChildIndex;

  var _d = useContext(onBlank ? FillingOnBlankContext : FillingContext),
      userSubmitItems = _d.userSubmitItems,
      editable = _d.editable,
      getCurrenAnswer = _d.getCurrenAnswer,
      questionId = _d.questionId,
      alwaysShowAnswer = _d.alwaysShowAnswer,
      showSubmitOnAnswerComp = _d.showSubmitOnAnswerComp,
      showSubmitInfo = _d.showSubmitInfo,
      showPlainBlank = _d.showPlainBlank,
      correctType = _d.correctType;
      // 其余为空上作答单独传入
  __rest$1(_d, ["userSubmitItems", "editable", "getCurrenAnswer", "questionId", "alwaysShowAnswer", "showSubmitOnAnswerComp", "showSubmitInfo", "showPlainBlank", "correctType"]);

  var isAnswerInBlank = !showSubmitOnAnswerComp && !showPlainBlank;
  var MAX_LENGTH = 50;
  var ENTER_CODE = 'Enter';

  function onClickEachBlank(e) {
    if (onBlank) {
      var id = e.target.id;
      changeCurrentChildId === null || changeCurrentChildId === void 0 ? void 0 : changeCurrentChildId(+id.slice(id.lastIndexOf('-') + 1));
    }
  }

  function isInputEmpty() {
    var _a;

    return !((_a = stemInput.current) === null || _a === void 0 ? void 0 : _a.innerText.length);
  }

  function getUserSubmitItemByBlank() {
    if ((userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && (blankId || blankId === 0) // 只有自动判题，空内作答的填空，才需要如下解析并回填，否则无需解析回填，只通过MultiAnswer组件显示
    && (correctType === ECorrectType.AUTO_CORRECT || correctType === ECorrectType.AI_CORRECT)) {
      var parsedItems = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0].resource;
      return (parsedItems === null || parsedItems === void 0 ? void 0 : parsedItems[blankId]) || null;
    }
  }

  function getOptionStyle(isFocus) {
    if (isFocus === void 0) {
      isFocus = false;
    }

    var baseClass = "".concat(style$n['blank-id']);
    var itemInBlank = getUserSubmitItemByBlank();

    var _a = itemInBlank || {},
        userAnswer = _a.userAnswer,
        isRight = _a.isRight; // 作答状态：focus或已填写-实心蓝圈（EDIT_RESULT），其他-空心蓝圈（NO_RESULT）
    // 解析状态：正确-绿圈（RESULT_RIGHT），填写内容为空-空心蓝圈（NO_RESULT），填写内容不为空且正误情况未知-实心蓝圈（EDIT_RESULT），其他-红圈（RESULT_WRONG）


    var styleState = onBlank && isRight && editable ? 'RESULT_RIGHT' : editable && !alwaysShowAnswer ? isFocus || !isInputEmpty() || onBlank && blankId === currentChildIndex ? 'EDIT_RESULT' : 'NO_RESULT' : isRight ? 'RESULT_RIGHT' : (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) ? typeof isRight === 'undefined' ? 'EDIT_RESULT' : 'RESULT_WRONG' : 'NO_RESULT';
    var styleMap = {
      EDIT_RESULT: "".concat(baseClass, " ").concat(style$n['blank-id--edit']),
      RESULT_RIGHT: "".concat(baseClass, " ").concat(style$n['blank-id--right']),
      RESULT_WRONG: "".concat(baseClass, " ").concat(style$n['blank-id--wrong']),
      NO_RESULT: "".concat(baseClass, " ").concat(style$n['blank-id'], "}")
    };
    setOptionStyle(styleMap[styleState]);
  }

  function getInputStyle(isFocus) {
    if (isFocus === void 0) {
      isFocus = false;
    }

    var baseClass = "".concat(style$n['stem-input']); // 非自动判题：蓝字（AUTO_EDIT）
    // 自动判题作答状态：focus或已填写-蓝字（AUTO_EDIT），其他-有编辑图标（UN_SELECT_EDIT）
    // 自动判题非作答状态：正确-绿字（RESULT_RIGHT），填写内容为空-灰字（NO_RESULT），填写内容不为空且正误情况未知-实心蓝圈（AUTO_EDIT），错误-红字（RESULT_WRONG）

    var itemInBlank = getUserSubmitItemByBlank();

    var _a = itemInBlank || {},
        userAnswer = _a.userAnswer,
        isRight = _a.isRight;

    var styleState = isAnswerInBlank ? onBlank && isRight && editable ? 'RESULT_RIGHT' // ? isRight
    //     ? 'RESULT_RIGHT'
    //     : blankId === currentChildIndex ? 'AUTO_EDIT' : 'UN_SELECT_EDIT'
    : editable && !alwaysShowAnswer ? isFocus || !isInputEmpty() ? 'AUTO_EDIT' : 'UN_SELECT_EDIT' : isRight ? 'RESULT_RIGHT' : (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) ? typeof isRight === 'undefined' ? 'AUTO_EDIT' : 'RESULT_WRONG' : 'NO_RESULT' : 'AUTO_EDIT';
    var styleMap = {
      AUTO_EDIT: "".concat(baseClass),
      RESULT_RIGHT: "".concat(baseClass, " ").concat(style$n['stem-input--right']),
      RESULT_WRONG: "".concat(baseClass, " ").concat(style$n['stem-input--wrong']),
      NO_RESULT: "".concat(baseClass, " ").concat(style$n['stem-input--no-result']),
      UN_SELECT_EDIT: "".concat(baseClass, " ").concat(style$n['stem-input--un-select'])
    };
    setInputStyle(styleMap[styleState]);
  }

  useEffect(function () {
    // 空上作答 切换子题
    onBlank && getOptionStyle();
  }, [currentChildIndex]);

  function forbidEvent(event) {
    if (event.preventDefault) {
      event.preventDefault();
    } else if (window.event) {
      window.event.returnValue = false;
    }
  }

  function watchClipboardEvent(event) {
    forbidEvent(event);
  }

  function watchEnter(event) {
    if (event.key === ENTER_CODE) {
      forbidEvent(event);
    }
  }

  function watchContextmenu(event) {
    forbidEvent(event);
  }

  function watchInput() {
    var _a;

    if (!stemInput.current || !blankRef.current) {
      return;
    }

    var content = ((_a = stemInput.current) === null || _a === void 0 ? void 0 : _a.innerText) || '';

    if (content.length > MAX_LENGTH) {
      stemInput.current.innerText = content = content.slice(0, MAX_LENGTH);
      var range = window.getSelection();
      range === null || range === void 0 ? void 0 : range.selectAllChildren(stemInput.current);
      range === null || range === void 0 ? void 0 : range.collapseToEnd();
    }

    if ((blankId || blankId === 0) && getCurrenAnswer) {
      // 该行代码导致部分浏览器的输入法输入复数个单词时异常，暂时注释
      // setIsBlankLong(judgeLongBlank(stemInput.current, blankRef.current));
      getCurrenAnswer({
        currentAnswer: stemInput.current.innerText,
        currentIndex: blankId
      });
    }
  }

  function watchMove(event) {
    if (!blankRef.current || !stemInput.current) {
      return;
    }

    document.ontouchmove = null; // 若点击区域在dom元素之外，失焦

    !blankRef.current.contains(event.target) && stemInput.current.blur();
  }

  function watchTouch(event) {
    if (!stemInput.current) {
      return;
    }

    document.ontouchmove = function () {
      // 移动时传入touchStart时的事件（判断触摸区域是否为当前题目）
      watchMove(event);
    };
  }

  function watchFocus(e) {
    if (!stemInput.current) {
      return;
    }

    getOptionStyle(true);
    getInputStyle(true);
    window.addEventListener('touchstart', watchTouch);
    onClickEachBlank(e);
  }

  function watchBlur() {
    if (!stemInput.current || !blankRef.current) {
      return;
    }

    window.removeEventListener('touchstart', watchTouch);
    var content = stemInput.current.innerText || '';
    var contentWithoutSIXPEREMSPACE = content.replace(/\u2006/g, ''); // 用户把空里面的内容全删除之后，innerText还会有一个'\n'换行符残留，这是不合理的，这个换行符需要被替换为空字符串

    stemInput.current.innerText = contentWithoutSIXPEREMSPACE === '\n' ? '' : contentWithoutSIXPEREMSPACE;
    getOptionStyle();
    getInputStyle();
    setIsBlankLong(judgeLongBlank(stemInput.current, blankRef.current));

    if ((blankId || blankId === 0) && getCurrenAnswer) {
      // 失焦完成输入上报
      footPrintDetailReport({
        detailAction: '输入完成',
        actionValue: "".concat(blankId, "-").concat(stemInput.current.innerText)
      });
      getCurrenAnswer({
        currentAnswer: stemInput.current.innerText,
        currentIndex: blankId
      });
    }
  }

  useEffect(function () {
    var stemInputCopy = stemInput.current;

    var _a = getUserSubmitItemByBlank() || {},
        userAnswer = _a.userAnswer,
        isRight = _a.isRight;

    var blankCopy = blankRef.current; // TODO:

    if (onBlank && isRight && editable) {
      stemInputCopy && (stemInputCopy.contentEditable = 'false');
    }

    if (stemInputCopy && blankCopy) {
      stemInputCopy.innerText = isAnswerInBlank ? editable ? userAnswer || '' : userAnswer || showSubmitInfo && '未作答' || '' : '';
      setIsBlankLong(judgeLongBlank(stemInputCopy));
    }

    getOptionStyle();
    getInputStyle();
    ['paste', 'cut', 'copy'].forEach(function (item) {
      // @ts-ignore
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener(item, watchClipboardEvent, false);
    });
    stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener('input', watchInput, false);
    stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener('keydown', watchEnter, false);
    stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener('contextmenu', watchContextmenu, false);
    stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener('blur', watchBlur, false);
    stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener('focus', watchFocus, false);
    return function () {
      ['paste', 'cut', 'copy'].forEach(function (item) {
        // @ts-ignore
        stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.addEventListener(item, watchClipboardEvent, false);
      });
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.removeEventListener('input', watchInput, false);
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.removeEventListener('keydown', watchEnter, false);
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.removeEventListener('contextmenu', watchContextmenu, false);
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.removeEventListener('blur', watchBlur, false);
      stemInputCopy === null || stemInputCopy === void 0 ? void 0 : stemInputCopy.removeEventListener('focus', watchFocus, false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId, correctType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$n['filling-blank'], " ").concat(isBlankLong ? style$n['filling-blank-long'] : ''),
    ref: blankRef
  }, (blankId || blankId === 0) && (isAnswerInBlank ? /*#__PURE__*/React.createElement("span", {
    className: optionStyle
  }, blankId + 1) : (blankId || blankId === 0) && /*#__PURE__*/React.createElement("span", {
    className: style$n['input-not-auto-grading']
  }, vacancy === EBlankVacancy.EBlankOrdered ? "\uFF08".concat(blankId + 1, "\uFF09") : '')), isAnswerInBlank && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    role: "presentation",
    contentEditable: editable && isAnswerInBlank ? 'true' : 'false',
    tabIndex: -1,
    className: "\n                                    ".concat(inputStyle, "\n                                    ").concat(isBlankLong ? style$n['stem-input-long'] : '', "\n                                    'swiping-disable'\n                                "),
    id: "blank-id-".concat(questionId, "-").concat(blankId),
    ref: stemInput
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      visibility: 'hidden'
    }
  }, "."))));
};

var style$m = {"compound-blank-wrapper":"tangram_C_compound-blank-wrapper_2f39ebeb44","compound-blank-id":"tangram_C_compound-blank-id_2f39ebeb44","compound-blank-id--edit":"tangram_C_compound-blank-id--edit_2f39ebeb44","compound-blank-id--wrong":"tangram_C_compound-blank-id--wrong_2f39ebeb44","compound-blank-id--right":"tangram_C_compound-blank-id--right_2f39ebeb44","compound-blank-id--wait":"tangram_C_compound-blank-id--wait_2f39ebeb44","compound-blank":"tangram_C_compound-blank_2f39ebeb44","compound-blank--no-result":"tangram_C_compound-blank--no-result_2f39ebeb44","compound-blank--wrong":"tangram_C_compound-blank--wrong_2f39ebeb44","compound-blank--right":"tangram_C_compound-blank--right_2f39ebeb44","compound-blank--wait":"tangram_C_compound-blank--wait_2f39ebeb44","compound-blank--plain":"tangram_C_compound-blank--plain_2f39ebeb44"};

var CompoundBlank = function CompoundBlank(props) {
  var stemInput = useRef(null);

  var _a = useState(''),
      optionStyle = _a[0],
      setOptionStyle = _a[1];

  var _b = useState(''),
      inputStyle = _b[0],
      setInputStyle = _b[1];

  var logicTypeId = props.logicTypeId,
      blankId = props.blankId,
      changeCurrentChildId = props.changeCurrentChildId,
      editable = props.editable,
      childrenQuestionList = props.childrenQuestionList,
      currentChildIndex = props.currentChildIndex,
      questionId = props.questionId,
      showSubmitInfo = props.showSubmitInfo,
      showPlainBlank = props.showPlainBlank;
  var isCloze = !!(logicTypeId && (ELogicTypeId.CLOZE === logicTypeId || ELogicTypeId.MULTI_CHOICE_MULTI === logicTypeId));
  var isFill = !!(ELogicTypeId.FILL_ON_BLANK === logicTypeId);

  function onClickEachBlank(e) {
    if (isCloze || isFill) {
      var id = e.target.id;
      changeCurrentChildId === null || changeCurrentChildId === void 0 ? void 0 : changeCurrentChildId(+id.slice(id.lastIndexOf('-') + 1));
    }
  }

  function getUserSubmitItemByBlank() {
    var _a, _b;

    return (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && (blankId || blankId === 0) && exist(childrenQuestionList[blankId]) ? ((_a = childrenQuestionList[blankId].userSubmitItems) === null || _a === void 0 ? void 0 : _a.length) ? (_b = childrenQuestionList[blankId].userSubmitItems) === null || _b === void 0 ? void 0 : _b[0] : null : null;
  }

  function getBlankAnswer() {
    var _a, _b, _c, _d, _e; // 完形填空的子题均为单选题，因此可以通过作答和答案进行===比对进行判断是否正确


    return (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && (blankId || blankId === 0) && exist(childrenQuestionList[blankId]) && childrenQuestionList[blankId].answer ? ((_e = (_d = (_c = (_b = (_a = parseJSON(childrenQuestionList[blankId].answer)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.child) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.text) || '' : null;
  }

  function getBlankEditable() {
    // 获取当前子题 是否可编辑
    return !!((childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && (blankId || blankId === 0) && exist(childrenQuestionList[blankId]) && childrenQuestionList[blankId].editable);
  }

  function getBlankResultCorrectness() {
    // 解析模式下： 已提交待批改（NO_EVALUATION） 、 未自评（ANSEWRED）=> WAIT
    // 获取当前子题的作答结果 对错
    return (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && (blankId || blankId === 0) && exist(childrenQuestionList[blankId]) // @ts-ignore
    && childrenQuestionList[blankId].resultCorrectness;
  }

  function getBlankIsRight() {
    // 获取当前子题的作答结果 对错
    return !!(getBlankResultCorrectness() === EResultCorrectness$1.RIGHT);
  }

  function getOptionStyle() {
    var _a, _b;

    var baseClass = "".concat(style$m['compound-blank-id']);
    var itemInBlank = getUserSubmitItemByBlank();
    var correctAnswer = getBlankAnswer();
    var userAnswer = (itemInBlank === null || itemInBlank === void 0 ? void 0 : itemInBlank.resource) || '';
    var isRightBlank = isFill && ((_b = (_a = userAnswer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.isRight) || (isCloze || isFill) && getBlankIsRight() && !getBlankEditable();
    var isWait = getBlankResultCorrectness() === 'WAIT'; // 作答状态：当前选中或已填写-实心蓝圈（EDIT_RESULT），其他-空心蓝圈（NO_RESULT）
    // 解析状态：正确-绿圈（RESULT_RIGHT），填写内容为空/无正确答案-空心蓝圈（NO_RESULT），其他-红圈（RESULT_WRONG）

    var styleState = isWait ? 'RESULT_WAIT' : isRightBlank ? 'RESULT_RIGHT' : editable ? currentChildIndex === blankId || (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) ? 'EDIT_RESULT' : 'NO_RESULT' : isRightBlank || userAnswer === correctAnswer ? 'RESULT_RIGHT' : (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) ? 'RESULT_WRONG' : 'NO_RESULT';
    var styleMap = {
      EDIT_RESULT: "".concat(baseClass, " ").concat(style$m['compound-blank-id--edit']),
      RESULT_RIGHT: "".concat(baseClass, " ").concat(style$m['compound-blank-id--right']),
      RESULT_WRONG: "".concat(baseClass, " ").concat(style$m['compound-blank-id--wrong']),
      RESULT_WAIT: "".concat(baseClass, " ").concat(style$m['compound-blank-id--wait']),
      NO_RESULT: "".concat(baseClass, " ").concat(style$m['compound-blank-id'], "}")
    };
    setOptionStyle(styleMap[styleState]);
  }

  function getInputStyle() {
    var _a, _b;

    var baseClass = "".concat(style$m['compound-blank']);
    var itemInBlank = getUserSubmitItemByBlank();
    var userAnswer = (itemInBlank === null || itemInBlank === void 0 ? void 0 : itemInBlank.resource) || '';
    var isRightBlank = isFill && ((_b = (_a = userAnswer) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.isRight) || (isCloze || isFill) && getBlankIsRight() && !getBlankEditable();
    var correctAnswer = getBlankAnswer(); // 作答状态：蓝字（AUTO_EDIT)
    // 非作答状态：正确-绿字（RESULT_RIGHT），填写内容为空-灰字（NO_RESULT），错误-红字（RESULT_WRONG）
    // 未自评或者待批改 (#FF893D)

    var isWait = getBlankResultCorrectness() === 'WAIT';
    var styleState = isWait ? 'RESULT_WAIT' : isRightBlank ? 'RESULT_RIGHT' : editable ? 'AUTO_EDIT' : showPlainBlank ? 'PLAIN' : isRightBlank || userAnswer === correctAnswer ? 'RESULT_RIGHT' : userAnswer.length ? 'RESULT_WRONG' : 'NO_RESULT';
    var styleMap = {
      AUTO_EDIT: "".concat(baseClass),
      RESULT_RIGHT: "".concat(baseClass, " ").concat(style$m['compound-blank--right']),
      RESULT_WRONG: "".concat(baseClass, " ").concat(style$m['compound-blank--wrong']),
      NO_RESULT: "".concat(baseClass, " ").concat(style$m['compound-blank--no-result']),
      RESULT_WAIT: "".concat(baseClass, " ").concat(style$m['compound-blank--wait']),
      PLAIN: "".concat(baseClass, " ").concat(style$m['compound-blank--plain'])
    };
    setInputStyle(styleMap[styleState]);
  }

  useEffect(function () {
    var _a, _b, _c;

    var stemInputCopy = stemInput.current;
    var userAnswer = ((_a = getUserSubmitItemByBlank()) === null || _a === void 0 ? void 0 : _a.resource) || ''; // 只有完形填空才修改stemInputCopy的内容

    if (stemInputCopy && (isCloze || isFill)) {
      stemInputCopy.innerText = editable ? userAnswer || '' // TODO: 空上作答 答案回显
      : isFill && userAnswer ? ((_c = (_b = userAnswer) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.userAnswer) || '' : userAnswer || showSubmitInfo && '未作答' || (showPlainBlank ? "".concat(blankId || blankId === 0 ? "\uFF08".concat(blankId + 1, "\uFF09") : '') : '');
    }

    getOptionStyle();
    getInputStyle();
  }, [currentChildIndex, childrenQuestionList]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: style$m['compound-blank-wrapper'],
    role: "button",
    tabIndex: -1,
    onClick: onClickEachBlank
  }, (blankId || blankId === 0) && (isCloze || isFill) && !showPlainBlank && /*#__PURE__*/React.createElement("span", {
    className: optionStyle
  }, blankId + 1), /*#__PURE__*/React.createElement("span", {
    className: inputStyle,
    id: "compound-blank-id-".concat(questionId, "-").concat(blankId),
    role: "presentation",
    tabIndex: -1,
    ref: stemInput
  })));
};

var baseStyle = {"exercise-wrapper":"tangram_C_exercise-wrapper_91c7d9ec25","question-detail":"tangram_C_question-detail_91c7d9ec25","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_91c7d9ec25","card-title":"tangram_C_card-title_91c7d9ec25","structure":"tangram_C_structure_91c7d9ec25","full-blank":"tangram_C_full-blank_91c7d9ec25","text-emphasis":"tangram_C_text-emphasis_91c7d9ec25","table-wrapper":"tangram_C_table-wrapper_91c7d9ec25"};

var ENodeType;

(function (ENodeType) {
  ENodeType["ELEMENT"] = "element";
  ENodeType["ROOT"] = "root";
  ENodeType["TEXT"] = "text";
  ENodeType["EQUATION"] = "equation";
})(ENodeType || (ENodeType = {})); // 编码参照：https://1024.com/a/1415（目前存在的编码需要替换的字符）


var replaceSign = {
  '&nbsp;': "\xA0",
  '&gt;': ">",
  '&lt;': "<",
  '&amp;': "&"
};
/**
 * 中划线转驼峰
 * @param s 需要转化的中划线字符串
 * @returns 驼峰字符串
 */

var dash2hump = function dash2hump(s) {
  if (!s) {
    return '';
  }

  var reg = /-(\w)/g;
  return s.replace(reg, function ($, $1) {
    return $1.toUpperCase();
  });
};
/**
 * 处理结构化的 attr属性，将中划线转化为驼峰，层级不变
 * @param attr attr属性包含填空信息+样式信息+资源信息等
 * @returns 可以传入组件props的对象
 */


var handleAttr = function handleAttr(attr) {
  var _a;

  if (!attr) {
    return null;
  }

  (_a = Object.keys(attr)) === null || _a === void 0 ? void 0 : _a.map(function (key) {
    var _a;

    if (key === 'style') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var temp_1 = {};
      (_a = Object.keys(attr.style)) === null || _a === void 0 ? void 0 : _a.forEach(function (styleKey) {
        var humpKey = dash2hump(styleKey);
        temp_1["".concat(humpKey)] = attr.style[styleKey];
      });
      attr.style = temp_1;
    } else if (key === 'vertical-align') {
      attr[dash2hump(key)] = attr[key];
      delete attr['vertical-align'];
    } else if (key === 'data-img-type') {
      attr[dash2hump(key)] = attr[key];
      delete attr['data-img-type'];
    }

    return attr[key];
  });
  return attr;
};
/**
 * 处理带有空格的文本，将&nbsp;转化为空格
 * @param text 文本
 */


var dealText = function dealText(text) {
  var _a;

  if (!text) {
    return null;
  }

  var res = text;
  (_a = Object.keys(replaceSign)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
    res = res.replace(new RegExp(key, 'g'), replaceSign[key]);
  });
  return res;
};
/**
 * 将新结构化的 json 对象转化为 React.Elememt 组件
 * @param json 新结构化json对象
 * @param extra 其他需要传入组件的参数 (题型logicTypeId、)
 * @returns React.Element
 */


var json2reactElement = function json2reactElement(json, extra) {
  if (!json) {
    return null;
  }

  var child = json.child,
      node = json.node,
      attr = json.attr,
      tag = json.tag,
      text = json.text,
      index = json.index;
      json.length;
  var key = extra.key,
      containerTag = extra.containerTag,
      compoundUse = extra.compoundUse,
      changeCurChildId = extra.changeCurChildId,
      editable = extra.editable,
      childrenQuestionList = extra.childrenQuestionList,
      currentChildIndex = extra.currentChildIndex,
      questionId = extra.questionId,
      showSubmitInfo = extra.showSubmitInfo,
      platForm = extra.platForm,
      showPlainBlank = extra.showPlainBlank;
  var childElement = null;

  if (child) {
    childElement = child === null || child === void 0 ? void 0 : child.map(function (c, i) {
      return json2reactElement(c, _assign$4(_assign$4({}, extra), {
        key: i
      }));
    });
  }

  var attrObj = handleAttr(attr);

  if (node === ENodeType.TEXT) {
    return dealText(text);
  } // 添加对图片、填空、视频、音频的判断


  if (node === ENodeType.ELEMENT) {
    if (!tag) {
      return text;
    }

    switch (tag) {
      case 'img':
        {
          var style = _assign$4({
            width: "".concat(attrObj === null || attrObj === void 0 ? void 0 : attrObj.width),
            height: "".concat(attrObj === null || attrObj === void 0 ? void 0 : attrObj.height),
            background: /^(.*\.(jpg|jpeg))$/i.test((attrObj === null || attrObj === void 0 ? void 0 : attrObj.src) || '') ? '#f6f8fc' : ''
          }, attrObj === null || attrObj === void 0 ? void 0 : attrObj.style); // 不能放大的图片


          if ((attrObj === null || attrObj === void 0 ? void 0 : attrObj.dataImgType) === 'symbol') {
            return /*#__PURE__*/createElement('img', _assign$4({
              key: key,
              src: attrObj === null || attrObj === void 0 ? void 0 : attrObj.src,
              alt: text
            }, style));
          } // 可以放大的图片


          return /*#__PURE__*/React.createElement(Image$1, {
            key: key,
            source: attrObj === null || attrObj === void 0 ? void 0 : attrObj.src,
            style: style
          });
        }

      case 'audio':
        return /*#__PURE__*/React.createElement(Audio$1, _assign$4({
          key: key,
          content: attrObj === null || attrObj === void 0 ? void 0 : attrObj.src
        }, attrObj));

      case 'video':
        return /*#__PURE__*/React.createElement(VideoPlayer, _assign$4({
          key: key,
          source: attrObj === null || attrObj === void 0 ? void 0 : attrObj.src,
          videoWrapperStyle: compoundUse && platForm === EPlatForm.pc ? {
            width: '100%'
          } : {}
        }, attrObj));

      case 'u':
        {
          var _a = attrObj || {},
              vacancy = _a.vacancy,
              line = _a.line;

          if (line === 'full' && attrObj) {
            attrObj.className = baseStyle['full-blank'];
          }

          if (typeof vacancy !== 'string') {
            return /*#__PURE__*/createElement(tag, _assign$4(_assign$4({}, attrObj), {
              key: key
            }), childElement);
          }

          var logicTypeId = (extra === null || extra === void 0 ? void 0 : extra.logicTypeId) || 0;

          if (logicTypeId === ELogicTypeId.FILL_BLANK) {
            return /*#__PURE__*/React.createElement(Blank, {
              key: key,
              blankId: index,
              vacancy: vacancy
            });
          } // 空上作答


          if (logicTypeId === ELogicTypeId.FILL_ON_BLANK) {
            // TODO: 区分可编辑空格和点击定位到子题空格
            if (editable) {
              return /*#__PURE__*/React.createElement(Blank, {
                key: key,
                blankId: index,
                vacancy: vacancy,
                onBlank: true,
                changeCurrentChildId: changeCurChildId,
                currentChildIndex: currentChildIndex
              });
            }

            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompoundBlank, {
              key: key,
              blankId: index,
              logicTypeId: logicTypeId,
              editable: editable,
              childrenQuestionList: childrenQuestionList,
              currentChildIndex: currentChildIndex,
              changeCurrentChildId: changeCurChildId,
              questionId: questionId,
              showSubmitInfo: showSubmitInfo,
              showPlainBlank: showPlainBlank
            }));
          }

          if (logicTypeId && [ELogicTypeId.CLOZE, ELogicTypeId.MULTI_CHOICE_MULTI, ELogicTypeId.COMPOUND].includes(logicTypeId)) {
            return /*#__PURE__*/React.createElement(CompoundBlank, {
              key: key,
              blankId: index,
              logicTypeId: logicTypeId,
              editable: editable,
              childrenQuestionList: childrenQuestionList,
              currentChildIndex: currentChildIndex,
              changeCurrentChildId: changeCurChildId,
              questionId: questionId,
              showSubmitInfo: showSubmitInfo,
              showPlainBlank: showPlainBlank
            });
          }

          return /*#__PURE__*/createElement(tag, _assign$4(_assign$4({}, attrObj), {
            key: key
          }), dealText(text));
        }

      case 'table':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(baseStyle['table-wrapper'], " swiping-disable"),
            key: key
          }, /*#__PURE__*/createElement(tag, _assign$4(_assign$4({}, attrObj), {
            key: key
          }), childElement));
        }

      default:
        return /*#__PURE__*/createElement(tag, _assign$4(_assign$4({}, attrObj), {
          key: key
        }), childElement);
    }
  }

  if (node === ENodeType.EQUATION) {
    if (json === null || json === void 0 ? void 0 : json.src) {
      return /*#__PURE__*/createElement('img', {
        key: key,
        src: json === null || json === void 0 ? void 0 : json.src,
        alt: text,
        style: _assign$4(_assign$4(_assign$4({}, attrObj), {
          width: attrObj === null || attrObj === void 0 ? void 0 : attrObj.width,
          height: attrObj === null || attrObj === void 0 ? void 0 : attrObj.height
        }), attrObj === null || attrObj === void 0 ? void 0 : attrObj.style)
      });
    }

    return /*#__PURE__*/createElement('span', {
      key: key
    }, text);
  }

  if (node === ENodeType.ROOT && (childElement === null || childElement === void 0 ? void 0 : childElement.length)) {
    return /*#__PURE__*/createElement(containerTag || 'div', {
      className: baseStyle.structure
    }, childElement);
  }

  return null;
};

var style$l = {"stem-wrapper":"tangram_C_stem-wrapper_0147fd993c","stem-source":"tangram_C_stem-source_0147fd993c"};

var EEJustifySubject;

(function (EEJustifySubject) {
  EEJustifySubject[EEJustifySubject["\u82F1\u8BED"] = 2] = "\u82F1\u8BED";
  EEJustifySubject[EEJustifySubject["\u8BED\u6587"] = 6] = "\u8BED\u6587";
})(EEJustifySubject || (EEJustifySubject = {}));

var justifyRequiredNames = ['语法填空', '完形填空', '阅读理解', '测试学科大题型', '七选五阅读', '现代文阅读'];
/**
 * 题干来源
 * @param props
 */

var StemSource = function StemSource(_a) {
  var source = _a.source;

  if (!source || Array.isArray(source) && source.length === 0) {
    return null;
  }

  var sourceToUse = Array.isArray(source) ? source[0] : source; // 增加对于各类可能被任意编辑的不可控题源的支持

  if (typeof sourceToUse === 'string') {
    return /*#__PURE__*/React.createElement("span", {
      className: style$l['stem-source']
    }, "\uFF08", sourceToUse, "\uFF09");
  }

  var paperName = sourceToUse.paperName;

  if (paperName) {
    return /*#__PURE__*/React.createElement("span", {
      className: style$l['stem-source']
    }, "\uFF08", paperName, "\uFF09");
  }

  return null;
};
/**
 * 题干组件
 * @param props
 */


var Stem = function Stem(props) {
  var _a;

  var source = props.source,
      stem = props.stem,
      bigTypeName = props.bigTypeName,
      logicTypeId = props.logicTypeId,
      subjectId = props.subjectId,
      changeCurChildId = props.changeCurChildId,
      compoundUse = props.compoundUse,
      questionId = props.questionId,
      childrenQuestionList = props.childrenQuestionList,
      editable = props.editable,
      currentChildIndex = props.currentChildIndex,
      showSubmitInfo = props.showSubmitInfo,
      platForm = props.platForm,
      showPlainBlank = props.showPlainBlank;
  var stemJsonParse = parseJSON(stem);
  var subjectJustify = subjectId && (+subjectId === EEJustifySubject['英语'] || +subjectId === EEJustifySubject['语文']);
  var bigTypeNameJustify = bigTypeName && justifyRequiredNames.includes(bigTypeName);
  var isJustifyAlign = subjectJustify || bigTypeNameJustify; // 没有题干并且没有题源

  return !((_a = stemJsonParse === null || stemJsonParse === void 0 ? void 0 : stemJsonParse.child) === null || _a === void 0 ? void 0 : _a.length) && (!source || Array.isArray(source) && source.length === 0) ? null : /*#__PURE__*/React.createElement("div", {
    className: style$l['stem-wrapper'],
    style: {
      textAlign: isJustifyAlign ? 'justify' : 'left'
    },
    lang: "en-US"
  }, /*#__PURE__*/React.createElement(StemSource, {
    source: source
  }), json2reactElement(stemJsonParse, {
    key: "".concat(questionId, "-stem"),
    logicTypeId: logicTypeId,
    richTextLocation: ERichTextLocation.STEM,
    compoundUse: compoundUse,
    platForm: platForm,
    changeCurChildId: changeCurChildId,
    editable: editable,
    childrenQuestionList: childrenQuestionList,
    currentChildIndex: currentChildIndex,
    questionId: questionId,
    showSubmitInfo: showSubmitInfo,
    showPlainBlank: showPlainBlank
  }));
};

var style$k = {"result-wrap":"tangram_C_result-wrap_e4dc4c1bcd","info-item":"tangram_C_info-item_e4dc4c1bcd","info-title":"tangram_C_info-title_e4dc4c1bcd","info-detail":"tangram_C_info-detail_e4dc4c1bcd","result-info":"tangram_C_result-info_e4dc4c1bcd"};

var AnswerResultInfo = function AnswerResultInfo(_a) {
  var resultInfo = _a.resultInfo;

  if (!resultInfo) {
    return null;
  }

  var useTime = resultInfo.useTime,
      correctRate = resultInfo.correctRate,
      easyErrorOption = resultInfo.easyErrorOption;
  var correctRateStr = correctRate === null || correctRate === void 0 ? void 0 : correctRate.replace('%', '');
  return /*#__PURE__*/React.createElement("div", {
    className: style$k['result-wrap']
  }, useTime || +useTime === 0 ? /*#__PURE__*/React.createElement("div", {
    className: style$k['info-item']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: style$k['info-detail']
  }, useTime), useTime !== '--' && /*#__PURE__*/React.createElement("span", {
    className: style$k['result-info']
  }, "\u79D2")), /*#__PURE__*/React.createElement("span", {
    className: style$k['info-title']
  }, "\u4F5C\u7B54\u7528\u65F6")) : null, correctRateStr ? /*#__PURE__*/React.createElement("div", {
    className: style$k['info-item']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: style$k['info-detail']
  }, correctRateStr), correctRateStr !== '--' && /*#__PURE__*/React.createElement("span", {
    className: style$k['result-info']
  }, "%")), /*#__PURE__*/React.createElement("span", {
    className: style$k['info-title']
  }, "\u5168\u7AD9\u6B63\u786E\u7387")) : null, easyErrorOption ? /*#__PURE__*/React.createElement("div", {
    className: style$k['info-item']
  }, /*#__PURE__*/React.createElement("span", {
    className: style$k['info-detail']
  }, easyErrorOption), /*#__PURE__*/React.createElement("span", {
    className: style$k['info-title']
  }, "\u6613\u9519\u9879")) : null);
};

var EResultCorrectness;

(function (EResultCorrectness) {
  EResultCorrectness["WAIT"] = "WAIT";
  EResultCorrectness["RIGHT"] = "RIGHT";
  EResultCorrectness["PARTIAL_RIGHT"] = "PARTIAL_RIGHT";
  EResultCorrectness["WRONG"] = "WRONG";
})(EResultCorrectness || (EResultCorrectness = {}));

var style$j = {"exercise-wrapper":"tangram_C_exercise-wrapper_f41ad78c49","question-detail":"tangram_C_question-detail_f41ad78c49","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_f41ad78c49","card-title":"tangram_C_card-title_f41ad78c49","structure":"tangram_C_structure_f41ad78c49","full-blank":"tangram_C_full-blank_f41ad78c49","text-emphasis":"tangram_C_text-emphasis_f41ad78c49","table-wrapper":"tangram_C_table-wrapper_f41ad78c49","answer-wrapper":"tangram_C_answer-wrapper_f41ad78c49","sticker":"tangram_C_sticker_f41ad78c49","top-right":"tangram_C_top-right_f41ad78c49","bottom-right":"tangram_C_bottom-right_f41ad78c49","bottom-left":"tangram_C_bottom-left_f41ad78c49","top-left":"tangram_C_top-left_f41ad78c49","imgs-wrapper":"tangram_C_imgs-wrapper_f41ad78c49","img-wrapper":"tangram_C_img-wrapper_f41ad78c49","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_f41ad78c49","answer-box":"tangram_C_answer-box_f41ad78c49","correct-answer":"tangram_C_correct-answer_f41ad78c49","user-answer":"tangram_C_user-answer_f41ad78c49"};

/**
 * 正确答案、用户答案
 */

var Answer = function Answer() {
  var _a = useContext(Context$1),
      answer = _a.answer,
      userSubmitItems = _a.userSubmitItems,
      resultCorrectness = _a.resultCorrectness,
      resultInfo = _a.resultInfo;

  if (!answer) {
    return null;
  }

  var questionAnswers = parseJSON(answer);
  var userAnswer = (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) ? userSubmitItems.map(function (item) {
    return item.resource;
  }).join('') : '';
  var correctAnswerList = questionAnswers === null || questionAnswers === void 0 ? void 0 : questionAnswers.map(function (ans) {
    return ans === null || ans === void 0 ? void 0 : ans.map(function (item) {
      var _a, _b;

      return (_b = (_a = item.child) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text;
    }).join('');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: answerStyle['answer-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$j['card-title']
  }, "\u7B54\u9898\u7ED3\u679C"), /*#__PURE__*/React.createElement("div", {
    className: style$j['answer-box']
  }, (questionAnswers === null || questionAnswers === void 0 ? void 0 : questionAnswers.length) && /*#__PURE__*/React.createElement("span", {
    className: style$j['correct-answer']
  }, "\u6B63\u786E\u7B54\u6848\uFF1A", /*#__PURE__*/React.createElement("strong", null, questionAnswers === null || questionAnswers === void 0 ? void 0 : questionAnswers.map(function (answer, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("span", {
        key: index
      }, answer === null || answer === void 0 ? void 0 : answer.map(function (structure, key) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("span", {
            key: key
          }, json2reactElement(structure, {
            key: key,
            containerTag: 'span'
          }), key < answer.length - 1 && /*#__PURE__*/React.createElement(React.Fragment, null, "; \xA0"))
        );
      }), index < questionAnswers.length - 1 && /*#__PURE__*/React.createElement(React.Fragment, null, "\u6216\xA0"))
    );
  }))), userAnswer && /*#__PURE__*/React.createElement("span", {
    className: "\n                                ".concat(style$j['user-answer'], "\n                                ").concat(resultCorrectness === EResultCorrectness.RIGHT || (correctAnswerList === null || correctAnswerList === void 0 ? void 0 : correctAnswerList.includes(userAnswer)) ? style$j['correct-answer'] : '', "\n                            ")
  }, "\u4F60\u7684\u7B54\u6848\uFF1A", /*#__PURE__*/React.createElement("strong", null, userAnswer)), resultInfo && /*#__PURE__*/React.createElement(AnswerResultInfo, {
    resultInfo: resultInfo
  }))));
};

/**
 * 答案、解析、来源
 * @param props
 */

var AnswerInfo$1 = function AnswerInfo() {
  var _a = useContext(Context$1),
      analysis = _a.analysis,
      editable = _a.editable,
      source = _a.source,
      labelList = _a.labelList,
      answer = _a.answer,
      platForm = _a.platForm,
      sticker = _a.sticker;

  if (editable) {
    return null;
  }

  if (!analysis && !source && !labelList && !answer) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, !!answer && /*#__PURE__*/React.createElement(Answer, null), /*#__PURE__*/React.createElement(Analysis, {
    analysis: analysis,
    platForm: platForm
  }), /*#__PURE__*/React.createElement(StickerInCard, {
    sticker: sticker,
    locModule: EStickerLocModule.ANALYSIS_END_IN_CARD
  }), /*#__PURE__*/React.createElement(Point, {
    labelList: labelList
  }), /*#__PURE__*/React.createElement(Source, {
    source: source
  }));
};

var style$i = {"exercise-wrapper":"tangram_C_exercise-wrapper_b2b2e3987f","question-detail":"tangram_C_question-detail_b2b2e3987f","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_b2b2e3987f","card-title":"tangram_C_card-title_b2b2e3987f","structure":"tangram_C_structure_b2b2e3987f","full-blank":"tangram_C_full-blank_b2b2e3987f","text-emphasis":"tangram_C_text-emphasis_b2b2e3987f","table-wrapper":"tangram_C_table-wrapper_b2b2e3987f","option-wrapper":"tangram_C_option-wrapper_b2b2e3987f","direction-row":"tangram_C_direction-row_b2b2e3987f","option-item":"tangram_C_option-item_b2b2e3987f","all":"tangram_C_all_b2b2e3987f","col2":"tangram_C_col2_b2b2e3987f","option-editable":"tangram_C_option-editable_b2b2e3987f","mutiple-option-item":"tangram_C_mutiple-option-item_b2b2e3987f","option-title":"tangram_C_option-title_b2b2e3987f","option-title-multi":"tangram_C_option-title-multi_b2b2e3987f","option-text":"tangram_C_option-text_b2b2e3987f","option-correct":"tangram_C_option-correct_b2b2e3987f","option-wrong":"tangram_C_option-wrong_b2b2e3987f","option-unselect":"tangram_C_option-unselect_b2b2e3987f","option-selected":"tangram_C_option-selected_b2b2e3987f","option-correct-no-select":"tangram_C_option-correct-no-select_b2b2e3987f"};

var _a$5;
var THROTTLE_TIME = 500;
var ESingleOptionStateTypes;

(function (ESingleOptionStateTypes) {
  ESingleOptionStateTypes["NORMAL_OPTION"] = "NORMAL_OPTION";
  ESingleOptionStateTypes["CORRECT_OPTION"] = "CORRECT";
  ESingleOptionStateTypes["USER_WRONG_OPTION"] = "USER_WRONG_OPTION";
  ESingleOptionStateTypes["UNSELECT_OPTION"] = "UNSELECT_OPTION";
})(ESingleOptionStateTypes || (ESingleOptionStateTypes = {}));

var EMutipleOptionStateTypes;

(function (EMutipleOptionStateTypes) {
  EMutipleOptionStateTypes["IS_USER_SELECTED"] = "IS_USER_SELECTED";
  EMutipleOptionStateTypes["NOT_USER_SELECTED"] = "NOT_USER_SELECTED";
})(EMutipleOptionStateTypes || (EMutipleOptionStateTypes = {})); // 多列样式


var EDirectionRow;

(function (EDirectionRow) {
  EDirectionRow["ALL"] = "all";
  EDirectionRow["NORMAL"] = "normal";
  EDirectionRow["COL2"] = "col2";
})(EDirectionRow || (EDirectionRow = {}));

(_a$5 = {}, _a$5[EDirectionRow.ALL] = {
  with: 'auto'
}, _a$5[EDirectionRow.NORMAL] = {
  with: '100%'
}, _a$5[EDirectionRow.COL2] = {
  with: '50%'
}, _a$5);
var A = 65; // 选项区内边距

var optionsDiff = 32; // 无选项宽度预设值

var optionsIndexDiff = 60;
/**
 * @param props 选项组件
 */

var ChoiceOptions = function ChoiceOptions() {
  var _a, _b, _c;

  var _d = useContext(Context$1),
      options = _d.options,
      userSubmitItems = _d.userSubmitItems,
      editable = _d.editable,
      logicTypeId = _d.logicTypeId,
      answer = _d.answer,
      answerChangeCallback = _d.onAnswerChange,
      questionId = _d.questionId,
      compoundUse = _d.compoundUse,
      platForm = _d.platForm,
      parentLogicTypeId = _d.parentLogicTypeId; // TODO: 宽度计算


  var optionsRef = useRef(null); // 是否两列

  var _e = useState(''),
      flexBasis = _e[0],
      setFlexBasis = _e[1]; // 选项初始样式，用于计算选项宽度


  var _f = useState(true),
      isInit = _f[0],
      setInit = _f[1]; // 多选多


  var isMCM = parentLogicTypeId === ELogicTypeId.MULTI_CHOICE_MULTI; // pc端复合题中选择题选项独占一行

  var customItemStyle = useMemo(function () {
    return isMCM && isInit ? {
      width: 'auto',
      visibility: 'hidden'
    } : compoundUse && platForm === EPlatForm.pc && !isMCM ? {
      width: '100%',
      marginRight: 0
    } : {};
  }, [compoundUse, isInit, isMCM]);
  var choseList = (((_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) || '').split('') || [];
  var optionsList = ((_b = parseJSON(options)) === null || _b === void 0 ? void 0 : _b.map(function (option, index) {
    return {
      optionIndex: String.fromCharCode(A + index),
      body: option
    };
  })) || [];
  var mutipleCorrectAnswers = answer ? (_c = parseJSON(answer)) === null || _c === void 0 ? void 0 : _c.map(function (ans) {
    return ans === null || ans === void 0 ? void 0 : ans.map(function (structure) {
      var _a, _b;

      return ((_b = (_a = structure === null || structure === void 0 ? void 0 : structure.child) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text) || '';
    }).join('');
  }) : null;
  var correctAnswers = mutipleCorrectAnswers === null || mutipleCorrectAnswers === void 0 ? void 0 : mutipleCorrectAnswers.join('');

  var updateUserSubmit = function updateUserSubmit(choseList) {
    // 每次选择将数据吐出,返还业务
    var sendDataToUser = choseList.length > 0 ? [{
      resource: choseList === null || choseList === void 0 ? void 0 : choseList.sort().join(''),
      resourceType: ESubmitItemTypes.OPTION
    }] : [];
    footPrintSecondaryReport({
      // 一级事件都从cookie中去查
      secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
      actionValue: JSON.stringify(sendDataToUser)
    });
    answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, sendDataToUser);
  };

  var choseOption = function choseOption(options) {
    if (!editable) {
      return false;
    }

    footPrintDetailReport({
      detailAction: '选项点击上报',
      actionValue: "".concat(options.optionIndex)
    }); // 单选题回调

    var single = function single() {
      return updateUserSubmit([options.optionIndex]);
    }; // 多选题回调


    var multiple = function multiple() {
      if (choseList.includes(options.optionIndex)) {
        updateUserSubmit(choseList.filter(function (val) {
          return val !== options.optionIndex;
        }));
      } else {
        updateUserSubmit(__spreadArray(__spreadArray([], choseList, true), [options.optionIndex], false));
      }
    };

    logicTypeId && +logicTypeId === 3 && multiple();
    logicTypeId && +logicTypeId === 2 && multiple();
    logicTypeId && +logicTypeId === 1 && single();
  };

  var isMyChoice = function isMyChoice(option) {
    var _a;

    if (!logicTypeId || +logicTypeId !== 2 && +logicTypeId !== 3 || editable) {
      return false;
    }

    var optionState = EMutipleOptionStateTypes.NOT_USER_SELECTED;
    optionState = userSubmitItems && (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.map(function (item) {
      return item.resource;
    }).join('').indexOf(option.optionIndex)) > -1 ? EMutipleOptionStateTypes.IS_USER_SELECTED : EMutipleOptionStateTypes.NOT_USER_SELECTED;
    var mutipleOptionMap = (_a = {}, _a[EMutipleOptionStateTypes.NOT_USER_SELECTED] = false, _a[EMutipleOptionStateTypes.IS_USER_SELECTED] = true, _a);
    return mutipleOptionMap[optionState];
  };

  var getOptionStyle = function getOptionStyle(option) {
    var _a; // 可作答


    if (editable) {
      return "\n                ".concat(style$i['option-item'], "\n                ").concat(style$i['option-editable'], "\n                ").concat(choseList.includes(option.optionIndex) && style$i['option-selected'], "\n            ");
    } // 单选题的对错有两种可能:1.是正确选项,则展示正确的样式2.是用户选择的错误选项,则展示错误的样式


    if (logicTypeId && +logicTypeId === 1) {
      var optionState = ESingleOptionStateTypes.NORMAL_OPTION; // 没有传答案数据，未批改情况

      if (!correctAnswers) {
        return "\n                ".concat(style$i['option-item'], "\n                ").concat((userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && option.optionIndex === userSubmitItems[0].resource && style$i['option-selected'], "\n            ");
      }

      var isUserSelected = (userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.length) && option.optionIndex === userSubmitItems[0].resource;
      optionState = (correctAnswers === null || correctAnswers === void 0 ? void 0 : correctAnswers.includes(option.optionIndex)) ? ESingleOptionStateTypes.CORRECT_OPTION : isUserSelected ? ESingleOptionStateTypes.USER_WRONG_OPTION : ESingleOptionStateTypes.UNSELECT_OPTION;
      var singleOptionMap = (_a = {}, _a[ESingleOptionStateTypes.NORMAL_OPTION] = '', _a[ESingleOptionStateTypes.CORRECT_OPTION] = style$i['option-correct'], _a[ESingleOptionStateTypes.USER_WRONG_OPTION] = style$i['option-wrong'], _a[ESingleOptionStateTypes.UNSELECT_OPTION] = style$i['option-unselect'], _a);
      return "\n                ".concat(style$i['option-item'], "\n                ").concat(singleOptionMap[optionState], "\n            ");
    } // 多选


    if (logicTypeId && (+logicTypeId === 2 || +logicTypeId === 3)) {
      var userSubmits_1 = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems.map(function (submit) {
        return submit === null || submit === void 0 ? void 0 : submit.resource;
      });

      if (!correctAnswers) {
        return "\n                ".concat(style$i['option-item'], "\n                ").concat(style$i['mutiple-option-item'], "\n                ").concat((userSubmits_1 === null || userSubmits_1 === void 0 ? void 0 : userSubmits_1.includes(option.optionIndex)) && style$i['option-selected'], "\n            ");
      } // 多选题多组答案规则：从第一种答案匹配选项，以最先匹配到的为准


      var searchCorrectAnswers = mutipleCorrectAnswers === null || mutipleCorrectAnswers === void 0 ? void 0 : mutipleCorrectAnswers.find(function (item) {
        var _a, _b;

        return (_b = (_a = userSubmits_1 === null || userSubmits_1 === void 0 ? void 0 : userSubmits_1.join('')) === null || _a === void 0 ? void 0 : _a.split('')) === null || _b === void 0 ? void 0 : _b.every(function (submitItem) {
          return item.includes(submitItem);
        });
      });
      var baseCorrectAnswers = searchCorrectAnswers ? searchCorrectAnswers : mutipleCorrectAnswers === null || mutipleCorrectAnswers === void 0 ? void 0 : mutipleCorrectAnswers[0];
      return "\n                ".concat(style$i['option-item'], "\n                ").concat(style$i['mutiple-option-item'], "\n                ").concat((baseCorrectAnswers === null || baseCorrectAnswers === void 0 ? void 0 : baseCorrectAnswers.includes(option.optionIndex)) ? isMyChoice(option) ? style$i['option-correct'] : style$i['option-correct-no-select'] : isMyChoice(option) ? style$i['option-wrong'] : style$i['option-unselect'], "\n\n            ");
    }
  };

  useEffect(function () {
    var _a, _b, _c;

    if (!(optionsRef === null || optionsRef === void 0 ? void 0 : optionsRef.current) || !isMCM) {
      return;
    }

    var childOptionsList = Array.from((_b = (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
    var maxWidth = childOptionsList.reduce(function (pre, cur) {
      return Math.max(pre, cur.offsetWidth);
    }, 0);
    var optionsWidth = ((_c = optionsRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth) || 0;
    var columnResult = optionsWidth > optionsDiff ? Math.floor((optionsWidth - optionsDiff) / maxWidth) : 0;

    if (maxWidth <= optionsIndexDiff) {
      // 判断是否都没有选项内容 横排展示 不设置 50%
      var allEmpty = optionsList.reduce(function (pre, cur) {
        var _a, _b;

        return pre && !((_b = (_a = cur === null || cur === void 0 ? void 0 : cur.body) === null || _a === void 0 ? void 0 : _a.child) === null || _b === void 0 ? void 0 : _b.length);
      }, true);
      var columnResult_1 = Math.floor((optionsWidth > optionsDiff ? optionsWidth - optionsDiff : 0) / maxWidth);
      setInit(false);
      setFlexBasis(allEmpty ? EDirectionRow.ALL : columnResult_1 > 1 ? EDirectionRow.COL2 : '');
    } else {
      setInit(false);
      setFlexBasis(columnResult > 1 ? EDirectionRow.COL2 : '');
    }
  }, [options]);
  return (optionsList === null || optionsList === void 0 ? void 0 : optionsList.length) ? /*#__PURE__*/React.createElement("div", {
    className: "\n                    ".concat(style$i['option-wrapper'], "\n                    ").concat(isMCM && !isInit && flexBasis ? style$i['direction-row'] : '', "\n                "),
    ref: optionsRef,
    // 初始
    style: isMCM && isInit ? {
      flexDirection: 'row',
      whiteSpace: 'nowrap'
    } : {}
  }, optionsList.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.optionIndex,
      role: "button",
      tabIndex: 0,
      onClick: throttle(function () {
        return choseOption(option);
      }, THROTTLE_TIME),
      className: "".concat(getOptionStyle(option), " ").concat(style$i[flexBasis] || ''),
      style: customItemStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "\n                                    ".concat(style$i['option-title'], "\n                                    ").concat(logicTypeId && +logicTypeId === 1 ? '' : style$i['option-title-multi'], "\n                                ")
    }, /*#__PURE__*/React.createElement("span", null, option.optionIndex)), /*#__PURE__*/React.createElement("div", {
      className: style$i['option-text']
    }, json2reactElement(option.body, {
      key: "".concat(questionId, "-").concat(option.optionIndex)
    })));
  })) : null;
};

var style$h = {"exercise-wrapper":"tangram_C_exercise-wrapper_e6ecb189de","choice-wrapper":"tangram_C_choice-wrapper_e6ecb189de","question-detail":"tangram_C_question-detail_e6ecb189de","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_e6ecb189de","card-title":"tangram_C_card-title_e6ecb189de","structure":"tangram_C_structure_e6ecb189de","full-blank":"tangram_C_full-blank_e6ecb189de","text-emphasis":"tangram_C_text-emphasis_e6ecb189de","table-wrapper":"tangram_C_table-wrapper_e6ecb189de","pc-child-about-grade":"tangram_C_pc-child-about-grade_e6ecb189de"};

var Context$1 = /*#__PURE__*/createContext({});

var Choice = function Choice(props) {
  var stem = props.stem,
      showGrade = props.showGrade,
      stemSource = props.stemSource,
      logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      bigTypeName = props.bigTypeName,
      questionId = props.questionId,
      subjectId = props.subjectId,
      sticker = props.sticker,
      parentLogicTypeId = props.parentLogicTypeId,
      editable = props.editable,
      compoundUse = props.compoundUse,
      platForm = props.platForm;
  useSetCookie(questionId);
  useEffect(function () {
    if (questionId) {
      footPrintSecondaryReport({
        // 一级事件都从cookie中去查
        secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
        actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Context$1.Provider, {
    value: _assign$4({}, props)
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n                        ".concat(style$h['choice-wrapper'], "\n                        single-question-item\n                        ").concat(compoundUse ? style$h['compound-sub-card-between-space'] : '', "\n                    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$h['question-detail'], "\n                            ").concat(!showGrade && platForm === EPlatForm.pc ? style$h['pc-child-about-grade'] : '', "\n                            ").concat(!showGrade && platForm === EPlatForm.pc ? 'pc-child-about-grade' : '', "\n                        "),
    style: {
      borderRadius: "".concat(compoundUse ? '0 0 10px 10px' : '10px')
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName,
    parentLogicTypeId: parentLogicTypeId
  }), /*#__PURE__*/React.createElement(Stem, {
    stem: stem,
    questionId: questionId,
    source: stemSource,
    subjectId: subjectId,
    bigTypeName: bigTypeName,
    logicTypeId: logicTypeId,
    editable: editable
  }), /*#__PURE__*/React.createElement(ChoiceOptions, null), sticker === null || sticker === void 0 ? void 0 : sticker.map(function (item, index) {
    return (item.location === EStickerLocModule.ANSWERINFO || item.location === EStickerLocModule.ANSWERINFOEND) &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Sticker, {
      sticker: item,
      key: "".concat(questionId).concat(index)
    });
  })), /*#__PURE__*/React.createElement(AnswerInfo$1, null))));
};

var Choice$1 = Choice;

var style$g = {"interactive-wrapper":"tangram_C_interactive-wrapper_c2c1811dbe"};

/**
 * 互动题
 */

var Interactive = function Interactive(props) {
  var _a, _b;

  var questionId = props.questionId,
      interactiveContent = props.interactiveContent,
      editable = props.editable,
      userSubmitItems = props.userSubmitItems,
      onAnswerChange = props.onAnswerChange;
  var coursewareUrl = interactiveContent.coursewareUrl;
  var iframeRef = useRef(null);

  var _c = useState("status=".concat(editable ? EQuestionStatus.ANSWER : EQuestionStatus.ANALYSIS, "&studentSubmit=").concat((_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) !== null && _b !== void 0 ? _b : '')),
      urlParams = _c[0],
      setUrlParams = _c[1];

  useEffect(function () {
    footPrintSecondaryReport({
      secondaryAction: FOOT_PRINT_SECOND_ACTION.RECEIVED_DATA,
      actionValue: "\u9898\u76EE\u4FE1\u606F\u83B7\u53D6\u6210\u529F, questionId\uFF1A".concat(questionId)
    });
  }, [questionId]);

  function dealStudentSubmit(e) {
    var _a = e.data || {},
        type = _a.type,
        answerList = _a.answerList;

    if (type !== 'studentSubmit') {
      return;
    }

    onAnswerChange === null || onAnswerChange === void 0 ? void 0 : onAnswerChange(questionId, [{
      resourceType: ESubmitItemTypes.INTERACTIVE,
      resource: answerList
    }]);
    footPrintSecondaryReport({
      secondaryAction: FOOT_PRINT_SECOND_ACTION.SEND_USER_DATA,
      actionValue: JSON.stringify(answerList)
    });
  }

  function loadedIframe() {
    footPrintSecondaryReport({
      secondaryAction: '互动题加载完成'
    });
  }

  useEffect(function () {
    var _a, _b;

    setUrlParams("status=".concat(editable ? EQuestionStatus.ANSWER : EQuestionStatus.ANALYSIS, "&studentSubmit=").concat((_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) !== null && _b !== void 0 ? _b : ''));
    var iframeDom = iframeRef.current;
    window.addEventListener('message', dealStudentSubmit);
    iframeDom === null || iframeDom === void 0 ? void 0 : iframeDom.addEventListener('load', loadedIframe);
    return function () {
      window.removeEventListener('message', dealStudentSubmit);
      iframeDom === null || iframeDom === void 0 ? void 0 : iframeDom.removeEventListener('load', loadedIframe);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeRef.current, questionId]);

  if (!coursewareUrl) {
    console.error('互动题链接不能为空');
    return null;
  }

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: style$g['interactive-wrapper']
  }, coursewareUrl && /*#__PURE__*/React.createElement("iframe", {
    ref: iframeRef,
    title: "interactive",
    src: "".concat(coursewareUrl, "&").concat(urlParams),
    frameBorder: "0"
  })));
};

var style$f = {"fit-img":"tangram_C_fit-img_8d9bbcb362"};

var DEFAULT_HW_RATIO = 56;

var FitImg = function FitImg(props) {
  var src = props.src,
      _a = props.fit,
      fit = _a === void 0 ? 'contain' : _a,
      _b = props.ratio,
      ratio = _b === void 0 ? DEFAULT_HW_RATIO : _b;
  return /*#__PURE__*/React.createElement("div", {
    className: style$f['fit-img'],
    style: {
      objectFit: fit,
      paddingBottom: "".concat(ratio, "%"),
      backgroundImage: "url(".concat(src, ")")
    }
  });
};

var style$e = {"container":"tangram_C_container_3c0dcd2bb5","recite-content":"tangram_C_recite-content_3c0dcd2bb5","syllable":"tangram_C_syllable_3c0dcd2bb5","word":"tangram_C_word_3c0dcd2bb5","good":"tangram_C_good_3c0dcd2bb5","bad":"tangram_C_bad_3c0dcd2bb5"};

var styledClassNames$2 = bind.bind(style$e);
var PRONUNCIATION_GOOD_LINE = 75;
var PRONUNCIATION_PASS_LINE = 50;
var syllableId = 0;
var wordId = 0;

var AtomJudge = function AtomJudge(props) {
  var _a, _b, _c, _d;

  var base_info = props.atomJudge.base_info,
      showOriginalContent = props.showOriginalContent;
  var wordReciteStructured = useContext(Context).wordReciteStructured;
  var reciteContent = handlePhoneticSymbols(wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteContent);
  var begin = exit((_a = base_info === null || base_info === void 0 ? void 0 : base_info.char_range) === null || _a === void 0 ? void 0 : _a.begin) ? (_b = base_info === null || base_info === void 0 ? void 0 : base_info.char_range) === null || _b === void 0 ? void 0 : _b.begin : 0;
  var end = exit((_c = base_info === null || base_info === void 0 ? void 0 : base_info.char_range) === null || _c === void 0 ? void 0 : _c.end) ? (_d = base_info === null || base_info === void 0 ? void 0 : base_info.char_range) === null || _d === void 0 ? void 0 : _d.end : 0;
  return /*#__PURE__*/React.createElement("span", {
    className: styledClassNames$2({
      'word': true,
      'recite-content': true,
      'good': (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) && (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) > PRONUNCIATION_GOOD_LINE,
      'bad': (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) && (base_info === null || base_info === void 0 ? void 0 : base_info.pronunciation_score) < PRONUNCIATION_PASS_LINE
    })
  }, showOriginalContent ? reciteContent : reciteContent === null || reciteContent === void 0 ? void 0 : reciteContent.slice(begin, end));
};

var Words = function Words(props) {
  var wordInfo = props.wordInfo,
      _a = props.showOriginalContent,
      showOriginalContent = _a === void 0 ? false : _a;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AtomJudge, {
    atomJudge: wordInfo,
    showOriginalContent: showOriginalContent
  }), /*#__PURE__*/React.createElement("span", null, " "));
};

var Syllables = function Syllables(props) {
  var _a, _b, _c, _d;

  var wordInfo = props.wordInfo;
  var syllable_infos = wordInfo.syllable_infos; // 如果是follow-up这种连词，那么就回退到较大粒度即单词维度打分。否则按最细粒度音的维度打分

  var isConj = ((_b = (_a = syllable_infos === null || syllable_infos === void 0 ? void 0 : syllable_infos[0]) === null || _a === void 0 ? void 0 : _a.base_info) === null || _b === void 0 ? void 0 : _b.text_content) === ''; // 如果是音标，那么也回退到单词维度打分

  var isPhoneticSymbol = (_d = (_c = wordInfo === null || wordInfo === void 0 ? void 0 : wordInfo.base_info) === null || _c === void 0 ? void 0 : _c.text_content) === null || _d === void 0 ? void 0 : _d.startsWith('/');
  return /*#__PURE__*/React.createElement(React.Fragment, null, isConj ? /*#__PURE__*/React.createElement(Words, {
    wordInfo: wordInfo
  }) : isPhoneticSymbol ? /*#__PURE__*/React.createElement(Words, {
    wordInfo: wordInfo,
    showOriginalContent: true
  }) : syllable_infos === null || syllable_infos === void 0 ? void 0 : syllable_infos.map(function (syllableInfo) {
    return /*#__PURE__*/React.createElement(AtomJudge, {
      key: syllableId++,
      atomJudge: syllableInfo
    });
  }), /*#__PURE__*/React.createElement("span", null, " "));
};
/**
 * 语音题，朗读内容的渲染组件,有四种状态
 * @author chenbaijin
 * @desp 状态1: 没有判题结果，直接展示reciteContent
 * @desp 状态2: 有判题结果并且为句子，那么仅以单词维度展示朗读评分
 * @desp 状态3: 有判题结果并且为单词，并且是self-destruction这种连词，那么也以单词维度展示朗读评分
 * @desp 状态4: 有判题结果并且为普通单词，那么以一个音的维度展示朗读评分（这也是最细粒度的评分）
 */


var SpeechStem = function SpeechStem() {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  var _j = useContext(Context),
      wordReciteStructured = _j.wordReciteStructured,
      userSubmitItems = _j.userSubmitItems;

  var judgeResultJson = (_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b.result;
  var judgeResult = judgeResultJson ? parseJSON(judgeResultJson) : null;
  var reciteContent = handlePhoneticSymbols(wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteContent); // console.log(judgeResult, 'judgeResult==');
  // 修正函数

  function wordInfoCheckAndReformation(wordInfos) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;

    if ((wordInfos === null || wordInfos === void 0 ? void 0 : wordInfos.length) && (wordInfos === null || wordInfos === void 0 ? void 0 : wordInfos.length) >= 1) {
      var reformedWordInfos_1 = [];

      for (var i = 0; i < (wordInfos === null || wordInfos === void 0 ? void 0 : wordInfos.length); i++) {
        if (((_a = wordInfos[i].syllable_infos) === null || _a === void 0 ? void 0 : _a.length) && wordInfos[i].syllable_infos.length > 1) {
          var reformedSyllableInfos = [(_b = wordInfos[i]) === null || _b === void 0 ? void 0 : _b.syllable_infos[0]];

          for (var j = 1; j < wordInfos[i].syllable_infos.length; j++) {
            var refreshedLengt = reformedSyllableInfos.length - 1;
            var rawBegin = (_g = (_f = (_e = (_d = (_c = wordInfos[i]) === null || _c === void 0 ? void 0 : _c.syllable_infos) === null || _d === void 0 ? void 0 : _d[j]) === null || _e === void 0 ? void 0 : _e.base_info) === null || _f === void 0 ? void 0 : _f.char_range) === null || _g === void 0 ? void 0 : _g.begin;
            var rawEnd = (_m = (_l = (_k = (_j = (_h = wordInfos[i]) === null || _h === void 0 ? void 0 : _h.syllable_infos) === null || _j === void 0 ? void 0 : _j[j]) === null || _k === void 0 ? void 0 : _k.base_info) === null || _l === void 0 ? void 0 : _l.char_range) === null || _m === void 0 ? void 0 : _m.end;
            var confirmedEnd = (_p = (_o = reformedSyllableInfos[refreshedLengt].base_info) === null || _o === void 0 ? void 0 : _o.char_range) === null || _p === void 0 ? void 0 : _p.end;

            if (rawBegin && rawEnd && confirmedEnd && rawBegin < confirmedEnd) {
              reformedSyllableInfos.push(_assign$4(_assign$4({}, (_r = (_q = wordInfos[i]) === null || _q === void 0 ? void 0 : _q.syllable_infos) === null || _r === void 0 ? void 0 : _r[j]), {
                base_info: _assign$4(_assign$4({}, (_t = (_s = wordInfos[i]) === null || _s === void 0 ? void 0 : _s.syllable_infos) === null || _t === void 0 ? void 0 : _t[j].base_info), {
                  char_range: {
                    begin: confirmedEnd,
                    end: rawEnd
                  }
                })
              }));
            } else {
              reformedSyllableInfos.push(_assign$4({}, (_v = (_u = wordInfos[i]) === null || _u === void 0 ? void 0 : _u.syllable_infos) === null || _v === void 0 ? void 0 : _v[j]));
            }
          }

          reformedWordInfos_1.push(_assign$4(_assign$4({}, wordInfos[i]), {
            syllable_infos: reformedSyllableInfos
          }));
        } else {
          reformedWordInfos_1.push(_assign$4({}, wordInfos[i]));
        }
      }

      return reformedWordInfos_1;
    }

    return wordInfos;
  } // console.log('处理前', judgeResult?.word_infos);


  var reformedWordInfos = wordInfoCheckAndReformation(judgeResult === null || judgeResult === void 0 ? void 0 : judgeResult.word_infos); // console.log('处理后', reformedWordInfos);

  var reformedJudgeResult = _assign$4(_assign$4({}, judgeResult), {
    word_infos: reformedWordInfos
  });
  /**
   * 将拿到的需要进行语音评测的内容按空白符号分割
   * 以得到需要评测内容的词的总数，如果总数大于3，则该内容被认定为句子
   * 对于‘非’句子或以斜线 ‘/’ 开头的音标，需要居中显示
   */


  var processedReciteArray = [];
  (_c = reciteContent === null || reciteContent === void 0 ? void 0 : reciteContent.split(/\s/)) === null || _c === void 0 ? void 0 : _c.forEach(function (substr) {
    return substr && processedReciteArray.push(substr);
  });
  var isSentence = processedReciteArray.length > 3;
  var shouldCentered = (reciteContent === null || reciteContent === void 0 ? void 0 : reciteContent.startsWith('/')) || !isSentence; // 递归，不清楚逻辑勿随意改动优化

  function stringProcess(rawStr) {
    var processedStrs = [];

    function recursive(s) {
      if (!s) {
        return;
      }

      var trimedStr = s.trim();
      var baseIndex = 0;

      for (var _i = 0, s_1 = s; _i < s_1.length; _i++) {
        var each = s_1[_i];

        if (!/\n/.test(each)) {
          break;
        }

        baseIndex++;
      }

      var slicedStrForPush = trimedStr.includes('\n') ? s.slice(0, trimedStr.indexOf('\n') + baseIndex) : s;
      processedStrs.push(slicedStrForPush);
      slicedStrForPush !== s && recursive(s.slice(trimedStr.indexOf('\n') + baseIndex, s.length));
    }

    recursive(rawStr);
    return processedStrs;
  }
  /**
   * 将内容以除空格以及换行符 ‘\n’ 外的其他空白符号进行分割
   * 再对分割出来的每一个子串进行递归处理，以分离每个子串中的换行符
   */


  var processedReciteArrayWithReturn = [];
  (_d = reciteContent === null || reciteContent === void 0 ? void 0 : reciteContent.split(/[\f\r\t\v]/)) === null || _d === void 0 ? void 0 : _d.forEach(function (substr) {
    var _a;

    substr && ((_a = stringProcess(substr)) === null || _a === void 0 ? void 0 : _a.forEach(function (each) {
      return processedReciteArrayWithReturn.push(each);
    }));
  });
  var processedReciteArrayAlignWithAI = [];
  (_e = reciteContent === null || reciteContent === void 0 ? void 0 : reciteContent.split(/[ \f\r\t\v]/)) === null || _e === void 0 ? void 0 : _e.forEach(function (substr) {
    var _a;

    substr && ((_a = stringProcess(substr)) === null || _a === void 0 ? void 0 : _a.forEach(function (each) {
      return processedReciteArrayAlignWithAI.push(each);
    }));
  });

  function getPreAndPostReturn(originalStr, uniqueId, keyScale) {
    var preReturn = [];
    var postReturn = [];

    if (originalStr) {
      for (var _i = 0, originalStr_1 = originalStr; _i < originalStr_1.length; _i++) {
        var char = originalStr_1[_i];

        if (!/\n/.test(char)) {
          break;
        }

        preReturn.push( /*#__PURE__*/React.createElement("br", {
          key: "pre".concat(Math.random() * (keyScale ? keyScale : 100)).concat(uniqueId)
        }));
      }

      for (var i = originalStr.length - 1; i >= 0; i--) {
        if (!/\n/.test(originalStr === null || originalStr === void 0 ? void 0 : originalStr[i])) {
          break;
        }

        postReturn.push( /*#__PURE__*/React.createElement("br", {
          key: "post".concat(Math.random() * (keyScale ? keyScale : 100)).concat(uniqueId)
        }));
      }
    }

    return {
      preReturn: preReturn,
      postReturn: postReturn
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: style$e.container,
    style: {
      textAlign: shouldCentered === true ? 'center' : 'justify',
      padding: shouldCentered === true ? 0 : '15px'
    }
  }, ((_f = reformedJudgeResult === null || reformedJudgeResult === void 0 ? void 0 : reformedJudgeResult.word_infos) === null || _f === void 0 ? void 0 : _f.length) === 1 ? /*#__PURE__*/React.createElement(Syllables, {
    wordInfo: reformedJudgeResult === null || reformedJudgeResult === void 0 ? void 0 : reformedJudgeResult.word_infos[0],
    reciteContent: reciteContent
  }) : ((_g = reformedJudgeResult === null || reformedJudgeResult === void 0 ? void 0 : reformedJudgeResult.word_infos) === null || _g === void 0 ? void 0 : _g.length) && ((_h = reformedJudgeResult === null || reformedJudgeResult === void 0 ? void 0 : reformedJudgeResult.word_infos) === null || _h === void 0 ? void 0 : _h.length) > 0 ? reformedJudgeResult.word_infos.map(function (wordInfo) {
    var _a, _b;

    var originalStr = '';

    if ((_a = wordInfo === null || wordInfo === void 0 ? void 0 : wordInfo.base_info) === null || _a === void 0 ? void 0 : _a.text_content) {
      for (var i = 0; i < processedReciteArrayAlignWithAI.length; i++) {
        if (processedReciteArrayAlignWithAI[i].includes((_b = wordInfo === null || wordInfo === void 0 ? void 0 : wordInfo.base_info) === null || _b === void 0 ? void 0 : _b.text_content)) {
          originalStr = processedReciteArrayAlignWithAI[i];
          processedReciteArrayAlignWithAI.splice(i, 1);
          break;
        }
      }
    }

    var _c = getPreAndPostReturn(originalStr),
        preReturn = _c.preReturn,
        postReturn = _c.postReturn;

    return /*#__PURE__*/React.createElement("span", {
      key: wordId++
    }, preReturn, /*#__PURE__*/React.createElement(Words, {
      wordInfo: wordInfo
    }), postReturn);
  }) : /*#__PURE__*/React.createElement("div", {
    className: style$e['recite-content']
  }, processedReciteArrayWithReturn.map(function (substr, index) {
    var _a = getPreAndPostReturn(substr),
        preReturn = _a.preReturn,
        postReturn = _a.postReturn;

    return /*#__PURE__*/React.createElement("span", {
      key: substr + String(index)
    }, preReturn, substr, postReturn);
  })));
};

var EPlayState;

(function (EPlayState) {
  EPlayState["LOADING"] = "LOADING"; // ios微信浏览器的初始状态

  EPlayState["NO_LOAD"] = "NO_LOAD";
  EPlayState["PAUSED"] = "PAUSED";
  EPlayState["LOADED"] = "LOADED";
  EPlayState["PLAYING"] = "PLAYING";
  EPlayState["LOAD_FAULT"] = "LOAD_FAULT";
})(EPlayState || (EPlayState = {}));

var ERoleTypes;

(function (ERoleTypes) {
  ERoleTypes["MY_AUDIO"] = "MY_AUDIO";
  ERoleTypes["ORIGINAL"] = "ORIGINAL";
})(ERoleTypes || (ERoleTypes = {}));

var waitingTimer = null;

var usePlayHandler = function usePlayHandler(props) {
  var myTapeAudioRef = props.myTapeAudioRef,
      originalAudioRef = props.originalAudioRef,
      playBtnRef = props.playBtnRef,
      nativeAudioPlayStateRef = props.nativeAudioPlayStateRef,
      setNativeAudioState = props.setNativeAudioState,
      questionId = props.questionId,
      role = props.role,
      isTapingRef = props.isTapingRef,
      setSpeakError = props.setSpeakError,
      myTapeSrc = props.myTapeSrc,
      originalAudioSrc = props.originalAudioSrc;

  var _a = useState({
    webAudioDuration: 0,
    playState: isIOS && isWX ? EPlayState.NO_LOAD : EPlayState.LOADING
  }),
      state = _a[0],
      setState = _a[1];

  var audioRef = role === ERoleTypes.MY_AUDIO ? myTapeAudioRef : originalAudioRef;
  var myTapeSrcRef = useRef();
  var originalAudioSrcRef = useRef();
  var roleRef = useRef();
  myTapeSrcRef.current = myTapeSrc;
  originalAudioSrcRef.current = originalAudioSrc;
  roleRef.current = role;
  var loaded = useAudioLoaded(audioRef, questionId);
  useEffect(function () {
    var audioDom = audioRef.current;

    if (loaded.current && audioDom) {
      setState(function (state) {
        return _assign$4(_assign$4({}, state), {
          webAudioDuration: audioDom.duration,
          playState: isIOS && isWX ? state.playState : EPlayState.LOADED
        });
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [loaded.current]);
  useEffect(function () {
    if (loaded.current) {
      setState(function (state) {
        var _a; // Web音频播放中则暂停


        if (state.playState === EPlayState.PLAYING) {
          footPrintSecondaryReport({
            actionValue: "questionId\u6539\u53D8\u5BFC\u81F4\u7684\u6682\u505C\uFF0C\u5F53\u524Did\u4E3A".concat(questionId, "\uFF0C\u5F53\u524D\u64AD\u653E\u7684url\u4E3A\uFF1A").concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
          });
          return _assign$4(_assign$4({}, state), {
            playState: EPlayState.PAUSED
          });
        }

        return state;
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [questionId]);
  useEffect(function () {
    var _a, _b, _c, _d;

    if (state.playState === EPlayState.PAUSED && !((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.paused)) {
      (_b = audioRef.current) === null || _b === void 0 ? void 0 : _b.pause();
    } else if (state.playState === EPlayState.PLAYING && ((_c = audioRef.current) === null || _c === void 0 ? void 0 : _c.paused)) {
      (_d = audioRef.current) === null || _d === void 0 ? void 0 : _d.play().catch(function (error) {
        var _a;

        footPrintJSErrorReport({
          actionValue: "\u97F3\u9891\u64AD\u653E\u5931\u8D25\uFF1A".concat(error, ", url: ").concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
        });
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [audioRef, state]);
  useAutoPause(audioRef, questionId);
  usePreload(audioRef, questionId);
  usePauseEvent(audioRef, function () {
    setState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: state.playState === EPlayState.LOAD_FAULT ? EPlayState.LOAD_FAULT : EPlayState.PAUSED
      });
    });
  }, questionId);
  useEndEvent(audioRef, function () {
    setState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: EPlayState.LOADED
      });
    });
  }, questionId);
  usePlayEvent(audioRef, function () {
    waitingTimer && clearTimeout(waitingTimer);
    setState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: EPlayState.PLAYING
      });
    });
  });
  useExclusivePlay(audioRef, true);
  useWaitingEvent(audioRef, function () {
    setState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: EPlayState.LOADING
      });
    });

    if (isIOS && isWX) {
      waitingTimer = setTimeout(function () {
        var _a;

        (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        loaded.current = false;
        setState(function (state) {
          return _assign$4(_assign$4({}, state), {
            playState: EPlayState.LOAD_FAULT
          });
        });
      }, WAITING_TIME);
    }
  });
  useCanPlayEvent(audioRef);
  useErrorEvent(audioRef, function () {
    loaded.current = false;
    setState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: EPlayState.LOAD_FAULT
      });
    });
  });

  function playAudio() {
    var _a, _b, _c, _d, _e;

    footPrintSecondaryReport({
      actionValue: "\u70B9\u51FB\u64AD\u653E\u6309\u94AE\uFF0C\n                \u88AB\u70B9\u51FB\u7684\u6309\u94AE\u89D2\u8272\u662F\uFF1A".concat(role, "\n                \u5F53\u524D\u97F3\u9891\u662F\u5426\u5DF2\u52A0\u8F7D\u6210\u529F\uFF1A").concat(loaded.current, "\n                \u5F53\u524D\u70B9\u51FB\u6309\u94AE\u7684\u64AD\u653E\u72B6\u6001\uFF1A").concat(state.playState, "\n                \u5F53\u524D\u97F3\u9891\uFF1A").concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src, "\n                \u6211\u7684\u5F55\u97F3url\uFF1A").concat(myTapeSrcRef.current, "\n                \u5F53\u524D\u5F55\u97F3\u72B6\u6001\uFF1A").concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\uFF0C\n                \u539F\u97F3\u64AD\u653E\u72B6\u6001native\uFF1A").concat(nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current, "\n            ")
    });

    if (state.playState === EPlayState.LOADING) {
      return;
    }

    if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('录音中，请先结束录音');
      return;
    }

    if (!myTapeSrcRef.current && roleRef.current === ERoleTypes.MY_AUDIO) {
      return;
    }

    if (!originalAudioSrcRef.current && roleRef.current === ERoleTypes.ORIGINAL) {
      return;
    } // 如果原生的音频正在播放（那么此时播放的一定是原音），如果按的是原音按钮则调用端能力停止即可


    if (nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current) {
      stopNativeAudio().then(function () {
        var _a;

        setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
          // progress: 0,
          playState: false
        }); // 如果点击的是我的录音，停止原生音频后，则用web能力播放我的录音

        if (role === ERoleTypes.MY_AUDIO) {
          if (loaded.current) {
            footPrintSecondaryReport({
              actionValue: "aduio play\u88AB\u8C03\u7528, url: ".concat((_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.src)
            });
            setState(function (state) {
              return _assign$4(_assign$4({}, state), {
                playState: EPlayState.PLAYING
              });
            });
          } else {
            footPrintJSErrorReport({
              actionValue: '音频还加载完毕前点击播放或者音频为空'
            });
          }
        }
      });
      return;
    } // web播放资源加载失败点击刷新


    if (state.playState === EPlayState.LOAD_FAULT) {
      footPrintSecondaryReport({
        actionValue: '重新加载音频资源'
      });
      (_b = audioRef === null || audioRef === void 0 ? void 0 : audioRef.current) === null || _b === void 0 ? void 0 : _b.load();
      setState(function (state) {
        return _assign$4(_assign$4({}, state), {
          playState: isIOS && isWX ? EPlayState.PLAYING : EPlayState.LOADING
        });
      });
      return;
    } // 如果端没有播放音频，则不管对于web原音或我的录音都按如下逻辑进行


    if (loaded.current || isIOS && isWX) {
      // Web音频播放中则暂停，并设置播放状态为loaded
      footPrintSecondaryReport({
        actionValue: "".concat(isIOS && isWX ? 'ios微信浏览器' : '', "\n                ").concat(state.playState === EPlayState.PLAYING ? '暂停播放' : '播放音频', " url: ").concat((_c = audioRef.current) === null || _c === void 0 ? void 0 : _c.src)
      });
      setState(function (state) {
        return _assign$4(_assign$4({}, state), {
          playState: state.playState === EPlayState.PLAYING ? EPlayState.PAUSED : EPlayState.PLAYING
        });
      });
    } else {
      (_d = audioRef.current) === null || _d === void 0 ? void 0 : _d.load();
      footPrintSecondaryReport({
        actionValue: "\u672A\u52A0\u8F7D\u5B8C\u6210\uFF0C\u91CD\u65B0\u8FDB\u5165loading\u72B6\u6001 url: ".concat((_e = audioRef.current) === null || _e === void 0 ? void 0 : _e.src)
      });
      setState(_assign$4(_assign$4({}, state), {
        playState: EPlayState.LOADING
      }));
    }
  }

  useClickEvent(playBtnRef, playAudio, questionId, state);
  return {
    state: state,
    setState: setState
  };
};

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='%e5%9b%be%e5%b1%82_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 41 40' style='enable-background:new 0 0 41 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:%23FF3741%3bopacity:0.5%7d .st1%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:white%3bopacity:1%7d .st2%7bfill:none%3bstroke:white%3bstroke-width:2%3bstroke-linecap:round%3bopacity:1%7d%3c/style%3e%3ctitle%3e%e5%8e%9f%e9%9f%b3%3c/title%3e%3cg id='%e9%a1%b5%e9%9d%a2-1'%3e %3cg id='%e8%b7%9f%e8%af%bb-%e5%bd%95%e9%9f%b3%e5%ae%8c%e6%88%90' transform='translate(-77.000000%2c -521.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3%e7%bb%84%e5%bb%ba' transform='translate(0.000000%2c 479.000000)'%3e %3cg id='%e7%bc%96%e7%bb%84-4' transform='translate(73.500000%2c 28.000000)'%3e %3cg id='%e5%8e%9f%e9%9f%b3' transform='translate(4.000000%2c 14.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2%e5%a4%87%e4%bb%bd-2' class='st0' cx='20' cy='20' r='20'/%3e %3cpath id='%e5%bd%a2%e7%8a%b6%e7%bb%93%e5%90%88' class='st1' d='M19.8%2c12.3c0.3%2c0.4%2c0.5%2c0.9%2c0.5%2c1.4v12.9c0%2c1.1-0.9%2c2-2%2c2c-0.5%2c0-1-0.2-1.4-0.5 l-3.2-2.9l-3.5%2c0c-1.1%2c0-2-0.9-2-2v-6c0-1.1%2c0.9-2%2c2-2l3.5%2c0l3.2-2.9C17.7%2c11.5%2c19%2c11.5%2c19.8%2c12.3z'/%3e %3cpath id='%e8%b7%af%e5%be%84' class='st2' d='M28.4%2c25.8c3.1-3.1%2c3.1-8.2%2c0-11.3'/%3e %3cpath id='%e8%b7%af%e5%be%84%e5%a4%87%e4%bb%bd' class='st2' d='M24.2%2c23c1.6-1.6%2c1.6-4.1%2c0-5.7'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$5 = "data:image/png;base64,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";

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABEBJREFUeF7tmlvIplMUx39/pxwnpJALImnIKTEpw6QkGRlMlDRGk1wowo2GC6dcOoS4IEMpIckhygymkRinceHYJCKHC25EFJb+2lPb0/f63mc/+3nrfd9nXX7fs9de6/estfaz13rFnIvm3H8GAEMEzDmBIQXmPACGIjikwJACc05gSIE5D4DhFJhICkTEEuBsYDlwHHA4sB+wB/Ab8DOwHfgI2AxskvTrJKKzVwARYYevBc4Fdm/hkJ1/Drhb0vst1rV+tBcAEXE8cBdwZmuL/rsggJeA6yQ5QqpLVQARsTNwE3AzsGtFa38HbpR0b0Wd/6qqBiDl+ZPAOSOM/CKF9ZvAp8D3gB1zHTgEOBo4HVgFHDZCx1PAGkl/1AJRE4Bz9vwFDHsLuEXSq+MYHRG2yTXjduCEBda85v9LMrzOUhPAL8DemUWu7OskGUxrSSAuAx4A9mkoeB64QNLfrRU3FtQE8ARwadL/LnCxpK+6GhgRTo1ngaMauhxVt3bVXxPALnYacOV+WtKfXY3bsT4i9gecSjmEv4BlXY/JagBqOTtKT0QcAbwNHJA9s1XSsi57Tw0AOxkR/pp8uXF6nSfpxVIIUwUgQXgGuChzeKOks+YJgO8S27Io8ElwqKRvSyBMXQSkKHAtyHP/SkkPTxxARCz1ppL8Zde7RMQW4LRFNtosacW4xhRHQDqft6aNTpH0ybiblj4XEe8BJy2yfpukE8fdowhAROwJ+GPHHykWO3+yJN/te5MM+l4jNvE1utXLKAXwKLC2YcQGSVf05n1SHBGXAxtG7LNW0mNtbGgNoLYBbYzd8WxEVHsBrQD0EYKFAJyCrj/HpPUfp9BvnYJtAVQvQiUAvKZWEW4LoPoxVAogQeh8DLcCkBsbEVcBD2V/2yLJHZ2pki4A3Lb6Mvsk9TV4qaTPp4lAMYAUgu7h52/9cUk+pqZGugJY7eZH5q0vJssluXkxFdIVwE7pZnZs5u036Uj6oTaBiHCrPWp2mzoBSGngFHij0aR4B1hRq3Ob9lkH3JOg+vbnFnxn6QwgGWfDPALLxRAulPRdVysjYj1wRwb5R0kHddXr9bUA7AZsTMPP3C4770HGphJjI+JA4EG3wBvrt0s6skRnc00VACkK9gVeHzHMeAVYL+nDcYyOCE+OrwZuAKw3F9/4Vkpy2nWWagAyCB6EnDHCMl+hX0gt7s+AnwC3zz0+98jcd33390ZNk/38Kkker1WRqgASBFfqO4HrAZ8StcQ15RJJX9dSWK0GLGRQRJwK3DdGB2cxf/zWbwPurzEK660GjPIiIlYC16TfCnh8Pq54mvyIi6Akzx17keop8D8gDs5+JuN7vO8Szn2P1OygP5xcFxzq7vV/0IvHDaUTAzAJZ0r2GACUUJulNUMEzNLbLPFliIASarO0ZoiAWXqbJb4MEVBCbZbWDBEwS2+zxJe5j4B/AEnoPFDeH+h7AAAAAElFTkSuQmCC";

var img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='%e5%9b%be%e5%b1%82_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 41 40' style='enable-background:new 0 0 41 40%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:%23E0E6EB%3bopacity:1%7d .st1%7bfill-rule:evenodd%3bclip-rule:evenodd%3bfill:white%3bopacity:1%7d .st2%7bfill:none%3bstroke:white%3bstroke-width:2%3bstroke-linecap:round%3bopacity:1%7d%3c/style%3e%3ctitle%3e%e5%8e%9f%e9%9f%b3%3c/title%3e%3cg id='%e9%a1%b5%e9%9d%a2-1'%3e %3cg id='%e8%b7%9f%e8%af%bb-%e5%bd%95%e9%9f%b3%e5%ae%8c%e6%88%90' transform='translate(-77.000000%2c -521.000000)'%3e %3cg id='%e5%bd%95%e9%9f%b3%e7%bb%84%e5%bb%ba' transform='translate(0.000000%2c 479.000000)'%3e %3cg id='%e7%bc%96%e7%bb%84-4' transform='translate(73.500000%2c 28.000000)'%3e %3cg id='%e5%8e%9f%e9%9f%b3' transform='translate(4.000000%2c 14.000000)'%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2%e5%a4%87%e4%bb%bd-2' class='st0' cx='20' cy='20' r='20'/%3e %3cpath id='%e5%bd%a2%e7%8a%b6%e7%bb%93%e5%90%88' class='st1' d='M19.8%2c12.3c0.3%2c0.4%2c0.5%2c0.9%2c0.5%2c1.4v12.9c0%2c1.1-0.9%2c2-2%2c2c-0.5%2c0-1-0.2-1.4-0.5 l-3.2-2.9l-3.5%2c0c-1.1%2c0-2-0.9-2-2v-6c0-1.1%2c0.9-2%2c2-2l3.5%2c0l3.2-2.9C17.7%2c11.5%2c19%2c11.5%2c19.8%2c12.3z'/%3e %3cpath id='%e8%b7%af%e5%be%84' class='st2' d='M28.4%2c25.8c3.1-3.1%2c3.1-8.2%2c0-11.3'/%3e %3cpath id='%e8%b7%af%e5%be%84%e5%a4%87%e4%bb%bd' class='st2' d='M24.2%2c23c1.6-1.6%2c1.6-4.1%2c0-5.7'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var style$d = {"audio-wrapper":"tangram_C_audio-wrapper_00ebb3fdc4","title":"tangram_C_title_00ebb3fdc4","icon":"tangram_C_icon_00ebb3fdc4","reload-icon":"tangram_C_reload-icon_00ebb3fdc4","loading-icon":"tangram_C_loading-icon_00ebb3fdc4","loadingPlayBtn":"tangram_C_loadingPlayBtn_00ebb3fdc4","playing":"tangram_C_playing_00ebb3fdc4"};

var OriginalAudio = function OriginalAudio(props) {
  var _a = props.state,
      webAudioDuration = _a.webAudioDuration,
      playState = _a.playState,
      originalAudioRef = props.originalAudioRef,
      playBtnRef = props.playBtnRef;

  var _b = useContext(Context),
      wordReciteStructured = _b.wordReciteStructured,
      nativeAudioPlayStateRef = _b.nativeAudioPlayStateRef,
      nativeAudioState = _b.nativeAudioState;

  var reciteFile = wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteFile;
  var playing = (nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current) || playState === EPlayState.PLAYING;
  var duration = (nativeAudioState === null || nativeAudioState === void 0 ? void 0 : nativeAudioState.duration) || webAudioDuration;

  var backgroundImage = function backgroundImage() {
    if (!reciteFile) {
      return img$3;
    }

    if (playState === EPlayState.LOADING) {
      return img$5;
    }

    if (playState === EPlayState.LOAD_FAULT) {
      return img$4;
    }

    return playing ? img$6 : img$j;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: style$d['audio-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$d.icon, "\n                ").concat(playState === EPlayState.LOADING ? style$d['loading-icon'] : playState === EPlayState.LOAD_FAULT ? style$d['reload-icon'] : ''),
    ref: playBtnRef
  }, /*#__PURE__*/React.createElement(Progress, {
    playing: +playing,
    duration: playState === EPlayState.LOADED || playState === EPlayState.PAUSED ? 0 : duration,
    // progress={nativeAudioState?.progress || playProgress}
    backgroundImage: backgroundImage(),
    ringColor: "#ffffff",
    ringOpacity: 0.5,
    ringWidth: 3
  }), /*#__PURE__*/React.createElement("audio", {
    ref: originalAudioRef,
    src: reciteFile || ''
  })), /*#__PURE__*/React.createElement("span", {
    className: style$d.title
  }, "\u64AD\u653E\u539F\u97F3"));
};

var OriginalAudio$1 = /*#__PURE__*/memo(OriginalAudio);

function useDebounce(fn, delay) {
  var current = useRef({
    fn: fn,
    timer: null
  }).current;
  useEffect(function () {
    current.fn = fn;
  }, [fn]);
  return function f() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    } // const that = this;


    if (current.timer) {
      window.clearTimeout(current.timer);
    }

    current.timer = window.setTimeout(function () {
      var _a;

      (_a = current.fn).call.apply(_a, __spreadArray([null], args, false));
    }, delay);
  };
}

var style$c = {"tape":"tangram_C_tape_c8bf0394ad","error":"tangram_C_error_c8bf0394ad"};

// mis年级转sdk年级(左边gradeId右边targetUser)
var targetUserMap = {
  // 小学
  40: 4,
  // 一年级
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  // 初中
  20: 8,
  // 初一
  7: 7,
  8: 8,
  9: 9,
  // 高中
  30: 11,
  // 高一
  10: 10,
  11: 11,
  12: 12,
  13: 12,
  // 学前
  60: 13,
  // 大班（也算学前）
  19: 13,
  // 成人
  51: 14
}; // eslint-disable-next-line import/prefer-default-export

var mis2sdkTargetUser = function mis2sdkTargetUser(misValue) {
  return misValue && targetUserMap[misValue] || 0;
};

var _a$4;
var styledClassNames$1 = bind.bind(style$c);
var cdnBase = 'https://jy.gsxcdn.com/fe/project/exercise-tangram/static/img/tape/';
var tape = "".concat(cdnBase, "tape.svg");
var taping = "".concat(cdnBase, "taping.svg");
var ELANG;

(function (ELANG) {
  ELANG[ELANG["ENG"] = 0] = "ENG";
  ELANG[ELANG["CHN"] = 1] = "CHN";
})(ELANG || (ELANG = {}));

var EQTYPE;

(function (EQTYPE) {
  EQTYPE[EQTYPE["BASE"] = 0] = "BASE";
  EQTYPE[EQTYPE["POEM"] = 2] = "POEM";
})(EQTYPE || (EQTYPE = {}));

var EAUTYPE;

(function (EAUTYPE) {
  EAUTYPE[EAUTYPE["WAV"] = 1] = "WAV";
  EAUTYPE[EAUTYPE["MP3"] = 5] = "MP3";
})(EAUTYPE || (EAUTYPE = {})); // eslint-disable-next-line


var netErrCodes = [50, 51, 52, '3002'];
var client = (_a$4 = parseQuery()) === null || _a$4 === void 0 ? void 0 : _a$4.client;

var Tape = function Tape(props) {
  var _a, _b;

  var setMyaudioState = props.setMyaudioState,
      setOriginalState = props.setOriginalState; // const [speakError, setSpeakError] = useState('');

  var stop = useExclusivePlay().stop;
  var authoritiedRef = useRef(false);
  var questionIdRef = useRef('');

  var _c = useContext(Context),
      questionId = _c.questionId,
      wordReciteStructured = _c.wordReciteStructured,
      answerChangeCallback = _c.onAnswerChange,
      userSubmitItems = _c.userSubmitItems,
      nativeAudioPlayStateRef = _c.nativeAudioPlayStateRef,
      setNativeAudioState = _c.setNativeAudioState,
      timelimit = _c.timelimit,
      isNewVersion = _c.isNewVersion,
      gradeId = _c.gradeId;

  var _d = useContext(playContentContext),
      isTapingRef = _d.isTapingRef,
      setIsTaping = _d.setIsTaping,
      speakError = _d.speakError,
      setSpeakError = _d.setSpeakError;

  var targetUser = mis2sdkTargetUser(gradeId);
  questionIdRef.current = questionId || '';
  var hasMyAudio = (_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b.answer;
  var wxFinishRecording = useRef(false);
  var wxTimer = useRef();
  var wxEvaluationAddr = "https://".concat(envPrefix(), "api.gaotu100.com/exercise/speech/getResult");
  var requestPermission = wxRecorder.requestPermission,
      startRecording = wxRecorder.startRecording,
      stopRecording = wxRecorder.stopRecording,
      set = wxRecorder.set; // 停止录音相关 - 在14.3版本以下的iOS系统，微信小程序中使用小程序提供的录音能力

  function onStopSuccess(mediaIds) {
    console.log('获得了微信录音上传之后的ids', mediaIds); // 通过mediaIds及其他参数 -> 调用离线评测接口 -> 拿到结果

    var evaluation = {
      mediaIds: mediaIds,
      lang: ELANG.ENG,
      client: client,
      content: wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteContent,
      targetUser: targetUser
    };
    axios.post(wxEvaluationAddr, evaluation).then(function (res) {
      var code = res.code,
          data = res.data,
          msg = res.msg;

      if (code === 0 && data) {
        var score = data.score,
            answer = data.answer,
            result = data.result;

        if (score === 0) {
          setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('没有听清您的声音，请再试一次吧！');
          audioAvaluteExceptionReport$2("[wx\u8BED\u97F3\u8BC4\u6D4B]AI\u6253\u5206\u4E3A0\uFF0C\u53EF\u80FD\u662F\u6CA1\u6709\u97F3\u9891\u5BFC\u81F4, \u97F3\u9891url:".concat(answer));
          return;
        }

        answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, [{
          resource: {
            answer: answer,
            score: score,
            result: result
          },
          resourceType: ESubmitItemTypes.AUDIOEVALUATE
        }]);
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('');
        return;
      } // eslint-disable-next-line max-len


      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u97F3\u9891serverIds\uFF0C\u8BF7\u6C42\u79BB\u7EBF\u8BED\u97F3\u8BC4\u6D4B\u65F6\uFF0C\u54CD\u5E94\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(evaluation, "\uFF0C\u54CD\u5E94code\u53CAmsg: ").concat(code, ", ").concat(msg, " , \u54CD\u5E94\u6570\u636E: ").concat(data);
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('评测的时候出错了哦，请再重新试试吧～');
      console.error(errMsg);
      footPrintJSErrorReport({
        detailAction: errMsg
      });
    }).catch(function (reason) {
      var errMsg = "\u901A\u8FC7\u5FAE\u4FE1\u97F3\u9891serverIds\uFF0C\u8BF7\u6C42\u79BB\u7EBF\u8BED\u97F3\u8BC4\u6D4B\u65F6\uFF0C\u8BF7\u6C42\u51FA\u9519\uFF0C\u8BF7\u6C42\u53C2\u6570: ".concat(evaluation, "\uFF0C\u9519\u8BEF\u4FE1\u606F: ").concat(reason);
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('评测出错了哦，请再重新试试吧～');
      console.error(errMsg);
      footPrintJSErrorReport({
        detailAction: errMsg
      });
    });
  } // 微信录音大致分为两个阶段：
  // 1. 录音阶段 2. 上传/上传后请求音频URL阶段
  // beforeUpload 钩子用于感知录音完成后，上传录音前的这段状态


  function beforeUpload() {
    wxFinishRecording.current = true; // 录音完成后，改变录音状态为false
    // 清除定时器

    setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
    setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('正在评测中，请稍候...');
    window.clearTimeout(wxTimer.current);
  }

  function onStopFailed(e) {
    if (wxFinishRecording.current) {
      var errMsg_1 = "[wx\u8BED\u97F3\u8BC4\u6D4B\u5F55\u97F3]: \u97F3\u9891\u4E0A\u4F20\u5FAE\u4FE1\u670D\u52A1\u5668\u65F6\u51FA\u9519\uFF0C \u9519\u8BEF\u4FE1\u606F: ".concat(e);
      console.error(errMsg_1);
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('音频上传时出错了哦，请再重新评测试试吧～');
      wxFinishRecording.current = false;
      footPrintJSErrorReport({
        actionValue: errMsg_1
      });
      return;
    }

    var errMsg = "[wx\u8BED\u97F3\u8BC4\u6D4B\u5F55\u97F3]: \u7ED3\u675F\u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F:".concat(e);
    setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
    window.clearTimeout(wxTimer.current);
    wxFinishRecording.current = false;
    console.error(errMsg);
    setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('录音评测时出错了哦，请再重新试试吧～');
    footPrintJSErrorReport({
      actionValue: errMsg
    });
  }

  function wxEvaluation() {
    footPrintSecondaryReport({
      actionValue: "\u5F55\u97F3\u6309\u94AE\u88AB\u70B9\u51FB\uFF0C\n                \u5F53\u524D\u5F55\u97F3\u72B6\u6001\uFF1A".concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\n                \u5F53\u524D\u662F\u5426\u6709\u81EA\u52A8\u64AD\u653E\u7684\u97F3\u9891\uFF1A").concat(nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current, "\n                \u5F53\u524D\u5904\u4E8E\u5FAE\u4FE1\u5C0F\u7A0B\u5E8Fweb-view\u73AF\u5883\u4E2D")
    });
    setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError(''); // 如果是在录音过程中，则停止录音

    if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
      stopRecording(onStopSuccess, onStopFailed, beforeUpload);
      return;
    } // 将web页我的音频播放状态设置为loaded


    setMyaudioState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: state.playState === EPlayState.PLAYING || state.playState === EPlayState.LOADING ? EPlayState.PAUSED : state.playState
      });
    }); // 将web页原音播放状态设置为loaded

    setOriginalState(function (state) {
      return _assign$4(_assign$4({}, state), {
        playState: state.playState === EPlayState.PLAYING || state.playState === EPlayState.LOADING ? EPlayState.PAUSED : state.playState
      });
    }); // 录音授权相关

    function getPermission() {
      return new Promise(function (resolve, reject) {
        function permissionGranted() {
          console.info('[wx语音评测录音]: 小程序录音权限请求成功');
          footPrintSecondaryReport({
            actionValue: '小程序录音权限请求成功'
          });
          resolve(true);
        }

        function permissionDenied(e, userDenied) {
          if (userDenied === void 0) {
            userDenied = false;
          }

          var deniedMsg = "[wx\u8BED\u97F3\u8BC4\u6D4B\u5F55\u97F3]: \u5C0F\u7A0B\u5E8F\u5F55\u97F3\u6388\u6743\u672A\u901A\u8FC7\uFF0C".concat(userDenied ? '用户拒绝了录音权限请求，' : '', "\u9519\u8BEF\u4FE1\u606F:").concat(e);
          console.error(deniedMsg);
          setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError("\u5F55\u97F3\u5931\u8D25\u4E86\u54E6\uFF0C".concat("\u8BF7".concat(userDenied ? '授权录音后' : '', "\u518D\u8BD5\u8BD5\u5427\uFF5E"))); // 请求录音权限出错时脚印上报

          footPrintJSErrorReport({
            actionValue: deniedMsg
          });
          reject(deniedMsg);
        }

        requestPermission(permissionGranted, permissionDenied);
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('正在启动微信录音, 请稍候...');
      });
    } // 开始录音相关


    function onWxStartSuccess() {
      // 微信录音真正开始时，才设置录音状态为true，报错或停止时，将录音状态设置为false
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(true);
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('正在录音中，请大声朗读...'); // 录音超时检查，开始录音后挂载一个定时器，当达到timelimit限制时
      // 如果此时仍在录音，则自动调用停止
      // 出错或定时器触发前停止时，则清除此定时器

      function wxRecordingAutoStop() {
        if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
          console.log('[wx语音评测录音]: timelimit时间到，自动停止录音');
          stopRecording(onStopSuccess, onStopFailed, beforeUpload);
        }
      }

      wxTimer.current = window.setTimeout(wxRecordingAutoStop, timelimit ? (timelimit + 1.2) * 1000 : 61200);
    }

    function onWxStartFailed(e) {
      console.error("[wx\u8BED\u97F3\u8BC4\u6D4B\u5F55\u97F3]: \u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F\uFF1A".concat(e)); // 此函数被调用时，有两种情况：
      // 1. 开始录音时即报错
      // 2. 开始录音后，微信录音超过一分钟后，接续录音时报错
      // 第2种情况发生时，需要清除计时器，并设置录音状态为false.

      window.clearTimeout(wxTimer.current);
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
      setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('录音出错了哦，请再试试吧～'); // 录音出错时脚印上报

      footPrintJSErrorReport({
        actionValue: "\u5F55\u97F3\u51FA\u9519\uFF0C\u9519\u8BEF\u4FE1\u606F:".concat(e)
      });
    }

    getPermission().then(function (val) {
      console.info('[wx语音评测录音]: 录音开始'); // 停止所有音频播放

      stop();
      startRecording(set, onWxStartSuccess, onWxStartFailed);
    });
  }

  function handleJudgeCallback(payload) {
    // eslint-disable-next-line
    console.log(questionId, questionIdRef.current, payload, 'debug无法录音===');

    if (questionIdRef.current !== questionId) {
      audioAvaluteExceptionReport$2('切题导致的不再响应上一题的回调');
      return;
    }

    if (!payload) {
      audioAvaluteExceptionReport$2('回调没有参数');
      return;
    }

    var voiceStatus = payload.voiceStatus,
        resultCode = payload.resultCode,
        dataResult = payload.dataResult,
        appSdkCode = payload.appSdkCode; // eslint-disable-next-line

    console.log(voiceStatus, resultCode, dataResult, appSdkCode, '录音端能力的回调');

    if (+voiceStatus === 1) {
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(true);
      footPrintSecondaryReport({
        actionValue: '响应到开始录音回调，更改UI状态'
      });
    }

    if (+resultCode === 1) {
      // eslint-disable-next-line no-console
      console.log(dataResult.overall, 'AI的打分======');

      if (dataResult.overall === 0) {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('没有听清您的声音，请再试一次吧！');
        audioAvaluteExceptionReport$2("AI\u6253\u5206\u4E3A0\uFF0C\u53EF\u80FD\u662F\u6CA1\u6709\u97F3\u9891\u5BFC\u81F4, \u97F3\u9891url:".concat(dataResult.url));
        return;
      }

      answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, [{
        resource: {
          answer: dataResult.url,
          score: dataResult.overall,
          result: JSON.stringify(dataResult)
        },
        resourceType: ESubmitItemTypes.AUDIOEVALUATE
      }]); // 录音成功上报

      footPrintSecondaryReport({
        actionValue: "\u5F55\u97F3\u6210\u529F".concat(dataResult.url)
      });
    }

    if (+resultCode === 2) {
      if (netErrCodes.includes(appSdkCode)) {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('网络异常，请检查网络');
        audioAvaluteExceptionReport$2("\u7F51\u7EDC\u5F02\u5E38\u5BFC\u81F4\u7684\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
      } else {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError("\u5F55\u97F3\u80FD\u529B\u8C03\u7528\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5\uFF1A".concat(appSdkCode));
        audioAvaluteExceptionReport$2("\u8BED\u97F3\u8BC4\u6D4B\u7AEF\u80FD\u529B\u8C03\u7528\u5F02\u5E38, \u72B6\u6001\u7801\uFF1A".concat(appSdkCode));
      }
    }

    if (+voiceStatus === 2) {
      setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
      footPrintSecondaryReport({
        actionValue: '响应到录音结束端能力回调，更改UI状态为未录音'
      });
    }
  } // web语音评测定时器


  var timer;

  function onStart() {
    footPrintSecondaryReport({
      actionValue: "[web\u7AEF]\u5F00\u59CB\u8BED\u97F3\u8BC4\u6D4B requestId:".concat(j.getRequestId())
    }); // 语音评测开始时，设置录音状态为true，报错或停止时，将录音状态设置为false

    setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(true); // 录音超时检查，开始评测后挂载一个定时器，当达到timelimit限制时
    // 如果此时仍在录音，则自动调用停止
    // 每次用户手动停止语音测评的时候需要卸载这个定时器
    // 每次出错时也需要卸载

    function webRecordingAutoStop() {
      if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
        footPrintSecondaryReport({
          actionValue: "[web\u7AEF]timelimit\u65F6\u95F4\u5230\uFF0C\u81EA\u52A8\u505C\u6B62\u8BED\u97F3\u8BC4\u6D4B requestId:".concat(j.getRequestId())
        });
        j.aiengineStop();
      }
    }

    timer = window.setTimeout(webRecordingAutoStop, timelimit ? timelimit * 1000 : 60000);
  }

  function onError(err) {
    // 语音评测报错时，设置录音状态为false，抛出错误
    console.log('error：[web端]语音评测出错', err);
    window.clearTimeout(timer);
    setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError("\u8BED\u97F3\u8BC4\u6D4B\u5931\u8D25\uFF1A".concat(ESpeechWebSDKErrorCode[err.errId]));
    setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
    audioAvaluteExceptionReport$2("[web\u7AEF]\u8BED\u97F3\u8BC4\u6D4B\u51FA\u9519".concat(ESpeechWebSDKErrorCode[err.errId], "\n            requestId:").concat(j.getRequestId()));
  }

  function onResult(res) {
    if (res.is_last_response) {
      console.log('[web端]语音评测收到最后一个响应', res);

      if (questionIdRef.current !== questionId) {
        audioAvaluteExceptionReport$2("[web\u7AEF]\u5207\u9898\u5BFC\u81F4\u7684\u4E0D\u518D\u54CD\u5E94\u4E0A\u4E00\u9898\u7684\u56DE\u8C03 requestId:".concat(j.getRequestId()));
        return;
      }

      if (res.overall === 0) {
        setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('没有听清您的声音，请再试一次吧！');
        audioAvaluteExceptionReport$2("[web\u7AEF]AI\u6253\u5206\u4E3A0\uFF0C\u53EF\u80FD\u662F\u6CA1\u6709\u97F3\u9891\u5BFC\u81F4, \u97F3\u9891url:".concat(res.url, " \u6CA1\u6709\u542C\u6E05\u60A8\u7684\u58F0\u97F3\uFF0C\u8BF7\u518D\u8BD5\u4E00\u6B21\u5427\uFF01\n                    requestId:").concat(j.getRequestId()));
        return;
      }

      answerChangeCallback === null || answerChangeCallback === void 0 ? void 0 : answerChangeCallback(questionId, [{
        resource: {
          answer: res.url,
          score: res.overall,
          result: JSON.stringify(res)
        },
        resourceType: ESubmitItemTypes.AUDIOEVALUATE
      }]); // 录音成功上报

      footPrintSecondaryReport({
        actionValue: "[web\u7AEF]\u5F55\u97F3\u6210\u529F".concat(res.url, " requestId:").concat(j.getRequestId())
      });
    }
  }

  function onComplete() {
    console.log('complete：[web端]语音评测完成', j.getRequestId());
    window.clearTimeout(timer);
    setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
  }

  function handleClick() {
    return __awaiter$2(this, void 0, void 0, function () {
      var privilegeRes, options;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            footPrintSecondaryReport({
              actionValue: "\u5F55\u97F3\u6309\u94AE\u88AB\u70B9\u51FB\uFF0C\n                \u5F53\u524D\u5F55\u97F3\u72B6\u6001\uFF1A".concat(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current, "\n                \u5F53\u524D\u662F\u5426\u6709\u81EA\u52A8\u64AD\u653E\u7684\u97F3\u9891\uFF1A").concat(nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current, "\n                \u662F\u5426\u4F7F\u7528\u7AEF\u80FD\u529B\uFF1A").concat(isNewVersion, "\n                targetUser: ").concat(targetUser)
            });
            setSpeakError === null || setSpeakError === void 0 ? void 0 : setSpeakError('');
            if (!(isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current)) return [3
            /*break*/
            , 1];

            if (isNewVersion) {
              // 调用端能力结束录音并进行评测
              callNativeSpeakEvalute({
                speakType: ESpeakEvaluteTypes.STOP,
                callback: handleJudgeCallback
              });
              setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
            } else {
              // 调用web能力结束录音并进行评测
              j.aiengineStop();
            }

            return [3
            /*break*/
            , 8];

          case 1:
            // 停止所有音频的播放
            stop(); // 将web页我的音频播放状态设置为loaded

            setMyaudioState(function (state) {
              return _assign$4(_assign$4({}, state), {
                playState: state.playState === EPlayState.PLAYING || state.playState === EPlayState.LOADING ? EPlayState.PAUSED : state.playState
              });
            }); // 将web页原音播放状态设置为loaded

            setOriginalState(function (state) {
              return _assign$4(_assign$4({}, state), {
                playState: state.playState === EPlayState.PLAYING || state.playState === EPlayState.LOADING ? EPlayState.PAUSED : state.playState
              });
            }); // 如果端在播放原音，则停止

            if (nativeAudioPlayStateRef === null || nativeAudioPlayStateRef === void 0 ? void 0 : nativeAudioPlayStateRef.current) {
              stopNativeAudio().then(function () {
                setNativeAudioState === null || setNativeAudioState === void 0 ? void 0 : setNativeAudioState({
                  playState: false
                });
              });
            }

            if (!isNewVersion) return [3
            /*break*/
            , 6];
            privilegeRes = {
              'privilege:': false
            };
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , promisifiedCallNative({
              apiName: ENativeApi.CHECK_INDICATE_PRIVILEGE,
              params: {
                type: EAuthorityTypes.AUDIO
              },
              callbackName: ENativeCBNames.GET_AUTHORITY_CB,
              maxWaitTime: 10000
            })];

          case 3:
            privilegeRes = _a.sent();

            if ((privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']) === false) {
              audioAvaluteExceptionReport$2('端能力结果表示用户拒绝权限');
            }

            return [3
            /*break*/
            , 5];

          case 4:
            _a.sent();
            audioAvaluteExceptionReport$2('请求权限超时，导致无法录音');
            return [2
            /*return*/
            ];

          case 5:
            if ((privilegeRes === null || privilegeRes === void 0 ? void 0 : privilegeRes['privilege:']) === true) {
              // eslint-disable-next-line
              console.log('调用评测端能力，开始录音');
              authoritiedRef.current = true;
              callNativeSpeakEvalute({
                speakType: ESpeakEvaluteTypes.START,
                lang: 0,
                question_type: 0,
                questionId: questionId,
                content: wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteContent,
                targetUser: targetUser,
                callback: handleJudgeCallback
              });
              return [2
              /*return*/
              ];
            }

            return [3
            /*break*/
            , 7];

          case 6:
            options = {
              config: {
                lang: ELANG.ENG,
                questionType: EQTYPE.BASE,
                questionId: questionId,
                spokenText: wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteContent,
                // 测试Text改这里，正式的时候用上面的参数
                appId: '28655',
                audioType: EAUTYPE.MP3,
                enableSaveAudio: true,
                targetUser: targetUser
              },
              onStart: onStart,
              onResult: onResult,
              onError: onError,
              onComplete: onComplete
            };

            try {
              j.aiengineStart(options);
            } catch (error) {
              console.log('web端启用语音评测引擎失败', error);
            }

            return [2
            /*return*/
            ];

          case 7:
            throw new Error('用户未授权或其他异常');

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  }

  useEffect(function () {
    if (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) {
      // eslint-disable-next-line
      console.log('发生录音中切题事件');
      footPrintSecondaryReport({
        actionValue: '录音中发生切题事件'
      });

      if (isNewVersion) {
        callNativeSpeakEvalute({
          speakType: ESpeakEvaluteTypes.STOP,
          callback: noop$1
        });
        setIsTaping === null || setIsTaping === void 0 ? void 0 : setIsTaping(false);
      } else if (window.wx && isWX) {
        stopRecording(function () {});
      } else {
        j.aiengineStop();
      }
    }

    return function () {
      callNativeSpeakEvalute({
        speakType: ESpeakEvaluteTypes.STOP,
        callback: noop$1
      });
      j.aiengineStop();
      window.wx && isWX && stopRecording(function () {});
      window.clearTimeout(wxTimer.current);
      window.clearTimeout(timer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);
  var handleClickEvaluation = window.wx && isWX ? wxEvaluation : handleClick;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styledClassNames$1({
      tape: true
    }),
    "data-content": (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? '点击完成' : hasMyAudio ? '点击重录' : '开始录音',
    onClick: useDebounce(handleClickEvaluation, 1000)
  }, /*#__PURE__*/React.createElement("div", {
    className: style$c.error,
    style: {
      opacity: speakError ? 1 : 0
    }
  }, speakError), /*#__PURE__*/React.createElement(Progress, {
    circleWidth: 60,
    playing: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? 1 : 0,
    duration: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? timelimit : 0,
    backgroundImage: (isTapingRef === null || isTapingRef === void 0 ? void 0 : isTapingRef.current) ? taping : tape,
    ringColor: "#ffffff",
    ringOpacity: 0.5,
    ringWidth: 5
  }));
};

var style$b = {"star":"tangram_C_star_e291f563ec","star-0":"tangram_C_star-0_e291f563ec","star-1":"tangram_C_star-1_e291f563ec","star-2":"tangram_C_star-2_e291f563ec","star-3":"tangram_C_star-3_e291f563ec","star-4":"tangram_C_star-4_e291f563ec","audio-wrapper":"tangram_C_audio-wrapper_e291f563ec","title":"tangram_C_title_e291f563ec","record":"tangram_C_record_e291f563ec","record-disable":"tangram_C_record-disable_e291f563ec","record-playing":"tangram_C_record-playing_e291f563ec","record-loading":"tangram_C_record-loading_e291f563ec","loadingPlayBtn":"tangram_C_loadingPlayBtn_e291f563ec","record-reload":"tangram_C_record-reload_e291f563ec"};

var styledClassNames = bind.bind(style$b);
var RESULT_SEG_SIZE = 20;
var initialStarsInfo = [{
  className: style$b['star-0'],
  transform: 'translate(-36px, 4px)',
  left: '',
  top: '',
  isHighlight: false
}, {
  className: style$b['star-1'],
  transform: 'translate(-18px, 2px)',
  left: '',
  top: '',
  isHighlight: false
}, {
  className: style$b['star-2'],
  left: '50%',
  top: '-30px',
  transform: 'translateX(-50%)',
  isHighlight: false
}, {
  className: style$b['star-3'],
  isHighlight: false,
  transform: 'translate(18px, 2px)',
  left: '',
  top: ''
}, {
  className: style$b['star-4'],
  isHighlight: false,
  transform: 'translate(36px, 4px)',
  left: '',
  top: ''
}];

var MyAudio = function MyAudio(props) {
  var _a;

  var _b, _c, _d, _e;

  var playState = props.playState,
      myTapeAudioRef = props.myTapeAudioRef,
      playBtnRef = props.playBtnRef,
      setMyaudioState = props.setMyaudioState;

  var _f = useContext(Context),
      userSubmitItems = _f.userSubmitItems,
      questionId = _f.questionId;

  var myTapeSrc = (_c = (_b = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _b === void 0 ? void 0 : _b.resource) === null || _c === void 0 ? void 0 : _c.answer;
  var judgeResultJson = (_e = (_d = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _d === void 0 ? void 0 : _d.resource) === null || _e === void 0 ? void 0 : _e.result;
  var judgeResult = parseJSON(judgeResultJson);
  var starsInfo = initialStarsInfo.map(function (item, index) {
    return _assign$4(_assign$4({}, item), {
      isHighlight: (judgeResult === null || judgeResult === void 0 ? void 0 : judgeResult.overall) ? index < Math.ceil(judgeResult.overall / RESULT_SEG_SIZE) : false
    });
  }); // useExclusivePlay(myTapeAudioRef, true);
  // 当生成录音造成src变化后，停止我的录音，避免无法监听到end事件造成的UI状态异常

  useEffect(function () {
    setMyaudioState(function (state) {
      var _a; // Web音频播放中则暂停


      if (state.playState === EPlayState.PLAYING) {
        (_a = myTapeAudioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        return _assign$4(_assign$4({}, state), {
          playState: EPlayState.LOADED
        });
      }

      return state;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myTapeSrc]);
  return /*#__PURE__*/React.createElement("div", {
    className: style$b['audio-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    key: "star-2",
    className: styledClassNames((_a = {
      star: true
    }, _a[starsInfo[2].className] = true, _a)),
    style: {
      display: myTapeSrc ? 'block' : 'none',
      backgroundImage: "url(\"".concat(starsInfo[2].isHighlight ? img$b : img$c, "\")")
    }
  }, starsInfo.map(function (starInfo) {
    var _a;

    return /*#__PURE__*/React.createElement("div", {
      key: starInfo.className,
      className: styledClassNames((_a = {
        star: true
      }, _a[starInfo.className] = true, _a)),
      style: {
        display: starInfo.className === style$b['star-2'] ? 'none' : 'block',
        backgroundImage: "url(\"".concat(starInfo.isHighlight ? img$b : img$c, "\")")
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    ref: playBtnRef,
    className: styledClassNames({
      'record': true,
      'record-disable': !myTapeSrc,
      'record-playing': playState === EPlayState.PLAYING,
      'record-loading': myTapeSrc && playState === EPlayState.LOADING,
      'record-reload': playState === EPlayState.LOAD_FAULT
    })
  }, /*#__PURE__*/React.createElement("audio", {
    key: questionId,
    ref: myTapeAudioRef,
    src: myTapeSrc,
    "data-source": "exercise-ui"
  })), /*#__PURE__*/React.createElement("span", {
    className: style$b.title
  }, "\u6211\u7684\u5F55\u97F3"));
};

var MyTape = /*#__PURE__*/memo(MyAudio);

var style$a = {"play-container":"tangram_C_play-container_ba5231d0ec"};

var playContentContext = /*#__PURE__*/createContext({});

var PlayContent = function PlayContent() {
  var _a, _b;

  var _c = useContext(Context),
      questionId = _c.questionId,
      wordReciteStructured = _c.wordReciteStructured,
      userSubmitItems = _c.userSubmitItems,
      nativeAudioPlayStateRef = _c.nativeAudioPlayStateRef,
      setNativeAudioState = _c.setNativeAudioState,
      tellMeIsTaping = _c.tellMeIsTaping;

  var _d = useState(false),
      isTaping = _d[0],
      setIsTaping = _d[1];

  var isTapingRef = useRef(false);

  var _e = useState(''),
      speakError = _e[0],
      setSpeakError = _e[1];

  isTapingRef.current = isTaping;
  var myTapeAudioRef = useRef(null);
  var originalAudioRef = useRef(null);
  var myTapePlayBtnRef = useRef(null);
  var originalPlayBtnRef = useRef(null);
  useEffect(function () {
    setSpeakError('');
  }, [questionId]);
  useEffect(function () {
    return tellMeIsTaping === null || tellMeIsTaping === void 0 ? void 0 : tellMeIsTaping(isTaping);
  }, [isTaping]);
  var myTapeSrc = (_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b.answer;
  var originalAudioSrc = wordReciteStructured === null || wordReciteStructured === void 0 ? void 0 : wordReciteStructured.reciteFile;

  var _f = usePlayHandler({
    myTapeAudioRef: myTapeAudioRef,
    originalAudioRef: originalAudioRef,
    playBtnRef: myTapePlayBtnRef,
    nativeAudioPlayStateRef: nativeAudioPlayStateRef,
    setNativeAudioState: setNativeAudioState,
    myTapeSrc: myTapeSrc,
    questionId: questionId,
    role: ERoleTypes.MY_AUDIO,
    isTapingRef: isTapingRef,
    setSpeakError: setSpeakError
  }),
      myAudioPlayState = _f.state,
      setMyAudioState = _f.setState;

  var _g = usePlayHandler({
    myTapeAudioRef: myTapeAudioRef,
    originalAudioRef: originalAudioRef,
    playBtnRef: originalPlayBtnRef,
    nativeAudioPlayStateRef: nativeAudioPlayStateRef,
    setNativeAudioState: setNativeAudioState,
    myTapeSrc: myTapeSrc,
    originalAudioSrc: originalAudioSrc,
    questionId: questionId,
    role: ERoleTypes.ORIGINAL,
    isTapingRef: isTapingRef,
    setSpeakError: setSpeakError
  }),
      originalState = _g.state,
      setOriginalState = _g.setState;

  return /*#__PURE__*/React.createElement(playContentContext.Provider, {
    value: {
      isTapingRef: isTapingRef,
      setIsTaping: setIsTaping,
      speakError: speakError,
      setSpeakError: setSpeakError
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style$a['play-container']
  }, /*#__PURE__*/React.createElement(OriginalAudio$1, {
    state: originalState,
    originalAudioRef: originalAudioRef,
    playBtnRef: originalPlayBtnRef
  }), /*#__PURE__*/React.createElement(Tape, {
    setMyaudioState: setMyAudioState,
    setOriginalState: setOriginalState,
    originalAudioRef: originalAudioRef,
    myTapeAudioRef: myTapeAudioRef
  }), /*#__PURE__*/React.createElement(MyTape, {
    playState: myAudioPlayState.playState,
    myTapeAudioRef: myTapeAudioRef,
    playBtnRef: myTapePlayBtnRef,
    setMyaudioState: setMyAudioState
  })));
};

var style$9 = {"exercise-wrapper":"tangram_C_exercise-wrapper_69cdddae88","question-detail":"tangram_C_question-detail_69cdddae88","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_69cdddae88","card-title":"tangram_C_card-title_69cdddae88","structure":"tangram_C_structure_69cdddae88","full-blank":"tangram_C_full-blank_69cdddae88","text-emphasis":"tangram_C_text-emphasis_69cdddae88","table-wrapper":"tangram_C_table-wrapper_69cdddae88","answer-wrapper":"tangram_C_answer-wrapper_69cdddae88","sticker":"tangram_C_sticker_69cdddae88","top-right":"tangram_C_top-right_69cdddae88","bottom-right":"tangram_C_bottom-right_69cdddae88","bottom-left":"tangram_C_bottom-left_69cdddae88","top-left":"tangram_C_top-left_69cdddae88","imgs-wrapper":"tangram_C_imgs-wrapper_69cdddae88","img-wrapper":"tangram_C_img-wrapper_69cdddae88","img-wrapper-analyze":"tangram_C_img-wrapper-analyze_69cdddae88","answer-box":"tangram_C_answer-box_69cdddae88"};

var AnswerInfo = function AnswerInfo(props) {
  var originalAudioUrl = props.originalAudioUrl,
      myAudioUrl = props.myAudioUrl,
      labelList = props.labelList;

  if (!originalAudioUrl && !myAudioUrl && !(labelList === null || labelList === void 0 ? void 0 : labelList.length)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, myAudioUrl && /*#__PURE__*/React.createElement("div", {
    className: style$9['answer-wrapper']
  }, /*#__PURE__*/React.createElement("h4", {
    className: style$9['card-title']
  }, "\u6211\u7684\u56DE\u7B54"), /*#__PURE__*/React.createElement("div", {
    className: style$9['answer-box']
  }, /*#__PURE__*/React.createElement(Audio$1, {
    content: myAudioUrl,
    richTextLocation: ERichTextLocation.ANALYSIS,
    editable: false,
    maxWidth: 400
  }))), originalAudioUrl && /*#__PURE__*/React.createElement("div", {
    className: style$9['answer-wrapper']
  }, /*#__PURE__*/React.createElement("h4", {
    className: style$9['card-title']
  }, "\u539F\u97F3"), /*#__PURE__*/React.createElement("div", {
    className: style$9['answer-box']
  }, /*#__PURE__*/React.createElement(Audio$1, {
    content: originalAudioUrl,
    richTextLocation: ERichTextLocation.ANALYSIS,
    editable: false,
    maxWidth: 400
  }))), /*#__PURE__*/React.createElement(Point, {
    labelList: labelList
  }));
};

var style$8 = {"exercise-wrapper":"tangram_C_exercise-wrapper_f09f43e7cd","question-detail":"tangram_C_question-detail_f09f43e7cd","compound-sub-card-between-space":"tangram_C_compound-sub-card-between-space_f09f43e7cd","card-title":"tangram_C_card-title_f09f43e7cd","structure":"tangram_C_structure_f09f43e7cd","full-blank":"tangram_C_full-blank_f09f43e7cd","text-emphasis":"tangram_C_text-emphasis_f09f43e7cd","table-wrapper":"tangram_C_table-wrapper_f09f43e7cd","question-wrapper":"tangram_C_question-wrapper_f09f43e7cd","question-container":"tangram_C_question-container_f09f43e7cd","quesiton-container-editable":"tangram_C_quesiton-container-editable_f09f43e7cd"};

var css_248z = ".ps__rail-x,.ps__rail-y{opacity:.6}";
styleInject(css_248z);

var EPlayAudioStatus;

(function (EPlayAudioStatus) {
  EPlayAudioStatus[EPlayAudioStatus["NORMAL_START"] = 1] = "NORMAL_START";
  EPlayAudioStatus[EPlayAudioStatus["NORMAL_END"] = 2] = "NORMAL_END";
  EPlayAudioStatus[EPlayAudioStatus["FAIL"] = 3] = "FAIL";
  EPlayAudioStatus[EPlayAudioStatus["URL_NOT_VALID"] = 4] = "URL_NOT_VALID";
})(EPlayAudioStatus || (EPlayAudioStatus = {})); // 秒为单位的默认答题时限


var DEFAULT_TIME_LIMIT = 60; // const DEFAULT_HEADER_HEIGHT = 100;

var Context = /*#__PURE__*/createContext({});
/**
 * @author chenbaijin
 * @desp 组件文档：https://wiki.baijia.com/pages/viewpage.action?pageId=105367703
 */

var Speech = function Speech(props) {
  var _a, _b, _c, _d;

  var showGrade = props.showGrade,
      _e = props.timelimit,
      timelimit = _e === void 0 ? DEFAULT_TIME_LIMIT : _e,
      clearFunctionRef = props.clearFunctionRef,
      userSubmitItems = props.userSubmitItems,
      _f = props.editable,
      editable = _f === void 0 ? true : _f,
      sticker = props.sticker,
      _g = props.wordReciteStructured,
      wordReciteStructured = _g === void 0 ? {
    annotation: '',
    guideContent: '',
    media: {
      type: EMediaTypes.IMG,
      url: ''
    },
    reciteFile: '',
    phoneticSymbols: '',
    reciteContent: ''
  } : _g,
      logicTypeId = props.logicTypeId,
      difficulty = props.difficulty,
      bigTypeName = props.bigTypeName,
      answerTypeList = props.answerTypeList,
      questionId = props.questionId,
      labelList = props.labelList;

  var annotation = wordReciteStructured.annotation,
      guideContent = wordReciteStructured.guideContent,
      _h = wordReciteStructured.media,
      _j = _h === void 0 ? {
    type: EMediaTypes.IMG,
    url: ''
  } : _h,
      type = _j.type,
      url = _j.url,
      reciteFile = wordReciteStructured.reciteFile,
      phoneticSymbols = wordReciteStructured.phoneticSymbols,
      reciteContent = wordReciteStructured.reciteContent;

  var _k = useState({
    playState: false
  }),
      nativeAudioState = _k[0],
      setNativeAudioState = _k[1];

  var nativeAudioPlayStateRef = useRef(false);

  var _l = useState(false),
      taping = _l[0],
      setTaping = _l[1];

  function tellMeIsTaping(tapingMsg) {
    setTaping(tapingMsg);
  }

  if (clearFunctionRef) {
    clearFunctionRef.current = clearNativeAudio;
  }

  nativeAudioPlayStateRef.current = nativeAudioState.playState;

  if (!exit(questionId)) {
    propsException('questionId', questionId);
  } // 必须传入语音题的作答方式


  if (!exit(answerTypeList)) {
    propsException('answerTypeList', answerTypeList);
  } else if (!exit(answerTypeList === null || answerTypeList === void 0 ? void 0 : answerTypeList[0])) {
    propsException('answerType', answerTypeList === null || answerTypeList === void 0 ? void 0 : answerTypeList[0]);
  } // console.log('//////', userSubmitItems?.[0]);

  useSetCookie(questionId); // 进入新的语音题，如果在端上，则调用端能力自动播放原音，否则什么也不做

  useEffect(function () {
    return function () {
      if (nativeAudioPlayStateRef.current) {
        stopNativeAudio();
      }
    };
  } // eslint-disable-next-line react-hooks/exhaustive-deps
  , [questionId]);
  var hasGuideImg = type === EMediaTypes.IMG && url !== '';
  var currentPhoneticSymbols = handlePhoneticSymbols(phoneticSymbols);
  var currentReciteContent = handlePhoneticSymbols(reciteContent);
  var sentenceOrNot = (currentReciteContent === null || currentReciteContent === void 0 ? void 0 : currentReciteContent.startsWith('/')) ? {} : (currentReciteContent === null || currentReciteContent === void 0 ? void 0 : currentReciteContent.split(' ').length) && (currentReciteContent === null || currentReciteContent === void 0 ? void 0 : currentReciteContent.split(' ').length) <= 3 ? {} : {
    textAlign: 'left',
    opacity: 0.6,
    backgroundColor: '#f2f4f7',
    borderRadius: '5px',
    padding: '15px',
    color: '#333f4f' // fontSize: '18px'

  };
  return /*#__PURE__*/React.createElement("div", {
    className: style$8['question-wrapper'],
    style: {
      height: editable ? '100%' : 'auto'
    }
  }, /*#__PURE__*/React.createElement(Context.Provider, {
    value: _assign$4(_assign$4({}, props), {
      nativeAudioPlayStateRef: nativeAudioPlayStateRef,
      setNativeAudioState: setNativeAudioState,
      nativeAudioState: nativeAudioState,
      timelimit: timelimit,
      isNewVersion: isNewVersion,
      tellMeIsTaping: tellMeIsTaping
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: style$8.header,
    style: {
      // minHeight: hasGuideImg ? 0 : '73px'
      minHeight: hasGuideImg ? 0 : 'auto'
    }
  }, showGrade && /*#__PURE__*/React.createElement(Grade, {
    logicTypeId: logicTypeId,
    difficulty: difficulty,
    bigTypeName: bigTypeName
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(style$8['question-container'], "\n                    ").concat(editable ? style$8['quesiton-container-editable'] : '')
  }, exit(guideContent) && guideContent !== '' && /*#__PURE__*/React.createElement(Annotation, {
    text: guideContent,
    fontSize: 14,
    columnPadding: 16
  }), /*#__PURE__*/React.createElement("div", {
    className: style$8.content
  }, url === '' ? null : type === EMediaTypes.IMG ? /*#__PURE__*/React.createElement(FitImg, {
    src: url
  }) : type === EMediaTypes.VIDEO ? /*#__PURE__*/React.createElement(VideoPlayer, {
    source: url,
    isCenter: true
  }) : null, ((answerTypeList === null || answerTypeList === void 0 ? void 0 : answerTypeList[0]) === EAudioAnswerType.ENGLISH_ENGLISH || ((_b = (_a = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b.answer) && !taping) && /*#__PURE__*/React.createElement(SpeechStem, null), exit(annotation) && /*#__PURE__*/React.createElement(Annotation, {
    text: annotation,
    fontSize: sentenceOrNot.textAlign ? 18 : 14,
    otherStyles: sentenceOrNot
  }), exit(currentPhoneticSymbols) && /*#__PURE__*/React.createElement(Annotation, {
    text: currentPhoneticSymbols,
    fontSize: 20,
    color: "#15171a"
  }))), // eslint-disable-next-line react/no-array-index-key
  sticker === null || sticker === void 0 ? void 0 : sticker.map(function (item, index) {
    return (item.location === EStickerLocModule.ANSWERINFO || item.location === EStickerLocModule.ANSWERINFOEND) &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Sticker, {
      sticker: item,
      key: "".concat(questionId).concat(index)
    });
  }), !editable && /*#__PURE__*/React.createElement(AnswerInfo, {
    originalAudioUrl: reciteFile,
    // originalAudioUrl="https://jyimgs.gsxcdn.com/be/base/test/20210315/37950634531667968.mp3"
    myAudioUrl: (_d = (_c = userSubmitItems === null || userSubmitItems === void 0 ? void 0 : userSubmitItems[0]) === null || _c === void 0 ? void 0 : _c.resource) === null || _d === void 0 ? void 0 : _d.answer,
    labelList: labelList
  }), editable && /*#__PURE__*/React.createElement(PlayContent, null)));
};

var Speech$1 = withErrorBoundary(Speech);

var style$7 = {"reciteWraper":"tangram_C_reciteWraper_a1092b29c0","fixed-btn":"tangram_C_fixed-btn_a1092b29c0"};

var needReciteBtnQTypes = [ELogicTypeId.MULTIPLE_CHOICE, ELogicTypeId.INDEFINITE_CHOICE, ELogicTypeId.FILL_BLANK, ELogicTypeId.EXPLANATION, ELogicTypeId.WRITING, ELogicTypeId.WORD_RECITATION];
var FIXED_BTN_TYPES = [ELogicTypeId.WORD_RECITATION, ELogicTypeId.POETRY_RECITATION];

var reciteSticker = function reciteSticker(questionInfo, alwaysShowReciteConfirm, fastAnswer, reciteNode, onReciteModeChange) {
  var _a = questionInfo.questionInfoDTO,
      questionId = _a.questionId,
      logicTypeId = _a.logicTypeId; // 选择、判断展示查看答案条件（1、一直展示；2、非快速作答且已作答）

  if (alwaysShowReciteConfirm || !fastAnswer) {
    needReciteBtnQTypes.push(ELogicTypeId.CHOICE, ELogicTypeId.JUDGE);
  }

  var isNeedReciteBtn = needReciteBtnQTypes.includes(logicTypeId);

  var onReciteStickerClick = function onReciteStickerClick() {
    onReciteModeChange === null || onReciteModeChange === void 0 ? void 0 : onReciteModeChange(questionId);
  }; // 背题模式下的sticker


  var reciteStickerNode = function reciteStickerNode(_a) {
    var logicTypeId = _a.logicTypeId;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(style$7.reciteWraper, " ").concat(FIXED_BTN_TYPES.includes(logicTypeId) ? style$7['fixed-btn'] : '')
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      // eslint-disable-next-line react/jsx-no-bind
      onClick: onReciteStickerClick
    }, "\u67E5\u770B\u7B54\u6848"));
  };

  return isNeedReciteBtn ? {
    // @ts-ignore
    getCustomNode: function getCustomNode() {
      var _a, _b;

      return (_b = (_a = reciteNode === null || reciteNode === void 0 ? void 0 : reciteNode.getCustomNode) === null || _a === void 0 ? void 0 : _a.call(reciteNode, _assign$4(_assign$4({}, questionInfo), {
        onReciteStickerClick: onReciteStickerClick
      }))) !== null && _b !== void 0 ? _b : reciteStickerNode(questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionInfoDTO);
    },
    location: EStickerLocModule.ANSWERINFOEND,
    data: questionInfo
  } : null;
};

/* eslint-disable complexity */
function conversion(oldJSON, isSpeakEvaluation) {
  if (!oldJSON) {
    if (!isSpeakEvaluation) {
      return {
        body: '',
        answerInfo: '',
        selection: '',
        answer: ''
      };
    }

    return {
      annotation: '',
      guideContent: '',
      media: {
        type: EMediaTypes.IMG,
        url: ''
      },
      phoneticSymbols: '',
      reciteContent: '',
      reciteFile: '',
      reciteFileName: ''
    };
  }

  try {
    var wholeOldJsonObj = JSON.parse(oldJSON);
    var // 普通题结构字段
    body = wholeOldJsonObj.body,
        answerInfo = wholeOldJsonObj.answerInfo,
        selection = wholeOldJsonObj.selection,
        answer = wholeOldJsonObj.answer,
        // 语音评测题结构字段
    annotation = wholeOldJsonObj.annotation,
        guideContent = wholeOldJsonObj.guideContent,
        media = wholeOldJsonObj.media,
        phoneticSymbols = wholeOldJsonObj.phoneticSymbols,
        reciteContent = wholeOldJsonObj.reciteContent,
        reciteFile = wholeOldJsonObj.reciteFile,
        reciteFileName = wholeOldJsonObj.reciteFileName;

    if (!isSpeakEvaluation) {
      return {
        body: body !== null && body !== void 0 ? body : '',
        answerInfo: answerInfo !== null && answerInfo !== void 0 ? answerInfo : '',
        selection: selection !== null && selection !== void 0 ? selection : '',
        answer: answer !== null && answer !== void 0 ? answer : ''
      };
    }

    return {
      annotation: annotation !== null && annotation !== void 0 ? annotation : '',
      guideContent: guideContent !== null && guideContent !== void 0 ? guideContent : '',
      media: media !== null && media !== void 0 ? media : {
        type: EMediaTypes.IMG,
        url: ''
      },
      phoneticSymbols: phoneticSymbols !== null && phoneticSymbols !== void 0 ? phoneticSymbols : '',
      reciteContent: reciteContent !== null && reciteContent !== void 0 ? reciteContent : '',
      reciteFile: reciteFile !== null && reciteFile !== void 0 ? reciteFile : '',
      reciteFileName: reciteFileName !== null && reciteFileName !== void 0 ? reciteFileName : ''
    };
  } catch (error) {
    throw new Error("JSON\u6570\u636E\u8F6C\u6362\u5931\u8D25, ".concat(JSON.stringify(error)));
  }
}

/* eslint-disable complexity */

/* eslint-disable max-lines */
var _a$3, _b;

var QUESTION_ITEM_CONFIG = (_a$3 = {}, _a$3[PRACTICE_MODE.pratice] = {
  currentMode: PRACTICE_MODE.pratice,
  // 题目可编辑
  editable: true,
  // 展示解析
  showResult: false,
  // 展示历史提交
  showHistory: false,
  // 展示老师评语
  showTeacherComments: false,
  // 展示知识点标签
  showLabel: false,
  // 展示来源
  showSource: false,
  // 展示题目来源
  showStemSource: true,
  showDifficulty: true,
  // 展示解析视频
  showVideoExplanation: false,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true,
  // 显示简单填空
  showPlainBlank: false
}, _a$3[PRACTICE_MODE.recite] = {
  currentMode: PRACTICE_MODE.recite,
  // 题目可编辑
  editable: true,
  // 展示解析
  showResult: false,
  // 展示历史提交
  showHistory: false,
  // 展示老师评语
  showTeacherComments: false,
  // 展示知识点标签
  showLabel: false,
  // 展示来源
  showSource: false,
  // 展示题目来源
  showStemSource: true,
  showDifficulty: true,
  // 展示解析视频
  showVideoExplanation: false,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true,
  // 显示简单填空
  showPlainBlank: false
}, _a$3[PRACTICE_MODE.evaluation] = {
  currentMode: PRACTICE_MODE.evaluation,
  // 题目可编辑
  editable: false,
  // 展示解析
  showResult: true,
  // 展示历史提交
  showHistory: true,
  // 展示老师评语
  showTeacherComments: true,
  // 展示知识点标签
  showLabel: true,
  // 展示来源
  showSource: true,
  // 展示题目来源
  showStemSource: false,
  showDifficulty: true,
  // 展示自评
  showEvaluation: true,
  // 展示解析视频
  showVideoExplanation: true,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true,
  // 显示简单填空
  showPlainBlank: false
}, _a$3[PRACTICE_MODE.analysis] = {
  currentMode: PRACTICE_MODE.analysis,
  // 题目可编辑
  editable: false,
  // 展示解析
  showResult: true,
  // 展示历史提交
  showHistory: true,
  // 展示老师评语
  showTeacherComments: true,
  // 展示知识点标签
  showLabel: true,
  // 展示来源
  showSource: true,
  // 展示题目来源
  showStemSource: false,
  showDifficulty: true,
  // 展示自评
  showEvaluation: true,
  // 展示解析视频
  showVideoExplanation: true,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true,
  // 显示简单填空
  showPlainBlank: false
}, _a$3[PRACTICE_MODE.coreDisplay] = {
  currentMode: PRACTICE_MODE.coreDisplay,
  // 题目可编辑
  editable: false,
  // 展示解析
  showResult: false,
  // 展示历史提交
  showHistory: false,
  // 展示老师评语
  showTeacherComments: false,
  // 展示知识点标签
  showLabel: false,
  // 展示来源
  showSource: false,
  // 展示题干来源
  showStemSource: false,
  showDifficulty: false,
  // 展示自评
  showEvaluation: false,
  // 展示解析视频
  showVideoExplanation: false,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: false,
  // 显示简单填空
  showPlainBlank: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true
}, // 订正模式
_a$3[PRACTICE_MODE.revising] = {
  currentMode: PRACTICE_MODE.revising,
  // 题目可编辑
  editable: true,
  // 展示解析
  showResult: false,
  // 展示历史提交
  showHistory: false,
  // 展示老师评语
  showTeacherComments: false,
  // 展示知识点标签
  showLabel: false,
  // 展示来源
  showSource: false,
  // 展示题目来源
  showStemSource: true,
  showDifficulty: true,
  // 展示解析视频
  showVideoExplanation: false,
  // 选择题展示易错项/全站正确率/作答用时
  showResultInfo: false,
  // 展示作答信息
  showSubmitInfo: true,
  // 展示选项
  showOption: true,
  // 展示题型、难度模块
  showGrade: true,
  // 显示简单填空
  showPlainBlank: false
}, _a$3); // 判断是哪一种题型

var judgeQuestionType = function judgeQuestionType(logicTypeId) {
  switch (logicTypeId) {
    case ELogicTypeId.CHOICE:
    case ELogicTypeId.MULTIPLE_CHOICE:
      return EComponent.choice;

    case ELogicTypeId.INDEFINITE_CHOICE:
      return EComponent.multipleChoice;

    case ELogicTypeId.FILL_BLANK:
      return EComponent.fill;

    case ELogicTypeId.FILL_ON_BLANK:
      return EComponent.default;

    case ELogicTypeId.EXPLANATION:
    case ELogicTypeId.WRITING:
      return EComponent.explain;

    case ELogicTypeId.JUDGE:
      return EComponent.judge;

    case ELogicTypeId.WORD_RECITATION:
      return EComponent.speech;

    default:
      return EComponent.default;
  }
};
var ResultCorrectness = (_b = {}, _b[EAnswerStatus.WRONG] = EResultCorrectness$1.WRONG, _b[EAnswerStatus.RIGHT] = EResultCorrectness$1.RIGHT, _b[EAnswerStatus.LITTLE] = EResultCorrectness$1.WRONG, _b[EAnswerStatus.HALF_RIGHT] = EResultCorrectness$1.PARTIAL_RIGHT, _b[EAnswerStatus.UN_ANSWER] = EResultCorrectness$1.WRONG, _b[EAnswerStatus.BASIC_Right] = EResultCorrectness$1.PARTIAL_RIGHT, _b[EAnswerStatus.NO_EVALUATION] = EResultCorrectness$1.WRONG, _b[EAnswerStatus.ANSEWRED] = EResultCorrectness$1.WRONG, _b[EAnswerStatus.RECITED] = '', _b);

var parseInteractiveContent = function parseInteractiveContent(questionContentJson, isInteractive) {
  var interactiveContent = {
    coursewareUrl: '',
    coverUrl: '',
    fromTemplate: 0,
    modelId: '',
    name: '',
    templateKindId: '',
    templateTypeId: ''
  };
  return isInteractive ? parseJSON(questionContentJson) : interactiveContent;
}; // 解析题目中的questionContentJson


var conversionQuestion = function conversionQuestion(questionContentJson, questionType) {
  var isSpeech = questionType === ELogicTypeId.WORD_RECITATION;
  var isInteractive = questionType === ELogicTypeId.INTERACTIVE;
  return {
    questionfomateJson: conversion === null || conversion === void 0 ? void 0 : conversion(questionContentJson, isSpeech),
    wordReciteContent: conversion === null || conversion === void 0 ? void 0 : conversion(questionContentJson, isSpeech),
    interactiveContent: parseInteractiveContent(questionContentJson, isInteractive)
  };
};

var getDefaultMode = function getDefaultMode(status) {
  if (status === void 0) {
    status = 10;
  }

  switch (status) {
    case ERecordStatus.unSubmit:
    case ERecordStatus.halfSubmit:
    case ERecordStatus.rejected:
      return PRACTICE_MODE.pratice;

    case ERecordStatus.unEvaluation:
    case ERecordStatus.unCorrect:
      return PRACTICE_MODE.evaluation;
    // 订正模式

    case ERecordStatus.revising:
      return PRACTICE_MODE.revising;

    default:
      return PRACTICE_MODE.analysis;
  }
}; // 获取用户定义的模型


var getPracticeMode = function getPracticeMode(status, mode, customModeConfig) {
  if (status === void 0) {
    status = 10;
  }

  if (customModeConfig === void 0) {
    customModeConfig = {};
  }

  if (!mode) {
    mode = getDefaultMode(status);
  }

  return _assign$4(_assign$4({}, QUESTION_ITEM_CONFIG[mode]), customModeConfig[mode]);
}; // 子题的提交历史

var formateChildSubmitHistory = function formateChildSubmitHistory(userAnswerDetailDTOList, index, questionId, questionInfo) {
  var _a, _b, _c;

  var childAnswerMap = questionInfo.childAnswerMap; // TODO: 子题提交历史处理
  // 需要把每个userAnswerDetailDTO里的对应的子题的的提交数据整合在一起

  if (!childAnswerMap) {
    var newAnswerDetailDTOList_1 = (_a = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList.filter(function (answer) {
      return !answer.selfInited;
    })) === null || _a === void 0 ? void 0 : _a.map(function (userAnswerDetailDTO) {
      return userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.childQuestionList[index];
    }).filter(function (each) {
      var _a;

      return (each === null || each === void 0 ? void 0 : each.itemBaseList) && ((_a = each.itemBaseList) === null || _a === void 0 ? void 0 : _a.length) > 0;
    });
    return (newAnswerDetailDTOList_1 === null || newAnswerDetailDTOList_1 === void 0 ? void 0 : newAnswerDetailDTOList_1.length) >= 2 ? newAnswerDetailDTOList_1 : null;
  }

  var newAnswerDetailDTOList = (_c = (_b = childAnswerMap.get(questionId)) === null || _b === void 0 ? void 0 : _b.filter(function (answer) {
    return !answer.selfInited;
  })) === null || _c === void 0 ? void 0 : _c.filter(function (each) {
    var _a;

    return (each === null || each === void 0 ? void 0 : each.itemBaseList) && ((_a = each.itemBaseList) === null || _a === void 0 ? void 0 : _a.length) > 0;
  });
  return (newAnswerDetailDTOList === null || newAnswerDetailDTOList === void 0 ? void 0 : newAnswerDetailDTOList.length) >= 2 ? newAnswerDetailDTOList : null;
};

function isAutoGrading2CorrectType(isAutoGrading, userAnswerDetailDTO) {
  var _a, _b;

  return ((_a = userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.itemBaseList) === null || _a === void 0 ? void 0 : _a.length) && ((_b = userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.itemBaseList) === null || _b === void 0 ? void 0 : _b.every(function (item) {
    return item.resourceType !== ESubmitItemTypes.TEXT_AUTO;
  })) || [EAutoGradingTypes.CAN_AUTO, EAutoGradingTypes.CAN_AUTO_MULTIPLE].includes(isAutoGrading !== null && isAutoGrading !== void 0 ? isAutoGrading : -1) ? ECorrectType.AUTO_CORRECT : ECorrectType.TEACHER_CORRECT;
} // 题目渲染数据处理


var formatQuestion = function formatQuestion(questionInfoDTO, userAnswerDetailDTO, evaluationQuestionConfigVO, mode, // 评测状态
packageSubmitStatus, customModeConfig, stickerList, fastAnswer, onReciteModeChange, // 子题才会传入的母题题型
parentLogicTypeId) {
  var _a, _b;

  var _c = questionInfoDTO || {},
      questionId = _c.questionId,
      bigTypeName = _c.bigTypeName,
      difficulty = _c.difficulty,
      isAutoGrading = _c.isAutoGrading,
      labelList = _c.labelList,
      questionContentJson = _c.questionContentJson,
      logicTypeId = _c.logicTypeId,
      subjectId = _c.subjectId,
      sourceDTO = _c.sourceDTO,
      accuracy = _c.accuracy,
      errorOption = _c.errorOption,
      answerWay = _c.answerWay;

  var _d = userAnswerDetailDTO || {},
      questionScore = _d.questionScore,
      spendTime = _d.spendTime,
      userScore = _d.userScore,
      status = _d.status,
      itemBaseList = _d.itemBaseList,
      _e = _d.correctCommentVOList,
      questionCommentVOList = _e === void 0 ? [] : _e,
      answerRecordCorrectType = _d.correctType;

  var correctCommentVOList = questionCommentVOList;

  if (!correctCommentVOList.length) {
    itemBaseList === null || itemBaseList === void 0 ? void 0 : itemBaseList.forEach(function (item) {
      var _a;

      ((_a = item === null || item === void 0 ? void 0 : item.correctCommentVOList) === null || _a === void 0 ? void 0 : _a.length) && correctCommentVOList.push.apply(correctCommentVOList, item.correctCommentVOList);
    });
  }

  function parseCorrectCommentVOList(correctCommentVOList) {
    var parsed = [];

    if (correctCommentVOList === null || correctCommentVOList === void 0 ? void 0 : correctCommentVOList.length) {
      for (var _i = 0, correctCommentVOList_1 = correctCommentVOList; _i < correctCommentVOList_1.length; _i++) {
        var correctComment = correctCommentVOList_1[_i];
        var resource = correctComment.resource,
            resourceType = correctComment.resourceType,
            childCorrectCommentVOList = correctComment.childCorrectCommentVOList;
        var parsedChild = [];

        if (childCorrectCommentVOList === null || childCorrectCommentVOList === void 0 ? void 0 : childCorrectCommentVOList.length) {
          for (var _a = 0, childCorrectCommentVOList_1 = childCorrectCommentVOList; _a < childCorrectCommentVOList_1.length; _a++) {
            var child = childCorrectCommentVOList_1[_a];
            var resource_1 = child.resource,
                resourceType_1 = child.resourceType;
            parsedChild.push(_assign$4(_assign$4({}, child), {
              resourceType: resourceType_1,
              // @ts-ignore
              resource: parseResourceJSON(resourceType_1, resource_1)
            }));
          }
        }

        parsed.push({
          resourceType: resourceType,
          // @ts-ignore
          resource: parseResourceJSON(resourceType, resource),
          childCorrectCommentVOList: (childCorrectCommentVOList === null || childCorrectCommentVOList === void 0 ? void 0 : childCorrectCommentVOList.length) ? parsedChild : childCorrectCommentVOList
        });
      }
    }

    return parsed;
  }

  var _f = conversionQuestion(questionContentJson, logicTypeId),
      questionfomateJson = _f.questionfomateJson,
      wordReciteContent = _f.wordReciteContent,
      _g = _f.interactiveContent,
      interactiveContent = _g === void 0 ? {} : _g;

  var _h = questionfomateJson,
      body = _h.body,
      selection = _h.selection,
      answer = _h.answer,
      answerInfo = _h.answerInfo;

  var _j = evaluationQuestionConfigVO || {},
      videoUrl = _j.videoUrl,
      videoCoverImage = _j.videoCoverImage,
      videoVOList = _j.videoVOList,
      correctType = _j.correctType,
      _k = _j.subAnswerWay,
      subAnswerWay = _k === void 0 ? [] : _k,
      extendConfig = _j.extendConfig,
      answerMode = _j.answerMode;

  var expletorySource = null;

  if (extendConfig) {
    var expletorySourceJson = parseJSON(extendConfig).expletorySource;
    expletorySource = parseJSON(expletorySourceJson) || null;
  }

  var _l = getPracticeMode(packageSubmitStatus, mode, customModeConfig),
      editable = _l.editable,
      showResult = _l.showResult,
      showHistory = _l.showHistory,
      showTeacherComments = _l.showTeacherComments,
      showLabel = _l.showLabel,
      showSource = _l.showSource,
      showStemSource = _l.showStemSource,
      showDifficulty = _l.showDifficulty,
      showEvaluation = _l.showEvaluation,
      showVideoExplanation = _l.showVideoExplanation,
      showResultInfo = _l.showResultInfo,
      currentMode = _l.currentMode,
      showSubmitInfo = _l.showSubmitInfo,
      showPlainBlank = _l.showPlainBlank,
      showOption = _l.showOption,
      alwaysShowReciteConfirm = _l.alwaysShowReciteConfirm,
      showGrade = _l.showGrade,
      onlyMyAnswer = _l.onlyMyAnswer;

  var questionInfo = {
    questionInfoDTO: questionInfoDTO,
    userAnswerDetailDTOList: [userAnswerDetailDTO],
    evaluationQuestionConfigVO: evaluationQuestionConfigVO
  };
  var sticker = (stickerList === null || stickerList === void 0 ? void 0 : stickerList.filter(function (item) {
    var _a, _b;

    return !((_a = item === null || item === void 0 ? void 0 : item.component) === null || _a === void 0 ? void 0 : _a.length) || ((_b = item.component) === null || _b === void 0 ? void 0 : _b.includes(judgeQuestionType(logicTypeId)));
  }).map(function (item) {
    return _assign$4(_assign$4({}, item), {
      data: questionInfo
    });
  })) || []; // 背题模式

  if (alwaysShowReciteConfirm || status === EAnswerStatus.ANSEWRED && mode === PRACTICE_MODE.recite) {
    // 自定义背题按钮
    var reciteNode = stickerList === null || stickerList === void 0 ? void 0 : stickerList.find(function (item) {
      return item.location === EStickerLocModule.RECITE_NODE;
    });
    var currentSticker = reciteSticker(questionInfo, alwaysShowReciteConfirm, fastAnswer, reciteNode, onReciteModeChange);
    currentSticker && sticker.push(currentSticker);
  }

  var showExceptMyAnswer = true;

  if (onlyMyAnswer && mode === PRACTICE_MODE.analysis && (status === EAnswerStatus.ANSEWRED || status === EAnswerStatus.NO_EVALUATION)) {
    showExceptMyAnswer = false;
  }

  var extraParam = {
    showHistory: showExceptMyAnswer && showHistory,
    correctType: correctType,
    subAnswerWay: subAnswerWay,
    logicTypeId: logicTypeId,
    questionId: questionId
  }; // 自定义的题型展示信息

  var noCustomShowGrade = typeof ((_a = customModeConfig === null || customModeConfig === void 0 ? void 0 : customModeConfig[mode || getDefaultMode(packageSubmitStatus)]) === null || _a === void 0 ? void 0 : _a.showGrade) === 'undefined';
  var questionProps = {
    editable: editable,
    questionId: questionId,
    answerMode: answerMode,
    subjectId: subjectId,
    stem: body,
    options: showOption ? selection : null,
    answer: showResult && showExceptMyAnswer ? answer : null,
    analysis: showResult && showExceptMyAnswer ? answerInfo === '[]' ? null : answerInfo : null,
    isAutoGrading: isAutoGrading,
    logicTypeId: logicTypeId,
    difficulty: showDifficulty ? difficulty : null,
    userSubmitItems: itemBaseList,
    bigTypeName: bigTypeName,
    // @ts-ignore
    resultCorrectness: // 已提交未批改/未自评 的解析模式下， 待批改待自评题目尚无结果 WAIT
    currentMode === PRACTICE_MODE.analysis && packageSubmitStatus === ERecordStatus.unCorrect ? [EAnswerStatus.ANSEWRED, EAnswerStatus.NO_EVALUATION].includes(status) ? EResultCorrectness$1.WAIT : ResultCorrectness[status] : currentMode === PRACTICE_MODE.evaluation && packageSubmitStatus === ERecordStatus.unCorrect ? correctType === 1 ? EResultCorrectness$1.WAIT : ResultCorrectness[status] : ResultCorrectness[status],
    // @ts-ignore
    source: showSource && showExceptMyAnswer ? expletorySource ? expletorySource : sourceDTO : null,
    stemSource: showStemSource ? expletorySource ? expletorySource : sourceDTO : null,
    answerTypeList: (subAnswerWay === null || subAnswerWay === void 0 ? void 0 : subAnswerWay.length) ? subAnswerWay : answerWay,
    showEvaluation: showEvaluation && correctType === 1,
    evaluationStatus: status,
    evaluationEditable: currentMode === PRACTICE_MODE.evaluation,
    showGraded: showEvaluation && correctType === 2,
    scoreEditable: currentMode === PRACTICE_MODE.evaluation,
    scoreValue: userScore,
    maxScore: questionScore,
    labelList: showLabel ? labelList : null,
    resultInfo: showResultInfo ? {
      useTime: spendTime,
      correctRate: accuracy,
      easyErrorOption: errorOption
    } : null,
    // 视频讲解
    videoExplanationUrls: showVideoExplanation && showExceptMyAnswer ? videoUrl : '',
    videoExplanationCoverUrl: showVideoExplanation && showExceptMyAnswer ? videoCoverImage : '',
    videoVOList: showVideoExplanation && showExceptMyAnswer ? videoVOList : [],
    // 老师评语
    commentItems: showTeacherComments && showExceptMyAnswer ? parseCorrectCommentVOList(correctCommentVOList.filter(function (comment) {
      return comment.studentVisible !== 0;
    })) : [],
    sticker: sticker,
    interactiveContent: interactiveContent,
    wordReciteStructured: _assign$4(_assign$4({}, wordReciteContent), {
      // @ts-ignore
      reciteFile: PRACTICE_MODE.coreDisplay === mode ? null : wordReciteContent === null || wordReciteContent === void 0 ? void 0 : wordReciteContent.reciteFile
    }),
    showSubmitInfo: showSubmitInfo,
    showPlainBlank: showPlainBlank,
    showOption: showOption,
    alwaysShowReciteConfirm: alwaysShowReciteConfirm,
    // 没有自定义的题型展示信息时，多选多、按空解析、空上作答 子题默认不展示题型
    showGrade: parentLogicTypeId ? noCustomShowGrade ? !(parentLogicTypeId && [ELogicTypeId.CLOZE, ELogicTypeId.FILL_ON_BLANK, ELogicTypeId.MULTI_CHOICE_MULTI].includes(parentLogicTypeId)) : showGrade : showGrade,
    // 作答记录上的判题类型没有则取题目evaluationQuestionConfigVO上的作答类型
    correctType: (_b = answerRecordCorrectType !== null && answerRecordCorrectType !== void 0 ? answerRecordCorrectType : correctType) !== null && _b !== void 0 ? _b : isAutoGrading2CorrectType(isAutoGrading, userAnswerDetailDTO)
  };
  return {
    questionProps: questionProps,
    extraParam: extraParam
  };
}; // 复合题子题题目数据处理

var formateChildQuestion = function formateChildQuestion( // 子题题目渲染数据
childrenQuestionList, // 大题答题数据
userAnswerDetailDTOList, // 子题教研云配置信息
childEvaluationQuestionConfigVOList, modeList, // 评测状态
packageSubmitStatus, customModeConfig, stickerList, fastAnswer, onReciteModeChange, questionInfo) {
  var _a;

  if (childrenQuestionList === void 0) {
    childrenQuestionList = [];
  }

  if (packageSubmitStatus === void 0) {
    packageSubmitStatus = ERecordStatus.unSubmit;
  }

  var formateChildInfo = [];
  var childrenStatus = [];

  for (var i = 0; i < (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length); i++) {
    var _b = userAnswerDetailDTOList[0] || {},
        childQuestionList = _b.childQuestionList,
        childItemList = _b.childItemList;

    var _c = formatQuestion(childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[i], // 待批改，已通过，已提交，待自评使用childQuestionList
    // 其他评测状态下，使用childItemList
    [ERecordStatus.unCorrect, ERecordStatus.passed, ERecordStatus.submit, ERecordStatus.unEvaluation].includes(packageSubmitStatus) // 在没有题组/试卷概念的场景下，对于复合题，如果该单题变为解析态时也使用childQuestionList项作为答案展示
    || (modeList === null || modeList === void 0 ? void 0 : modeList[i]) === PRACTICE_MODE.analysis ? childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList[i] : childItemList === null || childItemList === void 0 ? void 0 : childItemList[i], childEvaluationQuestionConfigVOList === null || childEvaluationQuestionConfigVOList === void 0 ? void 0 : childEvaluationQuestionConfigVOList[i], modeList === null || modeList === void 0 ? void 0 : modeList[i], packageSubmitStatus, customModeConfig, stickerList, fastAnswer, onReciteModeChange, (_a = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.logicTypeId),
        questionProps = _c.questionProps,
        extraParam = _c.extraParam;

    var questionId = extraParam.questionId,
        showHistory = extraParam.showHistory;
    var status_1 = ([ERecordStatus.unCorrect, ERecordStatus.passed, ERecordStatus.submit, ERecordStatus.unEvaluation].includes(packageSubmitStatus) // 在没有题组/试卷概念的场景下，对于复合题，如果该单题变为解析态时也使用childQuestionList项作为答案展示
    || (modeList === null || modeList === void 0 ? void 0 : modeList[i]) === PRACTICE_MODE.analysis ? (childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList[i]) || {} : (childItemList === null || childItemList === void 0 ? void 0 : childItemList[i]) || {}).status;
    childrenStatus.push({
      status: ResultCorrectness[status_1],
      subQuestionId: questionId
    });
    formateChildInfo.push(_assign$4(_assign$4({}, questionProps), {
      // @ts-ignore
      submitHistoryItems: showHistory ? {
        questionId: questionId,
        submitHistory: formateChildSubmitHistory(userAnswerDetailDTOList, i, questionId, questionInfo)
      } : {
        questionId: questionId,
        submitHistory: []
      }
    }));
  }

  return {
    formateChildInfo: formateChildInfo,
    childrenStatus: childrenStatus
  };
};

var _a$2;
var QuestionTypeMap = (_a$2 = {}, _a$2[ELogicTypeId.INTERACTIVE] = Interactive, _a$2[ELogicTypeId.CHOICE] = Choice$1, _a$2[ELogicTypeId.MULTIPLE_CHOICE] = Choice$1, _a$2[ELogicTypeId.INDEFINITE_CHOICE] = Choice$1, _a$2[ELogicTypeId.FILL_BLANK] = Filling, // TODO: 空上作答
_a$2[ELogicTypeId.FILL_ON_BLANK] = FillingOnBlank, _a$2[ELogicTypeId.JUDGE] = Judge, _a$2[ELogicTypeId.EXPLANATION] = Explain, _a$2[ELogicTypeId.WRITING] = Explain, _a$2[ELogicTypeId.VOICE] = null, _a$2[ELogicTypeId.CLOZE] = Compound$1, _a$2[ELogicTypeId.COMPOUND] = Compound$1, _a$2[ELogicTypeId.WORD_RECITATION] = Speech$1, // [ELogicTypeId.MULTI_CHOICE_MULTI]: null,
// TODO: 多选多
_a$2[ELogicTypeId.MULTI_CHOICE_MULTI] = Compound$1, _a$2[ELogicTypeId.VIDEO] = null, _a$2[ELogicTypeId.POETRY_RECITATION] = null, _a$2[ELogicTypeId.ROLE_PLAY] = null, _a$2);

var Exercise = function Exercise(props) {
  var _a, _b, _c, _d;

  var questionInfo = props.questionInfo,
      onUserAnswerDetailChange = props.onUserAnswerDetailChange,
      _e = props.packageSubmitStatus,
      packageSubmitStatus = _e === void 0 ? ERecordStatus.unSubmit : _e,
      mode = props.mode,
      customModeConfig = props.customModeConfig,
      _f = props.stickerList,
      stickerList = _f === void 0 ? [] : _f,
      currentChildId = props.currentChildId,
      onQuestionIdChange = props.onQuestionIdChange,
      onReciteModeChange = props.onReciteModeChange,
      onSwiperInit = props.onSwiperInit,
      allowSwiper = props.allowSwiper,
      jumpSwiperSpeed = props.jumpSwiperSpeed,
      _g = props.childReciteModeList,
      childReciteModeList = _g === void 0 ? [] : _g,
      _h = props.platForm,
      platForm = _h === void 0 ? isPC ? EPlatForm.pc : EPlatForm.app : _h,
      beaconId = props.beaconId,
      fastAnswer = props.fastAnswer,
      displayType = props.displayType,
      colorTheme = props.colorTheme,
      gradeId = props.gradeId;

  var _j = useCounterRef(0),
      reset = _j.reset,
      setShouldStop = _j.setShouldStop,
      countRef = _j.countRef;

  var childrenQuestionList = questionInfo.questionInfoDTO.childrenQuestionList,
      _k = questionInfo.userAnswerDetailDTOList,
      userAnswerDetailDTOList = _k === void 0 ? [] : _k,
      _l = questionInfo.evaluationQuestionConfigVO,
      _m = _l === void 0 ? {} : _l,
      _o = _m.childEvaluationQuestionConfigVOList,
      childEvaluationQuestionConfigVOList = _o === void 0 ? [] : _o;

  var updatedQuestionInfo = cloneDeep(questionInfo); // 在切换至对应的题目时重新开始计时

  [(_a = questionInfo === null || questionInfo === void 0 ? void 0 : questionInfo.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.questionId, currentChildId].includes(beaconId) && reset(0);

  var _p = formatQuestion(questionInfo.questionInfoDTO, userAnswerDetailDTOList[0], questionInfo.evaluationQuestionConfigVO, mode, packageSubmitStatus, customModeConfig, stickerList, fastAnswer, // eslint-disable-next-line @typescript-eslint/no-use-before-define
  selfOnReciteModeChange),
      questionProps = _p.questionProps,
      extraParam = _p.extraParam;

  var logicTypeId = extraParam.logicTypeId,
      questionId = extraParam.questionId,
      correctType = extraParam.correctType,
      subAnswerWay = extraParam.subAnswerWay,
      showHistory = extraParam.showHistory;
  var Question = logicTypeId ? QuestionTypeMap[logicTypeId] : null;

  var _q = formateChildQuestion(childrenQuestionList, userAnswerDetailDTOList, childEvaluationQuestionConfigVOList, childReciteModeList, packageSubmitStatus, customModeConfig, stickerList, fastAnswer, // eslint-disable-next-line @typescript-eslint/no-use-before-define
  selfOnReciteModeChange, questionInfo),
      formateChildInfo = _q.formateChildInfo,
      childrenStatus = _q.childrenStatus;

  var videoExplanationUrls = questionProps.videoExplanationUrls,
      videoExplanationCoverUrl = questionProps.videoExplanationCoverUrl,
      videoVOList = questionProps.videoVOList,
      commentItems = questionProps.commentItems,
      answerMode = questionProps.answerMode;
  var currentChildIndex = (_b = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.findIndex(function (item) {
    return item.questionId === currentChildId;
  })) !== null && _b !== void 0 ? _b : -1;

  function isCurrentAnswerChangeItemSingleOrJudge(currentQuestionId) {
    var _a;

    if (currentQuestionId) {
      var isCompound = [ELogicTypeId.CLOZE, ELogicTypeId.MULTI_CHOICE_MULTI, ELogicTypeId.COMPOUND].includes(logicTypeId);
      var currentLogicTypeId = isCompound ? (_a = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.find(function (child) {
        return child.questionId === currentQuestionId;
      })) === null || _a === void 0 ? void 0 : _a.logicTypeId : logicTypeId;
      return currentLogicTypeId ? [ELogicTypeId.JUDGE, ELogicTypeId.CHOICE].includes(currentLogicTypeId) : false;
    }

    return false;
  } // answers是单个子题的答案
  // 对于复合题答案的改动
  // 如果当前子题作答了(answers.status === EAnswerStatus.ANSEWRED) 则母题状态也应变为已作答
  // 如果当前子题的改动导致该子题状态变为未作答 则应some操作所有子题中是否有已作答的子题来决定母题的作答状态
  // 背题模式下，点击确认按钮需要将对应题目（子题）的 status 改为 EAnswerStatus.RECITED
  // 此时，是对子题的背题，则要检查该道复合题每道子题的status是否为 EAnswerStatus.RECITED


  function regurgitation(answers, childQuestionList, oriMotifStatus) {
    if (answers.status === EAnswerStatus.RECITED) {
      return childQuestionList.every(function (childAnswer) {
        return childAnswer.status === EAnswerStatus.RECITED;
      }) ? EAnswerStatus.RECITED : oriMotifStatus;
    }

    return answers.status === EAnswerStatus.ANSEWRED ? EAnswerStatus.ANSEWRED : childQuestionList.some(function (childAnswer) {
      return (childAnswer === null || childAnswer === void 0 ? void 0 : childAnswer.status) === EAnswerStatus.ANSEWRED;
    }) ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER;
  } // 答案改变触发回调


  function answerChangeCallback(currentQuestionId, answer, reciteModeChangeOnly, evaluationOnly, evaluations) {
    var _a, _b;

    if (reciteModeChangeOnly === void 0) {
      reciteModeChangeOnly = false;
    }

    if (evaluationOnly === void 0) {
      evaluationOnly = false;
    } // 解析状态下，或卷子处于待批改:20，已通过:40，已提交: 70 时无需做任何动作


    if ((mode === PRACTICE_MODE.analysis || packageSubmitStatus && [ERecordStatus.unCorrect, ERecordStatus.passed, ERecordStatus.submit].includes(packageSubmitStatus)) && mode !== PRACTICE_MODE.evaluation) {
      return;
    } // 自评模式下-没有自评作答 不进行作答数据变更


    if (mode === PRACTICE_MODE.evaluation && !evaluations) {
      return;
    } // 默认背题模式单选题和判断题没有背题sticker 需要答题后触发背题状态改变的回调
    // fastAnswer为false的时候不自动触发


    var autoConfirm = mode === PRACTICE_MODE.recite && fastAnswer && isCurrentAnswerChangeItemSingleOrJudge(currentQuestionId);
    var contentArr = [];

    if (!evaluationOnly && !reciteModeChangeOnly) {
      answer.forEach(function (item) {
        var _a, _b, _c;

        var resource = item.resource,
            resourceType = item.resourceType;

        if (resourceType === ESubmitItemTypes.TEXT_AUTO) {
          (_a = resource) === null || _a === void 0 ? void 0 : _a.forEach(function (blank) {
            !!(blank === null || blank === void 0 ? void 0 : blank.userAnswer) && contentArr.push(blank.userAnswer);
          });
        } else {
          var currentContent = [ESubmitItemTypes.TEXT, ESubmitItemTypes.OPTION].includes(resourceType) ? resource : resourceType === ESubmitItemTypes.AUDIOEVALUATE ? (_b = resource) === null || _b === void 0 ? void 0 : _b.answer : (_c = resource) === null || _c === void 0 ? void 0 : _c.url;
          currentContent && contentArr.push(currentContent);
        }
      });
    } // 区分回调是子题 还是 大题
    // 答题/自评/背题确认后，重新组装题目数据


    var currentUserAnswerDetailDTO;

    if (currentQuestionId === questionId) {
      currentUserAnswerDetailDTO = userAnswerDetailDTOList[0];
      var updatedSpendTime = (+((currentUserAnswerDetailDTO === null || currentUserAnswerDetailDTO === void 0 ? void 0 : currentUserAnswerDetailDTO.spendTime) || 0) + countRef.current).toString();
      var updatedAnswer = evaluationOnly ? _assign$4(_assign$4({}, currentUserAnswerDetailDTO), evaluations) : reciteModeChangeOnly ? _assign$4(_assign$4({}, currentUserAnswerDetailDTO), {
        status: EAnswerStatus.RECITED,
        spendTime: updatedSpendTime
      }) : _assign$4(_assign$4({}, currentUserAnswerDetailDTO), {
        status: autoConfirm ? EAnswerStatus.RECITED : contentArr.length > 0 ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER,
        itemBaseList: answer,
        spendTime: updatedSpendTime
      });
      updatedQuestionInfo.userAnswerDetailDTOList[0] = updatedAnswer;
    } else if (currentQuestionId === currentChildId) {
      currentUserAnswerDetailDTO = (_b = (_a = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0]) === null || _a === void 0 ? void 0 : _a.childItemList) === null || _b === void 0 ? void 0 : _b[currentChildIndex];
      var updatedSpendTime = (+((currentUserAnswerDetailDTO === null || currentUserAnswerDetailDTO === void 0 ? void 0 : currentUserAnswerDetailDTO.spendTime) || 0) + countRef.current).toString();
      var updatedAnswer = evaluationOnly ? _assign$4(_assign$4({}, currentUserAnswerDetailDTO), evaluations) : reciteModeChangeOnly ? _assign$4(_assign$4({}, currentUserAnswerDetailDTO), {
        status: EAnswerStatus.RECITED,
        spendTime: updatedSpendTime
      }) : _assign$4(_assign$4({}, currentUserAnswerDetailDTO), {
        status: autoConfirm ? EAnswerStatus.RECITED : contentArr.length > 0 ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER,
        itemBaseList: answer,
        spendTime: updatedSpendTime
      }); // TODO: 数据容错
      // updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList[currentChildIndex] = updatedAnswer;
      // updatedQuestionInfo.userAnswerDetailDTOList[0].childQuestionList[currentChildIndex] = updatedAnswer;

      updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList && (updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList[currentChildIndex] = updatedAnswer);
      updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList && (updatedQuestionInfo.userAnswerDetailDTOList[0].childQuestionList[currentChildIndex] = updatedAnswer); // TODO: 数据容错
      // (!evaluationOnly) && (
      //     updatedQuestionInfo.userAnswerDetailDTOList[0].status = regurgitation(
      //         updatedAnswer, updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList,
      //         userAnswerDetailDTOList[0].status
      //     )
      // );

      !evaluationOnly && updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList && (updatedQuestionInfo.userAnswerDetailDTOList[0].status = regurgitation(updatedAnswer, updatedQuestionInfo.userAnswerDetailDTOList[0].childItemList, userAnswerDetailDTOList[0].status));
    }

    updatedQuestionInfo.isModified = true;
    onUserAnswerDetailChange === null || onUserAnswerDetailChange === void 0 ? void 0 : onUserAnswerDetailChange(updatedQuestionInfo, updatedQuestionInfo.userAnswerDetailDTOList[0], // 真正触发答案变更的题目id
    currentQuestionId, reciteModeChangeOnly || autoConfirm && !evaluationOnly);
    !evaluationOnly && reset(0);
  } // 自评触发回调


  var evaluationChangeCallback = function evaluationChangeCallback(currentQuestionId, value) {
    var currentUserAnswerDetailDTO;
    var currentCorrectType; // 需要修改的userAnswerDetailDTO以及correctType都要区分大题，小题

    if (currentQuestionId === questionId) {
      currentUserAnswerDetailDTO = userAnswerDetailDTOList[0];
      currentCorrectType = correctType;
    } else {
      var childItemList = userAnswerDetailDTOList[0].childItemList;
      currentUserAnswerDetailDTO = childItemList[currentChildIndex];
      currentCorrectType = childEvaluationQuestionConfigVOList[currentChildIndex].correctType;
    }

    var _a = currentUserAnswerDetailDTO || {},
        status = _a.status,
        userScore = _a.userScore;

    answerChangeCallback(currentQuestionId, currentUserAnswerDetailDTO === null || currentUserAnswerDetailDTO === void 0 ? void 0 : currentUserAnswerDetailDTO.itemBaseList, false, true, {
      status: currentCorrectType === 1 ? (value ? +value : value) || EAnswerStatus.NO_EVALUATION : status,
      userScore: currentCorrectType === 2 ? value ? +value : value : userScore
    });
  };

  function selfOnReciteModeChange(currentQuestionId) {
    var currentUserAnswerDetailDTO;

    if (currentQuestionId === currentChildId) {
      currentUserAnswerDetailDTO = userAnswerDetailDTOList[0].childItemList[currentChildIndex];
    } else {
      currentUserAnswerDetailDTO = userAnswerDetailDTOList[0];
    }

    answerChangeCallback(currentQuestionId, currentUserAnswerDetailDTO.itemBaseList, true);
    onReciteModeChange === null || onReciteModeChange === void 0 ? void 0 : onReciteModeChange(currentQuestionId);
    setShouldStop(true);
  }

  var selectColor = (colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.selectedColor) ? colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.selectedColor : '#0088ff';
  var wrongColor = (colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.wrongColor) ? colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.wrongColor : '#fe5335';
  var correctColor = (colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.correctColor) ? colorTheme === null || colorTheme === void 0 ? void 0 : colorTheme.correctColor : '#00cf8a';
  var showFollow = (commentItems === null || commentItems === void 0 ? void 0 : commentItems.length) || (videoExplanationUrls === null || videoExplanationUrls === void 0 ? void 0 : videoExplanationUrls.length) || showHistory && ((_c = userAnswerDetailDTOList.filter(function (answer) {
    return answer.itemBaseList && answer.itemBaseList.length > 0 && !answer.selfInited;
  })) === null || _c === void 0 ? void 0 : _c.length) >= 2;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    style: {
      // @ts-ignore
      '--correct': correctColor,
      '--selected': selectColor,
      '--wrong': wrongColor
    },
    className: // eslint-disable-next-line no-negated-condition
    displayType !== EDisplayType.EDisplayModule ? style$D["page-exercise".concat([ELogicTypeId.COMPOUND, ELogicTypeId.CLOZE, ELogicTypeId.MULTI_CHOICE_MULTI].includes(logicTypeId) ? '-compound' : '')] : style$D['module-exercise']
  }, Question && /*#__PURE__*/React.createElement(Question // eslint-disable-next-line react/jsx-no-bind
  , _assign$4({
    // eslint-disable-next-line react/jsx-no-bind
    onAnswerChange: answerChangeCallback,
    allowSwiper: allowSwiper,
    jumpSwiperSpeed: jumpSwiperSpeed,
    // eslint-disable-next-line react/jsx-no-bind
    onSelfEvaluationChange: evaluationChangeCallback,
    // eslint-disable-next-line react/jsx-no-bind
    onGradeChange: evaluationChangeCallback,
    // eslint-disable-next-line react/jsx-no-bind
    onGradeBlur: evaluationChangeCallback,
    // 子题列表
    childrenQuestionList: formateChildInfo,
    // 选中的当前小题index
    currentChildIndex: currentChildIndex,
    // 答题的回调
    // eslint-disable-next-line react/jsx-no-bind
    onCompoundAnswerChange: answerChangeCallback,
    // 点击小题按钮的回调
    onQuestionIdChange: onQuestionIdChange,
    onSwiperInit: onSwiperInit,
    answerStatus: childrenStatus,
    platForm: platForm,
    beaconId: beaconId,
    colorTheme: colorTheme,
    gradeId: gradeId,
    showSigleQImgUpload: answerMode !== EAnswerMode.UNIFIED
  }, questionProps)), /*#__PURE__*/React.createElement("span", {
    className: showFollow ? style$D['split-line'] : ''
  }), /*#__PURE__*/React.createElement("div", {
    className: showFollow ? style$D['follow-parts'] : ''
  }, // 除复合题，老师评语、视频讲解、提交历史
  ![ELogicTypeId.COMPOUND, ELogicTypeId.CLOZE, ELogicTypeId.MULTI_CHOICE_MULTI, ELogicTypeId.FILL_ON_BLANK].includes(logicTypeId) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VideoExplanation, {
    videoVOList: videoVOList,
    urls: videoExplanationUrls,
    coverUrl: videoExplanationCoverUrl,
    platForm: platForm
  }), /*#__PURE__*/React.createElement(Correction, {
    commentItems: commentItems
  }), showHistory && ((_d = userAnswerDetailDTOList.filter(function (answer) {
    return answer.itemBaseList && answer.itemBaseList.length > 0 && !answer.selfInited;
  })) === null || _d === void 0 ? void 0 : _d.length) >= 2 && /*#__PURE__*/React.createElement(SubmitHistory, {
    questionId: questionId,
    submitHistory: userAnswerDetailDTOList.filter(function (answer, index) {
      return answer.itemBaseList && answer.itemBaseList.length > 0 && !answer.selfInited;
    }),
    answerWay: subAnswerWay
  })))));
};

var Exercise$1 = /*#__PURE__*/React.memo(Exercise);

var style$6 = {"card-wrapper":"tangram_C_card-wrapper_4504b046eb","card-item":"tangram_C_card-item_4504b046eb","unanswer":"tangram_C_unanswer_4504b046eb","selected":"tangram_C_selected_4504b046eb","answered":"tangram_C_answered_4504b046eb","right":"tangram_C_right_4504b046eb","corrected-tag":"tangram_C_corrected-tag_4504b046eb","wrong":"tangram_C_wrong_4504b046eb","half-right":"tangram_C_half-right_4504b046eb","unevaluation":"tangram_C_unevaluation_4504b046eb","pc-card-wrapper":"tangram_C_pc-card-wrapper_4504b046eb"};

var _a$1;
var EAnswerStatusClass$1 = (_a$1 = {}, _a$1[EAnswerStatus.ANSEWRED] = 'answered', _a$1[EAnswerStatus.UN_ANSWER] = 'unanswer', _a$1[EAnswerStatus.RIGHT] = 'right', _a$1[EAnswerStatus.WRONG] = 'wrong', _a$1[EAnswerStatus.LITTLE] = 'wrong', _a$1[EAnswerStatus.BASIC_Right] = 'right', _a$1[EAnswerStatus.HALF_RIGHT] = 'half-right', _a$1[EAnswerStatus.NO_EVALUATION] = 'unevaluation', _a$1[EAnswerStatus.RECITED] = 'answered', _a$1);
var EVALUATION_STATUS = [EAnswerStatus.NO_EVALUATION, EAnswerStatus.ANSEWRED];

var AnswerCardItem = function AnswerCardItem(props) {
  var currentId = props.currentId,
      currentChildId = props.currentChildId,
      cardClickCallBack = props.cardClickCallBack,
      status = props.status,
      questionIndex = props.questionIndex,
      itemQuestionId = props.itemQuestionId,
      itemChildQuestionId = props.itemChildQuestionId,
      answerItemDetail = props.answerItemDetail,
      childAnswerItemDetail = props.childAnswerItemDetail,
      _a = props.mode,
      mode = _a === void 0 ? PRACTICE_MODE.pratice : _a;

  var onCardItemClick = function onCardItemClick() {
    cardClickCallBack(itemQuestionId, itemChildQuestionId, answerItemDetail, childAnswerItemDetail);
  };

  var isSelected = currentId === itemQuestionId && ( // 兼容 currentChildId 被处理成非 undefined 的情况
  currentChildId && itemChildQuestionId ? currentChildId === itemChildQuestionId : true);
  var questionAnswerVersion = childAnswerItemDetail ? childAnswerItemDetail.questionAnswerVersion || 0 : (answerItemDetail === null || answerItemDetail === void 0 ? void 0 : answerItemDetail.questionAnswerVersion) || 0;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    // eslint-disable-next-line react/jsx-no-bind
    onClick: onCardItemClick,
    tabIndex: 0,
    className: "\n                ".concat(style$6['card-item'], "\n                ").concat(style$6[EAnswerStatusClass$1[status]], "\n                ").concat(isSelected ? style$6.selected : '', "\n            ")
  }, /*#__PURE__*/React.createElement("span", null, questionIndex), questionAnswerVersion > 1 && [PRACTICE_MODE.analysis, PRACTICE_MODE.revising].includes(mode) && /*#__PURE__*/React.createElement("span", {
    className: "".concat(style$6['corrected-tag'])
  }, "\u5DF2\u8BA2\u6B63"));
};

var AnswerCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = useState([]),
      noEvaluationIds = _a[0],
      setNoEvaluationIds = _a[1];

  var version = props.version,
      answerSheetList = props.answerSheetList,
      currentId = props.currentId,
      currentChildId = props.currentChildId,
      cardClickCallBack = props.cardClickCallBack,
      _b = props.mode,
      mode = _b === void 0 ? PRACTICE_MODE.pratice : _b,
      _c = props.platForm,
      platForm = _c === void 0 ? isPC ? EPlatForm.pc : EPlatForm.app : _c;
  var itemProps = {
    mode: mode,
    currentId: currentId,
    currentChildId: currentChildId,
    cardClickCallBack: cardClickCallBack
  }; // 自评模式下，自评题目状态为 题目未自评或已作答， 答题卡状态对应为未作答状态
  // 解析状态下，已作答为待批改

  var formatStatus = function formatStatus(status, questionId, questionAnswerVersion) {
    if (mode === PRACTICE_MODE.evaluation) {
      return noEvaluationIds.includes(questionId) || version && version !== questionAnswerVersion ? status : EVALUATION_STATUS.includes(status) ? EAnswerStatus.UN_ANSWER : EAnswerStatus.ANSEWRED;
    }

    if (mode === PRACTICE_MODE.analysis) {
      return status === EAnswerStatus.ANSEWRED ? EAnswerStatus.NO_EVALUATION : status;
    }

    return status;
  };

  useEffect(function () {
    if ((answerSheetList === null || answerSheetList === void 0 ? void 0 : answerSheetList.length) && mode === PRACTICE_MODE.evaluation) {
      // 无需自评的子题id
      var noEvaluationIds_1 = [];
      answerSheetList.forEach(function (item) {
        var _a;

        var children = ((_a = item === null || item === void 0 ? void 0 : item.childItemList) === null || _a === void 0 ? void 0 : _a.length) ? item.childItemList : item.childQuestionList;
        (children === null || children === void 0 ? void 0 : children.length) && (children === null || children === void 0 ? void 0 : children.forEach(function (item) {
          item.correctType !== ECorrectType.SELF_CORRECT && (item === null || item === void 0 ? void 0 : item.questionId) && noEvaluationIds_1.push(item.questionId);
        }));
      });
      setNoEvaluationIds(noEvaluationIds_1);
    } else {
      // 清空自评模式下无需自评的子题id
      setNoEvaluationIds([]);
    }
  }, [answerSheetList === null || answerSheetList === void 0 ? void 0 : answerSheetList.length, mode]);
  return /*#__PURE__*/React.createElement("div", {
    className: "\n                ".concat(style$6['card-wrapper'], "\n                ").concat(platForm === EPlatForm.pc ? style$6['pc-card-wrapper'] : '', "\n            "),
    ref: ref
  }, answerSheetList === null || answerSheetList === void 0 ? void 0 : answerSheetList.map(function (answerItem, pidx) {
    var itemQuestionId = answerItem.questionId,
        questionIndex = answerItem.questionIndex,
        childQuestionList = answerItem.childQuestionList,
        childItemList = answerItem.childItemList,
        status = answerItem.status,
        questionAnswerVersion = answerItem.questionAnswerVersion;
    var children = mode === PRACTICE_MODE.analysis ? childQuestionList : (childItemList === null || childItemList === void 0 ? void 0 : childItemList.length) ? childItemList : childQuestionList;

    if (children === null || children === void 0 ? void 0 : children.length) {
      return children.map(function (childAnswerItem, cidx) {
        var itemChildQuestionId = childAnswerItem.questionId,
            childIndex = childAnswerItem.questionIndex,
            status = childAnswerItem.status,
            questionAnswerVersion = childAnswerItem.questionAnswerVersion;
        return /*#__PURE__*/React.createElement(AnswerCardItem, _assign$4({
          key: itemChildQuestionId,
          itemQuestionId: itemQuestionId,
          itemChildQuestionId: itemChildQuestionId,
          answerItemDetail: answerItem,
          childAnswerItemDetail: childAnswerItem,
          status: formatStatus(status, itemChildQuestionId, questionAnswerVersion),
          questionIndex: "".concat(questionIndex !== null && questionIndex !== void 0 ? questionIndex : pidx + 1, ".").concat(childIndex !== null && childIndex !== void 0 ? childIndex : cidx + 1)
        }, itemProps));
      });
    }

    return /*#__PURE__*/React.createElement(AnswerCardItem, _assign$4({
      key: itemQuestionId,
      itemQuestionId: itemQuestionId,
      answerItemDetail: answerItem,
      status: formatStatus(status, itemQuestionId, questionAnswerVersion),
      questionIndex: questionIndex !== null && questionIndex !== void 0 ? questionIndex : (pidx + 1).toString()
    }, itemProps));
  }));
});
AnswerCard.displayName = 'ExerciseUIAnswerCard';

var style$5 = {"annotations-wrapper":"tangram_C_annotations-wrapper_b3c9917459","each-annotation":"tangram_C_each-annotation_b3c9917459","annotation-item":"tangram_C_annotation-item_b3c9917459","unanswer":"tangram_C_unanswer_b3c9917459","answered":"tangram_C_answered_b3c9917459","right":"tangram_C_right_b3c9917459","half-right":"tangram_C_half-right_b3c9917459","wrong":"tangram_C_wrong_b3c9917459","unevaluation":"tangram_C_unevaluation_b3c9917459"};

var _a;
var EAnnotates;

(function (EAnnotates) {
  EAnnotates["unanswer"] = "\u672A\u4F5C\u7B54";
  EAnnotates["answered"] = "\u5DF2\u4F5C\u7B54";
  EAnnotates["right"] = "\u6B63\u786E";
  EAnnotates["half-right"] = "\u534A\u5BF9";
  EAnnotates["wrong"] = "\u9519\u8BEF";
  EAnnotates["unevaluation"] = "\u6279\u6539\u4E2D/\u672A\u81EA\u8BC4";
})(EAnnotates || (EAnnotates = {}));

var EOrder;

(function (EOrder) {
  EOrder[EOrder["unanswer"] = 1] = "unanswer";
  EOrder[EOrder["answered"] = 2] = "answered";
  EOrder[EOrder["right"] = 3] = "right";
  EOrder[EOrder["half-right"] = 4] = "half-right";
  EOrder[EOrder["wrong"] = 5] = "wrong";
  EOrder[EOrder["unevaluation"] = 6] = "unevaluation";
})(EOrder || (EOrder = {}));

var EAnswerStatusClass = (_a = {}, _a[EAnswerStatus.ANSEWRED] = 'answered', _a[EAnswerStatus.UN_ANSWER] = 'unanswer', _a[EAnswerStatus.RIGHT] = 'right', _a[EAnswerStatus.WRONG] = 'wrong', _a[EAnswerStatus.LITTLE] = 'wrong', _a[EAnswerStatus.BASIC_Right] = 'right', _a[EAnswerStatus.HALF_RIGHT] = 'half-right', _a[EAnswerStatus.NO_EVALUATION] = 'unevaluation', _a[EAnswerStatus.RECITED] = 'answered', _a);

var AnswerCardAnnotation = function AnswerCardAnnotation(props) {
  var annotations = props.annotations,
      answerSheetList = props.answerSheetList,
      mode = props.mode;

  if (!exist(annotations) && !exist(answerSheetList)) {
    footPrintDetailReport({
      detailAction: '接收到的答题卡（注释）数据不存在',
      actionValue: "".concat(annotations, ", ").concat(answerSheetList)
    });
    return null;
  }

  var as = new Set();

  if (exist(annotations) && annotations.length > 0) {
    for (var _i = 0, annotations_1 = annotations; _i < annotations_1.length; _i++) {
      var annotation = annotations_1[_i];
      EAnswerStatusClass[annotation] && as.add(EAnswerStatusClass[annotation]);
    }
  } else if (exist(answerSheetList) && answerSheetList.length > 0) {
    for (var _a = 0, answerSheetList_1 = answerSheetList; _a < answerSheetList_1.length; _a++) {
      var answer = answerSheetList_1[_a];
      var status_1 = answer.status,
          childQuestionList = answer.childQuestionList;

      if (childQuestionList && childQuestionList.length > 0) {
        for (var _b = 0, childQuestionList_1 = childQuestionList; _b < childQuestionList_1.length; _b++) {
          var child = childQuestionList_1[_b];
          var actualChildStatus = mode === PRACTICE_MODE.analysis && child.status === EAnswerStatus.ANSEWRED ? EAnswerStatus.NO_EVALUATION : child.status;
          EAnswerStatusClass[actualChildStatus] && as.add(EAnswerStatusClass[actualChildStatus]);
        }
      } else {
        var actualStatus = mode === PRACTICE_MODE.analysis && status_1 === EAnswerStatus.ANSEWRED ? EAnswerStatus.NO_EVALUATION : status_1;
        EAnswerStatusClass[actualStatus] && as.add(EAnswerStatusClass[actualStatus]);
      }
    }
  } // @ts-ignore


  var annotates = Array.from(as).sort(function (a, b) {
    return EOrder[a] - EOrder[b];
  });
  return /*#__PURE__*/React.createElement("div", {
    className: style$5['annotations-wrapper']
  }, annotates.map(function (annotate) {
    return /*#__PURE__*/React.createElement("div", {
      className: style$5['each-annotation'],
      key: annotate
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(style$5['annotation-item'], " ").concat(style$5[annotate])
    }), /*#__PURE__*/React.createElement("span", null, // @ts-ignore
    EAnnotates[annotate]));
  }));
};

var style$4 = {"swiper-slide":"tangram_C_swiper-slide_328e8d0246","exercise-list":"tangram_C_exercise-list_328e8d0246"};

var img$2 = "data:image/png;base64,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";

var style$3 = {"guide-wrapper":"tangram_C_guide-wrapper_cd892eed41","start-btn":"tangram_C_start-btn_cd892eed41","bubble":"tangram_C_bubble_cd892eed41","point-btn":"tangram_C_point-btn_cd892eed41","submit-outline":"tangram_C_submit-outline_cd892eed41","go-submit":"tangram_C_go-submit_cd892eed41"};

var uid = getUserId();

var GuideUnifeidAnswer = function GuideUnifeidAnswer(props) {
  var isShow = props.isShow;
  var node = useRef();

  var _a = React.useState(false),
      show = _a[0],
      setShow = _a[1];

  useEffect(function () {
    setShow(isShow && localStorage.getItem("guidedUnifiedAns_".concat(uid)) !== 'guided');
  }, [isShow]);

  function handleClick(e) {
    var _a;

    if (!((_a = e.target.className) === null || _a === void 0 ? void 0 : _a.includes('disabled-area'))) {
      setShow(false);
      localStorage.setItem("guidedUnifiedAns_".concat(uid), 'guided');
    }
  }

  useEffect(function () {
    var clickDom = node === null || node === void 0 ? void 0 : node.current;

    if (clickDom) {
      clickDom === null || clickDom === void 0 ? void 0 : clickDom.addEventListener('click', handleClick);
    }

    return function () {
      clickDom === null || clickDom === void 0 ? void 0 : clickDom.removeEventListener('click', handleClick);
    };
  }, [node.current]);
  useEffect(function () {
    if (isShow) {
      node.current = document.createElement('div');
      document.body.appendChild(node.current);
    }

    return function () {
      if (node.current) {
        node.current.remove();
      }
    };
  }, [isShow]);
  return show && node.current ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: style$3['guide-wrapper']
  }, /*#__PURE__*/React.createElement("button", {
    name: "startBtn",
    className: style$3['start-btn'],
    type: "button"
  }, "\u5F00\u59CB\u4F53\u9A8C"), /*#__PURE__*/React.createElement("img", {
    className: "disabled-area ".concat(style$3.bubble),
    src: img$2,
    alt: "\u62CD\u7167\u7B54\u9898\u5728\u7B54\u9898\u6700\u540E\u7EDF\u4E00\u4F5C\u7B54"
  }), /*#__PURE__*/React.createElement("span", {
    className: "disabled-area ".concat(style$3['point-btn'])
  }), /*#__PURE__*/React.createElement("div", {
    className: "disabled-area ".concat(style$3['submit-outline'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "disabled-area ".concat(style$3['go-submit'])
  }, /*#__PURE__*/React.createElement("span", {
    className: style$3['disabled-area']
  }, "\u4E0A\u4F20\u56FE\u7247")))), node.current) : null;
};

var style$2 = {"tip-wrapper":"tangram_C_tip-wrapper_c49313963e","close-btn":"tangram_C_close-btn_c49313963e"};

var UNIFIED_ANSWER_TIP = '本题如需拍照答题，请在答题最后统一上传';

var TipMsg = function TipMsg(props) {
  var questionList = props.questionList,
      currentId = props.currentId,
      currentChildId = props.currentChildId,
      onUserAnswerDetailChange = props.onUserAnswerDetailChange,
      mode = props.mode;

  var _a = useState(false),
      visible = _a[0],
      setVisible = _a[1];

  var onClose = function onClose() {
    var _a, _b;

    clickReport(EHaboEventId$1.CLOSE_UNIFY_TIP, {
      questionId: currentId,
      subjectId: (_b = (_a = questionList === null || questionList === void 0 ? void 0 : questionList[0]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.subjectId
    });
    onUserAnswerDetailChange === null || onUserAnswerDetailChange === void 0 ? void 0 : onUserAnswerDetailChange(questionList.map(function (question) {
      var _a, _b, _c;

      return question && _assign$4(_assign$4({}, question), {
        evaluationQuestionConfigVO: _assign$4(_assign$4({}, question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO), {
          showSigleQImgUpload: ((_a = question === null || question === void 0 ? void 0 : question.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.questionId) === currentId,
          childEvaluationQuestionConfigVOList: (_c = (_b = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _b === void 0 ? void 0 : _b.childEvaluationQuestionConfigVOList) === null || _c === void 0 ? void 0 : _c.map(function (childQuestion) {
            return _assign$4(_assign$4({}, childQuestion), {
              showSigleQImgUpload: (childQuestion === null || childQuestion === void 0 ? void 0 : childQuestion.questionId) === currentChildId
            });
          })
        })
      });
    }));
  };

  var isUnify = useMemo(function () {
    return isUnifyEvaluation(questionList, mode);
  }, [questionList, mode]);
  useEffect(function () {
    var _a, _b, _c, _d, _e, _f;

    if (questionList === null || questionList === void 0 ? void 0 : questionList.length) {
      var question = questionList.find(function (question) {
        return (question === null || question === void 0 ? void 0 : question.questionInfoDTO.questionId) === currentId;
      });

      if ((_b = (_a = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _a === void 0 ? void 0 : _a.childEvaluationQuestionConfigVOList) === null || _b === void 0 ? void 0 : _b.length) {
        var childQuestion = (_d = (_c = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _c === void 0 ? void 0 : _c.childEvaluationQuestionConfigVOList) === null || _d === void 0 ? void 0 : _d.find(function (childQuestion) {
          return (childQuestion === null || childQuestion === void 0 ? void 0 : childQuestion.questionId) === currentChildId;
        });
        childQuestion && setVisible(isUnify && (childQuestion === null || childQuestion === void 0 ? void 0 : childQuestion.answerMode) === EAnswerMode.UNIFIED && !(childQuestion === null || childQuestion === void 0 ? void 0 : childQuestion.showSigleQImgUpload));
      } else {
        question && setVisible(isUnify && ((_e = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _e === void 0 ? void 0 : _e.answerMode) === EAnswerMode.UNIFIED && !((_f = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _f === void 0 ? void 0 : _f.showSigleQImgUpload));
      }
    }
  }, [questionList, currentId, currentChildId]);
  return visible ? /*#__PURE__*/React.createElement("div", {
    className: style$2['tip-wrapper']
  }, UNIFIED_ANSWER_TIP, /*#__PURE__*/React.createElement("button", {
    className: style$2['close-btn'],
    type: "button",
    onClick: onClose
  })) : null;
};

/* eslint-disable max-lines */

var autoNextTime = 100;

var ExerciseList = function ExerciseList(props) {
  var _a, _b, _c;

  var _d = useState(),
      swiper = _d[0],
      setSwiper = _d[1];

  var playingMediaDomRef = useExclusivePlay().playingMediaDomRef;
  var currentId = props.currentId,
      chosenChildId = props.currentChildId,
      gradeId = props.gradeId;
  var timer;
  var questionList = props.questionList,
      answerSheetList = props.answerSheetList,
      _onUserAnswerDetailChange = props.onUserAnswerDetailChange,
      stickerList = props.stickerList,
      _e = props.mode,
      mode = _e === void 0 ? PRACTICE_MODE.pratice : _e,
      customModeConfig = props.customModeConfig,
      onQuestionIdChange = props.onQuestionIdChange,
      config = props.config,
      allowSwiper = props.allowSwiper,
      jumpSwiperSpeed = props.jumpSwiperSpeed,
      _f = props.fastAnswer,
      fastAnswer = _f === void 0 ? true : _f,
      _g = props.packageSubmitStatus,
      packageSubmitStatus = _g === void 0 ? ERecordStatus.unSubmit : _g,
      _h = props.reciteModeChangeTo,
      reciteModeChangeTo = _h === void 0 ? PRACTICE_MODE.analysis : _h,
      whileReciteModeChange = props.whileReciteModeChange,
      modeMapChangeConfig = props.modeMapChangeConfig,
      onSwiperInit = props.onSwiperInit,
      onChildrenSwiperInit = props.onChildrenSwiperInit,
      displayType = props.displayType,
      colorTheme = props.colorTheme,
      version = props.version,
      _j = props.platForm,
      platForm = _j === void 0 ? isPC ? EPlatForm.pc : EPlatForm.app : _j;

  if (!questionList || !questionList.length || questionList.every(function (question) {
    return !exist(question);
  })) {
    footPrintJSErrorReport({
      errorCause: "\u4E1A\u52A1\u65B9\u4F20\u5165\u7684\u9898\u76EE\u5217\u8868\u65E0\u6570\u636E\uFF0CquestionList:".concat(questionList)
    });
    throw new Error('请传入含有数据的题目列表');
  }

  var _k = useState(false),
      showUnifiedGuide = _k[0],
      setShowUnifiedGuideVisible = _k[1];

  function getQuestionIdx(id) {
    if (id === void 0) {
      id = currentId;
    }

    return questionList.findIndex(function (item) {
      return (item === null || item === void 0 ? void 0 : item.questionInfoDTO.questionId) === id;
    });
  }

  function getChildQuestionIdx(childId, id) {
    var _a, _b;

    if (id === void 0) {
      id = currentId;
    }

    var idx = getQuestionIdx(id);

    if (idx < 0) {
      return -1;
    }

    var childList = (_b = (_a = questionList[idx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.childrenQuestionList;

    if (childList && childList.length > 0) {
      return childList.findIndex(function (item) {
        return item.questionId === childId;
      });
    }

    return -1;
  }

  function needEvaluation(status, correctType) {
    return (correctType === 1 || correctType === 2) && ![EAnswerStatus.BASIC_Right, EAnswerStatus.LITTLE, EAnswerStatus.RIGHT, EAnswerStatus.WRONG].includes(status);
  }

  function onQuestionIdChangeCallback(questionId, childQuestionId) {
    var questionIndex = questionId ? getQuestionIdx(questionId) : -1;
    var childIndex = questionId && childQuestionId ? getChildQuestionIdx(childQuestionId, questionId) : -1;
    onQuestionIdChange === null || onQuestionIdChange === void 0 ? void 0 : onQuestionIdChange(questionId, childQuestionId, questionIndex >= 0 ? questionIndex + 1 : null, childIndex >= 0 ? childIndex + 1 : null);
  } // 若未传currentId


  if (!currentId) {
    var found = false; // 作答模式取第一道未作答题目id

    if (mode === PRACTICE_MODE.pratice) {
      var first = (_a = questionList.find(function (question) {
        var _a, _b;

        return ((_b = (_a = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.status) === EAnswerStatus.UN_ANSWER;
      })) === null || _a === void 0 ? void 0 : _a.questionInfoDTO;

      if (first) {
        var questionId = first.questionId,
            childrenQuestionList = first.childrenQuestionList;
        currentId = questionId; // 重置传入子题id

        chosenChildId = (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) ? childrenQuestionList[0].questionId : void 0;
        found = true;
      }
    }

    if (mode === PRACTICE_MODE.evaluation) {
      for (var _i = 0, questionList_1 = questionList; _i < questionList_1.length; _i++) {
        var question = questionList_1[_i];

        if (question) {
          var userAnswerDetailDTOList = question.userAnswerDetailDTOList,
              questionId = question.questionInfoDTO.questionId;

          var _l = (userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0]) || {},
              childQuestionList = _l.childQuestionList,
              status_1 = _l.status,
              correctType = _l.correctType;

          if ((childQuestionList === null || childQuestionList === void 0 ? void 0 : childQuestionList.length) > 0) {
            for (var _m = 0, childQuestionList_1 = childQuestionList; _m < childQuestionList_1.length; _m++) {
              var childAnswer = childQuestionList_1[_m];
              var status_2 = childAnswer.status,
                  correctType_1 = childAnswer.correctType,
                  childId = childAnswer.questionId;

              if (needEvaluation(status_2, correctType_1)) {
                currentId = questionId;
                chosenChildId = childId;
                found = true;
                onQuestionIdChangeCallback === null || onQuestionIdChangeCallback === void 0 ? void 0 : onQuestionIdChangeCallback(questionId, childId);
                break;
              }
            }
          } else if (needEvaluation(status_1, correctType)) {
            currentId = questionId;
            chosenChildId = void 0;
            found = true;
            onQuestionIdChangeCallback === null || onQuestionIdChangeCallback === void 0 ? void 0 : onQuestionIdChangeCallback(questionId);
          }
        }

        if (found) {
          break;
        }
      }
    }

    if (mode === PRACTICE_MODE.recite) {
      var first = questionList.find(function (question) {
        var _a;

        return ((_a = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0].status) !== EAnswerStatus.RECITED;
      });
      var firstDTO = first === null || first === void 0 ? void 0 : first.questionInfoDTO;
      var firstAnswers = (_b = first === null || first === void 0 ? void 0 : first.userAnswerDetailDTOList) === null || _b === void 0 ? void 0 : _b[0];

      if (firstDTO) {
        var questionId = firstDTO.questionId;
        var childQuestionList = (firstAnswers || {}).childQuestionList;
        currentId = questionId;

        if (childQuestionList && childQuestionList.length > 0) {
          chosenChildId = (_c = childQuestionList.find(function (childAnswers) {
            return childAnswers.status !== EAnswerStatus.RECITED;
          })) === null || _c === void 0 ? void 0 : _c.questionId;
        } else {
          chosenChildId = void 0;
        }

        found = true;
      }
    } // 解析模式，或其他模式下未找到符合规则的跳转id时，则找第一道存在数据题目的id
    // 若没有题目数据，则抛出错误


    if (!found) {
      var first = questionList.find(function (question) {
        return exist(question === null || question === void 0 ? void 0 : question.questionInfoDTO);
      });

      if (first) {
        var _o = first.questionInfoDTO,
            questionId = _o.questionId,
            childrenQuestionList = _o.childrenQuestionList;
        currentId = questionId; // 重置子题id

        chosenChildId = (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) ? childrenQuestionList[0].questionId : void 0;
      }
    }

    footPrintDetailReport({
      detailAction: '业务方未传入大题id，使用兜底方案',
      actionValue: "mode:".concat(mode, "\uFF0CmotifId:").concat(currentId, "\uFF0CchildId:").concat(chosenChildId)
    });
    console.warn({
      detailAction: '业务方未传入大题id，使用兜底方案',
      actionValue: "mode:".concat(mode, "\uFF0CmotifId:").concat(currentId, "\uFF0CchildId:").concat(chosenChildId)
    });
    onQuestionIdChangeCallback(currentId, chosenChildId);
  }

  var swiperSpeed = allowSwiper ? SWIPER_SPEED : 0;
  var unifyEvaluation = useMemo(function () {
    return isUnifyEvaluation(questionList, mode);
  }, [questionList, mode]);
  var isNeedEvaluation = mode === PRACTICE_MODE.evaluation || packageSubmitStatus === ERecordStatus.unEvaluation || (customModeConfig === null || customModeConfig === void 0 ? void 0 : customModeConfig.showEvaluation); // 初始化当前子题序号Map<questionId, curChildId>：优先匹配当前选中ID，若未选中过，自评取待自评的第一题，否则取第一小题ID

  function initCurChildIdMap() {
    var childMap = new Map();
    questionList.forEach(function (item) {
      var _a, _b, _c, _d;

      if (!(item === null || item === void 0 ? void 0 : item.questionInfoDTO)) {
        return;
      }

      var _e = item.questionInfoDTO,
          childrenQuestionList = _e.childrenQuestionList,
          questionId = _e.questionId;
      var userAnswerDetailDTO = ((_a = item.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0]) || {};
      childMap = childMap.set(questionId, chosenChildId && childrenQuestionList && childrenQuestionList.findIndex(function (child) {
        return child.questionId && child.questionId === chosenChildId;
      }) >= 0 ? chosenChildId : isNeedEvaluation && ((_c = (_b = userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.childQuestionList) === null || _b === void 0 ? void 0 : _b.find(function (child) {
        return [EAnswerStatus.NO_EVALUATION, EAnswerStatus.UN_ANSWER].includes(child.status);
      })) === null || _c === void 0 ? void 0 : _c.questionId) || ((_d = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[0]) === null || _d === void 0 ? void 0 : _d.questionId) || '');
    });
    return childMap;
  } // 初始化模式Map（记录背题模式状态）


  function initModeMap() {
    var modeMap = new Map();
    mode === PRACTICE_MODE.recite && questionList.forEach(function (item) {
      var _a, _b, _c, _d;

      if (!item) {
        return;
      }

      var questionInfoDTO = item.questionInfoDTO;

      if ((_b = (_a = item.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
        modeMap = modeMap.set(questionInfoDTO.questionId, PRACTICE_MODE.recite);
      } else {
        (_d = (_c = item.questionInfoDTO) === null || _c === void 0 ? void 0 : _c.childrenQuestionList) === null || _d === void 0 ? void 0 : _d.forEach(function (child) {
          modeMap = modeMap.set(child.questionId, PRACTICE_MODE.recite);
        });
      }
    });
    mode === PRACTICE_MODE.revising && questionList.forEach(function (item) {
      var _a, _b, _c, _d;

      if (!item) {
        return;
      }

      var lastAnswer = item.userAnswerDetailDTOList[0];
          item.questionInfoDTO; // 仅复合题需要给子题配置mode

      if ((_b = (_a = item.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
        if (lastAnswer) {
          var _e = lastAnswer.childItemList,
              childItemList = _e === void 0 ? [] : _e,
              _f = lastAnswer.childQuestionList,
              childQuestionList = _f === void 0 ? [] : _f;
          var targetList_1 = (childItemList === null || childItemList === void 0 ? void 0 : childItemList.length) > 0 ? childItemList : childQuestionList;
          (_d = (_c = item.questionInfoDTO) === null || _c === void 0 ? void 0 : _c.childrenQuestionList) === null || _d === void 0 ? void 0 : _d.forEach(function (child, childIndex) {
            var _a;

            modeMap = modeMap.set(child.questionId, [EAnswerStatus.UN_ANSWER, EAnswerStatus.ANSEWRED].includes((_a = targetList_1[childIndex]) === null || _a === void 0 ? void 0 : _a.status) ? PRACTICE_MODE.pratice : PRACTICE_MODE.analysis);
          });
        }
      }
    });
    mode === PRACTICE_MODE.evaluation && questionList.forEach(function (item) {
      var _a, _b, _c, _d;

      if (!item) {
        return;
      }

      var lastAnswer = item.userAnswerDetailDTOList[0];
          item.questionInfoDTO; // 仅复合题需要给子题配置mode

      if ((_b = (_a = item.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList) === null || _b === void 0 ? void 0 : _b.length) {
        if (lastAnswer) {
          var _e = lastAnswer.childItemList,
              childItemList = _e === void 0 ? [] : _e,
              _f = lastAnswer.childQuestionList,
              childQuestionList = _f === void 0 ? [] : _f;
          var targetList_2 = (childItemList === null || childItemList === void 0 ? void 0 : childItemList.length) > 0 ? childItemList : childQuestionList;
          (_d = (_c = item.questionInfoDTO) === null || _c === void 0 ? void 0 : _c.childrenQuestionList) === null || _d === void 0 ? void 0 : _d.forEach(function (child, childIndex) {
            var _a;

            modeMap = modeMap.set(child.questionId, version && version !== ((_a = targetList_2[childIndex]) === null || _a === void 0 ? void 0 : _a.questionAnswerVersion) ? PRACTICE_MODE.analysis : mode);
          });
        }
      }
    });
    return modeMap;
  }

  var _p = useState(initCurChildIdMap),
      curChildIdMap = _p[0],
      setCurChildMap = _p[1];

  var _q = useState(initModeMap),
      modeMap = _q[0],
      setModeMap = _q[1]; // 根据大题或小题ID查询信息


  function getQuestionById(questionId) {
    var _a, _b;

    var _c = questionList[getQuestionIdx()] || {},
        questionInfoDTO = _c.questionInfoDTO,
        userAnswerDetailDTOList = _c.userAnswerDetailDTOList,
        evaluationQuestionConfigVO = _c.evaluationQuestionConfigVO;

    var userAnswerDetailDTO = userAnswerDetailDTOList === null || userAnswerDetailDTOList === void 0 ? void 0 : userAnswerDetailDTOList[0];
    var isChild = false;
    var childIdx = getChildQuestionIdx(questionId);

    if (childIdx >= 0) {
      // 小题
      questionInfoDTO = (_a = questionInfoDTO === null || questionInfoDTO === void 0 ? void 0 : questionInfoDTO.childrenQuestionList) === null || _a === void 0 ? void 0 : _a[childIdx];
      userAnswerDetailDTO = userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.childQuestionList[childIdx];
      evaluationQuestionConfigVO = (_b = evaluationQuestionConfigVO === null || evaluationQuestionConfigVO === void 0 ? void 0 : evaluationQuestionConfigVO.childEvaluationQuestionConfigVOList) === null || _b === void 0 ? void 0 : _b[childIdx];
      isChild = true;
    }

    return {
      questionInfoDTO: questionInfoDTO,
      userAnswerDetailDTO: userAnswerDetailDTO,
      evaluationQuestionConfigVO: evaluationQuestionConfigVO,
      isChild: isChild
    };
  }

  function initSwiper(s) {
    setSwiper(s);
    s.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.39, 0.575, 0.565, 1)';
    s.slideTo(getQuestionIdx(), 0);
    onSwiperInit === null || onSwiperInit === void 0 ? void 0 : onSwiperInit(s);
  }

  function onSlideChange() {
    var _a;

    if (swiper) {
      var id = (_a = questionList[swiper.activeIndex]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO.questionId;
      id && onQuestionIdChangeCallback(id, curChildIdMap.get(id));
    }
  }

  function updateQuestionList(question) {
    var curIdx = getQuestionIdx(question.questionInfoDTO.questionId);

    if (curIdx >= 0) {
      var tmpDataList = cloneDeep(questionList);
      tmpDataList[curIdx] = question;
      return tmpDataList;
    }
  }

  function updateAnswerSheetList(answers) {
    var curIdx = getQuestionIdx(answers.questionId);

    if (curIdx >= 0 && answerSheetList) {
      var tmpDataList = cloneDeep(answerSheetList);
      tmpDataList[curIdx] = answers;
      return tmpDataList;
    }
  }

  function answerChange(question, answers, triggerId, recited) {
    if (recited === void 0) {
      recited = false;
    }

    if (timer) {
      clearTimeout(timer);
    } // 解析状态下，或卷子处于待批改:20，已通过:40，已提交: 70 时无需做任何动作


    if ((mode === PRACTICE_MODE.analysis || packageSubmitStatus && [ERecordStatus.unCorrect, ERecordStatus.passed, ERecordStatus.submit].includes(packageSubmitStatus)) && mode !== PRACTICE_MODE.evaluation) {
      return;
    } // 订正模式下-正确的子题 不进行作答数据变更


    if (mode === PRACTICE_MODE.revising) {
      var curChildmode = triggerId ? modeMap === null || modeMap === void 0 ? void 0 : modeMap.get(triggerId) : '';

      if (curChildmode === PRACTICE_MODE.analysis) {
        return;
      }
    }

    var questionId = answers.questionId;

    if (!triggerId || !questionId) {
      throw new Error('题目id缺失');
    }

    var questionList = updateQuestionList(question);
    var answerSheetList = updateAnswerSheetList(answers);
    questionList && (_onUserAnswerDetailChange === null || _onUserAnswerDetailChange === void 0 ? void 0 : _onUserAnswerDetailChange(questionList, answerSheetList)); // 单选和判断，作答模式下作答完成后自动跳转下一题
    // 根据真正触发答案变更的题目id来决定自动跳转

    var _a = getQuestionById(triggerId),
        questionInfoDTO = _a.questionInfoDTO,
        isChild = _a.isChild;

    if (questionInfoDTO && mode === PRACTICE_MODE.pratice && fastAnswer && [ELogicTypeId.CHOICE, ELogicTypeId.JUDGE].includes(questionInfoDTO === null || questionInfoDTO === void 0 ? void 0 : questionInfoDTO.logicTypeId)) {
      timer = setTimeout(function () {
        var currentIdx = getQuestionIdx();
        var currentChildIndex = isChild ? getChildQuestionIdx(triggerId) : void 0;

        var _a = V3Utils.goNext(currentIdx, questionList, currentChildIndex),
            motifId = _a.motifId,
            childId = _a.childId;

        onQuestionIdChangeCallback(motifId, childId);
      }, autoNextTime);
    }

    recited && setModeMap(cloneDeep(modeMap.set(triggerId, reciteModeChangeTo)));
  }

  function _onReciteModeChange(id) {
    whileReciteModeChange === null || whileReciteModeChange === void 0 ? void 0 : whileReciteModeChange(id, reciteModeChangeTo);
  }

  useEffect(function () {
    var _a, _b, _c;

    var _d = modeMapChangeConfig || {},
        shouldChange = _d.shouldChange,
        changeTo = _d.changeTo,
        cId = _d.cId;

    if (shouldChange && cId) {
      var newMode_1 = changeTo || PRACTICE_MODE.analysis;

      if (getQuestionIdx(cId) > -1) {
        var childIdList = (_c = (_b = (_a = questionList[getQuestionIdx(cId)]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.childrenQuestionList) === null || _c === void 0 ? void 0 : _c.map(function (child) {
          return child.questionId;
        });
        var newModeMap_1 = cloneDeep(modeMap);

        if ((childIdList === null || childIdList === void 0 ? void 0 : childIdList.length) && childIdList.length > 0) {
          // 注意：此处未更改母题状态
          childIdList === null || childIdList === void 0 ? void 0 : childIdList.forEach(function (cid) {
            return newModeMap_1.set(cid, newMode_1);
          });
        }

        newModeMap_1.set(cId, newMode_1);
        setModeMap(newModeMap_1);
      }
    }
  }, [modeMapChangeConfig === null || modeMapChangeConfig === void 0 ? void 0 : modeMapChangeConfig.shouldChange, modeMapChangeConfig === null || modeMapChangeConfig === void 0 ? void 0 : modeMapChangeConfig.changeTo, modeMapChangeConfig === null || modeMapChangeConfig === void 0 ? void 0 : modeMapChangeConfig.cId]);
  useEffect(function () {
    var _a, _b; // currentId中存在chosenChildId时更新当前子题序号列表


    if (chosenChildId && currentId && getChildQuestionIdx(chosenChildId) >= 0) {
      setCurChildMap(cloneDeep(curChildIdMap.set(currentId, chosenChildId)));
      var showGuide = platForm === EPlatForm.app && unifyEvaluation && ((_b = (_a = getQuestionById(chosenChildId)) === null || _a === void 0 ? void 0 : _a.evaluationQuestionConfigVO) === null || _b === void 0 ? void 0 : _b.answerMode) === EAnswerMode.UNIFIED;
      showGuide && setShowUnifiedGuideVisible(showGuide);
    }
  }, [chosenChildId]);
  useEffect(function () {
    var updatedMapWhileQuestionListLengthChange = cloneDeep(curChildIdMap);
    questionList.forEach(function (question) {
      var _a, _b, _c, _d;

      if (!question) {
        return;
      }

      var _e = question.questionInfoDTO,
          childrenQuestionList = _e.childrenQuestionList,
          questionId = _e.questionId;

      if (updatedMapWhileQuestionListLengthChange.has(questionId)) {
        return;
      }

      var userAnswerDetailDTO = (_a = question.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a[0];
      updatedMapWhileQuestionListLengthChange.set(questionId, chosenChildId && (childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList.length) && childrenQuestionList.findIndex(function (child) {
        return child.questionId && child.questionId === chosenChildId;
      }) >= 0 ? chosenChildId : isNeedEvaluation && ((_c = (_b = userAnswerDetailDTO === null || userAnswerDetailDTO === void 0 ? void 0 : userAnswerDetailDTO.childQuestionList) === null || _b === void 0 ? void 0 : _b.find(function (child) {
        return [EAnswerStatus.NO_EVALUATION, EAnswerStatus.UN_ANSWER].includes(child.status);
      })) === null || _c === void 0 ? void 0 : _c.questionId) || ((_d = childrenQuestionList === null || childrenQuestionList === void 0 ? void 0 : childrenQuestionList[0]) === null || _d === void 0 ? void 0 : _d.questionId) || '');
      setCurChildMap(updatedMapWhileQuestionListLengthChange);
    });
  }, [questionList.length, curChildIdMap]);
  useEffect(function () {
    var _a, _b, _c;

    if (currentId) {
      // 手动切题
      swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(getQuestionIdx(), jumpSwiperSpeed !== null && jumpSwiperSpeed !== void 0 ? jumpSwiperSpeed : JUMP_SWIPER_SPEED); // 暂停正在播放的语音

      (_a = playingMediaDomRef === null || playingMediaDomRef === void 0 ? void 0 : playingMediaDomRef.current) === null || _a === void 0 ? void 0 : _a.pause();
      var showGuide = platForm === EPlatForm.app && unifyEvaluation && ((_c = (_b = getQuestionById(currentId)) === null || _b === void 0 ? void 0 : _b.evaluationQuestionConfigVO) === null || _c === void 0 ? void 0 : _c.answerMode) === EAnswerMode.UNIFIED;
      showGuide && setShowUnifiedGuideVisible(showGuide);
    }
  }, [currentId]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(GuideUnifeidAnswer, {
    isShow: showUnifiedGuide
  }), /*#__PURE__*/React.createElement("div", {
    className: style$4['exercise-list']
  }, /*#__PURE__*/React.createElement(Swiper, {
    modules: [Virtual],
    onSlideChange: onSlideChange,
    onSwiper: initSwiper,
    speed: swiperSpeed,
    edgeSwipeDetection: true,
    resistanceRatio: 0,
    style: {
      height: '100%',
      width: '100%'
    },
    // 不触发滑动的类名（音频进度条、子题题号区域等）
    noSwipingClass: "swiping-disable",
    allowTouchMove: allowSwiper,
    virtual: {
      enabled: true
    },
    slidesPerView: 1
  }, questionList.map(function (item, index) {
    var _a, _b;

    var questionId = item === null || item === void 0 ? void 0 : item.questionInfoDTO.questionId;
    var childIdList = (_b = (_a = item === null || item === void 0 ? void 0 : item.questionInfoDTO) === null || _a === void 0 ? void 0 : _a.childrenQuestionList) === null || _b === void 0 ? void 0 : _b.map(function (item) {
      return item.questionId;
    });
    return questionId && /*#__PURE__*/React.createElement(SwiperSlide, {
      className: style$4['swiper-slide'],
      virtualIndex: index,
      key: questionId
    }, /*#__PURE__*/React.createElement(Exercise$1, {
      questionInfo: item,
      onUserAnswerDetailChange: function onUserAnswerDetailChange(question, answers, triggerId, autoConfirm) {
        question && answers && answerChange(question, answers, triggerId, autoConfirm);
      },
      currentChildId: curChildIdMap.get(questionId),
      packageSubmitStatus: packageSubmitStatus,
      mode: modeMap.get(questionId) || mode,
      customModeConfig: customModeConfig,
      config: config,
      stickerList: stickerList,
      childReciteModeList: childIdList === null || childIdList === void 0 ? void 0 : childIdList.map(function (id) {
        return modeMap.get(id) || mode;
      }),
      onQuestionIdChange: onQuestionIdChangeCallback,
      onReciteModeChange: function onReciteModeChange(id) {
        return id && _onReciteModeChange(id);
      },
      allowSwiper: allowSwiper,
      jumpSwiperSpeed: jumpSwiperSpeed,
      reciteModeChangeTo: reciteModeChangeTo,
      beaconId: currentId !== null && currentId !== void 0 ? currentId : '',
      fastAnswer: fastAnswer,
      onSwiperInit: onChildrenSwiperInit,
      colorTheme: colorTheme,
      displayType: displayType,
      gradeId: gradeId,
      platForm: platForm
    }));
  })), /*#__PURE__*/React.createElement(TipMsg, {
    questionList: questionList,
    mode: mode,
    currentId: currentId,
    currentChildId: chosenChildId,
    onUserAnswerDetailChange: function onUserAnswerDetailChange(list) {
      return _onUserAnswerDetailChange === null || _onUserAnswerDetailChange === void 0 ? void 0 : _onUserAnswerDetailChange(list);
    }
  })));
};

var index = /*#__PURE__*/React.memo(ExerciseList);

var useCounter = function useCounter(startTime, timingType) {
  if (timingType === void 0) {
    timingType = 1;
  }

  var _a = useState(startTime),
      countDown = _a[0],
      setCountDown = _a[1];

  var _b = useState(true),
      isPause = _b[0],
      setIsPause = _b[1];

  var timer = useRef(0);
  useEffect(function () {
    window.clearInterval(timer.current);

    if (!isPause) {
      timer.current = window.setInterval(function () {
        timingType === 2 ? setCountDown(function (c) {
          return c - 1;
        }) : setCountDown(function (c) {
          return c + 1;
        });
      }, 1000);
    }

    return function () {
      return window.clearInterval(timer.current);
    };
  }, [isPause]);
  useEffect(function () {
    var onVisibilityChange = function onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        setIsPause(false);
      }

      if (document.visibilityState === 'hidden') {
        setIsPause(true);
      }
    }; // 监听页面显示隐藏


    document.addEventListener('visibilitychange', onVisibilityChange);
    return function () {
      return document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
  return {
    countDown: countDown,
    setIsPause: setIsPause,
    setCountDown: setCountDown
  };
};

var style$1 = {"count-con":"tangram_C_count-con_0a4c76ad04","clock":"tangram_C_clock_0a4c76ad04","active":"tangram_C_active_0a4c76ad04","text":"tangram_C_text_0a4c76ad04"};

var tenMinutes = 600;

var CountDown = function CountDown(props) {
  var _a = props.startTime,
      startTime = _a === void 0 ? 0 : _a,
      _b = props.timingType,
      timingType = _b === void 0 ? 1 : _b,
      timingEndHandler = props.timingEndHandler,
      logoStyle = props.logoStyle,
      textStyle = props.textStyle;

  var _c = useState('00:00'),
      content = _c[0],
      setContent = _c[1];

  var _d = useState(false),
      isLastTenMinutes = _d[0],
      setIsTenMinutes = _d[1];

  var _e = useCounter(startTime, timingType),
      countDown = _e.countDown,
      setIsPause = _e.setIsPause;

  useEffect(function () {
    if (countDown >= 0) {
      if (countDown === startTime) {
        setIsPause(false);
      }

      setContent(timeFormat(countDown)); // 判断是否小于10分钟

      timingType === 2 && countDown <= tenMinutes && !isLastTenMinutes && setIsTenMinutes(true);
    } else if (timingType === 2 && countDown < 0) {
      timingEndHandler === null || timingEndHandler === void 0 ? void 0 : timingEndHandler();
      setContent('已超时');
      setIsPause(true);
    }
  }, [countDown, startTime]);
  return /*#__PURE__*/React.createElement("div", {
    className: style$1['count-con']
  }, /*#__PURE__*/React.createElement("div", {
    className: style$1.clock,
    style: logoStyle
  }), /*#__PURE__*/React.createElement("span", {
    className: isLastTenMinutes ? style$1.active : style$1.text,
    style: textStyle
  }, content));
};

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAA/lJREFUeF7tmk9oFFccx7+/92ZmZyu9CEVshbaH6sFDlB5U9OCh9xZ66ck0Lc2ikoQ2IYsgEkj9ExeSuAbbzVZbWlpk9SD0VvAsHjyJUNBz66EQoa2b3Zl9P5ltAhqS3ZeZTLKT/ua6772d72e+v9/79yPI05EACZ/OBARQF4cIIAGULImIg8RB4qBkBMRByfhJDhIHiYOSERAHJeMnOSjrDro48807WtMRIu0TzL2xocLvyTyxvt496aCJiQn1+q49fWFgrvq+f7QVhmAGXNdFfbH+SDvUP3bqiwfrkxqvdc8Bmq7V8uHThUkiGiVSaLVaryhTSsEYY0B0ojg8+HM82fa9egrQpbn5/crwr8x4t/MpFgHM/5DjvTd+euCpvdz1t+wJQOVyObeo8v0wXOEoliwe1/UQBMF0cWRw1KJ57CZbDmjq2vV9FITnteN8HEbhZAmIlAKz+aM4XHgrtnqLjlsKqDQ3/4lpYZYIu2yd87Imz8vhy5Ofpqoh1cHX+kCl0o872K+fcxxvPGg2Lb7j6k18P4+RwolUNaQ6+GqySlerx40xM14ud6DZaMSGE3XcdoAul+cnmTFOBC9OSK2kuW0ATVWre1DnW67jHA6CIJFrXu68LQCVZr/93BBNaq13r1z0JSWVaUDtRJyr32bGB0TkbERIbYsQYwaVZuf7WOOOIno72hWk9WTOQZFr4NfPGIMzSmtlVuyjNhpUpgBduHHjDf13+BvABzYaxFrjZQbQTOWn3Y3F50+0Uq+lGVKZzEGVSsV91sB9RergZsLJzEJxaqbyERRuAshtVmgt/08mQixaHQN0ljm92SqzOYiZqVSuXoGiIU5xOs8soOjFIwcR0dnNzj+ZyUGXrlQ/JDI3wfAlB61CYHkW00of3Oi9VjfgmUjSkYjp72o7g38XHmqt39xMSJkB1IY0XdsZ6IW7AGQl3ekoVfZiXRLDf7v57/uggzsku/m1acl5ULcpZul3OVG0ABWdSdNzc9tx3UNyJt0BmNxqWLhJ7sVsIMnNqgUlAEnv5h3Xxeipz1K9HU51cBtM7eqOVnheq/VVd0SFVMz8eHx4cK/N/8Rts+WAohePUx/keR6azeZkcaRwLq54m349AWj5RW0rzIgIDF7QOewdKxT+shEat01PAWpvemu1fPDns6+VwlcARfWIr2hTSkeFUy0G+ovDg78AsCtJi0mo5wBFOqKj3MtzlffB9IOfy+8Pw7Atb6nK9aF2aOB/W+W68kPPXru+r9EyxwAYDefe2NCA1EnHjIZUuvVkiKWiNOagAqgLOAEkgGLG1lI3cZA4SByUjIA4KBk/yUHiIHFQMgLioGT8JAeJg8RByQiIg5LxewHHGaFYOCPIxQAAAABJRU5ErkJggg==";

var img = "data:image/png;base64,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";

var style = {"button-wrapper-pc":"tangram_C_button-wrapper-pc_f023afc6ef","button-disable":"tangram_C_button-disable_f023afc6ef","button-wrapper-app":"tangram_C_button-wrapper-app_f023afc6ef","button-pre":"tangram_C_button-pre_f023afc6ef","button-next":"tangram_C_button-next_f023afc6ef","button-submit-app":"tangram_C_button-submit-app_f023afc6ef"};

var EGO;

(function (EGO) {
  EGO[EGO["PRE"] = 0] = "PRE";
  EGO[EGO["NEXT"] = 1] = "NEXT";
})(EGO || (EGO = {}));

var SwitchButtons = function SwitchButtons(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  var questionList = props.questionList,
      questionId = props.questionId,
      childQuestionId = props.childQuestionId,
      mode = props.mode,
      _j = props.platForm,
      platForm = _j === void 0 ? EPlatForm.app : _j,
      onQuestionIdChange = props.onQuestionIdChange,
      customGoPre = props.customGoPre,
      customGoNext = props.customGoNext,
      submitCallBack = props.submitCallBack,
      customStickers = props.customStickers,
      submitButtonText = props.submitButtonText,
      wrapperStyle = props.wrapperStyle,
      answerMode = props.answerMode,
      _k = props.isSubmitButtonAvaluable,
      isSubmitButtonAvaluable = _k === void 0 ? true : _k,
      submitButtonStyle = props.submitButtonStyle;
  var haboReportData = {
    eventId: EHaboEventId$1.CLICK_LAST_IMG_UPLOAD,
    otherInfo: {
      subjectId: (_b = (_a = questionList === null || questionList === void 0 ? void 0 : questionList[0]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.subjectId
    }
  };

  if (!questionList || !questionList.length || questionList.every(function (question) {
    return !exist(question);
  })) {
    footPrintJSErrorReport({
      errorCause: "\u4E1A\u52A1\u65B9\u4F20\u5165\u7684\u9898\u76EE\u5217\u8868\u65E0\u6570\u636E\uFF0CquestionList:".concat(questionList)
    });
    throw new Error('请传入含有数据的题目列表');
  }

  if (!exist(questionId)) {
    footPrintJSErrorReport({
      errorCause: "\u4E1A\u52A1\u65B9\u672A\u4F20\u5165\u9898\u76EEid\uFF0CquestionId: ".concat(questionId)
    });
    throw new Error('请传入题目id');
  }

  var stickers = (_c = customStickers === null || customStickers === void 0 ? void 0 : customStickers(questionId, childQuestionId, questionList)) !== null && _c !== void 0 ? _c : [];
  var firstDTO = (questionList[0] || {}).questionInfoDTO;
  var lastDTO = (questionList[questionList.length - 1] || {}).questionInfoDTO;
  var first = {
    id: firstDTO === null || firstDTO === void 0 ? void 0 : firstDTO.questionId,
    childId: (_e = (_d = firstDTO === null || firstDTO === void 0 ? void 0 : firstDTO.childrenQuestionList) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.questionId
  };
  var last = {
    id: lastDTO === null || lastDTO === void 0 ? void 0 : lastDTO.questionId,
    childId: (_h = (_f = lastDTO === null || lastDTO === void 0 ? void 0 : lastDTO.childrenQuestionList) === null || _f === void 0 ? void 0 : _f[((_g = lastDTO === null || lastDTO === void 0 ? void 0 : lastDTO.childrenQuestionList) === null || _g === void 0 ? void 0 : _g.length) - 1]) === null || _h === void 0 ? void 0 : _h.questionId
  };
  var unifiedAnswerList = useMemo(function () {
    return getUnifidItems(questionList, mode) || [];
  }, [questionList]);
  var unifiedUnAnsweredExist = useMemo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;

    if (!questionList.length || mode && ![PRACTICE_MODE.revising, PRACTICE_MODE.pratice].includes(mode)) {
      return [];
    }

    var version = questionList === null || questionList === void 0 ? void 0 : questionList.reduce(function (pre, cur) {
      var _a;

      return Math.max(pre, ((_a = cur === null || cur === void 0 ? void 0 : cur.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, 0); // eslint-disable-next-line @typescript-eslint/prefer-for-of

    for (var i = 0; i < questionList.length; i++) {
      if (((_b = (_a = questionList[i]) === null || _a === void 0 ? void 0 : _a.userAnswerDetailDTOList) === null || _b === void 0 ? void 0 : _b.length) === version) {
        var userAnswer = (_c = questionList[i]) === null || _c === void 0 ? void 0 : _c.userAnswerDetailDTOList[0];

        if ((_d = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _d === void 0 ? void 0 : _d.length) {
          for (var j = 0; j < ((_e = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _e === void 0 ? void 0 : _e.length); ++j) {
            var questionAnswerVersion = (((_f = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList) === null || _f === void 0 ? void 0 : _f[j]) || {}).questionAnswerVersion; // eslint-disable-next-line max-len

            if (((_k = (_j = (_h = (_g = questionList[i]) === null || _g === void 0 ? void 0 : _g.evaluationQuestionConfigVO) === null || _h === void 0 ? void 0 : _h.childEvaluationQuestionConfigVOList) === null || _j === void 0 ? void 0 : _j[j]) === null || _k === void 0 ? void 0 : _k.answerMode) === EAnswerMode.UNIFIED && ((_l = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _l === void 0 ? void 0 : _l.status) === EAnswerStatus.UN_ANSWER && (typeof questionAnswerVersion === 'undefined' || questionAnswerVersion >= version)) {
              return true;
            }
          }
        }

        if (((_o = (_m = questionList[i]) === null || _m === void 0 ? void 0 : _m.evaluationQuestionConfigVO) === null || _o === void 0 ? void 0 : _o.answerMode) === EAnswerMode.UNIFIED && (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.status) === EAnswerStatus.UN_ANSWER) {
          return true;
        }
      }
    }

    return false;
  }, [questionList, mode]);
  var showUnifyButton = useMemo(function () {
    return answerMode === EAnswerMode.UNIFIED && isUnifyEvaluation(questionList, mode) && unifiedAnswerList.length === 0 && unifiedUnAnsweredExist;
  }, [answerMode, unifiedAnswerList, questionList]); // 可编辑的按空解析题, 判断首尾题时，不判断子题id

  var isFirstQuestion = useMemo(function () {
    return first.id ? first.id === questionId ? first.childId ? first.childId === childQuestionId || [PRACTICE_MODE.pratice, PRACTICE_MODE.revising].includes(mode) && (firstDTO === null || firstDTO === void 0 ? void 0 : firstDTO.logicTypeId) === ELogicTypeId.FILL_ON_BLANK : true : false : false;
  }, [questionId, childQuestionId, first.id, first.childId]);
  var isLastQuestion = useMemo(function () {
    return last.id ? last.id === questionId ? last.childId ? last.childId === childQuestionId || [PRACTICE_MODE.pratice, PRACTICE_MODE.revising].includes(mode) && (lastDTO === null || lastDTO === void 0 ? void 0 : lastDTO.logicTypeId) === ELogicTypeId.FILL_ON_BLANK : true : false : false;
  }, [questionId, childQuestionId, last.id, last.childId]);
  var curIdx = useMemo(function () {
    var _a, _b, _c;

    var motifIdx = questionList.findIndex(function (question) {
      return (question === null || question === void 0 ? void 0 : question.questionInfoDTO.questionId) === questionId;
    });
    var childIdx = -1;

    if (motifIdx > -1 && childQuestionId) {
      childIdx = ((_c = (_b = (_a = questionList[motifIdx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.childrenQuestionList) === null || _c === void 0 ? void 0 : _c.findIndex(function (child) {
        return child.questionId === childQuestionId;
      })) || 0;
    }

    return {
      motifIdx: motifIdx,
      childIdx: childIdx >= 0 ? childIdx : void 0
    };
  }, [questionId, childQuestionId]);

  var getIds = function getIds(go, shouldGo) {
    var _a, _b;

    if (shouldGo === void 0) {
      shouldGo = false;
    }

    var motifIdx = curIdx.motifIdx,
        childIdx = curIdx.childIdx;

    if (mode && [PRACTICE_MODE.revising, PRACTICE_MODE.pratice].includes(mode)) {
      var curLogicTypeId = (_b = (_a = questionList === null || questionList === void 0 ? void 0 : questionList[motifIdx]) === null || _a === void 0 ? void 0 : _a.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.logicTypeId; // 编辑模式下，空上作答按母题逻辑切换
      // @ts-ignore

      curLogicTypeId === ELogicTypeId.FILL_ON_BLANK && (childIdx = undefined);
    }

    if (go === EGO.PRE && shouldGo) {
      var _c = customGoPre ? customGoPre(questionId, childQuestionId, questionList) : V3Utils.goPre(motifIdx, questionList, childIdx),
          motifId = _c.motifId,
          childId = _c.childId;

      onQuestionIdChange === null || onQuestionIdChange === void 0 ? void 0 : onQuestionIdChange(motifId, childId, motifIdx && motifIdx > 0 ? motifIdx : null, childIdx && childIdx > 0 ? childIdx : null);
      return;
    }

    if (go === EGO.NEXT && shouldGo) {
      var _d = customGoNext ? customGoNext(questionId, childQuestionId, questionList) : V3Utils.goNext(motifIdx, questionList, childIdx),
          motifId = _d.motifId,
          childId = _d.childId;

      onQuestionIdChange === null || onQuestionIdChange === void 0 ? void 0 : onQuestionIdChange(motifId, childId, motifIdx && motifIdx > 0 ? motifIdx : null, childIdx && childIdx > 0 ? childIdx : null);
    }
  };

  var preButtonClick = function preButtonClick() {
    !isFirstQuestion && getIds(EGO.PRE, !isFirstQuestion);
  };

  var showSubmitButton = isLastQuestion && platForm === EPlatForm.app && [PRACTICE_MODE.pratice, PRACTICE_MODE.evaluation, PRACTICE_MODE.recite, PRACTICE_MODE.revising, PRACTICE_MODE.analysis].includes(mode);

  var nextButtonClick = function nextButtonClick() {
    if (showSubmitButton) {
      isSubmitButtonAvaluable && !showUnifyButton && (submitCallBack === null || submitCallBack === void 0 ? void 0 : submitCallBack(questionList));
      return;
    }

    getIds(EGO.NEXT, !isLastQuestion);
  };

  var handleChange = function handleChange(list) {
    // 将questionList的每一道题的userAnswerDetailDTOList[0]的itemBaseList替换成list
    var version = questionList === null || questionList === void 0 ? void 0 : questionList.reduce(function (pre, cur) {
      var _a;

      return Math.max(pre, ((_a = cur === null || cur === void 0 ? void 0 : cur.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, 0);
    submitCallBack === null || submitCallBack === void 0 ? void 0 : submitCallBack(questionList.map(function (question) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

      if (((_a = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList) === null || _a === void 0 ? void 0 : _a.length) === version) {
        var userAnswer = question === null || question === void 0 ? void 0 : question.userAnswerDetailDTOList[0];
        var isRevision = mode === PRACTICE_MODE.revising;

        if ((_c = (_b = question === null || question === void 0 ? void 0 : question.questionInfoDTO) === null || _b === void 0 ? void 0 : _b.childrenQuestionList) === null || _c === void 0 ? void 0 : _c.length) {
          for (var j = 0; j < ((_e = (_d = question === null || question === void 0 ? void 0 : question.questionInfoDTO) === null || _d === void 0 ? void 0 : _d.childrenQuestionList) === null || _e === void 0 ? void 0 : _e.length); ++j) {
            if (((_h = (_g = (_f = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _f === void 0 ? void 0 : _f.childEvaluationQuestionConfigVOList) === null || _g === void 0 ? void 0 : _g[j]) === null || _h === void 0 ? void 0 : _h.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && !isRightQuestion((_j = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _j === void 0 ? void 0 : _j.status))) {
              var finalList = (_l = (_k = userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.childItemList[j]) === null || _k === void 0 ? void 0 : _k.itemBaseList) === null || _l === void 0 ? void 0 : _l.concat(list);
              var finalStatus = finalList.length ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER;
              question.userAnswerDetailDTOList[0].childQuestionList[j].itemBaseList = finalList;
              question.userAnswerDetailDTOList[0].childQuestionList[j].status = finalStatus;
              question.userAnswerDetailDTOList[0].childItemList[j].itemBaseList = finalList;
              question.userAnswerDetailDTOList[0].childItemList[j].status = finalStatus;
            }
          }
        }

        if (((_m = question === null || question === void 0 ? void 0 : question.evaluationQuestionConfigVO) === null || _m === void 0 ? void 0 : _m.answerMode) === EAnswerMode.UNIFIED && (!isRevision || isRevision && !isRightQuestion(userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.status))) {
          var finalList = userAnswer.itemBaseList.concat(list);
          question.userAnswerDetailDTOList[0].itemBaseList = finalList;
          question.userAnswerDetailDTOList[0].status = finalList.length ? EAnswerStatus.ANSEWRED : EAnswerStatus.UN_ANSWER;
        }
      }

      return question;
    }));
  };

  var unifiedUploadButton = /*#__PURE__*/React.createElement(CameraBtn, {
    curCount: unifiedAnswerList.length,
    node: /*#__PURE__*/React.createElement(React.Fragment, null, "\u4E0A\u4F20\u56FE\u7247"),
    answerMode: EAnswerMode.UNIFIED,
    // eslint-disable-next-line react/jsx-no-bind
    uploadCallback: function uploadCallback(list) {
      return (list === null || list === void 0 ? void 0 : list.length) > 0 && handleChange(list);
    },
    haboReportData: haboReportData
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: platForm === EPlatForm.pc ? style['button-wrapper-pc'] : style['button-wrapper-app'],
    style: _assign$4({}, wrapperStyle)
  }, Array.isArray(stickers) ? stickers.map(function (sticker) {
    return sticker;
  }) : stickers, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(isFirstQuestion ? style['button-disable'] : '', "\n                        ").concat(style['button-pre']),
    // eslint-disable-next-line react/jsx-no-bind
    onClick: preButtonClick
  }, platForm === EPlatForm.pc ? '上一题' : /*#__PURE__*/React.createElement("img", {
    src: isFirstQuestion ? img : img$1,
    alt: "\u4E0A\u4E00\u9898"
  })), // PC的下一题/完成
  platForm === EPlatForm.pc ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: showSubmitButton ? '' : isLastQuestion ? style['button-disable'] : '',
    // eslint-disable-next-line react/jsx-no-bind
    onClick: nextButtonClick
  }, "\u4E0B\u4E00\u9898") // APP的完成
  : showSubmitButton ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(isSubmitButtonAvaluable ? style['button-submit-app'] : style['button-disable']),
    // eslint-disable-next-line react/jsx-no-bind
    onClick: nextButtonClick,
    style: submitButtonStyle
  }, showUnifyButton && unifiedUploadButton || submitButtonText || '完成') :
  /*#__PURE__*/
  // APP的下一题
  React.createElement("button", {
    type: "button",
    // eslint-disable-next-line react/jsx-no-bind
    onClick: nextButtonClick
  }, /*#__PURE__*/React.createElement("span", {
    className: style['button-next']
  }, "\u4E0B\u4E00\u9898"))));
};

initSentry$1();

export { AnswerCard, AnswerCardAnnotation, Audio$1 as Audio, Cosplay, CountDown, Exercise$1 as Exercise, index as ExerciseList, index$2 as FollowRead, Image$1 as Image, SwitchButtons, UnifiedUpload, TipMsg as UnifyTipMsg, V3Utils, VideoPlayer as Video, wxRecorder };
//# sourceMappingURL=index.js.map
